
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1jMgA", function(module, exports) {

$parcel$export(module.exports, "Search", () => $51999f6351274dfb$export$4b85d3515bd863a5);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jZ4fr = parcelRequire("jZ4fr");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $kMSay = parcelRequire("kMSay");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $15rEL = parcelRequire("15rEL");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $h9iZl = parcelRequire("h9iZl");

var $9OXo1 = parcelRequire("9OXo1");

var $kxZPA = parcelRequire("kxZPA");

var $lVJAU = parcelRequire("lVJAU");

var $iULZP = parcelRequire("iULZP");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $eoNiZ = parcelRequire("eoNiZ");

var $bMQpY = parcelRequire("bMQpY");

var $hteTr = parcelRequire("hteTr");

var $gIk9n = parcelRequire("gIk9n");

var $crtj2 = parcelRequire("crtj2");

var $9uJ5I = parcelRequire("9uJ5I");
const $51999f6351274dfb$export$b77c6c44f6e7248e = (ref, isOpen)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) // Prevent keypress being passed to input
        setTimeout(()=>{
            ref && ref.current && ref.current.focus();
        }, 0);
    }, [
        isOpen,
        ref
    ]);
};
const $51999f6351274dfb$var$styles = {
    nav4SearchInputWrapper: "_1bsb1osq _p12fktbq",
    nav4SearchInputOverrider: "_1bsb1osq",
    searchInputWrapper: "_1e0c1txw _1bah1h6o _4cvr1h6o _kqswh2mm _1ul9t94y",
    searchInputOverrider: "_1xhqi2wt"
}; // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences

const $51999f6351274dfb$var$LazyQuickFind = (0, $kxZPA.lazy)(()=>(parcelRequire("dugW4")).then((m)=>m.QuickFind), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/search/quick-find.tsx"
});
const $51999f6351274dfb$var$Search = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ExtensibleCrossProductSearchDialog: ExtensibleCrossProductSearchDialog = (0, $hteTr.ExtensibleCrossProductSearchDialog), ClientProvider: ClientProvider = (0, $bMQpY.ClientProvider), EngagementSpotlight: EngagementSpotlight = (0, $jZ4fr.EngagementSpotlight), SearchInputOverrider: SearchInputOverrider = $51999f6351274dfb$var$SearchInputOverriderDI, SearchInputWrapper: SearchInputWrapper = $51999f6351274dfb$var$SearchInputWrapperDI, SpotlightTarget: SpotlightTarget = (0, $5Fk4Z.default), useEffectFocusOnOpen: useEffectFocusOnOpen = $51999f6351274dfb$export$b77c6c44f6e7248e, useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions), useTenantContext: useTenantContext = (0, $9OXo1.useTenantContext), useNavigationViewPlansPermission: useNavigationViewPlansPermission = (0, $h9iZl.useNavigationViewPlansPermission), useTheme: // @ts-expect-error - TS2339 - Property 'useTheme' does not exist on type 'SearchProps'.
useTheme = (0, $eoNiZ.useTheme), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus), JsErrorBoundary: JsErrorBoundary = (0, $7CMCs.JSErrorBoundary) }, forwardedInputRef)=>{
    const testId = (0, $6cNb0.testIdGenerate)('secondary-actions', 'search');
    const inputRef = (0, $5uXOq.useRef)();
    const tenantContext = useTenantContext();
    const { cloudId: cloudId, baseUrl: baseUrl, isAnonymous: isAnonymous, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const theme = useTheme();
    const [isSearchMenuOpen, { on: openMenu, off: closeMenu }] = useTopMenus((0, $lmyls.MENU_ID).SEARCH);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SEARCH
    });
    const [hasEditOrViewPlanPermission] = useNavigationViewPlansPermission();
    const pressTracing = (0, $kMSay.default)('open-search-dialog');
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        openMenu();
        (0, $4R6GH.fg)('measure_search_dialog_open') && pressTracing();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics,
        pressTracing
    ]);
    const withUpdatedLabel = (formattedDate)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, `${formatMessage((0, $gIk9n.default).updated)} ${formattedDate}`);
    const formatDate = (lastModified)=>{
        // @ts-expect-error - TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        const daysElapsed = (Date.now() - new Date(lastModified)) / 86400000;
        if (daysElapsed < 8) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15rEL.FormattedRelativeV2), {
            value: lastModified
        }, withUpdatedLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VHMR.FormattedDate), {
            year: "numeric",
            month: "short",
            day: "2-digit",
            value: lastModified
        }, withUpdatedLabel);
    };
    const { push: push } = useRouterActions();
    const onNavigate = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (href, event)=>{
        if (!(event.ctrlKey || event.metaKey)) {
            // ProductSearchDialog's onNavigate callback doesn't give us the `searchSessionId`
            // It also does not reliably provide us with an <a> tag to source the href from
            // So, where needed, we'll source the href by traversing up the DOM
            const url = event?.target?.href ?? event.target?.closest?.('a')?.href ?? href;
            push(url);
        } // NOTE: For whatever reason, `preventDefault` must occur after the `push`
        event.preventDefault();
    }, [
        push
    ]); // @ts-expect-error - Type '(instance: HTMLElementRefShape) => void' is not assignable to type '{ current: HTMLInputElement | null | undefined; }'
    useEffectFocusOnOpen(forwardedInputRef || inputRef, isSearchMenuOpen);
    const features = {
        hasSoftwareAccess: appPermissions.hasSoftwareAccess,
        hasAdvancedRoadmapsAccess: hasEditOrViewPlanPermission,
        issueNavigatorTransitionOn: true,
        isNINSmartQuerySPATransitionOn: true,
        isReportedByMeFilterEnabled: true,
        isPreviewOnJiraSearchResultsEnabled: true,
        enableIssueLabelsFilter: true,
        enableDateFromFilter: true
    };
    const dialogProps = {
        isExpanded: isSearchMenuOpen,
        onOpen: onOpen,
        onClose: closeMenu,
        onNavigate: onNavigate,
        jiraFeatures: features,
        formatDate: formatDate,
        dialogFeatures: undefined,
        theme: theme?.mode?.search,
        pageLoadMetrics: {
            metric: (0, $crtj2.searchDialogMetric),
            customDataGetter: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        },
        primaryProduct: 'jira'
    };
    const { isEligibleInactiveUser: isEligibleInactiveUser, isEligibleNewUser: isEligibleNewUser, nudgeShown: nudgeShown, setAllowConfluenceAccessCache: setAllowConfluenceAccessCacheReactivation } = (0, $iULZP.useConfluenceReactivationExperiment)(cloudId, isSearchMenuOpen);
    const { isEligible: isConfluenceAvailabilityExperimentEligible, tabClicked: isConfluenceAvailabilityExperimentTabClicked, setAllowConfluenceAccessCache: setAllowConfluenceAccessCache } = (0, $9uJ5I.useConfluenceAvailabilityExperiment)(cloudId, isSearchMenuOpen);
    if ((0, $4R6GH.fg)('rovo_search_jira_enable_quick_find')) {
        const isNav4Enabled = (0, $3HwlS.getWillShowNav4)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JsErrorBoundary, {
            id: "jira-quick-find",
            packageName: "search-page",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51999f6351274dfb$var$LazyQuickFind, {
            isNav4Enabled: isNav4Enabled,
            cloudId: cloudId,
            userId: atlassianAccountId || null,
            onNavigate: onNavigate
        }));
    }
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JsErrorBoundary, {
        id: "jira-quick-search",
        packageName: "product-search-dialog",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ClientProvider, {
        cloudId: cloudId,
        baseUrl: baseUrl,
        isAnonymous: isAnonymous,
        atlassianAccountId: atlassianAccountId
    }, ({ aggregatorUrl: aggregatorUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchInputWrapper, {
            "data-testid": testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchInputOverrider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ExtensibleCrossProductSearchDialog, {
            ...dialogProps,
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl,
            forwardRef: forwardedInputRef || inputRef,
            confluenceReactivationExperiment: {
                isEligibleInactiveUser: isEligibleInactiveUser,
                isEligibleNewUser: isEligibleNewUser,
                nudgeShown: nudgeShown,
                setAllowConfluenceAccessCache: setAllowConfluenceAccessCacheReactivation
            },
            confluenceAvailabilityExperiment: {
                isEligible: isConfluenceAvailabilityExperimentEligible,
                isTabClicked: isConfluenceAvailabilityExperimentTabClicked,
                setAllowConfluenceAccessCache: setAllowConfluenceAccessCache
            }
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JsErrorBoundary, {
        id: "jira-quick-search",
        packageName: "product-search-dialog",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ClientProvider, {
        cloudId: cloudId,
        baseUrl: baseUrl,
        isAnonymous: isAnonymous,
        atlassianAccountId: atlassianAccountId
    }, ({ aggregatorUrl: aggregatorUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchInputWrapper, {
            "data-testid": testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchInputOverrider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
            name: (0, $Mp6qH.SEARCH_SPOTLIGHT_KEY)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // We wrap the dialog in a div to make the spotlight work properly
        , null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ExtensibleCrossProductSearchDialog, {
            ...dialogProps,
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl,
            forwardRef: forwardedInputRef || inputRef,
            confluenceReactivationExperiment: {
                isEligibleInactiveUser: isEligibleInactiveUser,
                isEligibleNewUser: isEligibleNewUser,
                nudgeShown: nudgeShown,
                setAllowConfluenceAccessCache: setAllowConfluenceAccessCacheReactivation
            },
            confluenceAvailabilityExperiment: {
                isEligible: isConfluenceAvailabilityExperimentEligible,
                isTabClicked: isConfluenceAvailabilityExperimentTabClicked,
                setAllowConfluenceAccessCache: setAllowConfluenceAccessCache
            }
        }))), !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EngagementSpotlight, {
            engagementId: (0, $Mp6qH.SEARCH_SPOTLIGHT_KEY)
        }) : null))));
});
const $51999f6351274dfb$export$4b85d3515bd863a5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).SEARCH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51999f6351274dfb$var$Search, props));
const $51999f6351274dfb$var$SearchInputWrapperDI = (props)=>{
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-ssr-placeholder-replace": (0, $4R6GH.fg)('qs-7058-remove-experiment-call-search-dialog') ? 'nav4-search-bar' : undefined,
        className: (0, $bwpsq.default)([
            $51999f6351274dfb$var$styles.searchInputWrapper,
            $51999f6351274dfb$var$styles.nav4SearchInputWrapper
        ])
    }, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-vc": `search-input-wrapper${false ? '-ssr' : ''}`,
        className: (0, $bwpsq.default)([
            $51999f6351274dfb$var$styles.searchInputWrapper
        ])
    }, props.children);
};
const $51999f6351274dfb$var$SearchInputOverriderDI = (props)=>{
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $51999f6351274dfb$var$styles.searchInputOverrider,
            $51999f6351274dfb$var$styles.nav4SearchInputOverrider
        ])
    }, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $51999f6351274dfb$var$styles.searchInputOverrider
        ])
    }, props.children);
};

});
parcelRegister("15rEL", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $dff2faa5ae8b6f27$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $dff2faa5ae8b6f27$export$7317ee2f88fd1276);

var $5uXOq = parcelRequire("5uXOq");

var $j7anB = parcelRequire("j7anB");

var $2tElP = parcelRequire("2tElP");
const $dff2faa5ae8b6f27$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $dff2faa5ae8b6f27$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $j7anB.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $dff2faa5ae8b6f27$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $dff2faa5ae8b6f27$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $dff2faa5ae8b6f27$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tElP.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$dff2faa5ae8b6f27$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});

parcelRegister("iULZP", function(module, exports) {

$parcel$export(module.exports, "useConfluenceReactivationExperiment", () => $1b9db35a8ae93cf2$export$1322aade5d44bece);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $2NMNM = parcelRequire("2NMNM");

var $8ilPk = parcelRequire("8ilPk");

var $cYlk7 = parcelRequire("cYlk7");

var $cZpsT = parcelRequire("cZpsT");

var $6aP77 = parcelRequire("6aP77");

var $bQUBg = parcelRequire("bQUBg");
const $1b9db35a8ae93cf2$export$1322aade5d44bece = (cloudId, isSearchMenuOpen)=>{
    const { user: user } = (0, $cYlk7.useCurrentUser)().data;
    const { fetch: fetch } = (0, $8ilPk.useSiteUserPersonalization)();
    const isAnonymousUser = (0, $cZpsT.useIsAnonymous)();
    const [permitted, setPermitted] = (0, $5uXOq.useState)(false);
    const [nudgeShown, setNudgeShown] = (0, $5uXOq.useState)(false);
    const [passesJiraAgeCondition] = (0, $bQUBg.useIsJiraAccountAgeEligible)();
    const [passesConfluenceInactivityCondition] = (0, $bQUBg.useIsInactiveConfluenceUser)();
    const [passesNewConfluenceUserCondition] = (0, $bQUBg.useIsNewConfluenceUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const setAllowConfluenceAccessCache = (0, $5uXOq.useCallback)(()=>{
        (0, $6aP77.setConfluenceAccessCache)(true, createAnalyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const checkEligibility = async ()=>{
            if (!isSearchMenuOpen) return;
            if (isAnonymousUser) return;
            if (!passesJiraAgeCondition) return;
            if (!passesConfluenceInactivityCondition && !passesNewConfluenceUserCondition) return;
            try {
                const confluenceAccess = await (0, $6aP77.fetchCachedConfluenceAccess)(cloudId, createAnalyticsEvent);
                if (!confluenceAccess) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useConfluenceReactivationExperiment',
                        packageName: 'jiraConfluenceReactivationExperiment'
                    },
                    error: error
                });
            }
            if (!(0, $6s1PB.expValEquals)('cc_mandalorians_confluence_reactivation_ab', 'cohort', 'variation', 'control')) return;
            if (user.accountId) {
                const personalizationData = await fetch({
                    cloudId: cloudId,
                    userId: user.accountId
                });
                // We have no need for this data until we know the user is in the experiment.
                if (personalizationData) {
                    const isClicked = personalizationData.find((trait)=>trait.name === 'jira-platform_ui_panel_opened_crossproductsearchpanel_searchdialog_confluence_reactivation' && trait.value === true) !== undefined;
                    setNudgeShown(isClicked);
                }
            }
            setPermitted(true);
        };
        checkEligibility();
    }, [
        cloudId,
        user,
        passesJiraAgeCondition,
        passesConfluenceInactivityCondition,
        passesNewConfluenceUserCondition,
        isSearchMenuOpen,
        isAnonymousUser,
        createAnalyticsEvent,
        fetch,
        setNudgeShown
    ]);
    const isEligibleInactiveUser = passesJiraAgeCondition && // jira_first_active + 7 < today
    passesConfluenceInactivityCondition && // should be inactive in Confluence for at least 30 days
    permitted; // should have confluence access
    const isEligibleNewUser = passesJiraAgeCondition && // jira_first_active + 7 < today
    passesNewConfluenceUserCondition && // should have never been active in Confluence
    permitted; // should have confluence access
    return {
        isEligibleInactiveUser: isEligibleInactiveUser,
        isEligibleNewUser: isEligibleNewUser,
        nudgeShown: nudgeShown,
        setAllowConfluenceAccessCache: setAllowConfluenceAccessCache
    };
};

});
parcelRegister("6aP77", function(module, exports) {

$parcel$export(module.exports, "fetchCachedConfluenceAccess", () => $0279b6955b616b46$export$dcd634cbdca22f75);
$parcel$export(module.exports, "setConfluenceAccessCache", () => $0279b6955b616b46$export$67adcb5b9cbdeceb);

var $7f4tk = parcelRequire("7f4tk");

var $bSSG7 = parcelRequire("bSSG7");

var $8zOmE = parcelRequire("8zOmE");
const $0279b6955b616b46$export$fe9cdfed60649389 = (cloudId)=>{
    return (0, $7f4tk.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
};
const $0279b6955b616b46$var$URL = '/gateway/api/permissions/permitted';
const $0279b6955b616b46$var$hasProductAccess = async (cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:confluence::site/${cloudId}`
    };
    const response = await (0, $7f4tk.default)($0279b6955b616b46$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response?.permitted;
};
const $0279b6955b616b46$var$CONFLUENCE_ACCESS_CACHE_KEY = 'confluence-reactivation-exp.confluence-access.cache.key';
// Cache for 1 day
const $0279b6955b616b46$var$CONFLUENCE_ACCESS_CACHE_KEY_EXPIRY_MS = 86400000;
const $0279b6955b616b46$var$confluenceAccessApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('confluence-reactivation-exp-access-api-cache');
const $0279b6955b616b46$export$dcd634cbdca22f75 = async (cloudId, createAnalyticsEvent)=>{
    let confluenceAccess = $0279b6955b616b46$var$confluenceAccessApiCache.get($0279b6955b616b46$var$CONFLUENCE_ACCESS_CACHE_KEY);
    if (confluenceAccess === undefined) try {
        confluenceAccess = await $0279b6955b616b46$var$hasProductAccess(cloudId);
    } catch (error) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confReactivationInSearchExpConfAccess failed', {
            errorAction: 'Failed to get confluence access',
            error: error
        });
    } finally{
        // Set the cache either way. This make sure if error occurs, we don't keep hitting the API.
        $0279b6955b616b46$export$67adcb5b9cbdeceb(confluenceAccess ?? false, createAnalyticsEvent);
    }
    return confluenceAccess ?? false;
};
const $0279b6955b616b46$export$67adcb5b9cbdeceb = (value, createAnalyticsEvent)=>{
    try {
        $0279b6955b616b46$var$confluenceAccessApiCache.set($0279b6955b616b46$var$CONFLUENCE_ACCESS_CACHE_KEY, value, Date.now() + $0279b6955b616b46$var$CONFLUENCE_ACCESS_CACHE_KEY_EXPIRY_MS);
    } catch (error) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confReactivationInSearchExpConfAccess failed', {
            errorAction: 'Failed to set confluence access in cache',
            error: error
        });
    }
};

});

parcelRegister("bQUBg", function(module, exports) {

$parcel$export(module.exports, "useIsJiraAccountAgeEligible", () => $81cdacfda0d7bd29$export$ea1191afdb4370f7);
$parcel$export(module.exports, "useIsInactiveConfluenceUser", () => $81cdacfda0d7bd29$export$bda63b4e3fb10e74);
$parcel$export(module.exports, "useIsNewConfluenceUser", () => $81cdacfda0d7bd29$export$b7cfb1fc9e3f6f0c);

var $gwejS = parcelRequire("gwejS");
var $16v6W = parcelRequire("16v6W");
var $79nXx = parcelRequire("79nXx");
var $jovBr = parcelRequire("jovBr");

var $5GDqD = parcelRequire("5GDqD");
const $81cdacfda0d7bd29$var$isActiveInJiraFor7Days = (accountCreationDate)=>{
    const date = new Date(accountCreationDate);
    if (!(0, $jovBr.default)(date)) return false;
    const today = new Date();
    return (0, $79nXx.default)(today, (0, $16v6W.default)(date, 1));
};
const $81cdacfda0d7bd29$var$isInactiveInConfluenceFor28Days = (confluenceLastActiveDate)=>{
    const date = new Date(confluenceLastActiveDate);
    if (!(0, $jovBr.default)(date)) return false;
    const today = new Date();
    return (0, $79nXx.default)(today, (0, $gwejS.default)(date, 28));
};
const $81cdacfda0d7bd29$export$ea1191afdb4370f7 = (0, $5GDqD.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    const jiraFirstActiveDate = getTraitByName('jira_first_active')?.value;
    if (!jiraFirstActiveDate) return false;
    return typeof jiraFirstActiveDate === 'string' && $81cdacfda0d7bd29$var$isActiveInJiraFor7Days(jiraFirstActiveDate);
});
const $81cdacfda0d7bd29$export$bda63b4e3fb10e74 = (0, $5GDqD.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    const confluenceLastActiveDate = getTraitByName('confluence_last_active')?.value;
    return typeof confluenceLastActiveDate === 'string' && $81cdacfda0d7bd29$var$isInactiveInConfluenceFor28Days(confluenceLastActiveDate);
});
const $81cdacfda0d7bd29$export$b7cfb1fc9e3f6f0c = (0, $5GDqD.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    const confluenceFirstActiveDate = getTraitByName('confluence_first_active')?.value;
    if (!confluenceFirstActiveDate) return true;
    return false;
});
const $81cdacfda0d7bd29$export$bf2b21d0fd685794 = (0, $5GDqD.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    const hasOpenedPanelWithNudge = getTraitByName('jira-platform_ui_panel_opened_crossproductsearchpanel_searchdialog_confluence_reactivation')?.value;
    if (!hasOpenedPanelWithNudge) return true;
    return false;
});

});
parcelRegister("5GDqD", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $5e4cf08f88a8a143$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $5e4cf08f88a8a143$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $5e4cf08f88a8a143$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $5e4cf08f88a8a143$export$e653f602b87eec56);

var $eusud = parcelRequire("eusud");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $jX0pr = parcelRequire("jX0pr");

var $8ilPk = parcelRequire("8ilPk");

var $13UaH = parcelRequire("13UaH");

var $2LwjF = parcelRequire("2LwjF");
const $5e4cf08f88a8a143$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $5e4cf08f88a8a143$var$fetchTraitsOld = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                const fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$fetchTraitsNew = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $13UaH.SITE) && cloudId && (0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api')) fetchedTraits = {
                    attributes: await (0, $jX0pr.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $13UaH.SITE_USER) && cloudId && accountId && (0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api')) fetchedTraits = {
                    attributes: await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$fetchTraits = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api') || (0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api'), $5e4cf08f88a8a143$var$fetchTraitsNew, $5e4cf08f88a8a143$var$fetchTraitsOld);
const $5e4cf08f88a8a143$var$actions = {
    fetchTraits: $5e4cf08f88a8a143$var$fetchTraits,
    addTrait: $5e4cf08f88a8a143$var$addTrait
};
const $5e4cf08f88a8a143$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $5e4cf08f88a8a143$export$5b11e13f463f4eb = (0, $iXqE5.createStore)({
    initialState: $5e4cf08f88a8a143$var$initialState,
    actions: $5e4cf08f88a8a143$var$actions,
    name: 'TraitsStore'
});
const $5e4cf08f88a8a143$export$243330301a7ccf01 = (0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$export$87f1d888def9d5a0 = (0, $3sQ5x.createActionsHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$var$defaultSelector = (traitsType, selector)=>(0, $6dDSs.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $2LwjF.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitValue)(state, name) : null
        }), selector);
const $5e4cf08f88a8a143$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb, {
        selector: $5e4cf08f88a8a143$var$defaultSelector(traitsType, selector)
    });
const $5e4cf08f88a8a143$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("13UaH", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $c8223610b88d815b$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $c8223610b88d815b$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $c8223610b88d815b$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $c8223610b88d815b$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $c8223610b88d815b$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $c8223610b88d815b$export$ff5c5bd50c21e9a4);
const $c8223610b88d815b$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $c8223610b88d815b$export$1f4740cb59ea887e = 'SITE';
const $c8223610b88d815b$export$2b629adc0b711448 = 'SITE_USER';
const $c8223610b88d815b$export$c7bc89c720838974 = 'ORG';
const $c8223610b88d815b$export$872e93425a929c06 = 'ORG_USER';
const $c8223610b88d815b$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $c8223610b88d815b$export$ab3e7784d2a104d4 = [
    $c8223610b88d815b$export$eac8289d83d13c9e,
    $c8223610b88d815b$export$1f4740cb59ea887e,
    $c8223610b88d815b$export$2b629adc0b711448,
    $c8223610b88d815b$export$c7bc89c720838974,
    $c8223610b88d815b$export$872e93425a929c06
];

});

parcelRegister("2LwjF", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $a4882989c0079311$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $a4882989c0079311$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $a4882989c0079311$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $a4882989c0079311$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $a4882989c0079311$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $a4882989c0079311$export$da1e8ce191f01409);

var $13UaH = parcelRequire("13UaH");
const $a4882989c0079311$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $a4882989c0079311$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $13UaH.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $13UaH.SITE:
            return `site/${cloudId}`;
        case 0, $13UaH.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $13UaH.ORG:
            return `org/${orgId}`;
        case 0, $13UaH.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $a4882989c0079311$export$252a469687875173(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $a4882989c0079311$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $a4882989c0079311$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$a4882989c0079311$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $a4882989c0079311$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $a4882989c0079311$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});




parcelRegister("bMQpY", function(module, exports) {

$parcel$export(module.exports, "ClientProvider", () => $5381ac7e84b10acd$export$5d91bb6ce8e0f47);

var $5uXOq = parcelRequire("5uXOq");

var $9YbJT = parcelRequire("9YbJT");
var $3nZO6 = parcelRequire("3nZO6");

const $5381ac7e84b10acd$export$5d91bb6ce8e0f47 = ({ JiraSearchClientProvider: // @ts-expect-error - TS2322 - Type 'FunctionComponent<SearchClientConfig>' is not assignable to type 'ComponentType<JiraClientProviderProps>'.
JiraSearchClientProvider = (0, $3nZO6.JiraSearchClientProvider), ConfluenceClientsProvider: ConfluenceClientsProvider = (0, $9YbJT.ConfluenceClientsProvider), children: children, cloudId: cloudId, isAnonymous: isAnonymous, baseUrl: baseUrl, atlassianAccountId: atlassianAccountId })=>{
    const clientProviderConfig = {
        cloudId: cloudId,
        isUserAnonymous: isAnonymous,
        aggregatorUrl: `${baseUrl}/${(0, $3858a166c616a5ee$export$58d86c1da4a2ca1)}`,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        baseUrl: `${window.location.protocol}//${window.location.hostname}${baseUrl}`,
        collaborationGraphUrl: '/gateway/api/collaboration',
        accountId: atlassianAccountId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JiraSearchClientProvider, clientProviderConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConfluenceClientsProvider, {
        config: {
            ...clientProviderConfig,
            baseUrl: `${clientProviderConfig.baseUrl}/wiki`
        }
    }, children(clientProviderConfig)));
};

});
parcelRegister("9YbJT", function(module, exports) {

$parcel$export(module.exports, "ConfluenceClientsProvider", () => $dd7d1a2d5f811ad9$export$43e8a9214cb124ba);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9rqWx = parcelRequire("9rqWx");

var $8QpSo = parcelRequire("8QpSo");

var $6SBvm = parcelRequire("6SBvm");

var $8RYU8 = parcelRequire("8RYU8");

var $jFHlY = parcelRequire("jFHlY");
var $ckvH1 = parcelRequire("ckvH1");

var $7Jxgt = parcelRequire("7Jxgt");
const $dd7d1a2d5f811ad9$var$defaultCollaborationGraphConfig = {
    collaborationGraphUrl: 'gateway/api/collaboration',
    useCollaborationGraphForRecents: false
};
const $dd7d1a2d5f811ad9$var$getSearchClientWithConfig = (0, $8QpSo.default)((config, collabGraphClient)=>new (0, $9rqWx.ConfluenceSearchClient)(config, collabGraphClient), (0, (/*@__PURE__*/$parcel$interopDefault($6SBvm))));
const $dd7d1a2d5f811ad9$var$getRecentsClientWithConfig = (0, $8QpSo.default)((config, collabGraphClient)=>new (0, $8RYU8.ConfluenceRecentsClient)(config, collabGraphClient), (0, (/*@__PURE__*/$parcel$interopDefault($6SBvm))));
const $dd7d1a2d5f811ad9$var$getCollabGraphClientWithConfig = (0, $8QpSo.default)((config)=>new (0, $jFHlY.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        collabGraphSessionId: config.collabGraphSessionId,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6SBvm))));
const $dd7d1a2d5f811ad9$export$5a44dbd630fde657 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $dd7d1a2d5f811ad9$var$MISSING_PROVIDER_ERROR = new Error(`Could not find all required Clients, make sure ConfluenceClientsProvider is created further up the tree`);
//Will generate a session id to be sent to the CG endpoint as well as the frontend analytics
//This is created here as CG results are cached inside search dialog and is not invoked for subsequent use actions
const $dd7d1a2d5f811ad9$var$COLLABORATION_GRAPH_SESSION_ID = (0, $7Jxgt.v4)();
const $dd7d1a2d5f811ad9$export$413dca1b70dbb4a7 = (Component)=>{
    return (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($dd7d1a2d5f811ad9$export$5a44dbd630fde657.Consumer, {
            children: ({ searchClient: searchClient, recentClient: recentClient, cloudId: cloudId, siteUrl: siteUrl = '', sites: sites, collabGraphSessionId: collabGraphSessionId })=>{
                if (!searchClient || !recentClient) throw $dd7d1a2d5f811ad9$var$MISSING_PROVIDER_ERROR;
                const { ...rest } = props;
                return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...rest,
                    searchClient: searchClient,
                    recentClient: recentClient,
                    cloudId: cloudId,
                    collabGraphSessionId: collabGraphSessionId,
                    siteUrl: siteUrl,
                    sites: sites
                });
            }
        });
};
const $dd7d1a2d5f811ad9$export$43e8a9214cb124ba = ({ children: children, config: config })=>{
    const { baseUrl: baseUrl, cloudId: cloudId, collaborationGraphUrl: collaborationGraphUrl, aggregatorUrl: aggregatorUrl, isUserAnonymous: isUserAnonymous, useCollaborationGraphForRecents: useCollaborationGraphForRecents, recentItemsSupplier: recentItemsSupplier, sites: sites = [], collabGraphSessionId: collabGraphSessionId, scopes: scopes, useGraphQLClient: useGraphQLClient, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl } = {
        ...$dd7d1a2d5f811ad9$var$defaultCollaborationGraphConfig,
        ...config
    };
    const siteUrl = (0, $ckvH1.extractSiteUrl)(config);
    const collabGraphClient = $dd7d1a2d5f811ad9$var$getCollabGraphClientWithConfig({
        collaborationGraphUrl: collaborationGraphUrl,
        cloudId: cloudId,
        isMultiSite: sites.length > 1,
        sites: sites,
        collabGraphSessionId: collabGraphSessionId
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($dd7d1a2d5f811ad9$export$5a44dbd630fde657.Provider, {
        value: {
            searchClient: $dd7d1a2d5f811ad9$var$getSearchClientWithConfig({
                isUserAnonymous: isUserAnonymous,
                url: aggregatorUrl,
                cloudId: cloudId,
                isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                siteMasterList: sites,
                scopes: scopes,
                useGraphQLClient: useGraphQLClient
            }, collabGraphClient),
            recentClient: $dd7d1a2d5f811ad9$var$getRecentsClientWithConfig({
                url: baseUrl,
                isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                recentItemsSupplier: recentItemsSupplier,
                useRecentWork: useRecentWork,
                recentWorkAPIUrl: recentWorkAPIUrl
            }, collabGraphClient),
            collabGraphClient: collabGraphClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites,
            collabGraphSessionId: $dd7d1a2d5f811ad9$var$COLLABORATION_GRAPH_SESSION_ID
        },
        children: children
    });
};
const $dd7d1a2d5f811ad9$export$4823a6cc022cca16 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($dd7d1a2d5f811ad9$export$5a44dbd630fde657);
    if (!context.searchClient || !context.recentClient) throw $dd7d1a2d5f811ad9$var$MISSING_PROVIDER_ERROR;
    return context;
};
const $dd7d1a2d5f811ad9$export$376c08f4921c6b8d = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($dd7d1a2d5f811ad9$export$5a44dbd630fde657);
    return context.recentClient;
};

});
parcelRegister("9rqWx", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSearchClient", () => $471e7052ca87b8fc$export$2bdc82bf1cf036b4);

var $aHYZV = parcelRequire("aHYZV");

var $3JOCw = parcelRequire("3JOCw");

var $zo35K = parcelRequire("zo35K");
var $lQmoS = parcelRequire("lQmoS");

var $3GGIR = parcelRequire("3GGIR");

var $k7rsK = parcelRequire("k7rsK");

var $ckvH1 = parcelRequire("ckvH1");

var $cm5BA = parcelRequire("cm5BA");
var $jmwt7 = parcelRequire("jmwt7");
const $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
const $471e7052ca87b8fc$var$EMPTY_RESULT_PROMISE = Promise.resolve({
    items: [],
    timings: 0
});
class $471e7052ca87b8fc$export$2bdc82bf1cf036b4 {
    static{
        this.ITEM_RESULT_LIMIT = 30;
    }
    static{
        this.SPACE_RESULT_LIMIT = 10;
    }
    static{
        this.PEOPLE_RESULT_LIMIT = 10;
    }
    constructor(config, collabGraphClient){
        this.abTestDataCache = null;
        this.permissionsDataCache = null;
        this.searchWithFilters = (query, filters, context, modelParams, sites)=>{
            const scopes = [
                (0, $3GGIR.Scope).ConfluencePageBlogAttachment
            ];
            const allFilters = [];
            let baseSpaceFilters = null;
            let baseUserFilters = null;
            let baseTimeFilters = null;
            // TODO: GraphQL queries with filters
            filters.forEach((filter)=>{
                switch(filter.type){
                    case 'space':
                        if (!baseSpaceFilters) {
                            baseSpaceFilters = {
                                '@type': 'spaces',
                                spaceKeys: []
                            };
                            allFilters.push(baseSpaceFilters);
                        }
                        baseSpaceFilters.spaceKeys.push(filter.id);
                        break;
                    case 'contributor':
                        if (!baseUserFilters) {
                            baseUserFilters = {
                                '@type': 'contributors',
                                accountIds: []
                            };
                            allFilters.push(baseUserFilters);
                        }
                        baseUserFilters.accountIds.push(filter.id);
                        break;
                    case 'lastModified':
                        if (!baseTimeFilters) {
                            baseTimeFilters = {
                                '@type': 'lastModified',
                                from: filter.id
                            };
                            allFilters.push(baseTimeFilters);
                        }
                        break;
                    default:
                        break;
                }
            });
            const responseAndTiming = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
                filters: allFilters,
                experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            const results = {
                [(0, $3GGIR.Scope).ConfluencePageBlogAttachment]: (0, $aHYZV.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope((0, $3GGIR.Scope).ConfluencePageBlogAttachment), requestDurationMs))),
                [(0, $3GGIR.Scope).ConfluenceSpace]: (0, $aHYZV.CancellablePromise).from($471e7052ca87b8fc$var$EMPTY_RESULT_PROMISE),
                [(0, $3GGIR.Scope).UserConfluence]: (0, $aHYZV.CancellablePromise).from($471e7052ca87b8fc$var$EMPTY_RESULT_PROMISE)
            };
            return results;
        };
        this.recentPeopleSupplier = (context, sites)=>{
            if (this.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0
            });
            if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getUsers().then((response)=>this.mapCollabGraphPeople(response));
            return this.aggregatorClient.search({
                query: '',
                context: context,
                scopes: [
                    (0, $3GGIR.Scope).UserConfluence
                ],
                modelParams: [],
                resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
                experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites?.map((s)=>s.cloudId)
            }).then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, $3GGIR.Scope).UserConfluence), requestDurationMs, sites.length > 0));
        };
        this.mapUrsPeople = (response, timings, isMultiSite)=>{
            if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $3GGIR.Scope).UserConfluence}`);
            if (response.error) throw (0, $lQmoS.responseErrorToError)(response.error);
            const items = response.results.map((item)=>({
                    resultType: (0, $3GGIR.PersonResult),
                    resultId: `people-${item.id}`,
                    userId: item.id,
                    name: item.name,
                    href: (0, $ckvH1.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
                    avatarUrl: item.avatarUrl,
                    contentType: (0, $3GGIR.Person),
                    analyticsType: (0, $3GGIR.ResultPerson),
                    mentionName: item.nickname || '',
                    presenceMessage: ''
                }));
            return {
                items: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(items, (item)=>item.resultId),
                timings: timings
            };
        };
        this.mapCollabGraphPeople = (response)=>{
            const items = response.collaborationGraphEntities.map((item)=>({
                    resultId: item.userProfile.account_id,
                    userId: item.userProfile.account_id,
                    name: item.userProfile.name,
                    href: `${(0, $ckvH1.mapTenantIdToSiteUrl)(item.siteId, this.siteMasterList)}/people/${item.userProfile.account_id}`,
                    analyticsType: (0, $3GGIR.RecentPerson),
                    mentionName: item.userProfile.name,
                    presenceMessage: item.userProfile.name,
                    resultType: (0, $3GGIR.PersonResult),
                    avatarUrl: item.userProfile.picture,
                    contentType: (0, $3GGIR.Person)
                }));
            return {
                items: items,
                timings: response.timings
            };
        };
        const { siteMasterList: siteMasterList, scopes: scopes } = config;
        this.aggregatorClient = new (0, $zo35K.AggregatorClient)(config);
        this.graphQLClient = new (0, $jmwt7.GraphQLClient)(config);
        this.isUserAnonymous = config.isUserAnonymous;
        this.useGraphQLClient = config.useGraphQLClient || false;
        this.bootstrapPeopleCache = new (0, $k7rsK.SimpleCache)(this.recentPeopleSupplier);
        this.siteMasterList = siteMasterList;
        this.collaborationGraphClient = collabGraphClient;
        this.isCollabGraphEnabled = config.isCollaborationGraphEnabled;
        this.scopes = {
            itemScope: scopes?.itemScope ? scopes.itemScope : (0, $3GGIR.Scope).ConfluencePageBlogAttachment,
            spaceScope: scopes?.spaceScope ? scopes.spaceScope : (0, $3GGIR.Scope).ConfluenceSpace,
            ursUserScope: scopes?.ursUserScope ? scopes.ursUserScope : (0, $3GGIR.Scope).UserConfluence
        };
    }
    /**
	 * Makes a search across all relevant scopes.
	 */ search(query, filters, context, queryVersion, sites) {
        const modelParams = [
            {
                '@type': 'queryParams',
                queryVersion: queryVersion
            }
        ];
        if (filters.length > 0) return this.searchWithFilters(query, filters, context, modelParams, sites);
        if (this.useGraphQLClient) // TODO: convert this response to expected confluence search response
        this.graphQLClient.search({
            query: query,
            context: context,
            entities: (0, $cm5BA.CONFLUENCE_ITEM_ENTITIES),
            modelParams: modelParams,
            resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
            experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        const scopes = [
            this.scopes.itemScope,
            this.scopes.spaceScope,
            this.scopes.ursUserScope
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: modelParams,
            resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
            filters: [],
            experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        const allResults = {
            [(0, $3GGIR.Scope).ConfluencePageBlogAttachment]: (0, $aHYZV.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope(this.scopes.itemScope), requestDurationMs))),
            [(0, $3GGIR.Scope).ConfluenceSpace]: (0, $aHYZV.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope(this.scopes.spaceScope), requestDurationMs))),
            [(0, $3GGIR.Scope).UserConfluence]: (0, $aHYZV.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope(this.scopes.ursUserScope), requestDurationMs, sites.length > 0)))
        };
        return allResults;
    }
    searchSpaces(query, context, sites) {
        const scopes = [
            (0, $3GGIR.Scope).ConfluenceSpace
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: [],
            resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.SPACE_RESULT_LIMIT,
            filters: [],
            experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        return (0, $aHYZV.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope((0, $3GGIR.Scope).ConfluenceSpace), requestDurationMs)));
    }
    searchUsers(query, context, sites) {
        const scopes = [
            (0, $3GGIR.Scope).UserConfluence
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: [],
            resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
            filters: [],
            experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        return (0, $aHYZV.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, $3GGIR.Scope).UserConfluence), requestDurationMs, sites.length > 0)));
    }
    getRecentPeople(context, sites) {
        const { fromCache: fromCache, value: value } = this.bootstrapPeopleCache.get(context, sites);
        return new (0, $aHYZV.CancellablePromise)(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    /**
	 * Check the user permissions for the given list of products.
	 */ async getProductPermissions(products) {
        if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE);
        return this.permissionsDataCache;
    }
    async getAbTestData() {
        if (this.abTestDataCache) return this.abTestDataCache;
        const abTest = await this.aggregatorClient.getAbTestData((0, $3GGIR.Scope).ConfluencePageBlogAttachment, $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE);
        this.abTestDataCache = abTest;
        return abTest;
    }
    mapConfItem(response, timings) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $3GGIR.Scope).ConfluencePageBlogAttachment}`);
        if (response.error) throw (0, $lQmoS.responseErrorToError)(response.error);
        function removeHighlightTags(text) {
            return text.replace(/@@@hl@@@|@@@endhl@@@/g, '');
        }
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ const items = response.results.map((item)=>({
                resultId: item.content.id,
                name: removeHighlightTags(item.title),
                href: `${item.baseUrl}${item.url}`,
                containerName: item.container.title,
                analyticsType: (0, $3GGIR.ResultConfluence),
                contentType: `confluence-${item.content.type}`,
                resultType: (0, $3GGIR.ConfluenceObjectResult),
                containerId: item.content.space && item.content.space.id ? item.content.space.id : 'UNAVAILABLE',
                spaceId: item.container.id,
                iconClass: item.iconCssClass,
                lastModified: item.lastModified,
                isRecentResult: false
            }));
        /* eslint-enable */ return {
            items: items,
            totalSize: response.size !== undefined ? response.size : response.results.length,
            timings: timings
        };
    }
    mapConfSpace(response, timings) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $3GGIR.Scope).ConfluenceSpace}`);
        if (response.error) throw (0, $lQmoS.responseErrorToError)(response.error);
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ const items = response.results.map((item)=>({
                resultId: item.id,
                avatarUrl: `${item.baseUrl}${item.space.icon.path}`,
                name: item.container.title,
                href: `${item.baseUrl || ''}${item.container.displayUrl}`,
                analyticsType: (0, $3GGIR.ResultConfluence),
                resultType: (0, $3GGIR.GenericContainerResult),
                contentType: (0, $3GGIR.ConfluenceSpace),
                key: item.space.key,
                id: item.id
            }));
        /* eslint-enable */ return {
            items: items,
            timings: timings
        };
    }
}

});
parcelRegister("aHYZV", function(module, exports) {

$parcel$export(module.exports, "CancelError", () => $51cb7e70082e66c9$export$d7f5e52d091a66db);
$parcel$export(module.exports, "CancellablePromise", () => $51cb7e70082e66c9$export$5782acf08706f13d);
class $51cb7e70082e66c9$export$d7f5e52d091a66db extends Error {
    constructor(...args){
        super(...args), this.isCancelled = true;
    }
}
const $51cb7e70082e66c9$var$CANCEL_ERROR = new $51cb7e70082e66c9$export$d7f5e52d091a66db('Promise is cancelled');
class $51cb7e70082e66c9$export$5782acf08706f13d {
    constructor(promise){
        this.cancelInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.promise = ()=>this.cancellablePromiseInternal;
        this.cancel = ()=>this.cancelInternal();
        this.cancellablePromiseInternal = Promise.race([
            promise,
            new Promise((_, reject)=>{
                this.cancelInternal = ()=>reject($51cb7e70082e66c9$var$CANCEL_ERROR);
            })
        ]);
    }
    static from(promise) {
        return new $51cb7e70082e66c9$export$5782acf08706f13d(promise);
    }
}

});

parcelRegister("zo35K", function(module, exports) {

$parcel$export(module.exports, "AggregatorClient", () => $e6310830ec3a84a0$export$842695bca69eca86);

var $dS9cn = parcelRequire("dS9cn");

var $lFNae = parcelRequire("lFNae");

var $ckvH1 = parcelRequire("ckvH1");

var $ejWYQ = parcelRequire("ejWYQ");

var $dZkNM = parcelRequire("dZkNM");
class $e6310830ec3a84a0$export$842695bca69eca86 {
    static{
        // Static URLs
        this.EXPERIMENT_URL_PATH = 'experiment/v1';
    }
    static{
        this.QUICKSEARCH_API_URL = 'quicksearch/v1';
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList, backendExperiment: backendExperiment }){
        this.getAggregatorConfig = ()=>{
            return {
                url: this.serviceConfig.url,
                cloudId: this.cloudId,
                siteMasterList: this.siteMasterList
            };
        };
        this.getGenericProductPermissions = async (args)=>{
            return (0, $dZkNM.getFetchProductPermissions)(this.makeGetRequest)(args.productIds, this.cloudId, args.experience);
        };
        this.batchedGetExtensibleProductPermission = (0, $ejWYQ.batchMethod)((args)=>{
            const emptyProductPermissions = {
                productIds: [],
                experience: ''
            };
            if (args.length === 0) return emptyProductPermissions;
            return args.reduce((acc, arg)=>{
                return {
                    productIds: [
                        ...acc.productIds,
                        ...arg.productIds
                    ],
                    experience: arg.experience
                };
            }, emptyProductPermissions);
        }, this.getGenericProductPermissions, (response, id)=>response.get(id) || []);
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
        };
        this.makeGetRequest = (path)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            };
            return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
        this.backendExperiment = backendExperiment;
    }
    async getAbTestData(scope, experience, product) {
        const body = {
            cloudId: this.cloudId,
            scopes: [
                scope
            ],
            experience: experience,
            product: product
        };
        const response = await this.makePostRequest($e6310830ec3a84a0$export$842695bca69eca86.EXPERIMENT_URL_PATH, body);
        const scopeWithAbTest = response.scopes.find((s)=>s.id === scope);
        const abTestPromise = scopeWithAbTest ? Promise.resolve(scopeWithAbTest.abTest) : Promise.resolve(null);
        return abTestPromise;
    }
    /**
	 * Get a list of permitted scopes for the supplied product.
	 *
	 * Consumers should favour {@link batchedGetExtensibleProductPermission}, to batch
	 * multiple scopes calls into one. {@link getProductScopes} may be used when a caller
	 * explicitly wants a separate REST call to fetch scopes. One example may be if a product
	 * has different scopes caching rules to other products.
	 *
	 * @param productId the product id to lookup scopes for
	 * @param experience the experience this UI represents
	 * @returns a promise of a list of scopes for the supplied product
	 */ async getProductScopes(productId, experience) {
        const productScopeMap = await this.getGenericProductPermissions({
            productIds: [
                productId
            ],
            experience: experience
        });
        return productScopeMap.get(productId) || [];
    }
    /**
	 * Returns a list of {@link Products} which the user should see in the dialog
	 *
	 * @deprecated consumers should use {@link batchedGetExtensibleProductPermission} to fetch product scopes, or
	 * {@link getProductScopes} to force a separate call to fetch a single product's scopes.
	 *
	 */ async getProductPermissions(products, experience) {
        const lowercaseProductIds = products.map((p)=>p.toLowerCase());
        const productScopeMap = await this.getGenericProductPermissions({
            productIds: lowercaseProductIds,
            experience: experience
        });
        return lowercaseProductIds.filter((product)=>productScopeMap.get(product)?.length).map((product)=>product.toUpperCase());
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [], sourceProduct: sourceProduct }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, $ckvH1.limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn,
            experimentId: this.backendExperiment?.experimentId,
            shadowExperimentId: this.backendExperiment?.shadowExperimentId,
            ...sourceProduct ? {
                sourceProduct: sourceProduct
            } : {}
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $lFNae.timed)(this.makePostRequest($e6310830ec3a84a0$export$842695bca69eca86.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
}

});
parcelRegister("lFNae", function(module, exports) {

$parcel$export(module.exports, "timed", () => $11fc4f474ad1f553$export$d35186a762cd39c8);
const $11fc4f474ad1f553$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};

});

parcelRegister("ckvH1", function(module, exports) {

$parcel$export(module.exports, "extractSiteUrl", () => $1443f685fc002ca7$export$c9a345fa92182d1c);
$parcel$export(module.exports, "mapTenantIdToSiteUrl", () => $1443f685fc002ca7$export$fdb149c8c29e67a2);
$parcel$export(module.exports, "extractSiteIdBySiteUrl", () => $1443f685fc002ca7$export$4be99cb40bcf5aef);
$parcel$export(module.exports, "generatePeopleProfileUrl", () => $1443f685fc002ca7$export$ca98b3a6d1ea77f3);
$parcel$export(module.exports, "limitToMaxSiteUsage", () => $1443f685fc002ca7$export$ba81234f3ab84a86);
const $1443f685fc002ca7$export$c9a345fa92182d1c = ({ siteUrl: siteUrl, sites: sites })=>{
    if (siteUrl) return siteUrl;
    if (sites && sites.length > 0) return sites[0].siteUrl;
    return '';
};
const $1443f685fc002ca7$export$fdb149c8c29e67a2 = (siteId, sites)=>{
    const matchingSite = sites.find((site)=>site.cloudId === siteId);
    return matchingSite ? matchingSite.siteUrl : '';
};
const $1443f685fc002ca7$export$4be99cb40bcf5aef = (absSiteUrl, sites = [])=>{
    const baseUrlRegex = /^(http(s)?:\/\/[^\/]+)/;
    const urlRegexMatches = absSiteUrl.match(baseUrlRegex);
    if (!urlRegexMatches) return '';
    const baseUrl = urlRegexMatches[0];
    const matchingSite = sites.find((site)=>site.siteUrl === baseUrl);
    return matchingSite ? matchingSite.cloudId : '';
};
const $1443f685fc002ca7$export$ca98b3a6d1ea77f3 = (isMultiSite, absoluteUrl = '', accountId, contextPath = '')=>{
    if (isMultiSite && absoluteUrl) return absoluteUrl;
    return contextPath ? `/${contextPath}/people/${accountId}` : `/people/${accountId}`;
};
const $1443f685fc002ca7$var$MAX_SITES_INITIAL_QUERY = 3;
const $1443f685fc002ca7$export$ba81234f3ab84a86 = (sites = [])=>{
    return sites.slice(0, $1443f685fc002ca7$var$MAX_SITES_INITIAL_QUERY);
};

});

parcelRegister("ejWYQ", function(module, exports) {

$parcel$export(module.exports, "batchMethod", () => $a7dae7cbb19bb5a7$export$198da76335167312);

var $lFKmC = parcelRequire("lFKmC");
const $a7dae7cbb19bb5a7$export$198da76335167312 = (argumentResolver, finalFn, successfulResponseMapper, debounceTime = 100)=>{
    const batchMap = {};
    const timedFn = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
        const inFlightRequestsMap = {
            ...batchMap
        };
        const keys = Object.keys(inFlightRequestsMap);
        const args = keys.map((key)=>inFlightRequestsMap[key].arg);
        finalFn(argumentResolver(args)).then((response)=>{
            keys.forEach((key)=>{
                inFlightRequestsMap[key].resolve(successfulResponseMapper(response, key));
            });
        }).catch(()=>{
            keys.forEach((product)=>{
                inFlightRequestsMap[product].reject();
            });
        }).finally(()=>keys.forEach((key)=>delete batchMap[key]));
    }, debounceTime);
    return (id, arg)=>{
        const promise = new Promise((resolve, reject)=>{
            batchMap[id] = {
                resolve: resolve,
                reject: reject,
                arg: arg
            };
        });
        timedFn();
        return promise;
    };
};

});

parcelRegister("dZkNM", function(module, exports) {

$parcel$export(module.exports, "getFetchProductPermissions", () => $981ee2355df2e9f0$export$b756f4e692ecc8f);
const $981ee2355df2e9f0$var$SCOPES_API_URL = 'scopes/v1';
const $981ee2355df2e9f0$export$b756f4e692ecc8f = (makeRequest)=>async (productIds, cloudId, experience)=>{
        if (productIds.length === 0) return Promise.resolve(new Map());
        try {
            const productParams = productIds.map((productId)=>[
                    'productId',
                    productId
                ]);
            const params = new URLSearchParams([
                [
                    'experience',
                    experience
                ],
                ...productParams
            ]);
            const path = `${$981ee2355df2e9f0$var$SCOPES_API_URL}/${cloudId}?${params.toString()}`;
            const response = await makeRequest(path);
            return new Map(Object.keys(response.products).map((product)=>[
                    product,
                    response.products[product]
                ]));
        } catch (e) {
            return new Map();
        }
    };

});


parcelRegister("lQmoS", function(module, exports) {

$parcel$export(module.exports, "responseErrorToError", () => $b0458111dc193a05$export$59a963eec12b52ed);
function $b0458111dc193a05$export$59a963eec12b52ed(responseError) {
    let stringRepresentation = 'undefined';
    // Check if error response has a nested 'message' object, if so we use that instead.
    const error = responseError.message ? responseError.message : responseError;
    if (error) {
        // Convert it to string directly by default
        stringRepresentation = String(error);
        // If the error is an object we will try to JSON parse it
        if (typeof error === 'object') try {
            // Try to parse it as JSON
            stringRepresentation = JSON.stringify(responseError);
        } catch  {
        // Swallow all stringify errors
        }
    }
    return new Error(stringRepresentation);
}

});

parcelRegister("3GGIR", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $000ed1db71ba91f1$export$775b6bb06e53a214);
$parcel$export(module.exports, "GenericContainerResult", () => $000ed1db71ba91f1$export$6ec00f56b27cdc1d);
$parcel$export(module.exports, "PersonResult", () => $000ed1db71ba91f1$export$ca1a50bc869949e);
$parcel$export(module.exports, "ConfluenceObjectResult", () => $000ed1db71ba91f1$export$a99961038e9d5471);
$parcel$export(module.exports, "RecentConfluence", () => $000ed1db71ba91f1$export$18c69de2b4aa679c);
$parcel$export(module.exports, "ResultConfluence", () => $000ed1db71ba91f1$export$dc31f0db54ab1a30);
$parcel$export(module.exports, "RecentPerson", () => $000ed1db71ba91f1$export$cb8b6c470492bee8);
$parcel$export(module.exports, "ResultPerson", () => $000ed1db71ba91f1$export$ebb42dafe7a39a20);
$parcel$export(module.exports, "ConfluenceSpace", () => $000ed1db71ba91f1$export$8ee8726ca4e2f8bd);
$parcel$export(module.exports, "Person", () => $000ed1db71ba91f1$export$d0e824889e01c751);
var $000ed1db71ba91f1$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    return Scope;
}({});
const $000ed1db71ba91f1$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $000ed1db71ba91f1$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $000ed1db71ba91f1$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $000ed1db71ba91f1$export$80a5be864676016b = 'confluence.space';
const $000ed1db71ba91f1$export$70542451ad6057d2 = 'urs.user-confluence';
const $000ed1db71ba91f1$export$6ec00f56b27cdc1d = 'generic-container-result';
const $000ed1db71ba91f1$export$ca1a50bc869949e = 'person-result';
const $000ed1db71ba91f1$export$a99961038e9d5471 = 'confluence-object-result';
const $000ed1db71ba91f1$export$18c69de2b4aa679c = 'recent-confluence';
const $000ed1db71ba91f1$export$dc31f0db54ab1a30 = 'result-confluence';
const $000ed1db71ba91f1$export$cb8b6c470492bee8 = 'recent-person';
const $000ed1db71ba91f1$export$ebb42dafe7a39a20 = 'result-person';
const $000ed1db71ba91f1$export$602b44a55c824e30 = 'advanced-search-confluence';
const $000ed1db71ba91f1$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $000ed1db71ba91f1$export$bbd1709e62826142 = 'confluence-page';
const $000ed1db71ba91f1$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $000ed1db71ba91f1$export$b441f0c13fd510b9 = 'confluence-attachment';
const $000ed1db71ba91f1$export$8ee8726ca4e2f8bd = 'confluence-space';
const $000ed1db71ba91f1$export$d0e824889e01c751 = 'person';

});

parcelRegister("k7rsK", function(module, exports) {

$parcel$export(module.exports, "SimpleCache", () => $320d4902f9d2c6a3$export$de40364712978bcb);
// A imperfect workaround to represent variadic parameters (varargs) in typescript
class $320d4902f9d2c6a3$export$de40364712978bcb {
    static{
        this.DEFAULT_TIMEOUT_IN_MS = 900000;
    }
    /**
	 * @param initialValue The initial value, if undefined then the first get() call when initiate the cache value
	 *
	 * @param supplier The callback that will be called if the cache times out or if no existing value exists for the cache.
	 *                 In the case that the supplier throws an exception the error will not be cached. If there's an error
	 *                    we will instead return the last known good value but will attempt to refresh the cache again the next time
	 *                    get() is called.
	 *                 Any parameters passed into get() will be passed through to supplier. Unlike memoize the cache does not
	 *                    care about the parameters and will not be invalidated if these parameters change.
	 *
	 * @param timeoutMs The time to wait before allowing the cache to refresh, this defaults to 15 mins.
	 */ constructor(supplier, initialValue = null, timeoutMs = $320d4902f9d2c6a3$export$de40364712978bcb.DEFAULT_TIMEOUT_IN_MS){
        this.nextCacheRefreshTime = Date.now();
        this.timeoutMs = timeoutMs;
        this.supplier = supplier;
        this.currentValue = null;
        if (initialValue) {
            this.currentValue = initialValue;
            this.updateNextRefreshTime();
        }
    }
    get(...args) {
        if (!this.currentValue || Date.now() >= this.nextCacheRefreshTime) {
            this.updateNextRefreshTime();
            let exception = new Error('');
            try {
                const result = this.supplier(...args);
                this.currentValue = result;
                if (this.currentValue) return {
                    fromCache: false,
                    value: this.currentValue
                };
            } catch (e) {
                // If there's an error we will return the last good value but will attempt again on the next get()
                this.invalidate();
                exception = e;
            }
            if (!this.currentValue) throw new Error(`Failed to initialise a value for the cache: ${exception?.stack}`);
        }
        return {
            fromCache: true,
            value: this.currentValue
        };
    }
    /**
	 * Calls the given supplier and caches the value. If the value is a promise
	 * which rejects, the cache will be invalidated and a subsequent call to
	 * this function will call the supplier again.
	 * @param args
	 * @returns
	 */ getAsync(...args) {
        const { fromCache: fromCache, value: value } = this.get(...args);
        // When the cached value is a promise which rejects, invalidate the cache
        Promise.resolve(value).catch(()=>this.invalidate());
        return {
            fromCache: fromCache,
            value: value
        };
    }
    invalidate() {
        this.nextCacheRefreshTime = Date.now();
    }
    updateNextRefreshTime() {
        this.nextCacheRefreshTime = Date.now() + this.timeoutMs;
    }
}

});

parcelRegister("cm5BA", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_ITEM_ENTITIES", () => $c5556eab8dba4d6a$export$8c5e9a2b7d8e96fa);
$parcel$export(module.exports, "SEARCH_QUERY", () => $c5556eab8dba4d6a$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "sitesToLocations", () => $c5556eab8dba4d6a$export$13404986e7746e72);
const $c5556eab8dba4d6a$export$8c5e9a2b7d8e96fa = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:blogpost'
];
const $c5556eab8dba4d6a$export$f8e8a5f34f6ea725 = `
query($query: String, $entities:[String!]!, $locations: [String!]!, $confluenceFilters: SearchConfluenceFilter, $experience: String!){
  search{
    search(
      query: $query
      filters: {entities: $entities, locations: $locations, confluenceFilters: $confluenceFilters}
      analytics: {searchSessionId: "graphql"}
      experience: $experience
    ) {
      edges {
        node {
          id
          title
          url
          description
          type
          lastModifiedDate
          __typename
          ... on SearchConfluencePageBlogAttachment {
            type
            space {
              key
              iconUrl
            }
          }
        }
      }
    }
  }
}`;
const $c5556eab8dba4d6a$export$13404986e7746e72 = (sites, cloudId)=>{
    const cloudIds = sites.length > 0 ? sites : [
        cloudId
    ];
    const locations = cloudIds.map((cloudId)=>`ari:cloud:confluence::site/${cloudId}`);
    return locations;
};
const $c5556eab8dba4d6a$export$2351037d7dbc8a11 = (filters)=>{
    return {
        spaceFilter: filters.filter((filter)=>filter.type === 'space').map((filter)=>filter.id),
        contributorsFilter: filters.filter((filter)=>filter.type === 'contributor').map((filter)=>filter.id)
    };
};

});

parcelRegister("jmwt7", function(module, exports) {

$parcel$export(module.exports, "GraphQLClient", () => $94c9f4c748a90ea0$export$b0f268a6eae2cdf1);

var $dS9cn = parcelRequire("dS9cn");

var $lFNae = parcelRequire("lFNae");

var $ckvH1 = parcelRequire("ckvH1");

var $cm5BA = parcelRequire("cm5BA");
class $94c9f4c748a90ea0$export$b0f268a6eae2cdf1 {
    static{
        // Static URLs
        this.GRAPHQL_API_URL = 'graphql';
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
    async search({ query: query, context: // todo
    context, entities: entities, modelParams: // todo
    modelParams, resultLimit: // todo
    resultLimit, filters: filters, experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, $ckvH1.limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
        const locations = (0, $cm5BA.sitesToLocations)(cloudIdsToFilterOn, cloudId);
        const body = {
            query: (0, $cm5BA.SEARCH_QUERY),
            variables: {
                locations: locations,
                entities: entities,
                query: query,
                confluenceFilters: filters,
                experience: experience
            }
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $lFNae.timed)(this.makePostRequest($94c9f4c748a90ea0$export$b0f268a6eae2cdf1.GRAPHQL_API_URL, body));
        return {
            response: {
                rawData: response
            },
            requestDurationMs: requestDurationMs
        };
    }
}

});


parcelRegister("6SBvm", function(module, exports) {

var $dZMWQ = parcelRequire("dZMWQ");

var $eyPxb = parcelRequire("eyPxb");

var $joK88 = parcelRequire("joK88");

var $2jaDc = parcelRequire("2jaDc");

var $kjdG6 = parcelRequire("kjdG6");

var $6Fkfb = parcelRequire("6Fkfb");
var $5024e0e3cc4aeda1$var$getTime = Date.prototype.getTime;
function $5024e0e3cc4aeda1$var$deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $joK88(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? $joK88(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $5024e0e3cc4aeda1$var$objEquiv(actual, expected, opts);
}
function $5024e0e3cc4aeda1$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $5024e0e3cc4aeda1$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $5024e0e3cc4aeda1$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($5024e0e3cc4aeda1$var$isUndefinedOrNull(a) || $5024e0e3cc4aeda1$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($eyPxb(a) !== $eyPxb(b)) return false;
    var aIsRegex = $2jaDc(a);
    var bIsRegex = $2jaDc(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $kjdG6(a) === $kjdG6(b);
    if ($6Fkfb(a) && $6Fkfb(b)) return $5024e0e3cc4aeda1$var$getTime.call(a) === $5024e0e3cc4aeda1$var$getTime.call(b);
    var aIsBuffer = $5024e0e3cc4aeda1$var$isBuffer(a);
    var bIsBuffer = $5024e0e3cc4aeda1$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $dZMWQ(a);
        var kb = $dZMWQ(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$5024e0e3cc4aeda1$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = $5024e0e3cc4aeda1$var$deepEqual;

});
parcelRegister("dZMWQ", function(module, exports) {
'use strict';
var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;

var $1Houy = parcelRequire("1Houy");
var $a306f0f1bb5f232a$var$origKeys = Object.keys;

var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
    return $a306f0f1bb5f232a$var$origKeys(o);
} : (parcelRequire("eQVXL"));
var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
$a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
            return $a306f0f1bb5f232a$var$originalKeys(object);
        };
    } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
    return Object.keys || $a306f0f1bb5f232a$var$keysShim;
};
module.exports = $a306f0f1bb5f232a$var$keysShim;

});
parcelRegister("1Houy", function(module, exports) {
'use strict';
var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $13ccce2fa6936c75$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("eQVXL", function(module, exports) {
'use strict';
var $ad02e23a59d3730f$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
    var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
    var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy")); // eslint-disable-line global-require
    var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
    var $ad02e23a59d3730f$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $ad02e23a59d3730f$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
        try {
            return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $ad02e23a59d3730f$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
        var isArguments = $ad02e23a59d3730f$var$isArgs(object);
        var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($ad02e23a59d3730f$var$hasDontEnumBug) {
            var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $ad02e23a59d3730f$var$keysShim;

});


parcelRegister("eyPxb", function(module, exports) {
'use strict';

var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();

var $53KqO = parcelRequire("53KqO");
var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
    if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
};
var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
    if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
};
var $a99c3747cd09063d$var$supportsStandardArguments = function() {
    return $a99c3747cd09063d$var$isStandardArguments(arguments);
}();
$a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments; // for tests
module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;

});
parcelRegister("fmBzB", function(module, exports) {
'use strict';

var $9T9x9 = parcelRequire("9T9x9");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $9T9x9() && !!Symbol.toStringTag;
};

});

parcelRegister("53KqO", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $h05ZS = parcelRequire("h05ZS");
var $3af13fe1c3fdd190$var$$indexOf = $h05ZS($iPtqy('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $iPtqy(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $3af13fe1c3fdd190$var$$indexOf(name, '.prototype.') > -1) return $h05ZS(intrinsic);
    return intrinsic;
};

});
parcelRegister("h05ZS", function(module, exports) {
'use strict';

var $6ElEw = parcelRequire("6ElEw");

var $7Th0d = parcelRequire("7Th0d");

var $h08zB = parcelRequire("h08zB");

var $ghZDY = parcelRequire("ghZDY");
module.exports = function callBind(originalFunction) {
    var func = $h08zB(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $6ElEw(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($7Th0d) $7Th0d(module.exports, 'apply', {
    value: $ghZDY
});
else module.exports.apply = $ghZDY;

});
parcelRegister("6ElEw", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $le88V = parcelRequire("le88V");

var $4d77463b7ea9d419$var$hasDescriptors = (parcelRequire("9lmlE"))();

var $lBvcQ = parcelRequire("lBvcQ");

var $kQfBa = parcelRequire("kQfBa");
var $4d77463b7ea9d419$var$$floor = $iPtqy('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $kQfBa('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $4d77463b7ea9d419$var$$floor(length) !== length) throw new $kQfBa('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $lBvcQ) {
        var desc = $lBvcQ(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($4d77463b7ea9d419$var$hasDescriptors) $le88V(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $le88V(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("le88V", function(module, exports) {
'use strict';

var $7Th0d = parcelRequire("7Th0d");

var $6ZTEL = parcelRequire("6ZTEL");

var $kQfBa = parcelRequire("kQfBa");

var $lBvcQ = parcelRequire("lBvcQ");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $kQfBa('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $kQfBa('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $kQfBa('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $kQfBa('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $kQfBa('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $kQfBa('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$lBvcQ && $lBvcQ(obj, property);
    if ($7Th0d) $7Th0d(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6ZTEL('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9lmlE", function(module, exports) {
'use strict';

var $7Th0d = parcelRequire("7Th0d");
var $6cd7691e5358e89c$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7Th0d;
};
$6cd7691e5358e89c$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7Th0d) return null;
    try {
        return $7Th0d([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6cd7691e5358e89c$var$hasPropertyDescriptors;

});


parcelRegister("ghZDY", function(module, exports) {
'use strict';

var $g2Z6Y = parcelRequire("g2Z6Y");

var $iJCdB = parcelRequire("iJCdB");

var $4XlJF = parcelRequire("4XlJF");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $4XlJF($g2Z6Y, $iJCdB, arguments);
};

});




parcelRegister("joK88", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");

var $h05ZS = parcelRequire("h05ZS");

var $iwNFM = parcelRequire("iwNFM");

var $eJazH = parcelRequire("eJazH");

var $90RaO = parcelRequire("90RaO");
var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
$d94D2($e1f40ab7009ea590$var$polyfill, {
    getPolyfill: $eJazH,
    implementation: $iwNFM,
    shim: $90RaO
});
module.exports = $e1f40ab7009ea590$var$polyfill;

});
parcelRegister("d94D2", function(module, exports) {
'use strict';

var $dZMWQ = parcelRequire("dZMWQ");
var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
var $991fb4ca00f3da54$var$concat = Array.prototype.concat;

var $le88V = parcelRequire("le88V");
var $991fb4ca00f3da54$var$isFunction = function(fn) {
    return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
};

var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
    }
    if ($991fb4ca00f3da54$var$supportsDescriptors) $le88V(object, name, value, true);
    else $le88V(object, name, value);
};
var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $dZMWQ(map);
    if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
module.exports = $991fb4ca00f3da54$var$defineProperties;

});

parcelRegister("iwNFM", function(module, exports) {
'use strict';
var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("eJazH", function(module, exports) {
'use strict';

var $iwNFM = parcelRequire("iwNFM");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $iwNFM;
};

});

parcelRegister("90RaO", function(module, exports) {
'use strict';

var $eJazH = parcelRequire("eJazH");

var $d94D2 = parcelRequire("d94D2");
module.exports = function shimObjectIs() {
    var polyfill = $eJazH();
    $d94D2(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("2jaDc", function(module, exports) {
'use strict';

var $3T2jo = parcelRequire("3T2jo");

var $1ae59a456e400bfc$var$hasToStringTag = (parcelRequire("fmBzB"))();

var $kO8H7 = parcelRequire("kO8H7");

var $lBvcQ = parcelRequire("lBvcQ");
/** @type {import('.')} */ var $1ae59a456e400bfc$var$fn;
if ($1ae59a456e400bfc$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $1ae59a456e400bfc$var$$exec = $3T2jo('RegExp.prototype.exec');
    /** @type {object} */ var $1ae59a456e400bfc$var$isRegexMarker = {};
    var $1ae59a456e400bfc$var$throwRegexMarker = function() {
        throw $1ae59a456e400bfc$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $1ae59a456e400bfc$var$badStringifier = {
        toString: $1ae59a456e400bfc$var$throwRegexMarker,
        valueOf: $1ae59a456e400bfc$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $1ae59a456e400bfc$var$badStringifier[Symbol.toPrimitive] = $1ae59a456e400bfc$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $1ae59a456e400bfc$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $lBvcQ(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $kO8H7(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $1ae59a456e400bfc$var$$exec(value, /** @type {unknown} */ $1ae59a456e400bfc$var$badStringifier);
        } catch (e) {
            return e === $1ae59a456e400bfc$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $1ae59a456e400bfc$var$$toString = $3T2jo('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $1ae59a456e400bfc$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $1ae59a456e400bfc$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $1ae59a456e400bfc$var$$toString(value) === $1ae59a456e400bfc$var$regexClass;
    };
}
module.exports = $1ae59a456e400bfc$var$fn;

});

parcelRegister("kjdG6", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");

var $h05ZS = parcelRequire("h05ZS");

var $ckZYs = parcelRequire("ckZYs");

var $1kOo9 = parcelRequire("1kOo9");

var $jvGc4 = parcelRequire("jvGc4");
var $ec90312fceb278a3$var$flagsBound = $h05ZS($1kOo9());
$d94D2($ec90312fceb278a3$var$flagsBound, {
    getPolyfill: $1kOo9,
    implementation: $ckZYs,
    shim: $jvGc4
});
module.exports = $ec90312fceb278a3$var$flagsBound;

});
parcelRegister("ckZYs", function(module, exports) {
'use strict';

var $6vStt = parcelRequire("6vStt");

var $kQfBa = parcelRequire("kQfBa");
var $8fb76d112b6eea5e$var$$Object = Object;
module.exports = $6vStt(function flags() {
    if (this == null || this !== $8fb76d112b6eea5e$var$$Object(this)) throw new $kQfBa('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.hasIndices) result += 'd';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.unicodeSets) result += 'v';
    if (this.sticky) result += 'y';
    return result;
}, 'get flags', true);

});
parcelRegister("6vStt", function(module, exports) {
'use strict';

var $le88V = parcelRequire("le88V");

var $4bdfe4c785c362d4$var$hasDescriptors = (parcelRequire("9lmlE"))();

var $4bdfe4c785c362d4$var$functionsHaveConfigurableNames = (parcelRequire("9x3DX")).functionsHaveConfigurableNames();

var $kQfBa = parcelRequire("kQfBa");
/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') throw new $kQfBa('`fn` is not a function');
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $4bdfe4c785c362d4$var$functionsHaveConfigurableNames) {
        if ($4bdfe4c785c362d4$var$hasDescriptors) $le88V(/** @type {Parameters<define>[0]} */ fn, 'name', name, true, true);
        else $le88V(/** @type {Parameters<define>[0]} */ fn, 'name', name);
    }
    return fn;
};

});
parcelRegister("9x3DX", function(module, exports) {
'use strict';
var $6f0a05a05756bb65$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var $6f0a05a05756bb65$var$gOPD = Object.getOwnPropertyDescriptor;
if ($6f0a05a05756bb65$var$gOPD) try {
    $6f0a05a05756bb65$var$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $6f0a05a05756bb65$var$gOPD = null;
}
$6f0a05a05756bb65$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$6f0a05a05756bb65$var$functionsHaveNames() || !$6f0a05a05756bb65$var$gOPD) return false;
    var desc = $6f0a05a05756bb65$var$gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $6f0a05a05756bb65$var$$bind = Function.prototype.bind;
$6f0a05a05756bb65$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $6f0a05a05756bb65$var$functionsHaveNames() && typeof $6f0a05a05756bb65$var$$bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = $6f0a05a05756bb65$var$functionsHaveNames;

});



parcelRegister("1kOo9", function(module, exports) {
'use strict';

var $ckZYs = parcelRequire("ckZYs");

var $d94D2 = parcelRequire("d94D2");
var $0f8ebecd0b3aa0aa$require$supportsDescriptors = $d94D2.supportsDescriptors;
var $0f8ebecd0b3aa0aa$var$$gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if ($0f8ebecd0b3aa0aa$require$supportsDescriptors && /a/mig.flags === 'gim') {
        var descriptor = $0f8ebecd0b3aa0aa$var$$gOPD(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
            /* eslint getter-return: 0 */ var calls = '';
            var o = {};
            Object.defineProperty(o, 'hasIndices', {
                get: function() {
                    calls += 'd';
                }
            });
            Object.defineProperty(o, 'sticky', {
                get: function() {
                    calls += 'y';
                }
            });
            descriptor.get.call(o);
            if (calls === 'dy') return descriptor.get;
        }
    }
    return $ckZYs;
};

});

parcelRegister("jvGc4", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");
var $e341a45c8a08c1ee$require$supportsDescriptors = $d94D2.supportsDescriptors;

var $1kOo9 = parcelRequire("1kOo9");

var $lBvcQ = parcelRequire("lBvcQ");
var $e341a45c8a08c1ee$var$defineProperty = Object.defineProperty;

var $6GVaQ = parcelRequire("6GVaQ");

var $863dK = parcelRequire("863dK");
var $e341a45c8a08c1ee$var$regex = /a/;
module.exports = function shimFlags() {
    if (!$e341a45c8a08c1ee$require$supportsDescriptors || !$863dK) throw new $6GVaQ('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = $1kOo9();
    var proto = $863dK($e341a45c8a08c1ee$var$regex);
    var descriptor = $lBvcQ(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) $e341a45c8a08c1ee$var$defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

});


parcelRegister("6Fkfb", function(module, exports) {
'use strict';

var $3T2jo = parcelRequire("3T2jo");
var $4da6466ec2c71190$var$getDay = $3T2jo('Date.prototype.getDay');
/** @type {import('.')} */ var $4da6466ec2c71190$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $4da6466ec2c71190$var$getDay(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(value: unknown) => string} */ var $4da6466ec2c71190$var$toStr = $3T2jo('Object.prototype.toString');
var $4da6466ec2c71190$var$dateClass = '[object Date]';

var $4da6466ec2c71190$var$hasToStringTag = (parcelRequire("fmBzB"))();
/** @type {import('.')} */ module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return $4da6466ec2c71190$var$hasToStringTag ? $4da6466ec2c71190$var$tryDateObject(value) : $4da6466ec2c71190$var$toStr(value) === $4da6466ec2c71190$var$dateClass;
};

});


parcelRegister("8RYU8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceRecentsClient", () => $46ad8c35ae2dd88a$export$2c04424b0b9ef0ac);

var $dS9cn = parcelRequire("dS9cn");

var $aHYZV = parcelRequire("aHYZV");


var $lFNae = parcelRequire("lFNae");

var $k7rsK = parcelRequire("k7rsK");

var $3GGIR = parcelRequire("3GGIR");
const $46ad8c35ae2dd88a$export$be774cfa50234d6d = 'rest/recentlyviewed/1.0/recent';
const $46ad8c35ae2dd88a$export$d8751bf2ebec9fba = 'rest/recentlyviewed/1.0/recent/spaces';
const $46ad8c35ae2dd88a$var$RECENT_PAGES_LIMIT = 200;
const $46ad8c35ae2dd88a$var$RECENT_SPACE_LIMIT = 5;

class $46ad8c35ae2dd88a$export$2c04424b0b9ef0ac {
    constructor({ url: url, isCollaborationGraphEnabled: isCollaborationGraphEnabled, recentItemsSupplier: recentItemsSupplier, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl }, collabGraphClient){
        this.recentItemsSupplier = async ()=>{
            if (this.useRecentWork) {
                const { createActivityClient: createActivityClient } = await (parcelRequire("il3ui"));
                const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentWorkAPIUrl);
                const { viewed: viewed } = await activityClient.fetchActivities([
                    250
                ], {
                    products: [
                        'confluence'
                    ]
                }, [
                    'viewed'
                ]);
                const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$46ad8c35ae2dd88a$var$recentWorkItemToResult(item));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: 0
                };
            } else {
                const baseUrl = this.serviceConfig.url;
                const recentPagesPromiseWithTimings = this.createRecentRequestPromise($46ad8c35ae2dd88a$export$be774cfa50234d6d, {
                    limit: $46ad8c35ae2dd88a$var$RECENT_PAGES_LIMIT
                });
                const { result: result, durationMs: durationMs } = await recentPagesPromiseWithTimings;
                const items = result.filter((page)=>!!page.title).map((recentPage)=>$46ad8c35ae2dd88a$var$recentPageToResult(recentPage, baseUrl));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: durationMs
                };
            }
        };
        this.recentSpacesSupplier = ()=>{
            if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getContainers([
                (0, $94417f843d249742$export$e28d152a38023114)
            ]).then((response)=>$46ad8c35ae2dd88a$var$mapCollabGraphContainer(response));
            else {
                const recentSpacesPromise = this.createRecentRequestPromise($46ad8c35ae2dd88a$export$d8751bf2ebec9fba, {
                    limit: $46ad8c35ae2dd88a$var$RECENT_SPACE_LIMIT
                });
                return recentSpacesPromise.then(({ result: result, durationMs: durationMs })=>({
                        items: result.map((recentSpace)=>$46ad8c35ae2dd88a$var$recentSpaceToResult(recentSpace, `${this.baseUrl}/spaces/${recentSpace.key}`)),
                        timings: durationMs
                    }));
            }
        };
        this.serviceConfig = {
            url: url
        };
        this.baseUrl = url;
        this.recentItemCache = new (0, $k7rsK.SimpleCache)(recentItemsSupplier || this.recentItemsSupplier);
        this.recentSpaceCache = new (0, $k7rsK.SimpleCache)(this.recentSpacesSupplier);
        this.collaborationGraphClient = collabGraphClient;
        this.isCollabGraphEnabled = isCollaborationGraphEnabled;
        this.useRecentWork = useRecentWork || false;
        this.recentWorkAPIUrl = recentWorkAPIUrl;
    }
    getRecent(cache) {
        const { fromCache: fromCache, value: value } = cache.get();
        return (0, $aHYZV.CancellablePromise).from(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    getRecentItems() {
        return this.getRecent(this.recentItemCache);
    }
    getRecentSpaces() {
        return this.getRecent(this.recentSpaceCache);
    }
    createRecentRequestPromise(path, queryParams) {
        const options = {
            path: path,
            queryParams: queryParams
        };
        const requestPromise = (0, $dS9cn.utils).requestService(this.serviceConfig, options);
        return (0, $lFNae.timed)(requestPromise);
    }
}
function $46ad8c35ae2dd88a$var$recentWorkItemToResult(recentItem) {
    const { object: object, containers: containers } = recentItem;
    return {
        resultId: object.id,
        containerName: containers[0].name,
        containerId: '',
        resultType: (0, $3GGIR.ConfluenceObjectResult),
        isRecentResult: true,
        name: object.name || '',
        href: object.url,
        contentType: `confluence-${object.type}`,
        lastModified: undefined,
        analyticsType: (0, $3GGIR.RecentConfluence)
    };
}
function $46ad8c35ae2dd88a$var$recentPageToResult(recentPage, baseUrl) {
    return {
        resultId: String(recentPage.id),
        name: recentPage.title || '',
        href: `${baseUrl}${recentPage.url}`,
        containerName: recentPage.space,
        analyticsType: (0, $3GGIR.RecentConfluence),
        resultType: (0, $3GGIR.ConfluenceObjectResult),
        contentType: `confluence-${recentPage.contentType}`,
        iconClass: recentPage.iconClass,
        containerId: recentPage.spaceId.toString(),
        isRecentResult: true,
        lastModified: undefined,
        spaceId: recentPage.spaceId?.toString()
    };
}
function $46ad8c35ae2dd88a$var$recentSpaceToResult(recentSpace, href) {
    return {
        resultId: recentSpace.id,
        name: recentSpace.name,
        key: recentSpace.key,
        href: href,
        avatarUrl: recentSpace.icon,
        analyticsType: (0, $3GGIR.RecentConfluence),
        resultType: (0, $3GGIR.GenericContainerResult),
        contentType: (0, $3GGIR.ConfluenceSpace),
        id: recentSpace.id
    };
}
function $46ad8c35ae2dd88a$var$mapCollabGraphContainer(response) {
    const items = response.collaborationGraphEntities.map((item)=>({
            id: item.containerDetails?.id,
            key: item.containerDetails?.key,
            icon: item.containerDetails?.iconUrl,
            name: item.containerDetails?.name,
            url: item.containerDetails?.url,
            siteId: item.siteId
        })).filter((space)=>space.id !== undefined).map((space)=>$46ad8c35ae2dd88a$var$recentSpaceToResult(space, space.url));
    return {
        items: items,
        timings: response.timings
    };
}

});
const $94417f843d249742$export$e28d152a38023114 = 'confluenceSpace';
const $94417f843d249742$export$b9a68081b849a9ab = 'jiraProject';

parcelRegister("il3ui", function(module, exports) {

let $d59ce4c1c43b96ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d59ce4c1c43b96ed$var$load("7xpt2").then(()=>parcelRequire('8l3CP'));

});


parcelRegister("jFHlY", function(module, exports) {

$parcel$export(module.exports, "MAX_CG_RESULTS", () => $8e63f092c88bbd60$export$8b133b5f27893e80);
$parcel$export(module.exports, "CONTEXT_USER_ID", () => $8e63f092c88bbd60$export$886facd7f1fb825b);
$parcel$export(module.exports, "QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT", () => $8e63f092c88bbd60$export$c4871241365cf270);
$parcel$export(module.exports, "CollaborationGraphClient", () => $8e63f092c88bbd60$export$cd5b4a06db0ea4e2);

var $jRjRt = parcelRequire("jRjRt");

var $8TDoB = parcelRequire("8TDoB");
const $8e63f092c88bbd60$export$8b133b5f27893e80 = 10;
const $8e63f092c88bbd60$export$886facd7f1fb825b = 'context';
const $8e63f092c88bbd60$export$c4871241365cf270 = 'quickSearch';
class $8e63f092c88bbd60$export$cd5b4a06db0ea4e2 {
    constructor(config){
        this.getContainers = (containerTypes, sites = [])=>{
            if (this.isMultiSite) return this.collabGraphMultiSite.getContainers({
                selectedSites: sites,
                containerTypes: containerTypes,
                allSites: this.sites.length > 0 ? this.sites : [
                    {
                        cloudId: this.cloudId
                    }
                ]
            });
            else return this.collabGraphSingleSite.getContainers({
                containerTypes: containerTypes,
                cloudId: this.cloudId
            });
        };
        this.getUsers = (sites = [])=>{
            if (this.isMultiSite) return this.collabGraphMultiSite.getUsers({
                allSites: this.sites.length > 0 ? this.sites : [
                    {
                        cloudId: this.cloudId
                    }
                ],
                selectedSites: sites
            });
            else return this.collabGraphSingleSite.getUsers({
                cloudId: this.cloudId
            });
        };
        this.collabGraphSingleSite = new (0, $jRjRt.CollaborationGraphSingleSite)(config);
        this.collabGraphMultiSite = new (0, $8TDoB.CollaborationGraphMultiSite)(config);
        this.isMultiSite = config.isMultiSite;
        this.cloudId = config.cloudId;
        this.sites = config.sites;
    }
}

});
parcelRegister("jRjRt", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraphSingleSite", () => $64fd0e4444d66622$export$75acaca275e7d34b);

var $6DbKR = parcelRequire("6DbKR");

var $jFHlY = parcelRequire("jFHlY");
class $64fd0e4444d66622$export$75acaca275e7d34b extends (0, $6DbKR.CollaborationGraph) {
    constructor({ collaborationGraphUrl: url }){
        super({
            url: url
        }), this.CONTAINER_URL_PATH = 'v1/collaborationgraph/user/container', this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
    }
    getUsers(arg) {
        return this.usersCache.get(arg).value;
    }
    getContainers({ containerTypes: containerTypes, cloudId: cloudId }) {
        return this.containersCache.get({
            containerTypes: containerTypes,
            cloudId: cloudId
        }).value;
    }
    async getContainersSupplier({ containerTypes: containerTypes, cloudId: cloudId }) {
        const body = {
            containerTypes: containerTypes,
            context: {
                principalId: (0, $jFHlY.CONTEXT_USER_ID),
                siteId: cloudId,
                contextType: (0, $jFHlY.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $jFHlY.MAX_CG_RESULTS),
            userId: (0, $jFHlY.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: cloudId
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    async getUsersSupplier({ cloudId: cloudId = '', collabGraphSessionId: collabGraphSessionId = '' }) {
        const body = {
            context: {
                principalId: (0, $jFHlY.CONTEXT_USER_ID),
                siteId: cloudId,
                sessionId: collabGraphSessionId,
                contextType: (0, $jFHlY.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $jFHlY.MAX_CG_RESULTS),
            userId: (0, $jFHlY.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: cloudId
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
}

});
parcelRegister("6DbKR", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraph", () => $726c91b739953762$export$d4989257696242c9);

var $dS9cn = parcelRequire("dS9cn");

var $k7rsK = parcelRequire("k7rsK");

var $lFNae = parcelRequire("lFNae");
class $726c91b739953762$export$d4989257696242c9 {
    async makeRequest(path, body) {
        const options = {
            path: path,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(body)
            }
        };
        return (0, $lFNae.timed)((0, $dS9cn.utils).requestService(this.serviceConfig, options));
    }
    constructor({ url: url }){
        this.serviceConfig = {
            url: url
        };
        this.getContainersSupplier = this.getContainersSupplier.bind(this);
        this.getUsersSupplier = this.getUsersSupplier.bind(this);
        this.containersCache = new (0, $k7rsK.SimpleCache)(this.getContainersSupplier);
        this.usersCache = new (0, $k7rsK.SimpleCache)(this.getUsersSupplier);
    }
}

});


parcelRegister("8TDoB", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraphMultiSite", () => $84bac3b9614ce172$export$6150ad6d7e95f129);

var $3JOCw = parcelRequire("3JOCw");

var $6DbKR = parcelRequire("6DbKR");

var $jFHlY = parcelRequire("jFHlY");

var $ckvH1 = parcelRequire("ckvH1");
const $84bac3b9614ce172$var$mergeUsers = (prevResult, nextResult)=>({
        timings: Math.max(prevResult.timings, nextResult.timings),
        collaborationGraphEntities: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(prevResult.collaborationGraphEntities.concat(nextResult.collaborationGraphEntities), (user)=>user.id)
    });
const $84bac3b9614ce172$var$emptyUserResponse = {
    timings: 0,
    collaborationGraphEntities: []
};
class $84bac3b9614ce172$export$6150ad6d7e95f129 extends (0, $6DbKR.CollaborationGraph) {
    async getContainersSupplier(arg) {
        const body = {
            containerTypes: arg.containerTypes,
            context: {
                principalId: (0, $jFHlY.CONTEXT_USER_ID),
                siteIds: arg.cloudIds,
                contextType: (0, $jFHlY.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $jFHlY.MAX_CG_RESULTS),
            userId: (0, $jFHlY.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: (0, $ckvH1.extractSiteIdBySiteUrl)(cgEntity.containerDetails.url, arg.allSites)
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    async getUsersSupplier(arg) {
        const results = arg.cloudIds.map(async (cloudId)=>{
            const body = {
                context: {
                    principalId: (0, $jFHlY.CONTEXT_USER_ID),
                    siteId: cloudId,
                    contextType: (0, $jFHlY.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
                },
                maxNumberOfResults: (0, $jFHlY.MAX_CG_RESULTS),
                userId: (0, $jFHlY.CONTEXT_USER_ID),
                expanded: true
            };
            const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
            result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>({
                    ...cgEntity,
                    siteId: cloudId
                }));
            return {
                ...result,
                timings: durationMs
            };
        });
        return Promise.all(results).then((values)=>values.reduce($84bac3b9614ce172$var$mergeUsers, $84bac3b9614ce172$var$emptyUserResponse));
    }
    getUsers({ allSites: allSites, selectedSites: selectedSites }) {
        if (selectedSites.length === 0) return this.usersCache.get({
            cloudIds: (0, $ckvH1.limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId)
        }).value;
        else return this.getUsersSupplier({
            cloudIds: selectedSites.map((site)=>site.cloudId)
        });
    }
    getContainers({ allSites: allSites, selectedSites: selectedSites, containerTypes: containerTypes }) {
        if (selectedSites.length === 0) return this.containersCache.get({
            cloudIds: (0, $ckvH1.limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId),
            containerTypes: containerTypes
        }).value;
        else return this.getContainersSupplier({
            cloudIds: selectedSites.map((site)=>site.cloudId),
            containerTypes: containerTypes,
            allSites: allSites
        });
    }
    constructor(config){
        super({
            url: config.collaborationGraphUrl
        }), this.CONTAINER_URL_PATH = 'v1/collaborationgraph/multitenant/user/container', this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
    }
}

});



parcelRegister("3nZO6", function(module, exports) {

$parcel$export(module.exports, "JiraSearchClientProvider", () => $b13747da55b8eb78$export$f8102de5af58503c);
$parcel$export(module.exports, "useJiraSearchClientContext", () => $b13747da55b8eb78$export$71e1e199804dfd5e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6SBvm = parcelRequire("6SBvm");

var $8QpSo = parcelRequire("8QpSo");

var $fnNov = parcelRequire("fnNov");

var $fisvb = parcelRequire("fisvb");

var $jFHlY = parcelRequire("jFHlY");
var $ckvH1 = parcelRequire("ckvH1");

var $j97IK = parcelRequire("j97IK");
const $b13747da55b8eb78$var$ERROR_MESSAGE = 'Jira search client has not been instantiated. This is most likely because you are missing a JiraSearchClientProvider.';
const $b13747da55b8eb78$var$defaultCollaborationGraphConfig = {
    collaborationGraphUrl: 'gateway/api/collaboration',
    useCollaborationGraphForRecents: false
};
const $b13747da55b8eb78$var$getCollabGraphClientWithConfig = (0, $8QpSo.default)((config)=>new (0, $jFHlY.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6SBvm))));
const $b13747da55b8eb78$export$5b76b773dfc5ee6a = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $b13747da55b8eb78$var$DEFAULT_SITES = [];
const $b13747da55b8eb78$export$f8102de5af58503c = ({ aggregatorUrl: aggregatorUrl, cloudId: cloudId, isUserAnonymous: isUserAnonymous, collaborationGraphUrl: collaborationGraphUrl, children: children, baseUrl: baseUrl, accountId: accountId, siteUrl: siteUrl = '', recentIssuesSupplier: recentIssuesSupplier, currentUserSupplier: currentUserSupplier, sites: sites = $b13747da55b8eb78$var$DEFAULT_SITES })=>{
    siteUrl = (0, $5uXOq.useMemo)(()=>(0, $ckvH1.extractSiteUrl)({
            siteUrl: siteUrl,
            sites: sites
        }), [
        siteUrl,
        sites
    ]);
    const { backendExperiment: backendExperiment } = (0, $j97IK.useExperiments)();
    const searchClient = (0, $5uXOq.useMemo)(()=>new (0, $fisvb.JiraSearchClient)({
            siteMasterList: sites,
            url: aggregatorUrl,
            cloudId: cloudId,
            isUserAnonymous: isUserAnonymous,
            recentIssuesSupplier: recentIssuesSupplier,
            siteUrl: siteUrl,
            backendExperiment: backendExperiment
        }), [
        aggregatorUrl,
        cloudId,
        isUserAnonymous,
        recentIssuesSupplier,
        siteUrl,
        sites,
        backendExperiment
    ]);
    const collabGraphClient = $b13747da55b8eb78$var$getCollabGraphClientWithConfig({
        // If no collaborationGraphUrl is passed as a prop, use the fallback (default) URL
        collaborationGraphUrl: collaborationGraphUrl || $b13747da55b8eb78$var$defaultCollaborationGraphConfig.collaborationGraphUrl,
        cloudId: cloudId,
        isMultiSite: sites.length > 1,
        sites: sites
    });
    const currentUserClient = (0, $5uXOq.useMemo)(()=>accountId ? new (0, $fnNov.JiraCurrentUserClient)({
            accountId: accountId,
            baseUrl: baseUrl,
            currentUserSupplier: currentUserSupplier
        }) : undefined, [
        accountId,
        baseUrl,
        currentUserSupplier
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b13747da55b8eb78$export$5b76b773dfc5ee6a.Provider, {
        value: {
            searchClient: searchClient,
            collabGraphClient: collabGraphClient,
            currentUserClient: currentUserClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites
        },
        children: children
    });
};
const $b13747da55b8eb78$export$413dca1b70dbb4a7 = (Component)=>{
    return (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b13747da55b8eb78$export$5b76b773dfc5ee6a.Consumer, {
            children: ({ searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, cloudId: cloudId, sites: sites })=>{
                if (!searchClient) throw new Error($b13747da55b8eb78$var$ERROR_MESSAGE);
                const { ...rest } = props;
                return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...rest,
                    searchClient: searchClient,
                    collabGraphClient: collabGraphClient,
                    currentUserClient: currentUserClient,
                    cloudId: cloudId,
                    sites: sites
                });
            }
        });
};
function $b13747da55b8eb78$export$71e1e199804dfd5e() {
    const { searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, siteUrl: siteUrl, sites: sites, cloudId: cloudId } = (0, $5uXOq.useContext)($b13747da55b8eb78$export$5b76b773dfc5ee6a);
    if (!searchClient) throw new Error($b13747da55b8eb78$var$ERROR_MESSAGE);
    return {
        searchClient: searchClient,
        collabGraphClient: collabGraphClient,
        currentUserClient: currentUserClient,
        siteUrl: siteUrl,
        cloudId: cloudId,
        sites: sites
    };
}

});
parcelRegister("fnNov", function(module, exports) {

$parcel$export(module.exports, "JiraCurrentUserClient", () => $c8ed37043c300774$export$bbcfcc9f52275229);

var $5uXOq = parcelRequire("5uXOq");

var $dS9cn = parcelRequire("dS9cn");

var $lFNae = parcelRequire("lFNae");

var $k7rsK = parcelRequire("k7rsK");

var $3nZO6 = parcelRequire("3nZO6");
const $c8ed37043c300774$var$USER_DATA_URL = '/rest/api/3/user';
class $c8ed37043c300774$export$bbcfcc9f52275229 {
    constructor({ accountId: accountId, baseUrl: baseUrl, currentUserSupplier: currentUserSupplier }){
        this.getCurrentUser = ()=>this.currentUserCache.get().value;
        this.getUserSupplier = async ()=>{
            const { result: result, durationMs: durationMs } = await this.makeRequest($c8ed37043c300774$var$USER_DATA_URL);
            return {
                ...result,
                timings: durationMs
            };
        };
        this.serviceConfig = {
            url: baseUrl
        };
        this.accountId = accountId;
        this.currentUserCache = new (0, $k7rsK.SimpleCache)(currentUserSupplier || this.getUserSupplier);
    }
    async makeRequest(path) {
        const options = {
            path: path,
            queryParams: {
                accountId: this.accountId,
                expand: 'applicationRoles'
            }
        };
        return (0, $lFNae.timed)((0, $dS9cn.utils).requestService(this.serviceConfig, options));
    }
}
const $c8ed37043c300774$export$2393d475b44b8a57 = (user = {})=>{
    const [loadingComplete, setLoadingComplete] = (0, $5uXOq.useState)(false);
    const [currentUser, setCurrentUser] = (0, $5uXOq.useState)(user);
    const { currentUserClient: currentUserClient } = (0, $3nZO6.useJiraSearchClientContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (!loadingComplete) {
            let shouldUpdate = true;
            currentUserClient?.getCurrentUser().then((result)=>{
                if (shouldUpdate && !loadingComplete) {
                    setCurrentUser({
                        id: result.accountId,
                        name: result.displayName,
                        avatarUrl: result.avatarUrls['24x24'],
                        email: result.emailAddress,
                        hasSoftwareAccess: result.applicationRoles.items.some((item)=>item.key === 'jira-software')
                    });
                    setLoadingComplete(true);
                }
            }).catch(()=>{}); // swallow any errors
            return ()=>{
                shouldUpdate = false;
            };
        }
    }, [
        currentUserClient,
        loadingComplete
    ]);
    return currentUser;
};

});

parcelRegister("fisvb", function(module, exports) {

$parcel$export(module.exports, "JiraSearchClient", () => $c87c5ab85f19b8e5$export$824e4d5b28750c3f);
$parcel$export(module.exports, "attributeTypeToContentType", () => $c87c5ab85f19b8e5$export$1436a8642ffb43cf);

var $aHYZV = parcelRequire("aHYZV");

var $zo35K = parcelRequire("zo35K");
var $lQmoS = parcelRequire("lQmoS");

var $4biU5 = parcelRequire("4biU5");

var $k7rsK = parcelRequire("k7rsK");

var $6d2Zk = parcelRequire("6d2Zk");

var $4r0zY = parcelRequire("4r0zY");

var $ckvH1 = parcelRequire("ckvH1");
const $c87c5ab85f19b8e5$var$RECENT_PLANS_SOFT_LIMIT = 2;
const $c87c5ab85f19b8e5$var$NAVIGATION_V3_EXPERIENCE = 'jira.nav-v3';
class $c87c5ab85f19b8e5$export$824e4d5b28750c3f {
    static{
        this.ITEM_RESULT_LIMIT = 50;
    }
    static{
        this.PROJECT_BOARD_FILTER_LIMIT = 6;
    }
    static{
        this.PROJECT_BOARD_FILTER_PLAN_LIMIT = 8;
    }
    static{
        this.PROJECT_RESULT_LIMIT = 10;
    }
    static{
        this.PEOPLE_RESULT_LIMIT = 10;
    }
    constructor(config){
        this.abTestDataCache = null;
        this.permissionsDataCache = null;
        this.recentIssuesSupplier = async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $4biU5.Scope).JiraIssue
            ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, true, sites)[(0, $4biU5.Scope).JiraIssue];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $4biU5.Scope).JiraIssue}`);
            return results.promise();
        };
        // For recent results, we only want to show up to 2 recent plans as the last 2 results
        // as we cannot accurately interleave  recent plans with recent boards, projects, filter results.
        // However, it is valid to show more than 2 plans in the case where other entity types have been exhausted.
        this.interleaveRecentBoardsProjectsFiltersPlans = (boardProjectFilterResults, planResults)=>{
            const timings = planResults.timings > boardProjectFilterResults.timings ? planResults.timings : boardProjectFilterResults.timings;
            const { items: items } = boardProjectFilterResults;
            if (planResults.items.length >= $c87c5ab85f19b8e5$var$RECENT_PLANS_SOFT_LIMIT) while(items.length > $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - $c87c5ab85f19b8e5$var$RECENT_PLANS_SOFT_LIMIT)items.pop();
            else while(items.length > $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - planResults.items.length)items.pop();
            for(let planCount = 0; items.length < $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT && planResults.items.length > planCount; planCount++)items.push(planResults.items[planCount]);
            return {
                timings: timings,
                items: items,
                totalSize: items.length
            };
        };
        this.search = (query, filters, context, queryVersion, hasAdvancedRoadmapsAccess, sites)=>{
            const issueSearch = this.searchForScope(query, filters, context, [
                (0, $4biU5.Scope).JiraIssue
            ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites, queryVersion);
            const onlyDateFilterEnabled = filters.length === 1 && filters[0]?.type === 'dateFromLastModified';
            const scopes = hasAdvancedRoadmapsAccess ? [
                (0, $4biU5.Scope).JiraBoardProjectFilterPlan
            ] : [
                (0, $4biU5.Scope).JiraBoardProjectFilter
            ];
            const limit = hasAdvancedRoadmapsAccess ? $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT : $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_LIMIT;
            const jiraBoardProjectFilterSearch = filters.length === 0 || onlyDateFilterEnabled ? this.searchForScope(query, filters, context, scopes, limit, false, sites, queryVersion) : {};
            return {
                ...issueSearch,
                ...jiraBoardProjectFilterSearch
            };
        };
        this.searchForScope = (query, filters, context, scopes, resultLimit, isForRecentResults, sites = [], queryVersion)=>{
            const modelParams = queryVersion || queryVersion === 0 ? [
                {
                    '@type': 'queryParams',
                    queryVersion: queryVersion
                }
            ] : [];
            const allFilters = [];
            let baseProjectFilters = null;
            let baseAssigneeFilters = null;
            let baseBinaryStatusCategoryFilters = null;
            let lastModifiedFilter = {
                '@type': 'lastModified'
            };
            let lastViewedFilter = {
                '@type': 'lastViewed'
            };
            filters.forEach((filter)=>{
                switch(filter.type){
                    case 'project':
                        if (!baseProjectFilters) {
                            baseProjectFilters = {
                                '@type': 'projects',
                                projectIds: []
                            };
                            allFilters.push(baseProjectFilters);
                        }
                        baseProjectFilters.projectIds.push(filter.id);
                        break;
                    case 'assignee':
                        if (!baseAssigneeFilters) {
                            baseAssigneeFilters = {
                                '@type': 'assignees',
                                accountIds: []
                            };
                            allFilters.push(baseAssigneeFilters);
                        }
                        baseAssigneeFilters.accountIds.push(filter.id);
                        break;
                    case 'binary_status_category':
                        if (!baseBinaryStatusCategoryFilters) {
                            baseBinaryStatusCategoryFilters = {
                                '@type': 'binary_status_categories',
                                binaryStatusCategories: []
                            };
                            allFilters.push(baseBinaryStatusCategoryFilters);
                        }
                        baseBinaryStatusCategoryFilters.binaryStatusCategories.push(filter.id);
                        break;
                    case 'dateFromLastModified':
                        filter.id && (lastModifiedFilter.from = filter.id);
                        break;
                    case 'dateFromLastViewed':
                        filter.id && (lastViewedFilter.from = filter.id);
                        break;
                    case 'dateToLastModified':
                        filter.id && (lastModifiedFilter.to = filter.id);
                        break;
                    default:
                        break;
                }
            });
            if (lastModifiedFilter.from || lastModifiedFilter.to) allFilters.push(lastModifiedFilter);
            if (lastViewedFilter.from) allFilters.push(lastViewedFilter);
            const responses = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: resultLimit,
                filters: allFilters,
                experience: $c87c5ab85f19b8e5$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            return scopes.reduce((results, currentScope)=>({
                    ...results,
                    [currentScope]: (0, $aHYZV.CancellablePromise).from(responses.then(({ response: response, requestDurationMs: requestDurationMs })=>{
                        const scopedResponse = response.retrieveScope(currentScope);
                        if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
                        if (scopedResponse.error) throw (0, $lQmoS.responseErrorToError)(scopedResponse.error);
                        if (currentScope === (0, $4biU5.Scope).JiraIssue) return (0, $4r0zY.transformJiraIssueScope)(scopedResponse, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $4biU5.Scope).JiraPlan) return (0, $4r0zY.transformJiraPlanScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $4biU5.Scope).JiraBoardProjectFilter) return (0, $4r0zY.transformJiraBoardProjectFilterScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $4biU5.Scope).JiraBoardProjectFilterPlan) return (0, $4r0zY.transformJiraBoardProjectFilterScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $4biU5.Scope).JiraProject) return (0, $4r0zY.transformJiraProjectScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $4biU5.Scope).People) return (0, $4r0zY.transformUrsPeople)(scopedResponse.results, isForRecentResults, requestDurationMs, sites.length > 0);
                    }))
                }), {});
        };
        const { recentIssuesSupplier: recentIssuesSupplier = null } = config;
        this.aggregatorClient = new (0, $zo35K.AggregatorClient)(config);
        this.recentPeopleCache = new (0, $k7rsK.SimpleCache)((context, sites)=>this.searchForPeopleScope('', context, true, sites));
        this.recentIssuesCache = recentIssuesSupplier ? new (0, $k7rsK.SimpleCache)((ignored)=>recentIssuesSupplier()) : new (0, $k7rsK.SimpleCache)(this.recentIssuesSupplier);
        this.recentBoardsProjectsFiltersCache = new (0, $k7rsK.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $4biU5.Scope).JiraBoardProjectFilter
            ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, $4biU5.Scope).JiraBoardProjectFilter];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $4biU5.Scope).JiraBoardProjectFilter}`);
            return results.promise();
        });
        this.recentPlansCache = new (0, $k7rsK.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $4biU5.Scope).JiraPlan
            ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, $4biU5.Scope).JiraPlan];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $4biU5.Scope).JiraPlan}`);
            return results.promise();
        });
        this.recentProjectsCache = new (0, $k7rsK.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $4biU5.Scope).JiraProject
            ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_RESULT_LIMIT, true, sites)[(0, $4biU5.Scope).JiraProject];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $4biU5.Scope).JiraProject}`);
            return results.promise();
        });
        this.isUserAnonymous = config.isUserAnonymous;
    }
    getRecent(cache, context, sites) {
        const { fromCache: fromCache, value: value } = cache.get(context, (0, $ckvH1.limitToMaxSiteUsage)(sites));
        return (0, $aHYZV.CancellablePromise).from(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    getRecentBoardsProjectsFiltersPlansInterleaved(context, sites) {
        const { fromCache: boardsProjectsFiltersFromCache, value: boardsProjectsFiltersValue } = this.recentBoardsProjectsFiltersCache.get(context, sites);
        const { fromCache: plansFromCache, value: plansValue } = this.recentPlansCache.get(context, sites);
        return (0, $aHYZV.CancellablePromise).from(Promise.all([
            boardsProjectsFiltersValue,
            plansValue
        ]).then((results)=>({
                ...this.interleaveRecentBoardsProjectsFiltersPlans(results[0], results[1]),
                isCached: plansFromCache && boardsProjectsFiltersFromCache
            })));
    }
    getRecentIssues(context, sites) {
        return this.getRecent(this.recentIssuesCache, context, sites);
    }
    getRecentPlans(context, sites) {
        return this.getRecent(this.recentPlansCache, context, sites);
    }
    getRecentProjects(context, sites) {
        return this.getRecent(this.recentProjectsCache, context, sites);
    }
    getRecentBoardsProjectsFilters(context, sites) {
        return this.getRecent(this.recentBoardsProjectsFiltersCache, context, sites);
    }
    getRecentBoardsProjectsFiltersPlans(context, sites) {
        return this.getRecentBoardsProjectsFiltersPlansInterleaved(context, sites);
    }
    /**
	 * Check the user permissions for the given list of products.
	 */ async getProductPermissions(products) {
        if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $c87c5ab85f19b8e5$var$NAVIGATION_V3_EXPERIENCE);
        return this.permissionsDataCache;
    }
    async getAbTestData() {
        if (this.abTestDataCache) return this.abTestDataCache;
        const abTest = await this.aggregatorClient.getAbTestData((0, $4biU5.Scope).JiraIssue, $c87c5ab85f19b8e5$var$NAVIGATION_V3_EXPERIENCE);
        this.abTestDataCache = abTest;
        return abTest;
    }
    getRecentPeople(context, sites) {
        return this.getRecent(this.recentPeopleCache, context, sites);
    }
    searchPeople(query, context, sites) {
        return (0, $aHYZV.CancellablePromise).from(this.searchForPeopleScope(query, context, false, sites));
    }
    searchForPeopleScope(query, context, isForRecentResults, sites, queryVersion) {
        if (this.isUserAnonymous) return Promise.resolve({
            items: [],
            timings: 0,
            totalSize: 0
        });
        const results = this.searchForScope(query, [], context, [
            (0, $4biU5.Scope).People
        ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PEOPLE_RESULT_LIMIT, isForRecentResults, sites, queryVersion)[(0, $4biU5.Scope).People];
        if (!results) throw new Error(`Failed to retrieve results for scope ${(0, $4biU5.Scope).People}`);
        return results.promise();
    }
    searchProjects(query, context, sites) {
        const results = this.searchForScope(query, [], context, [
            (0, $4biU5.Scope).JiraProject
        ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites)[(0, $4biU5.Scope).JiraProject];
        if (!results) throw new Error(`Failed to retrieve results for scope ${(0, $4biU5.Scope).JiraProject}`);
        return results;
    }
}
function $c87c5ab85f19b8e5$export$1436a8642ffb43cf(attributeType) {
    switch(attributeType){
        case (0, $4biU5.AttributeType).issue:
            return (0, $4biU5.ContentType).JiraIssue;
        case (0, $4biU5.AttributeType).project:
            return (0, $4biU5.ContentType).JiraProject;
        case (0, $4biU5.AttributeType).board:
            return (0, $4biU5.ContentType).JiraBoard;
        case (0, $4biU5.AttributeType).filter:
            return (0, $4biU5.ContentType).JiraFilter;
        case (0, $4biU5.AttributeType).plan:
            return (0, $4biU5.ContentType).JiraPlan;
        case (0, $4biU5.AttributeType).people:
            return (0, $4biU5.ContentType).JiraPeople;
        default:
            throw new (0, $6d2Zk.UnreachableError)(attributeType);
    }
}

});
parcelRegister("4biU5", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $8afcf00701a56fa4$export$775b6bb06e53a214);
$parcel$export(module.exports, "ContentType", () => $8afcf00701a56fa4$export$e2e108cbe2e4f865);
$parcel$export(module.exports, "AttributeType", () => $8afcf00701a56fa4$export$d31c6c64cddbeeac);
var $8afcf00701a56fa4$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $8afcf00701a56fa4$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $8afcf00701a56fa4$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $8afcf00701a56fa4$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $8afcf00701a56fa4$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});

});

parcelRegister("6d2Zk", function(module, exports) {

$parcel$export(module.exports, "UnreachableError", () => $42598c636176952f$export$676c8946b241bf4b);
class $42598c636176952f$export$676c8946b241bf4b extends Error {
    constructor(v){
        super(`Unreachable code was reachable, value: ${v}`);
    }
}

});

parcelRegister("4r0zY", function(module, exports) {

$parcel$export(module.exports, "transformJiraIssueScope", () => $bbbead478f5b2048$export$ed218c5a500295c6);
$parcel$export(module.exports, "transformJiraPlanScope", () => $bbbead478f5b2048$export$3327c57623badb76);
$parcel$export(module.exports, "transformJiraBoardProjectFilterScope", () => $bbbead478f5b2048$export$313c00d1fd0198a9);
$parcel$export(module.exports, "transformJiraProjectScope", () => $bbbead478f5b2048$export$61106bcfd557994b);
$parcel$export(module.exports, "transformUrsPeople", () => $bbbead478f5b2048$export$ca9c7208f3fa3596);

var $4biU5 = parcelRequire("4biU5");

var $fisvb = parcelRequire("fisvb");

var $3JOCw = parcelRequire("3JOCw");

var $ckvH1 = parcelRequire("ckvH1");
function $bbbead478f5b2048$export$ed218c5a500295c6(response, isCached, timings) {
    const { results: results, size: size } = response;
    return {
        items: results.filter((item)=>item.attributes['@type'] === (0, $4biU5.AttributeType).issue).map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $4biU5.ContentType).JiraIssue,
                attributes: {
                    ...item.attributes,
                    isRecentResult: isCached
                },
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: size || results.length
    };
}
function $bbbead478f5b2048$export$3327c57623badb76(results, isCached, timings) {
    return {
        items: results.map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $4biU5.ContentType).JiraPlan,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $bbbead478f5b2048$export$313c00d1fd0198a9(results, isCached, timings) {
    return {
        items: results.filter((item)=>[
                (0, $4biU5.AttributeType).board,
                (0, $4biU5.AttributeType).project,
                (0, $4biU5.AttributeType).filter,
                (0, $4biU5.AttributeType).plan
            ].includes(item.attributes['@type'])).map((item)=>{
            const contentType = (0, $fisvb.attributeTypeToContentType)(item.attributes['@type']);
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: contentType,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $bbbead478f5b2048$export$61106bcfd557994b(results, isCached, timings) {
    return {
        items: results.map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $4biU5.ContentType).JiraProject,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $bbbead478f5b2048$export$ca9c7208f3fa3596(results, isCached, timings, isMultiSite) {
    return {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(results, (item)=>item.id).map((item)=>({
                resultId: item.id,
                name: item.name,
                href: (0, $ckvH1.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id, 'jira'),
                contentType: (0, $4biU5.ContentType).JiraPeople,
                attributes: {
                    '@type': (0, $4biU5.AttributeType).people,
                    avatarUrl: item.avatarUrl,
                    userId: item.id
                },
                isCached: isCached
            })),
        timings: timings,
        totalSize: results.length
    };
}

});


parcelRegister("j97IK", function(module, exports) {

$parcel$export(module.exports, "useExperiments", () => $b6add2fb9633682e$export$d98589668c6e11a9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1KoBw = parcelRequire("1KoBw");
var $1iGI5 = parcelRequire("1iGI5");
var $jlJyd = parcelRequire("jlJyd");
const $b6add2fb9633682e$export$ce7a53bcef5d6aee = ({ quickFindEnabled: quickFindEnabled, children: children })=>{
    const layerName = quickFindEnabled ? (0, $jlJyd.STATSIG_QUICK_FIND_LAYER) : undefined;
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = (0, $5uXOq.useMemo)(()=>(0, $1iGI5.getMutuallyExclusiveExperiment)(layerName), [
        layerName
    ]);
    let frontendExperiments;
    if (quickFindEnabled) {
        const exampleFrontendExperiment = (0, $1KoBw.getFrontendExperiment)({
            abTestId: 'fe_search_experiment'
        });
        frontendExperiments = {
            // the mutually exclusive frontend experiment
            ...frontendExperiment?.abTestId && {
                [frontendExperiment.abTestId]: frontendExperiment
            },
            // add other frontend experiments that can be run alongside backend experiments here
            [exampleFrontendExperiment.abTestId]: exampleFrontendExperiment
        };
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b6add2fb9633682e$var$ExperimentContext.Provider, {
        value: {
            backendExperiment: backendExperiment,
            frontendExperiments: frontendExperiments
        },
        children: children
    });
};
const $b6add2fb9633682e$var$ExperimentContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    backendExperiment: undefined,
    frontendExperiments: undefined
});
const $b6add2fb9633682e$export$d98589668c6e11a9 = ()=>{
    return (0, $5uXOq.useContext)($b6add2fb9633682e$var$ExperimentContext);
};

});
parcelRegister("1KoBw", function(module, exports) {

$parcel$export(module.exports, "getFrontendExperiment", () => $6e63d8e0ca134d4c$export$a68238496eb1c8ce);
$parcel$export(module.exports, "createFeatureGateHandler", () => $6e63d8e0ca134d4c$export$8774a01dc80b4a26);
$parcel$export(module.exports, "createFrontendExperimentHandler", () => $6e63d8e0ca134d4c$export$841981a8a1feee8d);

var $iEN9D = parcelRequire("iEN9D");

var $1jKPO = parcelRequire("1jKPO");
const $6e63d8e0ca134d4c$export$a68238496eb1c8ce = ({ abTestId: abTestId })=>{
    const cohort = (0, $iEN9D.default).getExperiment(abTestId).get('cohort', (0, $1jKPO.Cohort).Default);
    const serveExperiment = cohort === (0, $1jKPO.Cohort).Test;
    return {
        serveExperiment: serveExperiment,
        abTestId: abTestId,
        cohort: cohort
    };
};
const $6e63d8e0ca134d4c$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $iEN9D.default).checkGate('search-experiment-overrides-killswitch')) return $6e63d8e0ca134d4c$var$defaultCheckGate;
    if (!overrides) return $6e63d8e0ca134d4c$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $6e63d8e0ca134d4c$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $6e63d8e0ca134d4c$var$defaultCheckGate;
    }
};
const $6e63d8e0ca134d4c$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $iEN9D.default).checkGate('search-experiment-overrides-killswitch')) return $6e63d8e0ca134d4c$export$a68238496eb1c8ce;
    if (!overrides) return $6e63d8e0ca134d4c$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $6e63d8e0ca134d4c$export$a68238496eb1c8ce({
                abTestId: abTestId
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $1jKPO.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $6e63d8e0ca134d4c$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $6e63d8e0ca134d4c$var$defaultCheckGate = (name)=>(0, $iEN9D.default).checkGate(name);

});
parcelRegister("1jKPO", function(module, exports) {

$parcel$export(module.exports, "Cohort", () => $7ad507c82dc589a7$export$b76685d1b5a37732);
var $7ad507c82dc589a7$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});

});


parcelRegister("1iGI5", function(module, exports) {

$parcel$export(module.exports, "getMutuallyExclusiveExperiment", () => $6a4b2e2566fb6e32$export$fd4704975f80304e);
$parcel$export(module.exports, "getBackendExperimentsWithOverrides", () => $6a4b2e2566fb6e32$export$42e21c9a86f72c4f);

var $iEN9D = parcelRequire("iEN9D");

var $jlJyd = parcelRequire("jlJyd");

var $7QxWg = parcelRequire("7QxWg");

var $1KoBw = parcelRequire("1KoBw");
const $6a4b2e2566fb6e32$export$fd4704975f80304e = (layerName, onErrorFn, shouldNotGetBackendExperiment = false)=>{
    try {
        if (!layerName) return {
            frontendExperiment: undefined,
            backendExperiment: (0, $7QxWg.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment),
            isMutuallyExclusive: false
        };
        const layer = (0, $iEN9D.default).getLayer(layerName, {
            fireLayerExposure: false
        });
        const frontendExperimentName = layer.get('frontendExperimentName', '');
        if (frontendExperimentName) return {
            frontendExperiment: (0, $1KoBw.getFrontendExperiment)({
                abTestId: frontendExperimentName
            }),
            backendExperiment: (0, $jlJyd.DEFAULT_STATSIG_EXPERIMENT_CONFIG),
            isMutuallyExclusive: true
        };
        return {
            frontendExperiment: undefined,
            backendExperiment: (0, $7QxWg.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment),
            isMutuallyExclusive: false
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return {
        frontendExperiment: undefined,
        backendExperiment: (0, $jlJyd.DEFAULT_STATSIG_EXPERIMENT_CONFIG),
        isMutuallyExclusive: false
    };
};
const $6a4b2e2566fb6e32$export$42e21c9a86f72c4f = (overrides, layerName, onErrorFn, shouldNotGetBackendExperiment = false)=>{
    // We should only evaluate the backend experiment here if we are using search experiment overrides functionality
    // backend experiments outside of rovo v rovo are evaluated at request time instead
    const shouldUseSearchExperimentOverrides = (0, $iEN9D.default).checkGate('search-experiment-overrides-backend');
    const shouldNotGetBackendExperimentsForOverrides = shouldUseSearchExperimentOverrides ? false : shouldNotGetBackendExperiment;
    // If the feature gate is enabled or no overrides are provided, return the default experiment.
    if (!shouldUseSearchExperimentOverrides || !overrides || overrides.length === 0) return $6a4b2e2566fb6e32$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides);
    // Filter for backend experiment from the overrides. only allowing them for now
    const backendOverrideExperiments = overrides.filter((override)=>override.location === 'backend' && override.type === 'experiment');
    if (!backendOverrideExperiments.length) return $6a4b2e2566fb6e32$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides);
    // Get the base user's experiments from layers.
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment, isMutuallyExclusive: isMutuallyExclusive } = $6a4b2e2566fb6e32$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides);
    if (backendExperiment && 'experimentLayers' in backendExperiment) backendExperiment.experimentLayers = backendExperiment?.experimentLayers.map((layer)=>{
        const layerToOverride = backendOverrideExperiments.find((exp)=>{
            return exp.layer && layer.name?.includes(exp.layer === 'qr' ? 'query_expansion' : exp.layer);
        });
        if (!layerToOverride) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        const statsigOverrideExperiment = (0, $iEN9D.default).getExperiment(layerToOverride?.name);
        // handle case where experiment didnt add testId - for older experiments should be on new ones
        if (!statsigOverrideExperiment.get('testId', null)) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        return {
            name: layer.name,
            layerId: statsigOverrideExperiment.get('testId', null),
            shadowId: statsigOverrideExperiment.get('shadowId', null),
            // The below values might not be sent to the backend, but we can still track them in the frontend.
            controlId: statsigOverrideExperiment.get('controlId', null),
            abTestId: statsigOverrideExperiment.get('abTestId', null)
        };
    });
    return {
        backendExperiment: backendExperiment,
        frontendExperiment: frontendExperiment,
        isMutuallyExclusive: isMutuallyExclusive
    };
};

});
parcelRegister("jlJyd", function(module, exports) {

$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM", () => $6d7c25a0c5e201a6$export$71a8b319599e57dc);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD", () => $6d7c25a0c5e201a6$export$c076c4dd9e9d1e6e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM", () => $6d7c25a0c5e201a6$export$23877616cb34cf0c);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM", () => $6d7c25a0c5e201a6$export$68be56e20dba0ed5);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD", () => $6d7c25a0c5e201a6$export$f39fa5cd744578ae);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM", () => $6d7c25a0c5e201a6$export$a36d8c2d9981ec2b);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER", () => $6d7c25a0c5e201a6$export$fe025e19388affcf);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L3_LAYER", () => $6d7c25a0c5e201a6$export$11e2cd4e8edc5e82);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER", () => $6d7c25a0c5e201a6$export$9b30fb0a29b39382);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED", () => $6d7c25a0c5e201a6$export$a62089c95934ccf8);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED", () => $6d7c25a0c5e201a6$export$4e36729d15b3db9e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN", () => $6d7c25a0c5e201a6$export$87f92c12fc8bb620);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_NAME", () => $6d7c25a0c5e201a6$export$86bb6d2503529310);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_NAME", () => $6d7c25a0c5e201a6$export$722a4624bef605fa);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L3_LAYER_NAME", () => $6d7c25a0c5e201a6$export$1963cf4be1b2cd5e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME", () => $6d7c25a0c5e201a6$export$a18b3b3caa760214);
$parcel$export(module.exports, "STATSIG_FULL_PAGE_SEARCH_LAYER", () => $6d7c25a0c5e201a6$export$39bbb550e0341d58);
$parcel$export(module.exports, "STATSIG_QUICK_FIND_LAYER", () => $6d7c25a0c5e201a6$export$b669e8e4ed2b4c67);
$parcel$export(module.exports, "DEFAULT_STATSIG_EXPERIMENT_CONFIG", () => $6d7c25a0c5e201a6$export$afc3cbf9db978004);
$parcel$export(module.exports, "DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG", () => $6d7c25a0c5e201a6$export$fca208e1e43c6fac);
const $6d7c25a0c5e201a6$export$71a8b319599e57dc = 'l1_premium_vs_standard';
const $6d7c25a0c5e201a6$export$c076c4dd9e9d1e6e = 'search_platform_layer_l1_standard';
const $6d7c25a0c5e201a6$export$23877616cb34cf0c = 'search_platform_layer_l1_premium';
const $6d7c25a0c5e201a6$export$68be56e20dba0ed5 = 'l2_premium_vs_standard';
const $6d7c25a0c5e201a6$export$f39fa5cd744578ae = 'search_platform_layer_l2_standard';
const $6d7c25a0c5e201a6$export$a36d8c2d9981ec2b = 'search_platform_layer_l2_premium';
const $6d7c25a0c5e201a6$export$fe025e19388affcf = 'search_platform_layer_l2_blending';
const $6d7c25a0c5e201a6$export$11e2cd4e8edc5e82 = 'search_platform_layer_l3';
const $6d7c25a0c5e201a6$export$9b30fb0a29b39382 = 'search_platform_layer_query_expansion';
const $6d7c25a0c5e201a6$export$a62089c95934ccf8 = 'enable_l3';
const $6d7c25a0c5e201a6$export$4e36729d15b3db9e = 'enable_query_rewrite';
const $6d7c25a0c5e201a6$export$87f92c12fc8bb620 = 'search_platform_non_overlapping_domain';
const $6d7c25a0c5e201a6$export$86bb6d2503529310 = 'search_platform_layer_l1';
const $6d7c25a0c5e201a6$export$722a4624bef605fa = 'search_platform_layer_l2';
const $6d7c25a0c5e201a6$export$1963cf4be1b2cd5e = 'search_platform_layer_l3';
const $6d7c25a0c5e201a6$export$a18b3b3caa760214 = 'search_platform_layer_query_expansion';
const $6d7c25a0c5e201a6$export$39bbb550e0341d58 = 'full_page_search_layer';
const $6d7c25a0c5e201a6$export$b669e8e4ed2b4c67 = 'quick_find_layer';
const $6d7c25a0c5e201a6$export$afc3cbf9db978004 = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    controlId: 'default',
    abTestId: 'default'
};
const $6d7c25a0c5e201a6$export$fca208e1e43c6fac = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    experimentLayers: []
};

});

parcelRegister("7QxWg", function(module, exports) {

$parcel$export(module.exports, "getBackendExperimentConfig", () => $42e634b0c22afc73$export$2f6c9ab85be44d1a);
$parcel$export(module.exports, "getLayerValues", () => $42e634b0c22afc73$export$3178593b0bf95121);
$parcel$export(module.exports, "getBackendNonOverlappingDomainLayerValues", () => $42e634b0c22afc73$export$1e659fcd208b8aec);

var $iEN9D = parcelRequire("iEN9D");

var $jlJyd = parcelRequire("jlJyd");
const $42e634b0c22afc73$export$2f6c9ab85be44d1a = (onErrorFn, shouldNotGetBackendExperiment = false)=>{
    const isRequestDrivenExperimentationEnabled = (0, $iEN9D.default).checkGate('request_driven_experimentation_enabled');
    if (!isRequestDrivenExperimentationEnabled || shouldNotGetBackendExperiment) return;
    return $42e634b0c22afc73$var$getParallelBackendExperimentsConfig(onErrorFn);
};
const $42e634b0c22afc73$export$3178593b0bf95121 = (layerName)=>{
    const layer = (0, $iEN9D.default).getLayer(layerName);
    const layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
    return {
        name: layerNameWithoutSuffix,
        layerId: layer.get('layerId', 'default'),
        shadowId: layer.get('shadowId', null),
        // The below values might not be sent to the backend but we can still track them in the frontend
        controlId: layer.get('controlId', null),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        ...(0, $iEN9D.default).checkGate('search-experiment-overrides-backend') && {
            testId: layer.get('testId', null)
        }
    };
};
const $42e634b0c22afc73$export$1e659fcd208b8aec = ()=>{
    const layer = (0, $iEN9D.default).getLayer((0, $jlJyd.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN));
    return {
        l1Id: layer.get('l1Id', 'default'),
        l2Id: layer.get('l2Id', 'default'),
        l3Id: layer.get('l3Id', 'default'),
        qrId: layer.get('qrId', 'default'),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        mutualExclusion: layer.get('mutualExclusion', false),
        controlId: layer.get('controlId', 'default')
    };
};
const $42e634b0c22afc73$var$getStandardOrPremiumLayerValues = (featureGateName, standardLayerName, premiumLayerName)=>{
    const isPremium = (0, $iEN9D.default).checkGate(featureGateName);
    if (isPremium) return $42e634b0c22afc73$export$3178593b0bf95121(premiumLayerName);
    return $42e634b0c22afc73$export$3178593b0bf95121(standardLayerName);
};
const $42e634b0c22afc73$var$getParallelBackendExperimentsConfig = (onErrorFn)=>{
    const isRequestDrivenExperimentationEnabled = (0, $iEN9D.default).checkGate('request_driven_experimentation_enabled');
    if (!isRequestDrivenExperimentationEnabled) return;
    try {
        const allLayers = [];
        const layer1 = $42e634b0c22afc73$var$getStandardOrPremiumLayerValues((0, $jlJyd.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM), (0, $jlJyd.STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD), (0, $jlJyd.STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM));
        allLayers.push(layer1);
        const layer2 = $42e634b0c22afc73$var$getStandardOrPremiumLayerValues((0, $jlJyd.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM), (0, $jlJyd.STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD), (0, $jlJyd.STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM));
        allLayers.push(layer2);
        const layer2Blending = $42e634b0c22afc73$export$3178593b0bf95121((0, $jlJyd.STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER));
        allLayers.push(layer2Blending);
        const isLayer3Enabled = (0, $iEN9D.default).checkGate((0, $jlJyd.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED));
        if (isLayer3Enabled) {
            const layer3 = $42e634b0c22afc73$export$3178593b0bf95121((0, $jlJyd.STATSIG_SEARCH_BACKEND_L3_LAYER));
            allLayers.push(layer3);
        }
        const isQueryExpansionLayerEnabled = (0, $iEN9D.default).checkGate((0, $jlJyd.STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED));
        if (isQueryExpansionLayerEnabled) {
            const layerQueryExpansion = $42e634b0c22afc73$export$3178593b0bf95121((0, $jlJyd.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER));
            allLayers.push(layerQueryExpansion);
        }
        const concatenatedExperimentId = allLayers.map((l)=>l?.layerId).join('_');
        const concatenatedShadowExperimentId = allLayers.map((l)=>l?.shadowId).join('_');
        return {
            experimentId: concatenatedExperimentId,
            shadowExperimentId: concatenatedShadowExperimentId,
            experimentLayers: allLayers
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return 0, $jlJyd.DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
};

});




const $3858a166c616a5ee$export$58d86c1da4a2ca1 = 'gateway/api/xpsearch-aggregator';


parcelRegister("hteTr", function(module, exports) {

$parcel$export(module.exports, "ExtensibleCrossProductSearchDialog", () => $46a7ffce8732ffa8$export$c89d6fd97d04eec5);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $daJ0i = parcelRequire("daJ0i");

var $bay8L = parcelRequire("bay8L");

var $ld2hZ = parcelRequire("ld2hZ");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $lpwtK = parcelRequire("lpwtK");

var $3HwlS = parcelRequire("3HwlS");

var $cYlk7 = parcelRequire("cYlk7");

var $14XJw = parcelRequire("14XJw");

var $kkNtb = parcelRequire("kkNtb");

var $hqBSi = parcelRequire("hqBSi");

var $al2bB = parcelRequire("al2bB");

var $c5R4n = parcelRequire("c5R4n");
var $gZ0uu = parcelRequire("gZ0uu");
var $dlQRr = parcelRequire("dlQRr");
var $ktKQy = parcelRequire("ktKQy");
var $3tGqW = parcelRequire("3tGqW");
var $hynt0 = parcelRequire("hynt0");
var $7PQor = parcelRequire("7PQor");
var $9RlGt = parcelRequire("9RlGt");
var $6P5ov = parcelRequire("6P5ov");
var $ffvO4 = parcelRequire("ffvO4");
var $95MIc = parcelRequire("95MIc");
var $bHEFa = parcelRequire("bHEFa");
var $gUnI2 = parcelRequire("gUnI2");
var $2k6eV = parcelRequire("2k6eV");

var $cbTYT = parcelRequire("cbTYT");

var $kA88U = parcelRequire("kA88U");
const $46a7ffce8732ffa8$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER = 'watermelon';
const $46a7ffce8732ffa8$var$COMPASS_PRODUCT_IDENTIFIER = 'compass';
const $46a7ffce8732ffa8$var$COLLABORATION_GRAPH_URL = '/gateway/api/collaboration';
const $46a7ffce8732ffa8$var$ANALYTICS_CONTEXT_LOCATION = 'extensibleJiraTab';
const $46a7ffce8732ffa8$export$384daeb836cbae0f = [
    'jira.issue',
    'jira.project,board,plan,filter',
    'urs.user'
];
const $46a7ffce8732ffa8$export$12de0ba0966e9d50 = ()=>{
    const request = (0, $5uXOq.useCallback)(()=>(0, $eusud.performGetRequest)('/rest/api/3/serverInfo'), []);
    return (0, $ld2hZ.useService)(request);
};
const $46a7ffce8732ffa8$var$getJiraLinkComponent = (onJiraNavigation)=>(linkProps)=>{
        const { href: href } = linkProps;
        const onClick = (event)=>{
            if (!(event.ctrlKey || event.metaKey)) onJiraNavigation(href || '', event);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46a7ffce8732ffa8$var$LinkComponent, {
            onClick: onClick,
            role: "none",
            ...linkProps
        }, linkProps.children);
    };
const $46a7ffce8732ffa8$var$PreviewWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            attributes: {
                location: $46a7ffce8732ffa8$var$ANALYTICS_CONTEXT_LOCATION
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bay8L.SmartCardProviderMigration), null, children));
const $46a7ffce8732ffa8$var$ExtensibleCrossProductSearchDialogWithData = (props)=>{
    const rovoEntitlement = (0, $kkNtb.useRovoEntitlementResource)();
    const isRovoEnabled = rovoEntitlement?.data?.isRovoEnabled ?? false;
    const { cloudId: cloudId, formatDate: formatDate, isExpanded: isExpanded, jiraFeatures: jiraFeatures, onNavigate: onNavigate, onClose: onClose, onRetry: onRetry, confluenceReactivationExperiment: confluenceReactivationExperiment, confluenceAvailabilityExperiment: confluenceAvailabilityExperiment } = props;
    const instanceInfoResponse = $46a7ffce8732ffa8$export$12de0ba0966e9d50();
    const { fetch: fetchInstanceInfo } = instanceInfoResponse;
    (0, $5uXOq.useEffect)(()=>{
        fetchInstanceInfo();
    }, [
        fetchInstanceInfo
    ]);
    const onJiraNavigation = (0, $5uXOq.useCallback)((href, event)=>{
        onNavigate(href, event);
        onClose();
    }, [
        onClose,
        onNavigate
    ]);
    const JiraLinkComponent = (0, $5uXOq.useMemo)(()=>$46a7ffce8732ffa8$var$getJiraLinkComponent(onJiraNavigation), [
        onJiraNavigation
    ]);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const projectData = (0, $lpwtK.useProject)();
    const { user: user } = (0, $cYlk7.useCurrentUser)().data;
    const userDetails = (0, $5uXOq.useMemo)(()=>user && !user.isAnonymous && user.accountId ? {
            id: user.accountId,
            name: user.userFullname,
            // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
            avatarUrl: user.avatarUrls ? user.avatarUrls['48x48'] : ''
        } : undefined, [
        user
    ]);
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const isSearchWithTextFieldInAllIssuesLinkEnabled = !(0, $cbTYT.useNINGlobalScopeEnrolment)({
        cloudId: cloudId,
        isExpanded: isExpanded
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isRovoEnabled && (0, $4R6GH.fg)('jira_rovo_in_quick_search') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tGqW.CrossProductTab), {
        order: -1,
        onRetry: onRetry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46a7ffce8732ffa8$var$PreviewWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7PQor.ExtensibleJiraTab), {
        onRetry: onRetry,
        permissionSupplier: ()=>Promise.resolve($46a7ffce8732ffa8$export$384daeb836cbae0f),
        features: {
            ...jiraFeatures,
            isSearchWithTextFieldInAllIssuesLinkEnabled: isSearchWithTextFieldInAllIssuesLinkEnabled
        },
        order: 0,
        isPrefetchingEnabled: true,
        linkComponent: JiraLinkComponent,
        config: {
            cloudId: cloudId,
            collaborationGraphUrl: $46a7ffce8732ffa8$var$COLLABORATION_GRAPH_URL
        },
        currentProject: projectData.data ? {
            id: projectData.data.id.toString(),
            label: projectData.data.name,
            avatarUrl: projectData.data.avatarUrl
        } : undefined,
        currentUser: userDetails,
        autocorrectEnabled: true
    })), confluenceAvailabilityExperiment?.isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ktKQy.ConfluenceUpsellInJiraTab), {
        formatDate: formatDate,
        onRetry: onRetry,
        recentClientConfig: {
            url: instanceInfoResponse.data?.displayUrlConfluence ? `${instanceInfoResponse.data.displayUrlConfluence}/wiki` : '/wiki',
            cloudId: cloudId,
            isUserAnonymous: !user.accountId,
            isCollaborationGraphEnabled: false,
            collaborationGraphUrl: $46a7ffce8732ffa8$var$COLLABORATION_GRAPH_URL
        },
        order: 1,
        confluenceAvailabilityExperiment: confluenceAvailabilityExperiment
    }), !confluenceAvailabilityExperiment?.isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hynt0.ExtensibleConfluenceTab), {
        formatDate: formatDate,
        onRetry: onRetry,
        recentClientConfig: {
            url: instanceInfoResponse.data?.displayUrlConfluence ? `${instanceInfoResponse.data.displayUrlConfluence}/wiki` : '/wiki',
            cloudId: cloudId,
            isUserAnonymous: !user.accountId,
            isCollaborationGraphEnabled: false,
            collaborationGraphUrl: $46a7ffce8732ffa8$var$COLLABORATION_GRAPH_URL
        },
        order: 1,
        confluenceReactivationExperiment: confluenceReactivationExperiment,
        confluenceAvailabilityExperiment: confluenceAvailabilityExperiment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5R4n.BitbucketTab), {
        order: 2,
        onRetry: onRetry,
        features: {
            enableSingleScopesCall: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZ0uu.CompassTab), {
        crossFlowEnabled: true,
        sourceContext: "jira",
        isCompassActivated: licensedProducts?.compass ?? false,
        isUserAnonymous: user.isAnonymous,
        order: 3,
        onRetry: onRetry,
        userTeamConfig: {
            context: {
                contextType: 'filter',
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                organizationId: orgId,
                principalId: 'Context',
                productKey: $46a7ffce8732ffa8$var$COMPASS_PRODUCT_IDENTIFIER,
                siteId: cloudId
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ffvO4.OpsgenieTab), {
        order: 4,
        onRetry: onRetry,
        cloudId: cloudId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bHEFa.TownsquareTab), {
        order: 5,
        onRetry: onRetry,
        userTeamConfig: {
            context: {
                contextType: 'filter',
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                organizationId: orgId,
                principalId: 'Context',
                productKey: $46a7ffce8732ffa8$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER,
                siteId: cloudId
            }
        },
        // @ts-expect-error - TS2322 - Type '{ order: number; onRetry: () => void; userTeamConfig: { context: { contextType: string; principalId: string; productKey: string; siteId: string; }; }; cloudId: string; }' is not assignable to type 'IntrinsicAttributes & ExtensibleTabProps & { userTeamConfig?: UserTeamConfig | undefined; } & { children?: ReactNode; }'.
        cloudId: cloudId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUnI2.TrelloTab), {
        order: 5,
        onRetry: onRetry
    }));
};
const $46a7ffce8732ffa8$export$c89d6fd97d04eec5 = (props)=>{
    const { cloudId: cloudId, aggregatorUrl: aggregatorUrl, isExpanded: isExpanded, forwardRef: forwardRef, onNavigate: onNavigate, onOpen: onOpen, onClose: onClose, theme: theme, pageLoadMetrics: pageLoadMetrics, dialogFeatures: dialogFeatures, confluenceReactivationExperiment: confluenceReactivationExperiment, confluenceAvailabilityExperiment: confluenceAvailabilityExperiment, primaryProduct: primaryProduct } = props;
    // We want to track if the dialog has been expanded so that we do not unmount the tabs  when the dialog is collapsed
    const [hasBeenExpanded, setHasBeenExpanded] = (0, $5uXOq.useState)(false);
    const rovoEntitlement = (0, $kkNtb.useRovoEntitlementResource)();
    const isRovoEnabled = rovoEntitlement?.data?.isRovoEnabled ?? false;
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const secondaryProductNavigate = (0, $5uXOq.useCallback)((href)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(href);
    }, []);
    const onJiraNavigation = (0, $5uXOq.useCallback)((href, event)=>{
        onNavigate(href, event);
        onClose();
    }, [
        onClose,
        onNavigate
    ]);
    const isRovoCrossProductSearchLinkShown = (0, $95MIc.showAtlassianHomeSearchLink)(isRovoEnabled, orgId, primaryProduct);
    const onNavigateMultiProduct = (0, $5uXOq.useCallback)((id, href, event)=>{
        // Open the Rovo Search Atlassian Home link in a new tab if the user has either:
        // 1. navigated when the "All" product tab was selected
        // 2. navigated by using (cmd or ctrl) + enter when any product tab was selected
        if (isRovoCrossProductSearchLinkShown && (id === 'rovo-cross-product' || event.ctrlKey || event.metaKey)) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(href, '_blank');
            return;
        }
        if (id === 'jira') onJiraNavigation(href, event);
        else secondaryProductNavigate(href);
    }, [
        isRovoCrossProductSearchLinkShown,
        onJiraNavigation,
        secondaryProductNavigate
    ]);
    /**
   * A nav4 search theme that works with the nav3 theming API
   */ const newTheme = (0, $al2bB.useLegacySearchTheme)();
    const setIsExpanded = (0, $5uXOq.useCallback)((value)=>{
        if (value) onOpen();
        else onClose();
        if (value && !hasBeenExpanded) setHasBeenExpanded(true);
    }, [
        hasBeenExpanded,
        onClose,
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2k6eV.UserInputContextProvider), {
        stickySearchEnabled: true,
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlQRr.FilterContextProvider), {
        isEnabled: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RlGt.FilterContextProvider), {
        isEnabled: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6P5ov.MultiProductDialog), {
        shouldFillContainer: (0, $3HwlS.getWillShowNav4)(),
        aggregatorUrl: aggregatorUrl,
        abTestCloudId: cloudId,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        theme: (0, $3HwlS.getWillShowNav4)() ? newTheme : theme,
        // @ts-expect-error - TS2322 - Type 'HTMLInputElementRef' is not assignable to type 'Ref<HTMLInputElement>'.
        forwardRef: forwardRef,
        // @ts-expect-error - TS2322 - Type '(id: string, href: string, event: KeyboardEvent | MouseEvent) => void' is not assignable to type '(productId: string, href: string, event: MouseEvent<Element, MouseEvent> | KeyboardEvent) => void'.
        onNavigateGeneric: onNavigateMultiProduct,
        pageLoadMetrics: pageLoadMetrics,
        dialogFeatures: dialogFeatures,
        isRovoEnabled: isRovoEnabled,
        orgId: orgId,
        primaryProduct: primaryProduct
    }, ({ onRetry: onRetry })=>{
        // For performance reasons we want to avoid rendering the dialog content when it's not expanded. However, if we don't render any child tabs
        // then the search component will not be interactive. To work around this we render a dummy dialog when the dialog is not expanded with a single
        // section that is guaranteed to included in the allowed list.
        if (isExpanded || hasBeenExpanded) {
            if ((0, $4R6GH.fg)('blu-7149-search-dialog-tabpanel-semantics')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                role: "tabpanel"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46a7ffce8732ffa8$var$ExtensibleCrossProductSearchDialogWithData, {
                ...props,
                onRetry: onRetry,
                confluenceReactivationExperiment: confluenceReactivationExperiment,
                confluenceAvailabilityExperiment: confluenceAvailabilityExperiment
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46a7ffce8732ffa8$var$ExtensibleCrossProductSearchDialogWithData, {
                ...props,
                onRetry: onRetry,
                confluenceReactivationExperiment: confluenceReactivationExperiment,
                confluenceAvailabilityExperiment: confluenceAvailabilityExperiment
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kA88U.default), null);
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46a7ffce8732ffa8$var$LinkComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1q5t1r31 _1dit1r31 _1ohyglyw _ksodglyw _1r9x1o36 _4hz81o36",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bay8L", function(module, exports) {

$parcel$export(module.exports, "SmartCardProviderMigration", () => $bfd2a295419d11d6$export$c23cd4b65d8850b8);

var $5uXOq = parcelRequire("5uXOq");

var $8dO33 = parcelRequire("8dO33");

var $4R6GH = parcelRequire("4R6GH");
const $bfd2a295419d11d6$export$c23cd4b65d8850b8 = ({ children: children, product: product, client: client, isAdminHubAIEnabled: isAdminHubAIEnabled })=>(0, $4R6GH.fg)('fun-1689_single_root_smart_card_provider') ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        client: client
    }, children);

});
parcelRegister("8dO33", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $08b794feb02c83c1$export$497ecb0280204df4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $cCcdH = parcelRequire("cCcdH");

var $VSDnB = parcelRequire("VSDnB");

var $k9B19 = parcelRequire("k9B19");
var $dhQ1x = parcelRequire("dhQ1x");

var $8b7fu = parcelRequire("8b7fu");

var $051X7 = parcelRequire("051X7");

var $7cFR3 = parcelRequire("7cFR3");
function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport }) {
    const parentContext = (0, $5uXOq.useContext)((0, $051X7.SmartCardContext));
    const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $5uXOq.useMemo)(()=>{
        return (0, $3f2cs.createStore)((0, $8b7fu.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>{
        const client = customClient || new (0, $7cFR3.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cCcdH.getUrl)(store, url);
            return cardState.details ? (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkEmbed)(cardState.details) : (0, $k9B19.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        shouldControlDataExport,
        renderers,
        store
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $051X7.SmartCardContext).Provider, {
        value: parentContext || providerValue,
        children: children
    });
}
var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;

});
parcelRegister("cCcdH", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("k9B19", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $596309a7bcc79771$export$4b0d98b1b7f6d115);

var $TFljV = parcelRequire("TFljV");

var $7OmtM = parcelRequire("7OmtM");
const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $TFljV.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("TFljV", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $f8cdc1e628cbc347$export$3e8ad908070b68b2);
const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("7OmtM", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $0784379594099aa0$export$396ba4ef2e37dc65);
const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("dhQ1x", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkTitle", () => $084be06af531b246$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $084be06af531b246$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $084be06af531b246$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $084be06af531b246$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $084be06af531b246$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $084be06af531b246$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $084be06af531b246$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $084be06af531b246$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $084be06af531b246$export$7f099a839071a190);

var $hWyvy = parcelRequire("hWyvy");
var $8Tcl1 = parcelRequire("8Tcl1");
var $ccpJ1 = parcelRequire("ccpJ1");
var $8UXrm = parcelRequire("8UXrm");
var $4MmCl = parcelRequire("4MmCl");
var $g9Blp = parcelRequire("g9Blp");
var $f24gj = parcelRequire("f24gj");
var $iPUv2 = parcelRequire("iPUv2");

var $k9B19 = parcelRequire("k9B19");

var $kYwnb = parcelRequire("kYwnb");
const $084be06af531b246$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.displayName;
    return (0, $iPUv2.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $084be06af531b246$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.url;
    return (0, $8UXrm.extractLink)(response?.data);
};
const $084be06af531b246$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.ari;
    const data = response?.data;
    return (0, $hWyvy.extractAri)(data);
};
const $084be06af531b246$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) {
        const embedUrl = (0, $kYwnb.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $k9B19.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $084be06af531b246$export$ff753ed519e96e9e = (response)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntityProvider)(response);
    return response?.data && (0, $f24gj.extractProvider)(response?.data);
};
const $084be06af531b246$export$7a685df468cbf38f = (response)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.createdAt;
    return response?.data && (0, $8Tcl1.extractDateCreated)(response.data);
};
const $084be06af531b246$export$75047940e157fd1f = (response)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $ccpJ1.extractDateUpdated)(response.data);
};
const $084be06af531b246$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.createdBy?.id;
    const persons = (0, $4MmCl.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $084be06af531b246$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.lastUpdatedBy?.id;
    const person = (0, $g9Blp.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};

});
parcelRegister("hWyvy", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $e72cc95d6d37b739$export$be18a6294fd426ec);
const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("8Tcl1", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $ff639713cdfddc0e$export$e1226a5e0bbbf862);
const $ff639713cdfddc0e$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("ccpJ1", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $2985c9016975498b$export$7fc2f5e6f9d22ae7);
const $2985c9016975498b$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("8UXrm", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $c7ac01b191c63203$export$63f54cf4c5883620);

var $7OmtM = parcelRequire("7OmtM");
const $c7ac01b191c63203$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $7OmtM.extractUrlFromLinkJsonLd)(url);
    }
};

});

parcelRegister("4MmCl", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $b5a77ee228b8b40a$export$a66235cba0c9d11a);

var $aj6Xc = parcelRequire("aj6Xc");
const $b5a77ee228b8b40a$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $aj6Xc.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $aj6Xc.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});
parcelRegister("aj6Xc", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $39e0e436026dd560$export$c471ae5fddcf1392);

var $cuw1y = parcelRequire("cuw1y");
const $39e0e436026dd560$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});
parcelRegister("cuw1y", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $17919ed1c60776d3$export$67f3d92c824fd850);

var $7OmtM = parcelRequire("7OmtM");
const $17919ed1c60776d3$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $7OmtM.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $7OmtM.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});



parcelRegister("g9Blp", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $e35651e7203a8f3a$export$8a2d1ed7e6f336f0);

var $aj6Xc = parcelRequire("aj6Xc");
const $e35651e7203a8f3a$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $aj6Xc.extractPersonFromJsonLd)(updatedBy);
};

});

parcelRegister("f24gj", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $e8bec3b6f1f5b80a$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $e8bec3b6f1f5b80a$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $e8bec3b6f1f5b80a$export$38df542ff03a4183);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7anl7 = parcelRequire("7anl7");

var $29YN9 = parcelRequire("29YN9");


var $cuw1y = parcelRequire("cuw1y");
var $7OmtM = parcelRequire("7OmtM");
const $e8bec3b6f1f5b80a$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $e8bec3b6f1f5b80a$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $e8bec3b6f1f5b80a$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $e8bec3b6f1f5b80a$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $0b0a34f2504ca78c$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $0b0a34f2504ca78c$export$f654d825189934a7)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return (0, $cuw1y.extractUrlFromIconJsonLd)(icon);
};
const $e8bec3b6f1f5b80a$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $7OmtM.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $7OmtM.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};
const $e8bec3b6f1f5b80a$export$38df542ff03a4183 = (id)=>{
    return id === (0, $0b0a34f2504ca78c$export$cee224b5de4d6d66);
};

});
parcelRegister("7anl7", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $1c9c2365ff37a453$export$68f3db7f6af48bcb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $1c9c2365ff37a453$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $1c9c2365ff37a453$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $1c9c2365ff37a453$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

const $0b0a34f2504ca78c$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $0b0a34f2504ca78c$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $0b0a34f2504ca78c$export$84a73a0383f58180 = 'JiraTask';
const $0b0a34f2504ca78c$export$c6c83963a9378a67 = 'JiraSubTask';
const $0b0a34f2504ca78c$export$58af3c426c111a6d = 'JiraStory';
const $0b0a34f2504ca78c$export$ac9898a63417219e = 'JiraBug';
const $0b0a34f2504ca78c$export$54db5e3fb12e39cd = 'JiraEpic';
const $0b0a34f2504ca78c$export$2f54a5a217202c85 = 'JiraIncident';
const $0b0a34f2504ca78c$export$d097371052bfc411 = 'JiraServiceRequest';
const $0b0a34f2504ca78c$export$efd9452ad16c6676 = 'JiraChange';
const $0b0a34f2504ca78c$export$2e7e70abb5d81f67 = 'JiraProblem';
const $0b0a34f2504ca78c$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("iPUv2", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $3d37e098183ec9ac$export$b05803156e5015b6);

var $a8kxN = parcelRequire("a8kxN");

var $FcDCF = parcelRequire("FcDCF");
const $3d37e098183ec9ac$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $a8kxN.extractContext)(jsonLd);
    const type = (0, $FcDCF.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("a8kxN", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $1d582ee88fc2111b$export$efdbd45f3e77a161);

var $FcDCF = parcelRequire("FcDCF");

var $cuw1y = parcelRequire("cuw1y");
const $1d582ee88fc2111b$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $FcDCF.extractType)(context)
            };
        }
    }
};

});
parcelRegister("FcDCF", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $c2480e088a98b125$export$2e9ae379995d99e3);
const $c2480e088a98b125$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});



parcelRegister("kYwnb", function(module, exports) {

$parcel$export(module.exports, "isEntityPresent", () => $d95897e8ea09702f$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntity", () => $d95897e8ea09702f$export$8beff7405d020ddf);
$parcel$export(module.exports, "extractEntityEmbedUrl", () => $d95897e8ea09702f$export$f97663ee76ac5b24);
$parcel$export(module.exports, "extractEntityProvider", () => $d95897e8ea09702f$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $d95897e8ea09702f$export$19346520e937a99f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7anl7 = parcelRequire("7anl7");

var $29YN9 = parcelRequire("29YN9");

const $d95897e8ea09702f$export$c7168210b81d9383 = (response)=>Boolean(response?.nounData);
const $d95897e8ea09702f$export$8beff7405d020ddf = (response)=>response?.nounData;
const $d95897e8ea09702f$export$f97663ee76ac5b24 = (response)=>{
    const entity = $d95897e8ea09702f$export$8beff7405d020ddf(response);
    if (entity && $d95897e8ea09702f$export$7139465266d5efc6(entity)) return entity['atlassian:design'].liveEmbedUrl;
};
function $d95897e8ea09702f$export$7139465266d5efc6(object) {
    return typeof object === 'object' && object !== null && 'atlassian:design' in object;
}
const $d95897e8ea09702f$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $0b0a34f2504ca78c$export$cee224b5de4d6d66:
            providerIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        case 0, $0b0a34f2504ca78c$export$f654d825189934a7:
            providerIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $d95897e8ea09702f$export$19346520e937a99f = (response)=>{
    const entity = $d95897e8ea09702f$export$8beff7405d020ddf(response);
    let url;
    if ($d95897e8ea09702f$export$7139465266d5efc6(entity)) url = entity?.['atlassian:design'].iconUrl;
    return {
        url: url,
        label: entity?.displayName
    };
};

});


parcelRegister("8b7fu", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $92a815d7e26b35c0$export$3c7c3113a97b6492);

var $2yPrN = parcelRequire("2yPrN");
var $fiKQs = parcelRequire("fiKQs");
const $92a815d7e26b35c0$var$isCardAction = (action)=>{
    return [
        (0, $2yPrN.ACTION_PENDING),
        (0, $2yPrN.ACTION_RESOLVING),
        (0, $2yPrN.ACTION_RESOLVED),
        (0, $2yPrN.ACTION_RELOADING),
        (0, $2yPrN.ACTION_ERROR),
        (0, $2yPrN.ACTION_ERROR_FALLBACK),
        (0, $2yPrN.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $fiKQs.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $2yPrN.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVED:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $2yPrN.ACTION_RELOADING:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $2yPrN.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $2yPrN.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $2yPrN.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("2yPrN", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $23a1ee9f12bb755d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $23a1ee9f12bb755d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $23a1ee9f12bb755d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $23a1ee9f12bb755d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $23a1ee9f12bb755d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $23a1ee9f12bb755d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $23a1ee9f12bb755d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("fiKQs", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $5c2f531cb20db568$export$b70265791d2079d4);
const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("051X7", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $b8de051ddcb2808f$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $b8de051ddcb2808f$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $b8de051ddcb2808f$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $b8de051ddcb2808f$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $b8de051ddcb2808f$export$2a29ca11e08dc129);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $b8de051ddcb2808f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $b8de051ddcb2808f$export$e1d190b530cf0ee9() {
    const context = (0, $5uXOq.useContext)($b8de051ddcb2808f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $b8de051ddcb2808f$export$10e9cca30e50f657 = ()=>$b8de051ddcb2808f$var$useContextMemoized($b8de051ddcb2808f$export$156b523e63b4f63a);
const $b8de051ddcb2808f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
function $b8de051ddcb2808f$var$useContextMemoized(reactContext) {
    const value = (0, $5uXOq.useContext)(reactContext);
    const context = (0, $5uXOq.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $b8de051ddcb2808f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $b8de051ddcb2808f$export$2e2bcd8739ae039 = $b8de051ddcb2808f$export$156b523e63b4f63a;

});

parcelRegister("7cFR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d96ed473518bd99$export$2e2bcd8739ae039);

var $hhZW9 = parcelRequire("hhZW9");

var $hj8yn = parcelRequire("hj8yn");

var $hLXaJ = parcelRequire("hLXaJ");

var $kDZ6Z = parcelRequire("kDZ6Z");
var $itO4f = parcelRequire("itO4f");
var $fiKQs = parcelRequire("fiKQs");
var $dV0Jy = parcelRequire("dV0Jy");

var $4Bkrp = parcelRequire("4Bkrp");

var $iwKVT = parcelRequire("iwKVT");
const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
class $8d96ed473518bd99$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $4Bkrp.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $itO4f.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hLXaJ)))({
            limit: 1,
            interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $4Bkrp.isSuccessfulResponse)(response) || (0, $fiKQs.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $4Bkrp.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $4Bkrp.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $4Bkrp.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $4Bkrp.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $4Bkrp.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $dV0Jy.NetworkError)) return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $kDZ6Z.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $kDZ6Z.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $kDZ6Z.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $kDZ6Z.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("hhZW9", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $c964119340a5ebe3$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
        this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $c964119340a5ebe3$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
    if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
    $c964119340a5ebe3$var$resolvedPromise.then(function() {
        $6cAn5.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $c964119340a5ebe3$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $c964119340a5ebe3$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $c964119340a5ebe3$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $c964119340a5ebe3$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $c964119340a5ebe3$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $c964119340a5ebe3$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $c964119340a5ebe3$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $c964119340a5ebe3$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $c964119340a5ebe3$var$DataLoader;

});

parcelRegister("hj8yn", function(module, exports) {
// Packages

var $8DmlG = parcelRequire("8DmlG");
function $c99ad890679d3578$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $8DmlG.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $c99ad890679d3578$var$retry;

});
parcelRegister("8DmlG", function(module, exports) {

module.exports = (parcelRequire("j1SyJ"));

});
parcelRegister("j1SyJ", function(module, exports) {

var $gRLb1 = parcelRequire("gRLb1");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $gRLb1(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("gRLb1", function(module, exports) {
function $c47630e585ca345b$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $c47630e585ca345b$var$RetryOperation;
$c47630e585ca345b$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$c47630e585ca345b$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$c47630e585ca345b$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$c47630e585ca345b$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$c47630e585ca345b$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$c47630e585ca345b$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$c47630e585ca345b$var$RetryOperation.prototype.start = $c47630e585ca345b$var$RetryOperation.prototype.try;
$c47630e585ca345b$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$c47630e585ca345b$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$c47630e585ca345b$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("hLXaJ", function(module, exports) {
'use strict';
class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;

});

parcelRegister("kDZ6Z", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $8c263ecf028a2c14$export$3e5b797e39668f84);
class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("itO4f", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $21a0efece812cd9a$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $21a0efece812cd9a$export$dc37652c1696f231);
const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $21a0efece812cd9a$export$e2b040f052407032 = {
    dev: $21a0efece812cd9a$var$devBaseUrl,
    development: $21a0efece812cd9a$var$devBaseUrl,
    stg: $21a0efece812cd9a$var$stgBaseUrl,
    staging: $21a0efece812cd9a$var$stgBaseUrl,
    prd: $21a0efece812cd9a$var$prodBaseUrl,
    prod: $21a0efece812cd9a$var$prodBaseUrl,
    production: $21a0efece812cd9a$var$prodBaseUrl
};
const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;

});

parcelRegister("dV0Jy", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $5576d4e9d0a3858d$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $5576d4e9d0a3858d$export$b5fe3f66a567bec0);
const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("4Bkrp", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("iwKVT", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});




parcelRegister("c5R4n", function(module, exports) {

$parcel$export(module.exports, "BitbucketTab", () => $f1e7b2e1c6cce5f3$export$a83467d99f696187);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $a353g = parcelRequire("a353g");

var $f4GCr = parcelRequire("f4GCr");

var $e17vR = parcelRequire("e17vR");

var $k4hbD = parcelRequire("k4hbD");

var $cxU5p = parcelRequire("cxU5p");

var $8Xs9r = parcelRequire("8Xs9r");
var $kv2Va = parcelRequire("kv2Va");

var $kbhX0 = parcelRequire("kbhX0");

var $b1ovj = parcelRequire("b1ovj");

var $hEvMC = parcelRequire("hEvMC");

var $95MIc = parcelRequire("95MIc");

var $4f9Ma = parcelRequire("4f9Ma");

var $7VoGI = parcelRequire("7VoGI");

var $lvCts = parcelRequire("lvCts");
const $f1e7b2e1c6cce5f3$var$mapAggregatorResponseToSearchItem = (repo)=>{
    return {
        title: repo.name,
        id: repo.uuid,
        meta: repo.workspace.name,
        url: repo.links.html.href,
        iconUrl: repo.links.avatar.href,
        containerId: repo.workspace.uuid
    };
};
const $f1e7b2e1c6cce5f3$export$9d75ef492044e493 = ({ intl: intl, viewAllLinkGenerator: overriddenViewAllLinkGenerator, codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator, codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen, permissionSupplier: overriddenPermissionsSupplier, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, currentContext: currentContext, features: features, ...rest })=>{
    const { viewAllLinkGenerator: viewAllLinkGenerator, codeSearchUrlGenerator: codeSearchUrlGenerator, codeSearchContextualUrlGenerator: codeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $5uXOq.useMemo)(()=>{
        return (0, $hEvMC.bitbucketURLGenerators)({
            viewAllLinkGenerator: overriddenViewAllLinkGenerator,
            codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator,
            codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator,
            urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen
        });
    }, [
        overriddenCodeSearchUrlGenerator,
        overriddenCodeSearchContextualUrlGenerator,
        overriddenUrlGeneratorForNoResultsScreen,
        overriddenViewAllLinkGenerator
    ]);
    const sections = [
        {
            id: (0, $b1ovj.BitbucketScope).BitbucketRepostitory,
            title: intl.formatMessage((0, $e17vR.messages).bitbucket_repository_heading),
            scope: (0, $b1ovj.BitbucketScope).BitbucketRepostitory,
            showResultCount: true,
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultMapper: ({ results: results })=>results.map((value)=>$f1e7b2e1c6cce5f3$var$mapAggregatorResponseToSearchItem(value))
        }
    ];
    const itemSuppliers = (0, $f4GCr.useDefaultSuppliers)((0, $b1ovj.BITBUCKET_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const permissionSupplier = (0, $kbhX0.useBitbucketPermissionSupplier)(overriddenPermissionsSupplier);
    const formattedSearchForCodeLabel = (context)=>{
        const { repository: repository, workspace: workspace } = context || {};
        let source = 'Bitbucket';
        if (repository) source = repository.name;
        else if (workspace) source = workspace.name;
        return intl.formatMessage((0, $e17vR.messages).bitbucket_advanced_search, {
            source: source
        });
    };
    const { getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $4f9Ma.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return viewAllLinkGenerator(query);
    }, [
        viewAllLinkGenerator,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        expandedStateInputPlaceholder: intl.formatMessage((0, $e17vR.messages).bitbucket_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        id: (0, $b1ovj.BITBUCKET_PRODUCT_ID),
        permissionSupplier: permissionSupplier,
        preQuerySectionTitleGenerator: (section)=>section.id === (0, $b1ovj.BitbucketScope).BitbucketRepostitory ? intl.formatMessage((0, $e17vR.messages).bitbucket_recent_repositories) : '',
        sections: sections,
        title: intl.formatMessage((0, $k4hbD.messages).bitbucket_tab_label),
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        ...rest,
        ...itemSuppliers,
        children: ({ linkComponent: linkComponent, query: query })=>{
            const codeSearchUrl = currentContext ? codeSearchContextualUrlGenerator(query, currentContext) : codeSearchUrlGenerator(query);
            const contextualSearchMessage = formattedSearchForCodeLabel(currentContext);
            return {
                Header: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cxU5p.AdvancedSearch), {
                        advancedSearchMessage: contextualSearchMessage,
                        advancedSearchUrl: codeSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f9Ma.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $f1e7b2e1c6cce5f3$export$a83467d99f696187 = (0, $8RXs9.default)($f1e7b2e1c6cce5f3$export$9d75ef492044e493);

});
parcelRegister("a353g", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $ca1f4818c3f18a6a$export$64ded8b71dfcba9e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $ca1f4818c3f18a6a$export$64ded8b71dfcba9e = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jzvw2y0"
})({
    width: '100%',
    height: `${"var(--ds-space-600, 48px)"}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`
});

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("f4GCr", function(module, exports) {

$parcel$export(module.exports, "useDefaultSuppliers", () => $2d1493dd7443ea05$export$967ff0f6c3886589);

var $jKEl7 = parcelRequire("jKEl7");

var $6ZsPS = parcelRequire("6ZsPS");

var $lvCts = parcelRequire("lvCts");

var $bONub = parcelRequire("bONub");

var $kv2Va = parcelRequire("kv2Va");
const $2d1493dd7443ea05$var$MAX_DEFAULT_SITES = 3;
const $2d1493dd7443ea05$export$dc64f87f5460b276 = (aggregatorClient, sections, context, experience, sourceProduct)=>async ({ query: query, filters: allFilters, workspaces: workspaces, sectionIds: allPermissionedScopes })=>{
        const defaultSites = workspaces?.slice(0, $2d1493dd7443ea05$var$MAX_DEFAULT_SITES).map((workspace)=>workspace.id);
        // Extract sites from filters
        const siteFilter = allFilters.find((filter)=>filter['@type'] === (0, $bONub.SITE_FILTER_TYPE_NAME));
        // @ts-ignore - typescript is not smart enough to know `siteFilter` will only ever be the sites filter
        const sites = siteFilter?.values || defaultSites || [];
        // Remove sites from the filters array
        const filters = allFilters.filter((filter)=>filter['@type'] !== (0, $bONub.SITE_FILTER_TYPE_NAME)).map((f)=>f);
        const permittedSections = sections.filter((section)=>allPermissionedScopes.indexOf(section.id) >= 0).filter((section)=>section.isEnabled ? section.isEnabled(query, filters) : true);
        const scopes = permittedSections.map((section)=>section.scope);
        if (!aggregatorClient) return {
            sections: []
        };
        const { response: response } = await aggregatorClient.search({
            query: query,
            scopes: scopes,
            modelParams: [],
            experience: experience,
            context: context,
            filters: filters,
            sites: sites,
            sourceProduct: sourceProduct
        });
        const sectionsWithResults = permittedSections.map(({ scope: scope, id: id, title: title, resultMapper: resultMapper, ...rest })=>{
            const results = response.retrieveScope(scope);
            if (results === null) throw new Error(`Scope ${scope} was not found in the response, despite being requested`);
            return {
                ...rest,
                id: id,
                title: title,
                size: results.size,
                searchResults: resultMapper(results) || [],
                resultMapper: resultMapper
            };
        });
        const scopesWithSize = response.rawData.scopes.filter(({ size: size })=>size);
        const reponseHasSize = scopesWithSize.length > 0;
        const totalSizeAsReportedByAPI = reponseHasSize ? response.rawData.scopes.reduce((count, scope)=>count + (scope.size || 0), 0) : undefined;
        return {
            size: totalSizeAsReportedByAPI,
            sections: sectionsWithResults
        };
    };
const $2d1493dd7443ea05$export$967ff0f6c3886589 = (id, sections, overrides)=>{
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const sessionId = (0, $6ZsPS.useSearchSessionId)();
    const productContext = (0, $kv2Va.useProductContext)();
    const { getPrimaryProduct: getPrimaryProduct } = productContext;
    const primaryProduct = getPrimaryProduct();
    const primaryProductId = primaryProduct?.id;
    const search = $2d1493dd7443ea05$export$dc64f87f5460b276(aggregatorClient, sections, {
        sessionId: sessionId,
        referrerId: ''
    }, (0, $jKEl7.PLACEHOLDER_EXPERIENCE), primaryProductId);
    return {
        preQueryItemSupplier: overrides?.preQueryItemSupplier ?? ((args)=>search({
                ...args,
                query: '',
                filters: []
            })),
        postQueryItemSupplier: overrides?.postQueryItemSupplier ?? search
    };
};

});
parcelRegister("jKEl7", function(module, exports) {

$parcel$export(module.exports, "PLACEHOLDER_EXPERIENCE", () => $b4ca9de00d663510$export$2bde439437c11152);

var $lvCts = parcelRequire("lvCts");
const $b4ca9de00d663510$export$2bde439437c11152 = 'product-search-dialog';

});
parcelRegister("lvCts", function(module, exports) {

$parcel$export(module.exports, "AggregatorClientContextProvider", () => $6af66ca999c4da2e$export$db02e603a9db00);
$parcel$export(module.exports, "useAggregatorClient", () => $6af66ca999c4da2e$export$b8a9ed32354e757e);
$parcel$export(module.exports, "useTypedAggregatorClient", () => $6af66ca999c4da2e$export$51bbe78d05c20324);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $zo35K = parcelRequire("zo35K");

var $j97IK = parcelRequire("j97IK");
const $6af66ca999c4da2e$var$AggregatorClientContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $6af66ca999c4da2e$export$db02e603a9db00 = ({ abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, children: children })=>{
    const { backendExperiment: backendExperiment } = (0, $j97IK.useExperiments)();
    const aggregatorClient = (0, $5uXOq.useMemo)(()=>new (0, $zo35K.AggregatorClient)({
            url: aggregatorUrl,
            cloudId: abTestCloudId,
            siteMasterList: [],
            backendExperiment: backendExperiment
        }), [
        abTestCloudId,
        aggregatorUrl,
        backendExperiment
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($6af66ca999c4da2e$var$AggregatorClientContext.Provider, {
        value: aggregatorClient,
        children: children
    });
};
const $6af66ca999c4da2e$export$b8a9ed32354e757e = ()=>{
    const aggregatorClient = (0, $5uXOq.useContext)($6af66ca999c4da2e$var$AggregatorClientContext);
    return aggregatorClient;
};
const $6af66ca999c4da2e$export$51bbe78d05c20324 = ()=>{
    // Casting done here to ensure that the result types match the scopes requested
    const untypedClient = (0, $5uXOq.useContext)($6af66ca999c4da2e$var$AggregatorClientContext);
    return untypedClient;
};

});


parcelRegister("6ZsPS", function(module, exports) {

$parcel$export(module.exports, "SearchSessionProvider", () => $825e156d58807f26$export$facabd4fde35268);
$parcel$export(module.exports, "useSearchSessionId", () => $825e156d58807f26$export$e1e7a4797df1a656);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bXrHm = parcelRequire("bXrHm");

var $tUDIN = parcelRequire("tUDIN");
const $825e156d58807f26$var$SearchSessionContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    searchSessionId: undefined
});
class $825e156d58807f26$var$SearchSessionProviderError extends Error {
    constructor(){
        super('Could not find any SearchSessionProvider, make sure there is a SearchSessionProvider further up the tree');
    }
}
function $825e156d58807f26$export$432081be24450536(Component) {
    const WrapperComponent = (props)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)($825e156d58807f26$var$SearchSessionContext.Consumer, {
            children: ({ searchSessionId: searchSessionId })=>{
                if (!searchSessionId) throw new $825e156d58807f26$var$SearchSessionProviderError();
                return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...props,
                    searchSessionId: searchSessionId
                });
            }
        });
    };
    return WrapperComponent;
}
class $825e156d58807f26$export$facabd4fde35268 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static getDerivedStateFromProps(props, state) {
        // Reset the searchSessionId only when the dialog is expanded
        return {
            sessionKey: props.sessionKey,
            searchSessionId: props.sessionKey !== state.sessionKey && props.sessionKey !== 'ssid_provider_false' ? (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))() : state.searchSessionId
        };
    }
    render() {
        const { children: children } = this.props;
        const { searchSessionId: searchSessionId } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($825e156d58807f26$var$SearchSessionContext.Provider, {
            value: {
                searchSessionId: searchSessionId
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
                analyticContext: {
                    searchSessionId: searchSessionId
                },
                nonPrivacySafeAnalyticContext: {},
                children: children
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            sessionKey: this.props.sessionKey,
            searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()
        };
    }
}
function $825e156d58807f26$export$e1e7a4797df1a656() {
    const { searchSessionId: searchSessionId } = (0, $5uXOq.useContext)($825e156d58807f26$var$SearchSessionContext);
    if (searchSessionId) return searchSessionId;
    throw new $825e156d58807f26$var$SearchSessionProviderError();
}

});
parcelRegister("tUDIN", function(module, exports) {

$parcel$export(module.exports, "SearchDialogAnalyticsContext", () => $a2cc995c65c8dc02$export$b6f131c43d0365a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3FqY6 = parcelRequire("3FqY6");

var $bvUB1 = parcelRequire("bvUB1");
const $a2cc995c65c8dc02$export$b6f131c43d0365a = ({ analyticContext: analyticContext, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext = {}, filterAnalyticsContext: filterAnalyticsContext = {}, nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeAnalyticContextGenerator, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
        channel: (0, $3FqY6.DEFAULT_GAS_CHANNEL),
        onEvent: (event)=>{
            const additionalAttributes = typeof analyticContext === 'function' ? analyticContext() : analyticContext;
            const nonPrivacySafeAttributes = nonPrivacySafeAnalyticContextGenerator !== undefined ? nonPrivacySafeAnalyticContextGenerator() : nonPrivacySafeAnalyticContext;
            event.update((payload)=>{
                const filters = {
                    ...payload.attributes?.filters,
                    ...filterAnalyticsContext
                };
                // Operational event not support nonPrivacySafeAttributes
                const nonPrivacySafeAttributesPayload = payload.eventType === 'operational' ? {} : {
                    nonPrivacySafeAttributes: {
                        ...payload?.nonPrivacySafeAttributes,
                        ...nonPrivacySafeAttributes
                    }
                };
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        ...additionalAttributes,
                        filters: Object.keys(filters).length > 0 ? filters : undefined
                    },
                    ...nonPrivacySafeAttributesPayload
                };
            });
        },
        children: children
    });
};

});
parcelRegister("3FqY6", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GAS_CHANNEL", () => $64fe155c5383b984$export$ed78826c06dd24e3);
$parcel$export(module.exports, "Trigger", () => $64fe155c5383b984$export$41fb9f06171c75f4);
$parcel$export(module.exports, "AdvancedSearchLinkSubjectId", () => $64fe155c5383b984$export$f7a2a633defbe589);
$parcel$export(module.exports, "onAdvancedSearchSelected", () => $64fe155c5383b984$export$b544183e0becb531);
$parcel$export(module.exports, "onXButtonClicked", () => $64fe155c5383b984$export$19360e9b825e4dfb);
$parcel$export(module.exports, "onNonDebouncedSearchTriggered", () => $64fe155c5383b984$export$72e9f7dfc882e584);
$parcel$export(module.exports, "onStickySearchCleared", () => $64fe155c5383b984$export$9cb41cdfd7c5452f);
$parcel$export(module.exports, "onAutocorrectShown", () => $64fe155c5383b984$export$b4f9d93cc4bd7b82);
$parcel$export(module.exports, "onAutocorrectClicked", () => $64fe155c5383b984$export$33cdbdfa7f154d6c);
$parcel$export(module.exports, "onHoverPreviewShow", () => $64fe155c5383b984$export$82cfcc46988a9165);
$parcel$export(module.exports, "onHoverPreviewShown", () => $64fe155c5383b984$export$c666b7de327a3cc2);
$parcel$export(module.exports, "onHoverPreviewClicked", () => $64fe155c5383b984$export$dfba1b0d5d9e4887);
$parcel$export(module.exports, "onCardRequestFailed", () => $64fe155c5383b984$export$4b429c3d1a2c2d67);
$parcel$export(module.exports, "onSearchResultViewAllLinkClicked", () => $64fe155c5383b984$export$b87f0592bfac0edc);
$parcel$export(module.exports, "onMultiSiteAdvancedSearchSelected", () => $64fe155c5383b984$export$62946e9fdc11ae8d);
$parcel$export(module.exports, "onMoreFiltersSelected", () => $64fe155c5383b984$export$6c5bd82ba411ffb0);
$parcel$export(module.exports, "onSearchResultSelected", () => $64fe155c5383b984$export$7816fccc5a0a2fed);
$parcel$export(module.exports, "onSearchResultHighlighted", () => $64fe155c5383b984$export$95ef6569b5b2de4a);
$parcel$export(module.exports, "onSearchResultContext", () => $64fe155c5383b984$export$656ab76fbb25e04);
$parcel$export(module.exports, "ResultsShownActionSubjectId", () => $64fe155c5383b984$export$676101ab18001bd5);
$parcel$export(module.exports, "onSearchResultsShown", () => $64fe155c5383b984$export$2d1da932f40a427e);
$parcel$export(module.exports, "onTextEntered", () => $64fe155c5383b984$export$db28d8e16fb16e80);
$parcel$export(module.exports, "onPreQueryScreenViewed", () => $64fe155c5383b984$export$145f05df248491e5);
$parcel$export(module.exports, "onRequestMade", () => $64fe155c5383b984$export$93a340bed59d6525);
$parcel$export(module.exports, "onDismissed", () => $64fe155c5383b984$export$97e12e4b0f216b1d);
$parcel$export(module.exports, "onShown", () => $64fe155c5383b984$export$e79368bde551c62e);
$parcel$export(module.exports, "onDropdownMenuFilterView", () => $64fe155c5383b984$export$9e2ba0ae72f48da8);
$parcel$export(module.exports, "onFilterSelect", () => $64fe155c5383b984$export$151951fdc112763c);
$parcel$export(module.exports, "onFilterUnselect", () => $64fe155c5383b984$export$f448c439d93613dd);
$parcel$export(module.exports, "onFilterFieldCleared", () => $64fe155c5383b984$export$2e387d28788cf23b);
$parcel$export(module.exports, "onPaneLoadComplete", () => $64fe155c5383b984$export$8ba00734f8071933);
$parcel$export(module.exports, "onExperimentLoaded", () => $64fe155c5383b984$export$d9576525adc921c1);
$parcel$export(module.exports, "onTabSelected", () => $64fe155c5383b984$export$cb0c8d6d4bf862f8);
$parcel$export(module.exports, "selectEvent", () => $64fe155c5383b984$export$48143d759475d90f);
$parcel$export(module.exports, "onPrequeryBannerShown", () => $64fe155c5383b984$export$1338fc4f37de8396);
$parcel$export(module.exports, "onSuggestedPromptClick", () => $64fe155c5383b984$export$e7721900a147b5b2);
$parcel$export(module.exports, "onPrequeryBannerDismiss", () => $64fe155c5383b984$export$889f319cb696bfae);
$parcel$export(module.exports, "onConfluenceReactionNudgeShown", () => $64fe155c5383b984$export$a7d90f29e3bc6f4f);
/**
 * Note all events fired include the searchSessionId, experiment-id, queryHash, queryVersion, wordCount, resultCount where applicable
 */ const $64fe155c5383b984$export$ed78826c06dd24e3 = 'fabric-elements';
var $64fe155c5383b984$export$41fb9f06171c75f4 = /*#__PURE__*/ function(Trigger) {
    Trigger["SHORTCUT"] = "shortcut";
    Trigger["SHORTCUT_MODIFIED"] = "shortcutModified";
    Trigger["RETURN"] = "return";
    Trigger["CLICK"] = "click";
    Trigger["TEXT_ENTERED"] = "textEntered";
    return Trigger;
}({});
var $64fe155c5383b984$export$f7a2a633defbe589 = /*#__PURE__*/ function(AdvancedSearchLinkSubjectId) {
    AdvancedSearchLinkSubjectId["CONFLUENCE"] = "confluenceAdvancedSearchLink";
    AdvancedSearchLinkSubjectId["CONFLUENCE_PEOPLE"] = "confluencePeopleSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_ISSUES"] = "jiraIssuesSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
    AdvancedSearchLinkSubjectId["NO_RESULTS"] = "noResultsAdvancedSearchLink";
    return AdvancedSearchLinkSubjectId;
}({});
const $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE = 'searchDialog';
const $64fe155c5383b984$export$b544183e0becb531 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, isRovoCrossProductSearchLink: isRovoCrossProductSearchLink = false })=>{
    return {
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab,
            isRovoCrossProductSearchLink: isRovoCrossProductSearchLink
        }
    };
};
const $64fe155c5383b984$export$7d52695c66ad1422 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab })=>{
    return {
        action: 'selected',
        actionSubject: 'askAtlassianIntelligenceLink',
        actionSubjectId: actionSubjectId,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab
        }
    };
};
const $64fe155c5383b984$export$19360e9b825e4dfb = ({ actionSubjectId: actionSubjectId, searchSessionId: searchSessionId })=>{
    return {
        action: 'dismissed',
        actionSubject: 'stickySearch',
        actionSubjectId: actionSubjectId,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId
        }
    };
};
const $64fe155c5383b984$export$72e9f7dfc882e584 = ()=>{
    return {
        action: 'triggered',
        actionSubject: 'nonDebouncedSearch',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui'
    };
};
const $64fe155c5383b984$export$9cb41cdfd7c5452f = ({ timeout: timeout })=>{
    return {
        eventType: 'track',
        action: 'cleared',
        actionSubject: 'stickySearch',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        attributes: {
            timeout: timeout
        }
    };
};
const $64fe155c5383b984$export$b4f9d93cc4bd7b82 = ({ source: source, attributes: attributes })=>{
    return {
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'link',
        actionSubjectId: 'autocorrect',
        source: source,
        attributes: attributes
    };
};
const $64fe155c5383b984$export$33cdbdfa7f154d6c = ({ source: source, attributes: attributes })=>{
    return {
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'autocorrect',
        source: source,
        attributes: attributes
    };
};
const $64fe155c5383b984$export$82cfcc46988a9165 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        action: 'show',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $64fe155c5383b984$export$c666b7de327a3cc2 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        action: 'shown',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $64fe155c5383b984$export$dfba1b0d5d9e4887 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        action: 'clicked',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $64fe155c5383b984$export$4b429c3d1a2c2d67 = ({ attributes: attributes })=>({
        eventType: 'operational',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        action: 'failed',
        actionSubject: 'trelloCardRequest',
        attributes: {
            ...attributes
        }
    });
const $64fe155c5383b984$export$b87f0592bfac0edc = (sectionId)=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'searchResultViewAllLink',
        attributes: {
            sectionId: sectionId
        }
    });
const $64fe155c5383b984$export$62946e9fdc11ae8d = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, destinationId: destinationId, index: index })=>{
    return {
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab,
            destinationId: destinationId,
            index: index
        }
    };
};
const $64fe155c5383b984$export$6c5bd82ba411ffb0 = ({ trigger: trigger, selectedFiltersCount: selectedFiltersCount })=>{
    return {
        action: 'selected',
        actionSubject: 'moreFilterLink',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            trigger: trigger,
            selectedFiltersCount: selectedFiltersCount
        }
    };
};
const $64fe155c5383b984$export$7816fccc5a0a2fed = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'selected',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $64fe155c5383b984$export$95ef6569b5b2de4a = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'highlighted',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $64fe155c5383b984$export$656ab76fbb25e04 = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'contextMenu opened',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
var $64fe155c5383b984$export$676101ab18001bd5 = /*#__PURE__*/ function(ResultsShownActionSubjectId) {
    ResultsShownActionSubjectId["PREQUERY"] = "preQuerySearchResults";
    ResultsShownActionSubjectId["POSTQUERY"] = "postQuerySearchResults";
    ResultsShownActionSubjectId["CACHED"] = "cachedResults";
    ResultsShownActionSubjectId["PREQUERY_ERROR"] = "preQueryError";
    ResultsShownActionSubjectId["POSTQUERY_ERROR"] = "postQueryError";
    return ResultsShownActionSubjectId;
}({});
const $64fe155c5383b984$export$2d1da932f40a427e = ({ actionSubjectId: actionSubjectId, resultCount: resultCount, sectionCount: sectionCount, results: results, timeToQueryMs: timeToQueryMs, activeProduct: activeProduct, isMultiProduct: isMultiProduct, filters: filters })=>{
    return {
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: actionSubjectId,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            resultCount: resultCount,
            sectionCount: sectionCount,
            timeToQueryMs: timeToQueryMs,
            results: results,
            noResultsFetched: !resultCount,
            activeProduct: activeProduct,
            isMultiProduct: isMultiProduct,
            filters: filters
        }
    };
};
const $64fe155c5383b984$export$db28d8e16fb16e80 = ()=>{
    return {
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $64fe155c5383b984$export$3484ea513055aa12 = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'showMoreButton',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            total: total,
            currentSize: currentSize,
            pageSize: pageSize
        }
    };
};
const $64fe155c5383b984$export$3fb15ebf22b4884e = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'showAllLink',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            total: total,
            currentSize: currentSize,
            pageSize: pageSize
        }
    };
};
const $64fe155c5383b984$export$145f05df248491e5 = ({ searchSessionId: searchSessionId, trigger: trigger })=>{
    return {
        name: 'searchDialogPreQueryScreen',
        eventType: 'screen',
        attributes: {
            searchSessionId: searchSessionId,
            trigger: trigger
        }
    };
};
const $64fe155c5383b984$export$93a340bed59d6525 = ({ actionSubjectId: actionSubjectId, timings: timings, activeProduct: activeProduct, isExpanded: isExpanded, isMultiProduct: isMultiProduct, filters: filters }, additionalContext = {}, nonPrivacySafeAttributes = {
    query: ''
})=>{
    return {
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: actionSubjectId,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            activeProduct: activeProduct,
            isExpanded: isExpanded,
            isMultiProduct: isMultiProduct,
            filters: filters,
            ...timings,
            ...additionalContext
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $64fe155c5383b984$export$a8d299e4bdceb0be = ()=>({
        action: 'shown',
        eventType: 'ui',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: {
            resultCount: 0,
            results: []
        },
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE
    });
const $64fe155c5383b984$export$97e12e4b0f216b1d = ()=>{
    return {
        action: 'dismissed',
        actionSubject: 'searchDialog',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui'
    };
};
const $64fe155c5383b984$export$e79368bde551c62e = ({ visibleProducts: visibleProducts, visibleTabsCount: visibleTabsCount, isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown })=>{
    return {
        action: 'shown',
        actionSubject: 'searchDialog',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            visibleProducts: visibleProducts,
            visibleTabsCount: visibleTabsCount,
            isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown
        }
    };
};
const $64fe155c5383b984$export$9e2ba0ae72f48da8 = ({ filterType: filterType })=>{
    return {
        action: 'viewed',
        actionSubject: 'filterField',
        actionSubjectId: 'dropdownMenuFilterField',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterType: filterType
        }
    };
};
const $64fe155c5383b984$export$151951fdc112763c = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
    return {
        action: 'selected',
        actionSubject: 'filter',
        actionSubjectId: 'searchDialogFilter',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterId: filterId,
            filterType: filterType,
            filterSource: filterSource
        }
    };
};
const $64fe155c5383b984$export$f448c439d93613dd = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
    return {
        action: 'unselected',
        actionSubject: 'filter',
        actionSubjectId: 'searchDialogFilter',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterId: filterId,
            filterType: filterType,
            filterSource: filterSource
        }
    };
};
const $64fe155c5383b984$export$2e387d28788cf23b = ({ filterType: filterType })=>{
    return {
        action: 'cleared',
        actionSubject: 'filterField',
        actionSubjectId: 'searchDialogFilterField',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterType: filterType
        }
    };
};
const $64fe155c5383b984$export$e785b4d14ffa4348 = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'searchDialogClearFilters',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $64fe155c5383b984$export$8ba00734f8071933 = (product, duration)=>{
    return {
        action: 'loadComplete',
        actionSubject: 'searchDialogPane',
        actionSubjectId: product,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            durationMs: duration
        }
    };
};
const $64fe155c5383b984$export$d9576525adc921c1 = (abTest, experimentRequestDuration, isMultiProduct)=>{
    return {
        action: 'loaded',
        actionSubject: 'experiment',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'operational',
        attributes: {
            abTest: abTest,
            experimentRequestDuration: experimentRequestDuration,
            isMultiProduct: isMultiProduct
        }
    };
};
const $64fe155c5383b984$export$cb0c8d6d4bf862f8 = ({ tabName: tabName }, additionalContext = {}, nonPrivacySafeAttributes = {
    query: ''
})=>{
    // this event is fired at the same level as the anlytics context hence it needs mandatory additional objects.
    return {
        action: 'clicked',
        actionSubject: 'tab',
        actionSubjectId: 'crossProductSearchTab',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            tabName: tabName,
            ...additionalContext
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $64fe155c5383b984$export$e89c96d52a36944 = (authorised, product)=>{
    return {
        action: 'checked',
        actionSubject: 'thirdPartyAuth',
        actionSubjectId: product,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            authorised: authorised
        }
    };
};
const $64fe155c5383b984$export$a93c057f87e755b3 = (product)=>{
    return {
        action: 'authorised',
        actionSubject: 'thirdPartyProduct',
        actionSubjectId: product,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $64fe155c5383b984$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            ...attributes
        }
    });
const $64fe155c5383b984$var$position = (options, value)=>{
    return value ? options.findIndex((option)=>option.id === value.data.id) : -1;
};
const $64fe155c5383b984$var$result = (option)=>{
    return option ? $64fe155c5383b984$var$optionData2Analytics(option.data) : null;
};
const $64fe155c5383b984$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    return {
        id: id ? id : null,
        type: type || null
    };
};
const $64fe155c5383b984$var$createDefaultPickerAttributes = (fieldId, collabGraphSessionId)=>({
        context: fieldId,
        isCheckbox: true,
        queryLength: 0,
        collabGraphSessionId: collabGraphSessionId
    });
const $64fe155c5383b984$export$48143d759475d90f = (value, options, fieldId, collabGraphSessionId)=>{
    return $64fe155c5383b984$var$createEvent('ui', 'clicked', 'userPicker', {
        ...$64fe155c5383b984$var$createDefaultPickerAttributes(fieldId, collabGraphSessionId),
        position: $64fe155c5383b984$var$position(options, value),
        result: $64fe155c5383b984$var$result(value)
    });
};
const $64fe155c5383b984$export$73da5bde227e14d8 = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'recentSearch',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $64fe155c5383b984$export$1338fc4f37de8396 = ()=>{
    return {
        action: 'shown',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: 'prequeryBanner',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $64fe155c5383b984$export$e7721900a147b5b2 = (promptId)=>{
    return {
        action: 'clicked',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: promptId,
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $64fe155c5383b984$export$889f319cb696bfae = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: 'dismissButton',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $64fe155c5383b984$export$a7d90f29e3bc6f4f = (neverActive)=>{
    return {
        action: 'shown',
        actionSubject: 'nudge',
        actionSubjectId: 'confluenceReactivation',
        source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            touchpointId: 'search',
            neverActive: neverActive
        }
    };
};

});



parcelRegister("bONub", function(module, exports) {

$parcel$export(module.exports, "SITE_FILTER_TYPE_NAME", () => $86086a4870183521$export$f76bd7c689371575);
$parcel$export(module.exports, "DEFAULT_OPTION", () => $86086a4870183521$export$d3212964e526b51c);
$parcel$export(module.exports, "FilterUIVariant", () => $86086a4870183521$export$ab762b8071023de0);
$parcel$export(module.exports, "LastModifiedValues", () => $86086a4870183521$export$2a1fb5b806348bf0);
const $86086a4870183521$export$f76bd7c689371575 = 'sites';
const $86086a4870183521$export$d3212964e526b51c = 'default';
var $86086a4870183521$export$ab762b8071023de0 = /*#__PURE__*/ function(FilterUIVariant) {
    FilterUIVariant["CHECKBOX"] = "CHECKBOX";
    FilterUIVariant["STATIC_SELECT"] = "STATIC_SELECT";
    FilterUIVariant["MULTI_SELECT"] = "MULTI_SELECT";
    return FilterUIVariant;
}({});
var $86086a4870183521$export$2a1fb5b806348bf0 = /*#__PURE__*/ function(LastModifiedValues) {
    LastModifiedValues["DEFAULT"] = "default";
    LastModifiedValues["TODAY"] = "today";
    LastModifiedValues["YESTERDAY"] = "yesterday";
    LastModifiedValues["PAST_SEVEN_DAYS"] = "past7Days";
    LastModifiedValues["PAST_THIRTY_DAYS"] = "past30Days";
    LastModifiedValues["PAST_YEAR"] = "pastYear";
    return LastModifiedValues;
}({});

});

parcelRegister("kv2Va", function(module, exports) {

$parcel$export(module.exports, "ProductRouter", () => $0ccc3d4c76eeace6$export$36d5c2ec3fe68eef);
$parcel$export(module.exports, "useProductContext", () => $0ccc3d4c76eeace6$export$b5aab9e12d92574f);
$parcel$export(module.exports, "withProductContext", () => $0ccc3d4c76eeace6$export$a1f708a69696ca95);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6SBvm = parcelRequire("6SBvm");

var $i5cPn = parcelRequire("i5cPn");

var $8iCbm = parcelRequire("8iCbm");
const $0ccc3d4c76eeace6$var$ProductContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    getProduct: (id)=>undefined,
    getActiveProduct: ()=>undefined,
    getPrimaryProduct: ()=>undefined,
    addProduct: ()=>undefined,
    updateProduct: ()=>undefined,
    removeProduct: ()=>undefined,
    showProduct: ()=>undefined,
    getDefaultAIConfig: ()=>undefined,
    products: []
});
const $0ccc3d4c76eeace6$export$36d5c2ec3fe68eef = ({ primaryProduct: primaryProduct, __initialProducts: __initialProducts = (0, $8iCbm.INITIAL_STATE), children: children })=>{
    const [products, dispatch] = (0, $5uXOq.useReducer)((0, $8iCbm.reducer), __initialProducts);
    const { isExpanded: isExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isExpanded) dispatch({
            type: 'HIDE_ALL'
        });
    }, [
        isExpanded
    ]);
    const addProduct = (0, $5uXOq.useCallback)((payload)=>{
        return dispatch({
            type: 'ADD',
            payload: payload
        });
    }, [
        dispatch
    ]);
    const updateProduct = (0, $5uXOq.useCallback)((payload)=>{
        return dispatch({
            type: 'UPDATE',
            payload: payload
        });
    }, [
        dispatch
    ]);
    const removeProduct = (0, $5uXOq.useCallback)((id)=>{
        return dispatch({
            type: 'REMOVE',
            payload: {
                id: id
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * @function showProduct will ensure that only one product is displayed at a time
	 * @param {string} id - The product id which has to be made visible.
	 */ const showProduct = (0, $5uXOq.useCallback)((id)=>dispatch({
            type: 'SHOW',
            payload: {
                id: id
            }
        }), [
        dispatch
    ]);
    const getActiveProduct = (0, $5uXOq.useCallback)(()=>{
        return products.find((product)=>product.isDisplayed);
    }, [
        products
    ]);
    const productsRef = (0, $5uXOq.useRef)({});
    const getProduct = (0, $5uXOq.useCallback)((id)=>{
        const product = products.find((product)=>product.id === id);
        const productRef = productsRef.current[id];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6SBvm)))(product, productRef)) productsRef.current[id] = product;
        return productsRef.current[id];
    }, [
        products
    ]);
    const getPrimaryProduct = (0, $5uXOq.useCallback)(()=>{
        const nominatedPrimaryProduct = primaryProduct && getProduct(primaryProduct);
        const firstRegisteredProduct = products.length > 0 && products[0];
        return nominatedPrimaryProduct || firstRegisteredProduct || undefined;
    }, [
        getProduct,
        primaryProduct,
        products
    ]);
    const getDefaultAIConfig = (0, $5uXOq.useCallback)(()=>{
        const primaryProduct = getPrimaryProduct();
        if (primaryProduct?.aiSearchConfig) return primaryProduct.aiSearchConfig;
        else return products.filter((product)=>product.aiSearchConfig)[0]?.aiSearchConfig;
    }, [
        products,
        getPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0ccc3d4c76eeace6$var$ProductContext.Provider, {
        value: {
            getProduct: getProduct,
            getActiveProduct: getActiveProduct,
            getPrimaryProduct: getPrimaryProduct,
            addProduct: addProduct,
            updateProduct: updateProduct,
            removeProduct: removeProduct,
            showProduct: showProduct,
            products: products,
            getDefaultAIConfig: getDefaultAIConfig
        },
        children: children
    });
};
const $0ccc3d4c76eeace6$export$b5aab9e12d92574f = ()=>(0, $5uXOq.useContext)($0ccc3d4c76eeace6$var$ProductContext);
const $0ccc3d4c76eeace6$export$a1f708a69696ca95 = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            ...$0ccc3d4c76eeace6$export$b5aab9e12d92574f()
        });
};

});
parcelRegister("i5cPn", function(module, exports) {

$parcel$export(module.exports, "DialogExpansionContextProvider", () => $fc7cc3c84112fd09$export$4a9c91610a2bc03);
$parcel$export(module.exports, "useDialogExpansionContext", () => $fc7cc3c84112fd09$export$124a7aa8f9a7a608);
$parcel$export(module.exports, "withDialogExpansionContext", () => $fc7cc3c84112fd09$export$be366799d3426bb9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $fc7cc3c84112fd09$export$5d07de159ce5026c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    isExpanded: false,
    setIsExpanded: (isExpanded)=>{},
    allowChangeExpand: (expand)=>{}
});
const $fc7cc3c84112fd09$export$4a9c91610a2bc03 = ({ children: children, isExpanded: isExpanded, setIsExpanded: setIsExpanded })=>{
    const [changeExpand, setChangeExpand] = (0, $5uXOq.useState)(true);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fc7cc3c84112fd09$export$5d07de159ce5026c.Provider, {
        value: {
            isExpanded: isExpanded,
            setIsExpanded: changeExpand ? setIsExpanded : ()=>{},
            allowChangeExpand: setChangeExpand
        },
        children: children
    });
};
const $fc7cc3c84112fd09$export$124a7aa8f9a7a608 = ()=>{
    return (0, $5uXOq.useContext)($fc7cc3c84112fd09$export$5d07de159ce5026c);
};
const $fc7cc3c84112fd09$export$be366799d3426bb9 = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            ...$fc7cc3c84112fd09$export$124a7aa8f9a7a608()
        });
};

});

parcelRegister("8iCbm", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $7833e33069541c80$export$36d128238e6b60f5);
$parcel$export(module.exports, "reducer", () => $7833e33069541c80$export$1650419e431d3ba3);
const $7833e33069541c80$export$36d128238e6b60f5 = [];
const $7833e33069541c80$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case 'ADD':
            {
                const { payload: newProduct } = action;
                return $7833e33069541c80$export$7caf006d7b64ee15(state, newProduct);
            }
        case 'UPDATE':
            {
                const { payload: updatePayload } = action;
                return $7833e33069541c80$export$8d590d0c8872145e(state, updatePayload);
            }
        case 'SHOW':
            {
                const productIdToShow = action.payload.id;
                return $7833e33069541c80$export$821c121fea76e4f5(state, productIdToShow);
            }
        case 'REMOVE':
            {
                const productIdToRemove = action.payload.id;
                return $7833e33069541c80$export$86a330d9a979afdd(state, productIdToRemove);
            }
        case 'HIDE_ALL':
            return $7833e33069541c80$export$b6d3947c481ec009(state);
        default:
            return state;
    }
};
function $7833e33069541c80$export$7caf006d7b64ee15(products, addPayload) {
    // Check that new product id does not exist already
    if (products.filter((product)=>product.id === addPayload.id).length) return products;
    // Show error in console when duplicate order is added
    const duplicateOrder = products.find(({ order: order })=>order === addPayload.order);
    if (duplicateOrder) // eslint-disable-next-line no-console
    console.error(`product-search-dialog: Duplicate order of ${addPayload.order} has been set for the products of ${duplicateOrder.id} and ${addPayload.id}`);
    // Add product to state and maintain sorted array using order
    const newProduct = {
        ...addPayload,
        isDisplayed: false
    };
    const unsorted = [
        ...products,
        newProduct
    ];
    const sorted = unsorted.sort((a, b)=>a.order - b.order);
    return sorted;
}
function $7833e33069541c80$export$8d590d0c8872145e(products, updatePayload) {
    const productToUpdate = products.find((p)=>p.id === updatePayload.id);
    if (!productToUpdate) throw new Error(`Cannot update ${updatePayload.id} before being added`);
    const validUpdateKeys = [
        'generateAdvancedSearchUrl',
        'tabRenderer'
    ];
    const validUpdatePayload = Object.fromEntries(Object.entries(updatePayload).filter(([key])=>validUpdateKeys.includes(key)));
    Object.assign(productToUpdate, validUpdatePayload);
    return products;
}
function $7833e33069541c80$export$821c121fea76e4f5(products, productIdToShow) {
    return products.map((product)=>({
            ...product,
            isDisplayed: product.id === productIdToShow
        }));
}
function $7833e33069541c80$export$86a330d9a979afdd(products, productIdToRemove) {
    return products.filter((product)=>product.id !== productIdToRemove);
}
function $7833e33069541c80$export$b6d3947c481ec009(products) {
    return products.map((product)=>({
            ...product,
            isDisplayed: false
        }));
}

});



parcelRegister("e17vR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $53c844f08b6ae79b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $53c844f08b6ae79b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Bitbucket
	 */ bitbucket_repository_heading: {
        id: 'product_search_dialog.bitbucket.repository_heading',
        defaultMessage: 'Repositories',
        description: ''
    },
    bitbucket_advanced_search: {
        id: 'product_search_dialog.bitbucket.bitbucket_advanced_search',
        defaultMessage: 'Search for code in {source}',
        description: ''
    },
    bitbucket_repositories_section_title: {
        id: 'product_search_dialog.bitbucket.bitbucket_repositories_section_title',
        defaultMessage: 'Repositories',
        description: ''
    },
    bitbucket_recent_repositories: {
        id: 'product_search_dialog.bitbucket.bitbucket_recent_repositories',
        defaultMessage: 'Recently updated repositories',
        description: ''
    },
    bitbucket_expanded_input_placeholder: {
        id: 'product_search_dialog.bitbucket.expanded.input-placeholder',
        defaultMessage: 'Search Bitbucket',
        description: 'The placeholder which is visible to the user when bitbucket tab is active '
    }
});

});

parcelRegister("k4hbD", function(module, exports) {

$parcel$export(module.exports, "commentedEventTypeMessages", () => $ed77fbf192bbe6bf$export$29c048cc57fefaf8);
$parcel$export(module.exports, "createdEventTypeMessages", () => $ed77fbf192bbe6bf$export$99e7e287b0f1db7);
$parcel$export(module.exports, "editedEventTypeMessages", () => $ed77fbf192bbe6bf$export$4d0c20aef6601783);
$parcel$export(module.exports, "publishedEventTypeMessages", () => $ed77fbf192bbe6bf$export$2cd1ec4decb563bb);
$parcel$export(module.exports, "updatedEventTypeMessages", () => $ed77fbf192bbe6bf$export$3b389551d0b5bf03);
$parcel$export(module.exports, "viewedEventTypeMessages", () => $ed77fbf192bbe6bf$export$2d3fe6e7f84a868e);
$parcel$export(module.exports, "defaultEventTypeMessages", () => $ed77fbf192bbe6bf$export$9be55d016b768442);
$parcel$export(module.exports, "messages", () => $ed77fbf192bbe6bf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ed77fbf192bbe6bf$export$29c048cc57fefaf8 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You commented on {date}',
        description: 'action taken on this object with absolute timestamp - comment added',
        id: 'recentWork.eventTypeMessage.absolute.commented'
    },
    relative: {
        defaultMessage: 'You commented {date}',
        description: 'action taken by the user on this object with relative timestamp - comment added',
        id: 'recentWork.eventTypeMessage.relative.commented'
    }
});
const $ed77fbf192bbe6bf$export$99e7e287b0f1db7 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You created on {date}',
        description: 'action taken by the user on this object with absolute timestamp - initially created',
        id: 'recentWork.eventTypeMessage.absolute.created'
    },
    relative: {
        defaultMessage: 'You created {date}',
        description: 'action taken by the user on this object with relative timestamp - initially created',
        id: 'recentWork.eventTypeMessage.relative.created'
    }
});
const $ed77fbf192bbe6bf$export$4d0c20aef6601783 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You edited on {date}',
        description: 'action taken by the user on this object with absolute timestamp - edited',
        id: 'recentWork.eventTypeMessage.absolute.edited'
    },
    relative: {
        defaultMessage: 'You edited {date}',
        description: 'action taken by the user on this object with relative timestamp - edited',
        id: 'recentWork.eventTypeMessage.relative.edited'
    }
});
const $ed77fbf192bbe6bf$export$2cd1ec4decb563bb = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You published on {date}',
        description: 'action taken by the user on this object with absolute timestamp - published',
        id: 'recentWork.eventTypeMessage.absolute.published'
    },
    relative: {
        defaultMessage: 'You published {date}',
        description: 'action taken by the user on this object with relative timestamp - published',
        id: 'recentWork.eventTypeMessage.relative.published'
    }
});
const $ed77fbf192bbe6bf$export$3b389551d0b5bf03 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You updated on {date}',
        description: 'action taken by the user on this object with absolute timestamp - updated',
        id: 'recentWork.eventTypeMessage.absolute.updated'
    },
    relative: {
        defaultMessage: 'You updated {date}',
        description: 'action taken by the user on this object with relative timestamp - updated',
        id: 'recentWork.eventTypeMessage.relative.updated'
    }
});
const $ed77fbf192bbe6bf$export$2d3fe6e7f84a868e = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You viewed on {date}',
        description: 'action taken by the user on this object with absolute timestamp - viewed',
        id: 'recentWork.eventTypeMessage.absolute.viewed'
    },
    relative: {
        defaultMessage: 'You viewed {date}',
        description: 'action taken by the user on this object with relative timestamp - viewed',
        id: 'recentWork.eventTypeMessage.relative.viewed'
    }
});
const $ed77fbf192bbe6bf$export$9be55d016b768442 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You worked on {date}',
        description: 'action taken by the user on this object with an absolute or relative date/time - worked on',
        id: 'recentWork.eventTypeMessage.absolute.workedOn'
    },
    relative: {
        defaultMessage: 'You worked on {date}',
        description: 'action taken by the user on this object with an absolute or relative date/time - worked on',
        id: 'recentWork.eventTypeMessage.absolute.workedOn'
    }
});
const $ed77fbf192bbe6bf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Product-agnostic messages
	 */ common_updated_date_formatter: {
        id: 'product_search_dialog.updated_date_formatter',
        defaultMessage: 'Updated {date}',
        description: 'A text shown next to the date for the search results.'
    },
    common_recently_viewed_section_heading: {
        id: 'product_search_dialog.recently_viewed_section_heading',
        defaultMessage: 'Recently viewed',
        description: ''
    },
    common_recently_spaces_section_heading: {
        id: 'product_search_dialog.recent_spaces_section_heading',
        defaultMessage: 'Recent spaces',
        description: ''
    },
    common_recently_worked_with_section_heading: {
        id: 'product_search_dialog.recently_worked_with_section_heading',
        defaultMessage: 'Recently worked with',
        description: ''
    },
    common_error_state_failed_search_heading: {
        id: 'product_search_dialog.error.failed_loading_search_heading',
        defaultMessage: "We're having trouble loading your recently viewed content.",
        description: ''
    },
    common_error_state_failed_search_body: {
        id: 'product_search_dialog.error.failed_loading_search_body',
        defaultMessage: 'It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>',
        description: ''
    },
    common_empty_state_heading: {
        id: 'product_search_dialog.empty.no_results_heading',
        defaultMessage: "We couldn't find anything matching your search.",
        description: ''
    },
    common_empty_state_prequery_heading: {
        id: 'product_search_dialog.empty_prequery.no_results_heading',
        defaultMessage: 'Search for what you need',
        description: ''
    },
    common_error_state_prequery_heading: {
        id: 'product_search_dialog.empty_prequery.error_heading',
        defaultMessage: 'Something went wrong with showing initial results',
        description: ''
    },
    common_show_more_results_link: {
        id: 'product_search_dialog.show_more_results_link',
        defaultMessage: 'Show more',
        description: ''
    },
    common_show_all_results_link: {
        id: 'product_search_dialog.show_all_results_link',
        defaultMessage: 'View all results',
        description: ''
    },
    common_search_people_link: {
        id: 'product_search_dialog.search_people_link',
        defaultMessage: 'Search people',
        description: ''
    },
    common_search_input_collapsed_placeholder: {
        id: 'product_search_dialog.search_input_collapsed_placeholder',
        defaultMessage: 'Search',
        description: ''
    },
    common_search_input_enlarged_aria_label: {
        id: 'product_search_dialog.search_input_enlarged_aria_label',
        defaultMessage: 'Press enter to navigate to advanced search',
        description: 'used for accessibility for the EnlargedSearchInput component'
    },
    common_empty_state_body: {
        id: 'product_search_dialog.empty.no_results_body',
        defaultMessage: 'Try again with a different term, or refine your results with <a>Advanced Search</a>',
        description: ''
    },
    common_empty_state_body_no_advanced_search: {
        id: 'product_search_dialog.empty.no_results_body_with_no_advanced_search',
        defaultMessage: 'Try again with a different term.',
        description: ''
    },
    common_give_feedback: {
        id: 'product_search_dialog.give_feedback',
        defaultMessage: 'Give feedback',
        description: 'Button that looks like a link that the user clicks to open a dialog to give feedback about search'
    },
    common_inline_onboarding_title: {
        id: 'product_search_dialog.inline_onboarding_title',
        defaultMessage: 'Search across Jira and Confluence',
        description: 'Heading of the inline section message which educates first time users about cross product search tabs'
    },
    common_inline_onboarding_body: {
        id: 'product_search_dialog.inline_onboarding_body',
        defaultMessage: 'Use the Jira and Confluence tabs to search and see recent items in either location.',
        description: 'Description of the inline section message which educates first time users about cross product search tabs'
    },
    common_inline_onboarding_action: {
        id: 'product_search_dialog.inline_onboarding_action',
        defaultMessage: 'Ok',
        description: 'A button that looks like a link which suspends the section message.'
    },
    common_search_input_exit_button_label: {
        id: 'search_dialog.search_input_exit_label',
        defaultMessage: 'Exit Search',
        description: 'Label for the back button to exit search'
    },
    common_search_input_clear_button_label: {
        id: 'search_dialog.search_input_clear_label',
        defaultMessage: 'Clear search session',
        description: 'Label for the x button to clear the search input'
    },
    multi_site_advanced_search_label: {
        id: 'product_search_dialog.multi_site_advanced_search_label',
        defaultMessage: 'Search on:',
        description: 'Label for a list of site links in advanced search'
    },
    multi_site_advanced_search_more_dropdown: {
        id: 'product_search_dialog.multi_site_advanced_search_more_dropdown',
        defaultMessage: '{count} more',
        description: 'A dropdown which opens a list of links to sites to advanced search in'
    },
    common_autocorrection_label: {
        id: 'product_search_dialog.autocorrection.label',
        defaultMessage: 'Did you mean',
        description: 'Label text for the autocorrection component'
    },
    /**
	 * Cross product
	 */ jira_tab_label: {
        id: 'cross_product_search_dialog.jira.tab_label',
        defaultMessage: 'Jira',
        description: ''
    },
    confluence_tab_label: {
        id: 'cross_product_search_dialog.confluence.tab_label',
        defaultMessage: 'Confluence',
        description: ''
    },
    atlas_tab_label: {
        id: 'cross_product_search_dialog.atlas.tab_label',
        defaultMessage: 'Atlas',
        description: 'The name of the Atlas product'
    },
    bitbucket_tab_label: {
        id: 'cross_product_search_dialog.bitbucket.tab_label',
        defaultMessage: 'Bitbucket',
        description: ''
    },
    opsgenie_tab_label: {
        id: 'cross_product_search_dialog.opsgenie.tab_label',
        defaultMessage: 'Opsgenie',
        description: ''
    },
    trello_tab_label: {
        id: 'cross_product_search_dialog.trello.tab_label',
        defaultMessage: 'Trello',
        description: ''
    },
    view_all_results_link: {
        id: 'cross_product_search_dialog.view_all_results_link',
        defaultMessage: 'View all {sectionTitle}',
        description: ''
    },
    recently_viewed_title: {
        id: 'cross_product_search_dialog.recently_viewed_title',
        defaultMessage: 'Recently Viewed {sectionTitle}',
        description: ''
    },
    /**
	 * Common Confluence Messages
	 */ confluence_people_section_heading: {
        id: 'product_search_dialog.confluence.people_section_heading',
        defaultMessage: 'People',
        description: ''
    },
    confluence_content_section_heading: {
        id: 'product_search_dialog.confluence.content_section_heading',
        defaultMessage: 'Content',
        description: 'Section label for pages, blogs, attachments, and whiteboards in quick search dialog'
    },
    confluence_spaces_section_heading: {
        id: 'product_search_dialog.confluence.spaces_section_heading',
        defaultMessage: 'Spaces',
        description: ''
    },
    confluence_search_input_expanded_placeholder: {
        id: 'product_search_dialog.confluence.search_input_expanded_placeholder',
        defaultMessage: 'Search Confluence',
        description: ''
    },
    confluence_search_input_expanded_placeholder_ai: {
        id: 'product_search_dialog.confluence.search_input_expanded_placeholder_ai',
        defaultMessage: 'Search or ask questions within your Confluence',
        description: ''
    },
    confluence_pages_blogs_attachments_section_heading: {
        id: 'product_search_dialog.confluence.pages_blogs_attachments_section_heading',
        defaultMessage: 'Pages, blogs and attachments',
        description: ''
    },
    /**
	 * Common Filtering Messages
	 */ filters_applied: {
        id: 'product_search_dialog.confluence.filters_applied',
        defaultMessage: 'Looks like you have some filters applied',
        description: 'Message to show when there are no search results due to filters being applied'
    },
    clear_filters: {
        id: 'product_search_dialog.confluence.clear_filters',
        defaultMessage: 'Clear filters',
        description: 'Message to be displayed on button to clear the filters applied'
    },
    show_more_filters: {
        id: 'search_dialog.filters.group.show-more',
        defaultMessage: 'Show more',
        description: 'Text display on button to select more items to filter by'
    },
    more_filters: {
        id: 'product_search_dialog.more_filters',
        defaultMessage: 'View all filters',
        description: 'Clicking on this link takes a user to a page with more filters and options.'
    },
    no_options_filters: {
        id: 'product_search_dialog.no_options_filters',
        defaultMessage: 'No options',
        description: 'Message to show when no results are returned when filtering'
    },
    loading_filters: {
        id: 'product_search_dialog.loading_filters',
        defaultMessage: 'Loading',
        description: 'Message to show when filter results are loading'
    },
    site_filters_title: {
        id: 'product_search_dialog.common.site_filters',
        defaultMessage: 'Filter by site',
        description: 'Section title for site filters'
    },
    space_filters_title: {
        id: 'product_search_dialog.confluence.space_filters',
        defaultMessage: 'Filter by space',
        description: 'Section title for space filters in Confluence'
    },
    contributor_filters_title: {
        id: 'product_search_dialog.confluence.contributor_filters',
        defaultMessage: 'Filter by contributor',
        description: 'Section title for contributor filters in Confluence'
    },
    contributor_filters_find_more: {
        id: 'product_search_dialog.confluence.contributor_filters_find_more',
        defaultMessage: 'Find a contributor',
        description: 'Placeholder text for select menu when finding a contributor to filter results by'
    },
    space_filters_find_more: {
        id: 'product_search_dialog.confluence.space_filters_find_more',
        defaultMessage: 'Find a space',
        description: 'Placeholder text for select menu when finding a space to filter results by'
    },
    site_filters_find_more: {
        id: 'product_search_dialog.jira.site_filters_find_more',
        defaultMessage: 'Find a site',
        description: 'Placeholder text for select menu when finding a site to filter results by'
    },
    project_filters_find_more: {
        id: 'product_search_dialog.jira.project_filters_find_more',
        defaultMessage: 'Find a project',
        description: 'Placeholder text for select menu when finding a project to filter results by'
    },
    project_filters_title: {
        id: 'product_search_dialog.jira.project_filters',
        defaultMessage: 'Filter by project',
        description: 'Section title for project filters in Jira'
    },
    assignee_filters_find_more: {
        id: 'product_s earch_dialog.confluence.assignee_filters_find_more',
        defaultMessage: 'Find an assignee',
        description: 'Placeholder text for select menu when finding a assignee to filter results by'
    },
    assignee_filters_title: {
        id: 'product_search_dialog.jira.assignee_filters',
        defaultMessage: 'Filter by assignee',
        description: 'Section title for assignee filters in Jira'
    },
    binary_status_category_filters_title: {
        id: 'product_search_dialog.jira.issue_filters',
        defaultMessage: 'Filter by status',
        description: 'Section title for issue filters in Jira'
    },
    binary_status_category_filter_option_done: {
        id: 'product_search_dialog.jira.issue_filter_done',
        defaultMessage: 'Done',
        description: 'Filter option title for done issues'
    },
    binary_status_category_filter_option_open: {
        id: 'product_search_dialog.jira.issue_filter_open',
        defaultMessage: 'Open',
        description: 'Filter option title for open issues'
    },
    date_filter_any_time_label: {
        id: 'product_search_dialog.jira.date_filter_any',
        defaultMessage: 'Any time',
        description: 'Date filter label for any time.'
    },
    date_filter_filters_title: {
        id: 'product_search_dialog.jira.date_filters',
        defaultMessage: 'Last updated',
        description: 'Section title for date filters in Jira'
    },
    /**
	 * Common Jira Messages
	 */ jira_advanced_search_label: {
        id: 'global_search.jira.advanced_search_label',
        defaultMessage: 'Go to all:',
        description: ''
    },
    jira_advanced_search_issues: {
        id: 'global_search.jira.advanced_search_issues',
        defaultMessage: 'Issues',
        description: 'Plural of issue'
    },
    jira_advanced_search_projects: {
        id: 'global_search.jira.advanced_search_projects',
        defaultMessage: 'Projects',
        description: 'Plural of project'
    },
    jira_advanced_search_boards: {
        id: 'global_search.jira.advanced_search_boards',
        defaultMessage: 'Boards',
        description: 'Plural of board'
    },
    jira_advanced_search_filters: {
        id: 'global_search.jira.advanced_search_filters',
        defaultMessage: 'Filters',
        description: 'Plural of filter'
    },
    jira_advanced_search_plans: {
        id: 'global_search.jira.advanced_search_plans',
        defaultMessage: 'Plans',
        description: 'Plural of plan'
    },
    jira_advanced_search_people: {
        id: 'global_search.jira.advanced_search_people',
        defaultMessage: 'People',
        description: ''
    },
    jira_empty_state_prequery_heading: {
        id: 'product_search_dialog.jira.empty_prequery.no_results_heading',
        defaultMessage: 'Start searching to find your work',
        description: 'This message is shown when the user has no recently viewed issues and has not yet typed a search query'
    },
    jira_issues_section_heading: {
        id: 'product_search_dialog.jira.issues_section_heading',
        defaultMessage: 'Issues',
        description: ''
    },
    jira_boards_projects_filters_section_heading: {
        id: 'product_search_dialog.jira.boards_projects_filters_section_heading',
        defaultMessage: 'Boards, Projects and Filters',
        description: ''
    },
    jira_projects_filters_section_heading: {
        id: 'product_search_dialog.jira.projects_filters_section_heading',
        defaultMessage: 'Projects and Filters',
        description: ''
    },
    jira_boards_projects_filters_plans_section_heading: {
        id: 'product_search_dialog.jira.boards_projects_filters_plans_section_heading',
        defaultMessage: 'Boards, Projects, Filters and Plans',
        description: 'Title for search results of Jira entities (Boards, Projects, Filters, and Plans)'
    },
    jira_view_all_issues_new: {
        id: 'product_search_dialog.jira.jira_view_all_issues_new',
        defaultMessage: 'View all issues',
        description: 'Text for link that takes users to advanced search for issues - renamed from "Advanced issue search"'
    },
    jira_recent_boards_projects_filters_section_heading: {
        id: 'product_search_dialog.jira.recent_boards_projects_filters_section_heading',
        defaultMessage: 'Recent Boards, Projects and Filters',
        description: ''
    },
    jira_recent_projects_filters_section_heading: {
        id: 'product_search_dialog.jira.recent_projects_filters_section_heading',
        defaultMessage: 'Recent Projects and Filters',
        description: ''
    },
    jira_recent_boards_projects_filters_plans_section_heading: {
        id: 'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading',
        defaultMessage: 'Recent Boards, Projects, Filters and Plans',
        description: 'Title for recently accessed Jira entities (Boards, Projects, Filters, and Plans)'
    },
    jira_recently_viewed_issues_section_heading: {
        id: 'product_search_dialog.jira.recently_viewed_issues_section_heading',
        defaultMessage: 'Recently viewed issues',
        description: ''
    },
    jira_search_placeholder: {
        id: 'global_search.jira.search_placeholder',
        defaultMessage: 'Search Jira',
        description: 'Search field placeholder when the Jira tab is active'
    },
    jira_search_placeholder_experiment_jsw_enabled: {
        id: 'global_search.jira.search_placeholder_experiment_jsw_enabled',
        defaultMessage: 'Search for issues, boards, projects, and filters',
        description: 'Search field placeholder when the Jira tab is active and the user has a JSW license but no access to advanced roadmaps'
    },
    jira_advanced_search_issuesIssueTermRefresh: {
        id: 'global_search.jira.advanced_search_issues-issue-term-refresh',
        defaultMessage: 'Work items',
        description: 'Plural of issue'
    },
    jira_issues_section_headingIssueTermRefresh: {
        id: 'product_search_dialog.jira.issues_section_heading-issue-term-refresh',
        defaultMessage: 'Work items',
        description: ''
    },
    jira_view_all_issues_newIssueTermRefresh: {
        id: 'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh',
        defaultMessage: 'View all work items',
        description: 'Text for link that takes users to advanced search for issues - renamed from "Advanced issue search"'
    },
    jira_recently_viewed_issues_section_headingIssueTermRefresh: {
        id: 'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh',
        defaultMessage: 'Recently viewed work items',
        description: ''
    },
    jira_search_placeholder_experiment_jsw_enabledIssueTermRefresh: {
        id: 'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh',
        defaultMessage: 'Search for work items, boards, projects, and filters',
        description: 'Search field placeholder when the Jira tab is active and the user has a JSW license but no access to advanced roadmaps'
    }
});

});

parcelRegister("cxU5p", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearch", () => $a580255cf910629e$export$2709da4acd7d0aec);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cIQMR = parcelRequire("cIQMR");
var $fYvdU = parcelRequire("fYvdU");

var $26g7Y = parcelRequire("26g7Y");

var $8oG5R = parcelRequire("8oG5R");
var $3FqY6 = parcelRequire("3FqY6");
var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");

var $8TPno = parcelRequire("8TPno");
var $hN1kQ = parcelRequire("hN1kQ");

var $kv2Va = parcelRequire("kv2Va");

var $2dI5H = parcelRequire("2dI5H");

var $dV2Gy = parcelRequire("dV2Gy");
const $a580255cf910629e$var$onKeyDown = (e, target, actionSubjectId, fireAnalyticsEvent)=>{
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        fireAnalyticsEvent((0, $3FqY6.onAdvancedSearchSelected)({
            trigger: (0, $3FqY6.Trigger).RETURN,
            actionSubjectId: actionSubjectId,
            isLoading: false,
            newTab: false
        }));
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $a580255cf910629e$export$2709da4acd7d0aec = ({ advancedSearchMessage: advancedSearchMessage, advancedSearchUrl: advancedSearchUrl, linkComponent: linkComponent })=>{
    const { isLoading: isLoading } = (0, $2dI5H.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const productName = getActiveProduct()?.title;
    const actionSubjectId = `${productName}AdvancedSearchLink`;
    const onAdvancedSearchClicked = (0, $5uXOq.useCallback)((e)=>{
        fireAnalyticsEvent((0, $3FqY6.onAdvancedSearchSelected)({
            trigger: (0, $8oG5R.getTrigger)(e),
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: (0, $8oG5R.isNewTab)(e)
        }));
    }, [
        fireAnalyticsEvent,
        actionSubjectId,
        isLoading
    ]);
    const [isKeyboardHighlighted, ref] = (0, $fYvdU.useKeyboardNavigation)({
        onKeydownCallback: (0, $5uXOq.useCallback)((e, target)=>$a580255cf910629e$var$onKeyDown(e, target, actionSubjectId, fireAnalyticsEvent), [
            actionSubjectId,
            fireAnalyticsEvent
        ])
    });
    if (!advancedSearchUrl || !advancedSearchMessage) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV2Gy.AdvancedSearchLinkWrapper), {
        ref: ref,
        onClick: onAdvancedSearchClicked,
        role: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hN1kQ.AdvancedSearchLink), {
            href: advancedSearchUrl,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8TPno.CenteredAdvancedSearchGroup), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
                            color: "currentColor",
                            LEGACY_size: "small",
                            label: advancedSearchMessage
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8TPno.AdvancedSearchContent), {
                            children: advancedSearchMessage
                        })
                    ]
                }),
                isKeyboardHighlighted && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cIQMR.ReturnIcon), {
                    inverted: isKeyboardHighlighted
                })
            ]
        })
    });
};

});
parcelRegister("cIQMR", function(module, exports) {

$parcel$export(module.exports, "ReturnIcon", () => $635887d47813f9b5$export$d6c38c54dfb7c9d5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

const $635887d47813f9b5$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    width: "24",
                    height: "16",
                    fill: inverted ? `var(--ds-background-neutral-bold, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})` : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
                    rx: "3"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fill: inverted ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`,
                    fillRule: "nonzero",
                    d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
                })
            ]
        })
    });

});

parcelRegister("fYvdU", function(module, exports) {

$parcel$export(module.exports, "useKeyboardNavigation", () => $f1d9337c6a7330cc$export$4da28cf324280418);
$parcel$export(module.exports, "KeyboardHighlightProvider", () => $f1d9337c6a7330cc$export$c8551b32665b42b);
$parcel$export(module.exports, "useKeyboardHighlightProvider", () => $f1d9337c6a7330cc$export$cbeda0f7f7a8026c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $f1d9337c6a7330cc$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $f1d9337c6a7330cc$export$4da28cf324280418 = (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const navigationTrackingId = options?.navigationTrackingId ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $5uXOq.useContext)($f1d9337c6a7330cc$export$ef7af5d8bc5d5ac1);
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const onKeydownCallback = options?.onKeydownCallback;
    const onHighlightedCallback = options?.onHighlightedCallback;
    const unregister = (0, $5uXOq.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $5uXOq.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $5uXOq.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $5uXOq.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
class $f1d9337c6a7330cc$export$c8551b32665b42b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.attach(this.props.listenerNode);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.listenerNode !== this.props.listenerNode) {
            this.detach(prevProps.listenerNode);
            this.attach(this.props.listenerNode);
        }
    }
    componentWillUnmount() {
        this.detach(this.props.listenerNode);
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)($f1d9337c6a7330cc$export$ef7af5d8bc5d5ac1.Provider, {
            value: {
                registerKeyboardEnabled: this.registerKeyboardEnabled,
                unregisterKeyboardEnabled: this.unregisterKeyboardEnabled,
                getSelectedIndex: this.getSelectedIndex,
                highlightComponentAt: this.highlightComponentAt,
                unhighlightComponentAt: this.unhighlightComponentAt,
                unhighlightAll: this.unhighlightAll,
                keyboardNavComponents: this.keyboardNavComponents
            },
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.currentlySelected = undefined, this.currentSelectedTrackingId = null, this.keyboardNavComponents = [], this.registerKeyboardEnabled = (currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCallback)=>{
            const indexAt = this.keyboardNavComponents.findIndex(({ id: id })=>id === currentId);
            // If the currentId is null or we can't find any records of the id we will create a new entry
            const isNew = currentId === null || currentId === undefined || indexAt === -1;
            const id = isNew ? Math.max(...this.keyboardNavComponents.map((component)=>component.id), 0) + 1 : this.keyboardNavComponents[indexAt].id;
            if (isNew) this.keyboardNavComponents.push({
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            });
            else // Otherwise we will update the current entry
            this.keyboardNavComponents[indexAt] = {
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            };
            this.keyboardNavComponents = this.keyboardNavComponents.sort((c1, c2)=>{
                const result = c1.domRef.compareDocumentPosition(c2.domRef);
                if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
                else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
                return 0;
            });
            const indexToHighlight = this.getSearchIdIndex(this.currentSelectedTrackingId);
            if (indexToHighlight !== undefined && indexToHighlight >= 0) {
                this.unhighlightAll();
                this.highlightComponentAt(indexToHighlight);
            }
            this.keyboardNavComponents = [
                ...this.keyboardNavComponents
            ];
            return id;
        }, this.unregisterKeyboardEnabled = (unregisterRef)=>{
            if (this.currentlySelected === unregisterRef) this.currentlySelected = undefined;
            this.keyboardNavComponents = this.keyboardNavComponents.filter(({ id: ref })=>ref !== unregisterRef);
        }, this.onKeyDownCallbackAt = (index, e)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const onKeyDown = this.keyboardNavComponents[index].onKeyDownWhenHighlighted;
                onKeyDown && onKeyDown(e, this.keyboardNavComponents[index].domRef);
            }
        }, this.onHighlightedCallback = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const callback = this.keyboardNavComponents[index].onHighlightedCallback;
                callback && callback(index);
            }
        }, this.unhighlightComponentAt = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) this.keyboardNavComponents[index].onHighlightChanged(false);
        }, this.highlightComponentAt = (index)=>{
            if (index >= 0 && index < this.keyboardNavComponents.length) {
                const { id: id, navigationTrackingId: navigationTrackingId } = this.keyboardNavComponents[index];
                this.currentlySelected = id;
                this.currentSelectedTrackingId = navigationTrackingId;
                this.keyboardNavComponents[index].onHighlightChanged(true);
            }
        }, this.unhighlightAll = ()=>{
            this.currentSelectedTrackingId = null;
            this.currentlySelected = undefined;
            this.keyboardNavComponents.forEach((component)=>component.onHighlightChanged(false));
        }, this.getSelectedIndex = ()=>{
            if (!this.currentlySelected) return undefined;
            return this.keyboardNavComponents.findIndex(({ id: id })=>id === this.currentlySelected);
        }, this.getSearchIdIndex = (searchId)=>searchId === null ? undefined : this.keyboardNavComponents.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), this.onKeyDown = (e)=>{
            if (this.keyboardNavComponents.length === 0) return;
            if (e.isComposing || e.keyCode === 229) return;
            let currentIndex = this.getSelectedIndex();
            const prevIndex = currentIndex;
            if (e.code === 'ArrowDown' || e.keyCode === 40) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = 0;
                    else currentIndex = (currentIndex + 1) % this.keyboardNavComponents.length;
                    e.preventDefault();
                }
            } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = this.keyboardNavComponents.length - 1;
                    else {
                        currentIndex -= 1;
                        if (currentIndex < 0) currentIndex = this.keyboardNavComponents.length - Math.abs(currentIndex);
                    }
                    e.preventDefault();
                }
            } else {
                if (typeof currentIndex !== 'undefined') this.onKeyDownCallbackAt(currentIndex, e);
                return;
            }
            if (prevIndex !== currentIndex && currentIndex !== undefined) {
                this.unhighlightComponentAt(prevIndex);
                this.highlightComponentAt(currentIndex);
                this.onHighlightedCallback(currentIndex);
            }
        }, this.attach = (listenerNode)=>{
            if (listenerNode) listenerNode.addEventListener('keydown', this.onKeyDown);
        }, this.detach = (listenerNode)=>{
            if (listenerNode) listenerNode.removeEventListener('keydown', this.onKeyDown);
        };
    }
}
const $f1d9337c6a7330cc$export$cbeda0f7f7a8026c = ()=>{
    return (0, $5uXOq.useContext)($f1d9337c6a7330cc$export$ef7af5d8bc5d5ac1);
};

});

parcelRegister("8oG5R", function(module, exports) {

$parcel$export(module.exports, "sha256Hash", () => $b98021c2bc89ec3c$export$e9131c78c1110376);
$parcel$export(module.exports, "getTrigger", () => $b98021c2bc89ec3c$export$670ec347a1a78e34);
$parcel$export(module.exports, "isNewTab", () => $b98021c2bc89ec3c$export$dfd8482ecf3b52d8);
$parcel$export(module.exports, "getWordCount", () => $b98021c2bc89ec3c$export$dba3e2bcdbd49da4);

var $3FqY6 = parcelRequire("3FqY6");

var $gvK9N = parcelRequire("gvK9N");
const $b98021c2bc89ec3c$export$e9131c78c1110376 = (str)=>(0, (/*@__PURE__*/$parcel$interopDefault($gvK9N))).createHash('sha256').update(str).digest('hex');
const $b98021c2bc89ec3c$export$670ec347a1a78e34 = (e)=>{
    if (e instanceof KeyboardEvent) return (0, $3FqY6.Trigger).RETURN;
    return e.screenX === 0 ? (0, $3FqY6.Trigger).RETURN : (0, $3FqY6.Trigger).CLICK;
};
const $b98021c2bc89ec3c$export$dfd8482ecf3b52d8 = (e)=>{
    return !!(e && (e.metaKey || e.ctrlKey || e.shiftKey));
};
const $b98021c2bc89ec3c$export$dba3e2bcdbd49da4 = (str)=>{
    return str.length > 0 ? str.split(/\s+/).length : 0;
};

});
parcelRegister("gvK9N", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $c053586507d63757$export$5f828d93ff035aa8, (v) => $c053586507d63757$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $c053586507d63757$export$cd94982b18c6332c, (v) => $c053586507d63757$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $c053586507d63757$export$1d518568e4f529b0, (v) => $c053586507d63757$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $c053586507d63757$export$5285b6d41c912b41, (v) => $c053586507d63757$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $c053586507d63757$export$2fb37efbf6ae0c0e, (v) => $c053586507d63757$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $c053586507d63757$export$ab85ecd77ce6a5cd, (v) => $c053586507d63757$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $c053586507d63757$export$da39cf97e1eb7c91, (v) => $c053586507d63757$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $c053586507d63757$export$52a9039d7177394f, (v) => $c053586507d63757$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $c053586507d63757$export$f7201db400317331, (v) => $c053586507d63757$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $c053586507d63757$export$448fa22aedc9dbca, (v) => $c053586507d63757$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $c053586507d63757$export$b80c7ba289c8fa56, (v) => $c053586507d63757$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $c053586507d63757$export$26e5786e8ac8e530, (v) => $c053586507d63757$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $c053586507d63757$export$bdd223f16383713e, (v) => $c053586507d63757$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $c053586507d63757$export$20533d26f07f1ee0, (v) => $c053586507d63757$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $c053586507d63757$export$2f64596b8cbf08b4, (v) => $c053586507d63757$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $c053586507d63757$export$2ce6d8d0e8b04e1a, (v) => $c053586507d63757$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $c053586507d63757$export$12ada9414fbc594c, (v) => $c053586507d63757$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $c053586507d63757$export$f5e7e39d57cd9700, (v) => $c053586507d63757$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $c053586507d63757$export$36b6d6ef312eab39, (v) => $c053586507d63757$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $c053586507d63757$export$58a258485f1e49f6, (v) => $c053586507d63757$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $c053586507d63757$export$dedd8dc3dc62b370, (v) => $c053586507d63757$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $c053586507d63757$export$971862a2fcb1bb40, (v) => $c053586507d63757$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $c053586507d63757$export$c6ff6a88acbeaf40, (v) => $c053586507d63757$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $c053586507d63757$export$fdc27893e98845cc, (v) => $c053586507d63757$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $c053586507d63757$export$6671fb9a1323bed, (v) => $c053586507d63757$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $c053586507d63757$export$d74daf141a551db, (v) => $c053586507d63757$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $c053586507d63757$export$45df7cae684751af, (v) => $c053586507d63757$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $c053586507d63757$export$1db683ad541682f6, (v) => $c053586507d63757$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $c053586507d63757$export$6f65485f87568e37, (v) => $c053586507d63757$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $c053586507d63757$export$91a8e56769aeb334, (v) => $c053586507d63757$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $c053586507d63757$export$2d4117e99c2179e4, (v) => $c053586507d63757$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $c053586507d63757$export$512823e338ddb1b7, (v) => $c053586507d63757$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $c053586507d63757$export$9d0e0c0c4a8d30f3, (v) => $c053586507d63757$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $c053586507d63757$export$b9d55ff329113abd, (v) => $c053586507d63757$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $c053586507d63757$export$7efb24e2fddf99b9, (v) => $c053586507d63757$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $c053586507d63757$export$bb1abf2ce84fc7e8, (v) => $c053586507d63757$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $c053586507d63757$export$2f7171e78e524d5e, (v) => $c053586507d63757$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $c053586507d63757$export$e1d879b482f37d98, (v) => $c053586507d63757$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $c053586507d63757$export$1a988e7317c65621, (v) => $c053586507d63757$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $c053586507d63757$export$5f828d93ff035aa8;
var $c053586507d63757$export$cd94982b18c6332c;
var $c053586507d63757$export$1d518568e4f529b0;
var $c053586507d63757$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $c053586507d63757$export$2fb37efbf6ae0c0e;
var $c053586507d63757$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $c053586507d63757$export$da39cf97e1eb7c91;
var $c053586507d63757$export$52a9039d7177394f;
var $c053586507d63757$export$f7201db400317331;
var $c053586507d63757$export$448fa22aedc9dbca;
var $c053586507d63757$export$b80c7ba289c8fa56;
var $c053586507d63757$export$26e5786e8ac8e530;
var $c053586507d63757$export$bdd223f16383713e;
var $c053586507d63757$export$20533d26f07f1ee0;
var $c053586507d63757$export$2f64596b8cbf08b4;
var $c053586507d63757$export$2ce6d8d0e8b04e1a;
var $c053586507d63757$export$12ada9414fbc594c;
var $c053586507d63757$export$f5e7e39d57cd9700;
var $c053586507d63757$export$36b6d6ef312eab39;
var $c053586507d63757$export$58a258485f1e49f6;
var $c053586507d63757$export$dedd8dc3dc62b370;
var $c053586507d63757$export$971862a2fcb1bb40;
var $c053586507d63757$export$c6ff6a88acbeaf40;
var $c053586507d63757$export$fdc27893e98845cc;
var $c053586507d63757$export$6671fb9a1323bed;
var $c053586507d63757$export$d74daf141a551db;
var $c053586507d63757$export$45df7cae684751af;
var $c053586507d63757$export$1db683ad541682f6;
var $c053586507d63757$export$6f65485f87568e37;
var $c053586507d63757$export$91a8e56769aeb334;
var $c053586507d63757$export$2d4117e99c2179e4;
var $c053586507d63757$export$512823e338ddb1b7;
var $c053586507d63757$export$9d0e0c0c4a8d30f3;
var $c053586507d63757$export$b9d55ff329113abd;
var $c053586507d63757$export$7efb24e2fddf99b9;
var $c053586507d63757$export$bb1abf2ce84fc7e8;
var $c053586507d63757$export$2f7171e78e524d5e;
var $c053586507d63757$export$e1d879b482f37d98;
var $c053586507d63757$export$1a988e7317c65621;
'use strict';

$c053586507d63757$export$5f828d93ff035aa8 = $c053586507d63757$export$cd94982b18c6332c = $c053586507d63757$export$1d518568e4f529b0 = $c053586507d63757$export$5285b6d41c912b41 = (parcelRequire("1DyI6"));

$c053586507d63757$export$2fb37efbf6ae0c0e = $c053586507d63757$export$ab85ecd77ce6a5cd = (parcelRequire("7K4uY"));

$c053586507d63757$export$da39cf97e1eb7c91 = $c053586507d63757$export$52a9039d7177394f = (parcelRequire("j65bP"));

var $NKdOQ = parcelRequire("NKdOQ");
var $c053586507d63757$var$algoKeys = Object.keys($NKdOQ);
var $c053586507d63757$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($c053586507d63757$var$algoKeys);
$c053586507d63757$export$f7201db400317331 = function() {
    return $c053586507d63757$var$hashes;
};

var $fS6zE = parcelRequire("fS6zE");
$c053586507d63757$export$448fa22aedc9dbca = $fS6zE.pbkdf2;
$c053586507d63757$export$b80c7ba289c8fa56 = $fS6zE.pbkdf2Sync;

var $a2ApW = parcelRequire("a2ApW");
$c053586507d63757$export$26e5786e8ac8e530 = $a2ApW.Cipher;
$c053586507d63757$export$bdd223f16383713e = $a2ApW.createCipher;
$c053586507d63757$export$20533d26f07f1ee0 = $a2ApW.Cipheriv;
$c053586507d63757$export$2f64596b8cbf08b4 = $a2ApW.createCipheriv;
$c053586507d63757$export$2ce6d8d0e8b04e1a = $a2ApW.Decipher;
$c053586507d63757$export$12ada9414fbc594c = $a2ApW.createDecipher;
$c053586507d63757$export$f5e7e39d57cd9700 = $a2ApW.Decipheriv;
$c053586507d63757$export$36b6d6ef312eab39 = $a2ApW.createDecipheriv;
$c053586507d63757$export$58a258485f1e49f6 = $a2ApW.getCiphers;
$c053586507d63757$export$dedd8dc3dc62b370 = $a2ApW.listCiphers;

var $ilRwV = parcelRequire("ilRwV");
$c053586507d63757$export$971862a2fcb1bb40 = $ilRwV.DiffieHellmanGroup;
$c053586507d63757$export$c6ff6a88acbeaf40 = $ilRwV.createDiffieHellmanGroup;
$c053586507d63757$export$fdc27893e98845cc = $ilRwV.getDiffieHellman;
$c053586507d63757$export$6671fb9a1323bed = $ilRwV.createDiffieHellman;
$c053586507d63757$export$d74daf141a551db = $ilRwV.DiffieHellman;

var $kqxVX = parcelRequire("kqxVX");
$c053586507d63757$export$45df7cae684751af = $kqxVX.createSign;
$c053586507d63757$export$1db683ad541682f6 = $kqxVX.Sign;
$c053586507d63757$export$6f65485f87568e37 = $kqxVX.createVerify;
$c053586507d63757$export$91a8e56769aeb334 = $kqxVX.Verify;

$c053586507d63757$export$2d4117e99c2179e4 = (parcelRequire("bsZLy"));

var $bIasb = parcelRequire("bIasb");
$c053586507d63757$export$512823e338ddb1b7 = $bIasb.publicEncrypt;
$c053586507d63757$export$9d0e0c0c4a8d30f3 = $bIasb.privateEncrypt;
$c053586507d63757$export$b9d55ff329113abd = $bIasb.publicDecrypt;
$c053586507d63757$export$7efb24e2fddf99b9 = $bIasb.privateDecrypt;

var $9hQRv = parcelRequire("9hQRv");
$c053586507d63757$export$bb1abf2ce84fc7e8 = $9hQRv.randomFill;
$c053586507d63757$export$2f7171e78e524d5e = $9hQRv.randomFillSync;
$c053586507d63757$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$c053586507d63757$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("1DyI6", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $13145bb397e3672d$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $13145bb397e3672d$var$MAX_UINT32 = 4294967295;
function $13145bb397e3672d$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $Wth4q = parcelRequire("Wth4q");
var $13145bb397e3672d$require$Buffer = $Wth4q.Buffer;
var $13145bb397e3672d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($13145bb397e3672d$var$crypto && $13145bb397e3672d$var$crypto.getRandomValues) module.exports = $13145bb397e3672d$var$randomBytes;
else module.exports = $13145bb397e3672d$var$oldBrowser;
function $13145bb397e3672d$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $13145bb397e3672d$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $13145bb397e3672d$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $13145bb397e3672d$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $13145bb397e3672d$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $13145bb397e3672d$var$crypto.getRandomValues(bytes.slice(generated, generated + $13145bb397e3672d$var$MAX_BYTES));
        else $13145bb397e3672d$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $6cAn5.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("Wth4q", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $5k7LC = parcelRequire("5k7LC");
var $0afc202a9b74167d$var$Buffer = $5k7LC.Buffer;
// alternative to using Object.keys for old browsers
function $0afc202a9b74167d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($0afc202a9b74167d$var$Buffer.from && $0afc202a9b74167d$var$Buffer.alloc && $0afc202a9b74167d$var$Buffer.allocUnsafe && $0afc202a9b74167d$var$Buffer.allocUnsafeSlow) module.exports = $5k7LC;
else {
    // Copy properties from require('buffer')
    $0afc202a9b74167d$var$copyProps($5k7LC, module.exports);
    module.exports.Buffer = $0afc202a9b74167d$var$SafeBuffer;
}
function $0afc202a9b74167d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $0afc202a9b74167d$var$Buffer(arg, encodingOrOffset, length);
}
$0afc202a9b74167d$var$SafeBuffer.prototype = Object.create($0afc202a9b74167d$var$Buffer.prototype);
// Copy static methods from Buffer
$0afc202a9b74167d$var$copyProps($0afc202a9b74167d$var$Buffer, $0afc202a9b74167d$var$SafeBuffer);
$0afc202a9b74167d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $0afc202a9b74167d$var$Buffer(arg, encodingOrOffset, length);
};
$0afc202a9b74167d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $0afc202a9b74167d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$0afc202a9b74167d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $0afc202a9b74167d$var$Buffer(size);
};
$0afc202a9b74167d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5k7LC.SlowBuffer(size);
};

});


parcelRegister("7K4uY", function(module, exports) {
'use strict';

var $v3bBu = parcelRequire("v3bBu");

var $8ZJxF = parcelRequire("8ZJxF");

var $6EPBm = parcelRequire("6EPBm");

var $a21Ya = parcelRequire("a21Ya");

var $77fwb = parcelRequire("77fwb");
function $5a3051967cf0fdc1$var$Hash(hash) {
    $77fwb.call(this, 'digest');
    this._hash = hash;
}
$v3bBu($5a3051967cf0fdc1$var$Hash, $77fwb);
$5a3051967cf0fdc1$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$5a3051967cf0fdc1$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $8ZJxF();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $6EPBm();
    return new $5a3051967cf0fdc1$var$Hash($a21Ya(alg));
};

});
parcelRegister("v3bBu", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("8ZJxF", function(module, exports) {

var $5k7LC = parcelRequire("5k7LC");
var $68c758ebde74a508$require$Buffer = $5k7LC.Buffer;
'use strict';

var $v3bBu = parcelRequire("v3bBu");

var $gOR7Z = parcelRequire("gOR7Z");
var $68c758ebde74a508$var$ARRAY16 = new Array(16);
function $68c758ebde74a508$var$MD5() {
    $gOR7Z.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$v3bBu($68c758ebde74a508$var$MD5, $gOR7Z);
$68c758ebde74a508$var$MD5.prototype._update = function() {
    var M = $68c758ebde74a508$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $68c758ebde74a508$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $68c758ebde74a508$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $68c758ebde74a508$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $68c758ebde74a508$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $68c758ebde74a508$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $68c758ebde74a508$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $68c758ebde74a508$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $68c758ebde74a508$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $68c758ebde74a508$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $68c758ebde74a508$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $68c758ebde74a508$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $68c758ebde74a508$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $68c758ebde74a508$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $68c758ebde74a508$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $68c758ebde74a508$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $68c758ebde74a508$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $68c758ebde74a508$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $68c758ebde74a508$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $68c758ebde74a508$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $68c758ebde74a508$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $68c758ebde74a508$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $68c758ebde74a508$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $68c758ebde74a508$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $68c758ebde74a508$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $68c758ebde74a508$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $68c758ebde74a508$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $68c758ebde74a508$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $68c758ebde74a508$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $68c758ebde74a508$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $68c758ebde74a508$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $68c758ebde74a508$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $68c758ebde74a508$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $68c758ebde74a508$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $68c758ebde74a508$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $68c758ebde74a508$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $68c758ebde74a508$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $68c758ebde74a508$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $68c758ebde74a508$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $68c758ebde74a508$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $68c758ebde74a508$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $68c758ebde74a508$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $68c758ebde74a508$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $68c758ebde74a508$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $68c758ebde74a508$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $68c758ebde74a508$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $68c758ebde74a508$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $68c758ebde74a508$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $68c758ebde74a508$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $68c758ebde74a508$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $68c758ebde74a508$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $68c758ebde74a508$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $68c758ebde74a508$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $68c758ebde74a508$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $68c758ebde74a508$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $68c758ebde74a508$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $68c758ebde74a508$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $68c758ebde74a508$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $68c758ebde74a508$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $68c758ebde74a508$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $68c758ebde74a508$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $68c758ebde74a508$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $68c758ebde74a508$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $68c758ebde74a508$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $68c758ebde74a508$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$68c758ebde74a508$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $68c758ebde74a508$require$Buffer(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $68c758ebde74a508$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $68c758ebde74a508$var$fnF(a, b, c, d, m, k, s) {
    return $68c758ebde74a508$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $68c758ebde74a508$var$fnG(a, b, c, d, m, k, s) {
    return $68c758ebde74a508$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $68c758ebde74a508$var$fnH(a, b, c, d, m, k, s) {
    return $68c758ebde74a508$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $68c758ebde74a508$var$fnI(a, b, c, d, m, k, s) {
    return $68c758ebde74a508$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $68c758ebde74a508$var$MD5;

});
parcelRegister("gOR7Z", function(module, exports) {
'use strict';

var $Wth4q = parcelRequire("Wth4q");
var $c3ea86f24fd070bd$require$Buffer = $Wth4q.Buffer;

var $e2HvS = parcelRequire("e2HvS");
var $c3ea86f24fd070bd$require$Transform = $e2HvS.Transform;

var $v3bBu = parcelRequire("v3bBu");
function $c3ea86f24fd070bd$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$c3ea86f24fd070bd$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $c3ea86f24fd070bd$var$HashBase(blockSize) {
    $c3ea86f24fd070bd$require$Transform.call(this);
    this._block = $c3ea86f24fd070bd$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$v3bBu($c3ea86f24fd070bd$var$HashBase, $c3ea86f24fd070bd$require$Transform);
$c3ea86f24fd070bd$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$c3ea86f24fd070bd$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$c3ea86f24fd070bd$var$HashBase.prototype.update = function(data, encoding) {
    $c3ea86f24fd070bd$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$c3ea86f24fd070bd$require$Buffer.isBuffer(data)) data = $c3ea86f24fd070bd$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$c3ea86f24fd070bd$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$c3ea86f24fd070bd$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$c3ea86f24fd070bd$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $c3ea86f24fd070bd$var$HashBase;

});
parcelRegister("e2HvS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $a393016297afccce$var$Stream;

var $6Oghe = parcelRequire("6Oghe");
var $a393016297afccce$require$EE = $6Oghe.EventEmitter;

var $v3bBu = parcelRequire("v3bBu");
$v3bBu($a393016297afccce$var$Stream, $a393016297afccce$require$EE);

$a393016297afccce$var$Stream.Readable = (parcelRequire("1QiFm"));

$a393016297afccce$var$Stream.Writable = (parcelRequire("kY7wA"));

$a393016297afccce$var$Stream.Duplex = (parcelRequire("7TTUN"));

$a393016297afccce$var$Stream.Transform = (parcelRequire("3uw87"));

$a393016297afccce$var$Stream.PassThrough = (parcelRequire("fLUve"));

$a393016297afccce$var$Stream.finished = (parcelRequire("ajkeH"));

$a393016297afccce$var$Stream.pipeline = (parcelRequire("gwu9c"));
// Backwards-compat with node 0.4.x
$a393016297afccce$var$Stream.Stream = $a393016297afccce$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $a393016297afccce$var$Stream() {
    $a393016297afccce$require$EE.call(this);
}
$a393016297afccce$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($a393016297afccce$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("6Oghe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4f5409da028b4771$var$ReflectOwnKeys;
if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4f5409da028b4771$var$EventEmitter() {
    $4f5409da028b4771$var$EventEmitter.init.call(this);
}
module.exports = $4f5409da028b4771$var$EventEmitter;
module.exports.once = $4f5409da028b4771$var$once;
// Backwards-compat with node 0.10.x
$4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
$4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
$4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
$4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4f5409da028b4771$var$defaultMaxListeners = 10;
function $4f5409da028b4771$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4f5409da028b4771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4f5409da028b4771$var$defaultMaxListeners = arg;
    }
});
$4f5409da028b4771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4f5409da028b4771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4f5409da028b4771$var$_getMaxListeners(this);
};
$4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4f5409da028b4771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4f5409da028b4771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4f5409da028b4771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, false);
};
$4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
$4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, true);
};
function $4f5409da028b4771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4f5409da028b4771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4f5409da028b4771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
$4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
}
$4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, true);
};
$4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, false);
};
$4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
};
$4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
function $4f5409da028b4771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
};
function $4f5409da028b4771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4f5409da028b4771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4f5409da028b4771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4f5409da028b4771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("1QiFm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
module.exports = $1579207ccf57b205$var$Readable;
/*<replacement>*/ var $1579207ccf57b205$var$Duplex;
/*</replacement>*/ $1579207ccf57b205$var$Readable.ReadableState = $1579207ccf57b205$var$ReadableState;

var $6Oghe = parcelRequire("6Oghe");
var $1579207ccf57b205$require$EE = $6Oghe.EventEmitter;
var $1579207ccf57b205$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $ccIwY = parcelRequire("ccIwY");

var $5k7LC = parcelRequire("5k7LC");
var $1579207ccf57b205$require$Buffer = $5k7LC.Buffer;
var $1579207ccf57b205$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $1579207ccf57b205$var$_uint8ArrayToBuffer(chunk) {
    return $1579207ccf57b205$require$Buffer.from(chunk);
}
function $1579207ccf57b205$var$_isUint8Array(obj) {
    return $1579207ccf57b205$require$Buffer.isBuffer(obj) || obj instanceof $1579207ccf57b205$var$OurUint8Array;
}

var $hq3wB = parcelRequire("hq3wB");
var $1579207ccf57b205$var$debug;
if ($hq3wB && $hq3wB.debuglog) $1579207ccf57b205$var$debug = $hq3wB.debuglog('stream');
else $1579207ccf57b205$var$debug = function debug() {};

var $l9yJP = parcelRequire("l9yJP");

var $dlhEt = parcelRequire("dlhEt");

var $7UMzQ = parcelRequire("7UMzQ");
var $1579207ccf57b205$var$getHighWaterMark = $7UMzQ.getHighWaterMark;

var $7w9IA = parcelRequire("7w9IA");
var $1579207ccf57b205$require$_require$codes = $7w9IA.codes;
var $1579207ccf57b205$var$ERR_INVALID_ARG_TYPE = $1579207ccf57b205$require$_require$codes.ERR_INVALID_ARG_TYPE, $1579207ccf57b205$var$ERR_STREAM_PUSH_AFTER_EOF = $1579207ccf57b205$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $1579207ccf57b205$var$ERR_METHOD_NOT_IMPLEMENTED = $1579207ccf57b205$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $1579207ccf57b205$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $1579207ccf57b205$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $1579207ccf57b205$var$StringDecoder;
var $1579207ccf57b205$var$createReadableStreamAsyncIterator;
var $1579207ccf57b205$var$from;

(parcelRequire("v3bBu"))($1579207ccf57b205$var$Readable, $ccIwY);
var $1579207ccf57b205$var$errorOrDestroy = $dlhEt.errorOrDestroy;
var $1579207ccf57b205$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $1579207ccf57b205$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $1579207ccf57b205$var$ReadableState(options, stream, isDuplex) {
    $1579207ccf57b205$var$Duplex = $1579207ccf57b205$var$Duplex || (parcelRequire("7TTUN"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $1579207ccf57b205$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $1579207ccf57b205$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $l9yJP();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$1579207ccf57b205$var$StringDecoder) $1579207ccf57b205$var$StringDecoder = (parcelRequire("3872E")).StringDecoder;
        this.decoder = new $1579207ccf57b205$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $1579207ccf57b205$var$Readable(options) {
    $1579207ccf57b205$var$Duplex = $1579207ccf57b205$var$Duplex || (parcelRequire("7TTUN"));
    if (!(this instanceof $1579207ccf57b205$var$Readable)) return new $1579207ccf57b205$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $1579207ccf57b205$var$Duplex;
    this._readableState = new $1579207ccf57b205$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $ccIwY.call(this);
}
Object.defineProperty($1579207ccf57b205$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$1579207ccf57b205$var$Readable.prototype.destroy = $dlhEt.destroy;
$1579207ccf57b205$var$Readable.prototype._undestroy = $dlhEt.undestroy;
$1579207ccf57b205$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$1579207ccf57b205$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $1579207ccf57b205$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $1579207ccf57b205$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$1579207ccf57b205$var$Readable.prototype.unshift = function(chunk) {
    return $1579207ccf57b205$var$readableAddChunk(this, chunk, null, true, false);
};
function $1579207ccf57b205$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $1579207ccf57b205$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $1579207ccf57b205$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $1579207ccf57b205$var$chunkInvalid(state, chunk);
        if (er) $1579207ccf57b205$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $1579207ccf57b205$require$Buffer.prototype) chunk = $1579207ccf57b205$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $1579207ccf57b205$var$errorOrDestroy(stream, new $1579207ccf57b205$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $1579207ccf57b205$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $1579207ccf57b205$var$errorOrDestroy(stream, new $1579207ccf57b205$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $1579207ccf57b205$var$addChunk(stream, state, chunk, false);
                    else $1579207ccf57b205$var$maybeReadMore(stream, state);
                } else $1579207ccf57b205$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $1579207ccf57b205$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $1579207ccf57b205$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $1579207ccf57b205$var$emitReadable(stream);
    }
    $1579207ccf57b205$var$maybeReadMore(stream, state);
}
function $1579207ccf57b205$var$chunkInvalid(state, chunk) {
    var er;
    if (!$1579207ccf57b205$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $1579207ccf57b205$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$1579207ccf57b205$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$1579207ccf57b205$var$Readable.prototype.setEncoding = function(enc) {
    if (!$1579207ccf57b205$var$StringDecoder) $1579207ccf57b205$var$StringDecoder = (parcelRequire("3872E")).StringDecoder;
    var decoder = new $1579207ccf57b205$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $1579207ccf57b205$var$MAX_HWM = 0x40000000;
function $1579207ccf57b205$var$computeNewHighWaterMark(n) {
    if (n >= $1579207ccf57b205$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $1579207ccf57b205$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1579207ccf57b205$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $1579207ccf57b205$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$1579207ccf57b205$var$Readable.prototype.read = function(n) {
    $1579207ccf57b205$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $1579207ccf57b205$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $1579207ccf57b205$var$endReadable(this);
        else $1579207ccf57b205$var$emitReadable(this);
        return null;
    }
    n = $1579207ccf57b205$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $1579207ccf57b205$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $1579207ccf57b205$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $1579207ccf57b205$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $1579207ccf57b205$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $1579207ccf57b205$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $1579207ccf57b205$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $1579207ccf57b205$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $1579207ccf57b205$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $1579207ccf57b205$var$onEofChunk(stream, state) {
    $1579207ccf57b205$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $1579207ccf57b205$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $1579207ccf57b205$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $1579207ccf57b205$var$emitReadable(stream) {
    var state = stream._readableState;
    $1579207ccf57b205$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $1579207ccf57b205$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $6cAn5.nextTick($1579207ccf57b205$var$emitReadable_, stream);
    }
}
function $1579207ccf57b205$var$emitReadable_(stream) {
    var state = stream._readableState;
    $1579207ccf57b205$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $1579207ccf57b205$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $1579207ccf57b205$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $6cAn5.nextTick($1579207ccf57b205$var$maybeReadMore_, stream, state);
    }
}
function $1579207ccf57b205$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $1579207ccf57b205$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$1579207ccf57b205$var$Readable.prototype._read = function(n) {
    $1579207ccf57b205$var$errorOrDestroy(this, new $1579207ccf57b205$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$1579207ccf57b205$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $1579207ccf57b205$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6cAn5.stdout && dest !== $6cAn5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $6cAn5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $1579207ccf57b205$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $1579207ccf57b205$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $1579207ccf57b205$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $1579207ccf57b205$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $1579207ccf57b205$var$debug('ondata');
        var ret = dest.write(chunk);
        $1579207ccf57b205$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $1579207ccf57b205$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $1579207ccf57b205$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $1579207ccf57b205$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($1579207ccf57b205$var$EElistenerCount(dest, 'error') === 0) $1579207ccf57b205$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $1579207ccf57b205$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $1579207ccf57b205$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $1579207ccf57b205$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $1579207ccf57b205$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $1579207ccf57b205$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $1579207ccf57b205$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $1579207ccf57b205$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $1579207ccf57b205$var$flow(src);
        }
    };
}
$1579207ccf57b205$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $1579207ccf57b205$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$1579207ccf57b205$var$Readable.prototype.on = function(ev, fn) {
    var res = $ccIwY.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $1579207ccf57b205$var$debug('on readable', state.length, state.reading);
            if (state.length) $1579207ccf57b205$var$emitReadable(this);
            else if (!state.reading) $6cAn5.nextTick($1579207ccf57b205$var$nReadingNextTick, this);
        }
    }
    return res;
};
$1579207ccf57b205$var$Readable.prototype.addListener = $1579207ccf57b205$var$Readable.prototype.on;
$1579207ccf57b205$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $ccIwY.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6cAn5.nextTick($1579207ccf57b205$var$updateReadableListening, this);
    return res;
};
$1579207ccf57b205$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $ccIwY.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6cAn5.nextTick($1579207ccf57b205$var$updateReadableListening, this);
    return res;
};
function $1579207ccf57b205$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $1579207ccf57b205$var$nReadingNextTick(self1) {
    $1579207ccf57b205$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$1579207ccf57b205$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $1579207ccf57b205$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $1579207ccf57b205$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $1579207ccf57b205$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $6cAn5.nextTick($1579207ccf57b205$var$resume_, stream, state);
    }
}
function $1579207ccf57b205$var$resume_(stream, state) {
    $1579207ccf57b205$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $1579207ccf57b205$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$1579207ccf57b205$var$Readable.prototype.pause = function() {
    $1579207ccf57b205$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $1579207ccf57b205$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $1579207ccf57b205$var$flow(stream) {
    var state = stream._readableState;
    $1579207ccf57b205$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$1579207ccf57b205$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $1579207ccf57b205$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $1579207ccf57b205$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $1579207ccf57b205$var$kProxyEvents.length; n++)stream.on($1579207ccf57b205$var$kProxyEvents[n], this.emit.bind(this, $1579207ccf57b205$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $1579207ccf57b205$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $1579207ccf57b205$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($1579207ccf57b205$var$createReadableStreamAsyncIterator === undefined) $1579207ccf57b205$var$createReadableStreamAsyncIterator = (parcelRequire("6RqQp"));
    return $1579207ccf57b205$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($1579207ccf57b205$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($1579207ccf57b205$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($1579207ccf57b205$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$1579207ccf57b205$var$Readable._fromList = $1579207ccf57b205$var$fromList;
Object.defineProperty($1579207ccf57b205$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1579207ccf57b205$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $1579207ccf57b205$var$endReadable(stream) {
    var state = stream._readableState;
    $1579207ccf57b205$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $6cAn5.nextTick($1579207ccf57b205$var$endReadableNT, state, stream);
    }
}
function $1579207ccf57b205$var$endReadableNT(state, stream) {
    $1579207ccf57b205$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $1579207ccf57b205$var$Readable.from = function(iterable, opts) {
    if ($1579207ccf57b205$var$from === undefined) $1579207ccf57b205$var$from = (parcelRequire("lAEFk"));
    return $1579207ccf57b205$var$from($1579207ccf57b205$var$Readable, iterable, opts);
};
function $1579207ccf57b205$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("ccIwY", function(module, exports) {

module.exports = (parcelRequire("6Oghe")).EventEmitter;

});

parcelRegister("l9yJP", function(module, exports) {
'use strict';
function $f6656289a2a09cc1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f6656289a2a09cc1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f6656289a2a09cc1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f6656289a2a09cc1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f6656289a2a09cc1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f6656289a2a09cc1$var$_defineProperty(obj, key, value) {
    key = $f6656289a2a09cc1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f6656289a2a09cc1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f6656289a2a09cc1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f6656289a2a09cc1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f6656289a2a09cc1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f6656289a2a09cc1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f6656289a2a09cc1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f6656289a2a09cc1$var$_toPropertyKey(arg) {
    var key = $f6656289a2a09cc1$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f6656289a2a09cc1$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $5k7LC = parcelRequire("5k7LC");
var $f6656289a2a09cc1$var$Buffer = $5k7LC.Buffer;

var $hq3wB = parcelRequire("hq3wB");
var $f6656289a2a09cc1$var$inspect = $hq3wB.inspect;
var $f6656289a2a09cc1$var$custom = $f6656289a2a09cc1$var$inspect && $f6656289a2a09cc1$var$inspect.custom || 'inspect';
function $f6656289a2a09cc1$var$copyBuffer(src, target, offset) {
    $f6656289a2a09cc1$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $f6656289a2a09cc1$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $f6656289a2a09cc1$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $f6656289a2a09cc1$var$Buffer.alloc(0);
                var ret = $f6656289a2a09cc1$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $f6656289a2a09cc1$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $f6656289a2a09cc1$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $f6656289a2a09cc1$var$custom,
            value: function value(_, options) {
                return $f6656289a2a09cc1$var$inspect(this, $f6656289a2a09cc1$var$_objectSpread($f6656289a2a09cc1$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("dlhEt", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $9b6aedd2654b128b$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $6cAn5.nextTick($9b6aedd2654b128b$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $6cAn5.nextTick($9b6aedd2654b128b$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $6cAn5.nextTick($9b6aedd2654b128b$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $6cAn5.nextTick($9b6aedd2654b128b$var$emitErrorAndCloseNT, _this, err);
            } else $6cAn5.nextTick($9b6aedd2654b128b$var$emitCloseNT, _this);
        } else if (cb) {
            $6cAn5.nextTick($9b6aedd2654b128b$var$emitCloseNT, _this);
            cb(err);
        } else $6cAn5.nextTick($9b6aedd2654b128b$var$emitCloseNT, _this);
    });
    return this;
}
function $9b6aedd2654b128b$var$emitErrorAndCloseNT(self, err) {
    $9b6aedd2654b128b$var$emitErrorNT(self, err);
    $9b6aedd2654b128b$var$emitCloseNT(self);
}
function $9b6aedd2654b128b$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $9b6aedd2654b128b$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $9b6aedd2654b128b$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $9b6aedd2654b128b$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $9b6aedd2654b128b$var$destroy,
    undestroy: $9b6aedd2654b128b$var$undestroy,
    errorOrDestroy: $9b6aedd2654b128b$var$errorOrDestroy
};

});

parcelRegister("7UMzQ", function(module, exports) {
'use strict';

var $5c3371c5c4db7987$var$ERR_INVALID_OPT_VALUE = (parcelRequire("7w9IA")).codes.ERR_INVALID_OPT_VALUE;
function $5c3371c5c4db7987$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $5c3371c5c4db7987$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $5c3371c5c4db7987$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $5c3371c5c4db7987$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $5c3371c5c4db7987$var$getHighWaterMark
};

});
parcelRegister("7w9IA", function(module, exports) {

$parcel$export(module.exports, "codes", () => $57930f5da6850d6d$export$e45cb6485273080e, (v) => $57930f5da6850d6d$export$e45cb6485273080e = v);
var $57930f5da6850d6d$export$e45cb6485273080e;
'use strict';
function $57930f5da6850d6d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $57930f5da6850d6d$var$codes = {};
function $57930f5da6850d6d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $57930f5da6850d6d$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $57930f5da6850d6d$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $57930f5da6850d6d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $57930f5da6850d6d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $57930f5da6850d6d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $57930f5da6850d6d$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$57930f5da6850d6d$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$57930f5da6850d6d$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $57930f5da6850d6d$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($57930f5da6850d6d$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($57930f5da6850d6d$var$oneOf(expected, 'type'));
    else {
        var type = $57930f5da6850d6d$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($57930f5da6850d6d$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$57930f5da6850d6d$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$57930f5da6850d6d$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$57930f5da6850d6d$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$57930f5da6850d6d$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$57930f5da6850d6d$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$57930f5da6850d6d$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$57930f5da6850d6d$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$57930f5da6850d6d$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$57930f5da6850d6d$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$57930f5da6850d6d$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$57930f5da6850d6d$export$e45cb6485273080e = $57930f5da6850d6d$var$codes;

});


parcelRegister("7TTUN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
/*<replacement>*/ var $5c090b08a8eef60f$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $5c090b08a8eef60f$var$Duplex;

var $1QiFm = parcelRequire("1QiFm");

var $kY7wA = parcelRequire("kY7wA");

(parcelRequire("v3bBu"))($5c090b08a8eef60f$var$Duplex, $1QiFm);
// Allow the keys array to be GC'ed.
var $5c090b08a8eef60f$var$keys = $5c090b08a8eef60f$var$objectKeys($kY7wA.prototype);
for(var $5c090b08a8eef60f$var$v = 0; $5c090b08a8eef60f$var$v < $5c090b08a8eef60f$var$keys.length; $5c090b08a8eef60f$var$v++){
    var $5c090b08a8eef60f$var$method = $5c090b08a8eef60f$var$keys[$5c090b08a8eef60f$var$v];
    if (!$5c090b08a8eef60f$var$Duplex.prototype[$5c090b08a8eef60f$var$method]) $5c090b08a8eef60f$var$Duplex.prototype[$5c090b08a8eef60f$var$method] = $kY7wA.prototype[$5c090b08a8eef60f$var$method];
}
function $5c090b08a8eef60f$var$Duplex(options) {
    if (!(this instanceof $5c090b08a8eef60f$var$Duplex)) return new $5c090b08a8eef60f$var$Duplex(options);
    $1QiFm.call(this, options);
    $kY7wA.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $5c090b08a8eef60f$var$onend);
        }
    }
}
Object.defineProperty($5c090b08a8eef60f$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($5c090b08a8eef60f$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($5c090b08a8eef60f$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $5c090b08a8eef60f$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $6cAn5.nextTick($5c090b08a8eef60f$var$onEndNT, this);
}
function $5c090b08a8eef60f$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($5c090b08a8eef60f$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("kY7wA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
module.exports = $f43f3f741107719f$var$Writable;
/* <replacement> */ function $f43f3f741107719f$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $f43f3f741107719f$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $f43f3f741107719f$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $f43f3f741107719f$var$Duplex;
/*</replacement>*/ $f43f3f741107719f$var$Writable.WritableState = $f43f3f741107719f$var$WritableState;

/*<replacement>*/ var $f43f3f741107719f$var$internalUtil = {
    deprecate: (parcelRequire("geQ6V"))
};

var $ccIwY = parcelRequire("ccIwY");

var $5k7LC = parcelRequire("5k7LC");
var $f43f3f741107719f$require$Buffer = $5k7LC.Buffer;
var $f43f3f741107719f$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f43f3f741107719f$var$_uint8ArrayToBuffer(chunk) {
    return $f43f3f741107719f$require$Buffer.from(chunk);
}
function $f43f3f741107719f$var$_isUint8Array(obj) {
    return $f43f3f741107719f$require$Buffer.isBuffer(obj) || obj instanceof $f43f3f741107719f$var$OurUint8Array;
}

var $dlhEt = parcelRequire("dlhEt");

var $7UMzQ = parcelRequire("7UMzQ");
var $f43f3f741107719f$var$getHighWaterMark = $7UMzQ.getHighWaterMark;

var $7w9IA = parcelRequire("7w9IA");
var $f43f3f741107719f$require$_require$codes = $7w9IA.codes;
var $f43f3f741107719f$var$ERR_INVALID_ARG_TYPE = $f43f3f741107719f$require$_require$codes.ERR_INVALID_ARG_TYPE, $f43f3f741107719f$var$ERR_METHOD_NOT_IMPLEMENTED = $f43f3f741107719f$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f43f3f741107719f$var$ERR_MULTIPLE_CALLBACK = $f43f3f741107719f$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f43f3f741107719f$var$ERR_STREAM_CANNOT_PIPE = $f43f3f741107719f$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $f43f3f741107719f$var$ERR_STREAM_DESTROYED = $f43f3f741107719f$require$_require$codes.ERR_STREAM_DESTROYED, $f43f3f741107719f$var$ERR_STREAM_NULL_VALUES = $f43f3f741107719f$require$_require$codes.ERR_STREAM_NULL_VALUES, $f43f3f741107719f$var$ERR_STREAM_WRITE_AFTER_END = $f43f3f741107719f$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $f43f3f741107719f$var$ERR_UNKNOWN_ENCODING = $f43f3f741107719f$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $f43f3f741107719f$var$errorOrDestroy = $dlhEt.errorOrDestroy;

(parcelRequire("v3bBu"))($f43f3f741107719f$var$Writable, $ccIwY);
function $f43f3f741107719f$var$nop() {}

function $f43f3f741107719f$var$WritableState(options, stream, isDuplex) {
    $f43f3f741107719f$var$Duplex = $f43f3f741107719f$var$Duplex || (parcelRequire("7TTUN"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $f43f3f741107719f$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $f43f3f741107719f$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $f43f3f741107719f$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $f43f3f741107719f$var$CorkedRequest(this);
}
$f43f3f741107719f$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($f43f3f741107719f$var$WritableState.prototype, 'buffer', {
            get: $f43f3f741107719f$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $f43f3f741107719f$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $f43f3f741107719f$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($f43f3f741107719f$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($f43f3f741107719f$var$realHasInstance.call(this, object)) return true;
            if (this !== $f43f3f741107719f$var$Writable) return false;
            return object && object._writableState instanceof $f43f3f741107719f$var$WritableState;
        }
    });
} else $f43f3f741107719f$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $f43f3f741107719f$var$Writable(options) {
    $f43f3f741107719f$var$Duplex = $f43f3f741107719f$var$Duplex || (parcelRequire("7TTUN"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f43f3f741107719f$var$Duplex;
    if (!isDuplex && !$f43f3f741107719f$var$realHasInstance.call($f43f3f741107719f$var$Writable, this)) return new $f43f3f741107719f$var$Writable(options);
    this._writableState = new $f43f3f741107719f$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $ccIwY.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$f43f3f741107719f$var$Writable.prototype.pipe = function() {
    $f43f3f741107719f$var$errorOrDestroy(this, new $f43f3f741107719f$var$ERR_STREAM_CANNOT_PIPE());
};
function $f43f3f741107719f$var$writeAfterEnd(stream, cb) {
    var er = new $f43f3f741107719f$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $f43f3f741107719f$var$errorOrDestroy(stream, er);
    $6cAn5.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $f43f3f741107719f$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $f43f3f741107719f$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $f43f3f741107719f$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $f43f3f741107719f$var$errorOrDestroy(stream, er);
        $6cAn5.nextTick(cb, er);
        return false;
    }
    return true;
}
$f43f3f741107719f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $f43f3f741107719f$var$_isUint8Array(chunk);
    if (isBuf && !$f43f3f741107719f$require$Buffer.isBuffer(chunk)) chunk = $f43f3f741107719f$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $f43f3f741107719f$var$nop;
    if (state.ending) $f43f3f741107719f$var$writeAfterEnd(this, cb);
    else if (isBuf || $f43f3f741107719f$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $f43f3f741107719f$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$f43f3f741107719f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$f43f3f741107719f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f43f3f741107719f$var$clearBuffer(this, state);
    }
};
$f43f3f741107719f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $f43f3f741107719f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($f43f3f741107719f$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $f43f3f741107719f$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $f43f3f741107719f$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($f43f3f741107719f$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f43f3f741107719f$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $f43f3f741107719f$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $f43f3f741107719f$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $f43f3f741107719f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $f43f3f741107719f$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f43f3f741107719f$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $6cAn5.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $6cAn5.nextTick($f43f3f741107719f$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $f43f3f741107719f$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $f43f3f741107719f$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $f43f3f741107719f$var$finishMaybe(stream, state);
    }
}
function $f43f3f741107719f$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $f43f3f741107719f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $f43f3f741107719f$var$ERR_MULTIPLE_CALLBACK();
    $f43f3f741107719f$var$onwriteStateUpdate(state);
    if (er) $f43f3f741107719f$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $f43f3f741107719f$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f43f3f741107719f$var$clearBuffer(stream, state);
        if (sync) $6cAn5.nextTick($f43f3f741107719f$var$afterWrite, stream, state, finished, cb);
        else $f43f3f741107719f$var$afterWrite(stream, state, finished, cb);
    }
}
function $f43f3f741107719f$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $f43f3f741107719f$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $f43f3f741107719f$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $f43f3f741107719f$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $f43f3f741107719f$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $f43f3f741107719f$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $f43f3f741107719f$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $f43f3f741107719f$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$f43f3f741107719f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $f43f3f741107719f$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$f43f3f741107719f$var$Writable.prototype._writev = null;
$f43f3f741107719f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $f43f3f741107719f$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($f43f3f741107719f$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $f43f3f741107719f$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $f43f3f741107719f$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $f43f3f741107719f$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $f43f3f741107719f$var$finishMaybe(stream, state);
    });
}
function $f43f3f741107719f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $6cAn5.nextTick($f43f3f741107719f$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $f43f3f741107719f$var$finishMaybe(stream, state) {
    var need = $f43f3f741107719f$var$needFinish(state);
    if (need) {
        $f43f3f741107719f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $f43f3f741107719f$var$endWritable(stream, state, cb) {
    state.ending = true;
    $f43f3f741107719f$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $6cAn5.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $f43f3f741107719f$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($f43f3f741107719f$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$f43f3f741107719f$var$Writable.prototype.destroy = $dlhEt.destroy;
$f43f3f741107719f$var$Writable.prototype._undestroy = $dlhEt.undestroy;
$f43f3f741107719f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("geQ6V", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $bd26603cb430fbe6$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $bd26603cb430fbe6$var$deprecate(fn, msg) {
    if ($bd26603cb430fbe6$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($bd26603cb430fbe6$var$config('throwDeprecation')) throw new Error(msg);
            else if ($bd26603cb430fbe6$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $bd26603cb430fbe6$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("3872E", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $247794d1c930d1a9$export$63a7aa211a91ed69, (v) => $247794d1c930d1a9$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $247794d1c930d1a9$export$63a7aa211a91ed69;
'use strict';

var $Wth4q = parcelRequire("Wth4q");
var $247794d1c930d1a9$require$Buffer = $Wth4q.Buffer;
/*</replacement>*/ var $247794d1c930d1a9$var$isEncoding = $247794d1c930d1a9$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $247794d1c930d1a9$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $247794d1c930d1a9$var$normalizeEncoding(enc) {
    var nenc = $247794d1c930d1a9$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($247794d1c930d1a9$require$Buffer.isEncoding === $247794d1c930d1a9$var$isEncoding || !$247794d1c930d1a9$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$247794d1c930d1a9$export$63a7aa211a91ed69 = $247794d1c930d1a9$var$StringDecoder;
function $247794d1c930d1a9$var$StringDecoder(encoding) {
    this.encoding = $247794d1c930d1a9$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $247794d1c930d1a9$var$utf16Text;
            this.end = $247794d1c930d1a9$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $247794d1c930d1a9$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $247794d1c930d1a9$var$base64Text;
            this.end = $247794d1c930d1a9$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $247794d1c930d1a9$var$simpleWrite;
            this.end = $247794d1c930d1a9$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $247794d1c930d1a9$require$Buffer.allocUnsafe(nb);
}
$247794d1c930d1a9$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$247794d1c930d1a9$var$StringDecoder.prototype.end = $247794d1c930d1a9$var$utf8End;
// Returns only complete characters in a Buffer
$247794d1c930d1a9$var$StringDecoder.prototype.text = $247794d1c930d1a9$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$247794d1c930d1a9$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $247794d1c930d1a9$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $247794d1c930d1a9$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $247794d1c930d1a9$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $247794d1c930d1a9$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $247794d1c930d1a9$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $247794d1c930d1a9$var$utf8Text(buf, i) {
    var total = $247794d1c930d1a9$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $247794d1c930d1a9$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $247794d1c930d1a9$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $247794d1c930d1a9$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $247794d1c930d1a9$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $247794d1c930d1a9$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $247794d1c930d1a9$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $247794d1c930d1a9$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("6RqQp", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
var $4fec840a774d4c33$var$_Object$setPrototypeO;
function $4fec840a774d4c33$var$_defineProperty(obj, key, value) {
    key = $4fec840a774d4c33$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4fec840a774d4c33$var$_toPropertyKey(arg) {
    var key = $4fec840a774d4c33$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4fec840a774d4c33$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ajkeH = parcelRequire("ajkeH");
var $4fec840a774d4c33$var$kLastResolve = Symbol('lastResolve');
var $4fec840a774d4c33$var$kLastReject = Symbol('lastReject');
var $4fec840a774d4c33$var$kError = Symbol('error');
var $4fec840a774d4c33$var$kEnded = Symbol('ended');
var $4fec840a774d4c33$var$kLastPromise = Symbol('lastPromise');
var $4fec840a774d4c33$var$kHandlePromise = Symbol('handlePromise');
var $4fec840a774d4c33$var$kStream = Symbol('stream');
function $4fec840a774d4c33$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $4fec840a774d4c33$var$readAndResolve(iter) {
    var resolve = iter[$4fec840a774d4c33$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$4fec840a774d4c33$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$4fec840a774d4c33$var$kLastPromise] = null;
            iter[$4fec840a774d4c33$var$kLastResolve] = null;
            iter[$4fec840a774d4c33$var$kLastReject] = null;
            resolve($4fec840a774d4c33$var$createIterResult(data, false));
        }
    }
}
function $4fec840a774d4c33$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $6cAn5.nextTick($4fec840a774d4c33$var$readAndResolve, iter);
}
function $4fec840a774d4c33$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$4fec840a774d4c33$var$kEnded]) {
                resolve($4fec840a774d4c33$var$createIterResult(undefined, true));
                return;
            }
            iter[$4fec840a774d4c33$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $4fec840a774d4c33$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $4fec840a774d4c33$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($4fec840a774d4c33$var$_Object$setPrototypeO = {
    get stream () {
        return this[$4fec840a774d4c33$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$4fec840a774d4c33$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$4fec840a774d4c33$var$kEnded]) return Promise.resolve($4fec840a774d4c33$var$createIterResult(undefined, true));
        if (this[$4fec840a774d4c33$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $6cAn5.nextTick(function() {
                if (_this[$4fec840a774d4c33$var$kError]) reject(_this[$4fec840a774d4c33$var$kError]);
                else resolve($4fec840a774d4c33$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$4fec840a774d4c33$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($4fec840a774d4c33$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$4fec840a774d4c33$var$kStream].read();
            if (data !== null) return Promise.resolve($4fec840a774d4c33$var$createIterResult(data, false));
            promise = new Promise(this[$4fec840a774d4c33$var$kHandlePromise]);
        }
        this[$4fec840a774d4c33$var$kLastPromise] = promise;
        return promise;
    }
}, $4fec840a774d4c33$var$_defineProperty($4fec840a774d4c33$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $4fec840a774d4c33$var$_defineProperty($4fec840a774d4c33$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$4fec840a774d4c33$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($4fec840a774d4c33$var$createIterResult(undefined, true));
        });
    });
}), $4fec840a774d4c33$var$_Object$setPrototypeO), $4fec840a774d4c33$var$AsyncIteratorPrototype);
var $4fec840a774d4c33$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($4fec840a774d4c33$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $4fec840a774d4c33$var$_defineProperty(_Object$create, $4fec840a774d4c33$var$kStream, {
        value: stream,
        writable: true
    }), $4fec840a774d4c33$var$_defineProperty(_Object$create, $4fec840a774d4c33$var$kLastResolve, {
        value: null,
        writable: true
    }), $4fec840a774d4c33$var$_defineProperty(_Object$create, $4fec840a774d4c33$var$kLastReject, {
        value: null,
        writable: true
    }), $4fec840a774d4c33$var$_defineProperty(_Object$create, $4fec840a774d4c33$var$kError, {
        value: null,
        writable: true
    }), $4fec840a774d4c33$var$_defineProperty(_Object$create, $4fec840a774d4c33$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $4fec840a774d4c33$var$_defineProperty(_Object$create, $4fec840a774d4c33$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$4fec840a774d4c33$var$kStream].read();
            if (data) {
                iterator[$4fec840a774d4c33$var$kLastPromise] = null;
                iterator[$4fec840a774d4c33$var$kLastResolve] = null;
                iterator[$4fec840a774d4c33$var$kLastReject] = null;
                resolve($4fec840a774d4c33$var$createIterResult(data, false));
            } else {
                iterator[$4fec840a774d4c33$var$kLastResolve] = resolve;
                iterator[$4fec840a774d4c33$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$4fec840a774d4c33$var$kLastPromise] = null;
    $ajkeH(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$4fec840a774d4c33$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$4fec840a774d4c33$var$kLastPromise] = null;
                iterator[$4fec840a774d4c33$var$kLastResolve] = null;
                iterator[$4fec840a774d4c33$var$kLastReject] = null;
                reject(err);
            }
            iterator[$4fec840a774d4c33$var$kError] = err;
            return;
        }
        var resolve = iterator[$4fec840a774d4c33$var$kLastResolve];
        if (resolve !== null) {
            iterator[$4fec840a774d4c33$var$kLastPromise] = null;
            iterator[$4fec840a774d4c33$var$kLastResolve] = null;
            iterator[$4fec840a774d4c33$var$kLastReject] = null;
            resolve($4fec840a774d4c33$var$createIterResult(undefined, true));
        }
        iterator[$4fec840a774d4c33$var$kEnded] = true;
    });
    stream.on('readable', $4fec840a774d4c33$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $4fec840a774d4c33$var$createReadableStreamAsyncIterator;

});
parcelRegister("ajkeH", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $781b602d67767261$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("7w9IA")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $781b602d67767261$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $781b602d67767261$var$noop() {}
function $781b602d67767261$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $781b602d67767261$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $781b602d67767261$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $781b602d67767261$var$once(callback || $781b602d67767261$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $781b602d67767261$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $781b602d67767261$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($781b602d67767261$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $781b602d67767261$var$eos;

});


parcelRegister("lAEFk", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("3uw87", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $28ad18cab71901a4$var$Transform;

var $7w9IA = parcelRequire("7w9IA");
var $28ad18cab71901a4$require$_require$codes = $7w9IA.codes;
var $28ad18cab71901a4$var$ERR_METHOD_NOT_IMPLEMENTED = $28ad18cab71901a4$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $28ad18cab71901a4$var$ERR_MULTIPLE_CALLBACK = $28ad18cab71901a4$require$_require$codes.ERR_MULTIPLE_CALLBACK, $28ad18cab71901a4$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $28ad18cab71901a4$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $28ad18cab71901a4$var$ERR_TRANSFORM_WITH_LENGTH_0 = $28ad18cab71901a4$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $7TTUN = parcelRequire("7TTUN");

(parcelRequire("v3bBu"))($28ad18cab71901a4$var$Transform, $7TTUN);
function $28ad18cab71901a4$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $28ad18cab71901a4$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $28ad18cab71901a4$var$Transform(options) {
    if (!(this instanceof $28ad18cab71901a4$var$Transform)) return new $28ad18cab71901a4$var$Transform(options);
    $7TTUN.call(this, options);
    this._transformState = {
        afterTransform: $28ad18cab71901a4$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $28ad18cab71901a4$var$prefinish);
}
function $28ad18cab71901a4$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $28ad18cab71901a4$var$done(_this, er, data);
    });
    else $28ad18cab71901a4$var$done(this, null, null);
}
$28ad18cab71901a4$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $7TTUN.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$28ad18cab71901a4$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $28ad18cab71901a4$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$28ad18cab71901a4$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$28ad18cab71901a4$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$28ad18cab71901a4$var$Transform.prototype._destroy = function(err, cb) {
    $7TTUN.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $28ad18cab71901a4$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $28ad18cab71901a4$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $28ad18cab71901a4$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("fLUve", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $b7b71312e2fe9973$var$PassThrough;

var $3uw87 = parcelRequire("3uw87");

(parcelRequire("v3bBu"))($b7b71312e2fe9973$var$PassThrough, $3uw87);
function $b7b71312e2fe9973$var$PassThrough(options) {
    if (!(this instanceof $b7b71312e2fe9973$var$PassThrough)) return new $b7b71312e2fe9973$var$PassThrough(options);
    $3uw87.call(this, options);
}
$b7b71312e2fe9973$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("gwu9c", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $c07705286646dcb8$var$eos;
function $c07705286646dcb8$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $7w9IA = parcelRequire("7w9IA");
var $c07705286646dcb8$require$_require$codes = $7w9IA.codes;
var $c07705286646dcb8$var$ERR_MISSING_ARGS = $c07705286646dcb8$require$_require$codes.ERR_MISSING_ARGS, $c07705286646dcb8$var$ERR_STREAM_DESTROYED = $c07705286646dcb8$require$_require$codes.ERR_STREAM_DESTROYED;
function $c07705286646dcb8$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $c07705286646dcb8$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $c07705286646dcb8$var$destroyer(stream, reading, writing, callback) {
    callback = $c07705286646dcb8$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($c07705286646dcb8$var$eos === undefined) $c07705286646dcb8$var$eos = (parcelRequire("ajkeH"));
    $c07705286646dcb8$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($c07705286646dcb8$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $c07705286646dcb8$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $c07705286646dcb8$var$call(fn) {
    fn();
}
function $c07705286646dcb8$var$pipe(from, to) {
    return from.pipe(to);
}
function $c07705286646dcb8$var$popCallback(streams) {
    if (!streams.length) return $c07705286646dcb8$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $c07705286646dcb8$var$noop;
    return streams.pop();
}
function $c07705286646dcb8$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $c07705286646dcb8$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $c07705286646dcb8$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $c07705286646dcb8$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($c07705286646dcb8$var$call);
            if (reading) return;
            destroys.forEach($c07705286646dcb8$var$call);
            callback(error);
        });
    });
    return streams.reduce($c07705286646dcb8$var$pipe);
}
module.exports = $c07705286646dcb8$var$pipeline;

});




parcelRegister("6EPBm", function(module, exports) {
'use strict';

var $5k7LC = parcelRequire("5k7LC");
var $4d8e8181b4bf2e98$require$Buffer = $5k7LC.Buffer;

var $v3bBu = parcelRequire("v3bBu");

var $gOR7Z = parcelRequire("gOR7Z");
var $4d8e8181b4bf2e98$var$ARRAY16 = new Array(16);
var $4d8e8181b4bf2e98$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $4d8e8181b4bf2e98$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $4d8e8181b4bf2e98$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $4d8e8181b4bf2e98$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $4d8e8181b4bf2e98$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $4d8e8181b4bf2e98$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $4d8e8181b4bf2e98$var$RIPEMD160() {
    $gOR7Z.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$v3bBu($4d8e8181b4bf2e98$var$RIPEMD160, $gOR7Z);
$4d8e8181b4bf2e98$var$RIPEMD160.prototype._update = function() {
    var words = $4d8e8181b4bf2e98$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $4d8e8181b4bf2e98$var$fn1(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[0], $4d8e8181b4bf2e98$var$sl[i]);
            tr = $4d8e8181b4bf2e98$var$fn5(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[0], $4d8e8181b4bf2e98$var$sr[i]);
        } else if (i < 32) {
            tl = $4d8e8181b4bf2e98$var$fn2(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[1], $4d8e8181b4bf2e98$var$sl[i]);
            tr = $4d8e8181b4bf2e98$var$fn4(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[1], $4d8e8181b4bf2e98$var$sr[i]);
        } else if (i < 48) {
            tl = $4d8e8181b4bf2e98$var$fn3(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[2], $4d8e8181b4bf2e98$var$sl[i]);
            tr = $4d8e8181b4bf2e98$var$fn3(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[2], $4d8e8181b4bf2e98$var$sr[i]);
        } else if (i < 64) {
            tl = $4d8e8181b4bf2e98$var$fn4(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[3], $4d8e8181b4bf2e98$var$sl[i]);
            tr = $4d8e8181b4bf2e98$var$fn2(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[3], $4d8e8181b4bf2e98$var$sr[i]);
        } else {
            tl = $4d8e8181b4bf2e98$var$fn5(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[4], $4d8e8181b4bf2e98$var$sl[i]);
            tr = $4d8e8181b4bf2e98$var$fn1(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[4], $4d8e8181b4bf2e98$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $4d8e8181b4bf2e98$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $4d8e8181b4bf2e98$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$4d8e8181b4bf2e98$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $4d8e8181b4bf2e98$require$Buffer.alloc ? $4d8e8181b4bf2e98$require$Buffer.alloc(20) : new $4d8e8181b4bf2e98$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $4d8e8181b4bf2e98$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $4d8e8181b4bf2e98$var$fn1(a, b, c, d, e, m, k, s) {
    return $4d8e8181b4bf2e98$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $4d8e8181b4bf2e98$var$fn2(a, b, c, d, e, m, k, s) {
    return $4d8e8181b4bf2e98$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $4d8e8181b4bf2e98$var$fn3(a, b, c, d, e, m, k, s) {
    return $4d8e8181b4bf2e98$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $4d8e8181b4bf2e98$var$fn4(a, b, c, d, e, m, k, s) {
    return $4d8e8181b4bf2e98$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $4d8e8181b4bf2e98$var$fn5(a, b, c, d, e, m, k, s) {
    return $4d8e8181b4bf2e98$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $4d8e8181b4bf2e98$var$RIPEMD160;

});

parcelRegister("a21Ya", function(module, exports) {
var $74db9e664dfd9270$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $74db9e664dfd9270$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$74db9e664dfd9270$var$exports.sha = (parcelRequire("dFso9"));

$74db9e664dfd9270$var$exports.sha1 = (parcelRequire("fWNgi"));

$74db9e664dfd9270$var$exports.sha224 = (parcelRequire("dCenE"));

$74db9e664dfd9270$var$exports.sha256 = (parcelRequire("jtWQG"));

$74db9e664dfd9270$var$exports.sha384 = (parcelRequire("1c7yZ"));

$74db9e664dfd9270$var$exports.sha512 = (parcelRequire("c0lzM"));

});
parcelRegister("dFso9", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $v3bBu = parcelRequire("v3bBu");

var $jCRNn = parcelRequire("jCRNn");

var $Wth4q = parcelRequire("Wth4q");
var $9f35200cb3ec19b0$require$Buffer = $Wth4q.Buffer;
var $9f35200cb3ec19b0$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f35200cb3ec19b0$var$W = new Array(80);
function $9f35200cb3ec19b0$var$Sha() {
    this.init();
    this._w = $9f35200cb3ec19b0$var$W;
    $jCRNn.call(this, 64, 56);
}
$v3bBu($9f35200cb3ec19b0$var$Sha, $jCRNn);
$9f35200cb3ec19b0$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f35200cb3ec19b0$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f35200cb3ec19b0$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f35200cb3ec19b0$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f35200cb3ec19b0$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f35200cb3ec19b0$var$rotl5(a) + $9f35200cb3ec19b0$var$ft(s, b, c, d) + e + W[j] + $9f35200cb3ec19b0$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f35200cb3ec19b0$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f35200cb3ec19b0$var$Sha.prototype._hash = function() {
    var H = $9f35200cb3ec19b0$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f35200cb3ec19b0$var$Sha;

});
parcelRegister("jCRNn", function(module, exports) {

var $Wth4q = parcelRequire("Wth4q");
var $e49b4b9320828ebb$require$Buffer = $Wth4q.Buffer;
// prototype class for hash functions
function $e49b4b9320828ebb$var$Hash(blockSize, finalSize) {
    this._block = $e49b4b9320828ebb$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$e49b4b9320828ebb$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $e49b4b9320828ebb$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$e49b4b9320828ebb$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$e49b4b9320828ebb$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $e49b4b9320828ebb$var$Hash;

});


parcelRegister("fWNgi", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $v3bBu = parcelRequire("v3bBu");

var $jCRNn = parcelRequire("jCRNn");

var $Wth4q = parcelRequire("Wth4q");
var $b9c27c2bc18fcde5$require$Buffer = $Wth4q.Buffer;
var $b9c27c2bc18fcde5$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $b9c27c2bc18fcde5$var$W = new Array(80);
function $b9c27c2bc18fcde5$var$Sha1() {
    this.init();
    this._w = $b9c27c2bc18fcde5$var$W;
    $jCRNn.call(this, 64, 56);
}
$v3bBu($b9c27c2bc18fcde5$var$Sha1, $jCRNn);
$b9c27c2bc18fcde5$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $b9c27c2bc18fcde5$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $b9c27c2bc18fcde5$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $b9c27c2bc18fcde5$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $b9c27c2bc18fcde5$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$b9c27c2bc18fcde5$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $b9c27c2bc18fcde5$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $b9c27c2bc18fcde5$var$rotl5(a) + $b9c27c2bc18fcde5$var$ft(s, b, c, d) + e + W[j] + $b9c27c2bc18fcde5$var$K[s] | 0;
        e = d;
        d = c;
        c = $b9c27c2bc18fcde5$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$b9c27c2bc18fcde5$var$Sha1.prototype._hash = function() {
    var H = $b9c27c2bc18fcde5$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $b9c27c2bc18fcde5$var$Sha1;

});

parcelRegister("dCenE", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $v3bBu = parcelRequire("v3bBu");

var $jtWQG = parcelRequire("jtWQG");

var $jCRNn = parcelRequire("jCRNn");

var $Wth4q = parcelRequire("Wth4q");
var $9e99faa5be7d643e$require$Buffer = $Wth4q.Buffer;
var $9e99faa5be7d643e$var$W = new Array(64);
function $9e99faa5be7d643e$var$Sha224() {
    this.init();
    this._w = $9e99faa5be7d643e$var$W // new Array(64)
    ;
    $jCRNn.call(this, 64, 56);
}
$v3bBu($9e99faa5be7d643e$var$Sha224, $jtWQG);
$9e99faa5be7d643e$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$9e99faa5be7d643e$var$Sha224.prototype._hash = function() {
    var H = $9e99faa5be7d643e$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $9e99faa5be7d643e$var$Sha224;

});
parcelRegister("jtWQG", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $v3bBu = parcelRequire("v3bBu");

var $jCRNn = parcelRequire("jCRNn");

var $Wth4q = parcelRequire("Wth4q");
var $e2ee5fe8d7032812$require$Buffer = $Wth4q.Buffer;
var $e2ee5fe8d7032812$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $e2ee5fe8d7032812$var$W = new Array(64);
function $e2ee5fe8d7032812$var$Sha256() {
    this.init();
    this._w = $e2ee5fe8d7032812$var$W // new Array(64)
    ;
    $jCRNn.call(this, 64, 56);
}
$v3bBu($e2ee5fe8d7032812$var$Sha256, $jCRNn);
$e2ee5fe8d7032812$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $e2ee5fe8d7032812$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $e2ee5fe8d7032812$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $e2ee5fe8d7032812$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $e2ee5fe8d7032812$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $e2ee5fe8d7032812$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $e2ee5fe8d7032812$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$e2ee5fe8d7032812$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $e2ee5fe8d7032812$var$gamma1(W[i - 2]) + W[i - 7] + $e2ee5fe8d7032812$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $e2ee5fe8d7032812$var$sigma1(e) + $e2ee5fe8d7032812$var$ch(e, f, g) + $e2ee5fe8d7032812$var$K[j] + W[j] | 0;
        var T2 = $e2ee5fe8d7032812$var$sigma0(a) + $e2ee5fe8d7032812$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$e2ee5fe8d7032812$var$Sha256.prototype._hash = function() {
    var H = $e2ee5fe8d7032812$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $e2ee5fe8d7032812$var$Sha256;

});


parcelRegister("1c7yZ", function(module, exports) {

var $v3bBu = parcelRequire("v3bBu");

var $c0lzM = parcelRequire("c0lzM");

var $jCRNn = parcelRequire("jCRNn");

var $Wth4q = parcelRequire("Wth4q");
var $0decc7569dc7c272$require$Buffer = $Wth4q.Buffer;
var $0decc7569dc7c272$var$W = new Array(160);
function $0decc7569dc7c272$var$Sha384() {
    this.init();
    this._w = $0decc7569dc7c272$var$W;
    $jCRNn.call(this, 128, 112);
}
$v3bBu($0decc7569dc7c272$var$Sha384, $c0lzM);
$0decc7569dc7c272$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$0decc7569dc7c272$var$Sha384.prototype._hash = function() {
    var H = $0decc7569dc7c272$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $0decc7569dc7c272$var$Sha384;

});
parcelRegister("c0lzM", function(module, exports) {

var $v3bBu = parcelRequire("v3bBu");

var $jCRNn = parcelRequire("jCRNn");

var $Wth4q = parcelRequire("Wth4q");
var $8bd638b23ac34e9a$require$Buffer = $Wth4q.Buffer;
var $8bd638b23ac34e9a$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bd638b23ac34e9a$var$W = new Array(160);
function $8bd638b23ac34e9a$var$Sha512() {
    this.init();
    this._w = $8bd638b23ac34e9a$var$W;
    $jCRNn.call(this, 128, 112);
}
$v3bBu($8bd638b23ac34e9a$var$Sha512, $jCRNn);
$8bd638b23ac34e9a$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bd638b23ac34e9a$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bd638b23ac34e9a$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bd638b23ac34e9a$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bd638b23ac34e9a$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bd638b23ac34e9a$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bd638b23ac34e9a$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bd638b23ac34e9a$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bd638b23ac34e9a$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bd638b23ac34e9a$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bd638b23ac34e9a$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bd638b23ac34e9a$var$Gamma0(xh, xl);
        var gamma0l = $8bd638b23ac34e9a$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bd638b23ac34e9a$var$Gamma1(xh, xl);
        var gamma1l = $8bd638b23ac34e9a$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bd638b23ac34e9a$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bd638b23ac34e9a$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bd638b23ac34e9a$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bd638b23ac34e9a$var$maj(ah, bh, ch);
        var majl = $8bd638b23ac34e9a$var$maj(al, bl, cl);
        var sigma0h = $8bd638b23ac34e9a$var$sigma0(ah, al);
        var sigma0l = $8bd638b23ac34e9a$var$sigma0(al, ah);
        var sigma1h = $8bd638b23ac34e9a$var$sigma1(eh, el);
        var sigma1l = $8bd638b23ac34e9a$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bd638b23ac34e9a$var$K[j];
        var Kil = $8bd638b23ac34e9a$var$K[j + 1];
        var chh = $8bd638b23ac34e9a$var$Ch(eh, fh, gh);
        var chl = $8bd638b23ac34e9a$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bd638b23ac34e9a$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bd638b23ac34e9a$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bd638b23ac34e9a$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bd638b23ac34e9a$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bd638b23ac34e9a$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bd638b23ac34e9a$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bd638b23ac34e9a$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bd638b23ac34e9a$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bd638b23ac34e9a$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bd638b23ac34e9a$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bd638b23ac34e9a$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bd638b23ac34e9a$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bd638b23ac34e9a$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bd638b23ac34e9a$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bd638b23ac34e9a$var$getCarry(this._hl, hl) | 0;
};
$8bd638b23ac34e9a$var$Sha512.prototype._hash = function() {
    var H = $8bd638b23ac34e9a$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bd638b23ac34e9a$var$Sha512;

});



parcelRegister("77fwb", function(module, exports) {

var $Wth4q = parcelRequire("Wth4q");
var $52e5397100350dcf$require$Buffer = $Wth4q.Buffer;

var $e2HvS = parcelRequire("e2HvS");
var $52e5397100350dcf$require$Transform = $e2HvS.Transform;

var $3872E = parcelRequire("3872E");
var $52e5397100350dcf$require$StringDecoder = $3872E.StringDecoder;

var $v3bBu = parcelRequire("v3bBu");
function $52e5397100350dcf$var$CipherBase(hashMode) {
    $52e5397100350dcf$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$v3bBu($52e5397100350dcf$var$CipherBase, $52e5397100350dcf$require$Transform);
$52e5397100350dcf$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === 'string') data = $52e5397100350dcf$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$52e5397100350dcf$var$CipherBase.prototype.setAutoPadding = function() {};
$52e5397100350dcf$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$52e5397100350dcf$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$52e5397100350dcf$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$52e5397100350dcf$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$52e5397100350dcf$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$52e5397100350dcf$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $52e5397100350dcf$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$52e5397100350dcf$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $52e5397100350dcf$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error('can\'t switch encodings');
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $52e5397100350dcf$var$CipherBase;

});


parcelRegister("j65bP", function(module, exports) {
'use strict';

var $v3bBu = parcelRequire("v3bBu");

var $3nQOH = parcelRequire("3nQOH");

var $77fwb = parcelRequire("77fwb");

var $Wth4q = parcelRequire("Wth4q");
var $de729a71cb7df339$require$Buffer = $Wth4q.Buffer;

var $2BrHl = parcelRequire("2BrHl");

var $6EPBm = parcelRequire("6EPBm");

var $a21Ya = parcelRequire("a21Ya");
var $de729a71cb7df339$var$ZEROS = $de729a71cb7df339$require$Buffer.alloc(128);
function $de729a71cb7df339$var$Hmac(alg, key) {
    $77fwb.call(this, 'digest');
    if (typeof key === 'string') key = $de729a71cb7df339$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $6EPBm() : $a21Ya(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $de729a71cb7df339$require$Buffer.concat([
        key,
        $de729a71cb7df339$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $de729a71cb7df339$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $de729a71cb7df339$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $6EPBm() : $a21Ya(alg);
    this._hash.update(ipad);
}
$v3bBu($de729a71cb7df339$var$Hmac, $77fwb);
$de729a71cb7df339$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$de729a71cb7df339$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $6EPBm() : $a21Ya(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $de729a71cb7df339$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $3nQOH($2BrHl, key);
    return new $de729a71cb7df339$var$Hmac(alg, key);
};

});
parcelRegister("3nQOH", function(module, exports) {
'use strict';

var $v3bBu = parcelRequire("v3bBu");

var $Wth4q = parcelRequire("Wth4q");
var $276c7d685fb1f219$require$Buffer = $Wth4q.Buffer;

var $77fwb = parcelRequire("77fwb");
var $276c7d685fb1f219$var$ZEROS = $276c7d685fb1f219$require$Buffer.alloc(128);
var $276c7d685fb1f219$var$blocksize = 64;
function $276c7d685fb1f219$var$Hmac(alg, key) {
    $77fwb.call(this, 'digest');
    if (typeof key === 'string') key = $276c7d685fb1f219$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $276c7d685fb1f219$var$blocksize) key = alg(key);
    else if (key.length < $276c7d685fb1f219$var$blocksize) key = $276c7d685fb1f219$require$Buffer.concat([
        key,
        $276c7d685fb1f219$var$ZEROS
    ], $276c7d685fb1f219$var$blocksize);
    var ipad = this._ipad = $276c7d685fb1f219$require$Buffer.allocUnsafe($276c7d685fb1f219$var$blocksize);
    var opad = this._opad = $276c7d685fb1f219$require$Buffer.allocUnsafe($276c7d685fb1f219$var$blocksize);
    for(var i = 0; i < $276c7d685fb1f219$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$v3bBu($276c7d685fb1f219$var$Hmac, $77fwb);
$276c7d685fb1f219$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$276c7d685fb1f219$var$Hmac.prototype._final = function() {
    var h = this._alg($276c7d685fb1f219$require$Buffer.concat(this._hash));
    return this._alg($276c7d685fb1f219$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $276c7d685fb1f219$var$Hmac;

});

parcelRegister("2BrHl", function(module, exports) {

var $8ZJxF = parcelRequire("8ZJxF");
module.exports = function(buffer) {
    return new $8ZJxF().update(buffer).digest();
};

});


parcelRegister("NKdOQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5kFDZ"));

});
parcelRegister("5kFDZ", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa\\/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa\\/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa\\/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa\\/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("fS6zE", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $b8e0ffa4349c8ce4$export$448fa22aedc9dbca, (v) => $b8e0ffa4349c8ce4$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $b8e0ffa4349c8ce4$export$b80c7ba289c8fa56, (v) => $b8e0ffa4349c8ce4$export$b80c7ba289c8fa56 = v);
var $b8e0ffa4349c8ce4$export$448fa22aedc9dbca;
var $b8e0ffa4349c8ce4$export$b80c7ba289c8fa56;

$b8e0ffa4349c8ce4$export$448fa22aedc9dbca = (parcelRequire("8U4Ei"));

$b8e0ffa4349c8ce4$export$b80c7ba289c8fa56 = (parcelRequire("5GCF3"));

});
parcelRegister("8U4Ei", function(module, exports) {

var $Wth4q = parcelRequire("Wth4q");
var $67b728dbcfdb7234$require$Buffer = $Wth4q.Buffer;

var $4ryRx = parcelRequire("4ryRx");

var $7DfkD = parcelRequire("7DfkD");

var $5GCF3 = parcelRequire("5GCF3");

var $fpAzU = parcelRequire("fpAzU");
var $67b728dbcfdb7234$var$ZERO_BUF;
var $67b728dbcfdb7234$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $67b728dbcfdb7234$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $67b728dbcfdb7234$var$checks = [];
function $67b728dbcfdb7234$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$67b728dbcfdb7234$var$subtle || !$67b728dbcfdb7234$var$subtle.importKey || !$67b728dbcfdb7234$var$subtle.deriveBits) return Promise.resolve(false);
    if ($67b728dbcfdb7234$var$checks[algo] !== undefined) return $67b728dbcfdb7234$var$checks[algo];
    $67b728dbcfdb7234$var$ZERO_BUF = $67b728dbcfdb7234$var$ZERO_BUF || $67b728dbcfdb7234$require$Buffer.alloc(8);
    var prom = $67b728dbcfdb7234$var$browserPbkdf2($67b728dbcfdb7234$var$ZERO_BUF, $67b728dbcfdb7234$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $67b728dbcfdb7234$var$checks[algo] = prom;
    return prom;
}
var $67b728dbcfdb7234$var$nextTick;
function $67b728dbcfdb7234$var$getNextTick() {
    if ($67b728dbcfdb7234$var$nextTick) return $67b728dbcfdb7234$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $67b728dbcfdb7234$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $67b728dbcfdb7234$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $67b728dbcfdb7234$var$nextTick = $parcel$global.setImmediate;
    else $67b728dbcfdb7234$var$nextTick = $parcel$global.setTimeout;
    return $67b728dbcfdb7234$var$nextTick;
}
function $67b728dbcfdb7234$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $67b728dbcfdb7234$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $67b728dbcfdb7234$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $67b728dbcfdb7234$require$Buffer.from(res);
    });
}
function $67b728dbcfdb7234$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $67b728dbcfdb7234$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $67b728dbcfdb7234$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $67b728dbcfdb7234$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $67b728dbcfdb7234$var$getNextTick()(function() {
            var out;
            try {
                out = $5GCF3(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $4ryRx(iterations, keylen);
    password = $fpAzU(password, $7DfkD, 'Password');
    salt = $fpAzU(salt, $7DfkD, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $67b728dbcfdb7234$var$resolvePromise($67b728dbcfdb7234$var$checkNative(algo).then(function(resp) {
        if (resp) return $67b728dbcfdb7234$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $5GCF3(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("4ryRx", function(module, exports) {
var $33c4ba00ce725092$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $33c4ba00ce725092$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("7DfkD", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
var $58e8117f50848d7e$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $58e8117f50848d7e$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $58e8117f50848d7e$var$pVersionMajor = parseInt($6cAn5.version.split('.')[0].slice(1), 10);
    $58e8117f50848d7e$var$defaultEncoding = $58e8117f50848d7e$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $58e8117f50848d7e$var$defaultEncoding = 'utf-8';
module.exports = $58e8117f50848d7e$var$defaultEncoding;

});

parcelRegister("5GCF3", function(module, exports) {

var $2BrHl = parcelRequire("2BrHl");

var $6EPBm = parcelRequire("6EPBm");

var $a21Ya = parcelRequire("a21Ya");

var $Wth4q = parcelRequire("Wth4q");
var $423edd4c77469706$require$Buffer = $Wth4q.Buffer;

var $4ryRx = parcelRequire("4ryRx");

var $7DfkD = parcelRequire("7DfkD");

var $fpAzU = parcelRequire("fpAzU");
var $423edd4c77469706$var$ZEROS = $423edd4c77469706$require$Buffer.alloc(128);
var $423edd4c77469706$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $423edd4c77469706$var$Hmac(alg, key, saltLen) {
    var hash = $423edd4c77469706$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $423edd4c77469706$require$Buffer.concat([
        key,
        $423edd4c77469706$var$ZEROS
    ], blocksize);
    var ipad = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + $423edd4c77469706$var$sizes[alg]);
    var opad = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + $423edd4c77469706$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $423edd4c77469706$var$sizes[alg];
}
$423edd4c77469706$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $423edd4c77469706$var$getDigest(alg) {
    function shaFunc(data) {
        return $a21Ya(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $6EPBm().update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
    if (alg === 'md5') return $2BrHl;
    return shaFunc;
}
function $423edd4c77469706$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $4ryRx(iterations, keylen);
    password = $fpAzU(password, $7DfkD, 'Password');
    salt = $fpAzU(salt, $7DfkD, 'Salt');
    digest = digest || 'sha1';
    var hmac = new $423edd4c77469706$var$Hmac(digest, password, salt.length);
    var DK = $423edd4c77469706$require$Buffer.allocUnsafe(keylen);
    var block1 = $423edd4c77469706$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $423edd4c77469706$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $423edd4c77469706$var$pbkdf2;

});
parcelRegister("fpAzU", function(module, exports) {

var $Wth4q = parcelRequire("Wth4q");
var $b38590769b62ee4f$require$Buffer = $Wth4q.Buffer;
module.exports = function(thing, encoding, name) {
    if ($b38590769b62ee4f$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === 'string') return $b38590769b62ee4f$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $b38590769b62ee4f$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView');
};

});




parcelRegister("a2ApW", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $74f6570266d69f84$export$bdd223f16383713e, (v) => $74f6570266d69f84$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $74f6570266d69f84$export$26e5786e8ac8e530, (v) => $74f6570266d69f84$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $74f6570266d69f84$export$2f64596b8cbf08b4, (v) => $74f6570266d69f84$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $74f6570266d69f84$export$20533d26f07f1ee0, (v) => $74f6570266d69f84$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $74f6570266d69f84$export$12ada9414fbc594c, (v) => $74f6570266d69f84$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $74f6570266d69f84$export$2ce6d8d0e8b04e1a, (v) => $74f6570266d69f84$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $74f6570266d69f84$export$36b6d6ef312eab39, (v) => $74f6570266d69f84$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $74f6570266d69f84$export$f5e7e39d57cd9700, (v) => $74f6570266d69f84$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $74f6570266d69f84$export$dedd8dc3dc62b370, (v) => $74f6570266d69f84$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $74f6570266d69f84$export$58a258485f1e49f6, (v) => $74f6570266d69f84$export$58a258485f1e49f6 = v);
var $74f6570266d69f84$export$bdd223f16383713e;
var $74f6570266d69f84$export$26e5786e8ac8e530;
var $74f6570266d69f84$export$2f64596b8cbf08b4;
var $74f6570266d69f84$export$20533d26f07f1ee0;
var $74f6570266d69f84$export$12ada9414fbc594c;
var $74f6570266d69f84$export$2ce6d8d0e8b04e1a;
var $74f6570266d69f84$export$36b6d6ef312eab39;
var $74f6570266d69f84$export$f5e7e39d57cd9700;
var $74f6570266d69f84$export$dedd8dc3dc62b370;
var $74f6570266d69f84$export$58a258485f1e49f6;

var $1Awtz = parcelRequire("1Awtz");

var $gcaJj = parcelRequire("gcaJj");

var $6WLno = parcelRequire("6WLno");

var $dQ4TD = parcelRequire("dQ4TD");

var $55KiC = parcelRequire("55KiC");
function $74f6570266d69f84$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($6WLno[suite]) {
        keyLen = $6WLno[suite].key;
        ivLen = $6WLno[suite].iv;
    } else if ($dQ4TD[suite]) {
        keyLen = $dQ4TD[suite].key * 8;
        ivLen = $dQ4TD[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $55KiC(password, false, keyLen, ivLen);
    return $74f6570266d69f84$var$createCipheriv(suite, keys.key, keys.iv);
}
function $74f6570266d69f84$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($6WLno[suite]) {
        keyLen = $6WLno[suite].key;
        ivLen = $6WLno[suite].iv;
    } else if ($dQ4TD[suite]) {
        keyLen = $dQ4TD[suite].key * 8;
        ivLen = $dQ4TD[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $55KiC(password, false, keyLen, ivLen);
    return $74f6570266d69f84$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $74f6570266d69f84$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($6WLno[suite]) return $gcaJj.createCipheriv(suite, key, iv);
    if ($dQ4TD[suite]) return new $1Awtz({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $74f6570266d69f84$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($6WLno[suite]) return $gcaJj.createDecipheriv(suite, key, iv);
    if ($dQ4TD[suite]) return new $1Awtz({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $74f6570266d69f84$var$getCiphers() {
    return Object.keys($dQ4TD).concat($gcaJj.getCiphers());
}
$74f6570266d69f84$export$bdd223f16383713e = $74f6570266d69f84$export$26e5786e8ac8e530 = $74f6570266d69f84$var$createCipher;
$74f6570266d69f84$export$2f64596b8cbf08b4 = $74f6570266d69f84$export$20533d26f07f1ee0 = $74f6570266d69f84$var$createCipheriv;
$74f6570266d69f84$export$12ada9414fbc594c = $74f6570266d69f84$export$2ce6d8d0e8b04e1a = $74f6570266d69f84$var$createDecipher;
$74f6570266d69f84$export$36b6d6ef312eab39 = $74f6570266d69f84$export$f5e7e39d57cd9700 = $74f6570266d69f84$var$createDecipheriv;
$74f6570266d69f84$export$dedd8dc3dc62b370 = $74f6570266d69f84$export$58a258485f1e49f6 = $74f6570266d69f84$var$getCiphers;

});
parcelRegister("1Awtz", function(module, exports) {

var $5k7LC = parcelRequire("5k7LC");
var $12825845b88e2981$require$Buffer = $5k7LC.Buffer;

var $77fwb = parcelRequire("77fwb");

var $bsIyp = parcelRequire("bsIyp");

var $v3bBu = parcelRequire("v3bBu");
var $12825845b88e2981$var$modes = {
    'des-ede3-cbc': $bsIyp.CBC.instantiate($bsIyp.EDE),
    'des-ede3': $bsIyp.EDE,
    'des-ede-cbc': $bsIyp.CBC.instantiate($bsIyp.EDE),
    'des-ede': $bsIyp.EDE,
    'des-cbc': $bsIyp.CBC.instantiate($bsIyp.DES),
    'des-ecb': $bsIyp.DES
};
$12825845b88e2981$var$modes.des = $12825845b88e2981$var$modes['des-cbc'];
$12825845b88e2981$var$modes.des3 = $12825845b88e2981$var$modes['des-ede3-cbc'];
module.exports = $12825845b88e2981$var$DES;
$v3bBu($12825845b88e2981$var$DES, $77fwb);
function $12825845b88e2981$var$DES(opts) {
    $77fwb.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $12825845b88e2981$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $12825845b88e2981$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$12825845b88e2981$var$DES.prototype._update = function(data) {
    return new $12825845b88e2981$require$Buffer(this._des.update(data));
};
$12825845b88e2981$var$DES.prototype._final = function() {
    return new $12825845b88e2981$require$Buffer(this._des.final());
};

});
parcelRegister("bsIyp", function(module, exports) {

$parcel$export(module.exports, "DES", () => $8584dec09db13d9c$export$cc8859615686b300, (v) => $8584dec09db13d9c$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $8584dec09db13d9c$export$8ad3f227af08fcc5, (v) => $8584dec09db13d9c$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $8584dec09db13d9c$export$947646e34766044f, (v) => $8584dec09db13d9c$export$947646e34766044f = v);
var $8584dec09db13d9c$export$eab97d15b1788b8d;
var $8584dec09db13d9c$export$26e5786e8ac8e530;
var $8584dec09db13d9c$export$cc8859615686b300;
var $8584dec09db13d9c$export$8ad3f227af08fcc5;
var $8584dec09db13d9c$export$947646e34766044f;
'use strict';

$8584dec09db13d9c$export$eab97d15b1788b8d = (parcelRequire("1Qr12"));

$8584dec09db13d9c$export$26e5786e8ac8e530 = (parcelRequire("lE1WX"));

$8584dec09db13d9c$export$cc8859615686b300 = (parcelRequire("6uemC"));

$8584dec09db13d9c$export$8ad3f227af08fcc5 = (parcelRequire("bdh1b"));

$8584dec09db13d9c$export$947646e34766044f = (parcelRequire("d53eL"));

});
parcelRegister("1Qr12", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $157f9a87c9609c03$export$cfaef8ed399428b0, (v) => $157f9a87c9609c03$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $157f9a87c9609c03$export$a80c7deaea7cbd80, (v) => $157f9a87c9609c03$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $157f9a87c9609c03$export$ed7577ae6e1cd0ef, (v) => $157f9a87c9609c03$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $157f9a87c9609c03$export$5dcbef3aa594f567, (v) => $157f9a87c9609c03$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $157f9a87c9609c03$export$5bc8001ca71ed9c5, (v) => $157f9a87c9609c03$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $157f9a87c9609c03$export$3e714e2c5d5d8cb2, (v) => $157f9a87c9609c03$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $157f9a87c9609c03$export$94c3e544fd062b7f, (v) => $157f9a87c9609c03$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $157f9a87c9609c03$export$9f77e0932fb78f72, (v) => $157f9a87c9609c03$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $157f9a87c9609c03$export$d865ce2836f5927f, (v) => $157f9a87c9609c03$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $157f9a87c9609c03$export$95e62ad65da8b7d2, (v) => $157f9a87c9609c03$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $157f9a87c9609c03$export$209139ff098c441a, (v) => $157f9a87c9609c03$export$209139ff098c441a = v);
var $157f9a87c9609c03$export$cfaef8ed399428b0;
var $157f9a87c9609c03$export$a80c7deaea7cbd80;
var $157f9a87c9609c03$export$ed7577ae6e1cd0ef;
var $157f9a87c9609c03$export$5dcbef3aa594f567;
var $157f9a87c9609c03$export$5bc8001ca71ed9c5;
var $157f9a87c9609c03$export$3e714e2c5d5d8cb2;
var $157f9a87c9609c03$export$94c3e544fd062b7f;
var $157f9a87c9609c03$export$9f77e0932fb78f72;
var $157f9a87c9609c03$export$d865ce2836f5927f;
var $157f9a87c9609c03$export$95e62ad65da8b7d2;
var $157f9a87c9609c03$export$209139ff098c441a;
'use strict';
$157f9a87c9609c03$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$157f9a87c9609c03$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$157f9a87c9609c03$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$157f9a87c9609c03$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$157f9a87c9609c03$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$157f9a87c9609c03$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $157f9a87c9609c03$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$157f9a87c9609c03$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $157f9a87c9609c03$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $157f9a87c9609c03$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $157f9a87c9609c03$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $157f9a87c9609c03$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$157f9a87c9609c03$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $157f9a87c9609c03$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$157f9a87c9609c03$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $157f9a87c9609c03$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $157f9a87c9609c03$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $157f9a87c9609c03$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$157f9a87c9609c03$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $157f9a87c9609c03$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $157f9a87c9609c03$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$157f9a87c9609c03$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("lE1WX", function(module, exports) {
'use strict';

var $gxaFy = parcelRequire("gxaFy");
function $fc1ed8a00916f8f8$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $fc1ed8a00916f8f8$var$Cipher;
$fc1ed8a00916f8f8$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$fc1ed8a00916f8f8$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$fc1ed8a00916f8f8$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$fc1ed8a00916f8f8$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$fc1ed8a00916f8f8$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$fc1ed8a00916f8f8$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$fc1ed8a00916f8f8$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$fc1ed8a00916f8f8$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$fc1ed8a00916f8f8$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$fc1ed8a00916f8f8$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$fc1ed8a00916f8f8$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $gxaFy.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("gxaFy", function(module, exports) {
module.exports = $c098011ba04e0256$var$assert;
function $c098011ba04e0256$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$c098011ba04e0256$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("6uemC", function(module, exports) {
'use strict';

var $gxaFy = parcelRequire("gxaFy");

var $v3bBu = parcelRequire("v3bBu");

var $1Qr12 = parcelRequire("1Qr12");

var $lE1WX = parcelRequire("lE1WX");
function $4b90afcb2a1cbace$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $4b90afcb2a1cbace$var$DES(options) {
    $lE1WX.call(this, options);
    var state = new $4b90afcb2a1cbace$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$v3bBu($4b90afcb2a1cbace$var$DES, $lE1WX);
module.exports = $4b90afcb2a1cbace$var$DES;
$4b90afcb2a1cbace$var$DES.create = function create(options) {
    return new $4b90afcb2a1cbace$var$DES(options);
};
var $4b90afcb2a1cbace$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$4b90afcb2a1cbace$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $gxaFy.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $1Qr12.readUInt32BE(key, 0);
    var kR = $1Qr12.readUInt32BE(key, 4);
    $1Qr12.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $4b90afcb2a1cbace$var$shiftTable[i >>> 1];
        kL = $1Qr12.r28shl(kL, shift);
        kR = $1Qr12.r28shl(kR, shift);
        $1Qr12.pc2(kL, kR, state.keys, i);
    }
};
$4b90afcb2a1cbace$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $1Qr12.readUInt32BE(inp, inOff);
    var r = $1Qr12.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $1Qr12.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $1Qr12.writeUInt32BE(out, l, outOff);
    $1Qr12.writeUInt32BE(out, r, outOff + 4);
};
$4b90afcb2a1cbace$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$4b90afcb2a1cbace$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$gxaFy.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$4b90afcb2a1cbace$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $1Qr12.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $1Qr12.substitute(keyL, keyR);
        var f = $1Qr12.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $1Qr12.rip(r, l, out, off);
};
$4b90afcb2a1cbace$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $1Qr12.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $1Qr12.substitute(keyL, keyR);
        var f = $1Qr12.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $1Qr12.rip(l, r, out, off);
};

});

parcelRegister("bdh1b", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $829e1c11ed1f1a2c$export$f9bb8d20ccc7477a, (v) => $829e1c11ed1f1a2c$export$f9bb8d20ccc7477a = v);
var $829e1c11ed1f1a2c$export$f9bb8d20ccc7477a;
'use strict';

var $gxaFy = parcelRequire("gxaFy");

var $v3bBu = parcelRequire("v3bBu");
var $829e1c11ed1f1a2c$var$proto = {};
function $829e1c11ed1f1a2c$var$CBCState(iv) {
    $gxaFy.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $829e1c11ed1f1a2c$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $v3bBu(CBC, Base);
    var keys = Object.keys($829e1c11ed1f1a2c$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $829e1c11ed1f1a2c$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$829e1c11ed1f1a2c$export$f9bb8d20ccc7477a = $829e1c11ed1f1a2c$var$instantiate;
$829e1c11ed1f1a2c$var$proto._cbcInit = function _cbcInit() {
    var state = new $829e1c11ed1f1a2c$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$829e1c11ed1f1a2c$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("d53eL", function(module, exports) {
'use strict';

var $gxaFy = parcelRequire("gxaFy");

var $v3bBu = parcelRequire("v3bBu");

var $lE1WX = parcelRequire("lE1WX");

var $6uemC = parcelRequire("6uemC");
function $02752213ee35ee04$var$EDEState(type, key) {
    $gxaFy.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $6uemC.create({
            type: 'encrypt',
            key: k1
        }),
        $6uemC.create({
            type: 'decrypt',
            key: k2
        }),
        $6uemC.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $6uemC.create({
            type: 'decrypt',
            key: k3
        }),
        $6uemC.create({
            type: 'encrypt',
            key: k2
        }),
        $6uemC.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $02752213ee35ee04$var$EDE(options) {
    $lE1WX.call(this, options);
    var state = new $02752213ee35ee04$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$v3bBu($02752213ee35ee04$var$EDE, $lE1WX);
module.exports = $02752213ee35ee04$var$EDE;
$02752213ee35ee04$var$EDE.create = function create(options) {
    return new $02752213ee35ee04$var$EDE(options);
};
$02752213ee35ee04$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$02752213ee35ee04$var$EDE.prototype._pad = $6uemC.prototype._pad;
$02752213ee35ee04$var$EDE.prototype._unpad = $6uemC.prototype._unpad;

});



parcelRegister("gcaJj", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $bca6170d70d22f8b$export$2f64596b8cbf08b4, (v) => $bca6170d70d22f8b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $bca6170d70d22f8b$export$36b6d6ef312eab39, (v) => $bca6170d70d22f8b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $bca6170d70d22f8b$export$58a258485f1e49f6, (v) => $bca6170d70d22f8b$export$58a258485f1e49f6 = v);
var $bca6170d70d22f8b$export$bdd223f16383713e;
var $bca6170d70d22f8b$export$26e5786e8ac8e530;
var $bca6170d70d22f8b$export$2f64596b8cbf08b4;
var $bca6170d70d22f8b$export$20533d26f07f1ee0;
var $bca6170d70d22f8b$export$12ada9414fbc594c;
var $bca6170d70d22f8b$export$2ce6d8d0e8b04e1a;
var $bca6170d70d22f8b$export$36b6d6ef312eab39;
var $bca6170d70d22f8b$export$f5e7e39d57cd9700;
var $bca6170d70d22f8b$export$dedd8dc3dc62b370;
var $bca6170d70d22f8b$export$58a258485f1e49f6;

var $8YWSl = parcelRequire("8YWSl");

var $i9P5q = parcelRequire("i9P5q");

var $8DplL = parcelRequire("8DplL");
function $bca6170d70d22f8b$var$getCiphers() {
    return Object.keys($8DplL);
}
$bca6170d70d22f8b$export$bdd223f16383713e = $bca6170d70d22f8b$export$26e5786e8ac8e530 = $8YWSl.createCipher;
$bca6170d70d22f8b$export$2f64596b8cbf08b4 = $bca6170d70d22f8b$export$20533d26f07f1ee0 = $8YWSl.createCipheriv;
$bca6170d70d22f8b$export$12ada9414fbc594c = $bca6170d70d22f8b$export$2ce6d8d0e8b04e1a = $i9P5q.createDecipher;
$bca6170d70d22f8b$export$36b6d6ef312eab39 = $bca6170d70d22f8b$export$f5e7e39d57cd9700 = $i9P5q.createDecipheriv;
$bca6170d70d22f8b$export$dedd8dc3dc62b370 = $bca6170d70d22f8b$export$58a258485f1e49f6 = $bca6170d70d22f8b$var$getCiphers;

});
parcelRegister("8YWSl", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68a198cd46e098a5$export$2f64596b8cbf08b4, (v) => $68a198cd46e098a5$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68a198cd46e098a5$export$bdd223f16383713e, (v) => $68a198cd46e098a5$export$bdd223f16383713e = v);
var $68a198cd46e098a5$export$2f64596b8cbf08b4;
var $68a198cd46e098a5$export$bdd223f16383713e;

var $6WLno = parcelRequire("6WLno");

var $dsL7z = parcelRequire("dsL7z");

var $Wth4q = parcelRequire("Wth4q");
var $68a198cd46e098a5$require$Buffer = $Wth4q.Buffer;

var $ecK7f = parcelRequire("ecK7f");

var $77fwb = parcelRequire("77fwb");

var $h0C5b = parcelRequire("h0C5b");

var $55KiC = parcelRequire("55KiC");

var $v3bBu = parcelRequire("v3bBu");
function $68a198cd46e098a5$var$Cipher(mode, key, iv) {
    $77fwb.call(this);
    this._cache = new $68a198cd46e098a5$var$Splitter();
    this._cipher = new $h0C5b.AES(key);
    this._prev = $68a198cd46e098a5$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$v3bBu($68a198cd46e098a5$var$Cipher, $77fwb);
$68a198cd46e098a5$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68a198cd46e098a5$require$Buffer.concat(out);
};
var $68a198cd46e098a5$var$PADDING = $68a198cd46e098a5$require$Buffer.alloc(16, 0x10);
$68a198cd46e098a5$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68a198cd46e098a5$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$68a198cd46e098a5$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68a198cd46e098a5$var$Splitter() {
    this.cache = $68a198cd46e098a5$require$Buffer.allocUnsafe(0);
}
$68a198cd46e098a5$var$Splitter.prototype.add = function(data) {
    this.cache = $68a198cd46e098a5$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68a198cd46e098a5$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68a198cd46e098a5$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68a198cd46e098a5$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68a198cd46e098a5$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68a198cd46e098a5$var$createCipheriv(suite, password, iv) {
    var config = $6WLno[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $68a198cd46e098a5$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $68a198cd46e098a5$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $ecK7f(config.module, password, iv);
    else if (config.type === 'auth') return new $dsL7z(config.module, password, iv);
    return new $68a198cd46e098a5$var$Cipher(config.module, password, iv);
}
function $68a198cd46e098a5$var$createCipher(suite, password) {
    var config = $6WLno[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $55KiC(password, false, config.key, config.iv);
    return $68a198cd46e098a5$var$createCipheriv(suite, keys.key, keys.iv);
}
$68a198cd46e098a5$export$2f64596b8cbf08b4 = $68a198cd46e098a5$var$createCipheriv;
$68a198cd46e098a5$export$bdd223f16383713e = $68a198cd46e098a5$var$createCipher;

});
parcelRegister("6WLno", function(module, exports) {








var $50ece8ccaacc95aa$var$modeModules = {
    ECB: (parcelRequire("2r4jQ")),
    CBC: (parcelRequire("171QV")),
    CFB: (parcelRequire("7gub3")),
    CFB8: (parcelRequire("hHOIy")),
    CFB1: (parcelRequire("hJx3X")),
    OFB: (parcelRequire("3PEE4")),
    CTR: (parcelRequire("5VEEg")),
    GCM: (parcelRequire("5VEEg"))
};

var $8DplL = parcelRequire("8DplL");
for(var $50ece8ccaacc95aa$var$key in $8DplL)$8DplL[$50ece8ccaacc95aa$var$key].module = $50ece8ccaacc95aa$var$modeModules[$8DplL[$50ece8ccaacc95aa$var$key].mode];
module.exports = $8DplL;

});
parcelRegister("2r4jQ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $1c61741219819c7a$export$5b0f6292f11d1d18, (v) => $1c61741219819c7a$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $1c61741219819c7a$export$e85a0c9a1067c5d3, (v) => $1c61741219819c7a$export$e85a0c9a1067c5d3 = v);
var $1c61741219819c7a$export$5b0f6292f11d1d18;
var $1c61741219819c7a$export$e85a0c9a1067c5d3;
$1c61741219819c7a$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$1c61741219819c7a$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("171QV", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $0cf7e1c4789e90b1$export$5b0f6292f11d1d18, (v) => $0cf7e1c4789e90b1$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $0cf7e1c4789e90b1$export$e85a0c9a1067c5d3, (v) => $0cf7e1c4789e90b1$export$e85a0c9a1067c5d3 = v);
var $0cf7e1c4789e90b1$export$5b0f6292f11d1d18;
var $0cf7e1c4789e90b1$export$e85a0c9a1067c5d3;

var $hWuQG = parcelRequire("hWuQG");
$0cf7e1c4789e90b1$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $hWuQG(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$0cf7e1c4789e90b1$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $hWuQG(out, pad);
};

});
parcelRegister("hWuQG", function(module, exports) {

var $5k7LC = parcelRequire("5k7LC");
var $d0ffc85ebd18b8c9$require$Buffer = $5k7LC.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $d0ffc85ebd18b8c9$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("7gub3", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $54a16fa1fdb145af$export$5b0f6292f11d1d18, (v) => $54a16fa1fdb145af$export$5b0f6292f11d1d18 = v);
var $54a16fa1fdb145af$export$5b0f6292f11d1d18;

var $Wth4q = parcelRequire("Wth4q");
var $54a16fa1fdb145af$require$Buffer = $Wth4q.Buffer;

var $hWuQG = parcelRequire("hWuQG");
function $54a16fa1fdb145af$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $hWuQG(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $54a16fa1fdb145af$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$54a16fa1fdb145af$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $54a16fa1fdb145af$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $54a16fa1fdb145af$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $54a16fa1fdb145af$require$Buffer.concat([
                out,
                $54a16fa1fdb145af$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $54a16fa1fdb145af$require$Buffer.concat([
                out,
                $54a16fa1fdb145af$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("hHOIy", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $ce3dcb4bc3fa3501$export$5b0f6292f11d1d18, (v) => $ce3dcb4bc3fa3501$export$5b0f6292f11d1d18 = v);
var $ce3dcb4bc3fa3501$export$5b0f6292f11d1d18;

var $Wth4q = parcelRequire("Wth4q");
var $ce3dcb4bc3fa3501$require$Buffer = $Wth4q.Buffer;
function $ce3dcb4bc3fa3501$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $ce3dcb4bc3fa3501$require$Buffer.concat([
        self._prev.slice(1),
        $ce3dcb4bc3fa3501$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$ce3dcb4bc3fa3501$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $ce3dcb4bc3fa3501$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $ce3dcb4bc3fa3501$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("hJx3X", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $ce90493eb3a7fe0a$export$5b0f6292f11d1d18, (v) => $ce90493eb3a7fe0a$export$5b0f6292f11d1d18 = v);
var $ce90493eb3a7fe0a$export$5b0f6292f11d1d18;

var $Wth4q = parcelRequire("Wth4q");
var $ce90493eb3a7fe0a$require$Buffer = $Wth4q.Buffer;
function $ce90493eb3a7fe0a$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $ce90493eb3a7fe0a$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $ce90493eb3a7fe0a$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $ce90493eb3a7fe0a$require$Buffer.allocUnsafe(buffer.length);
    buffer = $ce90493eb3a7fe0a$require$Buffer.concat([
        buffer,
        $ce90493eb3a7fe0a$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$ce90493eb3a7fe0a$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $ce90493eb3a7fe0a$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $ce90493eb3a7fe0a$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("3PEE4", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2ca5a9cd9f4302f4$export$5b0f6292f11d1d18, (v) => $2ca5a9cd9f4302f4$export$5b0f6292f11d1d18 = v);
var $2ca5a9cd9f4302f4$export$5b0f6292f11d1d18;

var $5k7LC = parcelRequire("5k7LC");
var $2ca5a9cd9f4302f4$require$Buffer = $5k7LC.Buffer;

var $hWuQG = parcelRequire("hWuQG");
function $2ca5a9cd9f4302f4$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$2ca5a9cd9f4302f4$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $2ca5a9cd9f4302f4$require$Buffer.concat([
        self._cache,
        $2ca5a9cd9f4302f4$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $hWuQG(chunk, pad);
};

});

parcelRegister("5VEEg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $4511ce87a2b6ec4f$export$5b0f6292f11d1d18, (v) => $4511ce87a2b6ec4f$export$5b0f6292f11d1d18 = v);
var $4511ce87a2b6ec4f$export$5b0f6292f11d1d18;

var $hWuQG = parcelRequire("hWuQG");

var $Wth4q = parcelRequire("Wth4q");
var $4511ce87a2b6ec4f$require$Buffer = $Wth4q.Buffer;

var $eYeWA = parcelRequire("eYeWA");
function $4511ce87a2b6ec4f$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $eYeWA(self._prev);
    return out;
}
var $4511ce87a2b6ec4f$var$blockSize = 16;
$4511ce87a2b6ec4f$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $4511ce87a2b6ec4f$var$blockSize);
    var start = self._cache.length;
    self._cache = $4511ce87a2b6ec4f$require$Buffer.concat([
        self._cache,
        $4511ce87a2b6ec4f$require$Buffer.allocUnsafe(chunkNum * $4511ce87a2b6ec4f$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $4511ce87a2b6ec4f$var$getBlock(self);
        var offset = start + i * $4511ce87a2b6ec4f$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $hWuQG(chunk, pad);
};

});
parcelRegister("eYeWA", function(module, exports) {
function $ae6242d5e2554d0f$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $ae6242d5e2554d0f$var$incr32;

});


parcelRegister("8DplL", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("dsL7z", function(module, exports) {

var $h0C5b = parcelRequire("h0C5b");

var $Wth4q = parcelRequire("Wth4q");
var $9cd2712b02891133$require$Buffer = $Wth4q.Buffer;

var $77fwb = parcelRequire("77fwb");

var $v3bBu = parcelRequire("v3bBu");

var $3wyrd = parcelRequire("3wyrd");

var $hWuQG = parcelRequire("hWuQG");

var $eYeWA = parcelRequire("eYeWA");
function $9cd2712b02891133$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $9cd2712b02891133$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $9cd2712b02891133$require$Buffer.concat([
            iv,
            $9cd2712b02891133$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $9cd2712b02891133$require$Buffer.concat([
            iv,
            $9cd2712b02891133$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $3wyrd(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($9cd2712b02891133$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($9cd2712b02891133$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $9cd2712b02891133$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $9cd2712b02891133$require$Buffer.from(self._finID);
    $eYeWA(out);
    return out;
}
function $9cd2712b02891133$var$StreamCipher(mode, key, iv, decrypt) {
    $77fwb.call(this);
    var h = $9cd2712b02891133$require$Buffer.alloc(4, 0);
    this._cipher = new $h0C5b.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $3wyrd(ck);
    iv = $9cd2712b02891133$var$calcIv(this, iv, ck);
    this._prev = $9cd2712b02891133$require$Buffer.from(iv);
    this._cache = $9cd2712b02891133$require$Buffer.allocUnsafe(0);
    this._secCache = $9cd2712b02891133$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$v3bBu($9cd2712b02891133$var$StreamCipher, $77fwb);
$9cd2712b02891133$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $9cd2712b02891133$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$9cd2712b02891133$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $hWuQG(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $9cd2712b02891133$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$9cd2712b02891133$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$9cd2712b02891133$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$9cd2712b02891133$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$9cd2712b02891133$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $9cd2712b02891133$var$StreamCipher;

});
parcelRegister("h0C5b", function(module, exports) {

$parcel$export(module.exports, "AES", () => $c61ffa2be163e1f3$export$b80fbe1c3a2b92b5, (v) => $c61ffa2be163e1f3$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $c61ffa2be163e1f3$export$b80fbe1c3a2b92b5;

var $Wth4q = parcelRequire("Wth4q");
var $c61ffa2be163e1f3$require$Buffer = $Wth4q.Buffer;
function $c61ffa2be163e1f3$var$asUInt32Array(buf) {
    if (!$c61ffa2be163e1f3$require$Buffer.isBuffer(buf)) buf = $c61ffa2be163e1f3$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $c61ffa2be163e1f3$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $c61ffa2be163e1f3$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $c61ffa2be163e1f3$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $c61ffa2be163e1f3$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $c61ffa2be163e1f3$var$AES(key) {
    this._key = $c61ffa2be163e1f3$var$asUInt32Array(key);
    this._reset();
}
$c61ffa2be163e1f3$var$AES.blockSize = 16;
$c61ffa2be163e1f3$var$AES.keySize = 32;
$c61ffa2be163e1f3$var$AES.prototype.blockSize = $c61ffa2be163e1f3$var$AES.blockSize;
$c61ffa2be163e1f3$var$AES.prototype.keySize = $c61ffa2be163e1f3$var$AES.keySize;
$c61ffa2be163e1f3$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $c61ffa2be163e1f3$var$G.SBOX[t >>> 24] << 24 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 16 & 0xff] << 16 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 8 & 0xff] << 8 | $c61ffa2be163e1f3$var$G.SBOX[t & 0xff];
            t ^= $c61ffa2be163e1f3$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $c61ffa2be163e1f3$var$G.SBOX[t >>> 24] << 24 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 16 & 0xff] << 16 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 8 & 0xff] << 8 | $c61ffa2be163e1f3$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $c61ffa2be163e1f3$var$G.INV_SUB_MIX[0][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 24]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[1][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 16 & 0xff]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[2][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 8 & 0xff]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[3][$c61ffa2be163e1f3$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$c61ffa2be163e1f3$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $c61ffa2be163e1f3$var$asUInt32Array(M);
    return $c61ffa2be163e1f3$var$cryptBlock(M, this._keySchedule, $c61ffa2be163e1f3$var$G.SUB_MIX, $c61ffa2be163e1f3$var$G.SBOX, this._nRounds);
};
$c61ffa2be163e1f3$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $c61ffa2be163e1f3$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$c61ffa2be163e1f3$var$AES.prototype.decryptBlock = function(M) {
    M = $c61ffa2be163e1f3$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $c61ffa2be163e1f3$var$cryptBlock(M, this._invKeySchedule, $c61ffa2be163e1f3$var$G.INV_SUB_MIX, $c61ffa2be163e1f3$var$G.INV_SBOX, this._nRounds);
    var buf = $c61ffa2be163e1f3$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$c61ffa2be163e1f3$var$AES.prototype.scrub = function() {
    $c61ffa2be163e1f3$var$scrubVec(this._keySchedule);
    $c61ffa2be163e1f3$var$scrubVec(this._invKeySchedule);
    $c61ffa2be163e1f3$var$scrubVec(this._key);
};
$c61ffa2be163e1f3$export$b80fbe1c3a2b92b5 = $c61ffa2be163e1f3$var$AES;

});

parcelRegister("3wyrd", function(module, exports) {

var $Wth4q = parcelRequire("Wth4q");
var $290f12eeb62fc0f2$require$Buffer = $Wth4q.Buffer;
var $290f12eeb62fc0f2$var$ZEROES = $290f12eeb62fc0f2$require$Buffer.alloc(16, 0);
function $290f12eeb62fc0f2$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $290f12eeb62fc0f2$var$fromArray(out) {
    var buf = $290f12eeb62fc0f2$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $290f12eeb62fc0f2$var$GHASH(key) {
    this.h = key;
    this.state = $290f12eeb62fc0f2$require$Buffer.alloc(16, 0);
    this.cache = $290f12eeb62fc0f2$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$290f12eeb62fc0f2$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$290f12eeb62fc0f2$var$GHASH.prototype._multiply = function() {
    var Vi = $290f12eeb62fc0f2$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $290f12eeb62fc0f2$var$fromArray(Zi);
};
$290f12eeb62fc0f2$var$GHASH.prototype.update = function(buf) {
    this.cache = $290f12eeb62fc0f2$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$290f12eeb62fc0f2$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($290f12eeb62fc0f2$require$Buffer.concat([
        this.cache,
        $290f12eeb62fc0f2$var$ZEROES
    ], 16));
    this.ghash($290f12eeb62fc0f2$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $290f12eeb62fc0f2$var$GHASH;

});


parcelRegister("ecK7f", function(module, exports) {

var $h0C5b = parcelRequire("h0C5b");

var $Wth4q = parcelRequire("Wth4q");
var $a575f54f3a1f9ff7$require$Buffer = $Wth4q.Buffer;

var $77fwb = parcelRequire("77fwb");

var $v3bBu = parcelRequire("v3bBu");
function $a575f54f3a1f9ff7$var$StreamCipher(mode, key, iv, decrypt) {
    $77fwb.call(this);
    this._cipher = new $h0C5b.AES(key);
    this._prev = $a575f54f3a1f9ff7$require$Buffer.from(iv);
    this._cache = $a575f54f3a1f9ff7$require$Buffer.allocUnsafe(0);
    this._secCache = $a575f54f3a1f9ff7$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$v3bBu($a575f54f3a1f9ff7$var$StreamCipher, $77fwb);
$a575f54f3a1f9ff7$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$a575f54f3a1f9ff7$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $a575f54f3a1f9ff7$var$StreamCipher;

});

parcelRegister("55KiC", function(module, exports) {

var $Wth4q = parcelRequire("Wth4q");
var $3b515579f6a05835$require$Buffer = $Wth4q.Buffer;

var $8ZJxF = parcelRequire("8ZJxF");
/* eslint-disable camelcase */ function $3b515579f6a05835$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$3b515579f6a05835$require$Buffer.isBuffer(password)) password = $3b515579f6a05835$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$3b515579f6a05835$require$Buffer.isBuffer(salt)) salt = $3b515579f6a05835$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $3b515579f6a05835$require$Buffer.alloc(keyLen);
    var iv = $3b515579f6a05835$require$Buffer.alloc(ivLen || 0);
    var tmp = $3b515579f6a05835$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $8ZJxF();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $3b515579f6a05835$var$EVP_BytesToKey;

});


parcelRegister("i9P5q", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $d380b1fbce65edb7$export$12ada9414fbc594c, (v) => $d380b1fbce65edb7$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $d380b1fbce65edb7$export$36b6d6ef312eab39, (v) => $d380b1fbce65edb7$export$36b6d6ef312eab39 = v);
var $d380b1fbce65edb7$export$12ada9414fbc594c;
var $d380b1fbce65edb7$export$36b6d6ef312eab39;

var $dsL7z = parcelRequire("dsL7z");

var $Wth4q = parcelRequire("Wth4q");
var $d380b1fbce65edb7$require$Buffer = $Wth4q.Buffer;

var $6WLno = parcelRequire("6WLno");

var $ecK7f = parcelRequire("ecK7f");

var $77fwb = parcelRequire("77fwb");

var $h0C5b = parcelRequire("h0C5b");

var $55KiC = parcelRequire("55KiC");

var $v3bBu = parcelRequire("v3bBu");
function $d380b1fbce65edb7$var$Decipher(mode, key, iv) {
    $77fwb.call(this);
    this._cache = new $d380b1fbce65edb7$var$Splitter();
    this._last = void 0;
    this._cipher = new $h0C5b.AES(key);
    this._prev = $d380b1fbce65edb7$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$v3bBu($d380b1fbce65edb7$var$Decipher, $77fwb);
$d380b1fbce65edb7$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $d380b1fbce65edb7$require$Buffer.concat(out);
};
$d380b1fbce65edb7$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $d380b1fbce65edb7$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$d380b1fbce65edb7$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $d380b1fbce65edb7$var$Splitter() {
    this.cache = $d380b1fbce65edb7$require$Buffer.allocUnsafe(0);
}
$d380b1fbce65edb7$var$Splitter.prototype.add = function(data) {
    this.cache = $d380b1fbce65edb7$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$d380b1fbce65edb7$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$d380b1fbce65edb7$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $d380b1fbce65edb7$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $d380b1fbce65edb7$var$createDecipheriv(suite, password, iv) {
    var config = $6WLno[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $d380b1fbce65edb7$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $d380b1fbce65edb7$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $ecK7f(config.module, password, iv, true);
    else if (config.type === 'auth') return new $dsL7z(config.module, password, iv, true);
    return new $d380b1fbce65edb7$var$Decipher(config.module, password, iv);
}
function $d380b1fbce65edb7$var$createDecipher(suite, password) {
    var config = $6WLno[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $55KiC(password, false, config.key, config.iv);
    return $d380b1fbce65edb7$var$createDecipheriv(suite, keys.key, keys.iv);
}
$d380b1fbce65edb7$export$12ada9414fbc594c = $d380b1fbce65edb7$var$createDecipher;
$d380b1fbce65edb7$export$36b6d6ef312eab39 = $d380b1fbce65edb7$var$createDecipheriv;

});


parcelRegister("dQ4TD", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $a133ee05e0543499$export$116f8a5cee447347, (v) => $a133ee05e0543499$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $a133ee05e0543499$export$7483c4066bfb7ae9, (v) => $a133ee05e0543499$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $a133ee05e0543499$export$e7a565d2e588bb06, (v) => $a133ee05e0543499$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $a133ee05e0543499$export$aaa2f54a426f3eb8, (v) => $a133ee05e0543499$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $a133ee05e0543499$export$eba20568dde4ada, (v) => $a133ee05e0543499$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $a133ee05e0543499$export$d3b5e5996938f5ae, (v) => $a133ee05e0543499$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $a133ee05e0543499$export$57c08356130bc99b, (v) => $a133ee05e0543499$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $a133ee05e0543499$export$c7169791d5c1e65d, (v) => $a133ee05e0543499$export$c7169791d5c1e65d = v);
var $a133ee05e0543499$export$116f8a5cee447347;
var $a133ee05e0543499$export$7483c4066bfb7ae9;
var $a133ee05e0543499$export$e7a565d2e588bb06;
var $a133ee05e0543499$export$aaa2f54a426f3eb8;
var $a133ee05e0543499$export$eba20568dde4ada;
var $a133ee05e0543499$export$d3b5e5996938f5ae;
var $a133ee05e0543499$export$57c08356130bc99b;
var $a133ee05e0543499$export$c7169791d5c1e65d;
$a133ee05e0543499$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$a133ee05e0543499$export$7483c4066bfb7ae9 = $a133ee05e0543499$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$a133ee05e0543499$export$aaa2f54a426f3eb8 = $a133ee05e0543499$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$a133ee05e0543499$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$a133ee05e0543499$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$a133ee05e0543499$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("ilRwV", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $d5c3b620b637e62c$export$971862a2fcb1bb40, (v) => $d5c3b620b637e62c$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $d5c3b620b637e62c$export$c6ff6a88acbeaf40, (v) => $d5c3b620b637e62c$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $d5c3b620b637e62c$export$fdc27893e98845cc, (v) => $d5c3b620b637e62c$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $d5c3b620b637e62c$export$6671fb9a1323bed, (v) => $d5c3b620b637e62c$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $d5c3b620b637e62c$export$d74daf141a551db, (v) => $d5c3b620b637e62c$export$d74daf141a551db = v);
var $d5c3b620b637e62c$export$971862a2fcb1bb40;
var $d5c3b620b637e62c$export$c6ff6a88acbeaf40;
var $d5c3b620b637e62c$export$fdc27893e98845cc;
var $d5c3b620b637e62c$export$6671fb9a1323bed;
var $d5c3b620b637e62c$export$d74daf141a551db;

var $5k7LC = parcelRequire("5k7LC");
var $d5c3b620b637e62c$require$Buffer = $5k7LC.Buffer;

var $iQ4lm = parcelRequire("iQ4lm");

var $9TmmS = parcelRequire("9TmmS");

var $9UDry = parcelRequire("9UDry");
function $d5c3b620b637e62c$var$getDiffieHellman(mod) {
    var prime = new $d5c3b620b637e62c$require$Buffer($9TmmS[mod].prime, 'hex');
    var gen = new $d5c3b620b637e62c$require$Buffer($9TmmS[mod].gen, 'hex');
    return new $9UDry(prime, gen);
}
var $d5c3b620b637e62c$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $d5c3b620b637e62c$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($d5c3b620b637e62c$require$Buffer.isBuffer(enc) || $d5c3b620b637e62c$var$ENCODINGS[enc] === undefined) return $d5c3b620b637e62c$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $d5c3b620b637e62c$require$Buffer([
        2
    ]);
    if (!$d5c3b620b637e62c$require$Buffer.isBuffer(generator)) generator = new $d5c3b620b637e62c$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $9UDry($iQ4lm(prime, generator), generator, true);
    if (!$d5c3b620b637e62c$require$Buffer.isBuffer(prime)) prime = new $d5c3b620b637e62c$require$Buffer(prime, enc);
    return new $9UDry(prime, generator, true);
}
$d5c3b620b637e62c$export$971862a2fcb1bb40 = $d5c3b620b637e62c$export$c6ff6a88acbeaf40 = $d5c3b620b637e62c$export$fdc27893e98845cc = $d5c3b620b637e62c$var$getDiffieHellman;
$d5c3b620b637e62c$export$6671fb9a1323bed = $d5c3b620b637e62c$export$d74daf141a551db = $d5c3b620b637e62c$var$createDiffieHellman;

});
parcelRegister("iQ4lm", function(module, exports) {

var $1DyI6 = parcelRequire("1DyI6");
module.exports = $db7073d92ed84da3$var$findPrime;
$db7073d92ed84da3$var$findPrime.simpleSieve = $db7073d92ed84da3$var$simpleSieve;
$db7073d92ed84da3$var$findPrime.fermatTest = $db7073d92ed84da3$var$fermatTest;

var $9pbIC = parcelRequire("9pbIC");
var $db7073d92ed84da3$var$TWENTYFOUR = new $9pbIC(24);

var $j2pYc = parcelRequire("j2pYc");
var $db7073d92ed84da3$var$millerRabin = new $j2pYc();
var $db7073d92ed84da3$var$ONE = new $9pbIC(1);
var $db7073d92ed84da3$var$TWO = new $9pbIC(2);
var $db7073d92ed84da3$var$FIVE = new $9pbIC(5);
var $db7073d92ed84da3$var$SIXTEEN = new $9pbIC(16);
var $db7073d92ed84da3$var$EIGHT = new $9pbIC(8);
var $db7073d92ed84da3$var$TEN = new $9pbIC(10);
var $db7073d92ed84da3$var$THREE = new $9pbIC(3);
var $db7073d92ed84da3$var$SEVEN = new $9pbIC(7);
var $db7073d92ed84da3$var$ELEVEN = new $9pbIC(11);
var $db7073d92ed84da3$var$FOUR = new $9pbIC(4);
var $db7073d92ed84da3$var$TWELVE = new $9pbIC(12);
var $db7073d92ed84da3$var$primes = null;
function $db7073d92ed84da3$var$_getPrimes() {
    if ($db7073d92ed84da3$var$primes !== null) return $db7073d92ed84da3$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $db7073d92ed84da3$var$primes = res;
    return res;
}
function $db7073d92ed84da3$var$simpleSieve(p) {
    var primes = $db7073d92ed84da3$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $db7073d92ed84da3$var$fermatTest(p) {
    var red = $9pbIC.mont(p);
    return $db7073d92ed84da3$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $db7073d92ed84da3$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $9pbIC([
            0x8c,
            0x7b
        ]);
        else return new $9pbIC([
            0x8c,
            0x27
        ]);
    }
    gen = new $9pbIC(gen);
    var num, n2;
    while(true){
        num = new $9pbIC($1DyI6(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($db7073d92ed84da3$var$ONE);
        if (!num.testn(1)) num.iadd($db7073d92ed84da3$var$TWO);
        if (!gen.cmp($db7073d92ed84da3$var$TWO)) while(num.mod($db7073d92ed84da3$var$TWENTYFOUR).cmp($db7073d92ed84da3$var$ELEVEN))num.iadd($db7073d92ed84da3$var$FOUR);
        else if (!gen.cmp($db7073d92ed84da3$var$FIVE)) while(num.mod($db7073d92ed84da3$var$TEN).cmp($db7073d92ed84da3$var$THREE))num.iadd($db7073d92ed84da3$var$FOUR);
        n2 = num.shrn(1);
        if ($db7073d92ed84da3$var$simpleSieve(n2) && $db7073d92ed84da3$var$simpleSieve(num) && $db7073d92ed84da3$var$fermatTest(n2) && $db7073d92ed84da3$var$fermatTest(num) && $db7073d92ed84da3$var$millerRabin.test(n2) && $db7073d92ed84da3$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("9pbIC", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hq3wB")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("j2pYc", function(module, exports) {

var $9pbIC = parcelRequire("9pbIC");

var $9D8YT = parcelRequire("9D8YT");
function $ddc2594cff22236f$var$MillerRabin(rand) {
    this.rand = rand || new $9D8YT.Rand();
}
module.exports = $ddc2594cff22236f$var$MillerRabin;
$ddc2594cff22236f$var$MillerRabin.create = function create(rand) {
    return new $ddc2594cff22236f$var$MillerRabin(rand);
};
$ddc2594cff22236f$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $9pbIC(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$ddc2594cff22236f$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$ddc2594cff22236f$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $9pbIC.mont(n);
    var rone = new $9pbIC(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $9pbIC(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$ddc2594cff22236f$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $9pbIC.mont(n);
    var rone = new $9pbIC(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $9pbIC(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("9D8YT", function(module, exports) {
var $01cf348867612932$var$r;
module.exports = function rand(len) {
    if (!$01cf348867612932$var$r) $01cf348867612932$var$r = new $01cf348867612932$var$Rand(null);
    return $01cf348867612932$var$r.generate(len);
};
function $01cf348867612932$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $01cf348867612932$var$Rand;
$01cf348867612932$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $01cf348867612932$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $01cf348867612932$var$crypto = (parcelRequire("hq3wB"));
    if (typeof $01cf348867612932$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
        return $01cf348867612932$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("9TmmS", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("9UDry", function(module, exports) {

var $5k7LC = parcelRequire("5k7LC");
var $7377f0aaf3b8b68d$require$Buffer = $5k7LC.Buffer;

var $9pbIC = parcelRequire("9pbIC");

var $j2pYc = parcelRequire("j2pYc");
var $7377f0aaf3b8b68d$var$millerRabin = new $j2pYc();
var $7377f0aaf3b8b68d$var$TWENTYFOUR = new $9pbIC(24);
var $7377f0aaf3b8b68d$var$ELEVEN = new $9pbIC(11);
var $7377f0aaf3b8b68d$var$TEN = new $9pbIC(10);
var $7377f0aaf3b8b68d$var$THREE = new $9pbIC(3);
var $7377f0aaf3b8b68d$var$SEVEN = new $9pbIC(7);

var $iQ4lm = parcelRequire("iQ4lm");

var $1DyI6 = parcelRequire("1DyI6");
module.exports = $7377f0aaf3b8b68d$var$DH;
function $7377f0aaf3b8b68d$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(pub)) pub = new $7377f0aaf3b8b68d$require$Buffer(pub, enc);
    this._pub = new $9pbIC(pub);
    return this;
}
function $7377f0aaf3b8b68d$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(priv)) priv = new $7377f0aaf3b8b68d$require$Buffer(priv, enc);
    this._priv = new $9pbIC(priv);
    return this;
}
var $7377f0aaf3b8b68d$var$primeCache = {};
function $7377f0aaf3b8b68d$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $7377f0aaf3b8b68d$var$primeCache) return $7377f0aaf3b8b68d$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$iQ4lm.simpleSieve || !$iQ4lm.fermatTest(prime) || !$7377f0aaf3b8b68d$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $7377f0aaf3b8b68d$var$primeCache[hex] = error;
        return error;
    }
    if (!$7377f0aaf3b8b68d$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($7377f0aaf3b8b68d$var$TWENTYFOUR).cmp($7377f0aaf3b8b68d$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($7377f0aaf3b8b68d$var$TEN);
            if (rem.cmp($7377f0aaf3b8b68d$var$THREE) && rem.cmp($7377f0aaf3b8b68d$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $7377f0aaf3b8b68d$var$primeCache[hex] = error;
    return error;
}
function $7377f0aaf3b8b68d$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $9pbIC(prime);
    this._prime = $9pbIC.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $7377f0aaf3b8b68d$var$setPublicKey;
        this.setPrivateKey = $7377f0aaf3b8b68d$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($7377f0aaf3b8b68d$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $7377f0aaf3b8b68d$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$7377f0aaf3b8b68d$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $9pbIC($1DyI6(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$7377f0aaf3b8b68d$var$DH.prototype.computeSecret = function(other) {
    other = new $9pbIC(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $7377f0aaf3b8b68d$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $7377f0aaf3b8b68d$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $7377f0aaf3b8b68d$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$7377f0aaf3b8b68d$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $7377f0aaf3b8b68d$var$formatReturnValue(this._pub, enc);
};
$7377f0aaf3b8b68d$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $7377f0aaf3b8b68d$var$formatReturnValue(this._priv, enc);
};
$7377f0aaf3b8b68d$var$DH.prototype.getPrime = function(enc) {
    return $7377f0aaf3b8b68d$var$formatReturnValue(this.__prime, enc);
};
$7377f0aaf3b8b68d$var$DH.prototype.getGenerator = function(enc) {
    return $7377f0aaf3b8b68d$var$formatReturnValue(this._gen, enc);
};
$7377f0aaf3b8b68d$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(gen)) gen = new $7377f0aaf3b8b68d$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $9pbIC(gen);
    return this;
};
function $7377f0aaf3b8b68d$var$formatReturnValue(bn, enc) {
    var buf = new $7377f0aaf3b8b68d$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("kqxVX", function(module, exports) {
'use strict';

var $Wth4q = parcelRequire("Wth4q");
var $edf08eeced55ab26$require$Buffer = $Wth4q.Buffer;

var $7K4uY = parcelRequire("7K4uY");

var $67Fhe = parcelRequire("67Fhe");

var $v3bBu = parcelRequire("v3bBu");

var $kYhYb = parcelRequire("kYhYb");

var $1LYL6 = parcelRequire("1LYL6");

var $5kFDZ = parcelRequire("5kFDZ");
Object.keys($5kFDZ).forEach(function(key) {
    $5kFDZ[key].id = $edf08eeced55ab26$require$Buffer.from($5kFDZ[key].id, 'hex');
    $5kFDZ[key.toLowerCase()] = $5kFDZ[key];
});
function $edf08eeced55ab26$var$Sign(algorithm) {
    $67Fhe.Writable.call(this);
    var data = $5kFDZ[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $7K4uY(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$v3bBu($edf08eeced55ab26$var$Sign, $67Fhe.Writable);
$edf08eeced55ab26$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$edf08eeced55ab26$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $edf08eeced55ab26$require$Buffer.from(data, enc) : data);
    return this;
};
$edf08eeced55ab26$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $kYhYb(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $edf08eeced55ab26$var$Verify(algorithm) {
    $67Fhe.Writable.call(this);
    var data = $5kFDZ[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $7K4uY(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$v3bBu($edf08eeced55ab26$var$Verify, $67Fhe.Writable);
$edf08eeced55ab26$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$edf08eeced55ab26$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $edf08eeced55ab26$require$Buffer.from(data, enc) : data);
    return this;
};
$edf08eeced55ab26$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $edf08eeced55ab26$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $1LYL6(sigBuffer, hash, key, this._signType, this._tag);
};
function $edf08eeced55ab26$var$createSign(algorithm) {
    return new $edf08eeced55ab26$var$Sign(algorithm);
}
function $edf08eeced55ab26$var$createVerify(algorithm) {
    return new $edf08eeced55ab26$var$Verify(algorithm);
}
module.exports = {
    Sign: $edf08eeced55ab26$var$createSign,
    Verify: $edf08eeced55ab26$var$createVerify,
    createSign: $edf08eeced55ab26$var$createSign,
    createVerify: $edf08eeced55ab26$var$createVerify
};

});
parcelRegister("67Fhe", function(module, exports) {

exports = module.exports = (parcelRequire("hVjIO"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3YGVr"));

exports.Duplex = (parcelRequire("fAlCy"));

exports.Transform = (parcelRequire("8iQyH"));

exports.PassThrough = (parcelRequire("WEefO"));

});
parcelRegister("hVjIO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6cAn5 = parcelRequire("6cAn5");
'use strict';

var $iWV9i = parcelRequire("iWV9i");
/*</replacement>*/ module.exports = $d0c70edb1200ac87$var$Readable;

var $4phNF = parcelRequire("4phNF");
/*</replacement>*/ /*<replacement>*/ var $d0c70edb1200ac87$var$Duplex;
/*</replacement>*/ $d0c70edb1200ac87$var$Readable.ReadableState = $d0c70edb1200ac87$var$ReadableState;

var $6Oghe = parcelRequire("6Oghe");
var $d0c70edb1200ac87$require$EE = $6Oghe.EventEmitter;
var $d0c70edb1200ac87$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $4t6fq = parcelRequire("4t6fq");

var $cmRjm = parcelRequire("cmRjm");
var $d0c70edb1200ac87$require$Buffer = $cmRjm.Buffer;
var $d0c70edb1200ac87$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $d0c70edb1200ac87$var$_uint8ArrayToBuffer(chunk) {
    return $d0c70edb1200ac87$require$Buffer.from(chunk);
}
function $d0c70edb1200ac87$var$_isUint8Array(obj) {
    return $d0c70edb1200ac87$require$Buffer.isBuffer(obj) || obj instanceof $d0c70edb1200ac87$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $d0c70edb1200ac87$var$util = Object.create((parcelRequire("fvDPy")));

$d0c70edb1200ac87$var$util.inherits = (parcelRequire("v3bBu"));

var $hq3wB = parcelRequire("hq3wB");
var $d0c70edb1200ac87$var$debug = void 0;
if ($hq3wB && $hq3wB.debuglog) $d0c70edb1200ac87$var$debug = $hq3wB.debuglog('stream');
else $d0c70edb1200ac87$var$debug = function() {};

var $ZaRag = parcelRequire("ZaRag");

var $9tGJn = parcelRequire("9tGJn");
var $d0c70edb1200ac87$var$StringDecoder;
$d0c70edb1200ac87$var$util.inherits($d0c70edb1200ac87$var$Readable, $4t6fq);
var $d0c70edb1200ac87$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $d0c70edb1200ac87$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($4phNF(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $d0c70edb1200ac87$var$ReadableState(options, stream) {
    $d0c70edb1200ac87$var$Duplex = $d0c70edb1200ac87$var$Duplex || (parcelRequire("fAlCy"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $d0c70edb1200ac87$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $ZaRag();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$d0c70edb1200ac87$var$StringDecoder) $d0c70edb1200ac87$var$StringDecoder = (parcelRequire("6ayCS")).StringDecoder;
        this.decoder = new $d0c70edb1200ac87$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d0c70edb1200ac87$var$Readable(options) {
    $d0c70edb1200ac87$var$Duplex = $d0c70edb1200ac87$var$Duplex || (parcelRequire("fAlCy"));
    if (!(this instanceof $d0c70edb1200ac87$var$Readable)) return new $d0c70edb1200ac87$var$Readable(options);
    this._readableState = new $d0c70edb1200ac87$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $4t6fq.call(this);
}
Object.defineProperty($d0c70edb1200ac87$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$d0c70edb1200ac87$var$Readable.prototype.destroy = $9tGJn.destroy;
$d0c70edb1200ac87$var$Readable.prototype._undestroy = $9tGJn.undestroy;
$d0c70edb1200ac87$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d0c70edb1200ac87$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $d0c70edb1200ac87$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $d0c70edb1200ac87$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$d0c70edb1200ac87$var$Readable.prototype.unshift = function(chunk) {
    return $d0c70edb1200ac87$var$readableAddChunk(this, chunk, null, true, false);
};
function $d0c70edb1200ac87$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $d0c70edb1200ac87$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $d0c70edb1200ac87$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $d0c70edb1200ac87$require$Buffer.prototype) chunk = $d0c70edb1200ac87$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $d0c70edb1200ac87$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $d0c70edb1200ac87$var$addChunk(stream, state, chunk, false);
                    else $d0c70edb1200ac87$var$maybeReadMore(stream, state);
                } else $d0c70edb1200ac87$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $d0c70edb1200ac87$var$needMoreData(state);
}
function $d0c70edb1200ac87$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $d0c70edb1200ac87$var$emitReadable(stream);
    }
    $d0c70edb1200ac87$var$maybeReadMore(stream, state);
}
function $d0c70edb1200ac87$var$chunkInvalid(state, chunk) {
    var er;
    if (!$d0c70edb1200ac87$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $d0c70edb1200ac87$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$d0c70edb1200ac87$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$d0c70edb1200ac87$var$Readable.prototype.setEncoding = function(enc) {
    if (!$d0c70edb1200ac87$var$StringDecoder) $d0c70edb1200ac87$var$StringDecoder = (parcelRequire("6ayCS")).StringDecoder;
    this._readableState.decoder = new $d0c70edb1200ac87$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $d0c70edb1200ac87$var$MAX_HWM = 0x800000;
function $d0c70edb1200ac87$var$computeNewHighWaterMark(n) {
    if (n >= $d0c70edb1200ac87$var$MAX_HWM) n = $d0c70edb1200ac87$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d0c70edb1200ac87$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d0c70edb1200ac87$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$d0c70edb1200ac87$var$Readable.prototype.read = function(n) {
    $d0c70edb1200ac87$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $d0c70edb1200ac87$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $d0c70edb1200ac87$var$endReadable(this);
        else $d0c70edb1200ac87$var$emitReadable(this);
        return null;
    }
    n = $d0c70edb1200ac87$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d0c70edb1200ac87$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $d0c70edb1200ac87$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d0c70edb1200ac87$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $d0c70edb1200ac87$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $d0c70edb1200ac87$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d0c70edb1200ac87$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $d0c70edb1200ac87$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d0c70edb1200ac87$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $d0c70edb1200ac87$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $d0c70edb1200ac87$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d0c70edb1200ac87$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d0c70edb1200ac87$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $iWV9i.nextTick($d0c70edb1200ac87$var$emitReadable_, stream);
        else $d0c70edb1200ac87$var$emitReadable_(stream);
    }
}
function $d0c70edb1200ac87$var$emitReadable_(stream) {
    $d0c70edb1200ac87$var$debug('emit readable');
    stream.emit('readable');
    $d0c70edb1200ac87$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d0c70edb1200ac87$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $iWV9i.nextTick($d0c70edb1200ac87$var$maybeReadMore_, stream, state);
    }
}
function $d0c70edb1200ac87$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $d0c70edb1200ac87$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d0c70edb1200ac87$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$d0c70edb1200ac87$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $d0c70edb1200ac87$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6cAn5.stdout && dest !== $6cAn5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $iWV9i.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d0c70edb1200ac87$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d0c70edb1200ac87$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $d0c70edb1200ac87$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $d0c70edb1200ac87$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $d0c70edb1200ac87$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $d0c70edb1200ac87$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $d0c70edb1200ac87$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d0c70edb1200ac87$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($d0c70edb1200ac87$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $d0c70edb1200ac87$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $d0c70edb1200ac87$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $d0c70edb1200ac87$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $d0c70edb1200ac87$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $d0c70edb1200ac87$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $d0c70edb1200ac87$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $d0c70edb1200ac87$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $d0c70edb1200ac87$var$flow(src);
        }
    };
}
$d0c70edb1200ac87$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $d0c70edb1200ac87$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$d0c70edb1200ac87$var$Readable.prototype.on = function(ev, fn) {
    var res = $4t6fq.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $iWV9i.nextTick($d0c70edb1200ac87$var$nReadingNextTick, this);
            else if (state.length) $d0c70edb1200ac87$var$emitReadable(this);
        }
    }
    return res;
};
$d0c70edb1200ac87$var$Readable.prototype.addListener = $d0c70edb1200ac87$var$Readable.prototype.on;
function $d0c70edb1200ac87$var$nReadingNextTick(self1) {
    $d0c70edb1200ac87$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d0c70edb1200ac87$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $d0c70edb1200ac87$var$debug('resume');
        state.flowing = true;
        $d0c70edb1200ac87$var$resume(this, state);
    }
    return this;
};
function $d0c70edb1200ac87$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $iWV9i.nextTick($d0c70edb1200ac87$var$resume_, stream, state);
    }
}
function $d0c70edb1200ac87$var$resume_(stream, state) {
    if (!state.reading) {
        $d0c70edb1200ac87$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $d0c70edb1200ac87$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d0c70edb1200ac87$var$Readable.prototype.pause = function() {
    $d0c70edb1200ac87$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $d0c70edb1200ac87$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $d0c70edb1200ac87$var$flow(stream) {
    var state = stream._readableState;
    $d0c70edb1200ac87$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d0c70edb1200ac87$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $d0c70edb1200ac87$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $d0c70edb1200ac87$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $d0c70edb1200ac87$var$kProxyEvents.length; n++)stream.on($d0c70edb1200ac87$var$kProxyEvents[n], this.emit.bind(this, $d0c70edb1200ac87$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $d0c70edb1200ac87$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($d0c70edb1200ac87$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$d0c70edb1200ac87$var$Readable._fromList = $d0c70edb1200ac87$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d0c70edb1200ac87$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $d0c70edb1200ac87$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d0c70edb1200ac87$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $d0c70edb1200ac87$var$copyFromBufferString(n, list) : $d0c70edb1200ac87$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d0c70edb1200ac87$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d0c70edb1200ac87$var$copyFromBuffer(n, list) {
    var ret = $d0c70edb1200ac87$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $d0c70edb1200ac87$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $iWV9i.nextTick($d0c70edb1200ac87$var$endReadableNT, state, stream);
    }
}
function $d0c70edb1200ac87$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $d0c70edb1200ac87$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("iWV9i", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
if (typeof $6cAn5 === 'undefined' || !$6cAn5.version || $6cAn5.version.indexOf('v0.') === 0 || $6cAn5.version.indexOf('v1.') === 0 && $6cAn5.version.indexOf('v1.8.') !== 0) module.exports = {
    nextTick: $dcb9f95cdc97f624$var$nextTick
};
else module.exports = $6cAn5;
function $dcb9f95cdc97f624$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $6cAn5.nextTick(fn);
        case 2:
            return $6cAn5.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $6cAn5.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $6cAn5.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $6cAn5.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("4phNF", function(module, exports) {
var $33574df078d04d7d$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $33574df078d04d7d$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("4t6fq", function(module, exports) {

module.exports = (parcelRequire("6Oghe")).EventEmitter;

});

parcelRegister("cmRjm", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $5k7LC = parcelRequire("5k7LC");
var $9010e498dbe0c8b2$var$Buffer = $5k7LC.Buffer;
// alternative to using Object.keys for old browsers
function $9010e498dbe0c8b2$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($9010e498dbe0c8b2$var$Buffer.from && $9010e498dbe0c8b2$var$Buffer.alloc && $9010e498dbe0c8b2$var$Buffer.allocUnsafe && $9010e498dbe0c8b2$var$Buffer.allocUnsafeSlow) module.exports = $5k7LC;
else {
    // Copy properties from require('buffer')
    $9010e498dbe0c8b2$var$copyProps($5k7LC, module.exports);
    module.exports.Buffer = $9010e498dbe0c8b2$var$SafeBuffer;
}
function $9010e498dbe0c8b2$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $9010e498dbe0c8b2$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$9010e498dbe0c8b2$var$copyProps($9010e498dbe0c8b2$var$Buffer, $9010e498dbe0c8b2$var$SafeBuffer);
$9010e498dbe0c8b2$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $9010e498dbe0c8b2$var$Buffer(arg, encodingOrOffset, length);
};
$9010e498dbe0c8b2$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $9010e498dbe0c8b2$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$9010e498dbe0c8b2$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $9010e498dbe0c8b2$var$Buffer(size);
};
$9010e498dbe0c8b2$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5k7LC.SlowBuffer(size);
};

});

parcelRegister("fvDPy", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $b4a8a5c310566eb2$export$43bee75e5e14138e, (v) => $b4a8a5c310566eb2$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $b4a8a5c310566eb2$export$f9ce7b637dfbe238, (v) => $b4a8a5c310566eb2$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $b4a8a5c310566eb2$export$630801d484da15df, (v) => $b4a8a5c310566eb2$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $b4a8a5c310566eb2$export$bedb7023a7733221, (v) => $b4a8a5c310566eb2$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $b4a8a5c310566eb2$export$7e4aa119212bc614, (v) => $b4a8a5c310566eb2$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $b4a8a5c310566eb2$export$844ec244b1367d54, (v) => $b4a8a5c310566eb2$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $b4a8a5c310566eb2$export$a244864fd9645c7f, (v) => $b4a8a5c310566eb2$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $b4a8a5c310566eb2$export$fce6876652108ab, (v) => $b4a8a5c310566eb2$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $b4a8a5c310566eb2$export$49841c62b9eff15, (v) => $b4a8a5c310566eb2$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $b4a8a5c310566eb2$export$a6cdc56e425d0d0a, (v) => $b4a8a5c310566eb2$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $b4a8a5c310566eb2$export$871608497c498473, (v) => $b4a8a5c310566eb2$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $b4a8a5c310566eb2$export$e6127cc7fe7395c3, (v) => $b4a8a5c310566eb2$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $b4a8a5c310566eb2$export$f6e2535fb5126e54, (v) => $b4a8a5c310566eb2$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $b4a8a5c310566eb2$export$c3825b437cbdea5c, (v) => $b4a8a5c310566eb2$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $b4a8a5c310566eb2$export$a7884ebc965f8f54, (v) => $b4a8a5c310566eb2$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $b4a8a5c310566eb2$export$43bee75e5e14138e;
var $b4a8a5c310566eb2$export$f9ce7b637dfbe238;
var $b4a8a5c310566eb2$export$630801d484da15df;
var $b4a8a5c310566eb2$export$bedb7023a7733221;
var $b4a8a5c310566eb2$export$7e4aa119212bc614;
var $b4a8a5c310566eb2$export$844ec244b1367d54;
var $b4a8a5c310566eb2$export$a244864fd9645c7f;
var $b4a8a5c310566eb2$export$fce6876652108ab;
var $b4a8a5c310566eb2$export$49841c62b9eff15;
var $b4a8a5c310566eb2$export$a6cdc56e425d0d0a;
var $b4a8a5c310566eb2$export$871608497c498473;
var $b4a8a5c310566eb2$export$e6127cc7fe7395c3;
var $b4a8a5c310566eb2$export$f6e2535fb5126e54;
var $b4a8a5c310566eb2$export$c3825b437cbdea5c;
var $b4a8a5c310566eb2$export$a7884ebc965f8f54;
function $b4a8a5c310566eb2$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $b4a8a5c310566eb2$var$objectToString(arg) === '[object Array]';
}
$b4a8a5c310566eb2$export$43bee75e5e14138e = $b4a8a5c310566eb2$var$isArray;
function $b4a8a5c310566eb2$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$b4a8a5c310566eb2$export$f9ce7b637dfbe238 = $b4a8a5c310566eb2$var$isBoolean;
function $b4a8a5c310566eb2$var$isNull(arg) {
    return arg === null;
}
$b4a8a5c310566eb2$export$630801d484da15df = $b4a8a5c310566eb2$var$isNull;
function $b4a8a5c310566eb2$var$isNullOrUndefined(arg) {
    return arg == null;
}
$b4a8a5c310566eb2$export$bedb7023a7733221 = $b4a8a5c310566eb2$var$isNullOrUndefined;
function $b4a8a5c310566eb2$var$isNumber(arg) {
    return typeof arg === 'number';
}
$b4a8a5c310566eb2$export$7e4aa119212bc614 = $b4a8a5c310566eb2$var$isNumber;
function $b4a8a5c310566eb2$var$isString(arg) {
    return typeof arg === 'string';
}
$b4a8a5c310566eb2$export$844ec244b1367d54 = $b4a8a5c310566eb2$var$isString;
function $b4a8a5c310566eb2$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$b4a8a5c310566eb2$export$a244864fd9645c7f = $b4a8a5c310566eb2$var$isSymbol;
function $b4a8a5c310566eb2$var$isUndefined(arg) {
    return arg === void 0;
}
$b4a8a5c310566eb2$export$fce6876652108ab = $b4a8a5c310566eb2$var$isUndefined;
function $b4a8a5c310566eb2$var$isRegExp(re) {
    return $b4a8a5c310566eb2$var$objectToString(re) === '[object RegExp]';
}
$b4a8a5c310566eb2$export$49841c62b9eff15 = $b4a8a5c310566eb2$var$isRegExp;
function $b4a8a5c310566eb2$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$b4a8a5c310566eb2$export$a6cdc56e425d0d0a = $b4a8a5c310566eb2$var$isObject;
function $b4a8a5c310566eb2$var$isDate(d) {
    return $b4a8a5c310566eb2$var$objectToString(d) === '[object Date]';
}
$b4a8a5c310566eb2$export$871608497c498473 = $b4a8a5c310566eb2$var$isDate;
function $b4a8a5c310566eb2$var$isError(e) {
    return $b4a8a5c310566eb2$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$b4a8a5c310566eb2$export$e6127cc7fe7395c3 = $b4a8a5c310566eb2$var$isError;
function $b4a8a5c310566eb2$var$isFunction(arg) {
    return typeof arg === 'function';
}
$b4a8a5c310566eb2$export$f6e2535fb5126e54 = $b4a8a5c310566eb2$var$isFunction;
function $b4a8a5c310566eb2$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$b4a8a5c310566eb2$export$c3825b437cbdea5c = $b4a8a5c310566eb2$var$isPrimitive;

$b4a8a5c310566eb2$export$a7884ebc965f8f54 = (parcelRequire("5k7LC")).Buffer.isBuffer;
function $b4a8a5c310566eb2$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("ZaRag", function(module, exports) {
'use strict';
function $0b7e1e7e4868f65f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cmRjm = parcelRequire("cmRjm");
var $0b7e1e7e4868f65f$require$Buffer = $cmRjm.Buffer;

var $hq3wB = parcelRequire("hq3wB");
function $0b7e1e7e4868f65f$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $0b7e1e7e4868f65f$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $0b7e1e7e4868f65f$require$Buffer.alloc(0);
        var ret = $0b7e1e7e4868f65f$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $0b7e1e7e4868f65f$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($hq3wB && $hq3wB.inspect && $hq3wB.inspect.custom) module.exports.prototype[$hq3wB.inspect.custom] = function() {
    var obj = $hq3wB.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("9tGJn", function(module, exports) {
'use strict';

var $iWV9i = parcelRequire("iWV9i");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $6e67f7f8fc7376f2$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $6e67f7f8fc7376f2$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $6e67f7f8fc7376f2$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $6e67f7f8fc7376f2$var$destroy,
    undestroy: $6e67f7f8fc7376f2$var$undestroy
};

});

parcelRegister("fAlCy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $iWV9i = parcelRequire("iWV9i");
/*</replacement>*/ /*<replacement>*/ var $b58afd4655d03bd4$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b58afd4655d03bd4$var$Duplex;

/*<replacement>*/ var $b58afd4655d03bd4$var$util = Object.create((parcelRequire("fvDPy")));

$b58afd4655d03bd4$var$util.inherits = (parcelRequire("v3bBu"));

var $hVjIO = parcelRequire("hVjIO");

var $3YGVr = parcelRequire("3YGVr");
$b58afd4655d03bd4$var$util.inherits($b58afd4655d03bd4$var$Duplex, $hVjIO);
// avoid scope creep, the keys array can then be collected
var $b58afd4655d03bd4$var$keys = $b58afd4655d03bd4$var$objectKeys($3YGVr.prototype);
for(var $b58afd4655d03bd4$var$v = 0; $b58afd4655d03bd4$var$v < $b58afd4655d03bd4$var$keys.length; $b58afd4655d03bd4$var$v++){
    var $b58afd4655d03bd4$var$method = $b58afd4655d03bd4$var$keys[$b58afd4655d03bd4$var$v];
    if (!$b58afd4655d03bd4$var$Duplex.prototype[$b58afd4655d03bd4$var$method]) $b58afd4655d03bd4$var$Duplex.prototype[$b58afd4655d03bd4$var$method] = $3YGVr.prototype[$b58afd4655d03bd4$var$method];
}
function $b58afd4655d03bd4$var$Duplex(options) {
    if (!(this instanceof $b58afd4655d03bd4$var$Duplex)) return new $b58afd4655d03bd4$var$Duplex(options);
    $hVjIO.call(this, options);
    $3YGVr.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $b58afd4655d03bd4$var$onend);
}
Object.defineProperty($b58afd4655d03bd4$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $b58afd4655d03bd4$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $iWV9i.nextTick($b58afd4655d03bd4$var$onEndNT, this);
}
function $b58afd4655d03bd4$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b58afd4655d03bd4$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$b58afd4655d03bd4$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $iWV9i.nextTick(cb, err);
};

});
parcelRegister("3YGVr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $iWV9i = parcelRequire("iWV9i");
/*</replacement>*/ module.exports = $2e5845c95b44c650$var$Writable;
/* <replacement> */ function $2e5845c95b44c650$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2e5845c95b44c650$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2e5845c95b44c650$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2e5845c95b44c650$var$asyncWrite = (0, $iWV9i.nextTick);
/*</replacement>*/ /*<replacement>*/ var $2e5845c95b44c650$var$Duplex;
/*</replacement>*/ $2e5845c95b44c650$var$Writable.WritableState = $2e5845c95b44c650$var$WritableState;

/*<replacement>*/ var $2e5845c95b44c650$var$util = Object.create((parcelRequire("fvDPy")));

$2e5845c95b44c650$var$util.inherits = (parcelRequire("v3bBu"));

/*</replacement>*/ /*<replacement>*/ var $2e5845c95b44c650$var$internalUtil = {
    deprecate: (parcelRequire("geQ6V"))
};

var $4t6fq = parcelRequire("4t6fq");

var $cmRjm = parcelRequire("cmRjm");
var $2e5845c95b44c650$require$Buffer = $cmRjm.Buffer;
var $2e5845c95b44c650$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $2e5845c95b44c650$var$_uint8ArrayToBuffer(chunk) {
    return $2e5845c95b44c650$require$Buffer.from(chunk);
}
function $2e5845c95b44c650$var$_isUint8Array(obj) {
    return $2e5845c95b44c650$require$Buffer.isBuffer(obj) || obj instanceof $2e5845c95b44c650$var$OurUint8Array;
}

var $9tGJn = parcelRequire("9tGJn");
$2e5845c95b44c650$var$util.inherits($2e5845c95b44c650$var$Writable, $4t6fq);
function $2e5845c95b44c650$var$nop() {}

function $2e5845c95b44c650$var$WritableState(options, stream) {
    $2e5845c95b44c650$var$Duplex = $2e5845c95b44c650$var$Duplex || (parcelRequire("fAlCy"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $2e5845c95b44c650$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2e5845c95b44c650$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2e5845c95b44c650$var$CorkedRequest(this);
}
$2e5845c95b44c650$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2e5845c95b44c650$var$WritableState.prototype, 'buffer', {
            get: $2e5845c95b44c650$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2e5845c95b44c650$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $2e5845c95b44c650$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2e5845c95b44c650$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($2e5845c95b44c650$var$realHasInstance.call(this, object)) return true;
            if (this !== $2e5845c95b44c650$var$Writable) return false;
            return object && object._writableState instanceof $2e5845c95b44c650$var$WritableState;
        }
    });
} else $2e5845c95b44c650$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $2e5845c95b44c650$var$Writable(options) {
    $2e5845c95b44c650$var$Duplex = $2e5845c95b44c650$var$Duplex || (parcelRequire("fAlCy"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$2e5845c95b44c650$var$realHasInstance.call($2e5845c95b44c650$var$Writable, this) && !(this instanceof $2e5845c95b44c650$var$Duplex)) return new $2e5845c95b44c650$var$Writable(options);
    this._writableState = new $2e5845c95b44c650$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $4t6fq.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2e5845c95b44c650$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $2e5845c95b44c650$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $iWV9i.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2e5845c95b44c650$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $iWV9i.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$2e5845c95b44c650$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2e5845c95b44c650$var$_isUint8Array(chunk);
    if (isBuf && !$2e5845c95b44c650$require$Buffer.isBuffer(chunk)) chunk = $2e5845c95b44c650$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $2e5845c95b44c650$var$nop;
    if (state.ended) $2e5845c95b44c650$var$writeAfterEnd(this, cb);
    else if (isBuf || $2e5845c95b44c650$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2e5845c95b44c650$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2e5845c95b44c650$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$2e5845c95b44c650$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2e5845c95b44c650$var$clearBuffer(this, state);
    }
};
$2e5845c95b44c650$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $2e5845c95b44c650$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2e5845c95b44c650$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2e5845c95b44c650$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2e5845c95b44c650$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2e5845c95b44c650$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2e5845c95b44c650$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2e5845c95b44c650$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2e5845c95b44c650$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $iWV9i.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $iWV9i.nextTick($2e5845c95b44c650$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $2e5845c95b44c650$var$finishMaybe(stream, state);
    }
}
function $2e5845c95b44c650$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2e5845c95b44c650$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $2e5845c95b44c650$var$onwriteStateUpdate(state);
    if (er) $2e5845c95b44c650$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2e5845c95b44c650$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2e5845c95b44c650$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $2e5845c95b44c650$var$asyncWrite($2e5845c95b44c650$var$afterWrite, stream, state, finished, cb);
        else $2e5845c95b44c650$var$afterWrite(stream, state, finished, cb);
    }
}
function $2e5845c95b44c650$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2e5845c95b44c650$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2e5845c95b44c650$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2e5845c95b44c650$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $2e5845c95b44c650$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2e5845c95b44c650$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2e5845c95b44c650$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2e5845c95b44c650$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2e5845c95b44c650$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$2e5845c95b44c650$var$Writable.prototype._writev = null;
$2e5845c95b44c650$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2e5845c95b44c650$var$endWritable(this, state, cb);
};
function $2e5845c95b44c650$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2e5845c95b44c650$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $2e5845c95b44c650$var$finishMaybe(stream, state);
    });
}
function $2e5845c95b44c650$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $iWV9i.nextTick($2e5845c95b44c650$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2e5845c95b44c650$var$finishMaybe(stream, state) {
    var need = $2e5845c95b44c650$var$needFinish(state);
    if (need) {
        $2e5845c95b44c650$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $2e5845c95b44c650$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2e5845c95b44c650$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $iWV9i.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2e5845c95b44c650$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2e5845c95b44c650$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2e5845c95b44c650$var$Writable.prototype.destroy = $9tGJn.destroy;
$2e5845c95b44c650$var$Writable.prototype._undestroy = $9tGJn.undestroy;
$2e5845c95b44c650$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("6ayCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $0128c026524ba8eb$export$63a7aa211a91ed69, (v) => $0128c026524ba8eb$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $0128c026524ba8eb$export$63a7aa211a91ed69;
'use strict';

var $cmRjm = parcelRequire("cmRjm");
var $0128c026524ba8eb$require$Buffer = $cmRjm.Buffer;
/*</replacement>*/ var $0128c026524ba8eb$var$isEncoding = $0128c026524ba8eb$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $0128c026524ba8eb$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $0128c026524ba8eb$var$normalizeEncoding(enc) {
    var nenc = $0128c026524ba8eb$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($0128c026524ba8eb$require$Buffer.isEncoding === $0128c026524ba8eb$var$isEncoding || !$0128c026524ba8eb$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$0128c026524ba8eb$export$63a7aa211a91ed69 = $0128c026524ba8eb$var$StringDecoder;
function $0128c026524ba8eb$var$StringDecoder(encoding) {
    this.encoding = $0128c026524ba8eb$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $0128c026524ba8eb$var$utf16Text;
            this.end = $0128c026524ba8eb$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $0128c026524ba8eb$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $0128c026524ba8eb$var$base64Text;
            this.end = $0128c026524ba8eb$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $0128c026524ba8eb$var$simpleWrite;
            this.end = $0128c026524ba8eb$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $0128c026524ba8eb$require$Buffer.allocUnsafe(nb);
}
$0128c026524ba8eb$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$0128c026524ba8eb$var$StringDecoder.prototype.end = $0128c026524ba8eb$var$utf8End;
// Returns only complete characters in a Buffer
$0128c026524ba8eb$var$StringDecoder.prototype.text = $0128c026524ba8eb$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$0128c026524ba8eb$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $0128c026524ba8eb$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $0128c026524ba8eb$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $0128c026524ba8eb$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $0128c026524ba8eb$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $0128c026524ba8eb$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $0128c026524ba8eb$var$utf8Text(buf, i) {
    var total = $0128c026524ba8eb$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $0128c026524ba8eb$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $0128c026524ba8eb$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $0128c026524ba8eb$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $0128c026524ba8eb$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $0128c026524ba8eb$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $0128c026524ba8eb$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $0128c026524ba8eb$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("8iQyH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $60b8c636590317a6$var$Transform;

var $fAlCy = parcelRequire("fAlCy");

/*<replacement>*/ var $60b8c636590317a6$var$util = Object.create((parcelRequire("fvDPy")));

$60b8c636590317a6$var$util.inherits = (parcelRequire("v3bBu"));
/*</replacement>*/ $60b8c636590317a6$var$util.inherits($60b8c636590317a6$var$Transform, $fAlCy);
function $60b8c636590317a6$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $60b8c636590317a6$var$Transform(options) {
    if (!(this instanceof $60b8c636590317a6$var$Transform)) return new $60b8c636590317a6$var$Transform(options);
    $fAlCy.call(this, options);
    this._transformState = {
        afterTransform: $60b8c636590317a6$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $60b8c636590317a6$var$prefinish);
}
function $60b8c636590317a6$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $60b8c636590317a6$var$done(_this, er, data);
    });
    else $60b8c636590317a6$var$done(this, null, null);
}
$60b8c636590317a6$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fAlCy.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$60b8c636590317a6$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$60b8c636590317a6$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$60b8c636590317a6$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$60b8c636590317a6$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $fAlCy.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $60b8c636590317a6$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("WEefO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $0b049f8430f02ec4$var$PassThrough;

var $8iQyH = parcelRequire("8iQyH");

/*<replacement>*/ var $0b049f8430f02ec4$var$util = Object.create((parcelRequire("fvDPy")));

$0b049f8430f02ec4$var$util.inherits = (parcelRequire("v3bBu"));
/*</replacement>*/ $0b049f8430f02ec4$var$util.inherits($0b049f8430f02ec4$var$PassThrough, $8iQyH);
function $0b049f8430f02ec4$var$PassThrough(options) {
    if (!(this instanceof $0b049f8430f02ec4$var$PassThrough)) return new $0b049f8430f02ec4$var$PassThrough(options);
    $8iQyH.call(this, options);
}
$0b049f8430f02ec4$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("kYhYb", function(module, exports) {
'use strict';

var $Wth4q = parcelRequire("Wth4q");
var $f44759abe9feb4ae$require$Buffer = $Wth4q.Buffer;

var $j65bP = parcelRequire("j65bP");

var $cfrZu = parcelRequire("cfrZu");

var $8JoQd = parcelRequire("8JoQd");
var $f44759abe9feb4ae$require$EC = $8JoQd.ec;

var $bSSUf = parcelRequire("bSSUf");

var $ejFGc = parcelRequire("ejFGc");

var $jf5f0 = parcelRequire("jf5f0");
var $f44759abe9feb4ae$var$RSA_PKCS1_PADDING = 1;
function $f44759abe9feb4ae$var$sign(hash, key, hashType, signType, tag) {
    var priv = $ejFGc(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $f44759abe9feb4ae$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $f44759abe9feb4ae$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $f44759abe9feb4ae$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $f44759abe9feb4ae$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $cfrZu(pad, priv);
    return out;
}
function $f44759abe9feb4ae$var$ecSign(hash, priv) {
    var curveId = $jf5f0[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $f44759abe9feb4ae$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $f44759abe9feb4ae$require$Buffer.from(out.toDER());
}
function $f44759abe9feb4ae$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $bSSUf(0);
    var k;
    var H = $f44759abe9feb4ae$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $f44759abe9feb4ae$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $f44759abe9feb4ae$var$makeKey(q, kv, algo);
        r = $f44759abe9feb4ae$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $bSSUf(0);
        }
    }
    return $f44759abe9feb4ae$var$toDER(r, s);
}
function $f44759abe9feb4ae$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $f44759abe9feb4ae$require$Buffer.from(res);
}
function $f44759abe9feb4ae$var$getKey(x, q, hash, algo) {
    x = $f44759abe9feb4ae$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $f44759abe9feb4ae$require$Buffer.alloc(q.byteLength() - x.length);
        x = $f44759abe9feb4ae$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $f44759abe9feb4ae$var$bits2octets(hash, q);
    var v = $f44759abe9feb4ae$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $f44759abe9feb4ae$require$Buffer.alloc(hlen);
    k = $j65bP(algo, k).update(v).update($f44759abe9feb4ae$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $j65bP(algo, k).update(v).digest();
    k = $j65bP(algo, k).update(v).update($f44759abe9feb4ae$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $j65bP(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $f44759abe9feb4ae$var$bits2int(obits, q) {
    var bits = new $bSSUf(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $f44759abe9feb4ae$var$bits2octets(bits, q) {
    bits = $f44759abe9feb4ae$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $f44759abe9feb4ae$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $f44759abe9feb4ae$require$Buffer.alloc(q.byteLength() - out.length);
        out = $f44759abe9feb4ae$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $f44759abe9feb4ae$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $f44759abe9feb4ae$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $j65bP(algo, kv.k).update(kv.v).digest();
            t = $f44759abe9feb4ae$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $f44759abe9feb4ae$var$bits2int(t, q);
        kv.k = $j65bP(algo, kv.k).update(kv.v).update($f44759abe9feb4ae$require$Buffer.from([
            0
        ])).digest();
        kv.v = $j65bP(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $f44759abe9feb4ae$var$makeR(g, k, p, q) {
    return g.toRed($bSSUf.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $f44759abe9feb4ae$var$sign;
module.exports.getKey = $f44759abe9feb4ae$var$getKey;
module.exports.makeKey = $f44759abe9feb4ae$var$makeKey;

});
parcelRegister("cfrZu", function(module, exports) {
'use strict';

var $bSSUf = parcelRequire("bSSUf");

var $1DyI6 = parcelRequire("1DyI6");

var $Wth4q = parcelRequire("Wth4q");
var $8eac99241a98d6c0$require$Buffer = $Wth4q.Buffer;
function $8eac99241a98d6c0$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $bSSUf($1DyI6(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $8eac99241a98d6c0$var$blind(priv) {
    var r = $8eac99241a98d6c0$var$getr(priv);
    var blinder = r.toRed($bSSUf.mont(priv.modulus)).redPow(new $bSSUf(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $8eac99241a98d6c0$var$crt(msg, priv) {
    var blinds = $8eac99241a98d6c0$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $bSSUf(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($bSSUf.mont(priv.prime1));
    var c2 = blinded.toRed($bSSUf.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($8eac99241a98d6c0$require$Buffer, 'be', len);
}
$8eac99241a98d6c0$var$crt.getr = $8eac99241a98d6c0$var$getr;
module.exports = $8eac99241a98d6c0$var$crt;

});
parcelRegister("bSSUf", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hq3wB")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("8JoQd", function(module, exports) {
'use strict';
var $65b5cb9dd0661cc3$var$elliptic = module.exports;

$65b5cb9dd0661cc3$var$elliptic.version = (parcelRequire("gkWIM")).version;

$65b5cb9dd0661cc3$var$elliptic.utils = (parcelRequire("onO0l"));

$65b5cb9dd0661cc3$var$elliptic.rand = (parcelRequire("9D8YT"));

$65b5cb9dd0661cc3$var$elliptic.curve = (parcelRequire("9QOKF"));

$65b5cb9dd0661cc3$var$elliptic.curves = (parcelRequire("gli5y"));

// Protocols
$65b5cb9dd0661cc3$var$elliptic.ec = (parcelRequire("9Cxq1"));

$65b5cb9dd0661cc3$var$elliptic.eddsa = (parcelRequire("5xIaV"));

});
parcelRegister("gkWIM", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib\\/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test\\/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist\\/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny\\/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https:\\/\\/github.com\\/indutny\\/elliptic\\/issues\"},\"homepage\":\"https:\\/\\/github.com\\/indutny\\/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("onO0l", function(module, exports) {
'use strict';
var $0494b54965d0d2c4$var$utils = module.exports;

var $9pbIC = parcelRequire("9pbIC");

var $gxaFy = parcelRequire("gxaFy");

var $2WqN6 = parcelRequire("2WqN6");
$0494b54965d0d2c4$var$utils.assert = $gxaFy;
$0494b54965d0d2c4$var$utils.toArray = $2WqN6.toArray;
$0494b54965d0d2c4$var$utils.zero2 = $2WqN6.zero2;
$0494b54965d0d2c4$var$utils.toHex = $2WqN6.toHex;
$0494b54965d0d2c4$var$utils.encode = $2WqN6.encode;
// Represent num in a w-NAF form
function $0494b54965d0d2c4$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$0494b54965d0d2c4$var$utils.getNAF = $0494b54965d0d2c4$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $0494b54965d0d2c4$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$0494b54965d0d2c4$var$utils.getJSF = $0494b54965d0d2c4$var$getJSF;
function $0494b54965d0d2c4$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$0494b54965d0d2c4$var$utils.cachedProperty = $0494b54965d0d2c4$var$cachedProperty;
function $0494b54965d0d2c4$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $0494b54965d0d2c4$var$utils.toArray(bytes, 'hex') : bytes;
}
$0494b54965d0d2c4$var$utils.parseBytes = $0494b54965d0d2c4$var$parseBytes;
function $0494b54965d0d2c4$var$intFromLE(bytes) {
    return new $9pbIC(bytes, 'hex', 'le');
}
$0494b54965d0d2c4$var$utils.intFromLE = $0494b54965d0d2c4$var$intFromLE;

});
parcelRegister("2WqN6", function(module, exports) {
'use strict';
var $2245c7a9bbd83d59$var$utils = module.exports;
function $2245c7a9bbd83d59$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$2245c7a9bbd83d59$var$utils.toArray = $2245c7a9bbd83d59$var$toArray;
function $2245c7a9bbd83d59$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$2245c7a9bbd83d59$var$utils.zero2 = $2245c7a9bbd83d59$var$zero2;
function $2245c7a9bbd83d59$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $2245c7a9bbd83d59$var$zero2(msg[i].toString(16));
    return res;
}
$2245c7a9bbd83d59$var$utils.toHex = $2245c7a9bbd83d59$var$toHex;
$2245c7a9bbd83d59$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $2245c7a9bbd83d59$var$toHex(arr);
    else return arr;
};

});


parcelRegister("9QOKF", function(module, exports) {
'use strict';
var $72c056a3dd9c1fd5$var$curve = module.exports;

$72c056a3dd9c1fd5$var$curve.base = (parcelRequire("5DDDX"));

$72c056a3dd9c1fd5$var$curve.short = (parcelRequire("adWZB"));

$72c056a3dd9c1fd5$var$curve.mont = (parcelRequire("8yFev"));

$72c056a3dd9c1fd5$var$curve.edwards = (parcelRequire("4wgwz"));

});
parcelRegister("5DDDX", function(module, exports) {
'use strict';

var $9pbIC = parcelRequire("9pbIC");

var $onO0l = parcelRequire("onO0l");
var $41af58a397e0e961$var$getNAF = $onO0l.getNAF;
var $41af58a397e0e961$var$getJSF = $onO0l.getJSF;
var $41af58a397e0e961$var$assert = $onO0l.assert;
function $41af58a397e0e961$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $9pbIC(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $9pbIC.red(conf.prime) : $9pbIC.mont(this.p);
    // Useful for many curves
    this.zero = new $9pbIC(0).toRed(this.red);
    this.one = new $9pbIC(1).toRed(this.red);
    this.two = new $9pbIC(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $9pbIC(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $41af58a397e0e961$var$BaseCurve;
$41af58a397e0e961$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$41af58a397e0e961$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$41af58a397e0e961$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $41af58a397e0e961$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $41af58a397e0e961$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$41af58a397e0e961$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $41af58a397e0e961$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $41af58a397e0e961$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$41af58a397e0e961$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $41af58a397e0e961$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $41af58a397e0e961$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $41af58a397e0e961$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $41af58a397e0e961$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$41af58a397e0e961$var$BaseCurve.BasePoint = $41af58a397e0e961$var$BasePoint;
$41af58a397e0e961$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$41af58a397e0e961$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$41af58a397e0e961$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $onO0l.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $41af58a397e0e961$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $41af58a397e0e961$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$41af58a397e0e961$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$41af58a397e0e961$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$41af58a397e0e961$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $onO0l.encode(this._encode(compact), enc);
};
$41af58a397e0e961$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$41af58a397e0e961$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$41af58a397e0e961$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$41af58a397e0e961$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$41af58a397e0e961$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$41af58a397e0e961$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("adWZB", function(module, exports) {
'use strict';

var $onO0l = parcelRequire("onO0l");

var $9pbIC = parcelRequire("9pbIC");

var $v3bBu = parcelRequire("v3bBu");

var $5DDDX = parcelRequire("5DDDX");
var $7718e0f8fe39ea5b$var$assert = $onO0l.assert;
function $7718e0f8fe39ea5b$var$ShortCurve(conf) {
    $5DDDX.call(this, 'short', conf);
    this.a = new $9pbIC(conf.a, 16).toRed(this.red);
    this.b = new $9pbIC(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$v3bBu($7718e0f8fe39ea5b$var$ShortCurve, $5DDDX);
module.exports = $7718e0f8fe39ea5b$var$ShortCurve;
$7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $9pbIC(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $9pbIC(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $7718e0f8fe39ea5b$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $9pbIC(vec.a, 16),
            b: new $9pbIC(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $9pbIC.mont(num);
    var tinv = new $9pbIC(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $9pbIC(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $9pbIC(1);
    var y1 = new $9pbIC(0);
    var x2 = new $9pbIC(0);
    var y2 = new $9pbIC(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$7718e0f8fe39ea5b$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$7718e0f8fe39ea5b$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $9pbIC(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$7718e0f8fe39ea5b$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$7718e0f8fe39ea5b$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $7718e0f8fe39ea5b$var$Point(curve, x, y, isRed) {
    $5DDDX.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $9pbIC(x, 16);
        this.y = new $9pbIC(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$v3bBu($7718e0f8fe39ea5b$var$Point, $5DDDX.BasePoint);
$7718e0f8fe39ea5b$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $7718e0f8fe39ea5b$var$Point(this, x, y, isRed);
};
$7718e0f8fe39ea5b$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $7718e0f8fe39ea5b$var$Point.fromJSON(this, obj, red);
};
$7718e0f8fe39ea5b$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$7718e0f8fe39ea5b$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$7718e0f8fe39ea5b$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$7718e0f8fe39ea5b$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$7718e0f8fe39ea5b$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$7718e0f8fe39ea5b$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$7718e0f8fe39ea5b$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$7718e0f8fe39ea5b$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$7718e0f8fe39ea5b$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$7718e0f8fe39ea5b$var$Point.prototype.mul = function mul(k) {
    k = new $9pbIC(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$7718e0f8fe39ea5b$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$7718e0f8fe39ea5b$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$7718e0f8fe39ea5b$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$7718e0f8fe39ea5b$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$7718e0f8fe39ea5b$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $7718e0f8fe39ea5b$var$JPoint(curve, x, y, z) {
    $5DDDX.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $9pbIC(0);
    } else {
        this.x = new $9pbIC(x, 16);
        this.y = new $9pbIC(y, 16);
        this.z = new $9pbIC(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$v3bBu($7718e0f8fe39ea5b$var$JPoint, $5DDDX.BasePoint);
$7718e0f8fe39ea5b$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $7718e0f8fe39ea5b$var$JPoint(this, x, y, z);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$7718e0f8fe39ea5b$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$7718e0f8fe39ea5b$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$7718e0f8fe39ea5b$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $9pbIC(k, kbase);
    return this.curve._wnafMul(this, k);
};
$7718e0f8fe39ea5b$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$7718e0f8fe39ea5b$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$7718e0f8fe39ea5b$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$7718e0f8fe39ea5b$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("8yFev", function(module, exports) {
'use strict';

var $9pbIC = parcelRequire("9pbIC");

var $v3bBu = parcelRequire("v3bBu");

var $5DDDX = parcelRequire("5DDDX");

var $onO0l = parcelRequire("onO0l");
function $63b17bb79b50781b$var$MontCurve(conf) {
    $5DDDX.call(this, 'mont', conf);
    this.a = new $9pbIC(conf.a, 16).toRed(this.red);
    this.b = new $9pbIC(conf.b, 16).toRed(this.red);
    this.i4 = new $9pbIC(4).toRed(this.red).redInvm();
    this.two = new $9pbIC(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$v3bBu($63b17bb79b50781b$var$MontCurve, $5DDDX);
module.exports = $63b17bb79b50781b$var$MontCurve;
$63b17bb79b50781b$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $63b17bb79b50781b$var$Point(curve, x, z) {
    $5DDDX.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $9pbIC(x, 16);
        this.z = new $9pbIC(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$v3bBu($63b17bb79b50781b$var$Point, $5DDDX.BasePoint);
$63b17bb79b50781b$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($onO0l.toArray(bytes, enc), 1);
};
$63b17bb79b50781b$var$MontCurve.prototype.point = function point(x, z) {
    return new $63b17bb79b50781b$var$Point(this, x, z);
};
$63b17bb79b50781b$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $63b17bb79b50781b$var$Point.fromJSON(this, obj);
};
$63b17bb79b50781b$var$Point.prototype.precompute = function precompute() {
// No-op
};
$63b17bb79b50781b$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$63b17bb79b50781b$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $63b17bb79b50781b$var$Point(curve, obj[0], obj[1] || curve.one);
};
$63b17bb79b50781b$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$63b17bb79b50781b$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$63b17bb79b50781b$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$63b17bb79b50781b$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$63b17bb79b50781b$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$63b17bb79b50781b$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$63b17bb79b50781b$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$63b17bb79b50781b$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$63b17bb79b50781b$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$63b17bb79b50781b$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$63b17bb79b50781b$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("4wgwz", function(module, exports) {
'use strict';

var $onO0l = parcelRequire("onO0l");

var $9pbIC = parcelRequire("9pbIC");

var $v3bBu = parcelRequire("v3bBu");

var $5DDDX = parcelRequire("5DDDX");
var $34a6f7f58efb73a0$var$assert = $onO0l.assert;
function $34a6f7f58efb73a0$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $5DDDX.call(this, 'edwards', conf);
    this.a = new $9pbIC(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $9pbIC(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $9pbIC(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $34a6f7f58efb73a0$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$v3bBu($34a6f7f58efb73a0$var$EdwardsCurve, $5DDDX);
module.exports = $34a6f7f58efb73a0$var$EdwardsCurve;
$34a6f7f58efb73a0$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$34a6f7f58efb73a0$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$34a6f7f58efb73a0$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $9pbIC(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $9pbIC(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$34a6f7f58efb73a0$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $34a6f7f58efb73a0$var$Point(curve, x, y, z, t) {
    $5DDDX.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $9pbIC(x, 16);
        this.y = new $9pbIC(y, 16);
        this.z = z ? new $9pbIC(z, 16) : this.curve.one;
        this.t = t && new $9pbIC(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$v3bBu($34a6f7f58efb73a0$var$Point, $5DDDX.BasePoint);
$34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $34a6f7f58efb73a0$var$Point.fromJSON(this, obj);
};
$34a6f7f58efb73a0$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $34a6f7f58efb73a0$var$Point(this, x, y, z, t);
};
$34a6f7f58efb73a0$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $34a6f7f58efb73a0$var$Point(curve, obj[0], obj[1], obj[2]);
};
$34a6f7f58efb73a0$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$34a6f7f58efb73a0$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$34a6f7f58efb73a0$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$34a6f7f58efb73a0$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$34a6f7f58efb73a0$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$34a6f7f58efb73a0$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$34a6f7f58efb73a0$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$34a6f7f58efb73a0$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$34a6f7f58efb73a0$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$34a6f7f58efb73a0$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$34a6f7f58efb73a0$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$34a6f7f58efb73a0$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$34a6f7f58efb73a0$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$34a6f7f58efb73a0$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$34a6f7f58efb73a0$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$34a6f7f58efb73a0$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$34a6f7f58efb73a0$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$34a6f7f58efb73a0$var$Point.prototype.toP = $34a6f7f58efb73a0$var$Point.prototype.normalize;
$34a6f7f58efb73a0$var$Point.prototype.mixedAdd = $34a6f7f58efb73a0$var$Point.prototype.add;

});


parcelRegister("gli5y", function(module, exports) {
'use strict';
var $be5ca37f73d5b5bb$var$curves = module.exports;

var $hx0iN = parcelRequire("hx0iN");

var $9QOKF = parcelRequire("9QOKF");

var $onO0l = parcelRequire("onO0l");
var $be5ca37f73d5b5bb$var$assert = $onO0l.assert;
function $be5ca37f73d5b5bb$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $9QOKF.short(options);
    else if (options.type === 'edwards') this.curve = new $9QOKF.edwards(options);
    else this.curve = new $9QOKF.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $be5ca37f73d5b5bb$var$assert(this.g.validate(), 'Invalid curve');
    $be5ca37f73d5b5bb$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$be5ca37f73d5b5bb$var$curves.PresetCurve = $be5ca37f73d5b5bb$var$PresetCurve;
function $be5ca37f73d5b5bb$var$defineCurve(name, options) {
    Object.defineProperty($be5ca37f73d5b5bb$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $be5ca37f73d5b5bb$var$PresetCurve(options);
            Object.defineProperty($be5ca37f73d5b5bb$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$be5ca37f73d5b5bb$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $hx0iN.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$be5ca37f73d5b5bb$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $hx0iN.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$be5ca37f73d5b5bb$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $hx0iN.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$be5ca37f73d5b5bb$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $hx0iN.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$be5ca37f73d5b5bb$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $hx0iN.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$be5ca37f73d5b5bb$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $hx0iN.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$be5ca37f73d5b5bb$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $hx0iN.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $be5ca37f73d5b5bb$var$pre;

try {
    $be5ca37f73d5b5bb$var$pre = (parcelRequire("6pt7M"));
} catch (e) {
    $be5ca37f73d5b5bb$var$pre = undefined;
}
$be5ca37f73d5b5bb$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $hx0iN.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $be5ca37f73d5b5bb$var$pre
    ]
});

});
parcelRegister("hx0iN", function(module, exports) {
var $cc35c0beabff9706$var$hash = module.exports;

$cc35c0beabff9706$var$hash.utils = (parcelRequire("3OMi8"));

$cc35c0beabff9706$var$hash.common = (parcelRequire("37Fr9"));

$cc35c0beabff9706$var$hash.sha = (parcelRequire("h6ox1"));

$cc35c0beabff9706$var$hash.ripemd = (parcelRequire("7uO26"));

$cc35c0beabff9706$var$hash.hmac = (parcelRequire("aFtrN"));
// Proxy hash functions to the main object
$cc35c0beabff9706$var$hash.sha1 = $cc35c0beabff9706$var$hash.sha.sha1;
$cc35c0beabff9706$var$hash.sha256 = $cc35c0beabff9706$var$hash.sha.sha256;
$cc35c0beabff9706$var$hash.sha224 = $cc35c0beabff9706$var$hash.sha.sha224;
$cc35c0beabff9706$var$hash.sha384 = $cc35c0beabff9706$var$hash.sha.sha384;
$cc35c0beabff9706$var$hash.sha512 = $cc35c0beabff9706$var$hash.sha.sha512;
$cc35c0beabff9706$var$hash.ripemd160 = $cc35c0beabff9706$var$hash.ripemd.ripemd160;

});
parcelRegister("3OMi8", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $2c7b8050559f98bf$export$69f1b2dcda23c5f8, (v) => $2c7b8050559f98bf$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $2c7b8050559f98bf$export$45b10814cc054894, (v) => $2c7b8050559f98bf$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $2c7b8050559f98bf$export$7ea66e3774a60b67, (v) => $2c7b8050559f98bf$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $2c7b8050559f98bf$export$34a52f00f601f6f1, (v) => $2c7b8050559f98bf$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $2c7b8050559f98bf$export$812b0cbd5e8a72ab, (v) => $2c7b8050559f98bf$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $2c7b8050559f98bf$export$f24f9e11d63bb314, (v) => $2c7b8050559f98bf$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $2c7b8050559f98bf$export$b71357c7e07ca1f1, (v) => $2c7b8050559f98bf$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $2c7b8050559f98bf$export$2e58a4b541fdcbe8, (v) => $2c7b8050559f98bf$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $2c7b8050559f98bf$export$183b950bde9faab8, (v) => $2c7b8050559f98bf$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $2c7b8050559f98bf$export$4785c77169fea59e, (v) => $2c7b8050559f98bf$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $2c7b8050559f98bf$export$242a185dfcffac5b, (v) => $2c7b8050559f98bf$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $2c7b8050559f98bf$export$58c04ae0ae31877d, (v) => $2c7b8050559f98bf$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $2c7b8050559f98bf$export$d058ca695f8c6f11, (v) => $2c7b8050559f98bf$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $2c7b8050559f98bf$export$a1efd7fc3e986367, (v) => $2c7b8050559f98bf$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $2c7b8050559f98bf$export$bbfea4a2b5abaab4, (v) => $2c7b8050559f98bf$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $2c7b8050559f98bf$export$97ad4afc7de86152, (v) => $2c7b8050559f98bf$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $2c7b8050559f98bf$export$ce4673d9a79f6a4b, (v) => $2c7b8050559f98bf$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $2c7b8050559f98bf$export$786cc99fc6eedc0b, (v) => $2c7b8050559f98bf$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $2c7b8050559f98bf$export$45c59b9a1848dd0, (v) => $2c7b8050559f98bf$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $2c7b8050559f98bf$export$50d8f613e76d3034, (v) => $2c7b8050559f98bf$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $2c7b8050559f98bf$export$b8e83683c60ee162, (v) => $2c7b8050559f98bf$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $2c7b8050559f98bf$export$aeeb51790d1bcc4a, (v) => $2c7b8050559f98bf$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $2c7b8050559f98bf$export$bb7c616f719ad9c, (v) => $2c7b8050559f98bf$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $2c7b8050559f98bf$export$4d63290824f9d7df, (v) => $2c7b8050559f98bf$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $2c7b8050559f98bf$export$2f64ceb90ef28ea1, (v) => $2c7b8050559f98bf$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $2c7b8050559f98bf$export$8d2089d465f6d10d, (v) => $2c7b8050559f98bf$export$8d2089d465f6d10d = v);
var $2c7b8050559f98bf$export$69f1b2dcda23c5f8;
var $2c7b8050559f98bf$export$45b10814cc054894;
var $2c7b8050559f98bf$export$7ea66e3774a60b67;
var $2c7b8050559f98bf$export$34a52f00f601f6f1;
var $2c7b8050559f98bf$export$812b0cbd5e8a72ab;
var $2c7b8050559f98bf$export$f24f9e11d63bb314;
var $2c7b8050559f98bf$export$b71357c7e07ca1f1;
var $2c7b8050559f98bf$export$2e58a4b541fdcbe8;
var $2c7b8050559f98bf$export$183b950bde9faab8;
var $2c7b8050559f98bf$export$4785c77169fea59e;
var $2c7b8050559f98bf$export$242a185dfcffac5b;
var $2c7b8050559f98bf$export$58c04ae0ae31877d;
var $2c7b8050559f98bf$export$d058ca695f8c6f11;
var $2c7b8050559f98bf$export$a1efd7fc3e986367;
var $2c7b8050559f98bf$export$bbfea4a2b5abaab4;
var $2c7b8050559f98bf$export$97ad4afc7de86152;
var $2c7b8050559f98bf$export$ce4673d9a79f6a4b;
var $2c7b8050559f98bf$export$786cc99fc6eedc0b;
var $2c7b8050559f98bf$export$45c59b9a1848dd0;
var $2c7b8050559f98bf$export$50d8f613e76d3034;
var $2c7b8050559f98bf$export$b8e83683c60ee162;
var $2c7b8050559f98bf$export$aeeb51790d1bcc4a;
var $2c7b8050559f98bf$export$bb7c616f719ad9c;
var $2c7b8050559f98bf$export$4d63290824f9d7df;
var $2c7b8050559f98bf$export$2f64ceb90ef28ea1;
var $2c7b8050559f98bf$export$8d2089d465f6d10d;
'use strict';

var $gxaFy = parcelRequire("gxaFy");

var $v3bBu = parcelRequire("v3bBu");
$2c7b8050559f98bf$export$69f1b2dcda23c5f8 = $v3bBu;
function $2c7b8050559f98bf$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$2c7b8050559f98bf$export$45b10814cc054894 = $2c7b8050559f98bf$var$toArray;
function $2c7b8050559f98bf$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $2c7b8050559f98bf$var$zero2(msg[i].toString(16));
    return res;
}
$2c7b8050559f98bf$export$7ea66e3774a60b67 = $2c7b8050559f98bf$var$toHex;
function $2c7b8050559f98bf$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$2c7b8050559f98bf$export$34a52f00f601f6f1 = $2c7b8050559f98bf$var$htonl;
function $2c7b8050559f98bf$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $2c7b8050559f98bf$var$htonl(w);
        res += $2c7b8050559f98bf$var$zero8(w.toString(16));
    }
    return res;
}
$2c7b8050559f98bf$export$812b0cbd5e8a72ab = $2c7b8050559f98bf$var$toHex32;
function $2c7b8050559f98bf$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$2c7b8050559f98bf$export$f24f9e11d63bb314 = $2c7b8050559f98bf$var$zero2;
function $2c7b8050559f98bf$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$2c7b8050559f98bf$export$b71357c7e07ca1f1 = $2c7b8050559f98bf$var$zero8;
function $2c7b8050559f98bf$var$join32(msg, start, end, endian) {
    var len = end - start;
    $gxaFy(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$2c7b8050559f98bf$export$2e58a4b541fdcbe8 = $2c7b8050559f98bf$var$join32;
function $2c7b8050559f98bf$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$2c7b8050559f98bf$export$183b950bde9faab8 = $2c7b8050559f98bf$var$split32;
function $2c7b8050559f98bf$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$2c7b8050559f98bf$export$4785c77169fea59e = $2c7b8050559f98bf$var$rotr32;
function $2c7b8050559f98bf$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$2c7b8050559f98bf$export$242a185dfcffac5b = $2c7b8050559f98bf$var$rotl32;
function $2c7b8050559f98bf$var$sum32(a, b) {
    return a + b >>> 0;
}
$2c7b8050559f98bf$export$58c04ae0ae31877d = $2c7b8050559f98bf$var$sum32;
function $2c7b8050559f98bf$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$2c7b8050559f98bf$export$d058ca695f8c6f11 = $2c7b8050559f98bf$var$sum32_3;
function $2c7b8050559f98bf$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$2c7b8050559f98bf$export$a1efd7fc3e986367 = $2c7b8050559f98bf$var$sum32_4;
function $2c7b8050559f98bf$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$2c7b8050559f98bf$export$bbfea4a2b5abaab4 = $2c7b8050559f98bf$var$sum32_5;
function $2c7b8050559f98bf$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$2c7b8050559f98bf$export$97ad4afc7de86152 = $2c7b8050559f98bf$var$sum64;
function $2c7b8050559f98bf$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$2c7b8050559f98bf$export$ce4673d9a79f6a4b = $2c7b8050559f98bf$var$sum64_hi;
function $2c7b8050559f98bf$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$2c7b8050559f98bf$export$786cc99fc6eedc0b = $2c7b8050559f98bf$var$sum64_lo;
function $2c7b8050559f98bf$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$2c7b8050559f98bf$export$45c59b9a1848dd0 = $2c7b8050559f98bf$var$sum64_4_hi;
function $2c7b8050559f98bf$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$2c7b8050559f98bf$export$50d8f613e76d3034 = $2c7b8050559f98bf$var$sum64_4_lo;
function $2c7b8050559f98bf$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$2c7b8050559f98bf$export$b8e83683c60ee162 = $2c7b8050559f98bf$var$sum64_5_hi;
function $2c7b8050559f98bf$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$2c7b8050559f98bf$export$aeeb51790d1bcc4a = $2c7b8050559f98bf$var$sum64_5_lo;
function $2c7b8050559f98bf$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$2c7b8050559f98bf$export$bb7c616f719ad9c = $2c7b8050559f98bf$var$rotr64_hi;
function $2c7b8050559f98bf$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$2c7b8050559f98bf$export$4d63290824f9d7df = $2c7b8050559f98bf$var$rotr64_lo;
function $2c7b8050559f98bf$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$2c7b8050559f98bf$export$2f64ceb90ef28ea1 = $2c7b8050559f98bf$var$shr64_hi;
function $2c7b8050559f98bf$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$2c7b8050559f98bf$export$8d2089d465f6d10d = $2c7b8050559f98bf$var$shr64_lo;

});

parcelRegister("37Fr9", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $24622b0c2a9af610$export$8687658379b577e6, (v) => $24622b0c2a9af610$export$8687658379b577e6 = v);
var $24622b0c2a9af610$export$8687658379b577e6;
'use strict';

var $3OMi8 = parcelRequire("3OMi8");

var $gxaFy = parcelRequire("gxaFy");
function $24622b0c2a9af610$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$24622b0c2a9af610$export$8687658379b577e6 = $24622b0c2a9af610$var$BlockHash;
$24622b0c2a9af610$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $3OMi8.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $3OMi8.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$24622b0c2a9af610$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $gxaFy(this.pending === null);
    return this._digest(enc);
};
$24622b0c2a9af610$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("h6ox1", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $c73606a9c2933b70$export$5091bdda49ba90f5, (v) => $c73606a9c2933b70$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $c73606a9c2933b70$export$97b70509d4e397ea, (v) => $c73606a9c2933b70$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $c73606a9c2933b70$export$bced8d2aada2d1c9, (v) => $c73606a9c2933b70$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $c73606a9c2933b70$export$612d47d55dedde45, (v) => $c73606a9c2933b70$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $c73606a9c2933b70$export$a888d2532e6dc7bb, (v) => $c73606a9c2933b70$export$a888d2532e6dc7bb = v);
var $c73606a9c2933b70$export$5091bdda49ba90f5;
var $c73606a9c2933b70$export$97b70509d4e397ea;
var $c73606a9c2933b70$export$bced8d2aada2d1c9;
var $c73606a9c2933b70$export$612d47d55dedde45;
var $c73606a9c2933b70$export$a888d2532e6dc7bb;
'use strict';

$c73606a9c2933b70$export$5091bdda49ba90f5 = (parcelRequire("fjde1"));

$c73606a9c2933b70$export$97b70509d4e397ea = (parcelRequire("9SOcT"));

$c73606a9c2933b70$export$bced8d2aada2d1c9 = (parcelRequire("56TG7"));

$c73606a9c2933b70$export$612d47d55dedde45 = (parcelRequire("bmcCc"));

$c73606a9c2933b70$export$a888d2532e6dc7bb = (parcelRequire("5EQvK"));

});
parcelRegister("fjde1", function(module, exports) {
'use strict';

var $3OMi8 = parcelRequire("3OMi8");

var $37Fr9 = parcelRequire("37Fr9");

var $35KxV = parcelRequire("35KxV");
var $02e04dfe542928ee$var$rotl32 = $3OMi8.rotl32;
var $02e04dfe542928ee$var$sum32 = $3OMi8.sum32;
var $02e04dfe542928ee$var$sum32_5 = $3OMi8.sum32_5;
var $02e04dfe542928ee$var$ft_1 = $35KxV.ft_1;
var $02e04dfe542928ee$var$BlockHash = $37Fr9.BlockHash;
var $02e04dfe542928ee$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $02e04dfe542928ee$var$SHA1() {
    if (!(this instanceof $02e04dfe542928ee$var$SHA1)) return new $02e04dfe542928ee$var$SHA1();
    $02e04dfe542928ee$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$3OMi8.inherits($02e04dfe542928ee$var$SHA1, $02e04dfe542928ee$var$BlockHash);
module.exports = $02e04dfe542928ee$var$SHA1;
$02e04dfe542928ee$var$SHA1.blockSize = 512;
$02e04dfe542928ee$var$SHA1.outSize = 160;
$02e04dfe542928ee$var$SHA1.hmacStrength = 80;
$02e04dfe542928ee$var$SHA1.padLength = 64;
$02e04dfe542928ee$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $02e04dfe542928ee$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $02e04dfe542928ee$var$sum32_5($02e04dfe542928ee$var$rotl32(a, 5), $02e04dfe542928ee$var$ft_1(s, b, c, d), e, W[i], $02e04dfe542928ee$var$sha1_K[s]);
        e = d;
        d = c;
        c = $02e04dfe542928ee$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $02e04dfe542928ee$var$sum32(this.h[0], a);
    this.h[1] = $02e04dfe542928ee$var$sum32(this.h[1], b);
    this.h[2] = $02e04dfe542928ee$var$sum32(this.h[2], c);
    this.h[3] = $02e04dfe542928ee$var$sum32(this.h[3], d);
    this.h[4] = $02e04dfe542928ee$var$sum32(this.h[4], e);
};
$02e04dfe542928ee$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
    else return $3OMi8.split32(this.h, 'big');
};

});
parcelRegister("35KxV", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $2405f1d094d8bdf3$export$5a92649d7ddb9f63, (v) => $2405f1d094d8bdf3$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $2405f1d094d8bdf3$export$c6d0d020c3a6269, (v) => $2405f1d094d8bdf3$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $2405f1d094d8bdf3$export$eb90c27fca05f956, (v) => $2405f1d094d8bdf3$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $2405f1d094d8bdf3$export$14a4a98e063b1999, (v) => $2405f1d094d8bdf3$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $2405f1d094d8bdf3$export$d20cecfa1564c686, (v) => $2405f1d094d8bdf3$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $2405f1d094d8bdf3$export$44fd472a12fc6db, (v) => $2405f1d094d8bdf3$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $2405f1d094d8bdf3$export$1ed238bb6ea1dd47, (v) => $2405f1d094d8bdf3$export$1ed238bb6ea1dd47 = v);
var $2405f1d094d8bdf3$export$5a92649d7ddb9f63;
var $2405f1d094d8bdf3$export$c6d0d020c3a6269;
var $2405f1d094d8bdf3$export$eb90c27fca05f956;
var $2405f1d094d8bdf3$export$cc992891a14496a1;
var $2405f1d094d8bdf3$export$14a4a98e063b1999;
var $2405f1d094d8bdf3$export$d20cecfa1564c686;
var $2405f1d094d8bdf3$export$44fd472a12fc6db;
var $2405f1d094d8bdf3$export$1ed238bb6ea1dd47;
'use strict';

var $3OMi8 = parcelRequire("3OMi8");
var $2405f1d094d8bdf3$var$rotr32 = $3OMi8.rotr32;
function $2405f1d094d8bdf3$var$ft_1(s, x, y, z) {
    if (s === 0) return $2405f1d094d8bdf3$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $2405f1d094d8bdf3$var$p32(x, y, z);
    if (s === 2) return $2405f1d094d8bdf3$var$maj32(x, y, z);
}
$2405f1d094d8bdf3$export$5a92649d7ddb9f63 = $2405f1d094d8bdf3$var$ft_1;
function $2405f1d094d8bdf3$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$2405f1d094d8bdf3$export$c6d0d020c3a6269 = $2405f1d094d8bdf3$var$ch32;
function $2405f1d094d8bdf3$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$2405f1d094d8bdf3$export$eb90c27fca05f956 = $2405f1d094d8bdf3$var$maj32;
function $2405f1d094d8bdf3$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$2405f1d094d8bdf3$export$cc992891a14496a1 = $2405f1d094d8bdf3$var$p32;
function $2405f1d094d8bdf3$var$s0_256(x) {
    return $2405f1d094d8bdf3$var$rotr32(x, 2) ^ $2405f1d094d8bdf3$var$rotr32(x, 13) ^ $2405f1d094d8bdf3$var$rotr32(x, 22);
}
$2405f1d094d8bdf3$export$14a4a98e063b1999 = $2405f1d094d8bdf3$var$s0_256;
function $2405f1d094d8bdf3$var$s1_256(x) {
    return $2405f1d094d8bdf3$var$rotr32(x, 6) ^ $2405f1d094d8bdf3$var$rotr32(x, 11) ^ $2405f1d094d8bdf3$var$rotr32(x, 25);
}
$2405f1d094d8bdf3$export$d20cecfa1564c686 = $2405f1d094d8bdf3$var$s1_256;
function $2405f1d094d8bdf3$var$g0_256(x) {
    return $2405f1d094d8bdf3$var$rotr32(x, 7) ^ $2405f1d094d8bdf3$var$rotr32(x, 18) ^ x >>> 3;
}
$2405f1d094d8bdf3$export$44fd472a12fc6db = $2405f1d094d8bdf3$var$g0_256;
function $2405f1d094d8bdf3$var$g1_256(x) {
    return $2405f1d094d8bdf3$var$rotr32(x, 17) ^ $2405f1d094d8bdf3$var$rotr32(x, 19) ^ x >>> 10;
}
$2405f1d094d8bdf3$export$1ed238bb6ea1dd47 = $2405f1d094d8bdf3$var$g1_256;

});


parcelRegister("9SOcT", function(module, exports) {
'use strict';

var $3OMi8 = parcelRequire("3OMi8");

var $56TG7 = parcelRequire("56TG7");
function $73201a428a00b147$var$SHA224() {
    if (!(this instanceof $73201a428a00b147$var$SHA224)) return new $73201a428a00b147$var$SHA224();
    $56TG7.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$3OMi8.inherits($73201a428a00b147$var$SHA224, $56TG7);
module.exports = $73201a428a00b147$var$SHA224;
$73201a428a00b147$var$SHA224.blockSize = 512;
$73201a428a00b147$var$SHA224.outSize = 224;
$73201a428a00b147$var$SHA224.hmacStrength = 192;
$73201a428a00b147$var$SHA224.padLength = 64;
$73201a428a00b147$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $3OMi8.toHex32(this.h.slice(0, 7), 'big');
    else return $3OMi8.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("56TG7", function(module, exports) {
'use strict';

var $3OMi8 = parcelRequire("3OMi8");

var $37Fr9 = parcelRequire("37Fr9");

var $35KxV = parcelRequire("35KxV");

var $gxaFy = parcelRequire("gxaFy");
var $3b88b3dcc017da11$var$sum32 = $3OMi8.sum32;
var $3b88b3dcc017da11$var$sum32_4 = $3OMi8.sum32_4;
var $3b88b3dcc017da11$var$sum32_5 = $3OMi8.sum32_5;
var $3b88b3dcc017da11$var$ch32 = $35KxV.ch32;
var $3b88b3dcc017da11$var$maj32 = $35KxV.maj32;
var $3b88b3dcc017da11$var$s0_256 = $35KxV.s0_256;
var $3b88b3dcc017da11$var$s1_256 = $35KxV.s1_256;
var $3b88b3dcc017da11$var$g0_256 = $35KxV.g0_256;
var $3b88b3dcc017da11$var$g1_256 = $35KxV.g1_256;
var $3b88b3dcc017da11$var$BlockHash = $37Fr9.BlockHash;
var $3b88b3dcc017da11$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $3b88b3dcc017da11$var$SHA256() {
    if (!(this instanceof $3b88b3dcc017da11$var$SHA256)) return new $3b88b3dcc017da11$var$SHA256();
    $3b88b3dcc017da11$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $3b88b3dcc017da11$var$sha256_K;
    this.W = new Array(64);
}
$3OMi8.inherits($3b88b3dcc017da11$var$SHA256, $3b88b3dcc017da11$var$BlockHash);
module.exports = $3b88b3dcc017da11$var$SHA256;
$3b88b3dcc017da11$var$SHA256.blockSize = 512;
$3b88b3dcc017da11$var$SHA256.outSize = 256;
$3b88b3dcc017da11$var$SHA256.hmacStrength = 192;
$3b88b3dcc017da11$var$SHA256.padLength = 64;
$3b88b3dcc017da11$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $3b88b3dcc017da11$var$sum32_4($3b88b3dcc017da11$var$g1_256(W[i - 2]), W[i - 7], $3b88b3dcc017da11$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $gxaFy(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $3b88b3dcc017da11$var$sum32_5(h, $3b88b3dcc017da11$var$s1_256(e), $3b88b3dcc017da11$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $3b88b3dcc017da11$var$sum32($3b88b3dcc017da11$var$s0_256(a), $3b88b3dcc017da11$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $3b88b3dcc017da11$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $3b88b3dcc017da11$var$sum32(T1, T2);
    }
    this.h[0] = $3b88b3dcc017da11$var$sum32(this.h[0], a);
    this.h[1] = $3b88b3dcc017da11$var$sum32(this.h[1], b);
    this.h[2] = $3b88b3dcc017da11$var$sum32(this.h[2], c);
    this.h[3] = $3b88b3dcc017da11$var$sum32(this.h[3], d);
    this.h[4] = $3b88b3dcc017da11$var$sum32(this.h[4], e);
    this.h[5] = $3b88b3dcc017da11$var$sum32(this.h[5], f);
    this.h[6] = $3b88b3dcc017da11$var$sum32(this.h[6], g);
    this.h[7] = $3b88b3dcc017da11$var$sum32(this.h[7], h);
};
$3b88b3dcc017da11$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
    else return $3OMi8.split32(this.h, 'big');
};

});


parcelRegister("bmcCc", function(module, exports) {
'use strict';

var $3OMi8 = parcelRequire("3OMi8");

var $5EQvK = parcelRequire("5EQvK");
function $844b88dda8a6facd$var$SHA384() {
    if (!(this instanceof $844b88dda8a6facd$var$SHA384)) return new $844b88dda8a6facd$var$SHA384();
    $5EQvK.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$3OMi8.inherits($844b88dda8a6facd$var$SHA384, $5EQvK);
module.exports = $844b88dda8a6facd$var$SHA384;
$844b88dda8a6facd$var$SHA384.blockSize = 1024;
$844b88dda8a6facd$var$SHA384.outSize = 384;
$844b88dda8a6facd$var$SHA384.hmacStrength = 192;
$844b88dda8a6facd$var$SHA384.padLength = 128;
$844b88dda8a6facd$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3OMi8.toHex32(this.h.slice(0, 12), 'big');
    else return $3OMi8.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("5EQvK", function(module, exports) {
'use strict';

var $3OMi8 = parcelRequire("3OMi8");

var $37Fr9 = parcelRequire("37Fr9");

var $gxaFy = parcelRequire("gxaFy");
var $41e96bc7d61a2263$var$rotr64_hi = $3OMi8.rotr64_hi;
var $41e96bc7d61a2263$var$rotr64_lo = $3OMi8.rotr64_lo;
var $41e96bc7d61a2263$var$shr64_hi = $3OMi8.shr64_hi;
var $41e96bc7d61a2263$var$shr64_lo = $3OMi8.shr64_lo;
var $41e96bc7d61a2263$var$sum64 = $3OMi8.sum64;
var $41e96bc7d61a2263$var$sum64_hi = $3OMi8.sum64_hi;
var $41e96bc7d61a2263$var$sum64_lo = $3OMi8.sum64_lo;
var $41e96bc7d61a2263$var$sum64_4_hi = $3OMi8.sum64_4_hi;
var $41e96bc7d61a2263$var$sum64_4_lo = $3OMi8.sum64_4_lo;
var $41e96bc7d61a2263$var$sum64_5_hi = $3OMi8.sum64_5_hi;
var $41e96bc7d61a2263$var$sum64_5_lo = $3OMi8.sum64_5_lo;
var $41e96bc7d61a2263$var$BlockHash = $37Fr9.BlockHash;
var $41e96bc7d61a2263$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $41e96bc7d61a2263$var$SHA512() {
    if (!(this instanceof $41e96bc7d61a2263$var$SHA512)) return new $41e96bc7d61a2263$var$SHA512();
    $41e96bc7d61a2263$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $41e96bc7d61a2263$var$sha512_K;
    this.W = new Array(160);
}
$3OMi8.inherits($41e96bc7d61a2263$var$SHA512, $41e96bc7d61a2263$var$BlockHash);
module.exports = $41e96bc7d61a2263$var$SHA512;
$41e96bc7d61a2263$var$SHA512.blockSize = 1024;
$41e96bc7d61a2263$var$SHA512.outSize = 512;
$41e96bc7d61a2263$var$SHA512.hmacStrength = 192;
$41e96bc7d61a2263$var$SHA512.padLength = 128;
$41e96bc7d61a2263$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $41e96bc7d61a2263$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $41e96bc7d61a2263$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $41e96bc7d61a2263$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $41e96bc7d61a2263$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $41e96bc7d61a2263$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $41e96bc7d61a2263$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$41e96bc7d61a2263$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $gxaFy(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $41e96bc7d61a2263$var$s1_512_hi(eh, el);
        var c1_lo = $41e96bc7d61a2263$var$s1_512_lo(eh, el);
        var c2_hi = $41e96bc7d61a2263$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $41e96bc7d61a2263$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $41e96bc7d61a2263$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $41e96bc7d61a2263$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $41e96bc7d61a2263$var$s0_512_hi(ah, al);
        c0_lo = $41e96bc7d61a2263$var$s0_512_lo(ah, al);
        c1_hi = $41e96bc7d61a2263$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $41e96bc7d61a2263$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $41e96bc7d61a2263$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $41e96bc7d61a2263$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $41e96bc7d61a2263$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $41e96bc7d61a2263$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $41e96bc7d61a2263$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $41e96bc7d61a2263$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $41e96bc7d61a2263$var$sum64(this.h, 0, ah, al);
    $41e96bc7d61a2263$var$sum64(this.h, 2, bh, bl);
    $41e96bc7d61a2263$var$sum64(this.h, 4, ch, cl);
    $41e96bc7d61a2263$var$sum64(this.h, 6, dh, dl);
    $41e96bc7d61a2263$var$sum64(this.h, 8, eh, el);
    $41e96bc7d61a2263$var$sum64(this.h, 10, fh, fl);
    $41e96bc7d61a2263$var$sum64(this.h, 12, gh, gl);
    $41e96bc7d61a2263$var$sum64(this.h, 14, hh, hl);
};
$41e96bc7d61a2263$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
    else return $3OMi8.split32(this.h, 'big');
};
function $41e96bc7d61a2263$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$s0_512_hi(xh, xl) {
    var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$s0_512_lo(xh, xl) {
    var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$s1_512_hi(xh, xl) {
    var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$s1_512_lo(xh, xl) {
    var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$g0_512_hi(xh, xl) {
    var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $41e96bc7d61a2263$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$g0_512_lo(xh, xl) {
    var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $41e96bc7d61a2263$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$g1_512_hi(xh, xl) {
    var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $41e96bc7d61a2263$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $41e96bc7d61a2263$var$g1_512_lo(xh, xl) {
    var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $41e96bc7d61a2263$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("7uO26", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $575225433f68bc9a$export$d1cea0ee4e3f0d3e, (v) => $575225433f68bc9a$export$d1cea0ee4e3f0d3e = v);
var $575225433f68bc9a$export$d1cea0ee4e3f0d3e;
'use strict';

var $3OMi8 = parcelRequire("3OMi8");

var $37Fr9 = parcelRequire("37Fr9");
var $575225433f68bc9a$var$rotl32 = $3OMi8.rotl32;
var $575225433f68bc9a$var$sum32 = $3OMi8.sum32;
var $575225433f68bc9a$var$sum32_3 = $3OMi8.sum32_3;
var $575225433f68bc9a$var$sum32_4 = $3OMi8.sum32_4;
var $575225433f68bc9a$var$BlockHash = $37Fr9.BlockHash;
function $575225433f68bc9a$var$RIPEMD160() {
    if (!(this instanceof $575225433f68bc9a$var$RIPEMD160)) return new $575225433f68bc9a$var$RIPEMD160();
    $575225433f68bc9a$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$3OMi8.inherits($575225433f68bc9a$var$RIPEMD160, $575225433f68bc9a$var$BlockHash);
$575225433f68bc9a$export$d1cea0ee4e3f0d3e = $575225433f68bc9a$var$RIPEMD160;
$575225433f68bc9a$var$RIPEMD160.blockSize = 512;
$575225433f68bc9a$var$RIPEMD160.outSize = 160;
$575225433f68bc9a$var$RIPEMD160.hmacStrength = 192;
$575225433f68bc9a$var$RIPEMD160.padLength = 64;
$575225433f68bc9a$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $575225433f68bc9a$var$sum32($575225433f68bc9a$var$rotl32($575225433f68bc9a$var$sum32_4(A, $575225433f68bc9a$var$f(j, B, C, D), msg[$575225433f68bc9a$var$r[j] + start], $575225433f68bc9a$var$K(j)), $575225433f68bc9a$var$s[j]), E);
        A = E;
        E = D;
        D = $575225433f68bc9a$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $575225433f68bc9a$var$sum32($575225433f68bc9a$var$rotl32($575225433f68bc9a$var$sum32_4(Ah, $575225433f68bc9a$var$f(79 - j, Bh, Ch, Dh), msg[$575225433f68bc9a$var$rh[j] + start], $575225433f68bc9a$var$Kh(j)), $575225433f68bc9a$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $575225433f68bc9a$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $575225433f68bc9a$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $575225433f68bc9a$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $575225433f68bc9a$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $575225433f68bc9a$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $575225433f68bc9a$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$575225433f68bc9a$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3OMi8.toHex32(this.h, 'little');
    else return $3OMi8.split32(this.h, 'little');
};
function $575225433f68bc9a$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $575225433f68bc9a$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $575225433f68bc9a$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $575225433f68bc9a$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $575225433f68bc9a$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $575225433f68bc9a$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $575225433f68bc9a$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("aFtrN", function(module, exports) {
'use strict';

var $3OMi8 = parcelRequire("3OMi8");

var $gxaFy = parcelRequire("gxaFy");
function $7c44935cedad0a05$var$Hmac(hash, key, enc) {
    if (!(this instanceof $7c44935cedad0a05$var$Hmac)) return new $7c44935cedad0a05$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($3OMi8.toArray(key, enc));
}
module.exports = $7c44935cedad0a05$var$Hmac;
$7c44935cedad0a05$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $gxaFy(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$7c44935cedad0a05$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$7c44935cedad0a05$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("6pt7M", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("9Cxq1", function(module, exports) {
'use strict';

var $9pbIC = parcelRequire("9pbIC");

var $kj2Mi = parcelRequire("kj2Mi");

var $onO0l = parcelRequire("onO0l");

var $gli5y = parcelRequire("gli5y");

var $9D8YT = parcelRequire("9D8YT");
var $701195e88ddcfeac$var$assert = $onO0l.assert;

var $1h5tm = parcelRequire("1h5tm");

var $hKBzv = parcelRequire("hKBzv");
function $701195e88ddcfeac$var$EC(options) {
    if (!(this instanceof $701195e88ddcfeac$var$EC)) return new $701195e88ddcfeac$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $701195e88ddcfeac$var$assert(Object.prototype.hasOwnProperty.call($gli5y, options), 'Unknown curve ' + options);
        options = $gli5y[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $gli5y.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $701195e88ddcfeac$var$EC;
$701195e88ddcfeac$var$EC.prototype.keyPair = function keyPair(options) {
    return new $1h5tm(this, options);
};
$701195e88ddcfeac$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $1h5tm.fromPrivate(this, priv, enc);
};
$701195e88ddcfeac$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $1h5tm.fromPublic(this, pub, enc);
};
$701195e88ddcfeac$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kj2Mi({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $9D8YT(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $9pbIC(2));
    for(;;){
        var priv = new $9pbIC(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$701195e88ddcfeac$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($9pbIC.isBN(msg) || typeof msg === 'number') {
        msg = new $9pbIC(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $9pbIC(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $9pbIC(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$701195e88ddcfeac$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$9pbIC.isBN(msg)) {
        $701195e88ddcfeac$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $701195e88ddcfeac$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$701195e88ddcfeac$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $701195e88ddcfeac$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $701195e88ddcfeac$var$assert(new $9pbIC(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $kj2Mi({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $9pbIC(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $9pbIC(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $hKBzv({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$701195e88ddcfeac$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $hKBzv(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$701195e88ddcfeac$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $701195e88ddcfeac$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $hKBzv(signature, enc);
    var n = this.n;
    var e = new $9pbIC(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$701195e88ddcfeac$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $hKBzv(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("kj2Mi", function(module, exports) {
'use strict';

var $hx0iN = parcelRequire("hx0iN");

var $2WqN6 = parcelRequire("2WqN6");

var $gxaFy = parcelRequire("gxaFy");
function $ec87bca0fe3c0ec7$var$HmacDRBG(options) {
    if (!(this instanceof $ec87bca0fe3c0ec7$var$HmacDRBG)) return new $ec87bca0fe3c0ec7$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $2WqN6.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $2WqN6.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $2WqN6.toArray(options.pers, options.persEnc || 'hex');
    $gxaFy(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $ec87bca0fe3c0ec7$var$HmacDRBG;
$ec87bca0fe3c0ec7$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$ec87bca0fe3c0ec7$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $hx0iN.hmac(this.hash, this.K);
};
$ec87bca0fe3c0ec7$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$ec87bca0fe3c0ec7$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $2WqN6.toArray(entropy, entropyEnc);
    add = $2WqN6.toArray(add, addEnc);
    $gxaFy(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$ec87bca0fe3c0ec7$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $2WqN6.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $2WqN6.encode(res, enc);
};

});

parcelRegister("1h5tm", function(module, exports) {
'use strict';

var $9pbIC = parcelRequire("9pbIC");

var $onO0l = parcelRequire("onO0l");
var $0edb9fb4895d148b$var$assert = $onO0l.assert;
function $0edb9fb4895d148b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $0edb9fb4895d148b$var$KeyPair;
$0edb9fb4895d148b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $0edb9fb4895d148b$var$KeyPair) return pub;
    return new $0edb9fb4895d148b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$0edb9fb4895d148b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $0edb9fb4895d148b$var$KeyPair) return priv;
    return new $0edb9fb4895d148b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$0edb9fb4895d148b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$0edb9fb4895d148b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$0edb9fb4895d148b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$0edb9fb4895d148b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $9pbIC(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$0edb9fb4895d148b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $0edb9fb4895d148b$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $0edb9fb4895d148b$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$0edb9fb4895d148b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $0edb9fb4895d148b$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$0edb9fb4895d148b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$0edb9fb4895d148b$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$0edb9fb4895d148b$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("hKBzv", function(module, exports) {
'use strict';

var $9pbIC = parcelRequire("9pbIC");

var $onO0l = parcelRequire("onO0l");
var $cec3e07d0e69d400$var$assert = $onO0l.assert;
function $cec3e07d0e69d400$var$Signature(options, enc) {
    if (options instanceof $cec3e07d0e69d400$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $cec3e07d0e69d400$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $9pbIC(options.r, 16);
    this.s = new $9pbIC(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $cec3e07d0e69d400$var$Signature;
function $cec3e07d0e69d400$var$Position() {
    this.place = 0;
}
function $cec3e07d0e69d400$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $cec3e07d0e69d400$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$cec3e07d0e69d400$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $onO0l.toArray(data, enc);
    var p = new $cec3e07d0e69d400$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $cec3e07d0e69d400$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $cec3e07d0e69d400$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $cec3e07d0e69d400$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $9pbIC(r);
    this.s = new $9pbIC(s);
    this.recoveryParam = null;
    return true;
};
function $cec3e07d0e69d400$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$cec3e07d0e69d400$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $cec3e07d0e69d400$var$rmPadding(r);
    s = $cec3e07d0e69d400$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $cec3e07d0e69d400$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $cec3e07d0e69d400$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $cec3e07d0e69d400$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $onO0l.encode(res, enc);
};

});


parcelRegister("5xIaV", function(module, exports) {
'use strict';

var $hx0iN = parcelRequire("hx0iN");

var $gli5y = parcelRequire("gli5y");

var $onO0l = parcelRequire("onO0l");
var $40924d19a5087ed3$var$assert = $onO0l.assert;
var $40924d19a5087ed3$var$parseBytes = $onO0l.parseBytes;

var $jMnN9 = parcelRequire("jMnN9");

var $4AHiD = parcelRequire("4AHiD");
function $40924d19a5087ed3$var$EDDSA(curve) {
    $40924d19a5087ed3$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $40924d19a5087ed3$var$EDDSA)) return new $40924d19a5087ed3$var$EDDSA(curve);
    curve = $gli5y[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $hx0iN.sha512;
}
module.exports = $40924d19a5087ed3$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $40924d19a5087ed3$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $40924d19a5087ed3$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $40924d19a5087ed3$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $40924d19a5087ed3$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$40924d19a5087ed3$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $onO0l.intFromLE(hash.digest()).umod(this.curve.n);
};
$40924d19a5087ed3$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $jMnN9.fromPublic(this, pub);
};
$40924d19a5087ed3$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $jMnN9.fromSecret(this, secret);
};
$40924d19a5087ed3$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $4AHiD) return sig;
    return new $4AHiD(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $40924d19a5087ed3$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$40924d19a5087ed3$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $onO0l.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $onO0l.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$40924d19a5087ed3$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$40924d19a5087ed3$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $onO0l.intFromLE(bytes);
};
$40924d19a5087ed3$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("jMnN9", function(module, exports) {
'use strict';

var $onO0l = parcelRequire("onO0l");
var $e664f48c9a4229a6$var$assert = $onO0l.assert;
var $e664f48c9a4229a6$var$parseBytes = $onO0l.parseBytes;
var $e664f48c9a4229a6$var$cachedProperty = $onO0l.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $e664f48c9a4229a6$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $e664f48c9a4229a6$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $e664f48c9a4229a6$var$parseBytes(params.pub);
}
$e664f48c9a4229a6$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $e664f48c9a4229a6$var$KeyPair) return pub;
    return new $e664f48c9a4229a6$var$KeyPair(eddsa, {
        pub: pub
    });
};
$e664f48c9a4229a6$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $e664f48c9a4229a6$var$KeyPair) return secret;
    return new $e664f48c9a4229a6$var$KeyPair(eddsa, {
        secret: secret
    });
};
$e664f48c9a4229a6$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$e664f48c9a4229a6$var$KeyPair.prototype.sign = function sign(message) {
    $e664f48c9a4229a6$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$e664f48c9a4229a6$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$e664f48c9a4229a6$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $e664f48c9a4229a6$var$assert(this._secret, 'KeyPair is public only');
    return $onO0l.encode(this.secret(), enc);
};
$e664f48c9a4229a6$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $onO0l.encode(this.pubBytes(), enc);
};
module.exports = $e664f48c9a4229a6$var$KeyPair;

});

parcelRegister("4AHiD", function(module, exports) {
'use strict';

var $9pbIC = parcelRequire("9pbIC");

var $onO0l = parcelRequire("onO0l");
var $357c1ca1a96c331d$var$assert = $onO0l.assert;
var $357c1ca1a96c331d$var$cachedProperty = $onO0l.cachedProperty;
var $357c1ca1a96c331d$var$parseBytes = $onO0l.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $357c1ca1a96c331d$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $357c1ca1a96c331d$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $357c1ca1a96c331d$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $357c1ca1a96c331d$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $9pbIC) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$357c1ca1a96c331d$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$357c1ca1a96c331d$var$Signature.prototype.toHex = function toHex() {
    return $onO0l.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $357c1ca1a96c331d$var$Signature;

});



parcelRegister("ejFGc", function(module, exports) {
'use strict';

var $6SLbO = parcelRequire("6SLbO");

var $h9FlO = parcelRequire("h9FlO");

var $gIBLw = parcelRequire("gIBLw");

var $gcaJj = parcelRequire("gcaJj");

var $fS6zE = parcelRequire("fS6zE");

var $Wth4q = parcelRequire("Wth4q");
var $a6c32bc236201271$require$Buffer = $Wth4q.Buffer;
function $a6c32bc236201271$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $h9FlO[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $fS6zE.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $gcaJj.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $a6c32bc236201271$require$Buffer.concat(out);
}
function $a6c32bc236201271$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$a6c32bc236201271$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $a6c32bc236201271$require$Buffer.from(buffer);
    var stripped = $gIBLw(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $6SLbO.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $6SLbO.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $6SLbO.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $6SLbO.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $6SLbO.EncryptedPrivateKey.decode(data, 'der');
            data = $a6c32bc236201271$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $6SLbO.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $6SLbO.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $6SLbO.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $6SLbO.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $6SLbO.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $6SLbO.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $6SLbO.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $6SLbO.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$a6c32bc236201271$var$parseKeys.signature = $6SLbO.signature;
module.exports = $a6c32bc236201271$var$parseKeys;

});
parcelRegister("6SLbO", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $502c641ac9e0adc8$export$c98397a6eb8d0678, (v) => $502c641ac9e0adc8$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $502c641ac9e0adc8$export$f4aab6816f64fa6b, (v) => $502c641ac9e0adc8$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $502c641ac9e0adc8$export$4471f5c65d097c11, (v) => $502c641ac9e0adc8$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $502c641ac9e0adc8$export$ca8b6604d6ce14de, (v) => $502c641ac9e0adc8$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $502c641ac9e0adc8$export$8f54525b330fd87b, (v) => $502c641ac9e0adc8$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $502c641ac9e0adc8$export$23cd2842b44ca3e7, (v) => $502c641ac9e0adc8$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $502c641ac9e0adc8$export$245c9aaa9f5ce4ce, (v) => $502c641ac9e0adc8$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $502c641ac9e0adc8$export$8ad762e3e6399afe, (v) => $502c641ac9e0adc8$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $502c641ac9e0adc8$export$32ef6f92e22c6ab0, (v) => $502c641ac9e0adc8$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $502c641ac9e0adc8$export$c9cd164b539ebb63, (v) => $502c641ac9e0adc8$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $502c641ac9e0adc8$export$c98397a6eb8d0678;
var $502c641ac9e0adc8$export$f4aab6816f64fa6b;
var $502c641ac9e0adc8$export$4471f5c65d097c11;
var $502c641ac9e0adc8$export$ca8b6604d6ce14de;
var $502c641ac9e0adc8$export$8f54525b330fd87b;
var $502c641ac9e0adc8$export$23cd2842b44ca3e7;
var $502c641ac9e0adc8$export$245c9aaa9f5ce4ce;
var $502c641ac9e0adc8$export$8ad762e3e6399afe;
var $502c641ac9e0adc8$export$32ef6f92e22c6ab0;
var $502c641ac9e0adc8$export$c9cd164b539ebb63;
'use strict';

var $4YrAW = parcelRequire("4YrAW");

$502c641ac9e0adc8$export$c98397a6eb8d0678 = (parcelRequire("eqV2A"));
var $502c641ac9e0adc8$var$RSAPrivateKey = $4YrAW.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$502c641ac9e0adc8$export$f4aab6816f64fa6b = $502c641ac9e0adc8$var$RSAPrivateKey;
var $502c641ac9e0adc8$var$RSAPublicKey = $4YrAW.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$502c641ac9e0adc8$export$4471f5c65d097c11 = $502c641ac9e0adc8$var$RSAPublicKey;
var $502c641ac9e0adc8$var$AlgorithmIdentifier = $4YrAW.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $502c641ac9e0adc8$var$PublicKey = $4YrAW.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($502c641ac9e0adc8$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$502c641ac9e0adc8$export$ca8b6604d6ce14de = $502c641ac9e0adc8$var$PublicKey;
var $502c641ac9e0adc8$var$PrivateKeyInfo = $4YrAW.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($502c641ac9e0adc8$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$502c641ac9e0adc8$export$8f54525b330fd87b = $502c641ac9e0adc8$var$PrivateKeyInfo;
var $502c641ac9e0adc8$var$EncryptedPrivateKeyInfo = $4YrAW.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$502c641ac9e0adc8$export$23cd2842b44ca3e7 = $502c641ac9e0adc8$var$EncryptedPrivateKeyInfo;
var $502c641ac9e0adc8$var$DSAPrivateKey = $4YrAW.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$502c641ac9e0adc8$export$245c9aaa9f5ce4ce = $502c641ac9e0adc8$var$DSAPrivateKey;
$502c641ac9e0adc8$export$8ad762e3e6399afe = $4YrAW.define('DSAparam', function() {
    this['int']();
});
var $502c641ac9e0adc8$var$ECParameters = $4YrAW.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $502c641ac9e0adc8$var$ECPrivateKey = $4YrAW.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($502c641ac9e0adc8$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$502c641ac9e0adc8$export$32ef6f92e22c6ab0 = $502c641ac9e0adc8$var$ECPrivateKey;
$502c641ac9e0adc8$export$c9cd164b539ebb63 = $4YrAW.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("4YrAW", function(module, exports) {
var $39f22bc6452e58d0$var$asn1 = module.exports;

$39f22bc6452e58d0$var$asn1.bignum = (parcelRequire("9pbIC"));

$39f22bc6452e58d0$var$asn1.define = (parcelRequire("ceLSt")).define;

$39f22bc6452e58d0$var$asn1.base = (parcelRequire("7pROP"));

$39f22bc6452e58d0$var$asn1.constants = (parcelRequire("9Gn7M"));

$39f22bc6452e58d0$var$asn1.decoders = (parcelRequire("jgiMU"));

$39f22bc6452e58d0$var$asn1.encoders = (parcelRequire("4mVZW"));

});
parcelRegister("ceLSt", function(module, exports) {

var $4YrAW = parcelRequire("4YrAW");

var $v3bBu = parcelRequire("v3bBu");
var $8e8bee50c1965a65$var$api = module.exports;
$8e8bee50c1965a65$var$api.define = function define(name, body) {
    return new $8e8bee50c1965a65$var$Entity(name, body);
};
function $8e8bee50c1965a65$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$8e8bee50c1965a65$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("203s9")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $v3bBu(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$8e8bee50c1965a65$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($4YrAW.decoders[enc]);
    return this.decoders[enc];
};
$8e8bee50c1965a65$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$8e8bee50c1965a65$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($4YrAW.encoders[enc]);
    return this.encoders[enc];
};
$8e8bee50c1965a65$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("203s9", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("7pROP", function(module, exports) {
var $56649d7a438b1476$var$base = module.exports;

$56649d7a438b1476$var$base.Reporter = (parcelRequire("9Mcka")).Reporter;

$56649d7a438b1476$var$base.DecoderBuffer = (parcelRequire("8BbkO")).DecoderBuffer;

$56649d7a438b1476$var$base.EncoderBuffer = (parcelRequire("8BbkO")).EncoderBuffer;

$56649d7a438b1476$var$base.Node = (parcelRequire("8pyk3"));

});
parcelRegister("9Mcka", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $71e22815ba47f766$export$957313a2f485e5ed, (v) => $71e22815ba47f766$export$957313a2f485e5ed = v);
var $71e22815ba47f766$export$957313a2f485e5ed;

var $v3bBu = parcelRequire("v3bBu");
function $71e22815ba47f766$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$71e22815ba47f766$export$957313a2f485e5ed = $71e22815ba47f766$var$Reporter;
$71e22815ba47f766$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $71e22815ba47f766$var$ReporterError;
};
$71e22815ba47f766$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$71e22815ba47f766$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$71e22815ba47f766$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$71e22815ba47f766$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$71e22815ba47f766$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$71e22815ba47f766$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$71e22815ba47f766$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$71e22815ba47f766$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$71e22815ba47f766$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $71e22815ba47f766$var$ReporterError;
    if (inherited) err = msg;
    else err = new $71e22815ba47f766$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$71e22815ba47f766$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $71e22815ba47f766$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$v3bBu($71e22815ba47f766$var$ReporterError, Error);
$71e22815ba47f766$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $71e22815ba47f766$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("8BbkO", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $642a923f98967a64$export$bf9f79cdc4a49163, (v) => $642a923f98967a64$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $642a923f98967a64$export$8ff24f7760c7a78e, (v) => $642a923f98967a64$export$8ff24f7760c7a78e = v);
var $642a923f98967a64$export$bf9f79cdc4a49163;
var $642a923f98967a64$export$8ff24f7760c7a78e;

var $v3bBu = parcelRequire("v3bBu");

var $7pROP = parcelRequire("7pROP");
var $642a923f98967a64$require$Reporter = $7pROP.Reporter;

var $5k7LC = parcelRequire("5k7LC");
var $642a923f98967a64$require$Buffer = $5k7LC.Buffer;
function $642a923f98967a64$var$DecoderBuffer(base, options) {
    $642a923f98967a64$require$Reporter.call(this, options);
    if (!$642a923f98967a64$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$v3bBu($642a923f98967a64$var$DecoderBuffer, $642a923f98967a64$require$Reporter);
$642a923f98967a64$export$bf9f79cdc4a49163 = $642a923f98967a64$var$DecoderBuffer;
$642a923f98967a64$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $642a923f98967a64$require$Reporter.prototype.save.call(this)
    };
};
$642a923f98967a64$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $642a923f98967a64$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $642a923f98967a64$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$642a923f98967a64$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$642a923f98967a64$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$642a923f98967a64$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $642a923f98967a64$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$642a923f98967a64$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $642a923f98967a64$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $642a923f98967a64$var$EncoderBuffer)) item = new $642a923f98967a64$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $642a923f98967a64$require$Buffer.byteLength(value);
    } else if ($642a923f98967a64$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$642a923f98967a64$export$8ff24f7760c7a78e = $642a923f98967a64$var$EncoderBuffer;
$642a923f98967a64$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $642a923f98967a64$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($642a923f98967a64$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("8pyk3", function(module, exports) {

var $7pROP = parcelRequire("7pROP");
var $61fb48423d223fb4$require$Reporter = $7pROP.Reporter;

var $7pROP = parcelRequire("7pROP");
var $61fb48423d223fb4$require$EncoderBuffer = $7pROP.EncoderBuffer;

var $7pROP = parcelRequire("7pROP");
var $61fb48423d223fb4$require$DecoderBuffer = $7pROP.DecoderBuffer;

var $gxaFy = parcelRequire("gxaFy");
// Supported tags
var $61fb48423d223fb4$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $61fb48423d223fb4$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($61fb48423d223fb4$var$tags);
// Overrided methods list
var $61fb48423d223fb4$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $61fb48423d223fb4$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $61fb48423d223fb4$var$Node;
var $61fb48423d223fb4$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$61fb48423d223fb4$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $61fb48423d223fb4$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$61fb48423d223fb4$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $61fb48423d223fb4$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$61fb48423d223fb4$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $gxaFy(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $gxaFy.equal(state.children.length, 1, 'Root node can have only one child');
};
$61fb48423d223fb4$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $gxaFy(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $gxaFy(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$61fb48423d223fb4$var$overrided.forEach(function(method) {
    $61fb48423d223fb4$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$61fb48423d223fb4$var$tags.forEach(function(tag) {
    $61fb48423d223fb4$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $gxaFy(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$61fb48423d223fb4$var$Node.prototype.use = function use(item) {
    $gxaFy(item);
    var state = this._baseState;
    $gxaFy(state.use === null);
    state.use = item;
    return this;
};
$61fb48423d223fb4$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$61fb48423d223fb4$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $gxaFy(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$61fb48423d223fb4$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $gxaFy(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$61fb48423d223fb4$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $gxaFy(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$61fb48423d223fb4$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$61fb48423d223fb4$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $gxaFy(state.key === null);
    state.key = newKey;
    return this;
};
$61fb48423d223fb4$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$61fb48423d223fb4$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $gxaFy(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$61fb48423d223fb4$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $gxaFy(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$61fb48423d223fb4$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $61fb48423d223fb4$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$61fb48423d223fb4$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$61fb48423d223fb4$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $gxaFy(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$61fb48423d223fb4$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$61fb48423d223fb4$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $61fb48423d223fb4$require$EncoderBuffer(data, this.reporter);
};
$61fb48423d223fb4$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$61fb48423d223fb4$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $61fb48423d223fb4$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$61fb48423d223fb4$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $gxaFy(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$61fb48423d223fb4$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$61fb48423d223fb4$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$61fb48423d223fb4$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("9Gn7M", function(module, exports) {
var $70c9f95905a88f58$var$constants = module.exports;
// Helper
$70c9f95905a88f58$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$70c9f95905a88f58$var$constants.der = (parcelRequire("lpBh5"));

});
parcelRegister("lpBh5", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $f968d8c070be10cd$export$3584c46ed60baee8, (v) => $f968d8c070be10cd$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $f968d8c070be10cd$export$f18596ef8d632e49, (v) => $f968d8c070be10cd$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $f968d8c070be10cd$export$2b067c6666111485, (v) => $f968d8c070be10cd$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $f968d8c070be10cd$export$f17df38a421ab9e3, (v) => $f968d8c070be10cd$export$f17df38a421ab9e3 = v);
var $f968d8c070be10cd$export$3584c46ed60baee8;
var $f968d8c070be10cd$export$f18596ef8d632e49;
var $f968d8c070be10cd$export$2b067c6666111485;
var $f968d8c070be10cd$export$f17df38a421ab9e3;

var $9Gn7M = parcelRequire("9Gn7M");
$f968d8c070be10cd$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$f968d8c070be10cd$export$f18596ef8d632e49 = $9Gn7M._reverse($f968d8c070be10cd$export$3584c46ed60baee8);
$f968d8c070be10cd$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$f968d8c070be10cd$export$f17df38a421ab9e3 = $9Gn7M._reverse($f968d8c070be10cd$export$2b067c6666111485);

});


parcelRegister("jgiMU", function(module, exports) {
var $e05e15d54de3c556$var$decoders = module.exports;

$e05e15d54de3c556$var$decoders.der = (parcelRequire("hhhbu"));

$e05e15d54de3c556$var$decoders.pem = (parcelRequire("bSW3A"));

});
parcelRegister("hhhbu", function(module, exports) {

var $v3bBu = parcelRequire("v3bBu");

var $4YrAW = parcelRequire("4YrAW");
var $c9415aa2b27c8979$var$base = $4YrAW.base;
var $c9415aa2b27c8979$var$bignum = $4YrAW.bignum;
// Import DER constants
var $c9415aa2b27c8979$var$der = $4YrAW.constants.der;
function $c9415aa2b27c8979$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $c9415aa2b27c8979$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $c9415aa2b27c8979$var$DERDecoder;
$c9415aa2b27c8979$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $c9415aa2b27c8979$var$base.DecoderBuffer)) data = new $c9415aa2b27c8979$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $c9415aa2b27c8979$var$DERNode(parent) {
    $c9415aa2b27c8979$var$base.Node.call(this, 'der', parent);
}
$v3bBu($c9415aa2b27c8979$var$DERNode, $c9415aa2b27c8979$var$base.Node);
$c9415aa2b27c8979$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $c9415aa2b27c8979$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$c9415aa2b27c8979$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $c9415aa2b27c8979$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $c9415aa2b27c8979$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$c9415aa2b27c8979$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $c9415aa2b27c8979$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $c9415aa2b27c8979$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$c9415aa2b27c8979$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$c9415aa2b27c8979$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$c9415aa2b27c8979$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$c9415aa2b27c8979$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$c9415aa2b27c8979$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$c9415aa2b27c8979$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$c9415aa2b27c8979$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $c9415aa2b27c8979$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$c9415aa2b27c8979$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $c9415aa2b27c8979$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $c9415aa2b27c8979$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $c9415aa2b27c8979$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $c9415aa2b27c8979$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("bSW3A", function(module, exports) {

var $v3bBu = parcelRequire("v3bBu");

var $5k7LC = parcelRequire("5k7LC");
var $8a71c5b853c3ea19$require$Buffer = $5k7LC.Buffer;

var $hhhbu = parcelRequire("hhhbu");
function $8a71c5b853c3ea19$var$PEMDecoder(entity) {
    $hhhbu.call(this, entity);
    this.enc = 'pem';
}
$v3bBu($8a71c5b853c3ea19$var$PEMDecoder, $hhhbu);
module.exports = $8a71c5b853c3ea19$var$PEMDecoder;
$8a71c5b853c3ea19$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $8a71c5b853c3ea19$require$Buffer(base64, 'base64');
    return $hhhbu.prototype.decode.call(this, input, options);
};

});


parcelRegister("4mVZW", function(module, exports) {
var $32e634ba5c9f5903$var$encoders = module.exports;

$32e634ba5c9f5903$var$encoders.der = (parcelRequire("7TTIj"));

$32e634ba5c9f5903$var$encoders.pem = (parcelRequire("6IIig"));

});
parcelRegister("7TTIj", function(module, exports) {

var $v3bBu = parcelRequire("v3bBu");

var $5k7LC = parcelRequire("5k7LC");
var $5c08e30abebc6b49$require$Buffer = $5k7LC.Buffer;

var $4YrAW = parcelRequire("4YrAW");
var $5c08e30abebc6b49$var$base = $4YrAW.base;
// Import DER constants
var $5c08e30abebc6b49$var$der = $4YrAW.constants.der;
function $5c08e30abebc6b49$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $5c08e30abebc6b49$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $5c08e30abebc6b49$var$DEREncoder;
$5c08e30abebc6b49$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $5c08e30abebc6b49$var$DERNode(parent) {
    $5c08e30abebc6b49$var$base.Node.call(this, 'der', parent);
}
$v3bBu($5c08e30abebc6b49$var$DERNode, $5c08e30abebc6b49$var$base.Node);
$5c08e30abebc6b49$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $5c08e30abebc6b49$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $5c08e30abebc6b49$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $5c08e30abebc6b49$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$5c08e30abebc6b49$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $5c08e30abebc6b49$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$5c08e30abebc6b49$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $5c08e30abebc6b49$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $5c08e30abebc6b49$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$5c08e30abebc6b49$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $5c08e30abebc6b49$var$two(date.getFullYear()),
        $5c08e30abebc6b49$var$two(date.getUTCMonth() + 1),
        $5c08e30abebc6b49$var$two(date.getUTCDate()),
        $5c08e30abebc6b49$var$two(date.getUTCHours()),
        $5c08e30abebc6b49$var$two(date.getUTCMinutes()),
        $5c08e30abebc6b49$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $5c08e30abebc6b49$var$two(date.getFullYear() % 100),
        $5c08e30abebc6b49$var$two(date.getUTCMonth() + 1),
        $5c08e30abebc6b49$var$two(date.getUTCDate()),
        $5c08e30abebc6b49$var$two(date.getUTCHours()),
        $5c08e30abebc6b49$var$two(date.getUTCMinutes()),
        $5c08e30abebc6b49$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$5c08e30abebc6b49$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$5c08e30abebc6b49$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$5c08e30abebc6b49$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $5c08e30abebc6b49$require$Buffer(numArray);
    }
    if ($5c08e30abebc6b49$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $5c08e30abebc6b49$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $5c08e30abebc6b49$require$Buffer(out));
};
$5c08e30abebc6b49$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$5c08e30abebc6b49$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$5c08e30abebc6b49$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $5c08e30abebc6b49$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($5c08e30abebc6b49$var$der.tagByName.hasOwnProperty(tag)) res = $5c08e30abebc6b49$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $5c08e30abebc6b49$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("6IIig", function(module, exports) {

var $v3bBu = parcelRequire("v3bBu");

var $7TTIj = parcelRequire("7TTIj");
function $4e4935f09ee49d47$var$PEMEncoder(entity) {
    $7TTIj.call(this, entity);
    this.enc = 'pem';
}
$v3bBu($4e4935f09ee49d47$var$PEMEncoder, $7TTIj);
module.exports = $4e4935f09ee49d47$var$PEMEncoder;
$4e4935f09ee49d47$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $7TTIj.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("eqV2A", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $4YrAW = parcelRequire("4YrAW");
var $a81fbd81d3c72dea$var$Time = $4YrAW.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $a81fbd81d3c72dea$var$AttributeTypeValue = $4YrAW.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $a81fbd81d3c72dea$var$AlgorithmIdentifier = $4YrAW.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $a81fbd81d3c72dea$var$SubjectPublicKeyInfo = $4YrAW.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $a81fbd81d3c72dea$var$RelativeDistinguishedName = $4YrAW.define('RelativeDistinguishedName', function() {
    this.setof($a81fbd81d3c72dea$var$AttributeTypeValue);
});
var $a81fbd81d3c72dea$var$RDNSequence = $4YrAW.define('RDNSequence', function() {
    this.seqof($a81fbd81d3c72dea$var$RelativeDistinguishedName);
});
var $a81fbd81d3c72dea$var$Name = $4YrAW.define('Name', function() {
    this.choice({
        rdnSequence: this.use($a81fbd81d3c72dea$var$RDNSequence)
    });
});
var $a81fbd81d3c72dea$var$Validity = $4YrAW.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($a81fbd81d3c72dea$var$Time), this.key('notAfter').use($a81fbd81d3c72dea$var$Time));
});
var $a81fbd81d3c72dea$var$Extension = $4YrAW.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $a81fbd81d3c72dea$var$TBSCertificate = $4YrAW.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('issuer').use($a81fbd81d3c72dea$var$Name), this.key('validity').use($a81fbd81d3c72dea$var$Validity), this.key('subject').use($a81fbd81d3c72dea$var$Name), this.key('subjectPublicKeyInfo').use($a81fbd81d3c72dea$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($a81fbd81d3c72dea$var$Extension).optional());
});
var $a81fbd81d3c72dea$var$X509Certificate = $4YrAW.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($a81fbd81d3c72dea$var$TBSCertificate), this.key('signatureAlgorithm').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $a81fbd81d3c72dea$var$X509Certificate;

});


parcelRegister("h9FlO", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("gIBLw", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $c2be0cd28f0ce65b$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $c2be0cd28f0ce65b$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $c2be0cd28f0ce65b$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $55KiC = parcelRequire("55KiC");

var $gcaJj = parcelRequire("gcaJj");

var $Wth4q = parcelRequire("Wth4q");
var $c2be0cd28f0ce65b$require$Buffer = $Wth4q.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($c2be0cd28f0ce65b$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($c2be0cd28f0ce65b$var$fullRegex);
        decrypted = $c2be0cd28f0ce65b$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $c2be0cd28f0ce65b$require$Buffer.from(match[2], 'hex');
        var cipherText = $c2be0cd28f0ce65b$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $55KiC(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $gcaJj.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $c2be0cd28f0ce65b$require$Buffer.concat(out);
    }
    var tag = key.match($c2be0cd28f0ce65b$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("jf5f0", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("1LYL6", function(module, exports) {
'use strict';

var $Wth4q = parcelRequire("Wth4q");
var $14a94faaa2710991$require$Buffer = $Wth4q.Buffer;

var $bSSUf = parcelRequire("bSSUf");

var $8JoQd = parcelRequire("8JoQd");
var $14a94faaa2710991$require$EC = $8JoQd.ec;

var $ejFGc = parcelRequire("ejFGc");

var $jf5f0 = parcelRequire("jf5f0");
function $14a94faaa2710991$var$verify(sig, hash, key, signType, tag) {
    var pub = $ejFGc(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $14a94faaa2710991$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $14a94faaa2710991$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $14a94faaa2710991$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $14a94faaa2710991$require$Buffer.from(pad);
    var red = $bSSUf.mont(pub.modulus);
    sig = new $bSSUf(sig).toRed(red);
    sig = sig.redPow(new $bSSUf(pub.publicExponent));
    sig = $14a94faaa2710991$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $14a94faaa2710991$var$ecVerify(sig, hash, pub) {
    var curveId = $jf5f0[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $14a94faaa2710991$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $14a94faaa2710991$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $ejFGc.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $14a94faaa2710991$var$checkValue(s, q);
    $14a94faaa2710991$var$checkValue(r, q);
    var montp = $bSSUf.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $bSSUf(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $14a94faaa2710991$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $14a94faaa2710991$var$verify;

});


parcelRegister("bsZLy", function(module, exports) {

var $5k7LC = parcelRequire("5k7LC");
var $859238ac8a186043$require$Buffer = $5k7LC.Buffer;

var $8JoQd = parcelRequire("8JoQd");

var $9pbIC = parcelRequire("9pbIC");
module.exports = function createECDH(curve) {
    return new $859238ac8a186043$var$ECDH(curve);
};
var $859238ac8a186043$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$859238ac8a186043$var$aliases.p224 = $859238ac8a186043$var$aliases.secp224r1;
$859238ac8a186043$var$aliases.p256 = $859238ac8a186043$var$aliases.secp256r1 = $859238ac8a186043$var$aliases.prime256v1;
$859238ac8a186043$var$aliases.p192 = $859238ac8a186043$var$aliases.secp192r1 = $859238ac8a186043$var$aliases.prime192v1;
$859238ac8a186043$var$aliases.p384 = $859238ac8a186043$var$aliases.secp384r1;
$859238ac8a186043$var$aliases.p521 = $859238ac8a186043$var$aliases.secp521r1;
function $859238ac8a186043$var$ECDH(curve) {
    this.curveType = $859238ac8a186043$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $8JoQd.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$859238ac8a186043$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$859238ac8a186043$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$859238ac8a186043$require$Buffer.isBuffer(other)) other = new $859238ac8a186043$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $859238ac8a186043$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$859238ac8a186043$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $859238ac8a186043$var$formatReturnValue(key, enc);
};
$859238ac8a186043$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $859238ac8a186043$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$859238ac8a186043$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$859238ac8a186043$require$Buffer.isBuffer(pub)) pub = new $859238ac8a186043$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$859238ac8a186043$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$859238ac8a186043$require$Buffer.isBuffer(priv)) priv = new $859238ac8a186043$require$Buffer(priv, enc);
    var _priv = new $9pbIC(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $859238ac8a186043$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $859238ac8a186043$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $859238ac8a186043$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $859238ac8a186043$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("bIasb", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $886be99faec3bef9$export$512823e338ddb1b7, (v) => $886be99faec3bef9$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $886be99faec3bef9$export$7efb24e2fddf99b9, (v) => $886be99faec3bef9$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $886be99faec3bef9$export$9d0e0c0c4a8d30f3, (v) => $886be99faec3bef9$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $886be99faec3bef9$export$b9d55ff329113abd, (v) => $886be99faec3bef9$export$b9d55ff329113abd = v);
var $886be99faec3bef9$export$512823e338ddb1b7;
var $886be99faec3bef9$export$7efb24e2fddf99b9;
var $886be99faec3bef9$export$9d0e0c0c4a8d30f3;
var $886be99faec3bef9$export$b9d55ff329113abd;

$886be99faec3bef9$export$512823e338ddb1b7 = (parcelRequire("fZDr0"));

$886be99faec3bef9$export$7efb24e2fddf99b9 = (parcelRequire("3p2ND"));
$886be99faec3bef9$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $886be99faec3bef9$export$512823e338ddb1b7(key, buf, true);
};
$886be99faec3bef9$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $886be99faec3bef9$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("fZDr0", function(module, exports) {

var $ejFGc = parcelRequire("ejFGc");

var $1DyI6 = parcelRequire("1DyI6");

var $7K4uY = parcelRequire("7K4uY");

var $5g0NR = parcelRequire("5g0NR");

var $ixBc1 = parcelRequire("ixBc1");

var $9pbIC = parcelRequire("9pbIC");

var $fr5TT = parcelRequire("fr5TT");

var $cfrZu = parcelRequire("cfrZu");

var $Wth4q = parcelRequire("Wth4q");
var $ba4b246a6106fed1$require$Buffer = $Wth4q.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $ejFGc(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $ba4b246a6106fed1$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $ba4b246a6106fed1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $9pbIC(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $cfrZu(paddedMsg, key);
    else return $fr5TT(paddedMsg, key);
};
function $ba4b246a6106fed1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $7K4uY('sha1').update($ba4b246a6106fed1$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $ba4b246a6106fed1$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $1DyI6(hLen);
    var maskedDb = $ixBc1($ba4b246a6106fed1$require$Buffer.concat([
        iHash,
        ps,
        $ba4b246a6106fed1$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5g0NR(seed, dblen));
    var maskedSeed = $ixBc1(seed, $5g0NR(maskedDb, hLen));
    return new $9pbIC($ba4b246a6106fed1$require$Buffer.concat([
        $ba4b246a6106fed1$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $ba4b246a6106fed1$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $ba4b246a6106fed1$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $ba4b246a6106fed1$var$nonZero(k - mLen - 3);
    return new $9pbIC($ba4b246a6106fed1$require$Buffer.concat([
        $ba4b246a6106fed1$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $ba4b246a6106fed1$require$Buffer.alloc(1),
        msg
    ], k));
}
function $ba4b246a6106fed1$var$nonZero(len) {
    var out = $ba4b246a6106fed1$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $1DyI6(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $1DyI6(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("5g0NR", function(module, exports) {

var $7K4uY = parcelRequire("7K4uY");

var $Wth4q = parcelRequire("Wth4q");
var $3d3f11d98f131928$require$Buffer = $Wth4q.Buffer;
module.exports = function(seed, len) {
    var t = $3d3f11d98f131928$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $3d3f11d98f131928$var$i2ops(i++);
        t = $3d3f11d98f131928$require$Buffer.concat([
            t,
            $7K4uY('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $3d3f11d98f131928$var$i2ops(c) {
    var out = $3d3f11d98f131928$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("ixBc1", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("fr5TT", function(module, exports) {

var $9pbIC = parcelRequire("9pbIC");

var $Wth4q = parcelRequire("Wth4q");
var $b3cdf455bc7e4e8e$require$Buffer = $Wth4q.Buffer;
function $b3cdf455bc7e4e8e$var$withPublic(paddedMsg, key) {
    return $b3cdf455bc7e4e8e$require$Buffer.from(paddedMsg.toRed($9pbIC.mont(key.modulus)).redPow(new $9pbIC(key.publicExponent)).fromRed().toArray());
}
module.exports = $b3cdf455bc7e4e8e$var$withPublic;

});


parcelRegister("3p2ND", function(module, exports) {

var $ejFGc = parcelRequire("ejFGc");

var $5g0NR = parcelRequire("5g0NR");

var $ixBc1 = parcelRequire("ixBc1");

var $9pbIC = parcelRequire("9pbIC");

var $cfrZu = parcelRequire("cfrZu");

var $7K4uY = parcelRequire("7K4uY");

var $fr5TT = parcelRequire("fr5TT");

var $Wth4q = parcelRequire("Wth4q");
var $27a5e0d2e6fe9775$require$Buffer = $Wth4q.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $ejFGc(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $9pbIC(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $fr5TT(new $9pbIC(enc), key);
    else msg = $cfrZu(enc, key);
    var zBuffer = $27a5e0d2e6fe9775$require$Buffer.alloc(k - msg.length);
    msg = $27a5e0d2e6fe9775$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $27a5e0d2e6fe9775$var$oaep(key, msg);
    else if (padding === 1) return $27a5e0d2e6fe9775$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $27a5e0d2e6fe9775$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $7K4uY('sha1').update($27a5e0d2e6fe9775$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $ixBc1(maskedSeed, $5g0NR(maskedDb, hLen));
    var db = $ixBc1(maskedDb, $5g0NR(seed, k - hLen - 1));
    if ($27a5e0d2e6fe9775$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $27a5e0d2e6fe9775$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $27a5e0d2e6fe9775$var$compare(a, b) {
    a = $27a5e0d2e6fe9775$require$Buffer.from(a);
    b = $27a5e0d2e6fe9775$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("9hQRv", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8, (v) => $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $6c2eb4e5b7b6051e$export$2f7171e78e524d5e, (v) => $6c2eb4e5b7b6051e$export$2f7171e78e524d5e = v);
var $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8;
var $6c2eb4e5b7b6051e$export$2f7171e78e524d5e;

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
function $6c2eb4e5b7b6051e$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $Wth4q = parcelRequire("Wth4q");

var $1DyI6 = parcelRequire("1DyI6");
var $6c2eb4e5b7b6051e$var$Buffer = $Wth4q.Buffer;
var $6c2eb4e5b7b6051e$var$kBufferMaxLength = $Wth4q.kMaxLength;
var $6c2eb4e5b7b6051e$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $6c2eb4e5b7b6051e$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $6c2eb4e5b7b6051e$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $6c2eb4e5b7b6051e$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $6c2eb4e5b7b6051e$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $6c2eb4e5b7b6051e$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $6c2eb4e5b7b6051e$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $6c2eb4e5b7b6051e$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($6c2eb4e5b7b6051e$var$crypto && $6c2eb4e5b7b6051e$var$crypto.getRandomValues || false) {
    $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = $6c2eb4e5b7b6051e$var$randomFill;
    $6c2eb4e5b7b6051e$export$2f7171e78e524d5e = $6c2eb4e5b7b6051e$var$randomFillSync;
} else {
    $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = $6c2eb4e5b7b6051e$var$oldBrowser;
    $6c2eb4e5b7b6051e$export$2f7171e78e524d5e = $6c2eb4e5b7b6051e$var$oldBrowser;
}
function $6c2eb4e5b7b6051e$var$randomFill(buf, offset, size, cb) {
    if (!$6c2eb4e5b7b6051e$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $6c2eb4e5b7b6051e$var$assertOffset(offset, buf.length);
    $6c2eb4e5b7b6051e$var$assertSize(size, offset, buf.length);
    return $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size, cb);
}
function $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $6c2eb4e5b7b6051e$var$crypto.getRandomValues(uint);
    if (cb) {
        $6cAn5.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $1DyI6(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $1DyI6(size);
    bytes.copy(buf, offset);
    return buf;
}
function $6c2eb4e5b7b6051e$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$6c2eb4e5b7b6051e$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $6c2eb4e5b7b6051e$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $6c2eb4e5b7b6051e$var$assertSize(size, offset, buf.length);
    return $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size);
}

});



parcelRegister("75NXP", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $bcab3434b73de5c0$export$e955abb82869dc84);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3FqY6 = parcelRequire("3FqY6");
const $bcab3434b73de5c0$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return {
        fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((payload)=>createAnalyticsEvent(payload).fire((0, $3FqY6.DEFAULT_GAS_CHANNEL)), [
            createAnalyticsEvent
        ])
    };
};

});

parcelRegister("8TPno", function(module, exports) {

$parcel$export(module.exports, "CenteredAdvancedSearchGroup", () => $31bf11d0c8ded2af$export$5d708f1c4bba7ac3);
$parcel$export(module.exports, "StyledAdvancedSearch", () => $31bf11d0c8ded2af$export$ffb3e5c7f83e1d2f);
$parcel$export(module.exports, "AdvancedSearchContent", () => $31bf11d0c8ded2af$export$aa7c31826bbddc7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $3RZIb = parcelRequire("3RZIb");

var $kCMvS = parcelRequire("kCMvS");

var $bWGt6 = parcelRequire("bWGt6");
function $31bf11d0c8ded2af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $31bf11d0c8ded2af$export$5d708f1c4bba7ac3 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1fpfwrr2"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const $31bf11d0c8ded2af$var$outlineWidth = 2;
const $31bf11d0c8ded2af$export$ffb3e5c7f83e1d2f = /*#__PURE__*/ (0, $bWGt6.default)((0, $kCMvS.Link), {
    target: "e1fpfwrr1"
})((props)=>({
        alignItems: 'center',
        color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
        cursor: 'pointer',
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        padding: `${"var(--ds-space-075, 6px)"} ${16 - $31bf11d0c8ded2af$var$outlineWidth}px`,
        border: `${$31bf11d0c8ded2af$var$outlineWidth}px solid transparent`,
        '&:hover': {
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            backgroundColor: `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
            textDecoration: 'none'
        },
        '&:visited': {
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
        },
        '&:focus': {
            outline: 'none',
            border: `${$31bf11d0c8ded2af$var$outlineWidth}px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})`}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
    }));
const $31bf11d0c8ded2af$export$aa7c31826bbddc7b = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1fpfwrr0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $3RZIb.fontFallback).body.medium})`,
    paddingLeft: "var(--ds-space-200, 16px)",
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("kCMvS", function(module, exports) {

$parcel$export(module.exports, "Link", () => $33c994828df19c61$export$a6c7ac8248d6e38a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $33c994828df19c61$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
    // Hack?
    const Component = linkComponent || 'a';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props
    });
};

});


parcelRegister("hN1kQ", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchLink", () => $f402b6a126e5d093$export$3f63855034354a21);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8TPno = parcelRequire("8TPno");
const $f402b6a126e5d093$export$3f63855034354a21 = ({ href: href, linkComponent: linkComponent, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8TPno.StyledAdvancedSearch), {
        linkComponent: linkComponent,
        "data-test-id": "search-dialog-advanced-search-link",
        href: href,
        ...rest
    });

});

parcelRegister("2dI5H", function(module, exports) {

$parcel$export(module.exports, "QueryContextProvider", () => $dac671db1ba592e6$export$96e4d538f00fbce1);
$parcel$export(module.exports, "useQuery", () => $dac671db1ba592e6$export$dd0a697e1782aedd);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2k6eV = parcelRequire("2k6eV");

var $tUDIN = parcelRequire("tUDIN");
var $e5JCl = parcelRequire("e5JCl");

var $i5cPn = parcelRequire("i5cPn");
const $dac671db1ba592e6$var$QueryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    query: '',
    queryVersion: 0,
    isLoading: false,
    setQuery: (ignore)=>{},
    setQueryOnly: (ignore)=>{},
    setAdditionalAnalyticsContext: (ignore)=>({})
});
const $dac671db1ba592e6$export$96e4d538f00fbce1 = ({ children: children })=>{
    const [stateQuery, setStateQuery] = (0, $5uXOq.useState)('');
    const { stickySearchEnabled: stickySearchEnabled, query: sessionQuery, showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog, storeQuery: storeQuery } = (0, $2k6eV.useSessionUserInput)();
    const query = stickySearchEnabled ? sessionQuery : stateQuery;
    const setQuery = (0, $5uXOq.useCallback)((value)=>{
        if (showSearchAIDialog) toggleShowSearchAIDialog(false);
        stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
    }, [
        showSearchAIDialog,
        toggleShowSearchAIDialog,
        stickySearchEnabled,
        storeQuery
    ]);
    const setQueryOnly = (0, $5uXOq.useCallback)((value)=>{
        stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
    }, [
        stickySearchEnabled,
        storeQuery
    ]);
    const { isExpanded: isExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const { isLoading: isLoading, setAdditionalAnalyticsContext: setAdditionalAnalyticsContext, addAnalyticContext: addAnalyticContext, nonPrivacySafeContext: nonPrivacySafeContext, queryVersion: queryVersion } = (0, $e5JCl.useAnalyticsContext)(query);
    (0, $5uXOq.useEffect)(()=>{
        if (!isExpanded) {
            if (!stickySearchEnabled) setQuery('');
            setAdditionalAnalyticsContext({
                type: 'reset'
            });
        }
    }, [
        isExpanded,
        setAdditionalAnalyticsContext,
        stickySearchEnabled,
        setQuery
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($dac671db1ba592e6$var$QueryContext.Provider, {
        value: {
            query: query,
            queryVersion: queryVersion,
            setQuery: setQuery,
            setQueryOnly: setQueryOnly,
            setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
            isLoading: isLoading
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
            analyticContext: addAnalyticContext,
            nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeContext,
            children: children
        })
    });
};
const $dac671db1ba592e6$export$dd0a697e1782aedd = ()=>{
    return (0, $5uXOq.useContext)($dac671db1ba592e6$var$QueryContext);
};

});
parcelRegister("2k6eV", function(module, exports) {

$parcel$export(module.exports, "UserInputContextProvider", () => $2425567f2928b10c$export$dab413a8570d1ac4);
$parcel$export(module.exports, "useSessionUserInput", () => $2425567f2928b10c$export$296c1552a8cb35a5);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3ZeOg = parcelRequire("3ZeOg");

var $3FqY6 = parcelRequire("3FqY6");
var $tUDIN = parcelRequire("tUDIN");
var $75NXP = parcelRequire("75NXP");
const $2425567f2928b10c$var$noop = ()=>{};
const $2425567f2928b10c$var$SESSION_RESET_TIMEOUT_MS = 300000;
const $2425567f2928b10c$var$anyConfluenceFiltersChecked = (filters)=>{
    const confluencefilters = filters.confluence;
    if (confluencefilters) {
        const hasSpaceFilterChecked = confluencefilters.space?.length ? confluencefilters.space?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        const hasPeopleFilterChecked = confluencefilters.people?.length ? confluencefilters.people?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        const hasSiteFilterChecked = confluencefilters.site?.length ? confluencefilters.site?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        return hasSpaceFilterChecked || hasPeopleFilterChecked || hasSiteFilterChecked;
    }
    return false;
};
const $2425567f2928b10c$export$c87c231bb0fb0228 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    stickySearchEnabled: false,
    query: '',
    showSearchAIDialog: false,
    storeQuery: $2425567f2928b10c$var$noop,
    toggleShowSearchAIDialog: $2425567f2928b10c$var$noop,
    readFilters: $2425567f2928b10c$var$noop,
    storeFilters: $2425567f2928b10c$var$noop,
    resetSearchSession: $2425567f2928b10c$var$noop,
    resetConfluenceFiltersRef: undefined,
    resetExtensibleFiltersRef: undefined
});
const $2425567f2928b10c$export$dab413a8570d1ac4 = ({ stickySearchEnabled: stickySearchEnabled = false, sessionResetIdleTime: sessionResetIdleTime = $2425567f2928b10c$var$SESSION_RESET_TIMEOUT_MS, isExpanded: isExpanded = false, resetStickySearchRef: resetStickySearchRef, children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const [query, setQuery] = (0, $5uXOq.useState)((0, $3ZeOg.getSessionItem)((0, $3ZeOg.SEARCH_QUERY_KEY)) || '');
    const [isStickyUpdated, setIsStickyUpdated] = (0, $5uXOq.useState)(false);
    const [stickyQueryUpdated, setStickyQueryUpdated] = (0, $5uXOq.useState)(false);
    const queryFirstUpdatedRef = (0, $5uXOq.useRef)(undefined);
    const lastExpandRef = (0, $5uXOq.useRef)(false);
    const lastQueryRef = (0, $5uXOq.useRef)('');
    const timeoutRef = (0, $5uXOq.useRef)();
    const resetConfluenceFiltersRef = (0, $5uXOq.useRef)();
    const resetExtensibleFiltersRef = (0, $5uXOq.useRef)();
    const sessionShowSearchAIDialogStr = (0, $3ZeOg.getSessionItem)((0, $3ZeOg.SEARCH_SHOW_AI_DIALOG_KEY));
    const sessionShowSearchAIDialog = sessionShowSearchAIDialogStr ? JSON.parse(sessionShowSearchAIDialogStr) : false;
    const [showSearchAIDialog, setShowSearchAIDialog] = (0, $5uXOq.useState)(sessionShowSearchAIDialog);
    const resetSearchSession = (0, $5uXOq.useCallback)(()=>{
        (0, $3ZeOg.deleteSessionItem)((0, $3ZeOg.SEARCH_QUERY_KEY));
        (0, $3ZeOg.deleteSessionItem)((0, $3ZeOg.SEARCH_FILTERS_KEY));
        (0, $3ZeOg.deleteSessionItem)((0, $3ZeOg.SEARCH_SHOW_AI_DIALOG_KEY));
        resetConfluenceFiltersRef.current?.();
        resetExtensibleFiltersRef.current?.();
        setQuery('');
        setShowSearchAIDialog(false);
        queryFirstUpdatedRef.current = undefined;
        lastQueryRef.current = '';
    }, [
        resetConfluenceFiltersRef,
        resetExtensibleFiltersRef
    ]);
    const readFilters = (0, $5uXOq.useCallback)((productId)=>{
        const searchFilterString = (0, $3ZeOg.getSessionItem)((0, $3ZeOg.SEARCH_FILTERS_KEY));
        const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
        if (productId in filters) return filters[productId];
        return {};
    }, []);
    const updateSessionResetTimeout = (0, $5uXOq.useCallback)(()=>{
        if (timeoutRef?.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            if (timeoutRef?.current) clearTimeout(timeoutRef.current);
            const searchFilterString = (0, $3ZeOg.getSessionItem)((0, $3ZeOg.SEARCH_FILTERS_KEY));
            const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
            if (query === '' && !$2425567f2928b10c$var$anyConfluenceFiltersChecked(filters)) return; // Skip the reset and analytics event if no filters or query entered
            resetSearchSession();
            fireAnalyticsEvent((0, $3FqY6.onStickySearchCleared)({
                timeout: sessionResetIdleTime
            }));
        }, sessionResetIdleTime);
    }, [
        query,
        sessionResetIdleTime,
        resetSearchSession,
        fireAnalyticsEvent
    ]);
    const storeQuery = (0, $5uXOq.useCallback)((query)=>{
        setQuery(query);
        (0, $3ZeOg.setSessionItem)((0, $3ZeOg.SEARCH_QUERY_KEY), query);
        updateSessionResetTimeout();
        if (queryFirstUpdatedRef.current === undefined) queryFirstUpdatedRef.current = Date.now();
        if (lastQueryRef.current) setStickyQueryUpdated(query !== lastQueryRef.current);
    }, [
        updateSessionResetTimeout
    ]);
    const toggleShowSearchAIDialog = (0, $5uXOq.useCallback)((showSearchAIDialog)=>{
        setShowSearchAIDialog(showSearchAIDialog);
        (0, $3ZeOg.setSessionItem)((0, $3ZeOg.SEARCH_SHOW_AI_DIALOG_KEY), showSearchAIDialog.toString());
    }, []);
    const storeFilters = (0, $5uXOq.useCallback)((productId, value)=>{
        const searchFilterString = (0, $3ZeOg.getSessionItem)((0, $3ZeOg.SEARCH_FILTERS_KEY));
        const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
        filters[productId] = value;
        (0, $3ZeOg.setSessionItem)((0, $3ZeOg.SEARCH_FILTERS_KEY), JSON.stringify(filters));
        if (lastExpandRef.current) updateSessionResetTimeout;
    }, [
        lastExpandRef,
        updateSessionResetTimeout
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (resetStickySearchRef) resetStickySearchRef.current = resetSearchSession;
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!lastExpandRef.current && isExpanded) updateSessionResetTimeout();
        if (lastExpandRef.current && !isExpanded) updateSessionResetTimeout();
    }, [
        lastExpandRef,
        isExpanded,
        updateSessionResetTimeout
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!lastExpandRef.current && isExpanded) {
            setIsStickyUpdated(query !== '');
            lastQueryRef.current = query;
            setStickyQueryUpdated(false);
        }
        lastExpandRef.current = isExpanded;
    }, [
        isExpanded,
        lastExpandRef,
        lastQueryRef,
        query
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2425567f2928b10c$export$c87c231bb0fb0228.Provider, {
        value: {
            stickySearchEnabled: stickySearchEnabled,
            query: query,
            showSearchAIDialog: showSearchAIDialog,
            storeQuery: stickySearchEnabled ? storeQuery : $2425567f2928b10c$var$noop,
            toggleShowSearchAIDialog: toggleShowSearchAIDialog,
            readFilters: stickySearchEnabled ? readFilters : $2425567f2928b10c$var$noop,
            storeFilters: stickySearchEnabled ? storeFilters : $2425567f2928b10c$var$noop,
            resetSearchSession: stickySearchEnabled ? resetSearchSession : $2425567f2928b10c$var$noop,
            resetConfluenceFiltersRef: stickySearchEnabled ? resetConfluenceFiltersRef : undefined,
            resetExtensibleFiltersRef: stickySearchEnabled ? resetExtensibleFiltersRef : undefined
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
            analyticContext: stickySearchEnabled ? {
                isSticky: true,
                isStickyUpdated: isStickyUpdated,
                stickyQueryUpdated: stickyQueryUpdated,
                queryUpdatedAgo: queryFirstUpdatedRef.current ? Date.now() - queryFirstUpdatedRef.current : undefined
            } : {
                isSticky: false
            },
            children: children
        })
    });
};
const $2425567f2928b10c$export$296c1552a8cb35a5 = ()=>{
    return (0, $5uXOq.useContext)($2425567f2928b10c$export$c87c231bb0fb0228);
};

});
parcelRegister("3ZeOg", function(module, exports) {

$parcel$export(module.exports, "SEARCH_QUERY_KEY", () => $ec26c0406ff6caf4$export$240cb7dc75f6cac2);
$parcel$export(module.exports, "SEARCH_FILTERS_KEY", () => $ec26c0406ff6caf4$export$978fb20afa14aaa7);
$parcel$export(module.exports, "SEARCH_SHOW_AI_DIALOG_KEY", () => $ec26c0406ff6caf4$export$f4dca218ecb5824a);
$parcel$export(module.exports, "getSessionItem", () => $ec26c0406ff6caf4$export$fdf7104ff19cc288);
$parcel$export(module.exports, "setSessionItem", () => $ec26c0406ff6caf4$export$a5376dd4adeb0fbf);
$parcel$export(module.exports, "deleteSessionItem", () => $ec26c0406ff6caf4$export$5896963da935fdc4);
const $ec26c0406ff6caf4$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $ec26c0406ff6caf4$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $ec26c0406ff6caf4$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $ec26c0406ff6caf4$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $ec26c0406ff6caf4$export$fdf7104ff19cc288 = (key)=>{
    return window.sessionStorage.getItem(key);
};
const $ec26c0406ff6caf4$export$a5376dd4adeb0fbf = (key, value)=>{
    try {
        window.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $ec26c0406ff6caf4$export$5896963da935fdc4 = (key)=>{
    window.sessionStorage.removeItem(key);
};

});


parcelRegister("e5JCl", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $f0b2b2e052773c1b$export$d1f587f82ad51c4);

var $5uXOq = parcelRequire("5uXOq");

var $8oG5R = parcelRequire("8oG5R");
const $f0b2b2e052773c1b$var$defaultAnalyticsContextState = {
    queryVersion: 0,
    isLoading: false
};
const $f0b2b2e052773c1b$var$analyticsContextReducer = (state, action)=>{
    switch(action.type){
        case 'queryVersion':
            return {
                ...state,
                queryVersion: action.value
            };
        case 'isLoading':
            return {
                ...state,
                isLoading: action.value
            };
        case 'reset':
            return $f0b2b2e052773c1b$var$defaultAnalyticsContextState;
        default:
            throw new Error();
    }
};
const $f0b2b2e052773c1b$export$d1f587f82ad51c4 = (query)=>{
    const [{ queryVersion: queryVersion, isLoading: isLoading }, setAdditionalAnalyticsContext] = (0, $5uXOq.useReducer)($f0b2b2e052773c1b$var$analyticsContextReducer, $f0b2b2e052773c1b$var$defaultAnalyticsContextState);
    const addAnalyticContext = (0, $5uXOq.useCallback)(()=>{
        return {
            wordCount: (0, $8oG5R.getWordCount)(query),
            queryLength: query.length,
            queryHash: (0, $8oG5R.sha256Hash)(query),
            queryHashSHA256: (0, $8oG5R.sha256Hash)(query),
            queryVersion: queryVersion
        };
    }, [
        query,
        queryVersion
    ]);
    const nonPrivacySafeContext = (0, $5uXOq.useCallback)(()=>{
        return {
            query: query
        };
    }, [
        query
    ]);
    return {
        isLoading: isLoading,
        setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
        addAnalyticContext: addAnalyticContext,
        nonPrivacySafeContext: nonPrivacySafeContext,
        queryVersion: queryVersion
    };
};

});


parcelRegister("dV2Gy", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchLinkWrapper", () => $a51e2d4a0639c8f2$export$8e79650dab255425);

var $bWGt6 = parcelRequire("bWGt6");
function $a51e2d4a0639c8f2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a51e2d4a0639c8f2$export$8e79650dab255425 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ecy8ma0"
})({
    name: "7whenc",
    styles: "display:flex;width:100%"
});

});


parcelRegister("8Xs9r", function(module, exports) {

$parcel$export(module.exports, "SearchDialogProduct", () => $e6bd28963f80b135$export$bea8d7c130bb15c8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lgJ2n = parcelRequire("lgJ2n");

var $dh6Py = parcelRequire("dh6Py");

var $i5cPn = parcelRequire("i5cPn");

var $1CzPM = parcelRequire("1CzPM");

var $2QmdW = parcelRequire("2QmdW");
const $e6bd28963f80b135$export$bea8d7c130bb15c8 = ({ generateAdvancedSearchUrl: genUrl, ...rest })=>{
    const { isExpanded: isExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const generateAdvancedSearchUrl = (0, $2QmdW.useGenerateAdvancedSearchUrl)(genUrl);
    const props = {
        ...rest,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dh6Py.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lgJ2n.AsyncProduct), {
            ...props,
            fallback: !isExpanded ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}) : undefined,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1CzPM.AsyncProvider), {
                ...props
            })
        })
    });
};

});
parcelRegister("lgJ2n", function(module, exports) {

$parcel$export(module.exports, "AsyncProduct", () => $ab8b897c5f6791e8$export$ea887de8bd536d84);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cRsyH = parcelRequire("cRsyH");

var $edfe8 = parcelRequire("edfe8");

var $kv2Va = parcelRequire("kv2Va");

var $hedKk = parcelRequire("hedKk");

var $kfPLS = parcelRequire("kfPLS");
class $ab8b897c5f6791e8$export$6bc62c4e30aa3c0a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentWillUnmount() {
        const { removeProduct: removeProduct, id: id } = this.props;
        removeProduct(id);
    }
    render() {
        const { fallback: FallbackComponent, id: id, children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kfPLS.ActiveProduct), {
                id: id,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cRsyH.TimeLazyLoad), {
                    product: id,
                    children: FallbackComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(FallbackComponent, {}) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $edfe8.LoadingSpinner), {})
                })
            }),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hedKk.InitialisationExperienceSuccess), {
                    ...this.props
                }),
                children
            ]
        });
    }
}
const $ab8b897c5f6791e8$export$ea887de8bd536d84 = (0, $kv2Va.withProductContext)($ab8b897c5f6791e8$export$6bc62c4e30aa3c0a);

});
parcelRegister("cRsyH", function(module, exports) {

$parcel$export(module.exports, "TimeLazyLoad", () => $87190a03e27263a5$export$5a31ea5680c95894);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");
const $87190a03e27263a5$export$5a31ea5680c95894 = ({ children: children, product: product })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        const start = Date.now();
        return ()=>{
            fireAnalyticsEvent((0, $3FqY6.onPaneLoadComplete)(product, Date.now() - start));
        };
    }, [
        fireAnalyticsEvent,
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("edfe8", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $8dfc4f16120049f8$export$b08b517936747730);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dOTq1 = parcelRequire("dOTq1");

var $eZJjh = parcelRequire("eZJjh");
const $8dfc4f16120049f8$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dOTq1.SpinnerContainer), {
        "data-testid": "search-dialog-loading-spinner",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dOTq1.HorizontalCenteredContainer), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
        })
    });

});
parcelRegister("dOTq1", function(module, exports) {

$parcel$export(module.exports, "HorizontalCenteredContainer", () => $81c9a6fe69fc2e72$export$574c01fef92380ae);
$parcel$export(module.exports, "SpinnerContainer", () => $81c9a6fe69fc2e72$export$a5e06607a5ac6158);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
function $81c9a6fe69fc2e72$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81c9a6fe69fc2e72$export$574c01fef92380ae = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eh93uzp1"
})({
    name: "9th5i",
    styles: "margin:0 auto"
});
const $81c9a6fe69fc2e72$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eh93uzp0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $k5uoT.gridSize)() * 12}px`,
    width: '100%',
    display: 'flex',
    alignItems: 'center'
});

});


parcelRegister("hedKk", function(module, exports) {

$parcel$export(module.exports, "InitialisationExperienceSuccess", () => $46f0cfaf913ce736$export$12ba87fc0c8ef4e3);

var $5uXOq = parcelRequire("5uXOq");

var $4tuQr = parcelRequire("4tuQr");

var $kv2Va = parcelRequire("kv2Va");

var $9Mho6 = parcelRequire("9Mho6");
const $46f0cfaf913ce736$export$7f8c86254a9e879c = ({ id: id, abTest: abTest, getPrimaryProduct: getPrimaryProduct })=>{
    const [successCalled, setSuccessCalled] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (successCalled) return;
        const primaryProduct = getPrimaryProduct();
        if (abTest && primaryProduct && primaryProduct.id === id) {
            (0, $9Mho6.initialisationExperience).success();
            setSuccessCalled(true);
        }
    }, [
        abTest,
        getPrimaryProduct,
        id,
        successCalled
    ]);
    return null;
};
const $46f0cfaf913ce736$export$12ba87fc0c8ef4e3 = (0, $4tuQr.withABTestContext)((0, $kv2Va.withProductContext)($46f0cfaf913ce736$export$7f8c86254a9e879c));

});
parcelRegister("4tuQr", function(module, exports) {

$parcel$export(module.exports, "ABTestContextProvider", () => $62a14a729926e68c$export$e7d53dc13567ec0e);
$parcel$export(module.exports, "useABTest", () => $62a14a729926e68c$export$14279a3fbdb52451);
$parcel$export(module.exports, "withABTestContext", () => $62a14a729926e68c$export$5124bc23083a567d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $tUDIN = parcelRequire("tUDIN");
var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");

var $jKEl7 = parcelRequire("jKEl7");
var $lvCts = parcelRequire("lvCts");

var $kv2Va = parcelRequire("kv2Va");

var $j97IK = parcelRequire("j97IK");

var $dh6Py = parcelRequire("dh6Py");

var $VSDnB = parcelRequire("VSDnB");
const $62a14a729926e68c$export$22966a5ebf51ce99 = {
    abTestId: 'default',
    controlId: 'default',
    experimentId: 'default'
};
const $62a14a729926e68c$var$ABTestContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    abTest: null
});
const $62a14a729926e68c$var$ABTestContextProviderStateless = ({ isMultiProduct: isMultiProduct, searchClient: searchClient, scope: scope, children: children, primaryProductId: primaryProductId, experience: experience })=>{
    const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, $j97IK.useExperiments)();
    const [abTest, setAbTest] = (0, $5uXOq.useState)(()=>{
        const defaultAbTest = (0, $VSDnB.fg)('qs-7058-remove-experiment-call-search-dialog') ? $62a14a729926e68c$export$22966a5ebf51ce99 : null;
        return backendExperiment || defaultAbTest;
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        const now = Date.now();
        if ((0, $VSDnB.fg)('qs-7058-remove-experiment-call-search-dialog') || !searchClient || !scope || abTest) return;
        if (scope === (0, $dh6Py.PERFORMANCE_IMPROVEMENT_DUMMY_SECTION)) {
            setAbTest($62a14a729926e68c$export$22966a5ebf51ce99);
            return;
        }
        searchClient// TODO: Remove PLACEHOLDER_EXPERIENCE
        .getAbTestData(scope, experience ?? (0, $jKEl7.PLACEHOLDER_EXPERIENCE), primaryProductId).then((abTestResponse)=>{
            const duration = Date.now() - now;
            const abTestWithDefault = abTestResponse || $62a14a729926e68c$export$22966a5ebf51ce99;
            setAbTest(abTestWithDefault);
            fireAnalyticsEvent((0, $3FqY6.onExperimentLoaded)(abTestWithDefault, duration, !!isMultiProduct));
        }).catch((e)=>{
            setAbTest($62a14a729926e68c$export$22966a5ebf51ce99);
        });
    }, [
        searchClient,
        fireAnalyticsEvent,
        isMultiProduct,
        scope,
        abTest,
        primaryProductId,
        experience,
        backendExperiment
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($62a14a729926e68c$var$ABTestContext.Provider, {
        value: {
            abTest: abTest
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
            analyticContext: {
                abTest: abTest || undefined,
                frontendExperiments: {
                    activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                    ...frontendExperiments
                }
            },
            nonPrivacySafeAnalyticContext: {},
            children: children
        })
    });
};
const $62a14a729926e68c$export$e7d53dc13567ec0e = (props)=>{
    const { getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const searchClient = (0, $lvCts.useAggregatorClient)();
    const primaryProduct = getPrimaryProduct();
    const { sectionIds: sectionIds } = primaryProduct || {};
    const scope = (0, $5uXOq.useMemo)(()=>sectionIds && sectionIds.length > 0 ? sectionIds[0] : undefined, [
        sectionIds
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($62a14a729926e68c$var$ABTestContextProviderStateless, {
        ...props,
        scope: scope,
        searchClient: searchClient,
        primaryProductId: primaryProduct?.id
    });
};
const $62a14a729926e68c$export$14279a3fbdb52451 = ()=>{
    const { abTest: abTest } = (0, $5uXOq.useContext)($62a14a729926e68c$var$ABTestContext);
    return abTest;
};
const $62a14a729926e68c$export$5124bc23083a567d = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            ...(0, $5uXOq.useContext)($62a14a729926e68c$var$ABTestContext)
        });
};

});
parcelRegister("dh6Py", function(module, exports) {

$parcel$export(module.exports, "PERFORMANCE_IMPROVEMENT_DUMMY_SECTION", () => $5ae1fd540ac967a4$export$d56c05d9b1186628);
$parcel$export(module.exports, "default", () => $5ae1fd540ac967a4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jKEl7 = parcelRequire("jKEl7");
var $lvCts = parcelRequire("lvCts");

var $kv2Va = parcelRequire("kv2Va");

var $97Hug = parcelRequire("97Hug");
const $5ae1fd540ac967a4$export$8e8702b7c6f58328 = ({ children: children, permissionSupplier: permissionSupplier, id: id, title: title, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter })=>{
    const invokePostQuerySearchRef = (0, $5uXOq.useRef)(()=>{});
    const [allowedSections, setAllowedSections] = (0, $5uXOq.useState)([]);
    const searchClient = (0, $lvCts.useAggregatorClient)();
    (0, $5uXOq.useEffect)(()=>{
        if (allowedSections.length === 0) {
            // For Jira we need to improve performance by not rendering all the search dialog tabs before the
            // dialog is expanded. However, in order to ensure that the search component is interactive there needs
            // to be at least one allowed section. This test is a workaround to ensure that when there is only this
            // single dummy section that it is included without a permission check. This hook will be called again
            // when the search dialog is expanded and the real sections are provided.
            if (sections.length === 1 && sections[0].id === $5ae1fd540ac967a4$export$d56c05d9b1186628) {
                setAllowedSections([
                    $5ae1fd540ac967a4$export$d56c05d9b1186628
                ]);
                return;
            } else {
                const promise = permissionSupplier ? permissionSupplier() : searchClient ? searchClient.batchedGetExtensibleProductPermission(id, {
                    productIds: [
                        id
                    ],
                    experience: (0, $jKEl7.PLACEHOLDER_EXPERIENCE)
                }) : Promise.resolve([]);
                promise.then((response)=>{
                    setAllowedSections(response);
                });
            }
        }
    /**
		 * We want to replicate componentDidMount behaviour to avoid invoking the API multiple times and we don't care if any other deps changed.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return allowedSections.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $97Hug.default), {
            allowedSections: allowedSections,
            sections: sections,
            id: id,
            title: title,
            order: order,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            expandedStateInputPlaceholder: expandedStateInputPlaceholder,
            workspaces: workspaces,
            autocorrectEnabled: autocorrectEnabled,
            showViewAllFiltersLink: showViewAllFiltersLink,
            tabRenderer: tabRenderer,
            aiSearchConfig: aiSearchConfig,
            showSearchOnEnter: showSearchOnEnter,
            invokePostQuerySearchRef: invokePostQuerySearchRef,
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
};
const $5ae1fd540ac967a4$export$d56c05d9b1186628 = '__PERFORMANCE_IMPROVEMENT_DUMMY_SECTION__';
var $5ae1fd540ac967a4$export$2e2bcd8739ae039 = (0, $kv2Va.withProductContext)($5ae1fd540ac967a4$export$8e8702b7c6f58328);

});
parcelRegister("97Hug", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c06cca48547accb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kv2Va = parcelRequire("kv2Va");
const $3c06cca48547accb$export$90be722c085777fe = ({ addProduct: addProduct, showProduct: showProduct, updateProduct: updateProduct, id: id, title: title, children: children, allowedSections: allowedSections, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter, invokePostQuerySearchRef: invokePostQuerySearchRef })=>{
    const [originalId] = (0, $5uXOq.useState)(id);
    const [registeredProduct, setRegisteredProduct] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (allowedSections.length > 0) {
            const allowedSectionString = allowedSections.join(' ');
            const allowedRegisteredSections = sections.map((sec)=>sec.id).filter((sectionId)=>{
                const sectionIds = sectionId.replace(id, '').replace('.', '').split(',');
                let allowed = true;
                sectionIds.forEach((section)=>{
                    if (allowedSectionString.indexOf(section) === -1) allowed = false;
                });
                return allowed;
            });
            if (allowedRegisteredSections.length > 0) {
                addProduct({
                    id: id,
                    title: title,
                    sectionIds: sections.map((sec)=>sec.id),
                    order: order,
                    generateAdvancedSearchUrl: generateAdvancedSearchUrl,
                    expandedStateInputPlaceholder: expandedStateInputPlaceholder,
                    workspaces: workspaces,
                    autocorrectEnabled: autocorrectEnabled,
                    showViewAllFiltersLink: showViewAllFiltersLink,
                    tabRenderer: tabRenderer,
                    aiSearchConfig: aiSearchConfig,
                    showSearchOnEnter: showSearchOnEnter,
                    invokePostQuerySearchRef: invokePostQuerySearchRef
                });
                setRegisteredProduct(true);
            }
        }
    /**
		 * Updating of state is a side effect. We want it to happen in component did mount stage. Hence replicating this behaviour.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!registeredProduct) return;
        if (id !== originalId) {
            // eslint-disable-next-line no-console
            console.error("product-search-dialog: Cannot update a different product's properties. Did you change accidentally change a product's id?");
            return;
        }
        updateProduct({
            id: id,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            tabRenderer: tabRenderer
        });
    }, [
        registeredProduct,
        id,
        originalId,
        updateProduct,
        generateAdvancedSearchUrl,
        tabRenderer
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
var $3c06cca48547accb$export$2e2bcd8739ae039 = (0, $kv2Va.withProductContext)($3c06cca48547accb$export$90be722c085777fe);

});



parcelRegister("9Mho6", function(module, exports) {

$parcel$export(module.exports, "COMPONENT", () => $e32e5db0ac5f4101$export$af1e30ebbae9df3b);
$parcel$export(module.exports, "initialisationExperience", () => $e32e5db0ac5f4101$export$e5b98327036a989d);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $e32e5db0ac5f4101$export$af1e30ebbae9df3b = 'search-dialog';
const $e32e5db0ac5f4101$export$e5b98327036a989d = new (0, $duUGa.UFOExperience)('intialisation', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $e32e5db0ac5f4101$export$af1e30ebbae9df3b
    }
});

});


parcelRegister("kfPLS", function(module, exports) {

$parcel$export(module.exports, "ActiveProduct", () => $0bc97596379e2299$export$13224c53a1606253);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kv2Va = parcelRequire("kv2Va");
const $0bc97596379e2299$export$13224c53a1606253 = ({ children: children, id: id })=>{
    const { getProduct: getProduct } = (0, $kv2Va.useProductContext)();
    const product = getProduct(id);
    if (!product?.isDisplayed) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("1CzPM", function(module, exports) {

$parcel$export(module.exports, "AsyncProvider", () => $64f4abae63d25af6$export$2f9c5c9733d48598);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $64f4abae63d25af6$var$AsyncResultProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("liteS")).then(({ ResultProvider: ResultProvider })=>({
            default: ResultProvider
        })));
const $64f4abae63d25af6$export$2f9c5c9733d48598 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($64f4abae63d25af6$var$AsyncResultProvider, {
        ...props,
        children: props.children
    });

});
parcelRegister("liteS", function(module, exports) {

let $f811f5a7c712e8a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f811f5a7c712e8a7$var$load("lUtRC").then(()=>parcelRequire('83lE1'));

});


parcelRegister("2QmdW", function(module, exports) {

$parcel$export(module.exports, "useGenerateAdvancedSearchUrl", () => $a9c90e41ea87daaa$export$25a2b20022e2a01a);

var $5uXOq = parcelRequire("5uXOq");

var $hNXQY = parcelRequire("hNXQY");

var $4QKbG = parcelRequire("4QKbG");
const $a9c90e41ea87daaa$export$25a2b20022e2a01a = (genUrl)=>{
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $hNXQY.useFeaturesContext)();
    const { queryParams: queryParams } = (0, $4QKbG.useQueryParams)();
    return (0, $5uXOq.useCallback)((query, baseUrl, usage)=>{
        const advancedSearchUrl = genUrl?.(query, baseUrl, usage) || '';
        if (isGriffinNavEnabled) {
            const urlParts = advancedSearchUrl.split('?');
            // Omit text and originalQuery from the query params
            // originalQuery is used to support AutoCorrection in FPS and we don't want it
            // to persist between search queries
            const { text: text, originalQuery: originalQuery, ...rest } = queryParams || {};
            return `${urlParts[0]}?${new URLSearchParams({
                ...rest,
                ...query !== '' && {
                    text: query
                }
            }).toString()}`;
        }
        return advancedSearchUrl;
    }, [
        genUrl,
        isGriffinNavEnabled,
        queryParams
    ]);
};

});
parcelRegister("hNXQY", function(module, exports) {

$parcel$export(module.exports, "FeaturesProvider", () => $b912e1fafdf2e976$export$502d46f2366b5b43);
$parcel$export(module.exports, "useFeaturesContext", () => $b912e1fafdf2e976$export$38c566c0640fb69a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4QKbG = parcelRequire("4QKbG");
const $b912e1fafdf2e976$export$98552201007e6417 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $b912e1fafdf2e976$export$502d46f2366b5b43 = ({ dialogFeatures: dialogFeatures = {}, children: children })=>{
    const { queryParams: queryParams } = (0, $4QKbG.useQueryParams)();
    // Do not proceed with griffin navigation if query param props are not available
    const isGriffinNavEnabled = (0, $5uXOq.useMemo)(()=>dialogFeatures.isGriffinNavEnabled === true && queryParams !== undefined, [
        dialogFeatures.isGriffinNavEnabled,
        queryParams
    ]);
    return(/**
		 * Defaults and platfrom feature flag values can be overriden if explicit props are injected. This serves two purposes:
		 *
		 * 1. Storybook knobs can be provisioned for features that are powered by platfrom feature flags
		 *
		 * 2. Consumer products like Confluence, Jira can run statsig based experiments, where the Statsig evaluation happens in the product's code
		 * but the effect happens inside the code shipped by search platform.
		 */ /*#__PURE__*/ (0, $2OMIu.jsx)($b912e1fafdf2e976$export$98552201007e6417.Provider, {
        value: {
            ...dialogFeatures,
            isGriffinNavEnabled: isGriffinNavEnabled
        },
        children: children
    }));
};
const $b912e1fafdf2e976$export$38c566c0640fb69a = ()=>{
    return (0, $5uXOq.useContext)($b912e1fafdf2e976$export$98552201007e6417);
};

});
parcelRegister("4QKbG", function(module, exports) {

$parcel$export(module.exports, "QueryParamsProvider", () => $02989d7843adadc2$export$90a656ad86ba2e2);
$parcel$export(module.exports, "useQueryParams", () => $02989d7843adadc2$export$b37ee0d76c6d2fbc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $02989d7843adadc2$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    queryParams: undefined
});
const $02989d7843adadc2$export$90a656ad86ba2e2 = ({ queryParams: queryParams, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($02989d7843adadc2$var$Context.Provider, {
        value: {
            queryParams: queryParams
        },
        children: children
    });
};
const $02989d7843adadc2$export$b37ee0d76c6d2fbc = ()=>{
    return (0, $5uXOq.useContext)($02989d7843adadc2$var$Context);
};

});




parcelRegister("kbhX0", function(module, exports) {

$parcel$export(module.exports, "useBitbucketPermissionSupplier", () => $840e389fc265c74e$export$e0a27ecb613d1aab);

var $5uXOq = parcelRequire("5uXOq");

var $jKEl7 = parcelRequire("jKEl7");
var $lvCts = parcelRequire("lvCts");

var $b1ovj = parcelRequire("b1ovj");
const $840e389fc265c74e$export$e0a27ecb613d1aab = (overridenPermissionsSupplier)=>{
    const client = (0, $lvCts.useTypedAggregatorClient)();
    return (0, $5uXOq.useMemo)(()=>{
        if (overridenPermissionsSupplier) return overridenPermissionsSupplier;
        return ()=>client?.getProductScopes((0, $b1ovj.BITBUCKET_PRODUCT_ID), (0, $jKEl7.PLACEHOLDER_EXPERIENCE)) || [];
    }, [
        client,
        overridenPermissionsSupplier
    ]);
};

});
parcelRegister("b1ovj", function(module, exports) {

$parcel$export(module.exports, "BitbucketScope", () => $e605897f10838a92$export$30e31f52a81be3c8);
$parcel$export(module.exports, "BITBUCKET_PRODUCT_ID", () => $e605897f10838a92$export$49fc3e2141fc5779);
var $e605897f10838a92$export$30e31f52a81be3c8 = /*#__PURE__*/ function(BitbucketScope) {
    BitbucketScope["BitbucketRepostitory"] = "bitbucket.repository";
    return BitbucketScope;
}({});
const $e605897f10838a92$export$49fc3e2141fc5779 = 'bitbucket';

});


parcelRegister("hEvMC", function(module, exports) {

$parcel$export(module.exports, "bitbucketURLGenerators", () => $76ef6489237afc4f$export$8f020ef2e5947a78);
const $76ef6489237afc4f$var$getBitbucketBaseURL = ()=>{
    const hostname = window.location.hostname;
    if (hostname.includes('jira-dev.com') || hostname.startsWith('localhost')) return 'https://staging.bb-inf.net';
    return 'https://bitbucket.org';
};
const $76ef6489237afc4f$export$8f020ef2e5947a78 = (overrides)=>{
    const viewAllLinkGenerator = (query)=>`${$76ef6489237afc4f$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}`;
    const urlGeneratorForNoResultsScreen = (query)=>query ? `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}` : `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/dashboard/repositories`;
    const codeSearchUrlGenerator = (query)=>query ? `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/search?q=${encodeURIComponent(query)}` : `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/search`;
    const codeSearchContextualUrlGenerator = (query, context)=>{
        const { repository: repository, workspace: workspace } = context;
        let fullModifier = query || repository ? '?q=' : '';
        // Populate query params
        if (repository) {
            const repoSlug = encodeURIComponent(`repo:${repository.slug} `);
            fullModifier = `${fullModifier}${repoSlug}`;
        }
        if (query) fullModifier = `${fullModifier}${encodeURIComponent(query)}`;
        const workspaceUUID = repository?.workspace?.uuid || workspace?.uuid;
        if (workspaceUUID) fullModifier = fullModifier ? `${fullModifier}&account=${encodeURIComponent(workspaceUUID)}` : `?account=${encodeURIComponent(workspaceUUID)}`;
        return `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/search${fullModifier}`;
    };
    return {
        viewAllLinkGenerator: overrides?.viewAllLinkGenerator || viewAllLinkGenerator,
        urlGeneratorForNoResultsScreen: overrides?.urlGeneratorForNoResultsScreen || urlGeneratorForNoResultsScreen,
        codeSearchUrlGenerator: overrides?.codeSearchUrlGenerator || codeSearchUrlGenerator,
        codeSearchContextualUrlGenerator: overrides?.codeSearchContextualUrlGenerator || codeSearchContextualUrlGenerator
    };
};

});

parcelRegister("95MIc", function(module, exports) {

$parcel$export(module.exports, "useShowAtlassianHomeSearchLink", () => $4dfdd18c128d2b80$export$14841bea82c8a2c4);
$parcel$export(module.exports, "showAtlassianHomeSearchLink", () => $4dfdd18c128d2b80$export$52dc59b9f236d940);

var $VSDnB = parcelRequire("VSDnB");

var $lTDGC = parcelRequire("lTDGC");

var $7VoGI = parcelRequire("7VoGI");
const $4dfdd18c128d2b80$export$14841bea82c8a2c4 = (primaryProduct)=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $lTDGC.useRovoContext)();
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    return $4dfdd18c128d2b80$export$52dc59b9f236d940(isRovoEnabled, orgId, primaryProduct);
};
const $4dfdd18c128d2b80$export$52dc59b9f236d940 = (isRovoEnabled, orgId, primaryProduct)=>!!(isRovoEnabled && orgId && primaryProduct === 'jira' && (0, $VSDnB.fg)('jira_rovo_in_quick_search'));

});
parcelRegister("lTDGC", function(module, exports) {

$parcel$export(module.exports, "RovoContextProvider", () => $5a4ba11087fc4efc$export$ee92d5ccc84fac27);
$parcel$export(module.exports, "useRovoContext", () => $5a4ba11087fc4efc$export$4deb785ed026cc56);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $5a4ba11087fc4efc$var$RovoContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    isRovoEnabled: false,
    setIsRovoEnabled: (isRovoEnabled)=>{}
});
const $5a4ba11087fc4efc$export$ee92d5ccc84fac27 = ({ isEnabled: isEnabled, children: children })=>{
    const [isRovoEnabled, setIsRovoEnabled] = (0, $5uXOq.useState)(isEnabled || false);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5a4ba11087fc4efc$var$RovoContext.Provider, {
        value: {
            isRovoEnabled: isRovoEnabled,
            setIsRovoEnabled: setIsRovoEnabled
        },
        children: children
    });
};
function $5a4ba11087fc4efc$export$4deb785ed026cc56() {
    return (0, $5uXOq.useContext)($5a4ba11087fc4efc$var$RovoContext);
}

});

parcelRegister("7VoGI", function(module, exports) {

$parcel$export(module.exports, "UserProvider", () => $552748c768c14934$export$88f24fd8fcfab6ca);
$parcel$export(module.exports, "useUserContext", () => $552748c768c14934$export$87c54b525b914dab);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $552748c768c14934$var$UserContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    user: {},
    setUser: (user)=>{}
});
const $552748c768c14934$export$88f24fd8fcfab6ca = ({ user: initialUser, orgId: orgId, children: children })=>{
    const [user, setUser] = (0, $5uXOq.useState)(initialUser || {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)($552748c768c14934$var$UserContext.Provider, {
        value: {
            user: user,
            orgId: orgId,
            setUser: setUser
        },
        children: children
    });
};
function $552748c768c14934$export$87c54b525b914dab() {
    return (0, $5uXOq.useContext)($552748c768c14934$var$UserContext);
}

});


parcelRegister("4f9Ma", function(module, exports) {

$parcel$export(module.exports, "getAtlassianHomeSearchUrl", () => $c0f59a78222868cd$export$306c16563e2015b8);
$parcel$export(module.exports, "AtlassianHomeSearchLink", () => $c0f59a78222868cd$export$829d02f6cd9ab0ce);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $kaR8K = parcelRequire("kaR8K");

var $1U4EY = parcelRequire("1U4EY");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2dI5H = parcelRequire("2dI5H");

var $1W52p = parcelRequire("1W52p");

var $dgPZl = parcelRequire("dgPZl");

var $lKCn7 = parcelRequire("lKCn7");

var $80Slk = parcelRequire("80Slk");

var $lwJQ0 = parcelRequire("lwJQ0");

var $8oG5R = parcelRequire("8oG5R");
var $3FqY6 = parcelRequire("3FqY6");
var $75NXP = parcelRequire("75NXP");

var $kv2Va = parcelRequire("kv2Va");

var $hN1kQ = parcelRequire("hN1kQ");
const $c0f59a78222868cd$var$ModifierIcon = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.ReturnIconWithModifier), {
        showModifierKey: true
    });
const $c0f59a78222868cd$var$ReturnIcon = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.ReturnIconWithModifier), {});
const $c0f59a78222868cd$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex'
});
const $c0f59a78222868cd$var$productIconStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '78px'
});
const $c0f59a78222868cd$var$moreButtonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.075',
    marginRight: 'space.050',
    height: '20px',
    display: 'flex',
    alignItems: 'center'
});
const $c0f59a78222868cd$var$absoluteStyles = (0, $8CUq3.xcss)({
    position: 'absolute'
});
const $c0f59a78222868cd$var$borderStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '22px',
    width: '22px',
    borderRadius: '6px'
});
const $c0f59a78222868cd$var$jiraIconOverlapStyles = (0, $8CUq3.xcss)({
    zIndex: 'dialog',
    transform: 'translate(15px, 0)'
});
const $c0f59a78222868cd$var$confluenceIconOverlapStyles = (0, $8CUq3.xcss)({
    zIndex: 'navigation',
    transform: 'translate(30px, 0)'
});
const $c0f59a78222868cd$var$googleDriveIconOverlapStyles = (0, $8CUq3.xcss)({
    zIndex: 'card',
    transform: 'translate(45px, 0)'
});
const $c0f59a78222868cd$var$slackIconOverlapStyles = (0, $8CUq3.xcss)({
    transform: 'translate(60px, 0)'
});
const $c0f59a78222868cd$var$IconComponent = ({ showModifierIcon: showModifierIcon })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
        xcss: $c0f59a78222868cd$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
                xcss: $c0f59a78222868cd$var$productIconStyles,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: [
                            $c0f59a78222868cd$var$absoluteStyles,
                            $c0f59a78222868cd$var$jiraIconOverlapStyles,
                            $c0f59a78222868cd$var$borderStyles
                        ],
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kaR8K.JiraIcon), {
                            size: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: [
                            $c0f59a78222868cd$var$absoluteStyles,
                            $c0f59a78222868cd$var$confluenceIconOverlapStyles,
                            $c0f59a78222868cd$var$borderStyles
                        ],
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1U4EY.ConfluenceIcon), {
                            size: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: [
                            $c0f59a78222868cd$var$absoluteStyles,
                            $c0f59a78222868cd$var$googleDriveIconOverlapStyles
                        ],
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $80Slk.GoogleDriveIcon), {})
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: [
                            $c0f59a78222868cd$var$absoluteStyles,
                            $c0f59a78222868cd$var$slackIconOverlapStyles
                        ],
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lwJQ0.SlackIcon), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $c0f59a78222868cd$var$moreButtonStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: formatMessage((0, $dgPZl.messages).more)
                })
            }),
            showModifierIcon ? /*#__PURE__*/ (0, $2OMIu.jsx)($c0f59a78222868cd$var$ModifierIcon, {}) : /*#__PURE__*/ (0, $2OMIu.jsx)($c0f59a78222868cd$var$ReturnIcon, {})
        ]
    });
};
const $c0f59a78222868cd$export$306c16563e2015b8 = (orgId, cloudId, query, primaryProduct)=>{
    const url = new URL(`${(0, $lKCn7.getDefaultAtlasBaseURL)(true)}/o/${orgId}/search`);
    url.searchParams.set('cloudId', cloudId);
    if (primaryProduct) url.searchParams.set('referrer', primaryProduct);
    if (query) url.searchParams.set('text', query);
    return url.toString();
};
const $c0f59a78222868cd$export$829d02f6cd9ab0ce = ({ orgId: orgId, cloudId: cloudId, showModifierIcon: showModifierIcon, actionSubjectId: actionSubjectId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { query: query, isLoading: isLoading } = (0, $2dI5H.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const activeProduct = getActiveProduct();
    const href = $c0f59a78222868cd$export$306c16563e2015b8(orgId, cloudId, query, primaryProduct?.id);
    const productName = activeProduct?.title;
    const defaultActionSubjectId = `${productName}AdvancedSearchLink`;
    const onAdvancedSearchClicked = (0, $5uXOq.useCallback)((e)=>{
        fireAnalyticsEvent((0, $3FqY6.onAdvancedSearchSelected)({
            trigger: (0, $8oG5R.getTrigger)(e),
            actionSubjectId: actionSubjectId || defaultActionSubjectId,
            isLoading: isLoading,
            newTab: true,
            isRovoCrossProductSearchLink: true
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        actionSubjectId,
        defaultActionSubjectId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.AdvancedSearchFooterLink), {
        href: href,
        onClick: onAdvancedSearchClicked,
        linkComponent: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hN1kQ.AdvancedSearchLink), {
                ...props,
                isKeyboardHighlighted: !!props.isKeyboardHighlighted,
                href: href,
                target: "_blank"
            }),
        contentLabel: formatMessage((0, $dgPZl.messages).extensible_advanced_search_cross_product_footer),
        returnKeyIconComponent: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($c0f59a78222868cd$var$IconComponent, {
                showModifierIcon: showModifierIcon
            })
    });
};

});
parcelRegister("1W52p", function(module, exports) {

$parcel$export(module.exports, "ReturnIconWithModifier", () => $ccc5d9bf7f88d6e3$export$74f31472c4e66c81);
$parcel$export(module.exports, "AdvancedSearchFooterLink", () => $ccc5d9bf7f88d6e3$export$3bd10e9d8677419f);
$parcel$export(module.exports, "AdvancedSearchFooter", () => $ccc5d9bf7f88d6e3$export$ad56be906d54f7e2);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cIQMR = parcelRequire("cIQMR");
var $fYvdU = parcelRequire("fYvdU");

var $26g7Y = parcelRequire("26g7Y");

var $2o8gl = parcelRequire("2o8gl");

var $8TPno = parcelRequire("8TPno");
var $hN1kQ = parcelRequire("hN1kQ");
var $dnt4h = parcelRequire("dnt4h");

var $2dI5H = parcelRequire("2dI5H");

var $7xoNc = parcelRequire("7xoNc");

var $8oG5R = parcelRequire("8oG5R");
var $3FqY6 = parcelRequire("3FqY6");
var $75NXP = parcelRequire("75NXP");

var $koVbs = parcelRequire("koVbs");

var $dgPZl = parcelRequire("dgPZl");

var $kv2Va = parcelRequire("kv2Va");

var $khXKC = parcelRequire("khXKC");

var $2k6eV = parcelRequire("2k6eV");

var $i5cPn = parcelRequire("i5cPn");

var $6ZsPS = parcelRequire("6ZsPS");

var $94iog = parcelRequire("94iog");

var $ll6QN = parcelRequire("ll6QN");

var $ib6Vt = parcelRequire("ib6Vt");

var $iGMUz = parcelRequire("iGMUz");
const $ccc5d9bf7f88d6e3$var$onKeyDown = (e, target)=>{
    if (e.key === 'Enter') {
        e.preventDefault();
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $ccc5d9bf7f88d6e3$var$onKeyDownWithShift = (e, target)=>{
    if (e.key === 'Enter' && e.shiftKey) {
        e.preventDefault();
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $ccc5d9bf7f88d6e3$export$74f31472c4e66c81 = ({ showModifierKey: showModifierKey })=>{
    const ModifierKeyIcon = window.navigator.userAgent.includes('Mac') ? (0, $ll6QN.CommandIcon) : (0, $ib6Vt.ControlIcon);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $khXKC.SearchFooterLabelWrapper), {
        children: [
            showModifierKey && /*#__PURE__*/ (0, $2OMIu.jsx)(ModifierKeyIcon, {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iGMUz.SquareReturnIcon), {})
        ]
    });
};
const $ccc5d9bf7f88d6e3$export$ec11565276b0198d = ({ isKeyboardHighlighted: isKeyboardHighlighted, showSearchOnEnter: showSearchOnEnter, filterByProductFooter: filterByProductFooter, squareReturnIcon: squareReturnIcon })=>{
    if (showSearchOnEnter) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $khXKC.SearchFooterLabelWrapper), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $khXKC.SearchFooterLabel), {
                children: "Shift"
            }),
            "+",
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cIQMR.ReturnIcon), {
                inverted: isKeyboardHighlighted
            })
        ]
    });
    if (squareReturnIcon) return /*#__PURE__*/ (0, $2OMIu.jsx)($ccc5d9bf7f88d6e3$export$74f31472c4e66c81, {
        showModifierKey: filterByProductFooter
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cIQMR.ReturnIcon), {
        inverted: isKeyboardHighlighted
    });
};
const $ccc5d9bf7f88d6e3$export$3bd10e9d8677419f = ({ href: href, searchIconLabel: searchIconLabel = '', contentLabel: contentLabel, onClick: onClick, filterByProductFooter: filterByProductFooter, showSearchOnEnter: showSearchOnEnter, squareReturnIcon: squareReturnIcon, linkComponent: linkComponent, returnKeyIconComponent: ReturnKeyIconComponent = $ccc5d9bf7f88d6e3$export$ec11565276b0198d })=>{
    const [isKeyboardHighlighted, ref] = (0, $fYvdU.useKeyboardNavigation)({
        onKeydownCallback: showSearchOnEnter ? $ccc5d9bf7f88d6e3$var$onKeyDownWithShift : $ccc5d9bf7f88d6e3$var$onKeyDown
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: ref,
        onClick: onClick,
        role: "none",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'flex',
            height: '100%',
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hN1kQ.AdvancedSearchLink), {
            href: href,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $khXKC.ContentWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8TPno.CenteredAdvancedSearchGroup), {
                        children: [
                            filterByProductFooter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2o8gl))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                label: searchIconLabel
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                label: searchIconLabel
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8TPno.AdvancedSearchContent), {
                                children: contentLabel
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)(ReturnKeyIconComponent, {
                    isKeyboardHighlighted: isKeyboardHighlighted,
                    showSearchOnEnter: showSearchOnEnter,
                    filterByProductFooter: filterByProductFooter,
                    squareReturnIcon: squareReturnIcon
                })
            ]
        })
    }));
};
const $ccc5d9bf7f88d6e3$export$de2cb7be8250c972 = ({ query: query, isLoading: isLoading, activeProduct: activeProduct, closeDialog: closeDialog, searchFooterLabel: searchFooterLabel, searchFooterLabelWithIcon: searchFooterLabelWithIcon, linkComponent: linkComponent, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', squareReturnIcon: squareReturnIcon = false, filterByProductFooter: filterByProductFooter = false, returnKeyIconComponent: returnKeyIconComponent })=>{
    const intl = (0, $koVbs.default)();
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const productName = activeProduct?.title;
    const productId = activeProduct?.id;
    const urlGenerator = activeProduct?.generateAdvancedSearchUrl || urlGeneratorForNoResultsScreen;
    const baseSearchUrl = filterByProductFooter ? `${urlGenerator(query)}&product=confluence` : urlGenerator(query);
    const advancedSearchUrl = query && productId === (0, $94iog.ProductKeys).Confluence ? (0, $7xoNc.addQuery)(baseSearchUrl, 'search_id', searchSessionId) : baseSearchUrl;
    const workspaces = activeProduct?.workspaces;
    const showSearchOnEnter = !!activeProduct?.showSearchOnEnter;
    const actionSubjectId = `${productName}AdvancedSearchLink`;
    const { resetSearchSession: resetSearchSession } = (0, $2k6eV.useSessionUserInput)();
    const searchLabel = searchFooterLabel || intl.formatMessage((0, $dgPZl.messages).extensible_advanced_search_footer);
    const advancedSearchContentLabel = searchFooterLabelWithIcon || searchLabel;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const onAdvancedSearchClicked = (0, $5uXOq.useCallback)((e)=>{
        if (!(0, $8oG5R.isNewTab)(e)) resetSearchSession();
        if (filterByProductFooter) closeDialog();
        fireAnalyticsEvent((0, $3FqY6.onAdvancedSearchSelected)({
            trigger: (0, $8oG5R.getTrigger)(e),
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: (0, $8oG5R.isNewTab)(e)
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        actionSubjectId,
        resetSearchSession,
        closeDialog,
        filterByProductFooter
    ]);
    if (workspaces && workspaces?.length > 1) {
        const workspacesWithAdvancedSearchLinks = workspaces.map((workspace)=>({
                product: productName || '',
                content: workspace.name,
                key: workspace.name,
                advancedSearchUrl: activeProduct?.generateAdvancedSearchUrl?.(query, workspace.baseUrl) || ''
            }));
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dnt4h.default), {
            workspaces: workspacesWithAdvancedSearchLinks,
            linkComponent: linkComponent,
            isLoading: isLoading,
            onClick: (_, e)=>{
                (0, $3FqY6.onAdvancedSearchSelected)({
                    actionSubjectId: actionSubjectId,
                    trigger: (0, $8oG5R.getTrigger)(e),
                    isLoading: isLoading,
                    newTab: (0, $8oG5R.isNewTab)(e)
                });
            }
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ccc5d9bf7f88d6e3$export$3bd10e9d8677419f, {
        href: advancedSearchUrl,
        searchIconLabel: searchLabel,
        contentLabel: advancedSearchContentLabel,
        onClick: onAdvancedSearchClicked,
        filterByProductFooter: filterByProductFooter,
        showSearchOnEnter: showSearchOnEnter,
        squareReturnIcon: squareReturnIcon,
        linkComponent: linkComponent,
        returnKeyIconComponent: returnKeyIconComponent
    });
};
const $ccc5d9bf7f88d6e3$export$ad56be906d54f7e2 = ({ ...rest })=>{
    const { query: query, isLoading: isLoading } = (0, $2dI5H.useQuery)();
    const { setIsExpanded: setIsExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const activeProduct = getActiveProduct();
    const closeDialog = (0, $5uXOq.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ccc5d9bf7f88d6e3$export$de2cb7be8250c972, {
        ...rest,
        query: query,
        isLoading: isLoading,
        activeProduct: activeProduct,
        closeDialog: closeDialog
    });
};

});
parcelRegister("dnt4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc824825d09983ba$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $aq7Ns = parcelRequire("aq7Ns");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $8oG5R = parcelRequire("8oG5R");
var $3FqY6 = parcelRequire("3FqY6");
var $75NXP = parcelRequire("75NXP");

var $k4hbD = parcelRequire("k4hbD");
const $fc824825d09983ba$var$MAX_PRIMARY_WORKSPACES = 5;
const $fc824825d09983ba$var$getActionSubjectIdForProduct = (product)=>{
    return `${product.toLowerCase()}AdvancedSearchLink`;
};
const $fc824825d09983ba$export$c1abbe883cc8875 = ({ workspaces: workspaces, linkComponent: linkComponent, onClick: onClick, isLoading: isLoading, intl: intl })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const links = workspaces.map((workspace)=>({
            content: workspace.content,
            key: workspace.key,
            href: workspace.advancedSearchUrl
        }));
    const label = intl.formatMessage((0, $k4hbD.messages).multi_site_advanced_search_label);
    const dropdownLabel = intl.formatMessage((0, $k4hbD.messages).multi_site_advanced_search_more_dropdown, {
        count: links.length - $fc824825d09983ba$var$MAX_PRIMARY_WORKSPACES
    });
    const onAdvancedSearchClicked = (0, $5uXOq.useCallback)(({ key: key }, e)=>{
        const workspace = workspaces.filter((w)=>w.key === key)[0];
        if (!workspace) return;
        fireAnalyticsEvent((0, $3FqY6.onMultiSiteAdvancedSearchSelected)({
            trigger: (0, $8oG5R.getTrigger)(e),
            actionSubjectId: $fc824825d09983ba$var$getActionSubjectIdForProduct(workspace.product),
            isLoading: isLoading,
            newTab: (0, $8oG5R.isNewTab)(e),
            destinationId: key,
            index: workspaces.map((w)=>w.key).indexOf(key)
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        workspaces
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aq7Ns.SearchFooterLinks), {
        linkComponent: linkComponent,
        onClick: (link, e)=>{
            onAdvancedSearchClicked(link, e);
            onClick && onClick(link.href, e);
        },
        label: label,
        dropdownTriggerLabel: dropdownLabel,
        links: links,
        maxPrimaryLinks: $fc824825d09983ba$var$MAX_PRIMARY_WORKSPACES
    });
};
var $fc824825d09983ba$export$2e2bcd8739ae039 = (0, $8RXs9.default)($fc824825d09983ba$export$c1abbe883cc8875);

});
parcelRegister("aq7Ns", function(module, exports) {

$parcel$export(module.exports, "SearchFooterLinks", () => $d20f170b0828d6a0$export$697ca8c8f8bb38fc);

var $2OMIu = parcelRequire("2OMIu");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $5uXOq = parcelRequire("5uXOq");

var $l5sRC = parcelRequire("l5sRC");

var $1N35P = parcelRequire("1N35P");

const $d20f170b0828d6a0$var$DropDownLinks = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8xlqK")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $d20f170b0828d6a0$var$DEFAULT_MAX_PRIMARY_LINKS = 5;
const $d20f170b0828d6a0$export$697ca8c8f8bb38fc = ({ label: label, links: links, dropdownTriggerLabel: dropdownTriggerLabel, onClick: onClick, linkComponent: linkComponent, maxPrimaryLinks: maxPrimaryLinks })=>{
    const primaryLinks = links.slice(0, maxPrimaryLinks || $d20f170b0828d6a0$var$DEFAULT_MAX_PRIMARY_LINKS);
    const dropdownLinks = links.slice(maxPrimaryLinks || $d20f170b0828d6a0$var$DEFAULT_MAX_PRIMARY_LINKS, links.length);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1N35P.SearchFooterLinksContainer), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1N35P.LabelContainer), {
                children: label
            }),
            primaryLinks.map((link)=>{
                const { key: key, href: href, content: content } = link;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1N35P.PrimaryButtonWrapper), {
                    onClick: (e)=>onClick && onClick(link, e),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1N35P.PrimaryButtonStyledLink), {
                        href: href,
                        linkComponent: linkComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                            content: content,
                            tag: (0, $l5sRC.ForwardedRefToolTipTag),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                                spacing: "compact",
                                tabIndex: -1,
                                children: content
                            })
                        })
                    })
                }, key);
            }),
            dropdownLinks && dropdownLinks.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($d20f170b0828d6a0$var$DropDownLinks, {
                    dropdownLinks: dropdownLinks,
                    dropdownTriggerLabel: dropdownTriggerLabel,
                    onClick: onClick,
                    linkComponent: linkComponent
                })
            }) : null
        ]
    });
};

});
parcelRegister("l5sRC", function(module, exports) {

$parcel$export(module.exports, "ForwardedRefToolTipTag", () => $aabad6bec7df30e0$export$349601f91196bc9c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1N35P = parcelRequire("1N35P");
const $aabad6bec7df30e0$export$349601f91196bc9c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1N35P.TruncatedTextDiv), {
        ...props,
        ref: ref
    }));

});
parcelRegister("1N35P", function(module, exports) {

$parcel$export(module.exports, "SearchFooterLinksContainer", () => $6c323b6c6c4e407f$export$636ae9b701e134a6);
$parcel$export(module.exports, "LabelContainer", () => $6c323b6c6c4e407f$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "TruncatedTextDiv", () => $6c323b6c6c4e407f$export$f060a0d7354d6f0f);
$parcel$export(module.exports, "PrimaryButtonWrapper", () => $6c323b6c6c4e407f$export$70f18730b5e534f8);
$parcel$export(module.exports, "PrimaryButtonStyledLink", () => $6c323b6c6c4e407f$export$c0a945c47b321ccb);
$parcel$export(module.exports, "DropownMenuLink", () => $6c323b6c6c4e407f$export$62368ee747a81340);


var $k5uoT = parcelRequire("k5uoT");

var $kCMvS = parcelRequire("kCMvS");

var $3JZ8k = parcelRequire("3JZ8k");

var $bWGt6 = parcelRequire("bWGt6");
function $6c323b6c6c4e407f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6c323b6c6c4e407f$export$636ae9b701e134a6 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e17810te5"
})({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'start',
    flexDirection: 'row',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}`,
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $3JZ8k.dialogWidth),
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
});
const $6c323b6c6c4e407f$export$f5ae33f1b01a6402 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e17810te4"
})({
    name: "1qp6hzm",
    styles: "margin-right:var(--ds-space-050, 4px);flex-shrink:0"
});
const $6c323b6c6c4e407f$export$f060a0d7354d6f0f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e17810te3"
})({
    name: "l8l8b8",
    styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis"
});
const $6c323b6c6c4e407f$export$70f18730b5e534f8 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e17810te2"
})({
    name: "7bnap7",
    styles: "flex:1 1 0;overflow:hidden;max-width:max-content;margin-right:var(--ds-space-025, 2px)"
});
const $6c323b6c6c4e407f$export$c0a945c47b321ccb = /*#__PURE__*/ (0, $bWGt6.default)((0, $kCMvS.Link), {
    target: "e17810te1"
})({
    display: 'flex',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $k5uoT.borderRadius)()}px`,
    transitionDuration: '0.2s',
    transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:focus': {
        outline: 'none',
        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`} inset`
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
const $6c323b6c6c4e407f$export$62368ee747a81340 = /*#__PURE__*/ (0, $bWGt6.default)((0, $kCMvS.Link), {
    target: "e17810te0"
})({
    display: 'block',
    position: 'relative',
    '&:focus': {
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
        outlineOffset: '-2px'
    },
    '&:hover': {
        textDecoration: 'none'
    }
});

});


parcelRegister("8xlqK", function(module, exports) {

let $6372076d2568109a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6372076d2568109a$var$load("9p9Qp").then(()=>parcelRequire('eKvJc'));

});



parcelRegister("7xoNc", function(module, exports) {

$parcel$export(module.exports, "addQuery", () => $c9245256a1dee5dd$export$46ffbef61eff3d00);
$parcel$export(module.exports, "addQueryParams", () => $c9245256a1dee5dd$export$cbc5b385481fb319);
const $c9245256a1dee5dd$export$46ffbef61eff3d00 = (url, key, unencodedValue)=>{
    return $c9245256a1dee5dd$export$cbc5b385481fb319(url, {
        [key]: unencodedValue
    });
};
const $c9245256a1dee5dd$export$cbc5b385481fb319 = (url, params)=>{
    if (!url) return url;
    const sanitisedUrl = url.endsWith('?') || url.endsWith('&') ? url.slice(0, url.length - 1) : url;
    const paramsString = Object.entries(params).reduce((rest, [key, unencodedValue])=>{
        if (!key) return rest;
        const nextPart = `${encodeURIComponent(key)}=${encodeURIComponent(unencodedValue)}`;
        if (rest) return `${rest}&${nextPart}`;
        return nextPart;
    }, '');
    if (!paramsString) return url;
    // If it has a query string already
    if (sanitisedUrl.includes('?')) return `${sanitisedUrl}&${paramsString}`;
    return `${sanitisedUrl}?${paramsString}`;
};

});

parcelRegister("dgPZl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a8414778ae08dd8c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a8414778ae08dd8c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Extensible
	 */ extensible_advanced_search_footer: {
        id: 'extensible_search_dialog.advanced_search',
        defaultMessage: 'Advanced search',
        description: 'If the user has not passed any label for the footer then the footer in the dialog leads to the advanced search of the product.'
    },
    extensible_advanced_search_cross_product_footer: {
        id: 'extensible_search_dialog.advanced_search_all_apps',
        defaultMessage: 'Search all apps',
        description: 'Label for footer link that redirects to cross product advanced search'
    },
    extensible_connect_to: {
        id: 'extensible_search_dialog.connect_to',
        defaultMessage: 'Connect to',
        description: 'When the user has not connected a third party app, they are prompted to connect the third party app e.g. "Connect to Google Drive".'
    },
    extensible_connect: {
        id: 'extensible_search_dialog.connect',
        defaultMessage: 'Connect',
        description: 'The text shown on the button to connect a third party app'
    },
    more: {
        id: 'extensible_search_dialog.more',
        defaultMessage: '+ more',
        description: 'There are more products that can be searched in Rovo.'
    }
});

});

parcelRegister("khXKC", function(module, exports) {

$parcel$export(module.exports, "ContentWrapper", () => $ad3302c1ee9eacf9$export$6ce170286acaa8d3);
$parcel$export(module.exports, "SearchFooterLabelWrapper", () => $ad3302c1ee9eacf9$export$85cc5ece3620f7ef);
$parcel$export(module.exports, "SearchFooterLabel", () => $ad3302c1ee9eacf9$export$db59656b68ced4b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
function $ad3302c1ee9eacf9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad3302c1ee9eacf9$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "er9v89y2"
})({
    name: "15currb",
    styles: "display:flex;height:100%"
});
const $ad3302c1ee9eacf9$export$85cc5ece3620f7ef = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "er9v89y1"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    gap: "var(--ds-space-025, 2px)",
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`
});
const $ad3302c1ee9eacf9$export$db59656b68ced4b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "er9v89y0"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    padding: `0px ${"var(--ds-space-025, 2px)"}`,
    borderRadius: '4px'
});

});

parcelRegister("94iog", function(module, exports) {

$parcel$export(module.exports, "ProductKeys", () => $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gGW0q = parcelRequire("gGW0q");

var $b2Pj5 = parcelRequire("b2Pj5");

var $VSDnB = parcelRequire("VSDnB");

var $8Xs9r = parcelRequire("8Xs9r");

var $k4hbD = parcelRequire("k4hbD");

var $c59Mn = parcelRequire("c59Mn");

var $23vLA = parcelRequire("23vLA");

var $9fSwv = parcelRequire("9fSwv");

var $hyCj5 = parcelRequire("hyCj5");

var $7ttuB = parcelRequire("7ttuB");

var $il5K0 = parcelRequire("il5K0");

var $lYkqd = parcelRequire("lYkqd");

var $VfjmV = parcelRequire("VfjmV");

var $7bjp7 = parcelRequire("7bjp7");

var $dtzJn = parcelRequire("dtzJn");

var $7VoGI = parcelRequire("7VoGI");

var $bUT2o = parcelRequire("bUT2o");

var $j97IK = parcelRequire("j97IK");

var $3HoVl = parcelRequire("3HoVl");

var $hNXQY = parcelRequire("hNXQY");
const $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c = {
    Confluence: 'confluence',
    Atlas: 'townsquare'
};
const $a84b62e2bbdc746d$export$a55448378aa900a7 = ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ttuB.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b2Pj5.EnlargedSearchResultContent), {
            ...searchResult,
            isKeyboardHighlighted: isKeyboardHighlighted,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(searchResult.icon) ? searchResult.icon : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {})
        })
    });
};
const $a84b62e2bbdc746d$export$1763eeb490def9b = ({ onRetry: onRetry, linkComponent: linkComponent, confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, onPreQueryErrorCallback: onPreQueryErrorCallback, cloudId: cloudId, orgId: orgId, primaryProduct: primaryProduct })=>{
    const { user: user } = (0, $7VoGI.useUserContext)();
    const features = (0, $hNXQY.useFeaturesContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const appendAnalyticsQueryParams = (0, $3HoVl.useQueryParams)();
    const isEnhancedSearchAnalyticsEnabled = (0, $VSDnB.fg)('cc_page_experiences_enhanced_search_analytics_conf');
    const appendQueryParams = isEnhancedSearchAnalyticsEnabled && primaryProduct === 'confluence' ? appendAnalyticsQueryParams : undefined;
    const preQueryItemSupplier = (0, $gGW0q.useQuickFindItemSupplier)({
        confCloudClient: confCloudClient,
        aggAbsoluteUrl: aggAbsoluteUrl,
        markErrorAsHandled: onPreQueryErrorCallback,
        itemRenderer: $a84b62e2bbdc746d$export$a55448378aa900a7,
        recentContentResultMapper: (0, $il5K0.quickFindRecentItemResultMapper),
        recentSpaceResultMapper: (0, $lYkqd.quickFindRecentSpaceResultMapper),
        userId: user.id,
        cloudId: cloudId
    });
    // This currently isn't being used for results fetching or rendering. It is
    // only being used to create an array of sections which are then used for
    // product registration. After product registration, these scopes are then
    // used to call the experiment endpoint, for this reason they need to be
    // valid scopes for each product.
    const defaultSections = (0, $5uXOq.useMemo)(()=>{
        switch(primaryProduct){
            case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Confluence:
                return [
                    {
                        id: 'confluence.page',
                        title: ''
                    }
                ];
            case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Atlas:
                return [
                    {
                        id: 'townsquare.goal',
                        title: ''
                    }
                ];
            default:
                return [];
        }
    }, [
        primaryProduct
    ]);
    const { backendExperiment: backendExperiment } = (0, $j97IK.useExperiments)();
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const quickFindPeopleAndTeamsResultMapper = (0, $VfjmV.getQuickFindPeopleAndTeamsResultMapper)(primaryProduct, orgId || '', cloudId);
    const quickFindPostQueryItemSupplier = (0, $gGW0q.useQuickFindPostQueryItemSupplier)({
        cloudId: cloudId,
        resultRenderer: $a84b62e2bbdc746d$export$a55448378aa900a7,
        confluenceResultMapper: (0, $dtzJn.quickFindConfluenceContentMapper),
        atlasResultMapper: (0, $bUT2o.quickFindAtlasContentMapper),
        spaceResultMapper: (0, $7bjp7.quickFindConfluenceSpaceMapper),
        peopleAndTeamsResultMapper: quickFindPeopleAndTeamsResultMapper,
        sectionTitle: formatMessage((0, $c59Mn.messages).quick_find_results_section),
        userId: user.id,
        orgId: orgId,
        aggAbsoluteUrl: aggAbsoluteUrl,
        primaryProduct: primaryProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId
            }))
    });
    const noResultsPostQueryItemSupplier = (0, $5uXOq.useCallback)(()=>Promise.resolve((0, $23vLA.EMPTY_SEARCH_ITEMS)), []);
    const postQueryItemSupplier = features?.quickFind?.postQueryDisabled ? noResultsPostQueryItemSupplier : quickFindPostQueryItemSupplier;
    // TODO: baseUrl is a holdover from QS and not needed in QF
    const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, baseUrl, usage)=>{
        let url = '';
        const params = new URLSearchParams();
        const trimmedQuery = query.trim();
        if (trimmedQuery) params.append('text', trimmedQuery);
        if (primaryProduct === $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Confluence) {
            url = '/wiki/search/';
            if (usage === 'onInputEnterModified') params.append('product', 'confluence');
        } else if (orgId && primaryProduct === $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Atlas) {
            url = `/o/${orgId}/search/`;
            params.append('cloudId', cloudId);
        }
        // URLSearchParams's toString will do encode special characters, however spaces
        // are encoded as +. We need to replace them with %20 to match existing behaviour.
        url += `?${params.toString()}`;
        url = url.replace(/\+/g, '%20');
        return url;
    }, [
        cloudId,
        orgId,
        primaryProduct
    ]);
    const title = (0, $5uXOq.useMemo)(()=>{
        switch(primaryProduct){
            case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Confluence:
                return formatMessage((0, $k4hbD.messages).confluence_tab_label);
            case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Atlas:
                return formatMessage((0, $k4hbD.messages).atlas_tab_label);
            default:
                return '';
        }
    }, [
        formatMessage,
        primaryProduct
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        permissionSupplier: ()=>Promise.resolve(defaultSections.map((s)=>s.id)),
        sections: defaultSections,
        id: primaryProduct,
        title: title,
        order: 0,
        expandedStateInputPlaceholder: formatMessage((0, $c59Mn.messages).quick_find_search_input_placeholder),
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier,
        onRetry: onRetry,
        ResultRenderer: (0, $9fSwv.QuickFindResultRenderer),
        SearchItemsTransformer: (0, $hyCj5.QuickFindConfluenceTransformer),
        isPrefetchingEnabled: true,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        searchFooterLabel: 'Search your organization',
        linkComponent: linkComponent,
        appendQueryParams: appendQueryParams
    });
};

});
parcelRegister("gGW0q", function(module, exports) {

$parcel$export(module.exports, "RECENT_ITEMS_SECTION_ID", () => $127163fa0d7261bb$export$9747eb11a16f4445);
$parcel$export(module.exports, "RECENT_SPACES_SECTION_ID", () => $127163fa0d7261bb$export$3813b30107e5b323);
$parcel$export(module.exports, "useQuickFindItemSupplier", () => $127163fa0d7261bb$export$ec546060f7cdc293);
$parcel$export(module.exports, "CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID", () => $127163fa0d7261bb$export$7b0766a033869f00);
$parcel$export(module.exports, "useQuickFindPostQueryItemSupplier", () => $127163fa0d7261bb$export$f872504428bf2e7e);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $au661 = parcelRequire("au661");

var $aCZVj = parcelRequire("aCZVj");

var $jovPR = parcelRequire("jovPR");

var $fZ270 = parcelRequire("fZ270");

var $eXMAG = parcelRequire("eXMAG");
const $127163fa0d7261bb$var$INCLUDED_PRODUCTS = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
// To filter out Confluence comment results - although query does
// not include comment type it is still returning comment results
const $127163fa0d7261bb$var$INCLUDED_OBJECT_TYPES = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED = 200;
const $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED = 10;
const $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED = 7;
const $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED = 3;
const $127163fa0d7261bb$var$POST_QUERY_MAX_CONTENTS = 7;
const $127163fa0d7261bb$var$POST_QUERY_MAX_SPACES = 1;
const $127163fa0d7261bb$export$9747eb11a16f4445 = 'recent-items';
const $127163fa0d7261bb$export$3813b30107e5b323 = 'recent-spaces';
const $127163fa0d7261bb$export$ec546060f7cdc293 = ({ confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, markErrorAsHandled: markErrorAsHandled, itemRenderer: itemRenderer, recentContentResultMapper: recentContentResultMapper, recentSpaceResultMapper: recentSpaceResultMapper, userId: userId, cloudId: cloudId })=>{
    return (0, $5uXOq.useCallback)(async ()=>{
        const getSections = ({ recentContents: recentContents, recentSpaces: recentSpaces })=>({
                sections: [
                    {
                        id: $127163fa0d7261bb$export$9747eb11a16f4445,
                        title: '',
                        searchResults: recentContents,
                        resultLimit: $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED,
                        resultRenderer: itemRenderer
                    },
                    {
                        id: $127163fa0d7261bb$export$3813b30107e5b323,
                        title: '',
                        searchResults: recentSpaces,
                        resultLimit: $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED,
                        resultRenderer: itemRenderer
                    }
                ]
            });
        if (!userId) return getSections({
            recentContents: [],
            recentSpaces: []
        });
        const recentActivitiesPromise = (0, $aCZVj.recentActivitiesQuery)({
            variables: {
                filteredProducts: $127163fa0d7261bb$var$INCLUDED_PRODUCTS,
                filteredObjectTypes: (0, $VSDnB.fg)('smartlinks-qf-recents') ? $127163fa0d7261bb$var$INCLUDED_OBJECT_TYPES : $127163fa0d7261bb$var$INCLUDED_OBJECT_TYPES.filter((type)=>type !== 'remote-link'),
                filteredRootContainerIds: [
                    `ari:cloud:platform::site/${cloudId}`,
                    `ari:cloud:townsquare::site/${cloudId}`
                ],
                itemsLimit: $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const recentSpacesPromise = confCloudClient ? confCloudClient.query({
            query: (0, $au661.QuickFindSpacesQuery),
            variables: {
                spaceLimit: $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED
            }
        }) : Promise.resolve(undefined);
        const { recentContents: recentContents, recentSpaces: recentSpaces } = await Promise.all([
            recentActivitiesPromise,
            recentSpacesPromise
        ]).then(([recentItemsResponse, recentSpacesResponse])=>{
            const recentContents = recentItemsResponse?.data?.activity?.myActivity?.all.edges.filter((edge)=>edge?.node?.object?.data).map(recentContentResultMapper) || [];
            const recentSpacesResults = (0, $eXMAG.parsePartialApolloResults)(recentSpacesResponse?.data?.myVisitedSpaces, recentSpacesResponse?.errors);
            const recentSpaces = recentSpacesResults?.nodes?.spaces?.map(recentSpaceResultMapper) || [];
            return {
                recentContents: recentContents,
                recentSpaces: recentSpaces
            };
        }).catch((err)=>{
            markErrorAsHandled && markErrorAsHandled(err);
            throw err;
        });
        return getSections({
            recentContents: recentContents,
            recentSpaces: recentSpaces
        });
    }, [
        confCloudClient,
        userId,
        markErrorAsHandled,
        itemRenderer,
        recentContentResultMapper,
        recentSpaceResultMapper,
        aggAbsoluteUrl,
        cloudId
    ]);
};
const $127163fa0d7261bb$var$CONFLUENCE_CONTENT_ENTITIES = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database'
];
const $127163fa0d7261bb$var$ATLAS_ENTITIES = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
const $127163fa0d7261bb$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID = 'townsquare.project,goal,tag';
const $127163fa0d7261bb$export$7b0766a033869f00 = 'confluence.page,blogpost,attachment';
const $127163fa0d7261bb$export$47653725e5b469bb = 'space';
const $127163fa0d7261bb$export$f80b16ba1f3b0d5c = 'people-and-teams';
const $127163fa0d7261bb$var$ProductKeys = {
    Confluence: 'confluence',
    Atlas: 'townsquare'
};
const $127163fa0d7261bb$export$f872504428bf2e7e = ({ aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, resultRenderer: resultRenderer, confluenceResultMapper: confluenceResultMapper, atlasResultMapper: atlasResultMapper, spaceResultMapper: spaceResultMapper, peopleAndTeamsResultMapper: peopleAndTeamsResultMapper, sectionTitle: sectionTitle, userId: userId, orgId: orgId, primaryProduct: primaryProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers })=>{
    const intl = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)(async (args)=>{
        const { query: query, analyticsInfo: analyticsInfo } = args;
        const getPeopleAndTeamsResults = async (query, userId, cloudId)=>{
            if (!userId || !cloudId) return [];
            const peopleResults = await (0, $fZ270.getUserAndTeamSearchResults)({
                query: query,
                cloudId: cloudId,
                principalId: userId || '',
                orgId: orgId || '',
                intl: intl
            }).catch((e)=>{
                console.error(e);
                return [];
            });
            return peopleResults.map(peopleAndTeamsResultMapper);
        };
        const getConfluenceResults = async (query, cloudId)=>{
            const contentQueryResults = await (0, $jovPR.quickFindSearchQuery)({
                variables: {
                    query: query,
                    cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                    resultsLimit: $127163fa0d7261bb$var$POST_QUERY_MAX_CONTENTS,
                    spaceLimit: $127163fa0d7261bb$var$POST_QUERY_MAX_SPACES,
                    includeAncestors: true,
                    contentEntities: $127163fa0d7261bb$var$CONFLUENCE_CONTENT_ENTITIES,
                    confluenceFilters: {
                        titleMatchOnly: true
                    },
                    searchSessionId: analyticsInfo?.searchSessionId,
                    queryVersion: analyticsInfo?.queryVersion,
                    includeSpaces: true,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const contentResponse = contentQueryResults.data?.search.results?.edges || [];
            const contentResults = contentResponse.map(confluenceResultMapper);
            const spaceResponse = contentQueryResults.data?.search.spaces?.edges || [];
            const spaceResults = spaceResponse.map(spaceResultMapper);
            return {
                contentResults: contentResults,
                spaceResults: spaceResults
            };
        };
        const getAtlasResults = async (query, analyticsInfo)=>{
            const contentQueryResults = await (0, $jovPR.quickFindSearchQuery)({
                variables: {
                    query: query,
                    cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                    contentEntities: $127163fa0d7261bb$var$ATLAS_ENTITIES,
                    confluenceFilters: {
                        titleMatchOnly: true
                    },
                    resultsLimit: $127163fa0d7261bb$var$POST_QUERY_MAX_CONTENTS,
                    spaceLimit: $127163fa0d7261bb$var$POST_QUERY_MAX_SPACES,
                    includeAncestors: false,
                    searchSessionId: analyticsInfo?.searchSessionId,
                    queryVersion: analyticsInfo?.queryVersion,
                    includeSpaces: false,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const contentResponse = contentQueryResults.data?.search.results?.edges || [];
            const contentResults = contentResponse.map(atlasResultMapper);
            return {
                contentResults: contentResults,
                spaceResults: []
            };
        };
        const getResults = (product)=>{
            switch(product){
                case $127163fa0d7261bb$var$ProductKeys.Confluence:
                    return getConfluenceResults(query, cloudId);
                case $127163fa0d7261bb$var$ProductKeys.Atlas:
                    return getAtlasResults(query, analyticsInfo);
                default:
                    return getConfluenceResults(query, cloudId);
            }
        };
        const { contentResults: contentResults, spaceResults: spaceResults } = await getResults(primaryProduct);
        const peopleAndTeamsResults = await getPeopleAndTeamsResults(query, userId, cloudId);
        const getContentSectionId = (product)=>{
            switch(product){
                case $127163fa0d7261bb$var$ProductKeys.Confluence:
                    return $127163fa0d7261bb$export$7b0766a033869f00;
                case $127163fa0d7261bb$var$ProductKeys.Atlas:
                    return $127163fa0d7261bb$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID;
                default:
                    return $127163fa0d7261bb$export$7b0766a033869f00;
            }
        };
        return {
            sections: [
                {
                    id: getContentSectionId(primaryProduct),
                    title: sectionTitle,
                    searchResults: contentResults,
                    resultRenderer: resultRenderer
                },
                {
                    id: $127163fa0d7261bb$export$47653725e5b469bb,
                    searchResults: spaceResults,
                    title: !contentResults.length ? sectionTitle : '',
                    resultRenderer: resultRenderer
                },
                {
                    id: $127163fa0d7261bb$export$f80b16ba1f3b0d5c,
                    searchResults: peopleAndTeamsResults,
                    title: !contentResults.length && !spaceResults.length ? sectionTitle : '',
                    resultRenderer: resultRenderer
                }
            ]
        };
    }, [
        cloudId,
        resultRenderer,
        confluenceResultMapper,
        atlasResultMapper,
        spaceResultMapper,
        peopleAndTeamsResultMapper,
        sectionTitle,
        intl,
        orgId,
        userId,
        aggAbsoluteUrl,
        primaryProduct,
        experimentId,
        shadowExperimentId,
        experimentLayers
    ]);
};

});
parcelRegister("au661", function(module, exports) {

$parcel$export(module.exports, "QuickFindSpacesQuery", () => $04ec88293f9b8f2d$export$9af2898b36d6a2cf);

var $5cllN = parcelRequire("5cllN");
const $04ec88293f9b8f2d$var$QuickFindSpacesFragment = (0, $5cllN.default)`
	fragment QuickFindSpacesFragment on Space {
		id
		key
		name
		icon {
			path
		}
		links {
			webui
		}
	}
`;
const $04ec88293f9b8f2d$export$9af2898b36d6a2cf = (0, $5cllN.default)`
	query QuickFindSpacesQuery($spaceLimit: Int!) {
		myVisitedSpaces(limit: $spaceLimit) {
			nodes {
				spaces {
					...QuickFindSpacesFragment
				}
			}
		}
	}
	${$04ec88293f9b8f2d$var$QuickFindSpacesFragment}
`;

});

parcelRegister("aCZVj", function(module, exports) {

$parcel$export(module.exports, "recentActivitiesQuery", () => $1a1eb1715e55a592$export$ba6bff93c920ff4a);

var $hIfEM = parcelRequire("hIfEM");

const $1a1eb1715e55a592$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $hIfEM.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $95c01b8f6a4d40eb$export$8a781e50bcd90a75),
        operationName: $95c01b8f6a4d40eb$export$5db520940cf00715
    });
};

});
parcelRegister("hIfEM", function(module, exports) {

$parcel$export(module.exports, "fetchAgg", () => $29ade44762956c6d$export$f49dad89491f6bf2);

var $dS9cn = parcelRequire("dS9cn");
const $29ade44762956c6d$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $29ade44762956c6d$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $29ade44762956c6d$var$DEFAULT_GRAPHQL_ENDPOINT, headers: headers }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    return (0, $dS9cn.utils).requestService({
        url: url
    }, options);
}

});

const $95c01b8f6a4d40eb$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $95c01b8f6a4d40eb$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $95c01b8f6a4d40eb$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $95c01b8f6a4d40eb$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $95c01b8f6a4d40eb$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $95c01b8f6a4d40eb$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
  }
`;
const $95c01b8f6a4d40eb$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    statusCategory {
      name,
      colorName
    }
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$95c01b8f6a4d40eb$var$JiraSingleIssueLineTextFieldFragment}
`;
const $95c01b8f6a4d40eb$var$GraphDocumentFragment = `
  fragment GraphDocumentFragment on ExternalDocument {
    id
    type {
        category
    }
    displayName
    parent @optIn(to: "ExternalDataDepotQueryV2"){
        ... on ExternalDocument {
            displayName
        }
    }
    url
    provider {
        providerId
    }
  }
`;
const $95c01b8f6a4d40eb$var$GraphRemoteLinkFragment = `
  fragment GraphRemoteLinkFragment on ExternalRemoteLink {
	  id
		displayName
		category @optIn(to: "ExternalDataDepotQueryV2")
		url
    provider {
			providerId
		}
  }
`;
const $95c01b8f6a4d40eb$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $95c01b8f6a4d40eb$export$8a781e50bcd90a75 = `
  query ${$95c01b8f6a4d40eb$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
        ) {
          __typename
          edges {
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                  ...GraphDocumentFragment
									...GraphRemoteLinkFragment
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$95c01b8f6a4d40eb$var$ConfluencePageFragment}
  ${$95c01b8f6a4d40eb$var$ConfluenceBlogPostFragment}
  ${$95c01b8f6a4d40eb$var$ConfluenceWhiteboardFragment}
  ${$95c01b8f6a4d40eb$var$AtlasProjectFragment}
  ${$95c01b8f6a4d40eb$var$AtlasGoalFragment}
  ${$95c01b8f6a4d40eb$var$JiraIssueFragment}
  ${$95c01b8f6a4d40eb$var$GraphDocumentFragment}
	${$95c01b8f6a4d40eb$var$GraphRemoteLinkFragment}
`;


parcelRegister("jovPR", function(module, exports) {

$parcel$export(module.exports, "quickFindSearchQuery", () => $fef551ab6609ace3$export$ac350a1cbaa2773a);

var $hIfEM = parcelRequire("hIfEM");

const $fef551ab6609ace3$export$ac350a1cbaa2773a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $hIfEM.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $48743fafd26957e0$export$5dd443f88002bca3),
        operationName: $48743fafd26957e0$export$5db520940cf00715
    });
};

});
const $48743fafd26957e0$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    __typename
    key
  }
}
`;
const $48743fafd26957e0$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    __typename
    key
  }
}
`;
const $48743fafd26957e0$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
  __typename
  lastModified
  iconCssClass
  space {
    __typename
    id
    name
  }
  confluenceEntity @include(if: $includeAncestors) {
    ... on ConfluencePage {
      __typename
      ancestors {
        __typename
        id
        title
      }
    }
  }
}`;
const $48743fafd26957e0$export$5db520940cf00715 = 'QuickFindSearchQuery';
const $48743fafd26957e0$export$5dd443f88002bca3 = `
  query ${$48743fafd26957e0$export$5db520940cf00715}(
    $query: String!
    $cloudIdARI: String!
    $resultsLimit: Int!
    $spaceLimit: Int!
    $contentEntities: [String!]!
    $confluenceFilters: SearchConfluenceFilter
    $queryVersion: Int
    $searchSessionId: String
    $includeSpaces: Boolean!
    $includeAncestors: Boolean!
    $experimentId: String
    $shadowExperimentId: String
    $experimentLayers: [SearchExperimentLayer]
  ) {
    search {
      results: search(
        experience: "quick-find"
        query: $query
        first: $resultsLimit
        filters: {
          entities: $contentEntities
          locations: [$cloudIdARI]
          confluenceFilters: $confluenceFilters
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
        experimentContext: {
          experimentId: $experimentId
          shadowExperimentId: $shadowExperimentId
          experimentLayers: $experimentLayers
        }
      ) {
        __typename
        edges {
          __typename
          node {
            id
            title
            url
            type
            iconUrl
            __typename
            ${$48743fafd26957e0$var$SearchConfluencePageBlogAttachment}
            ${$48743fafd26957e0$var$SearchResultAtlasProject}
            ${$48743fafd26957e0$var$SearchResultAtlasGoal}
          }
        }
        abTest {
          __typename
          abTestId
          controlId
          experimentId
        }
        totalCount
      }
      spaces: search(
        experience: "searchDialog"
        query: $query
        first: $spaceLimit
        filters: {
          entities: ["ati:cloud:confluence:space"]
          locations: [$cloudIdARI]
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
      ) @include(if: $includeSpaces) {
        __typename
        edges {
          __typename
          node {
            ... on SearchConfluenceSpace {
              __typename
              id
              key
              title
              type
              url
              iconPath
            }
          }
        }
      }
    }
  }
`;


parcelRegister("fZ270", function(module, exports) {

$parcel$export(module.exports, "getUserAndTeamSearchResults", () => $5d362ef29a27e34b$export$69624d2b3a5a261b);

var $3Q8Js = parcelRequire("3Q8Js");
const $5d362ef29a27e34b$var$MAX_RESULTS_USERS = 2;
const $5d362ef29a27e34b$export$6e670d76ab78fcb3 = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $5d362ef29a27e34b$export$69624d2b3a5a261b = ({ query: query, cloudId: cloudId, orgId: orgId, principalId: principalId = 'Context', intl: intl })=>(0, $3Q8Js.default)({
        searchQueryFilter: $5d362ef29a27e34b$export$6e670d76ab78fcb3,
        includeUsers: true,
        includeGroups: false,
        includeTeams: true,
        context: {
            contextType: 'confluence_search-dialog',
            principalId: principalId,
            productKey: 'confluence',
            siteId: cloudId,
            organizationId: orgId
        },
        maxNumberOfResults: $5d362ef29a27e34b$var$MAX_RESULTS_USERS,
        query: query
    }, intl);

});
parcelRegister("3Q8Js", function(module, exports) {

$parcel$export(module.exports, "default", () => $94c7434acb15702b$export$2e2bcd8739ae039);

var $f5wjp = parcelRequire("f5wjp");

var $lrQGi = parcelRequire("lrQGi");
const $94c7434acb15702b$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $lrQGi.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $f5wjp.transformUsers)(response, intl));
};
var $94c7434acb15702b$export$2e2bcd8739ae039 = $94c7434acb15702b$var$getUserRecommendations;

});
parcelRegister("f5wjp", function(module, exports) {

$parcel$export(module.exports, "transformUsers", () => $ba878881f0891deb$export$fb8c90bfc4beaa59);


var $Jzvpo = parcelRequire("Jzvpo");

var $60uqU = parcelRequire("60uqU");
const $ba878881f0891deb$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $Jzvpo.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $60uqU.EntityType).GROUP ? (0, $Jzvpo.messages).guestGroupLozengeTooltip : (0, $Jzvpo.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $Jzvpo.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $ba878881f0891deb$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $60uqU.EntityType).USER) {
        const user = item;
        const lozenge = $ba878881f0891deb$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $f93312f7d4958f08$export$50042ec1d2e00e63) : (0, $f93312f7d4958f08$export$8436e53e45ffe15b),
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $60uqU.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $f93312f7d4958f08$export$26bc40b960693765),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified
        };
    }
    if (type === (0, $60uqU.EntityType).GROUP) {
        const group = item;
        const lozenge = $ba878881f0891deb$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $f93312f7d4958f08$export$d460f747b73abb10),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $ba878881f0891deb$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$ba878881f0891deb$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);

});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';

parcelRegister("Jzvpo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0fd0da3298001d54$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0fd0da3298001d54$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("60uqU", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $e9a061fa52eafd84$export$8eda7e02f8f033b2);
var $e9a061fa52eafd84$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});

});


parcelRegister("lrQGi", function(module, exports) {

$parcel$export(module.exports, "config", () => $8648972412521072$export$e506a1d27d1eaa20);
const $8648972412521072$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};

});



parcelRegister("eXMAG", function(module, exports) {

$parcel$export(module.exports, "parsePartialApolloResults", () => $d02099fd0b809c29$export$e877f985e0128c5e);

var $eiiEv = parcelRequire("eiiEv");
function $d02099fd0b809c29$export$e877f985e0128c5e(data, graphQLErrors) {
    // Return data if there are no errors
    if (!graphQLErrors?.length) return data;
    // Return data if there are errors, but there is also partial data
    if (graphQLErrors?.length && data) {
        console.warn('Returning partial data despite GraphQL errors: ', graphQLErrors);
        return data;
    }
    // Throw an exception only if there are errors and NO data
    throw new (0, $eiiEv.GraphQLNoResultsWithErrorResponseError)(graphQLErrors);
}

});
parcelRegister("eiiEv", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsWithErrorResponseError", () => $9ff2f5ddeb9ffe12$export$beb638af7aef4c03);
class $9ff2f5ddeb9ffe12$export$beb638af7aef4c03 extends Error {
    constructor(graphQLErrors){
        super();
        this.name = 'GraphQLNoResultsWithErrorResponseError';
        this.graphQLErrors = graphQLErrors;
        this.message = 'GraphQL returned errors and no results';
    }
}

});



parcelRegister("b2Pj5", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultContent", () => $deff8b6fcada06c8$export$171a2a7e5a778acc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $54Fwx = parcelRequire("54Fwx");
var $8FPdi = parcelRequire("8FPdi");

var $rpOSY = parcelRequire("rpOSY");

var $ousew = parcelRequire("ousew");

var $8Lig8 = parcelRequire("8Lig8");

var $42CjB = parcelRequire("42CjB");

var $eiKpf = parcelRequire("eiKpf");
const $deff8b6fcada06c8$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const [isHover, setIsHover] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const isActive = isKeyboardHighlighted || isHover;
    const showReturnIcon = (0, $5uXOq.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
        isKeyboardHighlighted,
        returnIcon,
        isRecentSearch
    ]);
    const showRemoveIcon = (0, $5uXOq.useMemo)(()=>isRecentSearch && isActive, [
        isRecentSearch,
        isActive
    ]);
    const showAdditionalMeta = (0, $5uXOq.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
        displayAdditionalMetaWhenHighlightedOnly,
        isActive,
        additionalMeta
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.EnlargedResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedIconContainer), {
                children: icon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.EnlargedResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            typeof title === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                                    title: title,
                                    className: "SearchDialogResultTitle",
                                    children: highlightedTitle ? (0, $8Lig8.enrichResultTitle)(highlightedTitle) : title
                                })
                            }) : title,
                            typeof label === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.ResultLabel), {
                                title: label,
                                children: label
                            }) : label
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedCollapsedResultDetailWrapper), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedCollapsedResultDetail), {
                            children: meta
                        })
                    })
                ]
            }),
            showAdditionalMeta && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedResultDetail), {
                children: additionalMeta
            }),
            showReturnIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8FPdi.SquareReturnIcon), {})
            }),
            showRemoveIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    icon: (0, $54Fwx.RemoveIcon),
                    spacing: 'compact',
                    onClick: onRemove,
                    label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $rpOSY.messages).remove_button_label
                    }),
                    appearance: 'subtle'
                })
            })
        ]
    });
};

});
parcelRegister("54Fwx", function(module, exports) {

$parcel$export(module.exports, "RemoveIcon", () => $bcfdb9ab02365327$export$6382847193091a26);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $bcfdb9ab02365327$export$6382847193091a26 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.185 7.4 12 10.585 8.815 7.399a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.7-.7a.496.496 0 0 0 .004-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.507.507 0 0 0-.36-.153.5.5 0 0 0-.353.15h-.001Z",
            fill: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("8FPdi", function(module, exports) {

$parcel$export(module.exports, "SquareReturnIcon", () => $e27d60379addc563$export$4501fc029b186da8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

const $e27d60379addc563$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
            })
        ]
    });

});

parcelRegister("rpOSY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a2a6e63cc6de5e45$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a2a6e63cc6de5e45$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    remove_button_label: {
        id: 'search_dialog.results.remove_button_label',
        defaultMessage: 'Remove this.',
        description: 'Label of the button that has remove function and appearance.'
    }
});

});

parcelRegister("8Lig8", function(module, exports) {

$parcel$export(module.exports, "enrichResultTitle", () => $67a3dba4d63955ca$export$c43ff622b37ceaa9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
const $67a3dba4d63955ca$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $67a3dba4d63955ca$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $67a3dba4d63955ca$var$highlightRE = new RegExp(`${$67a3dba4d63955ca$var$HIGHLIGHT_START_TAG}(.*?)${$67a3dba4d63955ca$var$HIGHLIGHT_END_TAG}.*`);
const $67a3dba4d63955ca$var$openingTagRE = new RegExp(`(.*?)${$67a3dba4d63955ca$var$HIGHLIGHT_START_TAG}`);
const $67a3dba4d63955ca$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($67a3dba4d63955ca$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        as: "span",
        children: title
    }, title + counter);
    while(title){
        const [preMatch, preText] = title.match($67a3dba4d63955ca$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            as: "span",
            children: preText
        }, preText + counter));
        const [boldMatch, highlightText] = title.match($67a3dba4d63955ca$var$highlightRE) || [];
        title = title.replace(`${$67a3dba4d63955ca$var$HIGHLIGHT_START_TAG}${highlightText}${$67a3dba4d63955ca$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            as: "strong",
            children: highlightText
        }, highlightText + counter));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                as: "span",
                children: title
            }, title + counter));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};

});

parcelRegister("eiKpf", function(module, exports) {

$parcel$export(module.exports, "ResultLink", () => $160b324f70b6d5a8$export$d0a8235d2583609);
$parcel$export(module.exports, "ResultContentWrapper", () => $160b324f70b6d5a8$export$87a308048e18f5d7);
$parcel$export(module.exports, "EnlargedResultContentWrapper", () => $160b324f70b6d5a8$export$e10965f6350456f8);
$parcel$export(module.exports, "ReturnIconContainer", () => $160b324f70b6d5a8$export$b7244afbfdf4cb9a);
$parcel$export(module.exports, "EnlargedReturnIconContainer", () => $160b324f70b6d5a8$export$cc248e72bc9d7b85);
$parcel$export(module.exports, "IconContainer", () => $160b324f70b6d5a8$export$8f314e512d92575f);
$parcel$export(module.exports, "EnlargedIconContainer", () => $160b324f70b6d5a8$export$ca5c00fa71c2e27e);
$parcel$export(module.exports, "ResultTitleContainer", () => $160b324f70b6d5a8$export$9c613d6c52df949a);
$parcel$export(module.exports, "EnlargedResultTitleContainer", () => $160b324f70b6d5a8$export$e97ece467686c93c);
$parcel$export(module.exports, "ResultLabel", () => $160b324f70b6d5a8$export$a999164f6ebc756c);
$parcel$export(module.exports, "ResultDetail", () => $160b324f70b6d5a8$export$b695f824f00c1cb0);
$parcel$export(module.exports, "CollapsedResultDetail", () => $160b324f70b6d5a8$export$addf7aa0f753bbe8);
$parcel$export(module.exports, "EnlargedCollapsedResultDetail", () => $160b324f70b6d5a8$export$a44951d703db9a17);
$parcel$export(module.exports, "EnlargedResultTitleContainerSkeleton", () => $160b324f70b6d5a8$export$c571ffd341b1e6fe);
$parcel$export(module.exports, "EnlargedResultDetail", () => $160b324f70b6d5a8$export$c8ec38cc79b76eaa);
$parcel$export(module.exports, "EnlargedResultDetailSkeleton", () => $160b324f70b6d5a8$export$a15ed502bc39849a);
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $160b324f70b6d5a8$export$43a2b5c94cb85d9c);
$parcel$export(module.exports, "EnlargedCollapsedResultDetailWrapper", () => $160b324f70b6d5a8$export$2dfb537c5a7f8cc3);
$parcel$export(module.exports, "DetailsSeparator", () => $160b324f70b6d5a8$export$35507434feaa4496);
$parcel$export(module.exports, "CollapsedResultContentWrapper", () => $160b324f70b6d5a8$export$ee32d1086c278cfc);
$parcel$export(module.exports, "EnlargedSkeletonIcon", () => $160b324f70b6d5a8$export$3c77a9b2eee1dfc5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3JZ8k = parcelRequire("3JZ8k");

var $kCMvS = parcelRequire("kCMvS");


var $bWGt6 = parcelRequire("bWGt6");
function $160b324f70b6d5a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $160b324f70b6d5a8$export$d0a8235d2583609 = /*#__PURE__*/ (0, $bWGt6.default)((0, $kCMvS.Link), {
    target: "e8crcwv22"
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $3JZ8k.primaryTextColour),
    '&:hover': {
        textDecoration: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $3JZ8k.primaryTextColour)
    },
    '&:focus': {
        outlineOffset: '-2px'
    },
    '&:visited': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $3JZ8k.primaryTextColour),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.SearchDialogResultTitle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: (0, $3JZ8k.visitedLinkColor)
        }
    }
});
const $160b324f70b6d5a8$export$87a308048e18f5d7 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv21"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $3JZ8k.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $3JZ8k.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $3JZ8k.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $3JZ8k.itemHighlightColor)
        }
    }));
const $160b324f70b6d5a8$export$e10965f6350456f8 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv20"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-space-075, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $3JZ8k.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $3JZ8k.itemHighlightColor)
        }
    }));
const $160b324f70b6d5a8$export$b7244afbfdf4cb9a = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv19"
})((props)=>({
        borderRadius: '3px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $3JZ8k.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $3JZ8k.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $3JZ8k.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $3JZ8k.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $3JZ8k.grid).px : (0, $3JZ8k.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $160b324f70b6d5a8$export$cc248e72bc9d7b85 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv18"
})({
    name: "qrg2ys",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px)"
});
const $160b324f70b6d5a8$export$d84276b3ae03593f = /*#__PURE__*/ (0, $bWGt6.default)($160b324f70b6d5a8$export$b7244afbfdf4cb9a, {
    target: "e8crcwv17"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $3JZ8k.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $3JZ8k.grid).multiple(2.5).px,
    opacity: 1
});
const $160b324f70b6d5a8$export$8f314e512d92575f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv16"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $3JZ8k.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $3JZ8k.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $3JZ8k.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $3JZ8k.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});
const $160b324f70b6d5a8$export$ca5c00fa71c2e27e = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv15"
})({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
    display: 'flex',
    alignItems: 'center'
});
const $160b324f70b6d5a8$export$9c613d6c52df949a = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv14"
})((0, $3JZ8k.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $3JZ8k.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $3JZ8k.primaryTextColour), ";@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){width:100%;}");
const $160b324f70b6d5a8$export$e97ece467686c93c = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv13"
})((0, $3JZ8k.nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, $3JZ8k.primaryTextColour), ";height:16px;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){width:100%;}width:90%;");
const $160b324f70b6d5a8$export$a999164f6ebc756c = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e8crcwv12"
})((0, $3JZ8k.nowrapEllipsis), {
    color: "var(--ds-text-subtle, #5E6C84)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $3JZ8k.grid).px
});
const $160b324f70b6d5a8$export$b695f824f00c1cb0 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv11"
})((0, $3JZ8k.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $3JZ8k.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $3JZ8k.grid).multiple(3).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $3JZ8k.grid).multiple(19).px
});
const $160b324f70b6d5a8$export$addf7aa0f753bbe8 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv10"
})((0, $3JZ8k.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $3JZ8k.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $160b324f70b6d5a8$export$a44951d703db9a17 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv9"
})((0, $3JZ8k.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $3JZ8k.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $160b324f70b6d5a8$export$c571ffd341b1e6fe = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv8"
})({
    maxWidth: '100%',
    width: '256px',
    height: '14px',
    marginBottom: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
});
const $160b324f70b6d5a8$export$c8ec38cc79b76eaa = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv7"
})((0, $3JZ8k.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $3JZ8k.itemLinkSecondaryColor),
    maxWidth: "'initial'",
    minWidth: 'fit-content',
    marginLeft: "var(--ds-space-150, 12px)"
});
const $160b324f70b6d5a8$export$a15ed502bc39849a = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv6"
})({
    maxWidth: '100%',
    width: '100px',
    height: '12px',
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
});
const $160b324f70b6d5a8$export$43a2b5c94cb85d9c = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv5"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $3JZ8k.grid).multiple(54).px
});
const $160b324f70b6d5a8$export$2dfb537c5a7f8cc3 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv4"
})({
    name: "uy5e1i",
    styles: "display:flex;width:90%"
});
const $160b324f70b6d5a8$export$35507434feaa4496 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv3"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $3JZ8k.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $3JZ8k.grid).px}`
});
const $160b324f70b6d5a8$export$ee32d1086c278cfc = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv2"
})({
    name: "1ls843y",
    styles: "display:block;min-width:0;flex-grow:1"
});
const $160b324f70b6d5a8$export$2cacbb382e8a2ce4 = /*#__PURE__*/ (0, $bWGt6.default)("button", {
    target: "e8crcwv1"
})({
    name: "ykaoo6",
    styles: "background-color:transparent;border:none;cursor:pointer;padding:0;width:100%;text-align:left"
});
const $160b324f70b6d5a8$export$3c77a9b2eee1dfc5 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8crcwv0"
})({
    width: '100%',
    height: '100%',
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
});

});


parcelRegister("c59Mn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dbd376a2b13fd4d2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $dbd376a2b13fd4d2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Quick Find
	 */ quick_find_search_input_placeholder: {
        id: 'product_search_dialog.quick_find_search_input_rovo_placeholder',
        defaultMessage: 'Search or ask Rovo',
        description: 'A placeholder for the quick find search input'
    },
    quick_find_recent_search_text_dialog: {
        id: 'product_search_dialog.quick_find_recent_search_text_dialog',
        defaultMessage: 'From your recent searches',
        description: 'Recent search indicator text in search dialog box'
    },
    quick_find_show_organization_results: {
        id: 'product_search_dialog.quick_find_show_organization_results',
        defaultMessage: 'Search your organization',
        description: 'A label for a link that takes users to Full Page Search'
    },
    quick_find_show_filtered_results: {
        id: 'product_search_dialog.quick_find_show_filtered_confluence_results',
        defaultMessage: 'Filter by Confluence spaces, contributors and more',
        description: 'A label for a link that takes users to Full Page Search with a product filter applied'
    },
    quick_find_show_filtered_results_with_icon: {
        id: 'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon',
        defaultMessage: 'Filter by {confluenceIcon} Confluence spaces, contributors and more',
        description: 'A label for a link that takes users to Full Page Search with a product filter applied with confluence icon'
    },
    quick_find_ask_atlassian_intelligence: {
        id: 'product_search_dialog.quick_find_ask_atlassian_intelligence',
        defaultMessage: 'Ask Atlassian Intelligence',
        description: 'A label for the link that takes users to an AI search'
    },
    quick_find_recently_viewed: {
        id: 'product_search_dialog.quick_find_recently_viewed',
        defaultMessage: 'Recently Viewed',
        description: 'Section title for recent content in Quick Find'
    },
    quick_find_recent_draft_label: {
        id: 'product_search_dialog.quick_find_recent_draft_label',
        defaultMessage: 'DRAFT',
        description: 'Lozenge label for draft results'
    },
    quick_find_recent_spaces_additional_meta: {
        id: 'product_search_dialog.quick_find_recent_spaces_additional_meta',
        defaultMessage: 'You recently visited',
        description: 'Additional meta for Quick Find recent spaces results'
    },
    quick_find_footer_text: {
        id: 'product_search_dialog.quick_find_footer_help_text',
        defaultMessage: 'Help us improve search',
        description: 'Quick find footer text'
    },
    quick_find_footer_full_page_search_link: {
        id: 'product_search_dialog.quick_find_footer_full_page_search_products_link',
        defaultMessage: 'Search across products',
        description: 'A label for a link that takes users to Full Page Search'
    },
    quick_find_no_content_header: {
        id: 'product_search_dialog.quick_find_no_content_header',
        defaultMessage: 'Seek and you shall find',
        description: 'Header of prompt to begin search journey if no recent content results are rendered'
    },
    quick_find_no_content_body: {
        id: 'product_search_dialog.quick_find_no_content_body_rovo',
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated products",
        description: 'Body text of prompt to begin search journey if no recent content results are rendered'
    },
    quick_find_post_query_no_results_header: {
        id: 'product_search_dialog.quick_find_post_query_no_results_header',
        defaultMessage: "We couldn't find any results with that title",
        description: 'Header of prompt if entering query in quickfind returns no results'
    },
    quick_find_post_query_no_results_body: {
        id: 'product_search_dialog.quick_find_post_query_no_results_body',
        defaultMessage: '<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term.',
        description: 'Body text of prompt if entering query in quickfind returns no results'
    },
    quick_find_search_results: {
        id: 'product_search_dialog.quick_find_search_results',
        defaultMessage: 'Search Results',
        description: 'Section title for search results in Quick Find'
    },
    quick_find_confluence_space: {
        id: 'product_search_dialog.quick_find_confluence_space',
        defaultMessage: 'Confluence Space',
        description: 'Metadata for Confluence Space results'
    },
    quick_find_results_section: {
        id: 'product_search_dialog.quick_find_results_section',
        defaultMessage: 'Search Results',
        description: 'Section title for post query items in Quick Find'
    },
    quick_find_results_team: {
        id: 'product_search_dialog.quick_find_result_item_team',
        defaultMessage: 'Team',
        description: 'Label for team search results'
    },
    quick_find_recent_search: {
        id: 'product_search_dialog.quick_find_recent_search',
        defaultMessage: 'Recent search',
        description: 'Metadata for recent search results'
    },
    remove_button_label: {
        id: 'product_search_dialog.results.remove_button_label',
        defaultMessage: 'Remove this.',
        description: 'Label of the button that has remove function and appearance.'
    },
    quick_find_rovo_tip: {
        id: 'product_search_dialog.quick_find_rovo_tip',
        defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer.",
        description: 'Banner message for showing tip of using question query.'
    }
});

});

parcelRegister("23vLA", function(module, exports) {

$parcel$export(module.exports, "EMPTY_SEARCH_ITEMS", () => $9b0453a9d305fc01$export$205c1cd8d8ed1926);
const $9b0453a9d305fc01$export$205c1cd8d8ed1926 = {
    size: 0,
    sections: []
};

});

parcelRegister("9fSwv", function(module, exports) {

$parcel$export(module.exports, "QuickFindResultRenderer", () => $ea3ff240b098aaee$export$6e27f80792772bd6);

var $2OMIu = parcelRequire("2OMIu");

var $4BodE = parcelRequire("4BodE");
var $a9a3f = parcelRequire("a9a3f");
var $5bKWp = parcelRequire("5bKWp");

var $5uXOq = parcelRequire("5uXOq");

var $azBuE = parcelRequire("azBuE");

var $aKYAO = parcelRequire("aKYAO");

var $idS9H = parcelRequire("idS9H");

var $dOrUw = parcelRequire("dOrUw");
var $9KiUn = parcelRequire("9KiUn");
var $9bNhQ = parcelRequire("9bNhQ");

var $gXkA8 = parcelRequire("gXkA8");

var $ousew = parcelRequire("ousew");

var $c59Mn = parcelRequire("c59Mn");

var $8ilpI = parcelRequire("8ilpI");

var $9bNhQ = parcelRequire("9bNhQ");

var $kv2Va = parcelRequire("kv2Va");

var $5IxfD = parcelRequire("5IxfD");

var $lTDGC = parcelRequire("lTDGC");

var $94iog = parcelRequire("94iog");

var $7JF8H = parcelRequire("7JF8H");

var $6ZsPS = parcelRequire("6ZsPS");

var $7xoNc = parcelRequire("7xoNc");
const $ea3ff240b098aaee$export$6e27f80792772bd6 = ({ productState: productState, preQueryItems: preQueryItems, postQueryItems: postQueryItems, linkComponent: linkComponent, appendQueryParams: appendQueryParams, onRetryPreQuery: onRetryPreQuery, onRetryPostQuery: onRetryPostQuery })=>{
    const isMobileView = (0, $aKYAO.useIsMobileView)();
    const { isRovoEnabled: isRovoEnabled } = (0, $lTDGC.useRovoContext)();
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const activeProduct = getActiveProduct();
    const productId = activeProduct?.id;
    const renderResults = (0, $5uXOq.useCallback)(()=>{
        switch(productState){
            case (0, $azBuE.ProductStates).PreQuerySuccess:
            case (0, $azBuE.ProductStates).PreQueryLoading:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idS9H.GenericSearchResult), {
                    searchItems: preQueryItems,
                    linkComponent: linkComponent,
                    screen: "preQuerySearchResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
            case (0, $azBuE.ProductStates).PreQueryNoResult:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gXkA8.PreQueryEmptyScreen), {});
            case (0, $azBuE.ProductStates).PreQueryError:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ilpI.SearchErrorScreen), {
                    onRetry: onRetryPreQuery
                });
            case (0, $azBuE.ProductStates).PostQueryTyping:
            case (0, $azBuE.ProductStates).PostQueryLoading:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idS9H.GenericSearchResult), {
                    searchItems: postQueryItems,
                    linkComponent: linkComponent,
                    screen: "cachedResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams,
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $a9a3f.EnlargedSearchResultSection), {
                        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $c59Mn.messages).quick_find_search_results
                        }),
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4BodE.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4BodE.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4BodE.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4BodE.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4BodE.EnlargedSearchResultContentSkeleton), {})
                        ]
                    })
                });
            case (0, $azBuE.ProductStates).PostQueryError:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ilpI.SearchErrorScreen), {
                    onRetry: onRetryPostQuery
                });
            case (0, $azBuE.ProductStates).PostQueryNoResult:
                const urlGeneratorForNoResultsScreen = (query)=>{
                    const generateUrl = activeProduct?.generateAdvancedSearchUrl || (()=>'');
                    const advancedSearchUrl = generateUrl(query);
                    return (0, $7xoNc.addQuery)(advancedSearchUrl, 'search_id', searchSessionId);
                };
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7JF8H.default), {
                    urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
                    fromQuickFindPostQueryNoResults: true
                });
            case (0, $azBuE.ProductStates).PostQuerySuccess:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idS9H.GenericSearchResult), {
                    searchItems: postQueryItems,
                    linkComponent: linkComponent,
                    screen: "postQuerySearchResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
        }
    }, [
        productState,
        preQueryItems,
        linkComponent,
        isMobileView,
        appendQueryParams,
        postQueryItems,
        onRetryPreQuery,
        onRetryPostQuery,
        activeProduct?.generateAdvancedSearchUrl,
        searchSessionId
    ]);
    const showSearchFooter = productState === (0, $azBuE.ProductStates).PreQuerySuccess || productState === (0, $azBuE.ProductStates).PreQueryLoading || productState === (0, $azBuE.ProductStates).PreQueryNoResult || productId === (0, $94iog.ProductKeys).Confluence && (productState === (0, $azBuE.ProductStates).PostQuerySuccess || productState === (0, $azBuE.ProductStates).PostQueryLoading || productState === (0, $azBuE.ProductStates).PostQueryNoResult);
    const showFilterFooter = productId === (0, $94iog.ProductKeys).Confluence && (productState === (0, $azBuE.ProductStates).PostQuerySuccess || productState === (0, $azBuE.ProductStates).PostQueryLoading || productState === (0, $azBuE.ProductStates).PostQueryNoResult);
    const showFeedbackFooter = productState === (0, $azBuE.ProductStates).PreQuerySuccess || productState === (0, $azBuE.ProductStates).PostQuerySuccess || productState === (0, $azBuE.ProductStates).PostQueryLoading || productState === (0, $azBuE.ProductStates).PostQueryNoResult;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            isRovoEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5IxfD.QuickFindRovoTip), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bKWp.SearchDialogContent), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bKWp.ResultContainerOuter), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bKWp.ResultContainer), {
                        "aria-live": "polite",
                        children: renderResults()
                    })
                })
            }),
            showSearchFooter && productId === (0, $94iog.ProductKeys).Confluence ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9bNhQ.SearchFooterPersistRecentSearch), {
                linkComponent: linkComponent
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9bNhQ.SearchFooter), {
                linkComponent: linkComponent
            }),
            showFilterFooter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KiUn.FilterFooter), {}),
            showFeedbackFooter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dOrUw.FeedbackFooter), {})
        ]
    });
};

});
parcelRegister("4BodE", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultContentSkeleton", () => $568ef0183cbcb010$export$958cb3907bb9ede);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eiKpf = parcelRequire("eiKpf");
const $568ef0183cbcb010$export$958cb3907bb9ede = ({})=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.EnlargedResultContentWrapper), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedIconContainer), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedSkeletonIcon), {})
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.CollapsedResultContentWrapper), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedResultTitleContainerSkeleton), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedResultDetailSkeleton), {})
                ]
            })
        ]
    });
};

});

parcelRegister("a9a3f", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultSection", () => $ebea77da566a11aa$export$3cb2a92d364e01db);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $iHixP = parcelRequire("iHixP");
const $ebea77da566a11aa$export$3cb2a92d364e01db = ({ title: title, totalResults: totalResults, children: children })=>{
    const hasTitle = Boolean(title);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iHixP.EnlargedSearchResultSectionContainer), {
        "data-vc": "search-result-section-enlarged",
        children: [
            hasTitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iHixP.EnlargedSearchResultSectionHeading), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iHixP.EnlargedSearchResultsSectionTitle), {
                    children: [
                        title,
                        totalResults ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iHixP.SearchResultSectionTitleBadgeContainer), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
                                testId: "search-result-count-badge",
                                children: totalResults
                            })
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
};

});
parcelRegister("iHixP", function(module, exports) {

$parcel$export(module.exports, "SearchResultSectionContainer", () => $44e18234b9d22800$export$ee908270616a8c0);
$parcel$export(module.exports, "EnlargedSearchResultSectionContainer", () => $44e18234b9d22800$export$503dfba90bfcca30);
$parcel$export(module.exports, "SearchResultSectionHeading", () => $44e18234b9d22800$export$12a98bde80b93e83);
$parcel$export(module.exports, "EnlargedSearchResultSectionHeading", () => $44e18234b9d22800$export$7ff5e58611d4f213);
$parcel$export(module.exports, "SearchResultsSectionTitle", () => $44e18234b9d22800$export$ce295363b4299a23);
$parcel$export(module.exports, "EnlargedSearchResultsSectionTitle", () => $44e18234b9d22800$export$ba58138b255a651c);
$parcel$export(module.exports, "SearchResultSectionTitleBadgeContainer", () => $44e18234b9d22800$export$47dafe5a3fc802fe);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $3JZ8k = parcelRequire("3JZ8k");

var $bWGt6 = parcelRequire("bWGt6");
function $44e18234b9d22800$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $44e18234b9d22800$export$ee908270616a8c0 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1vq42j46"
})({
    padding: `${"var(--ds-space-100, 8px)"} 0`
});
const $44e18234b9d22800$export$503dfba90bfcca30 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1vq42j45"
})({
    name: "1yyzl0r",
    styles: "padding:0;display:flex;flex-direction:column;gap:var(--ds-space-025, 2px)"
});
const $44e18234b9d22800$export$12a98bde80b93e83 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1vq42j44"
})({
    marginBottom: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: (0, $3JZ8k.grid).multiple(4).px
});
const $44e18234b9d22800$export$7ff5e58611d4f213 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1vq42j43"
})({
    name: "1ifu3fr",
    styles: "height:28px;display:flex"
});
const $44e18234b9d22800$export$ce295363b4299a23 = /*#__PURE__*/ (0, $bWGt6.default)("h2", {
    target: "e1vq42j42"
})({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $3JZ8k.grid).twice().px,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $3JZ8k.grid).twice().px}`
});
const $44e18234b9d22800$export$ba58138b255a651c = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1vq42j41"
})({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    boxSizing: 'border-box',
    padding: `0 ${"var(--ds-space-100, 8px)"}`
});
const $44e18234b9d22800$export$47dafe5a3fc802fe = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1vq42j40"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $3JZ8k.grid).px,
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});


parcelRegister("5bKWp", function(module, exports) {

$parcel$export(module.exports, "SearchDialogWrapper", () => $8517d4d988dbeb18$export$dcefba65c42da69c);
$parcel$export(module.exports, "ResultContainerOuter", () => $8517d4d988dbeb18$export$d6e44c2a92a613c2);
$parcel$export(module.exports, "ResultContainer", () => $8517d4d988dbeb18$export$ab35601bed9ca017);
$parcel$export(module.exports, "SidebarScrollContainer", () => $8517d4d988dbeb18$export$34a31057caff1acb);
$parcel$export(module.exports, "SidebarContainerPane", () => $8517d4d988dbeb18$export$6b8430dd9f61a5c7);
$parcel$export(module.exports, "SidebarContainerBorder", () => $8517d4d988dbeb18$export$33eeaf745b96a17f);
$parcel$export(module.exports, "SidebarBottomFixedContainer", () => $8517d4d988dbeb18$export$dc065bf90da5c17d);
$parcel$export(module.exports, "SearchDialogContent", () => $8517d4d988dbeb18$export$c9e0e8491f083dd5);
$parcel$export(module.exports, "ResultRenderWrapper", () => $8517d4d988dbeb18$export$8644783c0dd52b5e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");


var $3JZ8k = parcelRequire("3JZ8k");

var $k5uoT = parcelRequire("k5uoT");

var $VSDnB = parcelRequire("VSDnB");

var $gJ29f = parcelRequire("gJ29f");

var $bWGt6 = parcelRequire("bWGt6");
function $8517d4d988dbeb18$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8517d4d988dbeb18$var$SIDEBAR_PANE_WIDTH = (0, $k5uoT.gridSize)() * 34;
const $8517d4d988dbeb18$var$resultContainerVerticalPadding = (0, $k5uoT.gridSize)();
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $8517d4d988dbeb18$var$SearchDialogWrapperOld = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s9"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $3JZ8k.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $3JZ8k.dialogWidth};` : '', " box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, $3JZ8k.grid).multiple(0.5).px + ' ' + (0, $3JZ8k.grid).px + ' ' + (0, $829f609a65d26a98$export$7d3359664e8bb0e5) + ', 0 0 1px ' + (0, $829f609a65d26a98$export$d2d3bedfb276cac0)})`, ";border-radius:3px;background-color:var(--ds-surface-overlay, #fff);overflow:hidden;margin-top:", (0, $3JZ8k.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $8517d4d988dbeb18$var$SearchDialogWrapperWithMobileFix = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s8"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $3JZ8k.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $3JZ8k.dialogWidth};` : '', " box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, $3JZ8k.grid).multiple(0.5).px + ' ' + (0, $3JZ8k.grid).px + ' ' + (0, $829f609a65d26a98$export$7d3359664e8bb0e5) + ', 0 0 1px ' + (0, $829f609a65d26a98$export$d2d3bedfb276cac0)})`, ";border-radius:3px;background-color:var(--ds-surface-overlay, #fff);overflow:hidden;margin-top:", (0, $3JZ8k.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
const $8517d4d988dbeb18$export$dcefba65c42da69c = (0, $gJ29f.componentWithCondition)(()=>(0, $VSDnB.fg)('jira_mobile_search_responsiveness'), $8517d4d988dbeb18$var$SearchDialogWrapperWithMobileFix, $8517d4d988dbeb18$var$SearchDialogWrapperOld);
const $8517d4d988dbeb18$export$d6e44c2a92a613c2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s7"
})({
    name: "s8tasg",
    styles: "flex:1;display:flex;flex-direction:column;overflow:hidden;max-width:100%;box-sizing:border-box"
});
const $8517d4d988dbeb18$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s6"
})({
    name: "n94oxe",
    styles: "overflow-x:hidden;overflow-y:auto;flex:1;max-width:100%;box-sizing:border-box"
});
const $8517d4d988dbeb18$export$34a31057caff1acb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s5"
})({
    flex: '1 1 auto',
    overflowX: 'hidden',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
});
const $8517d4d988dbeb18$export$6b8430dd9f61a5c7 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s4"
})("flex:0 1 auto;width:", $8517d4d988dbeb18$var$SIDEBAR_PANE_WIDTH, "px;display:flex;flex-direction:column;max-height:100%;padding-bottom:var(--ds-space-200, 16px);@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}");
const $8517d4d988dbeb18$export$33eeaf745b96a17f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s3"
})({
    margin: `${"var(--ds-space-200, 16px)"} 0`,
    borderLeft: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`
});
const $8517d4d988dbeb18$export$dc065bf90da5c17d = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s2"
})({
    padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`,
    flex: '0 0 auto'
});
const $8517d4d988dbeb18$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($8517d4d988dbeb18$export$33eeaf745b96a17f, {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)($8517d4d988dbeb18$export$6b8430dd9f61a5c7, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($8517d4d988dbeb18$export$34a31057caff1acb, {
                    children: children
                })
            })
        ]
    });
const $8517d4d988dbeb18$var$totalDialogHeightPx = 776 + $8517d4d988dbeb18$var$resultContainerVerticalPadding * 2;
const $8517d4d988dbeb18$var$footerHeight = (0, $k5uoT.gridSize)() * 6;
const $8517d4d988dbeb18$var$belowDialogSpace = (0, $k5uoT.gridSize)() * 28;
const $8517d4d988dbeb18$var$aiFullDialogPromptHeight = 64;
const $8517d4d988dbeb18$export$c9e0e8491f083dd5 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s1"
})("display:flex;max-height:", (props)=>`calc(100vh - ${$8517d4d988dbeb18$var$belowDialogSpace - $8517d4d988dbeb18$var$footerHeight + (props.showAtlassianHomeSearchLink ? $8517d4d988dbeb18$var$footerHeight : 0) + (props.aiSearchFullDialogEnabled ? $8517d4d988dbeb18$var$aiFullDialogPromptHeight : 0)}px)`, ";box-sizing:border-box;flex:1;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : 'auto', ";@media screen and (min-height: ", $8517d4d988dbeb18$var$totalDialogHeightPx + $8517d4d988dbeb18$var$belowDialogSpace, "px){max-height:", (props)=>`${$8517d4d988dbeb18$var$totalDialogHeightPx - $8517d4d988dbeb18$var$footerHeight - (props.aiSearchFullDialogEnabled ? $8517d4d988dbeb18$var$aiFullDialogPromptHeight : 0)}px;`, ";}@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){max-height:initial;overflow:auto;}");
const $8517d4d988dbeb18$export$8644783c0dd52b5e = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ee3sr7s0"
})("position:relative;display:flex;flex-direction:column;justify-content:space-between;min-height:", (props)=>props.shouldFixMinimumHeight ? `${props.minimumHeight}px` : 'auto', ";@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){flex-grow:1;}");

});

parcelRegister("azBuE", function(module, exports) {

$parcel$export(module.exports, "APIStates", () => $c05bd9c3eaf7d970$export$c701d1d8ac310aa0);
$parcel$export(module.exports, "ProductStates", () => $c05bd9c3eaf7d970$export$212790b4ffec121f);
var $c05bd9c3eaf7d970$export$c701d1d8ac310aa0 = /*#__PURE__*/ function(APIStates) {
    APIStates["Typing"] = "typing";
    APIStates["Loading"] = "loading";
    APIStates["Error"] = "error";
    APIStates["NoResult"] = "noresult";
    APIStates["Success"] = "success";
    return APIStates;
}({});
var $c05bd9c3eaf7d970$export$212790b4ffec121f = /*#__PURE__*/ function(ProductStates) {
    ProductStates["PreQueryLoading"] = "PreQueryLoading";
    ProductStates["PostQueryLoading"] = "PostQueryLoading";
    ProductStates["PreQuerySuccess"] = "PreQuerySuccess";
    ProductStates["PostQuerySuccess"] = "PostQuerySuccess";
    ProductStates["PreQueryError"] = "PreQueryError";
    ProductStates["PostQueryError"] = "PostQueryError";
    ProductStates["PreQueryNoResult"] = "PreQueryNoResult";
    ProductStates["PostQueryNoResult"] = "PostQueryNoResult";
    ProductStates["PostQueryTyping"] = "PostQueryTyping";
    ProductStates["Invalid"] = "Invalid";
    return ProductStates;
}({});

});

parcelRegister("aKYAO", function(module, exports) {

$parcel$export(module.exports, "useIsMobileView", () => $7df7357fe96e0b4e$export$853d1166284edec0);

var $3JZ8k = parcelRequire("3JZ8k");
const $7df7357fe96e0b4e$export$853d1166284edec0 = ()=>window.innerWidth <= (0, $3JZ8k.dialogPageTakeoverWidth);

});

parcelRegister("idS9H", function(module, exports) {

$parcel$export(module.exports, "GenericSearchResult", () => $6334d3524c536429$export$855c9ab7e6e3e97f);

var $2OMIu = parcelRequire("2OMIu");

var $a9a3f = parcelRequire("a9a3f");
var $9GJaT = parcelRequire("9GJaT");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $tUDIN = parcelRequire("tUDIN");

var $lVuuE = parcelRequire("lVuuE");

var $8W5yo = parcelRequire("8W5yo");

var $8djaw = parcelRequire("8djaw");

var $7ttuB = parcelRequire("7ttuB");

var $hNXQY = parcelRequire("hNXQY");

var $apEtD = parcelRequire("apEtD");
const $6334d3524c536429$export$f6fdc80358dfd95 = 10;
const $6334d3524c536429$export$fd06a2c70d34842e = (searchResultSections, sectionIndex)=>searchResultSections.slice(0, sectionIndex).reduce((accumulator, currentElem)=>accumulator + Math.min(currentElem.searchResults.length, currentElem.resultLimit || $6334d3524c536429$export$f6fdc80358dfd95), 0);
const $6334d3524c536429$var$getTotalResultCount = (forceHideResultCount, section)=>{
    // resultCount is only shown when a size is specified. We changed this
    // from using searchResults.length as we want to indicate the number of
    // possible search results rather than just the ones shown.
    const resultCount = !forceHideResultCount && section.showResultCount && section.size && section.searchResults.length ? Math.max(section.size, section.searchResults.length) : undefined;
    // totalResults considers the count returned from a section's resultMapper
    // to ensure rendered results align with the displayed count, in case results shown
    // are limited by the resultMapper
    const totalResults = Boolean(resultCount && section.searchResults.length < (section.resultLimit || $6334d3524c536429$export$f6fdc80358dfd95) && resultCount >= section.searchResults.length) ? section.searchResults.length : resultCount;
    return totalResults;
};
const $6334d3524c536429$var$GenericSearchResultWithIntl = ({ children: children, forceHideResultCount: forceHideResultCount = false, generateSectionTitle: generateSectionTitle = ({ title: title })=>title, intl: intl, isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, renderSectionViewAll: renderSectionViewAll, searchItems: searchItems, screen: screen, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext, appendQueryParams: appendQueryParams })=>{
    const { quickFind: quickFind } = (0, $hNXQY.useFeaturesContext)();
    if (!searchItems || !(0, $lVuuE.hasSearchResults)(searchItems)) {
        // This is mainly used to handle the loading state (e.g. a spinner or a skeleton)
        if (children) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $apEtD.SearchResultWrapper), {
            children: children
        });
        return null;
    }
    const ResultSection = quickFind?.enabled ? (0, $a9a3f.EnlargedSearchResultSection) : (0, $9GJaT.SearchResultSection);
    const QuickFindPersistRecentSearch = quickFind?.enabled ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment : (0, $7ttuB.PersistRecentSearch);
    const ItemSection = (props)=>{
        const { section: section, sectionIndex: sectionIndex } = props;
        const itemLimit = typeof section.resultLimit === 'number' ? section.resultLimit : $6334d3524c536429$export$f6fdc80358dfd95;
        const searchResults = section.searchResults?.slice(0, itemLimit) || [];
        const totalResults = $6334d3524c536429$var$getTotalResultCount(forceHideResultCount, section);
        const totalNumberOfItemsInPreviousSections = $6334d3524c536429$export$fd06a2c70d34842e(searchItems.sections, sectionIndex);
        if (searchResults.length === 0) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(ResultSection, {
            totalResults: totalResults,
            title: section.titleRenderer ? section.titleRenderer({
                isCollapsed: isCollapsed,
                productState: productState
            }) : generateSectionTitle(section, intl),
            children: [
                searchResults.map((result, index)=>{
                    const analyticContext = {
                        sectionIndex: sectionIndex,
                        sectionId: section.id,
                        containerId: result.containerId || null,
                        indexWithinSection: index,
                        globalIndex: totalNumberOfItemsInPreviousSections + index,
                        isCached: result.isRecentResult || false,
                        metadata: {
                            contentId: result.id,
                            containerId: result.containerId || null,
                            contentType: result.type || null
                        }
                    };
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
                        analyticContext: analyticContext,
                        nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext || {},
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(QuickFindPersistRecentSearch, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8W5yo.SearchResultItem), {
                                isCollapsed: isCollapsed,
                                linkComponent: linkComponent,
                                productState: productState,
                                resultRenderer: section.resultRenderer,
                                resultWrapper: section.resultWrapper,
                                screen: screen,
                                searchResult: result,
                                appendQueryParams: appendQueryParams,
                                useAnalyticsOverride: section.useAnalyticsOverride
                            })
                        })
                    }, result.id);
                }),
                renderSectionViewAll && section.viewAllLinkGenerator && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8djaw.ViewAllLink), {
                    linkComponent: linkComponent,
                    section: section,
                    totalResults: totalResults
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $apEtD.SearchResultWrapper), {
        children: [
            searchItems.sections.map((section, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)(ItemSection, {
                    section: section,
                    sectionIndex: index
                }, section.id)),
            children
        ]
    });
};
const $6334d3524c536429$export$855c9ab7e6e3e97f = (0, $8RXs9.default)($6334d3524c536429$var$GenericSearchResultWithIntl);

});
parcelRegister("9GJaT", function(module, exports) {

$parcel$export(module.exports, "SearchResultSection", () => $a53ee31faa6de3a1$export$51a5a703da15f0f7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $iHixP = parcelRequire("iHixP");
const $a53ee31faa6de3a1$export$51a5a703da15f0f7 = ({ title: title, totalResults: totalResults, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iHixP.SearchResultSectionContainer), {
        "data-vc": "search-result-section",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iHixP.SearchResultSectionHeading), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iHixP.SearchResultsSectionTitle), {
                    children: [
                        title,
                        totalResults ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iHixP.SearchResultSectionTitleBadgeContainer), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
                                testId: "search-result-count-badge",
                                children: totalResults
                            })
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
};

});

parcelRegister("lVuuE", function(module, exports) {

$parcel$export(module.exports, "hasSearchResults", () => $3da56dcd3f8448d0$export$bcf020eea629e7ed);
const $3da56dcd3f8448d0$export$bcf020eea629e7ed = (searchItems)=>{
    const sectionsWithSearchResults = searchItems.sections.filter(({ searchResults: searchResults })=>searchResults.length > 0);
    return sectionsWithSearchResults.length > 0;
};

});

parcelRegister("8W5yo", function(module, exports) {

$parcel$export(module.exports, "SearchResultItem", () => $26a82d6e28c4aa57$export$56e008c8bd1ccf7c);

var $2OMIu = parcelRequire("2OMIu");

var $5Zza9 = parcelRequire("5Zza9");
var $1OFaa = parcelRequire("1OFaa");

var $5uXOq = parcelRequire("5uXOq");

var $6ZsPS = parcelRequire("6ZsPS");

var $7xoNc = parcelRequire("7xoNc");

var $cvYmc = parcelRequire("cvYmc");

var $lywjH = parcelRequire("lywjH");
const $26a82d6e28c4aa57$var$DefaultSearchResultItemWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
/**
 * Intended to be used for search results that are not links
 */ const $26a82d6e28c4aa57$var$SearchResultItemKeyboardHiglightWrapper = ({ searchResultId: searchResultId, children: children })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $1OFaa.useKeyboardHighlighting)({
        searchResultId: searchResultId
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        children: children(isKeyboardHighlighted)
    });
};
const $26a82d6e28c4aa57$export$56e008c8bd1ccf7c = ({ isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, resultRenderer: resultRenderer, resultWrapper: resultWrapper, screen: screen, searchResult: searchResult, appendQueryParams: appendQueryParams, useAnalyticsOverride: useAnalyticsOverride = ()=>({}) })=>{
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const { onHighlightCallback: defaultOnHighlightCallback, onSelectCallback: defaultOnSelectCallback, onContextMenuCallback: defaultOnContextMenuCallback } = (0, $lywjH.useSearchResultAnalyticsCallbacks)({
        screen: screen,
        actionSubject: 'searchResult'
    });
    const { onHighlightCallback: overriddenOnHighlightCallback, onSelectCallback: overriddenOnSelectCallback, onContextMenuCallback: overriddenOnContextMenuCallback } = useAnalyticsOverride({
        screen: screen
    });
    const url = appendQueryParams === undefined ? (0, $7xoNc.addQuery)(searchResult.url, 'search_id', searchSessionId) : appendQueryParams(searchResult.url, searchSessionId, searchResult.type, searchResult.id);
    const SearchResultItemWrapper = resultWrapper || $26a82d6e28c4aa57$var$DefaultSearchResultItemWrapper;
    const searchResultContentRenderer = (0, $5uXOq.useCallback)((isKeyboardHighlighted)=>resultRenderer ? resultRenderer({
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            productState: productState,
            screen: screen,
            searchResult: searchResult
        }) : (0, $cvYmc.defaultResultRenderer)({
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            screen: screen,
            searchResult: searchResult
        }), [
        isCollapsed,
        productState,
        resultRenderer,
        screen,
        searchResult
    ]);
    const id = `link-${searchResult.id}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(SearchResultItemWrapper, {
        url: url,
        titleId: id,
        children: url ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Zza9.SearchResultLink), {
            href: url,
            linkComponent: searchResult.linkComponent ?? linkComponent,
            searchResultId: searchResult.id,
            onContextMenu: overriddenOnContextMenuCallback || defaultOnContextMenuCallback,
            onHighlighted: overriddenOnHighlightCallback || defaultOnHighlightCallback,
            onSelect: overriddenOnSelectCallback || defaultOnSelectCallback,
            "data-testid": id,
            id: id,
            children: (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)($26a82d6e28c4aa57$var$SearchResultItemKeyboardHiglightWrapper, {
            searchResultId: searchResult.id,
            children: (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)
        })
    });
};

});
parcelRegister("5Zza9", function(module, exports) {

$parcel$export(module.exports, "SearchResultLink", () => $1d3b9fa4072269d9$export$76cc11d043a1381);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eiKpf = parcelRequire("eiKpf");

var $1OFaa = parcelRequire("1OFaa");
const $1d3b9fa4072269d9$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $1OFaa.useKeyboardHighlighting)({
        searchResultId: searchResultId,
        onHighlighted: onHighlighted
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        onClick: onSelect,
        onContextMenu: onContextMenu,
        role: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.ResultLink), {
            linkComponent: linkComponent,
            href: href,
            ...rest,
            children: children(isKeyboardHighlighted)
        })
    }));
};

});
parcelRegister("1OFaa", function(module, exports) {

$parcel$export(module.exports, "useKeyboardHighlighting", () => $cd3a02b4d41aab00$export$9803d460130e453);

var $5uXOq = parcelRequire("5uXOq");

var $fYvdU = parcelRequire("fYvdU");
/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */ const $cd3a02b4d41aab00$var$onKeyDown = (e, target)=>{
    // Only navigate if Enter was pressed without any modifiers
    if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        // Find the deepest child element in the DOM
        let clickTarget = target;
        while(clickTarget.firstElementChild instanceof HTMLElement && clickTarget.firstElementChild?.click)clickTarget = clickTarget.firstElementChild;
        clickTarget.click();
    }
};
const $cd3a02b4d41aab00$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
    const [isKeyboardHighlighted, ref] = (0, $fYvdU.useKeyboardNavigation)({
        onKeydownCallback: $cd3a02b4d41aab00$var$onKeyDown,
        navigationTrackingId: searchResultId ?? null
    });
    // Ref for whether or not this search result was last highlighted
    const previousHighlight = (0, $5uXOq.useRef)(false);
    // Call the onHighlighted callback when this search result is highlighted
    (0, $5uXOq.useEffect)(()=>{
        if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted?.();
        previousHighlight.current = isKeyboardHighlighted;
    }, [
        isKeyboardHighlighted,
        previousHighlight,
        onHighlighted
    ]);
    return {
        isKeyboardHighlighted: isKeyboardHighlighted,
        ref: ref
    };
};

});


parcelRegister("cvYmc", function(module, exports) {

$parcel$export(module.exports, "defaultResultRenderer", () => $be3af5bb83306dae$export$fa734eedc505eef7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");

var $fuhQD = parcelRequire("fuhQD");

var $fHgxq = parcelRequire("fHgxq");

var $1KrIR = parcelRequire("1KrIR");
const $be3af5bb83306dae$export$fa734eedc505eef7 = ({ isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, screen: screen, searchResult: searchResult })=>{
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(searchResult.icon) ? searchResult.icon : typeof searchResult.icon === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1KrIR.ResultAvatar), {
        borderColor: "transparent",
        src: searchResult.icon,
        appearance: "square",
        size: "xsmall",
        testId: "result-avatar"
    }) : searchResult.iconRenderer ? searchResult.iconRenderer({
        screen: screen
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1KrIR.ResultAvatar), {
        borderColor: "transparent",
        src: searchResult.iconUrl,
        appearance: "square",
        size: "xsmall",
        testId: "result-avatar"
    });
    const title = searchResult.isVerified ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            searchResult.title,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fuhQD.VerifiedTeamIcon), {})
        ]
    }) : searchResult.title;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fHgxq.SearchResultContent), {
        isKeyboardHighlighted: isKeyboardHighlighted,
        title: title,
        meta: searchResult.meta,
        additionalMeta: searchResult.additionalMeta,
        isCollapsed: isCollapsed,
        icon: icon
    }, `item_${searchResult.id}`);
};

});
parcelRegister("fuhQD", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $a137cc376204c926$export$d7949f68d31e5edd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gqGjQ = parcelRequire("gqGjQ");

var $fGmbh = parcelRequire("fGmbh");

var $3bDjY = parcelRequire("3bDjY");

var $27dJz = parcelRequire("27dJz");
const $a137cc376204c926$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $27dJz.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $fGmbh.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $fGmbh.default)
    });
};

});
parcelRegister("gqGjQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08303db08bddd05336395b40b61b967a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf5fe6b7538334be$var$_react = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bf5fe6b7538334be$var$_baseNew = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bf5fe6b7538334be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf5fe6b7538334be$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $bf5fe6b7538334be$var$_react.default.createElement($bf5fe6b7538334be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.225.95c-.697.54-.87 1.52-.4 2.266l.827 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$bf5fe6b7538334be$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $bf5fe6b7538334be$var$_default = module.exports.default = $bf5fe6b7538334be$var$StatusVerifiedIcon;

});

parcelRegister("fGmbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bd2ad2ea16bb95$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
    });
var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;

});

parcelRegister("27dJz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $952fb45ddff9712a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $952fb45ddff9712a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});


parcelRegister("fHgxq", function(module, exports) {

$parcel$export(module.exports, "SearchResultContent", () => $8838fcb6e0179a11$export$b5fd7d6305bfbd3e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cIQMR = parcelRequire("cIQMR");

var $eiKpf = parcelRequire("eiKpf");
const $8838fcb6e0179a11$export$595b9d59c3d65270 = '@@@hl@@@';
const $8838fcb6e0179a11$export$eea8f6b95460c3c3 = '@@@endhl@@@';
const $8838fcb6e0179a11$var$getResultLabel = (label)=>{
    if (typeof label === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.ResultLabel), {
        title: typeof label === 'string' ? label : undefined,
        children: label
    });
    return label;
};
const $8838fcb6e0179a11$var$getResultTitle = (title)=>{
    if (typeof title === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            title: title,
            className: "SearchDialogResultTitle",
            children: title
        })
    });
    return title;
};
const $8838fcb6e0179a11$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    const getResultContent = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: isCollapsed ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.ResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            $8838fcb6e0179a11$var$getResultLabel(label),
                            $8838fcb6e0179a11$var$getResultTitle(title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.CollapsedResultDetailWrapper), {
                        children: [
                            meta && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.CollapsedResultDetail), {
                                title: typeof meta === 'string' ? meta : undefined,
                                children: meta
                            }),
                            additionalMeta && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.DetailsSeparator), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.CollapsedResultDetail), {
                                        children: additionalMeta
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.ResultTitleContainer), {
                        children: [
                            $8838fcb6e0179a11$var$getResultLabel(label),
                            $8838fcb6e0179a11$var$getResultTitle(title)
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.ResultDetail), {
                        title: typeof meta === 'string' ? meta : undefined,
                        children: meta
                    }),
                    additionalMeta ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.ResultDetail), {
                        title: typeof additionalMeta === 'string' ? additionalMeta : undefined,
                        children: additionalMeta
                    }) : null
                ]
            })
        });
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.ResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.IconContainer), {
                children: icon
            }),
            getResultContent(),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.ReturnIconContainer), {
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cIQMR.ReturnIcon), {
                    inverted: true
                })
            })
        ]
    });
};

});

parcelRegister("1KrIR", function(module, exports) {

$parcel$export(module.exports, "ResultAvatar", () => $b4c63e684429a304$export$d2397285980ae833);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $bWGt6 = parcelRequire("bWGt6");
function $b4c63e684429a304$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b4c63e684429a304$var$NegativeMargin = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez36xyc0"
})({
    name: "l8jj6j",
    styles: "margin:var(--ds-space-negative-025, -2px);display:flex"
});
const $b4c63e684429a304$export$d2397285980ae833 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b4c63e684429a304$var$NegativeMargin, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            ...props
        })
    });

});


parcelRegister("lywjH", function(module, exports) {

$parcel$export(module.exports, "useSearchResultAnalyticsCallbacks", () => $8ce201bcb35d3d00$export$4381245974d3b25a);

var $5uXOq = parcelRequire("5uXOq");

var $3FqY6 = parcelRequire("3FqY6");
var $75NXP = parcelRequire("75NXP");
const $8ce201bcb35d3d00$export$4381245974d3b25a = ({ onHighlighted: onHighlighted, onSelect: onSelect, screen: screen, actionSubject: actionSubject })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const onHighlightCallback = (0, $5uXOq.useCallback)(()=>{
        fireAnalyticsEvent((0, $3FqY6.onSearchResultHighlighted)({
            screen: screen,
            actionSubject: actionSubject
        }));
        onHighlighted?.();
    }, [
        actionSubject,
        fireAnalyticsEvent,
        onHighlighted,
        screen
    ]);
    const onSelectCallback = (0, $5uXOq.useCallback)((e)=>{
        fireAnalyticsEvent((0, $3FqY6.onSearchResultSelected)({
            screen: screen,
            actionSubject: actionSubject
        }));
        onSelect?.(e);
    }, [
        actionSubject,
        fireAnalyticsEvent,
        onSelect,
        screen
    ]);
    const onContextMenuCallback = (0, $5uXOq.useCallback)((e)=>{
        fireAnalyticsEvent((0, $3FqY6.onSearchResultContext)({
            screen: screen,
            actionSubject: actionSubject
        }));
    }, [
        actionSubject,
        fireAnalyticsEvent,
        screen
    ]);
    return {
        onHighlightCallback: onHighlightCallback,
        onSelectCallback: onSelectCallback,
        onContextMenuCallback: onContextMenuCallback
    };
};

});


parcelRegister("8djaw", function(module, exports) {

$parcel$export(module.exports, "ViewAllLink", () => $9d2eca8cb63a35b9$export$f8fe8ba0816633ed);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $e7T97 = parcelRequire("e7T97");

var $k4hbD = parcelRequire("k4hbD");

var $2dI5H = parcelRequire("2dI5H");

var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");
const $9d2eca8cb63a35b9$export$f8fe8ba0816633ed = ({ linkComponent: linkComponent, section: section, totalResults: totalResults = 0 })=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const { viewAllLinkGenerator: viewAllLinkGenerator, viewAllLinkRenderer: viewAllLinkRenderer } = section;
    if (!viewAllLinkGenerator) return null;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        onClick: ()=>{
            fireAnalyticsEvent((0, $3FqY6.onSearchResultViewAllLinkClicked)(section.id));
        },
        role: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e7T97.SearchResultSectionLink), {
            linkComponent: linkComponent,
            href: viewAllLinkGenerator(query),
            testId: "search-result-section-link",
            children: viewAllLinkRenderer ? viewAllLinkRenderer({
                section: section,
                totalResults: totalResults
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $k4hbD.messages).common_show_all_results_link
            })
        })
    }));
};

});
parcelRegister("e7T97", function(module, exports) {

$parcel$export(module.exports, "SearchResultSectionLink", () => $8a2fa9a37d3334b2$export$f39804bac419a7f4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7297k = parcelRequire("7297k");
const $8a2fa9a37d3334b2$export$f39804bac419a7f4 = ({ children: children, linkComponent: linkComponent, ...rest })=>/* component must either be `undefined` or an component. A null or false will throw an error */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7297k.SectionLink), {
        appearance: "link",
        ...rest,
        component: linkComponent || undefined,
        children: children
    });

});
parcelRegister("7297k", function(module, exports) {

$parcel$export(module.exports, "SectionLink", () => $4e0c934de1c69b04$export$3545bd757920e2b3);

var $fVnbM = parcelRequire("fVnbM");

var $3JZ8k = parcelRequire("3JZ8k");


var $bWGt6 = parcelRequire("bWGt6");
const $4e0c934de1c69b04$export$3545bd757920e2b3 = /*#__PURE__*/ (0, $bWGt6.default)((0, $fVnbM.default), {
    target: "e1052ovn0"
})("margin-left:", (0, $3JZ8k.grid).half().px, ";color:", `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`, ";cursor:pointer!important;&:hover{text-decoration:underline!important;}");

});



parcelRegister("7ttuB", function(module, exports) {

$parcel$export(module.exports, "usePersistRecentSearches", () => $947af48e629e5ba7$export$3adda20dc7f5408f);
$parcel$export(module.exports, "PersistRecentSearch", () => $947af48e629e5ba7$export$c8074e5d4e733c21);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VoGI = parcelRequire("7VoGI");

var $033iF = parcelRequire("033iF");

var $kv2Va = parcelRequire("kv2Va");

var $2dI5H = parcelRequire("2dI5H");
const $947af48e629e5ba7$export$3adda20dc7f5408f = (overrideQuery)=>{
    const previousQuery = (0, $5uXOq.useRef)(null);
    const { user: user } = (0, $7VoGI.useUserContext)();
    const { query: query } = (0, $2dI5H.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const product = getActiveProduct();
    const persistRecentSearch = (0, $5uXOq.useCallback)(()=>{
        if (user?.id && product?.id) {
            if (overrideQuery && overrideQuery.trim() !== '') (0, $033iF.addRecentSearch)(overrideQuery, user.id, product.id, (0, $033iF.RECENT_SEARCH_KEY));
            else if (previousQuery.current !== query && query.trim() !== '') {
                (0, $033iF.addRecentSearch)(query, user.id, product.id, (0, $033iF.RECENT_SEARCH_KEY));
                previousQuery.current = query;
            }
        }
    }, [
        product?.id,
        query,
        user.id,
        overrideQuery
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        persistRecentSearch();
    }, [
        persistRecentSearch
    ]);
    const onEnter = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter') persistRecentSearch();
    }, [
        persistRecentSearch
    ]);
    return [
        onClick,
        onEnter
    ];
};
const $947af48e629e5ba7$export$c8074e5d4e733c21 = ({ children: children, overrideQuery: overrideQuery })=>{
    const [onClick, onEnter] = $947af48e629e5ba7$export$3adda20dc7f5408f(overrideQuery);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        onClick: onClick,
        onKeyDown: onEnter,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: '100%'
        },
        "data-testid": "persist-recent-search",
        children: children
    }));
};

});
parcelRegister("033iF", function(module, exports) {

$parcel$export(module.exports, "RECENT_SEARCH_KEY", () => $c020cb84bb06833e$export$ec4722d39a5031c0);
$parcel$export(module.exports, "addRecentSearch", () => $c020cb84bb06833e$export$74e99d9695eabee6);
$parcel$export(module.exports, "getRecentSearches", () => $c020cb84bb06833e$export$1216255791599668);
$parcel$export(module.exports, "removeRecentSearch", () => $c020cb84bb06833e$export$6adb2cc1366d1e30);
const $c020cb84bb06833e$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
const $c020cb84bb06833e$export$c1b7badf23670c19 = 50;
const $c020cb84bb06833e$export$74e99d9695eabee6 = (value, userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $c020cb84bb06833e$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId]) recentSearches[userId] = {};
    let userSearches = recentSearches[userId];
    if (!userSearches[product]) userSearches[product] = [];
    let productSearches = userSearches[product];
    const trimmedValue = value.trim();
    // Pop the last value of the array if it is too long
    if (productSearches.length === $c020cb84bb06833e$export$c1b7badf23670c19) productSearches.pop();
    // If the given value is a duplicate, remove it from the array
    if (productSearches.includes(trimmedValue)) productSearches = productSearches.filter((v)=>v !== trimmedValue);
    productSearches.unshift(trimmedValue);
    recentSearches[userId][product] = productSearches;
    $c020cb84bb06833e$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
};
const $c020cb84bb06833e$export$1216255791599668 = (userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $c020cb84bb06833e$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    const userSearches = recentSearches[userId] || {};
    return userSearches[product] || [];
};
const $c020cb84bb06833e$export$6adb2cc1366d1e30 = (value, userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $c020cb84bb06833e$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId] || !recentSearches[userId][product]) return [];
    recentSearches[userId][product] = recentSearches[userId][product].filter((v)=>v !== value);
    $c020cb84bb06833e$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
    return recentSearches[userId][product];
};
const $c020cb84bb06833e$var$setLocalStorageItem = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $c020cb84bb06833e$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};

});


parcelRegister("apEtD", function(module, exports) {

$parcel$export(module.exports, "SearchResultWrapper", () => $a349d88b309f0316$export$7ef688c5abd67ccc);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $hNXQY = parcelRequire("hNXQY");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a349d88b309f0316$var$QuickFindSearchResultWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1v67m8r-0"
})`display:flex;flex-direction:column;gap:${"var(--ds-space-025, 2px)"};padding:${"var(--ds-space-100, 8px)"};`;
const $a349d88b309f0316$export$7ef688c5abd67ccc = ({ children: children })=>{
    const { quickFind: quickFind } = (0, $hNXQY.useFeaturesContext)();
    return quickFind?.enabled ? /*#__PURE__*/ (0, $2OMIu.jsx)($a349d88b309f0316$var$QuickFindSearchResultWrapper, {
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("dOrUw", function(module, exports) {

$parcel$export(module.exports, "FeedbackFooter", () => $287dd821bdf974d0$export$e7b87342306a8337);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $c59Mn = parcelRequire("c59Mn");

var $6em9K = parcelRequire("6em9K");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $luzFO = parcelRequire("luzFO");
const $287dd821bdf974d0$var$footerContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    borderTop: '1px solid',
    borderColor: 'color.border',
    display: 'flex',
    alignItems: 'center',
    color: 'color.text',
    gap: 'space.150'
});
const $287dd821bdf974d0$export$e7b87342306a8337 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
        xcss: $287dd821bdf974d0$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $c59Mn.messages).quick_find_footer_text
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6em9K.default), {
                TriggerComponent: ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $luzFO.FeedbackButton), {
                        onClick: onClick
                    })
            })
        ]
    });
};

});
parcelRegister("6em9K", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $264736d3030d4874$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6ARj7 = parcelRequire("6ARj7");

var $i5re6 = parcelRequire("i5re6");

var $koVbs = parcelRequire("koVbs");

var $7VoGI = parcelRequire("7VoGI");

var $aoQqW = parcelRequire("aoQqW");


var $lvCts = parcelRequire("lvCts");

var $kv2Va = parcelRequire("kv2Va");

var $hNXQY = parcelRequire("hNXQY");

var $j97IK = parcelRequire("j97IK");

const $264736d3030d4874$var$AkFeedbackCollector = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("dVp9v")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $264736d3030d4874$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("dVp9v")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $264736d3030d4874$var$HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $264736d3030d4874$var$ENTRYPOINT_ID = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const $264736d3030d4874$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
/**
 * Feedback collector for extensible tabs in Quick Search i.e. confluence tab in QS and QF
 */ const $264736d3030d4874$var$FeedbackCollector = ({ TriggerComponent: TriggerComponent = (0, $aoQqW.FeedbackButton) })=>{
    const { user: user } = (0, $7VoGI.useUserContext)();
    const { name: name, id: id } = user;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $5uXOq.useState)(false);
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, $j97IK.useExperiments)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const activeProduct = getActiveProduct()?.title;
    const primaryProduct = getPrimaryProduct()?.title;
    const isHello = $264736d3030d4874$var$HELLO_TENANT_ID === cloudId;
    const isQuickFind = (0, $hNXQY.useFeaturesContext)().quickFind?.enabled;
    const experience = isQuickFind ? 'quick-find' : 'quick-search';
    const feedbackContext = JSON.stringify({
        experimentLayers: backendExperiment?.experimentLayers,
        frontendExperiments: frontendExperiments,
        frontendVersion: (0, $7531534e67cbfa1e$export$2db401a6b81eceee),
        product: activeProduct,
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        userId: id,
        source: 'product-search-dialog',
        isHello: isHello,
        experience: experience,
        release: (0, $i5re6.getProductReleaseVersion)(primaryProduct)
    });
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(TriggerComponent, {
                onClick: (e)=>{
                    e.preventDefault();
                    setIsOpen(true);
                }
            }),
            isOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($264736d3030d4874$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>setIsOpen(false),
                    onSubmit: ()=>setDisplayFlag(true),
                    atlassianAccountId: id,
                    name: name,
                    entrypointId: $264736d3030d4874$var$ENTRYPOINT_ID,
                    additionalFields: [
                        {
                            id: $264736d3030d4874$var$FEEDBACK_CONTEXT_CF,
                            value: feedbackContext
                        }
                    ]
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ARj7.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($264736d3030d4874$var$AkFeedbackFlag, {
                        locale: locale
                    })
                })
            })
        ]
    });
};
var $264736d3030d4874$export$2e2bcd8739ae039 = $264736d3030d4874$var$FeedbackCollector;

});
parcelRegister("i5re6", function(module, exports) {

$parcel$export(module.exports, "getProductReleaseVersion", () => $ff5cd6a755b3284a$export$d521605fb33b0dfd);
const $ff5cd6a755b3284a$var$memoizedQuerySelector = (selectors)=>{
    let element = null;
    return ()=>{
        if (!element) element = document.querySelector(selectors);
        return element;
    };
};
const $ff5cd6a755b3284a$export$d521605fb33b0dfd = (product)=>{
    switch(product?.toLowerCase()){
        case 'confluence':
            return window.__buildInfo?.FRONTEND_VERSION || 'noversion';
        case 'jira':
            return window.BUILD_KEY;
        case 'townsquare':
            const versionMeta = $ff5cd6a755b3284a$var$memoizedQuerySelector('meta[name="release-version"]');
            if (versionMeta instanceof HTMLMetaElement) return versionMeta.content;
    }
    return 'noversion';
};

});

parcelRegister("aoQqW", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $e053694233c54610$export$116fedbe5e2e2bd8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $k4hbD = parcelRequire("k4hbD");

var $eCeGD = parcelRequire("eCeGD");
function $e053694233c54610$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e053694233c54610$var$buttonStyles = {
    name: "1y6tyz0",
    styles: "margin:0 auto;width:fit-content"
};
const $e053694233c54610$export$116fedbe5e2e2bd8 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e053694233c54610$var$buttonStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eCeGD.default), {
        onClick: onClick,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $k4hbD.messages).common_give_feedback)));
};

});

const $7531534e67cbfa1e$var$packageName = "platform-pkg";
const $7531534e67cbfa1e$var$packageVersion = "0.0.0-use.local";
const $7531534e67cbfa1e$export$2db401a6b81eceee = `${$7531534e67cbfa1e$var$packageName}@${$7531534e67cbfa1e$var$packageVersion}`;

parcelRegister("dVp9v", function(module, exports) {

let $a2341bfc1b2544ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a2341bfc1b2544ce$var$load("ffQaD"),
    $a2341bfc1b2544ce$var$load("kvRbA"),
    $a2341bfc1b2544ce$var$load("l7nfE")
]).then(()=>parcelRequire('ncXSS'));

});


parcelRegister("luzFO", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $7f80209c20eb6026$export$116fedbe5e2e2bd8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8CUq3 = parcelRequire("8CUq3");

var $5ILhZ = parcelRequire("5ILhZ");

var $iqsNk = parcelRequire("iqsNk");
const $7f80209c20eb6026$var$feedbackButtonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.link',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $7f80209c20eb6026$export$116fedbe5e2e2bd8 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
        xcss: $7f80209c20eb6026$var$feedbackButtonStyles,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $iqsNk.messages).feedbackButton
        })
    });

});
parcelRegister("iqsNk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bde196608288079f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bde196608288079f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    feedbackButton: {
        id: 'feedback_button',
        defaultMessage: 'Give feedback',
        description: 'Click this button to give feedback for search.'
    }
});

});



parcelRegister("9KiUn", function(module, exports) {

$parcel$export(module.exports, "FilterFooter", () => $53e3819222dc3555$export$b4bfb1c3ed0cdeca);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $7anl7 = parcelRequire("7anl7");

var $1W52p = parcelRequire("1W52p");

var $c59Mn = parcelRequire("c59Mn");

var $2WacJ = parcelRequire("2WacJ");

var $7ttuB = parcelRequire("7ttuB");
const $53e3819222dc3555$export$b4bfb1c3ed0cdeca = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const confluenceIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
        appearance: "brand",
        size: "small"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ttuB.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WacJ.QuickFindAdvancedSearchLink), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.AdvancedSearchFooter), {
                squareReturnIcon: true,
                searchFooterLabel: formatMessage((0, $c59Mn.messages).quick_find_show_filtered_results),
                searchFooterLabelWithIcon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $c59Mn.messages).quick_find_show_filtered_results_with_icon,
                    values: {
                        confluenceIcon: confluenceIcon
                    }
                }),
                filterByProductFooter: true
            })
        })
    });
};

});
parcelRegister("2WacJ", function(module, exports) {

$parcel$export(module.exports, "QuickFindAdvancedSearchLink", () => $fdc46d020a4f9e19$export$a10ba81e8e8d140);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $fdc46d020a4f9e19$export$a10ba81e8e8d140 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e58cvu60"
})({
    borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span > a': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    }
});

});


parcelRegister("9bNhQ", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $69249c2884524feb$export$64ded8b71dfcba9e);
$parcel$export(module.exports, "SearchFooterPersistRecentSearch", () => $69249c2884524feb$export$8784f9fd2cdbbd0a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1W52p = parcelRequire("1W52p");

var $c59Mn = parcelRequire("c59Mn");

var $2WacJ = parcelRequire("2WacJ");

var $7ttuB = parcelRequire("7ttuB");
const $69249c2884524feb$export$64ded8b71dfcba9e = ({ linkComponent: linkComponent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WacJ.QuickFindAdvancedSearchLink), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.AdvancedSearchFooter), {
            linkComponent: linkComponent,
            squareReturnIcon: true,
            searchFooterLabel: formatMessage((0, $c59Mn.messages).quick_find_footer_full_page_search_link)
        })
    });
};
const $69249c2884524feb$export$8784f9fd2cdbbd0a = ({ linkComponent: linkComponent })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ttuB.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($69249c2884524feb$export$64ded8b71dfcba9e, {
            linkComponent: linkComponent
        })
    });
};

});

parcelRegister("gXkA8", function(module, exports) {

$parcel$export(module.exports, "PreQueryEmptyScreen", () => $00d6c8cbe57bc275$export$f16a7ed214a332fa);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4bcZr = parcelRequire("4bcZr");

var $c59Mn = parcelRequire("c59Mn");

var $ousew = parcelRequire("ousew");

const $00d6c8cbe57bc275$export$f76aab36aa9d8077 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("kvJs6")));
const $00d6c8cbe57bc275$export$f16a7ed214a332fa = ({})=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4bcZr.EmptyState), {
        Image: $00d6c8cbe57bc275$export$f76aab36aa9d8077,
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $c59Mn.messages).quick_find_no_content_header
        }),
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $c59Mn.messages).quick_find_no_content_body
        })
    });
};

});
parcelRegister("4bcZr", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $dda640ab52c1dabd$export$fddf379e22a74b00);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $azqDa = parcelRequire("azqDa");
const $dda640ab52c1dabd$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $azqDa.Wrapper), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)(Image, {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $azqDa.Title), {
                    children: title
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $azqDa.Content), {
                    children: content
                })
            ]
        })
    });

});
parcelRegister("azqDa", function(module, exports) {

$parcel$export(module.exports, "Title", () => $8f804d6b826fc48a$export$f99233281efd08a0);
$parcel$export(module.exports, "Content", () => $8f804d6b826fc48a$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Wrapper", () => $8f804d6b826fc48a$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");

var $3JZ8k = parcelRequire("3JZ8k");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
parcelRequire("5uXOq");

var $bWGt6 = parcelRequire("bWGt6");
const $8f804d6b826fc48a$var$TitleContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginTop: 'space.100'
});
const $8f804d6b826fc48a$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $8f804d6b826fc48a$var$TitleContainerStyles,
        children: children
    });
};
const $8f804d6b826fc48a$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ttkipm1"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $3JZ8k.grid).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $3JZ8k.primaryTextColour)
});
const $8f804d6b826fc48a$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ttkipm0"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $3JZ8k.grid).twice().px
});

});


parcelRegister("kvJs6", function(module, exports) {

let $eee9f5c5bfba671d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eee9f5c5bfba671d$var$load("fYBhV").then(()=>parcelRequire('2sLjS'));

});


parcelRegister("8ilpI", function(module, exports) {

$parcel$export(module.exports, "SearchErrorScreen", () => $3a578a54f04954f4$export$66fb8d8f30619036);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i5Ctj = parcelRequire("i5Ctj");
const $3a578a54f04954f4$export$66fb8d8f30619036 = ({ onRetry: onRetry = ()=>null })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5Ctj.default), {
        onRetry: onRetry
    });
};

});
parcelRegister("i5Ctj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9363639e1d8132c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4bcZr = parcelRequire("4bcZr");
var $kCMvS = parcelRequire("kCMvS");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $k4hbD = parcelRequire("k4hbD");

var $66ZQB = parcelRequire("66ZQB");

const $9363639e1d8132c1$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("32Pfw")));
class $9363639e1d8132c1$export$930da00ff8e1539f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4bcZr.EmptyState), {
            title: intl.formatMessage((0, $k4hbD.messages).common_error_state_failed_search_heading),
            Image: $9363639e1d8132c1$var$Image,
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args), this.getContent = ()=>{
            const { onRetry: onRetry } = this.props;
            const linkComponent = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $66ZQB.Button), {
                    ...props,
                    role: "button",
                    tabIndex: 0,
                    onClick: ()=>onRetry(),
                    onKeyDown: (event)=>event.key === 'Enter' ? onRetry() : undefined
                });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $k4hbD.messages).common_error_state_failed_search_body,
                values: {
                    emptyLink: (s)=>// eslint-disable-next-line jsx-a11y/anchor-is-valid
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kCMvS.Link), {
                            linkComponent: linkComponent,
                            href: '',
                            children: s
                        })
                }
            });
        };
    }
}
var $9363639e1d8132c1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($9363639e1d8132c1$export$930da00ff8e1539f);

});
parcelRegister("66ZQB", function(module, exports) {

$parcel$export(module.exports, "Button", () => $a41176d265b0ecd7$export$353f5b6fc5456de1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $a41176d265b0ecd7$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1hs8rk0"
})({
    color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    cursor: 'pointer'
});

});

parcelRegister("32Pfw", function(module, exports) {

let $2379500cac42f67b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2379500cac42f67b$var$load("4yAaN").then(()=>parcelRequire('4vwHe'));

});



parcelRegister("5IxfD", function(module, exports) {

$parcel$export(module.exports, "QuickFindRovoTip", () => $d768a0065491f860$export$719e67cc0251dc18);

var $2OMIu = parcelRequire("2OMIu");

var $e78BF = parcelRequire("e78BF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $eiKpf = parcelRequire("eiKpf");
var $54Fwx = parcelRequire("54Fwx");

var $42CjB = parcelRequire("42CjB");

var $c59Mn = parcelRequire("c59Mn");

var $73b2G = parcelRequire("73b2G");

var $3bJE0 = parcelRequire("3bJE0");
const $d768a0065491f860$var$RovoTipMessageStyle = (0, $8CUq3.xcss)({
    width: '95%',
    marginLeft: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050'
});
const $d768a0065491f860$var$RovoTipContainerStyle = (0, $8CUq3.xcss)({
    paddingTop: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $d768a0065491f860$var$RovoTipStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: `${"var(--ds-space-500, 40px)"}`,
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    borderRadius: `${"var(--ds-space-050, 4px)"}`,
    backgroundColor: 'color.background.accent.purple.subtlest',
    color: 'color.text.accent.purple'
});
const $d768a0065491f860$export$719e67cc0251dc18 = ()=>{
    const { showRovoTip: showRovoTip, dismissRovoTip: dismissRovoTip } = (0, $73b2G.useQuickFindRovoTip)();
    const { focusInput: focusInput } = (0, $3bJE0.useInputContext)();
    if (!showRovoTip) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $d768a0065491f860$var$RovoTipContainerStyle,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
            xcss: $d768a0065491f860$var$RovoTipStyle,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e78BF))), {
                    label: "blank",
                    color: "var(--ds-text-accent-purple, #5E4DB2)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
                    xcss: $d768a0065491f860$var$RovoTipMessageStyle,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                            children: "Rovo tip:"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $c59Mn.messages).quick_find_rovo_tip
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.EnlargedReturnIconContainer), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        icon: (0, $54Fwx.RemoveIcon),
                        spacing: 'compact',
                        onClick: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            dismissRovoTip();
                            focusInput && focusInput();
                        },
                        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $c59Mn.messages).remove_button_label
                        }),
                        appearance: 'subtle'
                    })
                })
            ]
        })
    });
};

});
parcelRegister("73b2G", function(module, exports) {

$parcel$export(module.exports, "useQuickFindRovoTip", () => $f26cc4706fba3d7f$export$ccc3a6663aee8d48);

var $5uXOq = parcelRequire("5uXOq");

var $c7qbA = parcelRequire("c7qbA");

var $7VoGI = parcelRequire("7VoGI");

var $kv2Va = parcelRequire("kv2Va");
const $f26cc4706fba3d7f$export$ccc3a6663aee8d48 = ()=>{
    const { user: user } = (0, $7VoGI.useUserContext)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const product = getActiveProduct();
    const [showRovoTip, setShowRovoTip] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (!product) return;
        const rovoTipFromLocalStorage = (0, $c7qbA.getRovoTip)(product.id, user?.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        user.id,
        product
    ]);
    const dismissRovoTip = (0, $5uXOq.useCallback)(()=>{
        if (product?.id) {
            const rovoTipFromLocalStorage = (0, $c7qbA.setRovoTip)(product.id, user?.id);
            setShowRovoTip(rovoTipFromLocalStorage);
        }
    }, [
        user.id,
        product
    ]);
    return {
        showRovoTip: showRovoTip,
        dismissRovoTip: dismissRovoTip
    };
};

});
parcelRegister("c7qbA", function(module, exports) {

$parcel$export(module.exports, "getRovoTip", () => $180f656868691a56$export$b9330795d9444727);
$parcel$export(module.exports, "setRovoTip", () => $180f656868691a56$export$297a6fb093b042a3);
const $180f656868691a56$export$568e0ce3cc5a9972 = 'atlassian.unified-search.quick-find-rovo-tip';
const $180f656868691a56$export$4bac6b574c2c1d97 = 'anonymous-user';
const $180f656868691a56$export$b9330795d9444727 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $180f656868691a56$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = $180f656868691a56$var$getLocalStorageItem($180f656868691a56$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    const rovoTipProducts = rovoTip[userIdOrAnonymous] || {};
    return rovoTipProducts[productId] === undefined ? true : rovoTipProducts[productId];
};
const $180f656868691a56$export$297a6fb093b042a3 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $180f656868691a56$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = $180f656868691a56$var$getLocalStorageItem($180f656868691a56$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    if (!rovoTip[userIdOrAnonymous]) rovoTip[userIdOrAnonymous] = {};
    rovoTip[userIdOrAnonymous][productId] = false;
    $180f656868691a56$var$setLocalStorageItem($180f656868691a56$export$568e0ce3cc5a9972, JSON.stringify(rovoTip));
    return rovoTip[userIdOrAnonymous][productId];
};
const $180f656868691a56$var$setLocalStorageItem = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $180f656868691a56$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};

});


parcelRegister("3bJE0", function(module, exports) {

$parcel$export(module.exports, "InputContext", () => $2f62bc43e1f7b917$export$37fb8590cf2c088c);
$parcel$export(module.exports, "useInputContext", () => $2f62bc43e1f7b917$export$25c2004aac4f3cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $2f62bc43e1f7b917$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    focusInput: undefined
});
const $2f62bc43e1f7b917$export$37fb8590cf2c088c = ({ children: children, forwardRef: forwardRef })=>{
    const focusInput = (0, $5uXOq.useCallback)(()=>{
        if (typeof forwardRef === 'object') forwardRef?.current?.focus();
    }, [
        forwardRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f62bc43e1f7b917$var$Context.Provider, {
        value: {
            focusInput: focusInput
        },
        children: children
    });
};
const $2f62bc43e1f7b917$export$25c2004aac4f3cc = ()=>{
    return (0, $5uXOq.useContext)($2f62bc43e1f7b917$var$Context);
};

});


parcelRegister("7JF8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde1580d0c592255$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gsomE = parcelRequire("gsomE");

var $3FqY6 = parcelRequire("3FqY6");

var $1FaYJ = parcelRequire("1FaYJ");
var $cI0dp = parcelRequire("cI0dp");

var $2dI5H = parcelRequire("2dI5H");

var $j4xTD = parcelRequire("j4xTD");

var $71Kgw = parcelRequire("71Kgw");

var $337hv = parcelRequire("337hv");
const $dde1580d0c592255$var$NoResultsWithHooks = ({ urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', advancedSearchSelected: advancedSearchSelected, fromQuickFindPostQueryNoResults: fromQuickFindPostQueryNoResults })=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $j4xTD.useAutocorrectionEnabled)();
    const advancedSearchUrl = urlGeneratorForNoResultsScreen(query); // TODO: needs filters here
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            autocorrectionEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $71Kgw.AutocorrectAsyncWrapper), {
                container: (0, $337hv.NoResultsAutocorrectWrapper)
            }),
            fromQuickFindPostQueryNoResults ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cI0dp.default), {
                advancedSearchUrl: advancedSearchUrl,
                advancedSearchSelected: advancedSearchSelected
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1FaYJ.default), {
                advancedSearchUrl: advancedSearchUrl,
                advancedSearchSelected: advancedSearchSelected
            })
        ]
    });
};
var $dde1580d0c592255$export$2e2bcd8739ae039 = (0, $gsomE.withAnalytics)({
    advancedSearchSelected: (0, $3FqY6.onAdvancedSearchSelected)
})($dde1580d0c592255$var$NoResultsWithHooks);

});
parcelRegister("gsomE", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $2f16f957c4f4adf8$export$af9baadf0e4f6e13);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $3FqY6 = parcelRequire("3FqY6");
function $2f16f957c4f4adf8$export$af9baadf0e4f6e13(analytics) {
    return (Component)=>{
        class WrappedComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
            render() {
                const { createAnalyticsEvent: createAnalyticsEvent, ...rest } = this.props;
                // There is NOT typesafety for the next line as typescript cannot infer types correctly with spread operators.
                // This is just going to have to go without type safety for the next line.
                return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...rest,
                    ...this.wrappedAnalyticsCallback
                });
            }
            constructor(...args){
                super(...args), this.wrappedAnalyticsCallback = Object.keys(analytics).reduce((acc, key)=>({
                        ...acc,
                        // We forward all args to the corresponding callback regardless of type
                        [key]: (...args)=>{
                            this.props.createAnalyticsEvent && this.props.createAnalyticsEvent(analytics[key](...args)).fire((0, $3FqY6.DEFAULT_GAS_CHANNEL));
                        }
                    }), {});
            }
        }
        return (0, $cb25w.default)()(WrappedComponent);
    };
}

});

parcelRegister("1FaYJ", function(module, exports) {

$parcel$export(module.exports, "Image", () => $7c121ea0aed31f46$export$3e431a229df88919);
$parcel$export(module.exports, "default", () => $7c121ea0aed31f46$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4bcZr = parcelRequire("4bcZr");
var $kCMvS = parcelRequire("kCMvS");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $8oG5R = parcelRequire("8oG5R");

var $3FqY6 = parcelRequire("3FqY6");

var $k4hbD = parcelRequire("k4hbD");

var $fVnbM = parcelRequire("fVnbM");

var $c1tQw = parcelRequire("c1tQw");

const $7c121ea0aed31f46$export$3e431a229df88919 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("6YVxx")));
class $7c121ea0aed31f46$export$ef6006467f04ee41 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4bcZr.EmptyState), {
            title: intl.formatMessage((0, $k4hbD.messages).common_empty_state_heading),
            Image: $7c121ea0aed31f46$export$3e431a229df88919,
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args), this.onAdvancedSearchClicked = (e)=>{
            const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
            advancedSearchSelected({
                trigger: (0, $8oG5R.getTrigger)(e),
                actionSubjectId: (0, $3FqY6.AdvancedSearchLinkSubjectId).NO_RESULTS,
                isLoading: false,
                newTab: (0, $8oG5R.isNewTab)(e)
            });
            onClick && onClick(advancedSearchUrl, e);
        }, this.getContent = ()=>{
            const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
            if (!hasFilters) return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                role: "none",
                onClick: this.onAdvancedSearchClicked,
                children: isMultiSite || !advancedSearchUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $k4hbD.messages).common_empty_state_body_no_advanced_search
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $k4hbD.messages).common_empty_state_body,
                    values: {
                        a: (s)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kCMvS.Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl,
                                children: s
                            })
                    }
                })
            }));
            else return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        tagName: "div",
                        ...(0, $k4hbD.messages).filters_applied
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c1tQw.ClearFiltersButtonWrapper), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "primary",
                            onClick: clearFilters,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $k4hbD.messages).clear_filters
                            })
                        })
                    })
                ]
            });
        };
    }
}
var $7c121ea0aed31f46$export$2e2bcd8739ae039 = (0, $8RXs9.default)($7c121ea0aed31f46$export$ef6006467f04ee41);

});
parcelRegister("c1tQw", function(module, exports) {

$parcel$export(module.exports, "ClearFiltersButtonWrapper", () => $a9d1644c82c28bc4$export$8c06dfd742f74a6f);

var $bWGt6 = parcelRequire("bWGt6");
function $a9d1644c82c28bc4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a9d1644c82c28bc4$export$8c06dfd742f74a6f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eg9i8g80"
})({
    name: "1y04g5d",
    styles: "padding-top:var(--ds-space-400, 32px)"
});

});

parcelRegister("6YVxx", function(module, exports) {

let $5154fae378f5cf15$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5154fae378f5cf15$var$load("7B6Sc").then(()=>parcelRequire('4iDjt'));

});


parcelRegister("cI0dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8058a8d49035bb5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4bcZr = parcelRequire("4bcZr");
var $kCMvS = parcelRequire("kCMvS");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $8oG5R = parcelRequire("8oG5R");

var $3FqY6 = parcelRequire("3FqY6");

var $k4hbD = parcelRequire("k4hbD");

var $c59Mn = parcelRequire("c59Mn");

var $fVnbM = parcelRequire("fVnbM");

var $c1tQw = parcelRequire("c1tQw");

var $1FaYJ = parcelRequire("1FaYJ");
class $c8058a8d49035bb5$export$be28e1c115e337c7 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4bcZr.EmptyState), {
            title: intl.formatMessage((0, $c59Mn.messages).quick_find_post_query_no_results_header),
            Image: (0, $1FaYJ.Image),
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args), this.onAdvancedSearchClicked = (e)=>{
            const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
            advancedSearchSelected({
                trigger: (0, $8oG5R.getTrigger)(e),
                actionSubjectId: (0, $3FqY6.AdvancedSearchLinkSubjectId).NO_RESULTS,
                isLoading: false,
                newTab: (0, $8oG5R.isNewTab)(e)
            });
            onClick && onClick(advancedSearchUrl, e);
        }, this.getContent = ()=>{
            const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
            if (!hasFilters) return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                role: "none",
                onClick: this.onAdvancedSearchClicked,
                children: isMultiSite || !advancedSearchUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $k4hbD.messages).common_empty_state_body_no_advanced_search
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $c59Mn.messages).quick_find_post_query_no_results_body,
                    values: {
                        SearchContentLink: (s)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kCMvS.Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl,
                                children: s
                            })
                    }
                })
            }));
            else return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        tagName: "div",
                        ...(0, $k4hbD.messages).filters_applied
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c1tQw.ClearFiltersButtonWrapper), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "primary",
                            onClick: clearFilters,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $k4hbD.messages).clear_filters
                            })
                        })
                    })
                ]
            });
        };
    }
}
var $c8058a8d49035bb5$export$2e2bcd8739ae039 = (0, $8RXs9.default)($c8058a8d49035bb5$export$be28e1c115e337c7);

});

parcelRegister("j4xTD", function(module, exports) {

$parcel$export(module.exports, "AUTOCORRECT_API_PATH", () => $bbfab367b46fb33c$export$9e194549e403d7c0);
$parcel$export(module.exports, "DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS", () => $bbfab367b46fb33c$export$8cc0d0855105f007);
$parcel$export(module.exports, "isSupportedLanguage", () => $bbfab367b46fb33c$export$47c66070d6d6cd6d);
$parcel$export(module.exports, "sanitizeLanguage", () => $bbfab367b46fb33c$export$2c7172743adddb3f);
$parcel$export(module.exports, "shouldFetchAutocorrection", () => $bbfab367b46fb33c$export$68b44e0f3b4076e);
$parcel$export(module.exports, "useAutocorrectionEnabled", () => $bbfab367b46fb33c$export$bf742519320d45e9);
$parcel$export(module.exports, "fetchAutocorrection", () => $bbfab367b46fb33c$export$ac1bfa03f151bc79);

var $koVbs = parcelRequire("koVbs");

var $iCBcG = parcelRequire("iCBcG");

var $dS9cn = parcelRequire("dS9cn");

var $kv2Va = parcelRequire("kv2Va");
var $bbfab367b46fb33c$var$SUPPORTED_LANGUAGES = /*#__PURE__*/ function(SUPPORTED_LANGUAGES) {
    SUPPORTED_LANGUAGES["English"] = "en";
    return SUPPORTED_LANGUAGES;
}($bbfab367b46fb33c$var$SUPPORTED_LANGUAGES || {});
const $bbfab367b46fb33c$export$9e194549e403d7c0 = 'autocorrect';
const $bbfab367b46fb33c$export$8cc0d0855105f007 = 250;
const $bbfab367b46fb33c$export$47c66070d6d6cd6d = (language)=>{
    return Object.values($bbfab367b46fb33c$var$SUPPORTED_LANGUAGES).includes(language);
};
const $bbfab367b46fb33c$export$2c7172743adddb3f = (locale)=>{
    if (locale.includes('-')) return locale.split('-')[0];
    return locale;
};
const $bbfab367b46fb33c$export$68b44e0f3b4076e = (query)=>{
    return query.length >= 4;
};
const $bbfab367b46fb33c$export$bf742519320d45e9 = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    const lang = $bbfab367b46fb33c$export$2c7172743adddb3f(locale);
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const product = getActiveProduct();
    return {
        autocorrectionEnabled: !!product?.autocorrectEnabled && $bbfab367b46fb33c$export$47c66070d6d6cd6d(lang),
        productId: product?.id || ''
    };
};
const $bbfab367b46fb33c$export$ac1bfa03f151bc79 = (0, (/*@__PURE__*/$parcel$interopDefault($iCBcG)))(({ query: query, aggregatorUrl: aggregatorUrl, lang: lang, cloudId: cloudId })=>{
    return (0, $dS9cn.utils).requestService({
        url: aggregatorUrl
    }, {
        path: `${$bbfab367b46fb33c$export$9e194549e403d7c0}`,
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                language: lang,
                cloudId: cloudId
            })
        }
    });
}, $bbfab367b46fb33c$export$8cc0d0855105f007);

});
parcelRegister("iCBcG", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $d8e8a274648ab511$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $d8e8a274648ab511$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $d8e8a274648ab511$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $d8e8a274648ab511$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});


parcelRegister("71Kgw", function(module, exports) {

$parcel$export(module.exports, "AutocorrectAsyncWrapper", () => $a8d174fe7b782e45$export$5e9f08d9cf554737);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $a8d174fe7b782e45$var$LoadedAutocorrection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("9FIwE")).then(({ LoadedAutocorrection: LoadedAutocorrection })=>({
            default: LoadedAutocorrection
        })));
const $a8d174fe7b782e45$export$5e9f08d9cf554737 = ({ container: container, fallback: fallback })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($a8d174fe7b782e45$var$LoadedAutocorrection, {
            container: container,
            fallback: fallback
        })
    });
};

});
parcelRegister("9FIwE", function(module, exports) {

let $01d1338969add2d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01d1338969add2d7$var$load("jexs2").then(()=>parcelRequire('kS6aD'));

});


parcelRegister("337hv", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $322b20dd6ad0e588$export$44c18d210d5de37b);
$parcel$export(module.exports, "TextLabelWrapper", () => $322b20dd6ad0e588$export$379a552b6c4d77e1);
$parcel$export(module.exports, "TextCorrectionWrapper", () => $322b20dd6ad0e588$export$98340ed1d0e44a86);
$parcel$export(module.exports, "AutocorrectWrapper", () => $322b20dd6ad0e588$export$c349a6e4bcccfcee);
$parcel$export(module.exports, "NoResultsAutocorrectWrapper", () => $322b20dd6ad0e588$export$4bdce96b0ba50afe);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
function $322b20dd6ad0e588$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $322b20dd6ad0e588$export$44c18d210d5de37b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e23w5vh4"
})({
    backgroundColor: `var(--ds-surface, ${`${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)}`})`,
    height: '16px',
    width: '128px',
    borderRadius: '3px'
});
const $322b20dd6ad0e588$export$379a552b6c4d77e1 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e23w5vh3"
})({
    color: `var(--ds-text-accent-red, ${`${(0, $829f609a65d26a98$export$2010d0fb4295b346)}`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $322b20dd6ad0e588$export$98340ed1d0e44a86 = /*#__PURE__*/ (0, $bWGt6.default)("a", {
    target: "e23w5vh2"
})({
    cursor: 'pointer',
    color: `var(--ds-text-accent-blue, ${`${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)}`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $322b20dd6ad0e588$export$c349a6e4bcccfcee = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e23w5vh1"
})({
    name: "wf8ttk",
    styles: "text-transform:initial;font-weight:initial"
});
const $322b20dd6ad0e588$export$4bdce96b0ba50afe = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e23w5vh0"
})({
    name: "stwpk3",
    styles: "margin-top:var(--ds-space-100, 8px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-left:var(--ds-space-200, 16px)"
});

});



parcelRegister("hyCj5", function(module, exports) {

$parcel$export(module.exports, "QuickFindConfluenceTransformer", () => $b4e0a31d5cd30309$export$d1cc89207db04ec4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jTmj1 = parcelRequire("jTmj1");

var $5F6IF = parcelRequire("5F6IF");

var $7gTwf = parcelRequire("7gTwf");

var $fkSsY = parcelRequire("fkSsY");

var $4Cvc8 = parcelRequire("4Cvc8");

var $6NSru = parcelRequire("6NSru");
const $b4e0a31d5cd30309$export$d1cc89207db04ec4 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jTmj1.PreQueryFilterTransformer), {
        ...rest,
        children: (args)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5F6IF.PreQueryRecentlyViewedTransformer), {
                ...args,
                children: (args)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gTwf.RecentSearchesTransformer), {
                        ...args,
                        children: (args)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fkSsY.QueryFilterTransformer), {
                                ...args,
                                children: (args)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Cvc8.PostQueryRecentlyViewedTransformer), {
                                        ...args,
                                        children: (args)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6NSru.DeduplicateRecentlyViewedAndResultsTransformer), {
                                                ...args,
                                                children: (args)=>children(args)
                                            })
                                    })
                            })
                    })
            })
    });
};

});
parcelRegister("jTmj1", function(module, exports) {

$parcel$export(module.exports, "PreQueryFilterTransformer", () => $0aca07f3068a99cf$export$eb528a71db3ec636);

var $gGW0q = parcelRequire("gGW0q");

var $2dI5H = parcelRequire("2dI5H");
const $0aca07f3068a99cf$export$eb528a71db3ec636 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const filteredPreQuerySections = query ? preQueryItems.sections : preQueryItems.sections.filter((section)=>section.id !== (0, $gGW0q.RECENT_SPACES_SECTION_ID));
    const filteredPreQueryItems = {
        sections: filteredPreQuerySections,
        size: filteredPreQuerySections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0)
    };
    return children({
        preQueryItems: filteredPreQueryItems,
        postQueryItems: postQueryItems,
        productState: productState
    });
};

});

parcelRegister("5F6IF", function(module, exports) {

$parcel$export(module.exports, "PreQueryRecentlyViewedTransformer", () => $100a41540d6269e5$export$4cf1eef5109c47c9);

var $8RXs9 = parcelRequire("8RXs9");

var $c59Mn = parcelRequire("c59Mn");

var $5gpK9 = parcelRequire("5gpK9");
const $100a41540d6269e5$export$8d431b8c84c2735b = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const newPreQueryItemsSections = preQueryItems.sections.map((section, i)=>{
        if (section.id === (0, $5gpK9.RECENT_SEARCHES_SECTION_ID) || section.searchResults.length === 0) return section;
        else {
            const newSection = {
                ...section,
                title: intl.formatMessage((0, $c59Mn.messages).quick_find_recently_viewed)
            };
            return newSection;
        }
    });
    preQueryItems.sections = newPreQueryItemsSections;
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItems,
        productState: productState
    });
};
const $100a41540d6269e5$export$4cf1eef5109c47c9 = (0, $8RXs9.default)($100a41540d6269e5$export$8d431b8c84c2735b);

});
parcelRegister("5gpK9", function(module, exports) {

$parcel$export(module.exports, "RECENT_SEARCHES_SECTION_ID", () => $30106d69ed0c6a1b$export$6c90641783086ccb);
$parcel$export(module.exports, "useRecentSearchesSection", () => $30106d69ed0c6a1b$export$e5468815b4eb37d);

var $2OMIu = parcelRequire("2OMIu");

var $b2Pj5 = parcelRequire("b2Pj5");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $c59Mn = parcelRequire("c59Mn");

var $kv2Va = parcelRequire("kv2Va");

var $2dI5H = parcelRequire("2dI5H");

var $b3QDU = parcelRequire("b3QDU");

var $l431r = parcelRequire("l431r");

var $lywjH = parcelRequire("lywjH");

var $7ttuB = parcelRequire("7ttuB");

var $3bJE0 = parcelRequire("3bJE0");
const $30106d69ed0c6a1b$export$6c90641783086ccb = 'recent-searches';
const $30106d69ed0c6a1b$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY = 3;
const $30106d69ed0c6a1b$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY = 1;
const $30106d69ed0c6a1b$export$e5468815b4eb37d = ()=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const { focusInput: focusInput } = (0, $3bJE0.useInputContext)();
    const { recentSearchItems: recentSearchItems, removeRecentSearch: removeRecentSearch } = (0, $b3QDU.useRecentSearches)({
        Icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l431r.QuickFindIcon), {})
    });
    const recentSearches = recentSearchItems.map((result)=>({
            id: result.id,
            title: result.title,
            icon: result.icon,
            url: getActiveProduct()?.generateAdvancedSearchUrl?.(result.title) || '',
            meta: '',
            additionalMeta: query !== '' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $c59Mn.messages).quick_find_recent_search_text_dialog
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $c59Mn.messages).quick_find_recent_search
            })
        }));
    const recentSearchesSection = (0, $5uXOq.useMemo)(()=>{
        return {
            id: $30106d69ed0c6a1b$export$6c90641783086ccb,
            title: '',
            searchResults: recentSearches,
            resultRenderer: ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted, isCollapsed: isCollapsed })=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ttuB.PersistRecentSearch), {
                    overrideQuery: searchResult.title,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b2Pj5.EnlargedSearchResultContent), {
                        ...searchResult,
                        icon: searchResult.icon,
                        isKeyboardHighlighted: isKeyboardHighlighted,
                        isCollapsed: isCollapsed,
                        isRecentSearch: true,
                        onRemove: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            removeRecentSearch(searchResult.title);
                            focusInput && focusInput();
                        },
                        displayAdditionalMetaWhenHighlightedOnly: query === ''
                    })
                });
            },
            resultLimit: query ? $30106d69ed0c6a1b$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY : $30106d69ed0c6a1b$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY,
            useAnalyticsOverride: ({ screen: screen })=>(0, $lywjH.useSearchResultAnalyticsCallbacks)({
                    screen: screen,
                    actionSubject: 'recentSearch'
                })
        };
    }, [
        query,
        recentSearches,
        removeRecentSearch,
        focusInput
    ]);
    return recentSearchesSection;
};

});
parcelRegister("b3QDU", function(module, exports) {

$parcel$export(module.exports, "useRecentSearches", () => $7d5696f9b254c3ec$export$d349a1b1b7874c14);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VoGI = parcelRequire("7VoGI");

var $033iF = parcelRequire("033iF");

var $kv2Va = parcelRequire("kv2Va");

var $3ewb4 = parcelRequire("3ewb4");

var $8oG5R = parcelRequire("8oG5R");
const $7d5696f9b254c3ec$export$e0495117e49f394c = 50; // It can be different from the number of records in local storage
const $7d5696f9b254c3ec$export$d349a1b1b7874c14 = ({ Icon: Icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3ewb4.DefaultIcon), {}), limit: limit = $7d5696f9b254c3ec$export$e0495117e49f394c })=>{
    const { user: user } = (0, $7VoGI.useUserContext)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const product = getActiveProduct();
    const [recentSearchItems, setRecentSearchItems] = (0, $5uXOq.useState)([]);
    const memoizedIcon = (0, $5uXOq.useMemo)(()=>Icon, [
        Icon
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!product || !user.id) return;
        const recentSearches = (0, $033iF.getRecentSearches)(user.id, product.id, (0, $033iF.RECENT_SEARCH_KEY));
        const searchResults = recentSearches.map((value)=>({
                id: (0, $8oG5R.sha256Hash)(value),
                title: value,
                icon: memoizedIcon
            }));
        if (recentSearchItems.length === 0 && searchResults.length > 0) setRecentSearchItems(searchResults);
    }, [
        product,
        user.id,
        memoizedIcon,
        recentSearchItems.length
    ]);
    const removeRecentSearch = (0, $5uXOq.useCallback)((query)=>{
        if (user?.id && product?.id) {
            const recentSearches = (0, $033iF.removeRecentSearch)(query, user.id, product.id, (0, $033iF.RECENT_SEARCH_KEY));
            if (recentSearches) {
                const searchResults = recentSearches.map((value)=>({
                        id: (0, $8oG5R.sha256Hash)(value),
                        title: value,
                        icon: memoizedIcon
                    }));
                setRecentSearchItems(searchResults);
            }
        }
    }, [
        product,
        user.id,
        memoizedIcon
    ]);
    return {
        recentSearchItems: recentSearchItems.slice(0, limit),
        removeRecentSearch: removeRecentSearch
    };
};

});
parcelRegister("3ewb4", function(module, exports) {

$parcel$export(module.exports, "DefaultIcon", () => $bddf1c2f5cf58373$export$d206ce4c12e8ddf6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $feC7X = parcelRequire("feC7X");


var $bWGt6 = parcelRequire("bWGt6");
function $bddf1c2f5cf58373$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bddf1c2f5cf58373$var$IconContainer = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "eao5nkl0"
})({
    name: "1kyddlo",
    styles: "margin-left:var(--ds-space-negative-025, -2px);margin-top:var(--ds-space-025, 2px)"
});
const $bddf1c2f5cf58373$export$d206ce4c12e8ddf6 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($bddf1c2f5cf58373$var$IconContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($feC7X))), {
            color: `var(--ds-icon-accent-gray, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "recent-search"
        })
    });

});
parcelRegister("feC7X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c9c914f8f7a3631a5a598f1ef46602e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b175bd18e8763918$var$_react = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b175bd18e8763918$var$_clock = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("hyKRO")));

var $b175bd18e8763918$var$_frequent = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("6uqJA")));
function $b175bd18e8763918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "EmojiFrequentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b175bd18e8763918$var$ClockIcon = (props)=>/*#__PURE__*/ $b175bd18e8763918$var$_react.default.createElement($b175bd18e8763918$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $b175bd18e8763918$var$_frequent.default
    }, props));
$b175bd18e8763918$var$ClockIcon.Name = 'ClockIconMigration';
var $b175bd18e8763918$var$_default = module.exports.default = $b175bd18e8763918$var$ClockIcon;

});
parcelRegister("6uqJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
function $4b9a484973717fe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $4b9a484973717fe2$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $4b9a484973717fe2$var$_clock.default
    }));
$4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;

});




parcelRegister("l431r", function(module, exports) {

$parcel$export(module.exports, "QuickFindIcon", () => $5c0fbc733091b4c7$export$f5db5b3314f27023);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $feC7X = parcelRequire("feC7X");


var $bWGt6 = parcelRequire("bWGt6");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c0fbc733091b4c7$var$IconContainer = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e10r90tl0"
})({
    background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-400, 4px)",
    border: "'1px solid transparent'"
});
const $5c0fbc733091b4c7$export$f5db5b3314f27023 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($5c0fbc733091b4c7$var$IconContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($feC7X))), {
            color: `var(--ds-icon-accent-gray, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "recent-search"
        })
    });

});



parcelRegister("7gTwf", function(module, exports) {

$parcel$export(module.exports, "RecentSearchesTransformer", () => $b0c7bbcbd5e831f0$export$2142bc2fa441a5b0);

var $5gpK9 = parcelRequire("5gpK9");
const $b0c7bbcbd5e831f0$export$2142bc2fa441a5b0 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const recentSearchesSection = (0, $5gpK9.useRecentSearchesSection)();
    const preQueryItemsWithRecentSearches = {
        sections: [
            recentSearchesSection,
            ...preQueryItems.sections
        ],
        size: preQueryItems.size
    };
    return children({
        preQueryItems: preQueryItemsWithRecentSearches,
        postQueryItems: postQueryItems,
        productState: productState
    });
};

});

parcelRegister("fkSsY", function(module, exports) {

$parcel$export(module.exports, "QueryFilterTransformer", () => $f230ac300e4f3052$export$308bb2328bfeb2be);

var $2dI5H = parcelRequire("2dI5H");

var $hkGQV = parcelRequire("hkGQV");
const $f230ac300e4f3052$var$RECENTLY_VIEWED_ITEMS_SHOWN = 10;
const $f230ac300e4f3052$export$308bb2328bfeb2be = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const filteredPreQueryItems = (0, $hkGQV.filterAllSectionItems)({
        sections: preQueryItems.sections,
        size: preQueryItems.size
    }, query, $f230ac300e4f3052$var$RECENTLY_VIEWED_ITEMS_SHOWN);
    const highlightedPostQueryItems = (0, $hkGQV.highlightPostQueryResultTitles)(postQueryItems, query);
    return children({
        preQueryItems: filteredPreQueryItems,
        postQueryItems: highlightedPostQueryItems,
        productState: productState
    });
};

});
parcelRegister("hkGQV", function(module, exports) {

$parcel$export(module.exports, "filterFirstSectionItems", () => $991a69ad04863d88$export$c942155d15f72814);
$parcel$export(module.exports, "filterAllSectionItems", () => $991a69ad04863d88$export$f48d35d3732436aa);
$parcel$export(module.exports, "highlightPostQueryResultTitles", () => $991a69ad04863d88$export$630e09546900f38e);
$parcel$export(module.exports, "mergeFirstSectionSearchItems", () => $991a69ad04863d88$export$c28e3f530240553c);

var $lha1K = parcelRequire("lha1K");

var $5gpK9 = parcelRequire("5gpK9");

var $3JOCw = parcelRequire("3JOCw");
const $991a69ad04863d88$export$c942155d15f72814 = (searchItems, query, numberOfResultItems = 3)=>{
    if (!searchItems.sections[0]) return searchItems;
    const filteredSearchResults = searchItems.sections[0].searchResults.filter((item)=>{
        return item.title.toLowerCase().includes(query.toLowerCase());
    }).slice(0, numberOfResultItems);
    return {
        size: filteredSearchResults.length,
        sections: [
            {
                ...searchItems.sections[0],
                searchResults: filteredSearchResults
            }
        ]
    };
};
const $991a69ad04863d88$export$f48d35d3732436aa = (searchItems, query, numberOfResultItems = 3)=>{
    if (query === '') return searchItems;
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredSearchSections = searchItems.sections.map((section)=>{
        return {
            ...section,
            searchResults: section.searchResults.map((item)=>{
                // 1st pass
                const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
                    if (!acc) return acc;
                    return item.title.toLowerCase().includes(word.toLowerCase());
                }, true);
                if (doAllWordsMatch) {
                    // 2nd and 3rd Pass
                    const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $lha1K.highlightMatchedText)(item.title, wordsInQuery);
                    itemScoreMap[item.id] = score;
                    return {
                        ...item,
                        highlightedTitle: section.id !== (0, $5gpK9.RECENT_SEARCHES_SECTION_ID) ? highlightedTitle : negatedHighlightedTitle
                    };
                }
                return null;
            }).filter((item)=>item).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.id] - itemScoreMap[item.id] : 0).slice(0, numberOfResultItems)
        };
    });
    const size = filteredSearchSections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0);
    return {
        size: size,
        sections: filteredSearchSections
    };
};
const $991a69ad04863d88$export$630e09546900f38e = (postQueryItems, query)=>{
    const wordsInQuery = query.split(' ');
    const highlightedSearchSections = postQueryItems.sections.map((section)=>{
        return {
            ...section,
            searchResults: section.searchResults.map((item)=>{
                const { highlightedTitle: highlightedTitle } = (0, $lha1K.highlightMatchedText)(item.title, wordsInQuery);
                return {
                    ...item,
                    highlightedTitle: highlightedTitle
                };
            })
        };
    });
    return {
        size: postQueryItems.size,
        sections: highlightedSearchSections
    };
};
const $991a69ad04863d88$export$c28e3f530240553c = (intermediateSearchItems, postQuerySearchItems)=>{
    if (!intermediateSearchItems.sections[0] || intermediateSearchItems.sections[0]?.searchResults.length === 0) return postQuerySearchItems;
    if (!postQuerySearchItems.sections[0] || postQuerySearchItems.sections[0]?.searchResults.length === 0) return intermediateSearchItems;
    const fullMergedResultsList = [
        ...intermediateSearchItems.sections[0].searchResults.map((result)=>({
                ...result,
                isRecentResult: true
            })),
        ...postQuerySearchItems.sections[0].searchResults
    ];
    const deduplicatedList = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(fullMergedResultsList, (item)=>item.id);
    const sections = [
        {
            ...postQuerySearchItems.sections[0],
            searchResults: deduplicatedList
        }
    ];
    return {
        size: sections.reduce((accumulator, currentElem)=>accumulator + currentElem.searchResults.length, 0),
        sections: sections
    };
};

});
parcelRegister("lha1K", function(module, exports) {

$parcel$export(module.exports, "highlightMatchedText", () => $0360f977acb1f130$export$9f4c92a576b56d82);
/**
 * Breakdown of the filtering & ordering logic :
 *
 * 0th pass: if the string has any highlight tags, remove them and continue
 * An alternate could be to exit early, but then we don't have the scoring information from the later passes
 *
 * 1st Pass - Complete match of query broken by words - This checks that all the words of the query must occur somewhere in the Title.
 *    - This is case insensitive.
 *    - This is unordered.
 *    For eg -
 *    Query - "mad max" will NOT let "Nomad" or "Climax" pass through,
 *    but  "Nomad Climax", "Madmax", "max Mad" will pass through
 *
 * 2nd Pass Scoring - Score calculation based on the kind of matches.
 *    There are 3 types - Exact match, StartsWith match & Partial match
 *    For eg -
 *    Exact Match (Score = 100) - Query: "Mad" will score "mad", "mad max" with 100.
 *            Note: Special characters stripped -  "Mad" will score "mad-max", "max-mad" with 100.
 *    StartsWith Match (Score = 10) - Query: "ark" will score "ARKK" and "Arkose Meeting" as 10
 *    Partial Match (Score = 1) - Query: "mad max" will score "Nomad Climax" as 2
 *
 *    Mix of multiple matching scenarios is possible.
 *    For example - "mad max" query will score "Mad Climax" as 100 (Exact) + 1 (Partial) = 101
 *
 * 3rd Pass - Sorting & Highlighting
 *    Sorting happens in the descending order of the score.
 *    Highlighting will match the entered query and inject necessary tags.
 *    Note: if both StartsWith and Partial matching exists in the same word then only StartsWith is highlighted
 *
 *    Two new properties are populated:
 *    1. highlightedText - highlights the query
 *    2. negatedHighlightedText - highights everything except the part that matches the query
 */ const $0360f977acb1f130$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $0360f977acb1f130$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $0360f977acb1f130$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
const $0360f977acb1f130$var$CONSECUTIVE_START_REGEX = new RegExp(`${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}`, 'g');
const $0360f977acb1f130$var$CONSECUTIVE_END_REGEX = new RegExp(`${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`, 'g');
const $0360f977acb1f130$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`, 'g');
const $0360f977acb1f130$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
const $0360f977acb1f130$var$cleanStartRegex = new RegExp($0360f977acb1f130$var$HIGHLIGHT_START_TAG, 'g');
const $0360f977acb1f130$var$cleanEndRegex = new RegExp($0360f977acb1f130$var$HIGHLIGHT_END_TAG, 'g');
const $0360f977acb1f130$export$9f4c92a576b56d82 = (source, matchWords)=>{
    // Remove any previous highlighting and regenerate
    // Supports the use case where we perform this on the frontend, and later the backend starts doing it for us first
    const cleanedSource = source.replace($0360f977acb1f130$var$cleanStartRegex, '').replace($0360f977acb1f130$var$cleanEndRegex, '');
    const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
    const wordsDetails = cleanedSource.split(' ').map((word)=>{
        const lowerCaseWord = word.toLowerCase();
        const alphabetOnlyWord = lowerCaseWord.replace($0360f977acb1f130$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
        let partialCount = 0;
        let startsWithCount = 0;
        let exactMatchCount = 0;
        let exactMatch = '';
        let partialMatch = '';
        let startsWithMatch = '';
        for(let i = 0; i < lowerCaseMatchWords.length; ++i){
            if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                exactMatchCount++;
                exactMatch = lowerCaseMatchWords[i];
                break;
            }
            if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                startsWithCount++;
                startsWithMatch = lowerCaseMatchWords[i];
                continue;
            }
            if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                partialCount++;
                partialMatch = lowerCaseMatchWords[i];
            }
        }
        const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
        if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
            const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
            const regExp = new RegExp(`(${pattern.replace($0360f977acb1f130$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
            const openingClosingRegExp = new RegExp(`(${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}|${$0360f977acb1f130$var$HIGHLIGHT_END_TAG})`, 'ig');
            const highlighted = word.replace(regExp, `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}$1${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`).replace($0360f977acb1f130$var$CONSECUTIVE_START_END_REGEX, ``);
            const mirror = {
                [`${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}`]: `${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`,
                [`${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`]: `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}`
            };
            const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
            const negatedHighlight = `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`.replace($0360f977acb1f130$var$CONSECUTIVE_START_REGEX, `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}`).replace($0360f977acb1f130$var$CONSECUTIVE_END_REGEX, `${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`).replace($0360f977acb1f130$var$CONSECUTIVE_START_END_REGEX, '');
            return {
                highlighted: highlighted,
                negatedHighlight: negatedHighlight,
                score: score
            };
        }
        // no match scenario
        return {
            negatedHighlight: `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}${word}${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`,
            highlighted: word,
            score: score
        };
    });
    const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
    const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
    const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
    if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
        highlightedTitle: highlightedTitle,
        negatedHighlightedTitle: negatedHighlightedTitle,
        score: finalScore
    };
    return {};
};

});



parcelRegister("4Cvc8", function(module, exports) {

$parcel$export(module.exports, "PostQueryRecentlyViewedTransformer", () => $e80594c1acf5b2bc$export$1607c6754b1f6fc5);

var $8RXs9 = parcelRequire("8RXs9");

var $azBuE = parcelRequire("azBuE");

var $c59Mn = parcelRequire("c59Mn");

var $5gpK9 = parcelRequire("5gpK9");
const $e80594c1acf5b2bc$var$RECENTLY_VIEWED_ITEMS_SHOWN = 5;
/**
 * This transformer assumes that preQueryItems contains recently viewed search
 * results and adds them to the postQueryItems.
 */ const $e80594c1acf5b2bc$var$PostQueryRecentlyViewedTransformerWithIntl = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    // Create an array of recently viewed sections. These sections exclude recent
    // searches and have a combined result limit of 10.
    let recentlyViewedCount = 0;
    const recentlyViewedSections = preQueryItems.sections.filter((section)=>section.id !== (0, $5gpK9.RECENT_SEARCHES_SECTION_ID)).filter((section)=>section.searchResults.length > 0).map((section, i)=>{
        const newSection = {
            ...section,
            resultLimit: Math.min(section.searchResults.length, $e80594c1acf5b2bc$var$RECENTLY_VIEWED_ITEMS_SHOWN - recentlyViewedCount),
            title: i === 0 ? intl.formatMessage((0, $c59Mn.messages).quick_find_recently_viewed) : ''
        };
        recentlyViewedCount = Math.min(recentlyViewedCount + section.searchResults.length, $e80594c1acf5b2bc$var$RECENTLY_VIEWED_ITEMS_SHOWN);
        return newSection;
    });
    // Add recent searches to the end of postQueryItems after post query returns
    const recentSearchesSection = preQueryItems.sections.find((section)=>section.id === (0, $5gpK9.RECENT_SEARCHES_SECTION_ID));
    const postQueryItemsSectionsWithRecentSearches = recentSearchesSection && productState === (0, $azBuE.ProductStates).PostQuerySuccess ? [
        ...postQueryItems.sections,
        recentSearchesSection
    ] : [
        ...postQueryItems.sections
    ];
    // Create the new postQueryItems object
    const postQueryItemsWithRecentlyViewed = {
        size: [
            ...recentlyViewedSections,
            ...postQueryItems.sections
        ].map((section)=>section.searchResults.length).reduce((a, b)=>a + b, 0),
        sections: [
            ...recentlyViewedSections,
            ...postQueryItemsSectionsWithRecentSearches
        ]
    };
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItemsWithRecentlyViewed,
        productState: productState
    });
};
const $e80594c1acf5b2bc$export$1607c6754b1f6fc5 = (0, $8RXs9.default)($e80594c1acf5b2bc$var$PostQueryRecentlyViewedTransformerWithIntl);

});

parcelRegister("6NSru", function(module, exports) {

$parcel$export(module.exports, "DeduplicateRecentlyViewedAndResultsTransformer", () => $a143d1b989f5e8db$export$91b234728c3a1640);

var $gGW0q = parcelRequire("gGW0q");
const $a143d1b989f5e8db$var$MAX_RENDERED_SEARCH_RESULTS = 5;
const $a143d1b989f5e8db$export$91b234728c3a1640 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const searchResults = postQueryItems.sections.find((section)=>section.id === (0, $gGW0q.CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID))?.searchResults || [];
    const recentlyViewedResults = postQueryItems.sections.find((section)=>section.id === (0, $gGW0q.RECENT_ITEMS_SECTION_ID))?.searchResults || [];
    const dedupedSearchResults = searchResults.filter((searchResult)=>{
        // Check for duplicates using ARIs
        const isDuplicate = recentlyViewedResults.some((recentlyViewedResult)=>recentlyViewedResult.ari === searchResult.ari);
        return searchResult.ari && !isDuplicate;
    });
    const postDeduplication = {
        ...postQueryItems,
        sections: postQueryItems.sections.map((section)=>{
            if (section.id === (0, $gGW0q.CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID)) return {
                ...section,
                searchResults: dedupedSearchResults.slice(0, $a143d1b989f5e8db$var$MAX_RENDERED_SEARCH_RESULTS)
            };
            return section;
        })
    };
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postDeduplication,
        productState: productState
    });
};

});


parcelRegister("il5K0", function(module, exports) {

$parcel$export(module.exports, "quickFindRecentItemResultMapper", () => $fee5fffed0f32421$export$1aadfab314f9e7ce);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3kLdO = parcelRequire("3kLdO");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bE3Ky = parcelRequire("bE3Ky");

var $c59Mn = parcelRequire("c59Mn");

var $bBlrR = parcelRequire("bBlrR");

var $7WTmq = parcelRequire("7WTmq");

var $iySxd = parcelRequire("iySxd");
const $fee5fffed0f32421$var$CONTEXT_PATH = '/wiki';
const $fee5fffed0f32421$var$labelStyles = (0, $8CUq3.xcss)({
    marginInlineStart: 'space.050'
});
const $fee5fffed0f32421$export$1aadfab314f9e7ce = (edge)=>{
    const item = edge.node;
    const data = item.object.data;
    const productType = item.object.product;
    switch(productType){
        case (0, $3kLdO.ActivityProduct).JIRA:
            return {
                id: item.object.id,
                title: `${data?.key}: ${(data?.fieldsById?.edges || [
                    {}
                ])[0].node?.text}` || '',
                url: data?.webUrl || '',
                icon: (0, $bBlrR.ContentIconRenderer)({
                    type: 'jira',
                    title: data?.title
                }),
                meta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iySxd.QuickFindResultMeta), {
                    meta: [
                        'Jira',
                        (0, $iySxd.capitalizeFirstLetter)(item.object.type)
                    ]
                }),
                additionalMeta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bE3Ky.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`
            };
        case (0, $3kLdO.ActivityProduct).CONFLUENCE:
            // Do NOT show drafts for live-edit pages since they're not drafts from a user perspective
            const isDraft = (data?.pageStatus === 'DRAFT' || data?.blogStatus === 'DRAFT') && data?.subtype !== 'LIVE';
            return {
                ari: item.object.id,
                id: item.object.id,
                title: data?.title || '',
                url: `${data?.links?.base || $fee5fffed0f32421$var$CONTEXT_PATH}${data?.links?.webUi}`,
                icon: (0, $bBlrR.ContentIconRenderer)({
                    type: item.object.type,
                    title: data?.title,
                    isDraft: isDraft
                }),
                label: isDraft ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                    xcss: $fee5fffed0f32421$var$labelStyles,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $c59Mn.messages).quick_find_recent_draft_label
                        })
                    })
                }) : '',
                meta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7WTmq.ConfluenceResultMeta), {
                    resultContentType: item.object.type,
                    resultAncestors: data?.ancestors,
                    resultSpace: data?.space
                }),
                additionalMeta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bE3Ky.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`,
                containerId: data?.space?.id || undefined
            };
        case (0, $3kLdO.ActivityProduct).ATLAS:
            return {
                id: item.object.id,
                title: `${data?.name}` || '',
                url: data?.url || '',
                icon: (0, $bBlrR.ContentIconRenderer)({
                    type: 'atlas',
                    imageSrc: data?.iconData || '',
                    title: data?.title
                }),
                meta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iySxd.QuickFindResultMeta), {
                    meta: [
                        (0, $iySxd.capitalizeFirstLetter)(item.object.type),
                        data?.key
                    ]
                }),
                additionalMeta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bE3Ky.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`
            };
        default:
            return {
                id: '',
                title: '',
                url: '',
                icon: '',
                meta: ''
            };
    }
};

});
parcelRegister("3kLdO", function(module, exports) {

$parcel$export(module.exports, "ActivityProduct", () => $b20780cd62bfa3ab$export$3ca4051c67b8ec7b);
$parcel$export(module.exports, "isRemoteLinkActivity", () => $b20780cd62bfa3ab$export$b7d2f1faf131fc56);
$parcel$export(module.exports, "isDocumentActivity", () => $b20780cd62bfa3ab$export$8d4b7c5856642df3);
$parcel$export(module.exports, "isGraphActivity", () => $b20780cd62bfa3ab$export$ed71d50c78c3618b);
$parcel$export(module.exports, "is1PActivity", () => $b20780cd62bfa3ab$export$d26e891d2764b7d7);
var $b20780cd62bfa3ab$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["JIRA"] = "jira";
    ActivityProduct["CONFLUENCE"] = "confluence";
    ActivityProduct["ATLAS"] = "townsquare";
    ActivityProduct["GRAPH"] = "graph";
    return ActivityProduct;
}({});
var $b20780cd62bfa3ab$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $b20780cd62bfa3ab$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $b20780cd62bfa3ab$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory["DOCUMENT"] = "DOCUMENT";
    ExternalDocumentCategory["PRESENTATION"] = "PRESENTATION";
    ExternalDocumentCategory["SPREADSHEET"] = "SPREADSHEET";
    return ExternalDocumentCategory;
}($b20780cd62bfa3ab$var$ExternalDocumentCategory || {});
const $b20780cd62bfa3ab$export$b7d2f1faf131fc56 = (activity)=>{
    return activity.type === 'remote-link';
};
const $b20780cd62bfa3ab$export$8d4b7c5856642df3 = (activity)=>{
    return activity.type === 'document';
};
const $b20780cd62bfa3ab$export$ed71d50c78c3618b = (activity)=>{
    return activity.product === 'graph';
};
const $b20780cd62bfa3ab$export$d26e891d2764b7d7 = (activity)=>{
    return activity.product === 'confluence' || activity.product === 'jira' || activity.product === 'townsquare';
};

});

parcelRegister("bE3Ky", function(module, exports) {

$parcel$export(module.exports, "WORKED_EVENT", () => $50c2ee22ee222e6f$export$eb4e9f525aef1cc3);
$parcel$export(module.exports, "EventTypeMessage", () => $50c2ee22ee222e6f$export$9e4fb3fb50a3c754);
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $2tElP = parcelRequire("2tElP");

var $kUxFz = parcelRequire("kUxFz");

var $it1wb = parcelRequire("it1wb");

var $4PxOH = parcelRequire("4PxOH");

var $30tN5 = parcelRequire("30tN5");
var $fsGYp = parcelRequire("fsGYp");
var $50c2ee22ee222e6f$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $50c2ee22ee222e6f$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
function $50c2ee22ee222e6f$export$e873c799b137eec4(date) {
    return (0, $kUxFz.default)(new Date(date), $50c2ee22ee222e6f$var$startOfOneWeekAgo());
}
function $50c2ee22ee222e6f$var$startOfOneWeekAgo() {
    return (0, $it1wb.default)((0, $4PxOH.default)(new Date(), 1));
}
const $50c2ee22ee222e6f$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData = true })=>{
    const isAbsolute = $50c2ee22ee222e6f$export$e873c799b137eec4(timestamp);
    const message = (0, $fsGYp.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $30tN5.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tElP.default), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...message,
        values: values
    });
};

});
parcelRegister("30tN5", function(module, exports) {

$parcel$export(module.exports, "selectUnit", () => $eb796f916e517007$export$b8f7189986dd5395);
const $eb796f916e517007$var$MS_PER_SECOND = 1e3;
const $eb796f916e517007$var$SECS_PER_MIN = 60;
const $eb796f916e517007$var$SECS_PER_HOUR = $eb796f916e517007$var$SECS_PER_MIN * 60;
const $eb796f916e517007$var$SECS_PER_DAY = $eb796f916e517007$var$SECS_PER_HOUR * 24;
const $eb796f916e517007$var$SECS_PER_WEEK = $eb796f916e517007$var$SECS_PER_DAY * 7;
function $eb796f916e517007$export$b8f7189986dd5395(from, to = Date.now(), thresholds = {}) {
    const resolvedThresholds = {
        ...$eb796f916e517007$export$f4fd60e41371f80d,
        ...thresholds || {}
    };
    const secs = (+from - +to) / $eb796f916e517007$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    const mins = secs / $eb796f916e517007$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    const hours = secs / $eb796f916e517007$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    const days = secs / $eb796f916e517007$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    const weeks = secs / $eb796f916e517007$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
const $eb796f916e517007$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};

});

parcelRegister("fsGYp", function(module, exports) {

$parcel$export(module.exports, "WrappedRecentWorkEventTypeMessagesProvider", () => $7e590f3611eefa6e$export$779009172d654787);
$parcel$export(module.exports, "useEventTypeMessage", () => $7e590f3611eefa6e$export$7948ea9187af6c9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $54yUM = parcelRequire("54yUM");

var $jxobG = parcelRequire("jxobG");
const $7e590f3611eefa6e$export$613b94bf89cb511d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    eventTypeMessages: (0, $jxobG.LOCAL_EVENT_TYPE_MESSAGES)
});
function $7e590f3611eefa6e$export$63b523c1d6b0c2f4({ children: children, locale: locale }) {
    const artifact = (0, $54yUM.useRecentWorkArtifact)(locale);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            eventTypeMessages: (0, $jxobG.LOCAL_EVENT_TYPE_MESSAGES),
            eventTypeMessagesTranslated: (0, $jxobG.translatedStringsToMessageDescriptors)(artifact?.localization.eventTypes)
        }), [
        artifact
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7e590f3611eefa6e$export$613b94bf89cb511d.Provider, {
        value: providerValue,
        children: children
    });
}
function $7e590f3611eefa6e$export$779009172d654787({ children: children }) {
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7e590f3611eefa6e$export$63b523c1d6b0c2f4, {
        locale: locale,
        children: children
    });
}
const $7e590f3611eefa6e$export$ddd7b41a8fb59ad6 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($7e590f3611eefa6e$export$613b94bf89cb511d);
function $7e590f3611eefa6e$export$7948ea9187af6c9(eventType, options = {}) {
    const { eventTypeMessages: eventTypeMessages, eventTypeMessagesTranslated: translatedMessagesMap } = $7e590f3611eefa6e$export$ddd7b41a8fb59ad6();
    return (0, $jxobG.messageForEventType)(eventType, translatedMessagesMap || eventTypeMessages, options);
}

});
parcelRegister("54yUM", function(module, exports) {

$parcel$export(module.exports, "useRecentWorkArtifact", () => $94c556438de1cbd7$export$9c10d80bcd5b4264);

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $3LJ9C = parcelRequire("3LJ9C");
const $94c556438de1cbd7$export$9c10d80bcd5b4264 = (locale)=>{
    const dimensions = (0, $5uXOq.useMemo)(()=>({
            ...(0, $3LJ9C.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    return (0, $btDaU.useFlightDeckArtifact)((0, $3LJ9C.FD_CLIENT_FETCH_PROPS).name, dimensions);
};

});

parcelRegister("jxobG", function(module, exports) {

$parcel$export(module.exports, "LOCAL_EVENT_TYPE_MESSAGES", () => $c2569fc67eab27ad$export$be5e766167e613a9);
$parcel$export(module.exports, "messageForEventType", () => $c2569fc67eab27ad$export$d3dc5798f9d19382);
$parcel$export(module.exports, "translatedStringsToMessageDescriptors", () => $c2569fc67eab27ad$export$ba0d5bdc49112491);

var $2YGrx = parcelRequire("2YGrx");
const $c2569fc67eab27ad$export$be5e766167e613a9 = {
    commented: (0, $2YGrx.commentedEventTypeMessages),
    created: (0, $2YGrx.createdEventTypeMessages),
    edited: (0, $2YGrx.editedEventTypeMessages),
    published: (0, $2YGrx.publishedEventTypeMessages),
    updated: (0, $2YGrx.updatedEventTypeMessages),
    viewed: (0, $2YGrx.viewedEventTypeMessages),
    'sl-viewed': (0, $2YGrx.viewedEventTypeMessages)
};
function $c2569fc67eab27ad$export$d3dc5798f9d19382(eventType, eventTypeMessages = $c2569fc67eab27ad$export$be5e766167e613a9, options = {}) {
    const { isAbsolute: isAbsolute = true, isMyActivityData: isMyActivityData = true, isSimple: isSimple = false } = options;
    const eventTypeMessage = eventTypeMessages.hasOwnProperty(eventType) ? eventTypeMessages[eventType] : (0, $2YGrx.defaultEventTypeMessages);
    if (isSimple) {
        if (isMyActivityData) return eventTypeMessage.standalone;
        else return eventTypeMessage.multiStandalone;
    } else {
        if (isMyActivityData && isAbsolute) return eventTypeMessage.absolute;
        else if (isMyActivityData && !isAbsolute) return eventTypeMessage.relative;
        else if (!isMyActivityData && isAbsolute) return eventTypeMessage.multiAbsolute;
        else return eventTypeMessage.multiRelative;
    }
}
function $c2569fc67eab27ad$export$ba0d5bdc49112491(translatedStrings) {
    if (!translatedStrings) return undefined;
    return Object.entries(translatedStrings).reduce((acc, [eventType, translatedMessages])=>{
        acc[eventType] = Object.entries(translatedMessages).reduce((eventTypeMessages, [translatedKey, translatedEntry])=>{
            eventTypeMessages[translatedKey] = {
                defaultMessage: translatedEntry,
                id: `recentWork.eventTypeMessage.translated.${translatedKey}.no-translate`
            };
            return eventTypeMessages;
        }, {});
        return acc;
    }, {});
}

});
parcelRegister("2YGrx", function(module, exports) {

$parcel$export(module.exports, "commentedEventTypeMessages", () => $1668b2c18bde6139$export$29c048cc57fefaf8);
$parcel$export(module.exports, "createdEventTypeMessages", () => $1668b2c18bde6139$export$99e7e287b0f1db7);
$parcel$export(module.exports, "editedEventTypeMessages", () => $1668b2c18bde6139$export$4d0c20aef6601783);
$parcel$export(module.exports, "publishedEventTypeMessages", () => $1668b2c18bde6139$export$2cd1ec4decb563bb);
$parcel$export(module.exports, "updatedEventTypeMessages", () => $1668b2c18bde6139$export$3b389551d0b5bf03);
$parcel$export(module.exports, "viewedEventTypeMessages", () => $1668b2c18bde6139$export$2d3fe6e7f84a868e);
$parcel$export(module.exports, "defaultEventTypeMessages", () => $1668b2c18bde6139$export$9be55d016b768442);

var $7VHMR = parcelRequire("7VHMR");
const $1668b2c18bde6139$export$29c048cc57fefaf8 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You commented on {absoluteTime}',
        description: 'action taken on this object with absolute timestamp - comment added',
        id: 'recentWork.eventTypeMessage.absolute.commented'
    },
    relative: {
        defaultMessage: 'You commented {relativeTime}',
        description: 'action taken by the user on this object with relative timestamp - comment added',
        id: 'recentWork.eventTypeMessage.relative.commented'
    },
    standalone: {
        defaultMessage: 'You commented',
        description: 'action taken by the user on this object - comment added',
        id: 'recentWork.eventTypeMessage.commented'
    },
    multiAbsolute: {
        defaultMessage: 'Commented on {absoluteTime}',
        description: 'action taken by the user on this object with absolute timestamp - comment added',
        id: 'recentWork.eventTypeMessage.multi.absolute.commented'
    },
    multiRelative: {
        defaultMessage: 'Commented {relativeTime}',
        description: 'action taken on this object with relative timestamp - comment added',
        id: 'recentWork.eventTypeMessage.multi.relative.commented'
    },
    multiStandalone: {
        defaultMessage: 'Commented',
        description: 'action taken on this object - comment added',
        id: 'recentWork.eventTypeMessage.multi.commented'
    }
});
const $1668b2c18bde6139$export$99e7e287b0f1db7 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You created on {absoluteTime}',
        description: 'action taken by the user on this object with absolute timestamp - initially created',
        id: 'recentWork.eventTypeMessage.absolute.created'
    },
    relative: {
        defaultMessage: 'You created {relativeTime}',
        description: 'action taken by the user on this object with relative timestamp - initially created',
        id: 'recentWork.eventTypeMessage.relative.created'
    },
    standalone: {
        defaultMessage: 'You created',
        description: 'action taken by the user on this object - initially created',
        id: 'recentWork.eventTypeMessage.created'
    },
    multiAbsolute: {
        defaultMessage: 'Created on {absoluteTime}',
        description: 'action taken on this object with absolute timestamp - initially created',
        id: 'recentWork.eventTypeMessage.multi.absolute.created'
    },
    multiRelative: {
        defaultMessage: 'Created {relativeTime}',
        description: 'action taken on this object with relative timestamp - initially created',
        id: 'recentWork.eventTypeMessage.multi.relative.created'
    },
    multiStandalone: {
        defaultMessage: 'Created',
        description: 'action taken on this object - initially created',
        id: 'recentWork.eventTypeMessage.multi.created'
    }
});
const $1668b2c18bde6139$export$4d0c20aef6601783 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You edited on {absoluteTime}',
        description: 'action taken by the user on this object with absolute timestamp - edited',
        id: 'recentWork.eventTypeMessage.absolute.edited'
    },
    relative: {
        defaultMessage: 'You edited {relativeTime}',
        description: 'action taken by the user on this object with relative timestamp - edited',
        id: 'recentWork.eventTypeMessage.relative.edited'
    },
    standalone: {
        defaultMessage: 'You edited',
        description: 'action taken by the user on this object - edited',
        id: 'recentWork.eventTypeMessage.edited'
    },
    multiAbsolute: {
        defaultMessage: 'Edited on {absoluteTime}',
        description: 'action taken on this object with absolute timestamp - edited',
        id: 'recentWork.eventTypeMessage.multi.absolute.edited'
    },
    multiRelative: {
        defaultMessage: 'Edited {relativeTime}',
        description: 'action taken on this object with relative timestamp - edited',
        id: 'recentWork.eventTypeMessage.multi.relative.edited'
    },
    multiStandalone: {
        defaultMessage: 'Edited',
        description: 'action taken on this object - edited',
        id: 'recentWork.eventTypeMessage.multi.edited'
    }
});
const $1668b2c18bde6139$export$2cd1ec4decb563bb = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You published on {absoluteTime}',
        description: 'action taken by the user on this object with absolute timestamp - published',
        id: 'recentWork.eventTypeMessage.absolute.published'
    },
    relative: {
        defaultMessage: 'You published {relativeTime}',
        description: 'action taken by the user on this object with relative timestamp - published',
        id: 'recentWork.eventTypeMessage.relative.published'
    },
    standalone: {
        defaultMessage: 'You published',
        description: 'action taken by the user on this object - published',
        id: 'recentWork.eventTypeMessage.published'
    },
    multiAbsolute: {
        defaultMessage: 'Published on {absoluteTime}',
        description: 'action taken on this object with absolute timestamp - published',
        id: 'recentWork.eventTypeMessage.multi.absolute.published'
    },
    multiRelative: {
        defaultMessage: 'Published {relativeTime}',
        description: 'action taken on this object with relative timestamp - published',
        id: 'recentWork.eventTypeMessage.multi.relative.published'
    },
    multiStandalone: {
        defaultMessage: 'Published',
        description: 'action taken on this object - published',
        id: 'recentWork.eventTypeMessage.multi.published'
    }
});
const $1668b2c18bde6139$export$3b389551d0b5bf03 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You updated on {absoluteTime}',
        description: 'action taken by the user on this object with absolute timestamp - updated',
        id: 'recentWork.eventTypeMessage.absolute.updated'
    },
    relative: {
        defaultMessage: 'You updated {relativeTime}',
        description: 'action taken by the user on this object with relative timestamp - updated',
        id: 'recentWork.eventTypeMessage.relative.updated'
    },
    standalone: {
        defaultMessage: 'You updated',
        description: 'action taken by the user on this object - updated',
        id: 'recentWork.eventTypeMessage.updated'
    },
    multiAbsolute: {
        defaultMessage: 'Updated on {absoluteTime}',
        description: 'action taken on this object with absolute timestamp - updated',
        id: 'recentWork.eventTypeMessage.multi.absolute.updated'
    },
    multiRelative: {
        defaultMessage: 'Updated {relativeTime}',
        description: 'action taken on this object with relative timestamp - updated',
        id: 'recentWork.eventTypeMessage.multi.relative.updated'
    },
    multiStandalone: {
        defaultMessage: 'Updated',
        description: 'action taken on this object - updated',
        id: 'recentWork.eventTypeMessage.multi.updated'
    }
});
const $1668b2c18bde6139$export$2d3fe6e7f84a868e = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You viewed on {absoluteTime}',
        description: 'action taken by the user on this object with absolute timestamp - viewed',
        id: 'recentWork.eventTypeMessage.absolute.viewed'
    },
    relative: {
        defaultMessage: 'You viewed {relativeTime}',
        description: 'action taken by the user on this object with relative timestamp - viewed',
        id: 'recentWork.eventTypeMessage.relative.viewed'
    },
    standalone: {
        defaultMessage: 'You viewed',
        description: 'action taken by the user on this object - viewed',
        id: 'recentWork.eventTypeMessage.viewed'
    },
    multiAbsolute: {
        defaultMessage: 'Viewed on {absoluteTime}',
        description: 'action taken on this object with absolute timestamp - viewed',
        id: 'recentWork.eventTypeMessage.multi.absolute.viewed'
    },
    multiRelative: {
        defaultMessage: 'Viewed {relativeTime}',
        description: 'action taken on this object with relative timestamp - viewed',
        id: 'recentWork.eventTypeMessage.multi.relative.viewed'
    },
    multiStandalone: {
        defaultMessage: 'Viewed',
        description: 'action taken on this object - viewed',
        id: 'recentWork.eventTypeMessage.multi.viewed'
    }
});
const $1668b2c18bde6139$export$9be55d016b768442 = (0, $7VHMR.defineMessages)({
    absolute: {
        defaultMessage: 'You worked on {absoluteTime}',
        description: 'action taken by the user on this object with an absolute or relative date/time - worked on',
        id: 'recentWork.eventTypeMessage.absolute.workedOn'
    },
    relative: {
        defaultMessage: 'You worked on {relativeTime}',
        description: 'action taken by the user on this object with an absolute or relative date/time - worked on',
        id: 'recentWork.eventTypeMessage.absolute.workedOn'
    },
    standalone: {
        defaultMessage: 'You worked on',
        description: 'action taken by the user on this object - worked on',
        id: 'recentWork.eventTypeMessage.workedOn'
    },
    multiAbsolute: {
        defaultMessage: 'Worked on {absoluteTime}',
        description: 'action taken on this object with an absolute or relative date/time - worked on',
        id: 'recentWork.eventTypeMessage.multi.absolute.workedOn'
    },
    multiRelative: {
        defaultMessage: 'Worked on {relativeTime}',
        description: 'action taken on this object with an absolute or relative date/time - worked on',
        id: 'recentWork.eventTypeMessage.multi.dateTime.workedOn'
    },
    multiStandalone: {
        defaultMessage: 'Worked on',
        description: 'action taken on this object - worked on',
        id: 'recentWork.eventTypeMessage.multi.workedOn'
    }
});

});




parcelRegister("bBlrR", function(module, exports) {

$parcel$export(module.exports, "ContentIconRenderer", () => $50357333f14de355$export$bf56fa242f0fc37d);
$parcel$export(module.exports, "GenericIconRenderer", () => $50357333f14de355$export$e5d849fb708254a9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ujWmd = parcelRequire("ujWmd");

var $lhPtH = parcelRequire("lhPtH");

var $2UiHO = parcelRequire("2UiHO");

var $h5fUN = parcelRequire("h5fUN");

var $9xuGL = parcelRequire("9xuGL");

var $bFmnZ = parcelRequire("bFmnZ");

var $4sHZ9 = parcelRequire("4sHZ9");

var $kdfZa = parcelRequire("kdfZa");

var $01Hwk = parcelRequire("01Hwk");

var $cwmS5 = parcelRequire("cwmS5");
const $50357333f14de355$var$negativeMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.negative.025',
    display: 'flex'
});
const $50357333f14de355$var$iconTypes = {
    ATLAS: 'atlas',
    ATTACHMENT: 'attachment',
    BLOGPOST: 'blogpost',
    COMMENT: 'comment',
    CONTENT: 'content',
    CONFLUENCEBLOGPOST: 'confluence-blogpost',
    CONFLUENCEPAGE: 'confluence-page',
    DATABASE: 'database',
    FOLDER: 'folder',
    JIRA: 'jira',
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $50357333f14de355$var$iconStyles = {
    BLUE: 'blue',
    GRAY: 'gray',
    PURPLE: 'purple',
    SHAPE: 'square',
    SIZE: '24',
    TEAL: 'teal',
    YELLOW: 'yellow'
};
const $50357333f14de355$export$bf56fa242f0fc37d = ({ type: type, imageSrc: imageSrc, title: title, isDraft: isDraft = false })=>{
    // CONFLUENCE
    if (type === $50357333f14de355$var$iconTypes.PAGE || type === $50357333f14de355$var$iconTypes.CONFLUENCEPAGE || type === $50357333f14de355$var$iconTypes.CONTENT) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))),
        label: type,
        appearance: isDraft ? $50357333f14de355$var$iconStyles.GRAY : $50357333f14de355$var$iconStyles.BLUE,
        shape: $50357333f14de355$var$iconStyles.SHAPE,
        size: $50357333f14de355$var$iconStyles.SIZE
    });
    else if (type === $50357333f14de355$var$iconTypes.BLOGPOST || type === $50357333f14de355$var$iconTypes.CONFLUENCEBLOGPOST) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        label: type,
        appearance: $50357333f14de355$var$iconStyles.BLUE,
        shape: $50357333f14de355$var$iconStyles.SHAPE,
        size: $50357333f14de355$var$iconStyles.SIZE
    });
    else if (type === $50357333f14de355$var$iconTypes.DATABASE) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4sHZ9))),
        label: type,
        appearance: $50357333f14de355$var$iconStyles.PURPLE,
        shape: $50357333f14de355$var$iconStyles.SHAPE,
        size: $50357333f14de355$var$iconStyles.SIZE
    });
    else if (type === $50357333f14de355$var$iconTypes.FOLDER) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9xuGL))),
        label: type,
        appearance: $50357333f14de355$var$iconStyles.BLUE,
        shape: $50357333f14de355$var$iconStyles.SHAPE,
        size: $50357333f14de355$var$iconStyles.SIZE
    });
    else if (type === $50357333f14de355$var$iconTypes.WHITEBOARD) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h5fUN))),
        label: type,
        appearance: $50357333f14de355$var$iconStyles.TEAL,
        shape: $50357333f14de355$var$iconStyles.SHAPE,
        size: $50357333f14de355$var$iconStyles.SIZE
    });
    else if (type === $50357333f14de355$var$iconTypes.COMMENT) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))),
        label: type,
        appearance: $50357333f14de355$var$iconStyles.YELLOW,
        shape: $50357333f14de355$var$iconStyles.SHAPE,
        size: $50357333f14de355$var$iconStyles.SIZE
    });
    else if (type === $50357333f14de355$var$iconTypes.ATTACHMENT) // TODO: Clarify if the attachment icon should be changed
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $01Hwk.AttachmentIcon), {
        title: title || '',
        size: "medium",
        label: type
    });
    else if (type === $50357333f14de355$var$iconTypes.ATLAS) return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        width: "24px",
        height: "24px",
        src: imageSrc || '',
        "aria-label": type,
        alt: type
    });
    else if (type === $50357333f14de355$var$iconTypes.JIRA) // TODO: Clarify the decision made for jira icons
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lhPtH))),
        label: type,
        appearance: $50357333f14de355$var$iconStyles.BLUE,
        shape: $50357333f14de355$var$iconStyles.SHAPE,
        size: $50357333f14de355$var$iconStyles.SIZE
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {});
};
const $50357333f14de355$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $50357333f14de355$var$negativeMarginStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        })
    });

});
parcelRegister("lhPtH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26ba74a55619bd4b134c4c0c504c8b64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f31df16698d05e$var$_react = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7f31df16698d05e$var$_baseNew = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f7f31df16698d05e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f31df16698d05e$var$WorkItemIcon = (props)=>/*#__PURE__*/ $f7f31df16698d05e$var$_react.default.createElement($f7f31df16698d05e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm8.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L7 9.086z" clip-rule="evenodd"/>`
    }, props));
$f7f31df16698d05e$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $f7f31df16698d05e$var$_default = module.exports.default = $f7f31df16698d05e$var$WorkItemIcon;

});

parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("h5fUN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4cad5a4ce9de3d8f027113d1b7910c8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6ff3fae3688d83c$var$_react = $c6ff3fae3688d83c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c6ff3fae3688d83c$var$_baseNew = $c6ff3fae3688d83c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c6ff3fae3688d83c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6ff3fae3688d83c$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $c6ff3fae3688d83c$var$_react.default.createElement($c6ff3fae3688d83c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.178c-.714.282-1.28.816-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.169 8.61.783c.943-.373 2.248-.49 3.09.374.346.356.536.778.548 1.237.011.436-.14.827-.323 1.144-.228.393-.557.76-.876 1.074 1.466-.137 2.717.238 3.421 1.133.827 1.05.644 2.464-.256 3.698l-1.212-.885c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.756-2.524-.512-.521.09-.935.139-1.236.13a1.4 1.4 0 0 1-.537-.109.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.496 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.18.102-.179.124-.292.123-.355-.002-.04-.01-.112-.124-.23-.2-.204-.716-.32-1.464-.025M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$c6ff3fae3688d83c$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $c6ff3fae3688d83c$var$_default = module.exports.default = $c6ff3fae3688d83c$var$WhiteboardIcon;

});

parcelRegister("bFmnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e4e36d6c115ce9$var$_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e4e36d6c115ce9$var$CommentIcon = (props)=>/*#__PURE__*/ $87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;

});

parcelRegister("4sHZ9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e29bcfd0234aa321c6ad616146b15d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33fbe57d5c4f37e3$var$_react = $33fbe57d5c4f37e3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $33fbe57d5c4f37e3$var$_baseNew = $33fbe57d5c4f37e3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $33fbe57d5c4f37e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Database".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for databases in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33fbe57d5c4f37e3$var$DatabaseIcon = (props)=>/*#__PURE__*/ $33fbe57d5c4f37e3$var$_react.default.createElement($33fbe57d5c4f37e3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.5h11V3a.5.5 0 0 0-.5-.5zM13.5 8H8.75v2h4.75zm0 3.5H8.75v2H13a.5.5 0 0 0 .5-.5zm-6.25 2v-2H2.5V13a.5.5 0 0 0 .5.5zM2.5 10h4.75V8H2.5z" clip-rule="evenodd"/>`
    }, props));
$33fbe57d5c4f37e3$var$DatabaseIcon.displayName = 'DatabaseIcon';
var $33fbe57d5c4f37e3$var$_default = module.exports.default = $33fbe57d5c4f37e3$var$DatabaseIcon;

});

parcelRegister("01Hwk", function(module, exports) {

$parcel$export(module.exports, "AttachmentIcon", () => $fdf17f1c79e5d780$export$edc04f92718bbea4);

var $5uXOq = parcelRequire("5uXOq");

var $8njZH = parcelRequire("8njZH");

var $9CRO6 = parcelRequire("9CRO6");

var $dOkKo = parcelRequire("dOkKo");

var $lBSka = parcelRequire("lBSka");

var $eABwY = parcelRequire("eABwY");

var $7zjHG = parcelRequire("7zjHG");

var $7BHMh = parcelRequire("7BHMh");

var $jGmM2 = parcelRequire("jGmM2");

var $96Idm = parcelRequire("96Idm");

var $RiK2l = parcelRequire("RiK2l");

var $daL8e = parcelRequire("daL8e");

var $dg1MW = parcelRequire("dg1MW");

var $5m93C = parcelRequire("5m93C");

var $2tm8x = parcelRequire("2tm8x");

var $kKp2J = parcelRequire("kKp2J");

var $cHwqN = parcelRequire("cHwqN");

var $6cEsd = parcelRequire("6cEsd");

var $gYsK7 = parcelRequire("gYsK7");

var $lDRqn = parcelRequire("lDRqn");

var $b7OK3 = parcelRequire("b7OK3");

var $im5Hg = parcelRequire("im5Hg");

var $2sfBf = parcelRequire("2sfBf");
const $fdf17f1c79e5d780$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($5m93C))),
            (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($96Idm))),
            (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($daL8e))),
            (0, (/*@__PURE__*/$parcel$interopDefault($dg1MW)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($6cEsd))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($8njZH))),
            (0, (/*@__PURE__*/$parcel$interopDefault($9CRO6)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($eABwY))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($kKp2J))),
            (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($im5Hg))),
            (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($dOkKo))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lBSka)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($lDRqn))),
            (0, (/*@__PURE__*/$parcel$interopDefault($b7OK3)))
        ]
    }
];
const $fdf17f1c79e5d780$var$getIconArray = (title)=>{
    const extension = $fdf17f1c79e5d780$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
        const matches = extensionMatcher.regexp.exec(title);
        return matches && matches.length > 0;
    });
    if (extension) return extension.icon;
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($7BHMh))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jGmM2)))
    ];
};
const $fdf17f1c79e5d780$export$ebe2a8421106a1ee = {
    small: 0,
    medium: 1
};
const $fdf17f1c79e5d780$export$edc04f92718bbea4 = ({ title: title, label: label, size: size })=>{
    const iconArray = $fdf17f1c79e5d780$var$getIconArray(title);
    const sizeIndex = $fdf17f1c79e5d780$export$ebe2a8421106a1ee[size];
    const icon = iconArray[sizeIndex];
    return /*#__PURE__*/ (0, $5uXOq.createElement)(icon, {
        label: label,
        testId: icon.name
    });
};

});
parcelRegister("8njZH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $618ffb1f66ed7d88$var$_react = $618ffb1f66ed7d88$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $618ffb1f66ed7d88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $618ffb1f66ed7d88$var$Archive16Icon = (props)=>/*#__PURE__*/ $618ffb1f66ed7d88$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$618ffb1f66ed7d88$var$Archive16Icon.displayName = 'Archive16Icon';
var $618ffb1f66ed7d88$var$_default = module.exports.default = $618ffb1f66ed7d88$var$Archive16Icon;

});

parcelRegister("9CRO6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $702166a50812bddf$var$_react = $702166a50812bddf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $702166a50812bddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $702166a50812bddf$var$Archive24Icon = (props)=>/*#__PURE__*/ $702166a50812bddf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$702166a50812bddf$var$Archive24Icon.displayName = 'Archive24Icon';
var $702166a50812bddf$var$_default = module.exports.default = $702166a50812bddf$var$Archive24Icon;

});

parcelRegister("dOkKo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a0e009d71aa209df$var$_react = $a0e009d71aa209df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a0e009d71aa209df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a0e009d71aa209df$var$Audio16Icon = (props)=>/*#__PURE__*/ $a0e009d71aa209df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$a0e009d71aa209df$var$Audio16Icon.displayName = 'Audio16Icon';
var $a0e009d71aa209df$var$_default = module.exports.default = $a0e009d71aa209df$var$Audio16Icon;

});

parcelRegister("lBSka", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fbb7315e8019fa9d$var$_react = $fbb7315e8019fa9d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $fbb7315e8019fa9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbb7315e8019fa9d$var$Audio24Icon = (props)=>/*#__PURE__*/ $fbb7315e8019fa9d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$fbb7315e8019fa9d$var$Audio24Icon.displayName = 'Audio24Icon';
var $fbb7315e8019fa9d$var$_default = module.exports.default = $fbb7315e8019fa9d$var$Audio24Icon;

});

parcelRegister("eABwY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a9f18a5320d9d60d$var$_react = $a9f18a5320d9d60d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a9f18a5320d9d60d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9f18a5320d9d60d$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $a9f18a5320d9d60d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$a9f18a5320d9d60d$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $a9f18a5320d9d60d$var$_default = module.exports.default = $a9f18a5320d9d60d$var$ExcelSpreadsheet16Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("7BHMh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $589df26f9969902f$var$_react = $589df26f9969902f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $589df26f9969902f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $589df26f9969902f$var$Generic16Icon = (props)=>/*#__PURE__*/ $589df26f9969902f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$589df26f9969902f$var$Generic16Icon.displayName = 'Generic16Icon';
var $589df26f9969902f$var$_default = module.exports.default = $589df26f9969902f$var$Generic16Icon;

});

parcelRegister("jGmM2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e5439afabf017b97$var$_react = $e5439afabf017b97$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $e5439afabf017b97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5439afabf017b97$var$Generic24Icon = (props)=>/*#__PURE__*/ $e5439afabf017b97$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e5439afabf017b97$var$Generic24Icon.displayName = 'Generic24Icon';
var $e5439afabf017b97$var$_default = module.exports.default = $e5439afabf017b97$var$Generic24Icon;

});

parcelRegister("96Idm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6a16f8a7ac90846b$var$_react = $6a16f8a7ac90846b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $6a16f8a7ac90846b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6a16f8a7ac90846b$var$Gif16Icon = (props)=>/*#__PURE__*/ $6a16f8a7ac90846b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$6a16f8a7ac90846b$var$Gif16Icon.displayName = 'Gif16Icon';
var $6a16f8a7ac90846b$var$_default = module.exports.default = $6a16f8a7ac90846b$var$Gif16Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("daL8e", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9970c4e7d3f96cd3$var$_react = $9970c4e7d3f96cd3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9970c4e7d3f96cd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9970c4e7d3f96cd3$var$Image16Icon = (props)=>/*#__PURE__*/ $9970c4e7d3f96cd3$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$9970c4e7d3f96cd3$var$Image16Icon.displayName = 'Image16Icon';
var $9970c4e7d3f96cd3$var$_default = module.exports.default = $9970c4e7d3f96cd3$var$Image16Icon;

});

parcelRegister("dg1MW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9a6e2824e29d024a$var$_react = $9a6e2824e29d024a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9a6e2824e29d024a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a6e2824e29d024a$var$Image24Icon = (props)=>/*#__PURE__*/ $9a6e2824e29d024a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9a6e2824e29d024a$var$Image24Icon.displayName = 'Image24Icon';
var $9a6e2824e29d024a$var$_default = module.exports.default = $9a6e2824e29d024a$var$Image24Icon;

});

parcelRegister("5m93C", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e66086d4264b484$var$_react = $3e66086d4264b484$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $3e66086d4264b484$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e66086d4264b484$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $3e66086d4264b484$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e66086d4264b484$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $3e66086d4264b484$var$_default = module.exports.default = $3e66086d4264b484$var$PdfDocument16Icon;

});

parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("kKp2J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f1ab878cb9f5def5$var$_react = $f1ab878cb9f5def5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $f1ab878cb9f5def5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1ab878cb9f5def5$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $f1ab878cb9f5def5$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f1ab878cb9f5def5$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $f1ab878cb9f5def5$var$_default = module.exports.default = $f1ab878cb9f5def5$var$PowerpointPresentation16Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("6cEsd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $48433e65bc802338$var$_react = $48433e65bc802338$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $48433e65bc802338$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $48433e65bc802338$var$SourceCode16Icon = (props)=>/*#__PURE__*/ $48433e65bc802338$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm6.639 8.417L4.253 8.1l2.589-2.51a.924.924 0 1 0-1.288-1.328L2.281 7.435a.925.925 0 0 0 0 1.328l3.07 2.976a.925.925 0 1 0 1.288-1.328m7.203-3.173L10.77 4.26a.924.924 0 1 0-1.286 1.33l2.385 2.313-2.588 2.51a.924.924 0 1 0 1.287 1.327l3.274-3.173a.925.925 0 0 0 0-1.328"/></svg>`
    }, props, {
        size: 'small'
    }));
$48433e65bc802338$var$SourceCode16Icon.displayName = 'SourceCode16Icon';
var $48433e65bc802338$var$_default = module.exports.default = $48433e65bc802338$var$SourceCode16Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("lDRqn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fc16ae7d17f8a28d$var$_react = $fc16ae7d17f8a28d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $fc16ae7d17f8a28d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fc16ae7d17f8a28d$var$Video16Icon = (props)=>/*#__PURE__*/ $fc16ae7d17f8a28d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
    }, props, {
        size: 'small'
    }));
$fc16ae7d17f8a28d$var$Video16Icon.displayName = 'Video16Icon';
var $fc16ae7d17f8a28d$var$_default = module.exports.default = $fc16ae7d17f8a28d$var$Video16Icon;

});

parcelRegister("b7OK3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8197b56faa95d635$var$_react = $8197b56faa95d635$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8197b56faa95d635$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8197b56faa95d635$var$Video24Icon = (props)=>/*#__PURE__*/ $8197b56faa95d635$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8197b56faa95d635$var$Video24Icon.displayName = 'Video24Icon';
var $8197b56faa95d635$var$_default = module.exports.default = $8197b56faa95d635$var$Video24Icon;

});

parcelRegister("im5Hg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d5ceb35532dd9e71$var$_react = $d5ceb35532dd9e71$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d5ceb35532dd9e71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5ceb35532dd9e71$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $d5ceb35532dd9e71$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d5ceb35532dd9e71$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $d5ceb35532dd9e71$var$_default = module.exports.default = $d5ceb35532dd9e71$var$WordDocument16Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});


parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $a921419639fe8f6f$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $a921419639fe8f6f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $a921419639fe8f6f$var$iconTileStyles = null;
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});


parcelRegister("7WTmq", function(module, exports) {

$parcel$export(module.exports, "ConfluenceResultMeta", () => $f082e1865db27da9$export$9138e703d4b4585b);
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");


var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");

var $iySxd = parcelRequire("iySxd");

var $bWGt6 = parcelRequire("bWGt6");
function $f082e1865db27da9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f082e1865db27da9$var$ConfluenceResultMetaWrapper = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e10xva5d1"
})({
    name: "fhxb3m",
    styles: "display:flex;flex-direction:row;align-items:center"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f082e1865db27da9$var$ConfluenceTypeWrapper = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e10xva5d0"
})({
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
});
const $f082e1865db27da9$var$BreadCrumbs = ({ breadCrumbs: breadCrumbs = [] })=>{
    if (breadCrumbs.length === 0) return null;
    // only allow 2 breadcrumbs
    // take the first and the last (if different)
    let twoBreadcrumbs = [];
    if (breadCrumbs.length > 2) twoBreadcrumbs = [
        breadCrumbs[0],
        breadCrumbs[breadCrumbs.length - 1]
    ];
    else twoBreadcrumbs = breadCrumbs;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5TWP.default), {
        separator: "/",
        space: "space.100",
        children: twoBreadcrumbs.map(({ id: id, title: title }, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                color: "color.text.subtle",
                size: "small",
                children: title
            }, id))
    });
};
const $f082e1865db27da9$export$9138e703d4b4585b = ({ resultContentType: resultContentType, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
    const breadcrumbs = $f082e1865db27da9$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($f082e1865db27da9$var$ConfluenceResultMetaWrapper, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($f082e1865db27da9$var$ConfluenceTypeWrapper, {
                children: "Confluence"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iySxd.SpacerWrapper), {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($f082e1865db27da9$var$ConfluenceTypeWrapper, {
                children: `${(0, $iySxd.capitalizeFirstLetter)(resultContentType)}`
            }),
            breadcrumbs?.length && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iySxd.SpacerWrapper), {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)($f082e1865db27da9$var$BreadCrumbs, {
                        breadCrumbs: breadcrumbs
                    })
                ]
            })
        ]
    });
};
const $f082e1865db27da9$export$ed9f69ac7e699c53 = (ancestors, space)=>{
    let breadcrumbs = [];
    if (space) {
        const spaceBreadcrumb = {
            id: space?.id,
            title: space?.name
        };
        if (!ancestors || ancestors.length === 0) breadcrumbs = [
            spaceBreadcrumb
        ];
        else if (ancestors.length >= 1) // The first ancestor is a root node that shouldn't be rendered
        breadcrumbs = [
            spaceBreadcrumb,
            ...ancestors.slice(1)
        ];
    }
    // Filter out invalid breadcrumbs
    return breadcrumbs.filter((breadCrumb)=>breadCrumb.id && breadCrumb.title);
};

});
parcelRegister("iySxd", function(module, exports) {

$parcel$export(module.exports, "SpacerWrapper", () => $e9a2ef39864e9f1a$export$b05a2e78ddf8915e);
$parcel$export(module.exports, "capitalizeFirstLetter", () => $e9a2ef39864e9f1a$export$d07f57595c356899);
$parcel$export(module.exports, "QuickFindResultMeta", () => $e9a2ef39864e9f1a$export$73e5ecb29f7bf6e9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");


var $bWGt6 = parcelRequire("bWGt6");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $e9a2ef39864e9f1a$var$ResultMetaWrapper = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "eflzzry1"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
});
const $e9a2ef39864e9f1a$export$b05a2e78ddf8915e = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "eflzzry0"
})({
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
    margin: `0px ${"var(--ds-space-100, 8px)"}`
});
function $e9a2ef39864e9f1a$export$d07f57595c356899(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
const $e9a2ef39864e9f1a$export$73e5ecb29f7bf6e9 = ({ meta: meta })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e9a2ef39864e9f1a$var$ResultMetaWrapper, {
        children: meta.filter((metaItem)=>metaItem !== null && metaItem !== undefined).map((metaItem, index)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    metaItem,
                    index !== meta.length - 1 && /*#__PURE__*/ (0, $2OMIu.jsx)($e9a2ef39864e9f1a$export$b05a2e78ddf8915e, {
                        children: "\u2022"
                    })
                ]
            }))
    });
};

});



parcelRegister("lYkqd", function(module, exports) {

$parcel$export(module.exports, "quickFindRecentSpaceResultMapper", () => $8525d00f54a62176$export$d04e5b6d01e34c3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $ujWmd = parcelRequire("ujWmd");

var $c59Mn = parcelRequire("c59Mn");
const $8525d00f54a62176$var$negativeMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.negative.025'
});
const $8525d00f54a62176$var$CONTEXT_PATH = '/wiki';
const $8525d00f54a62176$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgoHi.default), {
        xcss: $8525d00f54a62176$var$negativeMarginStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        })
    });
const $8525d00f54a62176$export$d04e5b6d01e34c3 = (item)=>({
        id: item?.id || '',
        title: item?.name || '',
        meta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $c59Mn.messages).quick_find_confluence_space
        }),
        additionalMeta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $c59Mn.messages).quick_find_recent_spaces_additional_meta
        }),
        url: `${$8525d00f54a62176$var$CONTEXT_PATH}${item?.links?.webui || ''}`,
        containerId: item?.id || undefined,
        icon: $8525d00f54a62176$export$e5d849fb708254a9({
            iconUrl: `${$8525d00f54a62176$var$CONTEXT_PATH}${item?.icon?.path || ''}`,
            size: 'small'
        }),
        isRecentResult: true,
        type: 'confluence space'
    });

});

parcelRegister("VfjmV", function(module, exports) {

$parcel$export(module.exports, "getQuickFindPeopleAndTeamsResultMapper", () => $6f13b8667f0b538a$export$dbdea3e42644cff8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bBlrR = parcelRequire("bBlrR");

var $c59Mn = parcelRequire("c59Mn");

var $5B8KC = parcelRequire("5B8KC");
const $6f13b8667f0b538a$export$dbdea3e42644cff8 = (primaryProduct, orgId, cloudId)=>{
    return (result)=>{
        if (result.type === 'team') return {
            title: result.name,
            id: result.id,
            type: result.type,
            meta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $c59Mn.messages).quick_find_results_team
            }),
            url: `${window.location.origin}${(0, $5B8KC.getTeamPath)(result.id, primaryProduct, orgId, cloudId)}`,
            icon: (0, $bBlrR.GenericIconRenderer)({
                iconUrl: result.avatarUrl
            })
        };
        else return {
            title: result.name,
            id: result.id,
            type: result.type,
            meta: result.title || '',
            url: `${window.location.origin}${(0, $5B8KC.getUserPath)(result.id, primaryProduct, orgId, cloudId)}`,
            icon: (0, $bBlrR.GenericIconRenderer)({
                iconUrl: result.avatarUrl,
                appearance: 'circle'
            })
        };
    };
};

});
parcelRegister("5B8KC", function(module, exports) {

$parcel$export(module.exports, "cleanExcerpt", () => $58a6573bc67eb6fb$export$7512fe8206a7f75b);
$parcel$export(module.exports, "hashData", () => $58a6573bc67eb6fb$export$7904c6256691057a);
$parcel$export(module.exports, "getUserPath", () => $58a6573bc67eb6fb$export$451f7a1e7c934f54);
$parcel$export(module.exports, "getTeamPath", () => $58a6573bc67eb6fb$export$9456a8e088bfede1);

var $gvK9N = parcelRequire("gvK9N");
const $58a6573bc67eb6fb$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
// copied over from @confluence/hash
const $58a6573bc67eb6fb$var$hash = (algorithm, data, asBytes = false)=>{
    const hash = (0, (/*@__PURE__*/$parcel$interopDefault($gvK9N))).createHash(algorithm);
    hash.update(data);
    if (asBytes) return Array.from(hash.digest());
    return hash.digest('hex');
};
const $58a6573bc67eb6fb$export$5fdf8c875acfc1b3 = (data)=>{
    return $58a6573bc67eb6fb$var$hash('sha256', data, true);
};
const $58a6573bc67eb6fb$export$7904c6256691057a = (data)=>{
    return $58a6573bc67eb6fb$var$hash('sha256', data);
};
const $58a6573bc67eb6fb$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return `/wiki/people/${userId}`;
    else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
};
const $58a6573bc67eb6fb$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return `/wiki/people/team/${teamId}`;
    else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
};

});


parcelRegister("7bjp7", function(module, exports) {

$parcel$export(module.exports, "quickFindConfluenceSpaceMapper", () => $f553aa6fd8e1a7f8$export$831f92f4f63a8807);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $c59Mn = parcelRequire("c59Mn");

var $4ZbRt = parcelRequire("4ZbRt");

var $bBlrR = parcelRequire("bBlrR");
const $f553aa6fd8e1a7f8$export$831f92f4f63a8807 = ({ node: item })=>{
    return {
        id: (0, $4ZbRt.transformAriToId)(item?.id || '', item?.type || ''),
        title: item?.title || '',
        meta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $c59Mn.messages).quick_find_confluence_space
        }),
        url: item?.url || '',
        type: 'confluence space',
        containerId: item?.id,
        icon: (0, $bBlrR.GenericIconRenderer)({
            iconUrl: `/wiki${item?.iconPath || ''}`,
            size: 'small'
        })
    };
};

});
parcelRegister("4ZbRt", function(module, exports) {

$parcel$export(module.exports, "transformAriToId", () => $d10aa42ae5e2bb68$export$6d8886e8d5cdbeec);
const $d10aa42ae5e2bb68$export$6d8886e8d5cdbeec = (id, type)=>{
    switch(type){
        case 'page':
            return id.split(':page/')[1];
        case 'blogpost':
            return id.split(':blogpost/')[1];
        case 'attachment':
            return id.split(':attachment/')[1];
        case 'space':
            return id.split(':space/')[1];
        case 'whiteboard':
            return id.split(':whiteboard/')[1];
        case 'embed':
            // embed ari url contains activation id so we split it differently here
            const embedAri = id.split('/');
            return embedAri[embedAri.length - 1];
        case 'database':
            // Databases ari url contains activation id so we split it differently here
            const databaseAri = id.split('/');
            return databaseAri[databaseAri.length - 1];
        default:
            return id;
    }
};

});


parcelRegister("dtzJn", function(module, exports) {

$parcel$export(module.exports, "quickFindConfluenceContentMapper", () => $063ed7719c2ec5f6$export$6a180a233e580286);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bBlrR = parcelRequire("bBlrR");

var $4ZbRt = parcelRequire("4ZbRt");

var $7WTmq = parcelRequire("7WTmq");

var $bE3Ky = parcelRequire("bE3Ky");
const $063ed7719c2ec5f6$export$6a180a233e580286 = ({ node: item })=>{
    return {
        ari: item?.id,
        id: (0, $4ZbRt.transformAriToId)(item?.id || '', item?.type || ''),
        title: item?.title || '',
        url: item?.url || '',
        meta: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7WTmq.ConfluenceResultMeta), {
            resultContentType: item?.type || '',
            resultAncestors: item?.confluenceEntity?.ancestors,
            resultSpace: item?.space
        }),
        additionalMeta: item?.lastModified ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bE3Ky.EventTypeMessage), {
            timestamp: item.lastModified,
            eventType: (0, $bE3Ky.WORKED_EVENT).UPDATED,
            isMyActivityData: false
        }) : '',
        containerId: (0, $4ZbRt.transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
        type: `confluence ${item?.type}` || '',
        icon: (0, $bBlrR.ContentIconRenderer)({
            type: item?.type || '',
            title: item?.title
        })
    };
};

});

parcelRegister("bUT2o", function(module, exports) {

$parcel$export(module.exports, "quickFindAtlasContentMapper", () => $c92e39198c7c5383$export$92506b66b43d2a63);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7k20O = parcelRequire("7k20O");

var $4ZbRt = parcelRequire("4ZbRt");

var $5qRwM = parcelRequire("5qRwM");

var $iySxd = parcelRequire("iySxd");
const $c92e39198c7c5383$var$getIcon = (result)=>{
    return result?.iconUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
        height: 24,
        width: 24,
        title: result.type,
        src: result.iconUrl
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
};
const $c92e39198c7c5383$var$getKey = (item)=>{
    if ((0, $7k20O.isSearchResultAtlasProjectPartial)(item)) return item.project?.key;
    else if ((0, $7k20O.isSearchResultAtlasGoalPartial)(item)) return item.goal?.key;
    else return null;
};
const $c92e39198c7c5383$var$getTitle = (item)=>{
    if (!item) return '';
    let entityKey = $c92e39198c7c5383$var$getKey(item);
    if (entityKey) return `${entityKey}: ${item.title || ''}`;
    return item.title || '';
};
const $c92e39198c7c5383$export$92506b66b43d2a63 = ({ node: item })=>{
    return {
        id: (0, $4ZbRt.transformAriToId)(item?.id || '', item?.type || ''),
        title: $c92e39198c7c5383$var$getTitle(item),
        url: item?.url || '',
        meta: (0, $iySxd.capitalizeFirstLetter)(item?.type || ''),
        additionalMeta: '',
        containerId: '',
        type: `atlas ${item?.type}` || '',
        icon: $c92e39198c7c5383$var$getIcon(item)
    };
};

});
parcelRegister("7k20O", function(module, exports) {

$parcel$export(module.exports, "isSearchResultAtlasProjectPartial", () => $2cea3646501572ab$export$1724df33341798e0);
$parcel$export(module.exports, "isSearchResultAtlasGoalPartial", () => $2cea3646501572ab$export$1d556a3125797ca6);
$parcel$export(module.exports, "isSearchAtlasPartial", () => $2cea3646501572ab$export$750af6f011d7ee10);
$parcel$export(module.exports, "getAtlasPartials", () => $2cea3646501572ab$export$272c689528faac47);
const $2cea3646501572ab$var$SearchDefaultResultAtlas = ``;
const $2cea3646501572ab$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
    isPrivate
  }
}
`;
const $2cea3646501572ab$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
      value
      score
    }
    targetDate {
      label
    }
  }
}
`;
const $2cea3646501572ab$export$1724df33341798e0 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
};
const $2cea3646501572ab$export$1d556a3125797ca6 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
};
const $2cea3646501572ab$export$bff995b1cea89df3 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
};
const $2cea3646501572ab$export$aa63de26c950cf0f = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
};
const $2cea3646501572ab$export$750af6f011d7ee10 = (partial)=>{
    return $2cea3646501572ab$export$1d556a3125797ca6(partial) || $2cea3646501572ab$export$1724df33341798e0(partial) || $2cea3646501572ab$export$bff995b1cea89df3(partial) || $2cea3646501572ab$export$aa63de26c950cf0f(partial);
};
const $2cea3646501572ab$export$272c689528faac47 = ()=>{
    return `
		${$2cea3646501572ab$var$SearchResultAtlasGoal}
		${$2cea3646501572ab$var$SearchResultAtlasProject}
		${$2cea3646501572ab$var$SearchDefaultResultAtlas}
	`;
};

});


parcelRegister("3HoVl", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $3b0a40e35c359cd5$export$b37ee0d76c6d2fbc);

var $daJkT = parcelRequire("daJkT");

var $7xoNc = parcelRequire("7xoNc");

var $2dI5H = parcelRequire("2dI5H");
const $3b0a40e35c359cd5$export$b37ee0d76c6d2fbc = ()=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    return (url, searchSessionId, type, resultId, additionalAnalytics)=>{
        // legacy QF/QS have different types/have confluence prefixed or not
        return (0, $daJkT.transformAnalyticsToQueryParam)({
            query: query,
            url: url,
            searchSessionId: searchSessionId,
            additionalAnalytics: additionalAnalytics,
            resultId: resultId,
            type: type,
            addQueryParams: $7xoNc.addQueryParams,
            addQuery: $7xoNc.addQuery
        });
    };
};

});
parcelRegister("daJkT", function(module, exports) {

$parcel$export(module.exports, "transformAnalyticsToQueryParam", () => $18afc4e978753d45$export$f9c120c22694d7aa);

var $5B8KC = parcelRequire("5B8KC");

var $elSaW = parcelRequire("elSaW");
const $18afc4e978753d45$export$f9c120c22694d7aa = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics, resultId: resultId, addQueryParams: addQueryParams, addQuery: addQuery, type: type })=>{
    const isConfluenceContent = typeof resultId === 'string' && resultId.includes('confluence') || typeof type === 'string' && [
        'confluence page',
        'confluence blogpost',
        'confluence space',
        'confluence attachment',
        'confluence whiteboard'
    ].some((contentType)=>contentType.includes(type));
    const hasAdditionalAnalytics = typeof additionalAnalytics === 'object' && Object.keys(additionalAnalytics).length > 0;
    if (!isConfluenceContent || !(query || hasAdditionalAnalytics)) return addQuery(url, 'search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${(0, $elSaW.valueSeparator)}${(0, $5B8KC.hashData)(query)}`);
    if (hasAdditionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${(0, $elSaW.valueSeparator)}${value}`);
    });
    if (events.length === 0) return addQuery(url, 'search_id', searchSessionId);
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join((0, $elSaW.attributeSeparator)));
    return addQueryParams(url, {
        search_id: searchSessionId,
        additional_analytics: analyticsFormattedForUrlParsing
    });
};

});
parcelRegister("elSaW", function(module, exports) {

$parcel$export(module.exports, "valueSeparator", () => $93ec9862d492c681$export$a707596ddc3340c);
$parcel$export(module.exports, "attributeSeparator", () => $93ec9862d492c681$export$5204c4564f8b6d00);
const $93ec9862d492c681$export$a707596ddc3340c = '---';
const $93ec9862d492c681$export$5204c4564f8b6d00 = '___';
const $93ec9862d492c681$export$6e18f540c8c76192 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split('____');
    events.forEach((event)=>{
        const formattedEvent = event?.split('---');
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};

});




parcelRegister("ll6QN", function(module, exports) {

$parcel$export(module.exports, "CommandIcon", () => $d8fbfab606ec5666$export$76bfbab5e3f9a6a3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

const $d8fbfab606ec5666$export$76bfbab5e3f9a6a3 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
                fill: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
            })
        ]
    });

});

parcelRegister("ib6Vt", function(module, exports) {

$parcel$export(module.exports, "ControlIcon", () => $583292655ac631d1$export$1de95e9d7dda5112);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $583292655ac631d1$var$iconStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral',
    height: '20px',
    borderRadius: 'border.radius.050',
    border: '1px solid transparent',
    color: 'color.text.subtle',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.050',
    paddingBlock: '0'
});
const $583292655ac631d1$export$1de95e9d7dda5112 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $583292655ac631d1$var$iconStyles,
        children: "Ctrl"
    });

});

parcelRegister("iGMUz", function(module, exports) {

$parcel$export(module.exports, "SquareReturnIcon", () => $a9999641250bff49$export$4501fc029b186da8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

const $a9999641250bff49$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
            })
        ]
    });

});


parcelRegister("lKCn7", function(module, exports) {

$parcel$export(module.exports, "getDefaultAtlasBaseURL", () => $666aede204901136$export$b182d98f245a5298);
$parcel$export(module.exports, "createProfileLink", () => $666aede204901136$export$5b4f9e589794eb96);
$parcel$export(module.exports, "createTeamProfileLink", () => $666aede204901136$export$a1c75f05b6ef3ec6);
$parcel$export(module.exports, "default", () => $666aede204901136$export$2e2bcd8739ae039);
const $666aede204901136$export$b182d98f245a5298 = (isGlobalExperienceWorkspace)=>{
    const hostname = window.location.hostname;
    const subdomain = isGlobalExperienceWorkspace ? 'home' : 'team';
    if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) return `https://${subdomain}.stg.atlassian.com`;
    return `https://${subdomain}.atlassian.com`;
};
const $666aede204901136$export$4c191d74745f6ab1 = (entityId, path, isGlobalExperienceWorkspace, orgId)=>{
    const baseUrl = $666aede204901136$export$b182d98f245a5298(isGlobalExperienceWorkspace);
    if (isGlobalExperienceWorkspace && orgId) return `${baseUrl}/o/${orgId}/${path}/${entityId}`;
    return `${baseUrl}/${path}/${entityId}`;
};
const $666aede204901136$export$5b4f9e589794eb96 = (accountId, isGlobalExperienceWorkspace, orgId)=>$666aede204901136$export$4c191d74745f6ab1(accountId, 'people', isGlobalExperienceWorkspace, orgId);
const $666aede204901136$export$a1c75f05b6ef3ec6 = (teamId, isGlobalExperienceWorkspace, orgId)=>$666aede204901136$export$4c191d74745f6ab1(teamId, 'people/team', isGlobalExperienceWorkspace, orgId);
const $666aede204901136$var$getAtlasViewAllRedirectUrl = (entity, searchText, workspaces, isGlobalExperienceWorkspace, orgId)=>{
    let url;
    if (workspaces && workspaces.length === 1 && /team\.(stg\.)?atlassian\.com/.test(workspaces[0].baseUrl)) url = new URL(workspaces[0].baseUrl);
    else url = new URL($666aede204901136$export$b182d98f245a5298(isGlobalExperienceWorkspace));
    const pathPrefix = isGlobalExperienceWorkspace && orgId ? `o/${orgId}/` : '';
    url.pathname = `${pathPrefix}action/search/${entity}`;
    url.searchParams.append('searchText', searchText);
    return url.href;
};
var $666aede204901136$export$2e2bcd8739ae039 = $666aede204901136$var$getAtlasViewAllRedirectUrl;

});

parcelRegister("80Slk", function(module, exports) {

$parcel$export(module.exports, "GoogleDriveIcon", () => $86acfad1ea7db7e8$export$e16bd899bb4eebf9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $86acfad1ea7db7e8$var$iconStyles = (0, $8CUq3.xcss)({
    width: '22px',
    height: '22px'
});
const $86acfad1ea7db7e8$export$e16bd899bb4eebf9 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $86acfad1ea7db7e8$var$iconStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "0.618757",
                    y: "0.618757",
                    width: "20.7625",
                    height: "20.7625",
                    rx: "4.38124",
                    stroke: "#0B1228",
                    strokeOpacity: "0.14",
                    strokeWidth: "0.762486"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_931_182)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M4.20962 16.0782L4.91523 17.2907C5.06186 17.546 5.27262 17.7466 5.52005 17.8925L8.04009 13.5529H3C3 13.8355 3.07331 14.1181 3.21993 14.3734L4.20962 16.0782Z",
                            fill: "#0066DA"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M11 8.44751L8.47995 4.10791C8.23253 4.25378 8.02176 4.45435 7.87514 4.70962L3.21993 12.7324C3.07601 12.9822 3.00019 13.265 3 13.5529H8.04009L11 8.44751Z",
                            fill: "#00AC47"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M16.4799 17.8925C16.7273 17.7466 16.9381 17.546 17.0847 17.2907L17.3779 16.7893L18.78 14.3734C18.9266 14.1181 18.9999 13.8355 18.9999 13.5529H13.9595L15.032 15.6497L16.4799 17.8925Z",
                            fill: "#EA4335"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M11 8.4475L13.5201 4.1079C13.2726 3.96203 12.9886 3.8891 12.6953 3.8891H9.30472C9.01148 3.8891 8.7274 3.97115 8.47998 4.1079L11 8.4475Z",
                            fill: "#00832D"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M13.9594 13.5529H8.03958L5.51953 17.8925C5.76695 18.0383 6.05103 18.1113 6.34427 18.1113H15.6547C15.9479 18.1113 16.232 18.0292 16.4794 17.8925L13.9594 13.5529Z",
                            fill: "#2684FC"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M16.4525 8.72101L14.1249 4.70962C13.9782 4.45435 13.7675 4.25378 13.52 4.10791L11 8.44751L13.9599 13.5529H18.9908C18.9908 13.2703 18.9175 12.9877 18.7709 12.7324L16.4525 8.72101Z",
                            fill: "#FFBA00"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_931_182",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "16",
                            height: "14.2222",
                            fill: "white",
                            transform: "translate(3 3.88904)"
                        })
                    })
                })
            ]
        })
    });

});

parcelRegister("lwJQ0", function(module, exports) {

$parcel$export(module.exports, "SlackIcon", () => $30ccebdcd8ed90bf$export$b33fb54b08bb6422);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $30ccebdcd8ed90bf$var$iconStyles = (0, $8CUq3.xcss)({
    width: '22px',
    height: '22px'
});
const $30ccebdcd8ed90bf$export$b33fb54b08bb6422 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $30ccebdcd8ed90bf$var$iconStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "0.5",
                    y: "0.5",
                    width: "21",
                    height: "21",
                    rx: "4.5",
                    stroke: "#0B1228",
                    strokeOpacity: "0.14"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_931_190)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M6.99813 12.8186C6.99813 13.6234 6.34773 14.2738 5.54301 14.2738C4.73828 14.2738 4.08789 13.6234 4.08789 12.8186C4.08789 12.0139 4.73828 11.3635 5.54301 11.3635H6.99813V12.8186ZM7.72569 12.8186C7.72569 12.0139 8.37608 11.3635 9.1808 11.3635C9.98553 11.3635 10.6359 12.0139 10.6359 12.8186V16.4564C10.6359 17.2612 9.98553 17.9116 9.1808 17.9116C8.37608 17.9116 7.72569 17.2612 7.72569 16.4564V12.8186Z",
                            fill: "#E01E5A"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M9.18109 6.97615C8.37636 6.97615 7.72597 6.32576 7.72597 5.52104C7.72597 4.71631 8.37636 4.06592 9.18109 4.06592C9.98581 4.06592 10.6362 4.71631 10.6362 5.52104V6.97615H9.18109ZM9.18109 7.71474C9.98581 7.71474 10.6362 8.36513 10.6362 9.16986C10.6362 9.97458 9.98581 10.625 9.18109 10.625H5.53227C4.72754 10.625 4.07715 9.97458 4.07715 9.16986C4.07715 8.36513 4.72754 7.71474 5.53227 7.71474H9.18109Z",
                            fill: "#36C5F0"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M15.0123 9.16986C15.0123 8.36513 15.6627 7.71474 16.4674 7.71474C17.2721 7.71474 17.9225 8.36513 17.9225 9.16986C17.9225 9.97458 17.2721 10.625 16.4674 10.625H15.0123V9.16986ZM14.2847 9.16986C14.2847 9.97458 13.6344 10.625 12.8296 10.625C12.0249 10.625 11.3745 9.97458 11.3745 9.16986V5.52104C11.3745 4.71631 12.0249 4.06592 12.8296 4.06592C13.6344 4.06592 14.2847 4.71631 14.2847 5.52104V9.16986Z",
                            fill: "#2EB67D"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M12.8296 15.0013C13.6344 15.0013 14.2847 15.6517 14.2847 16.4564C14.2847 17.2612 13.6344 17.9116 12.8296 17.9116C12.0249 17.9116 11.3745 17.2612 11.3745 16.4564V15.0013H12.8296ZM12.8296 14.2738C12.0249 14.2738 11.3745 13.6234 11.3745 12.8186C11.3745 12.0139 12.0249 11.3635 12.8296 11.3635H16.4784C17.2832 11.3635 17.9336 12.0139 17.9336 12.8186C17.9336 13.6234 17.2832 14.2738 16.4784 14.2738H12.8296Z",
                            fill: "#ECB22E"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_931_190",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white",
                            transform: "translate(4 3.99988)"
                        })
                    })
                })
            ]
        })
    });

});



parcelRegister("gZ0uu", function(module, exports) {

$parcel$export(module.exports, "CompassTab", () => $14370b7f16d72bd9$export$47b1e713578cc03f);

var $2OMIu = parcelRequire("2OMIu");

var $VSDnB = parcelRequire("VSDnB");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $a353g = parcelRequire("a353g");

var $cxU5p = parcelRequire("cxU5p");

var $8Xs9r = parcelRequire("8Xs9r");
var $kv2Va = parcelRequire("kv2Va");

var $azBuE = parcelRequire("azBuE");

var $kwW3T = parcelRequire("kwW3T");

var $j1cmh = parcelRequire("j1cmh");

var $3R5l7 = parcelRequire("3R5l7");

var $5OxSR = parcelRequire("5OxSR");

var $6zJmu = parcelRequire("6zJmu");

var $e53Rq = parcelRequire("e53Rq");

var $7VoGI = parcelRequire("7VoGI");

var $95MIc = parcelRequire("95MIc");

var $4f9Ma = parcelRequire("4f9Ma");

var $lvCts = parcelRequire("lvCts");

const $14370b7f16d72bd9$var$UpsellModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("1pUZm")).then((mod)=>({
            default: mod.UpsellModal
        })));
/**
 * Callback function to be used by PSD's permission supplier.
 * @returns all Compass scope required for Compass tab to function properly.
 */ const $14370b7f16d72bd9$var$upsellPermissionSupplier = ()=>{
    const response = Object.values((0, $5OxSR.CompassScope));
    return Promise.resolve(response);
};
const $14370b7f16d72bd9$var$CompassTabWithIntl = ({ baseUrl: baseUrl, crossFlowEnabled: crossFlowEnabled, intl: intl, isCompassActivated: isCompassActivated = false, isUserAnonymous: isUserAnonymous = false, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, sourceContext: sourceContext, upsellCtaButtonProps: upsellCtaButtonProps, userTeamConfig: userTeamConfig, ...rest })=>{
    const { advancedSearchLinkGenerator: advancedSearchLinkGenerator } = (0, $5uXOq.useMemo)(()=>{
        return (0, $e53Rq.compassURLGenerators)(baseUrl);
    }, [
        baseUrl
    ]);
    const sections = (0, $j1cmh.getSections)(intl);
    const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, $3R5l7.useCompassSuppliers)({
        userTeamConfig: userTeamConfig,
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    }, sections);
    const getAdvancedSearchButtonLabel = (0, $5uXOq.useCallback)((productState)=>{
        switch(productState){
            case (0, $azBuE.ProductStates).PreQueryLoading:
            case (0, $azBuE.ProductStates).PreQuerySuccess:
            case (0, $azBuE.ProductStates).PreQueryError:
            case (0, $azBuE.ProductStates).PreQueryNoResult:
                return intl.formatMessage((0, $kwW3T.messages).compass_view_all_components);
            default:
                return intl.formatMessage((0, $kwW3T.messages).compass_view_all_results);
        }
    }, [
        intl
    ]);
    const upsellTabRenderer = (0, $5uXOq.useCallback)(({ title: title })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6zJmu.UpsellTab), {
            title: title
        });
    }, []);
    const shouldUpsell = !isUserAnonymous && crossFlowEnabled && !isCompassActivated;
    const permissionSupplier = shouldUpsell ? $14370b7f16d72bd9$var$upsellPermissionSupplier : rest.permissionSupplier;
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $4f9Ma.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return advancedSearchLinkGenerator(query);
    }, [
        advancedSearchLinkGenerator,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        id: (0, $3R5l7.COMPASS_PRODUCT_ID),
        sections: sections,
        title: intl.formatMessage((0, $kwW3T.messages).compass_tab_label),
        expandedStateInputPlaceholder: intl.formatMessage((0, $kwW3T.messages).compass_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        tabRenderer: !(0, $VSDnB.fg)('jira_remove_new_lozenge_from_compass_search_tab') && shouldUpsell ? upsellTabRenderer : undefined,
        permissionSupplier: permissionSupplier,
        ...rest,
        children: ({ linkComponent: linkComponent, productState: productState, query: query })=>{
            if (shouldUpsell) return {
                Body: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($14370b7f16d72bd9$var$UpsellModal, {
                        sourceContext: sourceContext ?? 'product search dialog',
                        ctaButtonProps: upsellCtaButtonProps
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {})
            };
            const advancedSearchUrl = advancedSearchLinkGenerator(query);
            const message = getAdvancedSearchButtonLabel(productState);
            return {
                Header: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cxU5p.AdvancedSearch), {
                        advancedSearchMessage: message,
                        advancedSearchUrl: advancedSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f9Ma.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $14370b7f16d72bd9$export$47b1e713578cc03f = (0, $8RXs9.default)($14370b7f16d72bd9$var$CompassTabWithIntl);

});
parcelRegister("kwW3T", function(module, exports) {

$parcel$export(module.exports, "messages", () => $032c54b3b0adfc72$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $032c54b3b0adfc72$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Compass
	 */ compass_tab_label: {
        id: 'product_search_dialog.compass.tab_label',
        defaultMessage: 'Compass',
        description: 'Label to display for the Compass search tab'
    },
    compass_components_section_heading: {
        id: 'product_search_dialog.compass.components_section_heading',
        defaultMessage: 'Components',
        description: 'Header for the components search flyout section'
    },
    compass_people_section_heading: {
        id: 'product_search_dialog.compass.people_section_heading',
        defaultMessage: 'People',
        description: 'People section header'
    },
    compass_teams_section_heading: {
        id: 'product_search_dialog.compass.teams_section_heading',
        defaultMessage: 'Teams',
        description: 'Teams section header'
    },
    compass_endpoints_section_heading: {
        id: 'product_search_dialog.compass.endpoints_section_heading',
        defaultMessage: 'Endpoints',
        description: 'Header for the endpoints search flyout section'
    },
    compass_expanded_input_placeholder: {
        id: 'product_search_dialog.compass.expanded.input-placeholder',
        defaultMessage: 'Search Compass',
        description: 'The placeholder which is visible to the user when Compass tab is active '
    },
    compass_view_all_components: {
        id: 'product_search_dialog.compass.view_all_components_label',
        defaultMessage: 'View all components',
        description: 'Compass tab advanced search link text'
    },
    compass_view_all_results: {
        id: 'product_search_dialog.compass.view_all_results_label',
        defaultMessage: 'View all results',
        description: 'Compass tab advanced search link text for post query and error states'
    },
    compass_component_type_service: {
        id: 'product_search_dialog.compass.component_type.service',
        defaultMessage: 'Service',
        description: 'Tool tip shown for Service components'
    },
    compass_component_type_library: {
        id: 'product_search_dialog.compass.component_type.library',
        defaultMessage: 'Library',
        description: 'Tool tip shown for Library components'
    },
    compass_component_type_application: {
        id: 'product_search_dialog.compass.component_type.application',
        defaultMessage: 'Application',
        description: 'Tool tip shown for Application components'
    },
    compass_component_type_capability: {
        id: 'product_search_dialog.compass.component_type.capability',
        defaultMessage: 'Capability',
        description: 'Tool tip shown for Capability components'
    },
    compass_component_type_cloud_resource: {
        id: 'product_search_dialog.compass.component_type.cloud_resource',
        defaultMessage: 'Cloud resource',
        description: 'Tool tip shown for Cloud resource components'
    },
    compass_component_type_data_pipeline: {
        id: 'product_search_dialog.compass.component_type.data_pipeline',
        defaultMessage: 'Data pipeline',
        description: 'Tool tip shown for Data pipeline components'
    },
    compass_component_type_machine_learning_model: {
        id: 'product_search_dialog.compass.component_type.machine_learning_model',
        defaultMessage: 'Machine learning model',
        description: 'Tool tip shown for Machine learning model components'
    },
    compass_component_type_ui_element: {
        id: 'product_search_dialog.compass.component_type.ui_element',
        defaultMessage: 'UI element',
        description: 'Tool tip shown for UI element components'
    },
    compass_component_type_website: {
        id: 'product_search_dialog.compass.component_type.website',
        defaultMessage: 'Website',
        description: 'Tool tip shown for Website components'
    },
    compass_component_type_other: {
        id: 'product_search_dialog.compass.component_type.other',
        defaultMessage: 'Other',
        description: 'Tool tip shown for Other components'
    },
    compass_recently_viewed_components: {
        id: 'product_search_dialog.compass.recently_viewed_components',
        defaultMessage: 'Recently viewed components',
        description: 'Header for recently viewed components'
    },
    compass_recently_viewed_teams: {
        id: 'product_search_dialog.compass.recently_viewed_teams',
        defaultMessage: 'Recently viewed teams',
        description: 'Header for recently viewed teams'
    },
    compass_recently_viewed_endpoints: {
        id: 'product_search_dialog.compass.recently_viewed_endpoints',
        defaultMessage: 'Recently viewed endpoints',
        description: 'Header for recently viewed endpoints'
    }
});

});

parcelRegister("j1cmh", function(module, exports) {

$parcel$export(module.exports, "getSections", () => $2e696b52ef5b358a$export$ddbcae0b0bd6b092);

var $kwW3T = parcelRequire("kwW3T");

var $kFdjV = parcelRequire("kFdjV");

var $5OxSR = parcelRequire("5OxSR");
const $2e696b52ef5b358a$var$mapComponentAggregatorResponseToSearchItem = (response)=>({
        title: response.title,
        id: response.id,
        meta: response.ownerId,
        url: response.url,
        icon: response.type,
        containerId: ''
    });
const $2e696b52ef5b358a$var$mapApiEndpointAggregatorResponseToSearchItem = (response)=>({
        title: response.title,
        id: response.id,
        url: response.url,
        icon: response.url.split('/').pop()?.split('.')[0] || '',
        meta: ''
    });
const $2e696b52ef5b358a$export$ddbcae0b0bd6b092 = (intl)=>{
    const sections = [
        {
            id: (0, $5OxSR.CompassScope).Component,
            title: intl.formatMessage((0, $kwW3T.messages).compass_components_section_heading),
            scope: (0, $5OxSR.CompassScope).Component,
            showResultCount: true,
            resultRenderer: (0, $kFdjV.componentResultRenderer),
            resultMapper: ({ results: results })=>results.map((value)=>$2e696b52ef5b358a$var$mapComponentAggregatorResponseToSearchItem(value))
        },
        {
            id: (0, $5OxSR.CompassScope).ApiEndpoint,
            title: intl.formatMessage((0, $kwW3T.messages).compass_endpoints_section_heading),
            scope: (0, $5OxSR.CompassScope).ApiEndpoint,
            showResultCount: true,
            resultRenderer: (0, $kFdjV.endpointResultRenderer),
            resultLimit: 5,
            resultMapper: ({ results: results })=>results.map((value)=>$2e696b52ef5b358a$var$mapApiEndpointAggregatorResponseToSearchItem(value))
        }
    ];
    return sections;
};

});
parcelRegister("kFdjV", function(module, exports) {

$parcel$export(module.exports, "componentResultRenderer", () => $351101053ea517bd$export$f2eed8836fc2639e);
$parcel$export(module.exports, "peopleAndTeamsResultRenderer", () => $351101053ea517bd$export$3269347603d2224e);
$parcel$export(module.exports, "endpointResultRenderer", () => $351101053ea517bd$export$2db93eff9b2b2c36);
/* result-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $d9xxV = parcelRequire("d9xxV");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $3bDjY = parcelRequire("3bDjY");

var $fHgxq = parcelRequire("fHgxq");

var $1KrIR = parcelRequire("1KrIR");

var $cvYmc = parcelRequire("cvYmc");

var $azBuE = parcelRequire("azBuE");

var $8UVcc = parcelRequire("8UVcc");
const $351101053ea517bd$export$f2eed8836fc2639e = (args)=>{
    const { productState: productState, searchResult: searchResult } = args;
    const iconSize = productState === (0, $azBuE.ProductStates).PreQuerySuccess ? 'small' : 'medium';
    const iconType = searchResult.icon?.toString() ?? '';
    return (0, $cvYmc.defaultResultRenderer)({
        ...args,
        searchResult: {
            ...searchResult,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UVcc.ResultIcon), {
                type: iconType,
                size: iconSize
            })
        }
    });
};
const $351101053ea517bd$export$3269347603d2224e = (args)=>{
    const { productState: productState, searchResult: searchResult } = args;
    const iconSize = productState === (0, $azBuE.ProductStates).PreQuerySuccess ? 'xsmall' : 'small';
    return (0, $cvYmc.defaultResultRenderer)({
        ...args,
        searchResult: {
            ...searchResult,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1KrIR.ResultAvatar), {
                borderColor: "transparent",
                src: searchResult.iconUrl,
                appearance: "square",
                size: iconSize,
                testId: "result-avatar"
            })
        }
    });
};
const $351101053ea517bd$var$MethodDetails = {
    POST: {
        abbreviation: 'POST',
        color: 'purpleLight'
    },
    GET: {
        abbreviation: 'GET',
        color: 'greenLight'
    },
    PUT: {
        abbreviation: 'PUT',
        color: 'blueLight'
    },
    DELETE: {
        abbreviation: 'DEL',
        color: 'redLight'
    },
    PATCH: {
        abbreviation: 'PATCH',
        color: 'greyLight'
    },
    OPTIONS: {
        abbreviation: 'OPT',
        color: 'greyLight'
    },
    HEAD: {
        abbreviation: 'HEAD',
        color: 'greyLight'
    },
    TRACE: {
        abbreviation: 'TRACE',
        color: 'greyLight'
    },
    CONNECT: {
        abbreviation: 'CONN',
        color: 'greyLight'
    }
};
const $351101053ea517bd$var$styles = {
    methodTag: "_18u0r5cr"
};
const $351101053ea517bd$export$2db93eff9b2b2c36 = (args)=>{
    const { searchResult: searchResult } = args;
    const method = (typeof searchResult.icon === 'string' ? searchResult.icon : '').toUpperCase();
    const methodDetails = $351101053ea517bd$var$MethodDetails[method];
    const methodTag = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $351101053ea517bd$var$styles.methodTag,
        children: methodDetails ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: methodDetails.abbreviation,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9xxV.default), {
                text: methodDetails.abbreviation,
                color: methodDetails.color
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: 'OTHER',
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9xxV.default), {
                text: 'OTHER',
                color: "greyLight"
            })
        })
    });
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        paddingInlineStart: "space.300",
        children: searchResult.title
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fHgxq.SearchResultContent), {
        isKeyboardHighlighted: args.isKeyboardHighlighted,
        title: title,
        icon: methodTag,
        isCollapsed: args.isCollapsed,
        meta: searchResult.meta
    }, `item_${searchResult.id}`);
};

});
parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");
const $db35d9df42c66ff0$var$borderColorCssVar = '--ds-bc';
const $db35d9df42c66ff0$var$focusRingCssVar = '--ds-cfr';
const $db35d9df42c66ff0$var$textLinkCssVar = '--ds-ctl';
const $db35d9df42c66ff0$var$textDefaultCssVar = '--ds-ct';
const $db35d9df42c66ff0$var$textHoverCssVar = '--ds-cth';
const $db35d9df42c66ff0$var$textActiveCssVar = '--ds-ctp';
const $db35d9df42c66ff0$var$backgroundDefaultCssVar = '--ds-cb';
const $db35d9df42c66ff0$var$backgroundHoverCssVar = '--ds-cbh';
const $db35d9df42c66ff0$var$backgroundActiveCssVar = '--ds-cba';
const $db35d9df42c66ff0$var$removeButtonDefaultCssVar = '--ds-rb';
const $db35d9df42c66ff0$var$removeButtonHoverCssVar = '--ds-rbh';
const $db35d9df42c66ff0$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = null;
const $db35d9df42c66ff0$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = null;
const $db35d9df42c66ff0$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = null;
const $db35d9df42c66ff0$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = null;
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $2hnSR.textColors)['standardLink'] : (0, $2hnSR.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$db35d9df42c66ff0$var$borderColorCssVar]: (0, $2hnSR.borderColors)[color],
            [$db35d9df42c66ff0$var$textDefaultCssVar]: (0, $2hnSR.textColors)[color],
            [$db35d9df42c66ff0$var$textHoverCssVar]: (0, $2hnSR.textHoverColors)[color],
            [$db35d9df42c66ff0$var$textActiveCssVar]: (0, $2hnSR.textActiveColors)[color],
            [$db35d9df42c66ff0$var$textLinkCssVar]: textLinkColors,
            [$db35d9df42c66ff0$var$backgroundDefaultCssVar]: (0, $2hnSR.backgroundColors)[color],
            [$db35d9df42c66ff0$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$db35d9df42c66ff0$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$db35d9df42c66ff0$var$focusRingCssVar]: (0, $2hnSR.focusRingColors),
            [$db35d9df42c66ff0$var$removeButtonDefaultCssVar]: (0, $2hnSR.removeButtonColors)[color],
            [$db35d9df42c66ff0$var$removeButtonHoverCssVar]: (0, $2hnSR.removeButtonHoverColors)[color],
            [$db35d9df42c66ff0$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
// Text colors
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $5b444d8505b9cc3c$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $5b444d8505b9cc3c$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $4b11e671062d0fc5$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = null;
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = null;
const $c46b06918fbe54e8$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = null;
const $c46b06918fbe54e8$var$linkStyles = null;
const $c46b06918fbe54e8$var$hasAfterStylesOld = null;
const $c46b06918fbe54e8$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = null;
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
        href: href,
        "data-color": color,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});


parcelRegister("8UVcc", function(module, exports) {

$parcel$export(module.exports, "ResultIcon", () => $c2b7711fb91b88da$export$e8ec4da10aa3e6a6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5LWLA = parcelRequire("5LWLA");

var $3bDjY = parcelRequire("3bDjY");

var $5OxSR = parcelRequire("5OxSR");

var $hHEKF = parcelRequire("hHEKF");
const $c2b7711fb91b88da$export$e8ec4da10aa3e6a6 = ({ type: type, size: size = 'medium' })=>{
    const intl = (0, $koVbs.default)();
    const componentType = (0, $5OxSR.COMPONENT_TYPES)[type] ?? (0, $5OxSR.COMPONENT_TYPES).OTHER;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: intl.formatMessage(componentType.message),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEKF.IconBackground), {
            color: componentType.color,
            size: size,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
                label: type,
                glyph: componentType.icon,
                size: size
            })
        })
    });
};

});
parcelRegister("5OxSR", function(module, exports) {

$parcel$export(module.exports, "CompassScope", () => $78d0ffb73fa58faa$export$7dfd429914c57d74);
$parcel$export(module.exports, "COMPONENT_TYPES", () => $78d0ffb73fa58faa$export$6349b6efda58d149);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");


var $kwW3T = parcelRequire("kwW3T");
var $78d0ffb73fa58faa$export$7dfd429914c57d74 = /*#__PURE__*/ function(CompassScope) {
    CompassScope["Component"] = "compass.component";
    CompassScope["People"] = "compass.people";
    CompassScope["Teams"] = "compass.teams";
    CompassScope["ApiEndpoint"] = "compass.api-endpoint";
    return CompassScope;
}({});
const $78d0ffb73fa58faa$export$6349b6efda58d149 = {
    SERVICE: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z"
                })
            }),
        message: (0, $kwW3T.messages).compass_component_type_service
    },
    LIBRARY: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$874739ea9e379ab6})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z"
                })
            }),
        message: (0, $kwW3T.messages).compass_component_type_library
    },
    APPLICATION: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$940e1f69e873f202})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z"
                })
            }),
        message: (0, $kwW3T.messages).compass_component_type_application
    },
    CAPABILITY: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$7090862dc3038a9f})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.5145 6.15717C10.5145 6.97758 11.1796 7.64266 12 7.64266C12.8204 7.64266 13.4855 6.97758 13.4855 6.15717C13.4855 5.33676 12.8204 4.67168 12 4.67168C11.1796 4.67168 10.5145 5.33676 10.5145 6.15717ZM11.15 9.22799C10.8953 9.15765 10.6534 9.05647 10.4286 8.92873L8.93348 10.426C9.19656 10.8894 9.34679 11.4253 9.34679 11.9963C9.34679 13.7556 7.9206 15.1818 6.1613 15.1818C4.40201 15.1818 2.97581 13.7556 2.97581 11.9963C2.97581 10.237 4.40201 8.81083 6.1613 8.81083C6.73217 8.81083 7.26796 8.96099 7.73134 9.22398L9.22707 7.72612C8.96447 7.263 8.81454 6.72759 8.81454 6.15717C8.81454 4.39787 10.2407 2.97168 12 2.97168C13.7593 2.97168 15.1855 4.39787 15.1855 6.15717C15.1855 6.72831 15.0352 7.26434 14.772 7.72787L16.2683 9.22419C16.7318 8.96107 17.2677 8.81083 17.8387 8.81083C19.598 8.81083 21.0242 10.237 21.0242 11.9963C21.0242 13.7556 19.598 15.1818 17.8387 15.1818C16.0794 15.1818 14.6532 13.7556 14.6532 11.9963C14.6532 11.4255 14.8034 10.8897 15.0663 10.4264L13.5697 8.92972C13.3453 9.057 13.104 9.15784 12.85 9.228V14.7646C14.1966 15.1366 15.1855 16.3705 15.1855 17.8355C15.1855 19.5948 13.7593 21.021 12 21.021C10.2407 21.021 8.81454 19.5948 8.81454 17.8355C8.81454 16.3705 9.80338 15.1366 11.15 14.7646V9.22799ZM4.67581 11.9963C4.67581 12.8167 5.34089 13.4818 6.1613 13.4818C6.98172 13.4818 7.64679 12.8167 7.64679 11.9963C7.64679 11.1759 6.98172 10.5108 6.1613 10.5108C5.34089 10.5108 4.67581 11.1759 4.67581 11.9963ZM12 19.321C11.1796 19.321 10.5145 18.6559 10.5145 17.8355C10.5145 17.0151 11.1796 16.35 12 16.35C12.8204 16.35 13.4855 17.0151 13.4855 17.8355C13.4855 18.6559 12.8204 19.321 12 19.321ZM16.3532 11.9963C16.3532 12.8167 17.0183 13.4818 17.8387 13.4818C18.6591 13.4818 19.3242 12.8167 19.3242 11.9963C19.3242 11.1759 18.6591 10.5108 17.8387 10.5108C17.0183 10.5108 16.3532 11.1759 16.3532 11.9963Z"
                })
            }),
        message: (0, $kwW3T.messages).compass_component_type_capability
    },
    CLOUD_RESOURCE: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $kwW3T.messages).compass_component_type_cloud_resource
    },
    DATA_PIPELINE: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$4a7404f376229999})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z",
                        stroke: "#fff",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z",
                        stroke: "#fff",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $kwW3T.messages).compass_component_type_data_pipeline
    },
    MACHINE_LEARNING_MODEL: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$4a7404f376229999})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z",
                        stroke: "#fff",
                        strokeWidth: "1.5",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M4.61222 7.89078L18.8696 16.1906",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M4.85273 16.2901L19.0688 7.95921",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "none",
                        d: "M11.7317 20.2989L11.7317 3.24756",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: "#FF5630",
                        d: "M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z",
                        stroke: "#fff",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $kwW3T.messages).compass_component_type_machine_learning_model
    },
    UI_ELEMENT: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$874739ea9e379ab6})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                        id: "path-1-inside-1_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            x: "2.83353",
                            y: "13.6489",
                            width: "6.97358",
                            height: "7.36887",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        fill: "none",
                        x: "2.83353",
                        y: "13.6489",
                        width: "6.97358",
                        height: "7.36887",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-1-inside-1_1403_23012)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                        id: "path-2-inside-2_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            x: "2.83353",
                            y: "3.01807",
                            width: "18.5455",
                            height: "8.59702",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        fill: "none",
                        x: "2.83353",
                        y: "3.01807",
                        width: "18.5455",
                        height: "8.59702",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-2-inside-2_1403_23012)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                        id: "path-3-inside-3_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            x: "11.5089",
                            y: "13.6489",
                            width: "9.87006",
                            height: "7.36887",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        fill: "none",
                        x: "11.5089",
                        y: "13.6489",
                        width: "9.87006",
                        height: "7.36887",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-3-inside-3_1403_23012)"
                    })
                ]
            }),
        message: (0, $kwW3T.messages).compass_component_type_ui_element
    },
    WEBSITE: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$940e1f69e873f202})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fill: "fff",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.3319 20.9136C13.5069 20.9136 14.6704 20.6821 15.756 20.2325C16.8416 19.7828 17.828 19.1237 18.6589 18.2928C19.4898 17.462 20.1489 16.4756 20.5985 15.39C21.0482 14.3044 21.2796 13.1409 21.2796 11.9658C21.2796 10.7908 21.0482 9.62725 20.5985 8.54166C20.1489 7.45607 19.4898 6.46968 18.6589 5.6388C17.828 4.80793 16.8416 4.14884 15.756 3.69917C14.6704 3.24951 13.5069 3.01807 12.3319 3.01807C9.95879 3.01807 7.68289 3.96077 6.00486 5.6388C4.32683 7.31683 3.38412 9.59273 3.38412 11.9658C3.38412 14.3389 4.32683 16.6148 6.00486 18.2928C7.68289 19.9709 9.95879 20.9136 12.3319 20.9136V20.9136ZM11.4371 19.0614C9.70752 18.8456 8.11636 18.0054 6.96289 16.6987C5.80941 15.3919 5.17312 13.7088 5.17368 11.9658C5.17368 11.4111 5.24526 10.8831 5.36158 10.3642L9.64755 14.6501V15.5449C9.64755 16.5292 10.4529 17.3345 11.4371 17.3345V19.0614V19.0614ZM17.6111 16.7887C17.4975 16.427 17.2713 16.1113 16.9654 15.8875C16.6595 15.6637 16.29 15.5436 15.911 15.5449H15.0162V12.8606C15.0162 12.3685 14.6136 11.9658 14.1214 11.9658H8.75278V10.1763H10.5423C11.0345 10.1763 11.4371 9.77362 11.4371 9.28149V7.49194H13.2267C14.2109 7.49194 15.0162 6.68665 15.0162 5.70239V5.33553C17.6379 6.40032 19.4901 8.96832 19.4901 11.9658C19.4901 13.827 18.7743 15.5181 17.6111 16.7887V16.7887Z"
                })
            }),
        message: (0, $kwW3T.messages).compass_component_type_website
    },
    OTHER: {
        color: `var(--ds-icon, ${$829f609a65d26a98$export$e62e8919cca44969})`,
        icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z"
                    })
                ]
            }),
        message: (0, $kwW3T.messages).compass_component_type_other
    }
};

});

parcelRegister("hHEKF", function(module, exports) {

$parcel$export(module.exports, "IconBackground", () => $72df0fc32c73ced0$export$e320804e9cbf60f);

var $5owSH = parcelRequire("5owSH");

var $47bDC = parcelRequire("47bDC");
const $72df0fc32c73ced0$export$e320804e9cbf60f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1k2j4tj-0"
})`display:flex;align-items:center;justify-content:center;width:${(props)=>(0, $5owSH.sizes)[props.size]};height:${(props)=>(0, $5owSH.sizes)[props.size]};background-color:${(props)=>props.color};border-radius:3px;& > svg,& > span[role='img'],& > span[role='presentation']{width:83.333333%;}`;

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});





parcelRegister("3R5l7", function(module, exports) {

$parcel$export(module.exports, "COMPASS_PRODUCT_ID", () => $a43055790ca3e7d9$export$29789a1990c8eafe);
$parcel$export(module.exports, "useCompassSuppliers", () => $a43055790ca3e7d9$export$9b569c25a7f27268);

var $koVbs = parcelRequire("koVbs");

var $f4GCr = parcelRequire("f4GCr");

var $g12zs = parcelRequire("g12zs");

var $kwW3T = parcelRequire("kwW3T");

var $8entA = parcelRequire("8entA");

var $5OxSR = parcelRequire("5OxSR");

var $e53Rq = parcelRequire("e53Rq");

var $kFdjV = parcelRequire("kFdjV");
const $a43055790ca3e7d9$export$29789a1990c8eafe = 'compass';
const $a43055790ca3e7d9$var$NO_OWNER_TEAM = 'ari:cloud:teams::team/unidentified';
const $a43055790ca3e7d9$export$9b569c25a7f27268 = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier }, sections)=>{
    const intl = (0, $koVbs.default)();
    const itemSuppliers = (0, $f4GCr.useDefaultSuppliers)($a43055790ca3e7d9$export$29789a1990c8eafe, sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const peopleAndTeamSupplier = (0, $g12zs.usePeopleAndTeamsQuery)({
        people: {
            id: (0, $5OxSR.CompassScope).People,
            title: intl.formatMessage((0, $kwW3T.messages).compass_people_section_heading)
        },
        teams: {
            id: (0, $5OxSR.CompassScope).Teams,
            title: intl.formatMessage((0, $kwW3T.messages).compass_teams_section_heading)
        }
    }, 3);
    const requestTeamMeta = async (teamId)=>{
        if (!userTeamConfig?.context.siteId || !teamId || teamId === $a43055790ca3e7d9$var$NO_OWNER_TEAM) return '';
        try {
            const team = await (0, $8entA.getTeamData)({
                url: userTeamConfig?.baseUrl || '',
                teamAri: teamId,
                siteId: userTeamConfig?.context.siteId
            });
            return team.displayName;
        } catch (e) {
            // Ignore
            return '';
        }
    };
    const userTeamConfigOverride = {
        context: userTeamConfig.context,
        baseUrl: userTeamConfig.baseUrl,
        resolveTeamUrl: userTeamConfig.resolveTeamUrl ?? (0, $e53Rq.compassURLGenerators)().teamUrlGenerator,
        resolveUserUrl: userTeamConfig.resolveUserUrl ?? (0, $e53Rq.compassURLGenerators)().userUrlGenerator
    };
    const hydrateOwnerMeta = async (items)=>{
        const promises = [];
        const compSection = items.sections.find((s)=>s.id === (0, $5OxSR.CompassScope).Component);
        if (compSection) compSection.searchResults.map(async (res)=>{
            promises.push(requestTeamMeta(res.meta).then((teamName)=>res.meta = teamName));
        });
        return Promise.all(promises).then(()=>items);
    };
    const preQueryItemSupplierWithTeamName = async (args)=>{
        const existingSections = await hydrateOwnerMeta(await itemSuppliers.preQueryItemSupplier(args));
        const teamSection = (await peopleAndTeamSupplier('', userTeamConfigOverride)).sections.find((section)=>section.id === (0, $5OxSR.CompassScope).Teams);
        return window.location.pathname.startsWith('/compass') ? existingSections : {
            size: existingSections.size,
            sections: [
                ...existingSections.sections,
                ...teamSection ? [
                    {
                        ...teamSection,
                        resultRenderer: (0, $kFdjV.peopleAndTeamsResultRenderer)
                    }
                ] : []
            ]
        };
    };
    const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await hydrateOwnerMeta(await itemSuppliers.postQueryItemSupplier(args));
        const people = userTeamConfigOverride ? await peopleAndTeamSupplier(args.query, {
            ...userTeamConfigOverride,
            context: {
                ...userTeamConfigOverride.context,
                siteId: userTeamConfigOverride.context.siteId
            }
        }) : null;
        return {
            size: existingSections.size,
            sections: [
                ...existingSections.sections,
                ...people?.sections.map((section)=>({
                        ...section,
                        resultRenderer: (0, $kFdjV.peopleAndTeamsResultRenderer)
                    })) ?? []
            ]
        };
    };
    const preQuerySectionTitleGenerator = (section)=>{
        switch(section.id){
            case (0, $5OxSR.CompassScope).Component:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $kwW3T.messages).compass_recently_viewed_components) : intl.formatMessage((0, $kwW3T.messages).compass_components_section_heading);
            case (0, $5OxSR.CompassScope).Teams:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $kwW3T.messages).compass_recently_viewed_teams) : intl.formatMessage((0, $kwW3T.messages).compass_teams_section_heading);
            case (0, $5OxSR.CompassScope).ApiEndpoint:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $kwW3T.messages).compass_recently_viewed_endpoints) : intl.formatMessage((0, $kwW3T.messages).compass_endpoints_section_heading);
            default:
                return '';
        }
    };
    return {
        preQueryItemSupplier: preQueryItemSupplierWithTeamName,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    };
};

});
parcelRegister("g12zs", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsQuery", () => $af3136587b54c1cd$export$f16e39d5b6af63da);

var $koVbs = parcelRequire("koVbs");
const $af3136587b54c1cd$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $af3136587b54c1cd$var$resolveRecommendationRequest = ({ baseUrl: baseUrl, context: context, includeUsers: includeUsers, includeTeams: includeTeams, query: query, maxNumberOfResults: maxNumberOfResults })=>({
        baseUrl: baseUrl,
        context: context,
        maxNumberOfResults: maxNumberOfResults,
        query: query ?? '',
        searchQueryFilter: $af3136587b54c1cd$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
        includeUsers: includeUsers ?? false,
        includeGroups: false,
        includeTeams: includeTeams ?? false
    });

const $af3136587b54c1cd$var$asyncGetUserRecommendations = async (request, intl)=>{
    try {
        const { getUserRecommendations: getUserRecommendations } = await (parcelRequire("cZrdv"));
        return getUserRecommendations(request, intl);
    } catch (e) {
    // Ignore
    }
};
const $af3136587b54c1cd$export$f16e39d5b6af63da = (peopleAndTeamSections, maxItemsPerSection)=>{
    const intl = (0, $koVbs.default)();
    return async (query, { baseUrl: baseUrl, context: context, resolveTeamUrl: resolveTeamUrl, resolveUserUrl: resolveUserUrl })=>{
        const teamsRequest = $af3136587b54c1cd$var$resolveRecommendationRequest({
            includeTeams: true,
            baseUrl: baseUrl,
            context: context,
            query: query,
            maxNumberOfResults: 20
        });
        // Separate requests enables better empty query results for each section
        const usersRequest = $af3136587b54c1cd$var$resolveRecommendationRequest({
            includeUsers: true,
            baseUrl: baseUrl,
            context: context,
            query: query,
            maxNumberOfResults: 20
        });
        try {
            const [teams, users] = await Promise.all([
                $af3136587b54c1cd$var$asyncGetUserRecommendations(teamsRequest, intl),
                $af3136587b54c1cd$var$asyncGetUserRecommendations(usersRequest, intl)
            ]);
            const teamResults = teams?.map((team)=>{
                return {
                    title: team.name,
                    id: team.id,
                    meta: '',
                    url: resolveTeamUrl ? resolveTeamUrl(team.id) : `/people/team/${team.id}`,
                    iconUrl: team.avatarUrl,
                    isVerified: team.verified
                };
            }) ?? [];
            const userResults = users?.map((user)=>{
                return {
                    title: user.name,
                    id: user.id,
                    meta: user.title || '',
                    url: resolveUserUrl ? resolveUserUrl(user.id) : `/people/${user.id}`,
                    iconUrl: user.avatarUrl
                };
            }) ?? [];
            return {
                sections: [
                    {
                        ...peopleAndTeamSections.people,
                        searchResults: maxItemsPerSection ? userResults.slice(0, maxItemsPerSection) : userResults
                    },
                    {
                        ...peopleAndTeamSections.teams,
                        searchResults: maxItemsPerSection ? teamResults.slice(0, maxItemsPerSection) : teamResults
                    }
                ]
            };
        } catch (error) {
            return {
                sections: [
                    {
                        ...peopleAndTeamSections.people,
                        searchResults: []
                    },
                    {
                        ...peopleAndTeamSections.teams,
                        searchResults: []
                    }
                ]
            };
        }
    };
};

});
parcelRegister("cZrdv", function(module, exports) {

let $97504b3c6f72f37c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $97504b3c6f72f37c$var$load("ffQaD"),
    $97504b3c6f72f37c$var$load("kvRbA"),
    $97504b3c6f72f37c$var$load("jFR9o")
]).then(()=>parcelRequire('jVMu6'));

});


parcelRegister("8entA", function(module, exports) {

$parcel$export(module.exports, "getTeamData", () => $361c7e4e68dd06c6$export$c11a6707e0ba3a30);

var $dS9cn = parcelRequire("dS9cn");
const $361c7e4e68dd06c6$export$a637ff7dbe7c1532 = ({ teamId: teamId, siteId: siteId })=>{
    if (teamId === undefined || siteId === undefined) throw new Error('Missing some required parameters teamId and siteId');
    return `/gateway/api/v4/teams/${encodeURIComponent(teamId)}?siteId=${encodeURIComponent(siteId)}`;
};
const $361c7e4e68dd06c6$export$c11a6707e0ba3a30 = ({ url: url, teamAri: teamAri, siteId: siteId })=>{
    const parts = teamAri.split('/');
    const teamId = parts[parts.length - 1];
    const options = {
        path: $361c7e4e68dd06c6$export$a637ff7dbe7c1532({
            teamId: teamId,
            siteId: siteId
        }),
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    return (0, $dS9cn.utils).requestService({
        url: url
    }, options);
};

});

parcelRegister("e53Rq", function(module, exports) {

$parcel$export(module.exports, "compassURLGenerators", () => $f78a1d7e5ef82a0f$export$9dd4fd2059f2de3b);
const $f78a1d7e5ef82a0f$var$getBaseURL = ()=>window.location.origin;
const $f78a1d7e5ef82a0f$export$9dd4fd2059f2de3b = (searchUrlOverride)=>{
    const advancedSearchLinkGenerator = (query)=>`${searchUrlOverride || $f78a1d7e5ef82a0f$var$getBaseURL()}/compass/components?query=${encodeURIComponent(query)}`;
    const teamUrlGenerator = (teamId)=>`${$f78a1d7e5ef82a0f$var$getBaseURL()}/compass/people/team/${teamId}`;
    const userUrlGenerator = (userId)=>`${$f78a1d7e5ef82a0f$var$getBaseURL()}/people/${userId}`;
    return {
        advancedSearchLinkGenerator: advancedSearchLinkGenerator,
        teamUrlGenerator: teamUrlGenerator,
        userUrlGenerator: userUrlGenerator
    };
};

});


parcelRegister("6zJmu", function(module, exports) {

$parcel$export(module.exports, "UpsellTab", () => $77f5ac77ff5ac3e8$export$2570220d7265a66b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $75NXP = parcelRequire("75NXP");

var $3H5gB = parcelRequire("3H5gB");

var $kgoHi = parcelRequire("kgoHi");

const $77f5ac77ff5ac3e8$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>Promise.resolve((parcelRequire("3u0c5"))).then((module)=>{
        return {
            default: module.default
        };
    }));
const $77f5ac77ff5ac3e8$var$UpsellTabWithIntl = ({ intl: intl, title: title })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'compassSearchCrossFlowExperiment',
            source: 'searchDialog'
        });
    }, [
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        alignItems: "center",
        columnGap: "space.100",
        testId: "compass-upsell-modal-header",
        children: [
            title,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($77f5ac77ff5ac3e8$var$Lozenge, {
                    appearance: "new",
                    children: intl.formatMessage((0, $3H5gB.messages).compass_upsell_tab_lozenge)
                })
            })
        ]
    });
};
const $77f5ac77ff5ac3e8$export$2570220d7265a66b = (0, $8RXs9.default)($77f5ac77ff5ac3e8$var$UpsellTabWithIntl);

});
parcelRegister("3H5gB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e6da5d64e2351011$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e6da5d64e2351011$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Compass upsell tab
	 */ compass_upsell_tab_lozenge: {
        id: 'product_search_dialog.compass.upsell_tab_title_lozenge',
        defaultMessage: 'New',
        description: 'Lozenge next to Compass tab title indicating new functionality'
    },
    compass_upsell_heading: {
        id: 'product_search_dialog.compass.upsell_modal_heading',
        defaultMessage: 'Control your software sprawl, so developers can control their time',
        description: 'Upsell modal heading presented to users who do not have Compass activated'
    },
    compass_upsell_heading_bitbucket: {
        id: 'product_search_dialog.compass.upsell_modal_heading.bitbucket',
        defaultMessage: 'Bring more context to your code',
        description: 'Upsell modal heading presented to Bitbucket users who do not have Compass activated'
    },
    compass_upsell_description: {
        id: 'product_search_dialog.compass.upsell_modal_description',
        defaultMessage: "Catalog your software architecture in one place \u2013 so the teams working on it can reduce context switching, find what they need faster, and be more productive. How\u2019s that for a developer experience?",
        description: 'Upsell modal description presented to users who don not have Compass activated'
    },
    compass_upsell_description_bitbucket: {
        id: 'product_search_dialog.compass.upsell_modal_description.bitbucket',
        defaultMessage: 'See owners, dependencies, and help resources for your repositories by linking them to a central software catalog.',
        description: 'Upsell modal description presented to Bitbucket users who don not have Compass activated'
    },
    compass_upsell_learn_more_link: {
        id: 'product_search_dialog.compass.upsell_modal_learn_more_link',
        defaultMessage: 'Learn more',
        description: 'Text for the learn more about Compass link'
    },
    compass_upsell_learn_more_aria_label: {
        id: 'product_search_dialog.compass.upsell_modal_learn_more_aria_label',
        defaultMessage: 'Learn more about Compass',
        description: 'Arial label text for the learn more about Compass link'
    },
    compass_upsell_cta_button: {
        id: 'product_search_dialog.compass.upsell_modal_cta_text',
        defaultMessage: 'Get Compass free',
        description: 'Text for the button clicking which will navigate user to the sign up page'
    }
});

});


parcelRegister("1pUZm", function(module, exports) {

let $108454fdac148eb3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $108454fdac148eb3$var$load("kNFvF"),
    $108454fdac148eb3$var$load("c8GJv")
]).then(()=>parcelRequire('7y0yx'));

});


parcelRegister("dlQRr", function(module, exports) {

$parcel$export(module.exports, "FilterContextProvider", () => $61296a19a0baeca4$export$eb71bf38f5ae0f9c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $tUDIN = parcelRequire("tUDIN");

var $5uOu6 = parcelRequire("5uOu6");

var $2k6eV = parcelRequire("2k6eV");
const $61296a19a0baeca4$export$5767e6ba1d152dc0 = ()=>{
    const lastModifiedDate = new Date();
    lastModifiedDate.setDate(lastModifiedDate.getDate() - 90);
    return lastModifiedDate.toISOString().split('T')[0];
};
const $61296a19a0baeca4$var$useFilters = (defaultFilters = [], storeFilters = (value)=>{})=>{
    const { filters: filters, dispatch: dispatch } = (0, $5uOu6.useFilter)(defaultFilters);
    (0, $5uXOq.useLayoutEffect)(()=>{
        storeFilters(filters);
    });
    const addFilters = (0, $5uXOq.useCallback)((newFilters)=>{
        dispatch((0, $5uOu6.addFilters)(newFilters));
        storeFilters(filters.concat(newFilters));
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const updateFilter = (0, $5uXOq.useCallback)((id, isChecked)=>{
        dispatch((0, $5uOu6.updateFilterState)(id, isChecked, true));
        const index = filters.findIndex((filter)=>filter.id === id);
        const newFilters = [
            ...filters
        ];
        newFilters[index] = {
            ...newFilters[index],
            isChecked: isChecked,
            isVisible: true
        };
        storeFilters(filters.concat(newFilters));
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const clearFilter = (0, $5uXOq.useCallback)(()=>{
        filters.forEach((f)=>{
            dispatch((0, $5uOu6.updateFilterState)(f.id, false));
        });
        const newFilters = filters.map((f)=>{
            const newF = {
                ...f
            };
            newF.isChecked = false;
            return newF;
        });
        storeFilters(newFilters);
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const resetFilter = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $5uOu6.replaceAllFilters)(defaultFilters));
    }, [
        defaultFilters,
        dispatch
    ]);
    return {
        availableFilters: filters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch
    };
};
const $61296a19a0baeca4$var$DEFAULT_FILTER_STATE = {
    availableFilters: [],
    addFilters: ()=>{},
    updateFilter: ()=>{},
    clearFilter: ()=>{},
    reset: ()=>{},
    dispatch: ()=>{}
};
const $61296a19a0baeca4$var$FilterContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    spaceFilters: $61296a19a0baeca4$var$DEFAULT_FILTER_STATE,
    peopleFilters: $61296a19a0baeca4$var$DEFAULT_FILTER_STATE,
    siteFilters: $61296a19a0baeca4$var$DEFAULT_FILTER_STATE,
    resetFilters: ()=>{},
    prequeryFiltersRef: {
        current: ''
    }
});
function $61296a19a0baeca4$export$5e1edcb3c154ab79(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $61296a19a0baeca4$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultSpaceFilters: defaultSpaceFilters, defaultPeopleFilters: defaultPeopleFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
    const previousEnabledState = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(isEnabled);
    const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters, resetConfluenceFiltersRef: resetConfluenceFiltersRef } = (0, $2k6eV.useSessionUserInput)();
    const [filters, setFilters] = (0, $5uXOq.useState)(readFilters('confluence'));
    const initialSpaceFilters = stickySearchEnabled ? filters?.space || defaultSpaceFilters : defaultSpaceFilters;
    const initialPeopleFilters = stickySearchEnabled ? filters?.people || defaultPeopleFilters : defaultPeopleFilters;
    const initialSiteFilters = stickySearchEnabled ? filters?.site || defaultSiteFilters : defaultSiteFilters;
    const getUpdateFilters = (0, $5uXOq.useCallback)((type)=>(options)=>{
            const filters = readFilters('confluence');
            switch(type){
                case 'SPACE':
                    filters.space = options;
                    break;
                case 'PEOPLE':
                    filters.people = options;
                    break;
                case 'SITE':
                    filters.site = options;
                    break;
            }
            storeFilters('confluence', filters);
        }, [
        readFilters,
        storeFilters
    ]);
    const spaceFilterStore = $61296a19a0baeca4$var$useFilters(initialSpaceFilters, stickySearchEnabled ? getUpdateFilters('SPACE') : undefined);
    const peopleFilterStore = $61296a19a0baeca4$var$useFilters(initialPeopleFilters, stickySearchEnabled ? getUpdateFilters('PEOPLE') : undefined);
    const siteFilterStore = $61296a19a0baeca4$var$useFilters(initialSiteFilters, stickySearchEnabled ? getUpdateFilters('SITE') : undefined);
    const prequeryFiltersRef = (0, $5uXOq.useRef)('');
    const filtersAnalyticsContext = spaceFilterStore.availableFilters.length === 0 && peopleFilterStore.availableFilters.length === 0 ? {} : {
        container: $61296a19a0baeca4$export$5e1edcb3c154ab79(spaceFilterStore.availableFilters),
        contributor: $61296a19a0baeca4$export$5e1edcb3c154ab79(peopleFilterStore.availableFilters)
    };
    const resetFilters = (0, $5uXOq.useCallback)(()=>{
        spaceFilterStore.dispatch((0, $5uOu6.replaceAllFilters)(defaultSpaceFilters || []));
        peopleFilterStore.dispatch((0, $5uOu6.replaceAllFilters)(defaultPeopleFilters || []));
        siteFilterStore.dispatch((0, $5uOu6.replaceAllFilters)(defaultSiteFilters || []));
    }, [
        defaultPeopleFilters,
        defaultSiteFilters,
        defaultSpaceFilters,
        peopleFilterStore,
        siteFilterStore,
        spaceFilterStore
    ]);
    const clearFilters = (0, $5uXOq.useCallback)(()=>{
        spaceFilterStore.clearFilter();
        peopleFilterStore.clearFilter();
        siteFilterStore.clearFilter();
        if (stickySearchEnabled) setFilters(readFilters('confluence'));
    }, [
        spaceFilterStore,
        peopleFilterStore,
        siteFilterStore,
        stickySearchEnabled,
        readFilters
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (resetConfluenceFiltersRef) resetConfluenceFiltersRef.current = clearFilters;
    }, [
        clearFilters,
        resetConfluenceFiltersRef
    ]);
    // We reset the state when the component becomes disabled
    if (previousEnabledState.current && !isEnabled && !stickySearchEnabled) resetFilters();
    previousEnabledState.current = isEnabled;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($61296a19a0baeca4$var$FilterContext.Provider, {
        value: {
            spaceFilters: spaceFilterStore,
            peopleFilters: peopleFilterStore,
            siteFilters: siteFilterStore,
            resetFilters: resetFilters,
            prequeryFiltersRef: prequeryFiltersRef
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext,
            children: children
        })
    });
};
const $61296a19a0baeca4$export$396ef541d9951d45 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($61296a19a0baeca4$var$FilterContext);
};

});
parcelRegister("5uOu6", function(module, exports) {

$parcel$export(module.exports, "addFilters", () => $90e82477d9a909f4$export$60c1905c6f855529);
$parcel$export(module.exports, "replaceAllFilters", () => $90e82477d9a909f4$export$4dce09b3092bd5e8);
$parcel$export(module.exports, "updateFilterState", () => $90e82477d9a909f4$export$e4269d58720a0c2c);
$parcel$export(module.exports, "useFilter", () => $90e82477d9a909f4$export$3274cf84b703fff);

var $5uXOq = parcelRequire("5uXOq");
const $90e82477d9a909f4$export$60c1905c6f855529 = (filters, sortFunction)=>({
        type: 'ADD_FILTERS',
        newFilters: filters,
        sortFunction: sortFunction
    });
const $90e82477d9a909f4$export$3be5fe9f09d6965 = (id)=>({
        type: 'REMOVE_FILTER',
        id: id
    });
const $90e82477d9a909f4$export$4dce09b3092bd5e8 = (newFilters)=>({
        type: 'REPLACE_ALL_FILTERS',
        newFilters: newFilters
    });
const $90e82477d9a909f4$export$e4269d58720a0c2c = (filterId, isChecked, isVisible)=>({
        type: 'UPDATE_FILTER_STATE',
        filterId: filterId,
        isChecked: isChecked,
        isVisible: isVisible
    });
const $90e82477d9a909f4$export$234bf2a76076d85a = (newFilters)=>({
        type: 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED',
        newFilters: newFilters
    });
function $90e82477d9a909f4$var$reducer(state, action) {
    switch(action.type){
        case 'ADD_FILTERS':
            {
                if (action.newFilters.length === 0) return state;
                let newState = [
                    ...state
                ];
                action.newFilters.forEach((f)=>{
                    const index = state.findIndex((filter)=>filter.id === f.id);
                    if (index === -1) newState.push(f);
                    else {
                        newState[index] = f;
                        return newState;
                    }
                });
                action.sortFunction && newState.sort(action.sortFunction);
                return newState;
            }
        case 'UPDATE_FILTER_STATE':
            {
                const index = state.findIndex((filter)=>filter.id === action.filterId);
                if (index === -1) return state;
                const newState = [
                    ...state
                ];
                newState[index] = {
                    ...newState[index],
                    isChecked: action.isChecked,
                    isVisible: action.isVisible === undefined || action.isVisible === null ? newState[index].isVisible : action.isVisible
                };
                return newState;
            }
        case 'REMOVE_FILTER':
            return [
                ...state.filter((filter)=>filter.id !== action.id)
            ];
        case 'REPLACE_ALL_FILTERS':
            return [
                ...action.newFilters
            ];
        case 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED':
            {
                const newState = action.newFilters.map((newFilter)=>{
                    const existingFilter = state.find((f)=>f.id === newFilter.id);
                    if (existingFilter && newFilter.isVisible) newFilter.isChecked = existingFilter.isChecked;
                    return newFilter;
                });
                return newState;
            }
        default:
            // exhaustive check
            const _ = action;
            throw new Error(_);
    }
}
const $90e82477d9a909f4$export$3274cf84b703fff = (initialValues)=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useReducer($90e82477d9a909f4$var$reducer, initialValues ? initialValues : []);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            filters: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return value;
};

});


parcelRegister("ktKQy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceUpsellInJiraTab", () => $ab081021b1e03f9c$export$571ac4203f9feb16);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $k4hbD = parcelRequire("k4hbD");

var $8Xs9r = parcelRequire("8Xs9r");

var $5S6Yv = parcelRequire("5S6Yv");

var $9WUgS = parcelRequire("9WUgS");

var $4DehF = parcelRequire("4DehF");

var $2PjIt = parcelRequire("2PjIt");

var $jmlNs = parcelRequire("jmlNs");

var $f4GCr = parcelRequire("f4GCr");

var $3UF9C = parcelRequire("3UF9C");

var $azBuE = parcelRequire("azBuE");
const $ab081021b1e03f9c$export$571ac4203f9feb16 = ({ recentClientConfig: recentClientConfig, formatDate: formatDate, children: children, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled = false, rendererOverride: rendererOverride, confluenceAvailabilityExperiment: confluenceAvailabilityExperiment, ...rest })=>{
    const { defineFilters: defineFilters } = (0, $3UF9C.useGenericFilters)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const initializeFilters = (0, $5uXOq.useCallback)(()=>{
        defineFilters((0, $5S6Yv.CONFLUENCE_PRODUCT_ID), []);
    }, [
        defineFilters
    ]);
    initializeFilters();
    const sections = (0, $4DehF.useConfluenceSections)({
        formatDate: formatDate,
        autocorrectEnabled: autocorrectEnabled,
        additionalContentTypesEnabled: additionalContentTypesEnabled,
        rendererOverride: rendererOverride
    });
    const itemSuppliers = (0, $f4GCr.useDefaultSuppliers)((0, $5S6Yv.CONFLUENCE_PRODUCT_ID), sections, {
        preQueryItemSupplier: undefined,
        postQueryItemSupplier: undefined
    });
    const { isTabClicked: isConfluenceAvailabilityTabClicked, setAllowConfluenceAccessCache: setAllowConfluenceAccessCache } = confluenceAvailabilityExperiment ?? {
        isTabClicked: false
    };
    const confluenceAvailabilityExperimentTabRenderer = (0, $5uXOq.useCallback)(({ title: title })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PjIt.ConfluenceAvailabilityExperimentTab), {
            title: title,
            isTabClicked: isConfluenceAvailabilityTabClicked
        }), [
        isConfluenceAvailabilityTabClicked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        id: (0, $5S6Yv.CONFLUENCE_PRODUCT_ID),
        title: formatMessage((0, $k4hbD.messages).confluence_tab_label),
        tabRenderer: confluenceAvailabilityExperimentTabRenderer,
        sections: sections,
        ...rest,
        ...itemSuppliers,
        permissionSupplier: (0, $9WUgS.defaultPermissionsSupplier),
        children: ({ productState: productState })=>{
            //Force set confluence access cache to true if the product state is PreQuerySuccess
            //This is specifically for the case where the user has access to confluence but the confluence access cache is not updated.
            if (productState === (0, $azBuE.ProductStates).PreQuerySuccess) setAllowConfluenceAccessCache?.();
            return {
                Body: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jmlNs.ConfluenceAvailabilityTabBody), {
                        confluenceUrl: recentClientConfig.url
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {})
            };
        }
    });
};

});
parcelRegister("5S6Yv", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_PRODUCT_ID", () => $37972a2792953ed7$export$661dd16d63ed8290);
$parcel$export(module.exports, "NAVIGATION_V3_EXPERIENCE", () => $37972a2792953ed7$export$4a204ebf24901f2e);
$parcel$export(module.exports, "SPACE_FILTER_LIMIT", () => $37972a2792953ed7$export$10d5a4cb19960c6c);
$parcel$export(module.exports, "PEOPLE_FILTER_LIMIT", () => $37972a2792953ed7$export$b41e7ecd9ba9baff);
$parcel$export(module.exports, "ConfluenceFilters", () => $37972a2792953ed7$export$cf834bb06694a4e);
$parcel$export(module.exports, "ConfluenceScope", () => $37972a2792953ed7$export$bb0f876d33576f3f);
const $37972a2792953ed7$export$661dd16d63ed8290 = 'confluence';
const $37972a2792953ed7$export$4a204ebf24901f2e = 'confluence.nav-v3';
const $37972a2792953ed7$export$d4cf0635e2303166 = 250;
const $37972a2792953ed7$export$10d5a4cb19960c6c = 10;
const $37972a2792953ed7$export$b41e7ecd9ba9baff = 10;
var $37972a2792953ed7$export$cf834bb06694a4e = /*#__PURE__*/ function(ConfluenceFilters) {
    ConfluenceFilters["Space"] = "spaces";
    ConfluenceFilters["People"] = "contributors";
    ConfluenceFilters["Date"] = "lastModified";
    return ConfluenceFilters;
}({});
var $37972a2792953ed7$export$bb0f876d33576f3f = /*#__PURE__*/ function(ConfluenceScope) {
    ConfluenceScope["Item"] = "confluence.page,blogpost,attachment";
    ConfluenceScope["Space"] = "confluence.space";
    ConfluenceScope["People"] = "urs.user-confluence";
    ConfluenceScope["Content"] = "confluence.page,blogpost,attachment,whiteboard";
    return ConfluenceScope;
}({});

});

parcelRegister("9WUgS", function(module, exports) {

$parcel$export(module.exports, "defaultPermissionsSupplier", () => $2bbcecdd256c45ee$export$79b79eb7219cb5fd);

var $5S6Yv = parcelRequire("5S6Yv");
const $2bbcecdd256c45ee$export$79b79eb7219cb5fd = ()=>{
    const response = Object.values((0, $5S6Yv.ConfluenceScope));
    return Promise.resolve(response);
};

});

parcelRegister("4DehF", function(module, exports) {

$parcel$export(module.exports, "useConfluenceSections", () => $432480fd53e8a34c$export$468e9a0e16eb3222);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5S6Yv = parcelRequire("5S6Yv");

var $k4hbD = parcelRequire("k4hbD");

var $iRI1s = parcelRequire("iRI1s");

var $luwNM = parcelRequire("luwNM");

var $bONub = parcelRequire("bONub");

var $lMcGZ = parcelRequire("lMcGZ");
const $432480fd53e8a34c$var$ITEM_LIMIT_SIZE = 10;
const $432480fd53e8a34c$var$SPACE_LIMIT_SIZE = 3;
const $432480fd53e8a34c$var$PEOPLE_LIMIT_SIZE = 3;
const $432480fd53e8a34c$export$468e9a0e16eb3222 = ({ formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled, rendererOverride: rendererOverride })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const confluenceItemResultMapper = (0, $5uXOq.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.content.id,
                title: result.title,
                type: result.content.type,
                meta: result.container.title,
                additionalMeta: result.lastModified ? formatDate ? formatDate(result.lastModified) : (0, $iRI1s.defaultFormatDate)(result.lastModified) : '',
                url: `${result.baseUrl}${result.url}`,
                containerId: result.content?.space?.id || result.container?.id || 'UNAVAILABLE',
                iconRenderer: (0, $luwNM.ConfluenceItemIconRenderer)(result, true)
            })).slice(0, $432480fd53e8a34c$var$ITEM_LIMIT_SIZE), [
        formatDate
    ]);
    const confluenceSpaceResultMapper = (0, $5uXOq.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.id,
                title: result.title,
                meta: '',
                url: `${result.baseUrl || ''}${result.container.displayUrl}`,
                containerId: result.id,
                icon: (0, $luwNM.GenericConfluenceIconRenderer)(`${result.baseUrl}${result.space.icon.path}`, true)
            })).slice(0, $432480fd53e8a34c$var$SPACE_LIMIT_SIZE), []);
    const confluencePeopleResultMapper = (0, $5uXOq.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.id,
                title: result.name,
                meta: '',
                url: result.absoluteUrl?.replace('/people', '/wiki/people') || '',
                containerId: '',
                icon: (0, $luwNM.GenericConfluenceIconRenderer)(result.avatarUrl, true)
            })).slice(0, $432480fd53e8a34c$var$PEOPLE_LIMIT_SIZE), []);
    const enableSpaceAndPeopleScope = (query, filters)=>{
        return !filters.find((filter)=>filter['@type'] === 'spaces' && filter['spaceKeys'].length > 0 || filter['@type'] === 'contributors' && filter['accountIds'].length > 0 || filter['@type'] === 'lastModified' && filter.from && filter.from !== (0, $bONub.DEFAULT_OPTION));
    };
    const scopeId = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, $5S6Yv.ConfluenceScope).Item;
    return (0, $5uXOq.useMemo)(()=>[
            {
                id: scopeId,
                title: formatMessage((0, $k4hbD.messages).confluence_content_section_heading),
                titleRenderer: (0, $lMcGZ.sectionTitleRenderer)(!!autocorrectEnabled),
                resultRenderer: additionalContentTypesEnabled && !!rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, $lMcGZ.ConfluenceItemResultRenderer),
                scope: scopeId,
                resultMapper: confluenceItemResultMapper,
                showResultCount: true,
                resultLimit: $432480fd53e8a34c$var$ITEM_LIMIT_SIZE
            },
            {
                id: (0, $5S6Yv.ConfluenceScope).Space,
                title: formatMessage((0, $k4hbD.messages).confluence_spaces_section_heading),
                scope: (0, $5S6Yv.ConfluenceScope).Space,
                resultMapper: confluenceSpaceResultMapper,
                isEnabled: enableSpaceAndPeopleScope
            },
            {
                id: (0, $5S6Yv.ConfluenceScope).People,
                title: formatMessage((0, $k4hbD.messages).confluence_people_section_heading),
                scope: (0, $5S6Yv.ConfluenceScope).People,
                resultMapper: confluencePeopleResultMapper,
                isEnabled: enableSpaceAndPeopleScope
            }
        ], [
        formatMessage,
        autocorrectEnabled,
        confluenceItemResultMapper,
        confluenceSpaceResultMapper,
        confluencePeopleResultMapper,
        scopeId,
        additionalContentTypesEnabled,
        rendererOverride
    ]);
};

});
parcelRegister("iRI1s", function(module, exports) {

$parcel$export(module.exports, "useConfluenceAdvancedSearchUrlFactory", () => $845351b910327ad7$export$e189237de9f436c5);
$parcel$export(module.exports, "defaultFormatDate", () => $845351b910327ad7$export$579a505f09fc5afa);

var $5uXOq = parcelRequire("5uXOq");
const $845351b910327ad7$var$CONFLUENCE_ADVANCED_SEARCH_URL = '/wiki/search';
const $845351b910327ad7$var$removeDuplicateWikiInUrl = (siteUrl)=>{
    return siteUrl.replace(/\/wiki(\/)?$/, '');
};
function $845351b910327ad7$export$e189237de9f436c5(siteUrl, filters) {
    const trimmedSiteUrl = $845351b910327ad7$var$removeDuplicateWikiInUrl(siteUrl);
    const spaceFilterString = filters.spaceFilters.length > 0 ? `&spaces=${encodeURIComponent(filters.spaceFilters.join(','))}` : '';
    const peopleFilterString = filters.peopleFilters.length > 0 ? `&contributors=${encodeURIComponent(filters.peopleFilters.join(','))}` : '';
    const dateFilterString = filters.dateFilter.length > 0 ? `&lastModified=${filters.dateFilter[0]}` : '';
    return (0, $5uXOq.useCallback)((query, siteUrl)=>{
        const url = siteUrl ? $845351b910327ad7$var$removeDuplicateWikiInUrl(siteUrl) : trimmedSiteUrl;
        const trimmedQuery = query.trim();
        if (!trimmedQuery) return `${url}${$845351b910327ad7$var$CONFLUENCE_ADVANCED_SEARCH_URL}`;
        return `${url}${$845351b910327ad7$var$CONFLUENCE_ADVANCED_SEARCH_URL}?text=${encodeURIComponent(trimmedQuery)}${spaceFilterString}${peopleFilterString}${dateFilterString}`;
    }, [
        trimmedSiteUrl,
        spaceFilterString,
        peopleFilterString,
        dateFilterString
    ]);
}
const $845351b910327ad7$export$579a505f09fc5afa = (lastModified)=>{
    const date = new Date(lastModified);
    return date.toLocaleString();
};

});

parcelRegister("luwNM", function(module, exports) {

$parcel$export(module.exports, "getAvatarForConfluenceObjectResult", () => $58a870bb05bb3b63$export$310004de4fa0ccba);
$parcel$export(module.exports, "ConfluenceItemIconRenderer", () => $58a870bb05bb3b63$export$9e3ce228520dfa00);
$parcel$export(module.exports, "GenericConfluenceIconRenderer", () => $58a870bb05bb3b63$export$8fde8d521a2cd996);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8njZH = parcelRequire("8njZH");

var $dOkKo = parcelRequire("dOkKo");

var $eABwY = parcelRequire("eABwY");

var $7BHMh = parcelRequire("7BHMh");

var $daL8e = parcelRequire("daL8e");

var $5m93C = parcelRequire("5m93C");

var $kKp2J = parcelRequire("kKp2J");

var $6cEsd = parcelRequire("6cEsd");

var $lDRqn = parcelRequire("lDRqn");

var $im5Hg = parcelRequire("im5Hg");

var $iRZQl = parcelRequire("iRZQl");

var $liajA = parcelRequire("liajA");

var $9CRO6 = parcelRequire("9CRO6");

var $lBSka = parcelRequire("lBSka");

var $7zjHG = parcelRequire("7zjHG");

var $jGmM2 = parcelRequire("jGmM2");

var $dg1MW = parcelRequire("dg1MW");

var $2tm8x = parcelRequire("2tm8x");

var $cHwqN = parcelRequire("cHwqN");

var $gYsK7 = parcelRequire("gYsK7");

var $b7OK3 = parcelRequire("b7OK3");

var $2sfBf = parcelRequire("2sfBf");

var $7oCpB = parcelRequire("7oCpB");

var $lpihe = parcelRequire("lpihe");

var $1KrIR = parcelRequire("1KrIR");
/**
 * The following code was derived from an implementation in confluence-frontend,
 * although it differs substantially.
 *
 * The original can be found at ./packages/confluence-rest-api/src/helpers/icons.js
 */ const $58a870bb05bb3b63$var$ATTACHMENT_ICON_CLASS_PREFIXES = [
    // Quick Nav prefix
    'content-type-attachment-',
    // CQL prefix
    'icon-file-'
];
const $58a870bb05bb3b63$var$DEFAULT_ATTACHMENT_AVATAR = (0, (/*@__PURE__*/$parcel$interopDefault($7BHMh)));
const $58a870bb05bb3b63$var$DEFAULT_ATTACHMENT_AVATAR_LARGE = (0, (/*@__PURE__*/$parcel$interopDefault($jGmM2)));
const $58a870bb05bb3b63$var$ATTACHMENT_FILE_EXTENSION_MATCHERS = [
    {
        regexp: /\.(gif|jpeg|jpg|png)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($daL8e))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($dg1MW)))
    },
    {
        regexp: /\.(pdf)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($5m93C))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($im5Hg))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($6cEsd))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($eABwY))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($dOkKo))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($lBSka)))
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($kKp2J))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($lDRqn))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($b7OK3)))
    },
    {
        regexp: /\.(zip)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($8njZH))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($9CRO6)))
    }
];
const $58a870bb05bb3b63$var$getIconType = (iconClass, fileName, isLarge)=>{
    // Check the iconClass to make sure we're looking at an attachment
    const prefixMatches = $58a870bb05bb3b63$var$ATTACHMENT_ICON_CLASS_PREFIXES.find((prefix)=>{
        return iconClass.startsWith(prefix);
    });
    // if it's an attachment, look at the file extension to work out which type
    if (prefixMatches) {
        const matchingType = $58a870bb05bb3b63$var$ATTACHMENT_FILE_EXTENSION_MATCHERS.find((extensionMatcher)=>{
            const matches = extensionMatcher.regexp.exec(fileName);
            return !!matches && matches.length > 0;
        });
        if (matchingType) return isLarge ? matchingType.avatarLarge : matchingType.avatar;
    }
    return isLarge ? $58a870bb05bb3b63$var$DEFAULT_ATTACHMENT_AVATAR_LARGE : $58a870bb05bb3b63$var$DEFAULT_ATTACHMENT_AVATAR;
};
const $58a870bb05bb3b63$export$310004de4fa0ccba = ({ type: type, title: title, iconCssClass: iconCssClass, isCollapsed: isCollapsed })=>{
    if (type === 'page' || type === 'confluence-page') {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- no icon available (https://product-fabric.atlassian.net/browse/DSP-20735)
        const Icon = isCollapsed ? (0, $lpihe.default) : (0, $liajA.default);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: type
        });
    } else if (type === 'blogpost' || type === 'confluence-blogpost') {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- no icon available (https://product-fabric.atlassian.net/browse/DSP-20735)
        const Icon = isCollapsed ? (0, $7oCpB.default) : (0, $iRZQl.default);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: type
        });
    } else if (type === 'attachment') {
        const IconComponent = $58a870bb05bb3b63$var$getIconType(iconCssClass || '', title, isCollapsed);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(IconComponent, {
            label: type
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
};
const $58a870bb05bb3b63$export$9e3ce228520dfa00 = (result, largerIcons)=>()=>{
        if (result.content) return $58a870bb05bb3b63$export$310004de4fa0ccba({
            type: result.content.type,
            title: result.content.type,
            iconCssClass: result.iconCssClass,
            isCollapsed: largerIcons
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
    };
const $58a870bb05bb3b63$export$8fde8d521a2cd996 = (iconUrl, largerIcons)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1KrIR.ResultAvatar), {
        borderColor: "transparent",
        src: iconUrl,
        appearance: "square",
        size: largerIcons ? 'small' : 'xsmall',
        testId: "result-avatar"
    });

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("liajA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41b90368f925c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79077d9339ad2083a3901f522ad14f6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $kdfZa = parcelRequire("kdfZa");

var $VSDnB = parcelRequire("VSDnB");

var $kZjZ3 = parcelRequire("kZjZ3");
/**
 * __16px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c41b90368f925c6c$var$Page16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZjZ3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZjZ3.default), {
        label: label,
        testId: testId
    });
};
$c41b90368f925c6c$var$Page16Icon.displayName = 'Page16Icon';
var $c41b90368f925c6c$export$2e2bcd8739ae039 = $c41b90368f925c6c$var$Page16Icon;

});
parcelRegister("kZjZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb586f8874bd1e95$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8396146cc2fa60842aed7101fb3015b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $fb586f8874bd1e95$var$Page16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`,
        ...props,
        size: "small"
    });
$fb586f8874bd1e95$var$Page16Icon.displayName = 'Page16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fb586f8874bd1e95$export$2e2bcd8739ae039 = $fb586f8874bd1e95$var$Page16Icon;

});


parcelRegister("7oCpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8806751d7f7ea905$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $asoCt = parcelRequire("asoCt");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $8806751d7f7ea905$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
        label: label,
        testId: testId
    });
};
$8806751d7f7ea905$var$Blog24Icon.displayName = 'Blog24Icon';
var $8806751d7f7ea905$export$2e2bcd8739ae039 = $8806751d7f7ea905$var$Blog24Icon;

});
parcelRegister("asoCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $158d85a5273c8dbb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $158d85a5273c8dbb$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$158d85a5273c8dbb$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$158d85a5273c8dbb$export$2e2bcd8739ae039 = $158d85a5273c8dbb$var$Blog24Icon;

});


parcelRegister("lpihe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0b3b184bfbc17b2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5be9a9ebb9218a8e901e4b7981f2d3aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $kdfZa = parcelRequire("kdfZa");

var $VSDnB = parcelRequire("VSDnB");

var $epQp2 = parcelRequire("epQp2");
/**
 * __24px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c0b3b184bfbc17b2$var$Page24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epQp2.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epQp2.default), {
        label: label,
        testId: testId
    });
};
$c0b3b184bfbc17b2$var$Page24Icon.displayName = 'Page24Icon';
var $c0b3b184bfbc17b2$export$2e2bcd8739ae039 = $c0b3b184bfbc17b2$var$Page24Icon;

});
parcelRegister("epQp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef51f4c74c79085c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53ef6f7a1832e036ce5224563679fcb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $ef51f4c74c79085c$var$Page24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`,
        ...props,
        size: "medium"
    });
$ef51f4c74c79085c$var$Page24Icon.displayName = 'Page24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ef51f4c74c79085c$export$2e2bcd8739ae039 = $ef51f4c74c79085c$var$Page24Icon;

});



parcelRegister("lMcGZ", function(module, exports) {

$parcel$export(module.exports, "sectionTitleRenderer", () => $548089604d372bb1$export$aee00814c9e3bae7);
$parcel$export(module.exports, "ConfluenceItemResultRenderer", () => $548089604d372bb1$export$1bdb91707b6d5bed);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $k4hbD = parcelRequire("k4hbD");

var $azBuE = parcelRequire("azBuE");

var $337hv = parcelRequire("337hv");

var $71Kgw = parcelRequire("71Kgw");

var $cvYmc = parcelRequire("cvYmc");

var $luwNM = parcelRequire("luwNM");
const $548089604d372bb1$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
        const { productState: productState } = args;
        const recentTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $k4hbD.messages).common_recently_viewed_section_heading
        });
        const contentTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $k4hbD.messages).confluence_content_section_heading
        });
        switch(productState){
            case (0, $azBuE.ProductStates).PreQuerySuccess:
                return recentTitle;
            case (0, $azBuE.ProductStates).PostQueryLoading:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $337hv.LoadingSkeleton), {
                    "data-testid": 'autocorrection-loading-skeleton'
                });
                return contentTitle;
            case (0, $azBuE.ProductStates).PostQuerySuccess:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $71Kgw.AutocorrectAsyncWrapper), {
                    fallback: contentTitle
                });
                return contentTitle;
            default:
                return contentTitle;
        }
    };
const $548089604d372bb1$export$1bdb91707b6d5bed = ({ searchResult: searchResult, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { productState: productState } = rest;
    if (productState === 'PreQuerySuccess') return (0, $cvYmc.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: ''
        }
    });
    if (productState === 'PostQueryLoading' || productState === 'PostQuerySuccess') return (0, $cvYmc.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: !!searchResult.isRecentResult ? formatMessage((0, $k4hbD.messages).common_recently_viewed_section_heading) : searchResult.additionalMeta,
            icon: !!searchResult.isRecentResult ? (0, $luwNM.getAvatarForConfluenceObjectResult)({
                // the recent content type is stored in additionalMeta but not displayed
                type: searchResult.additionalMeta || '',
                title: searchResult.title,
                isCollapsed: rest.isCollapsed
            }) : searchResult.icon
        }
    });
    return (0, $cvYmc.defaultResultRenderer)({
        searchResult: searchResult,
        ...rest
    });
};

});


parcelRegister("2PjIt", function(module, exports) {

$parcel$export(module.exports, "ConfluenceAvailabilityExperimentTab", () => $316b2c9f7a140275$export$7c1324847c202edb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $3u0c5 = parcelRequire("3u0c5");

var $kgoHi = parcelRequire("kgoHi");

var $hE3SI = parcelRequire("hE3SI");
const $316b2c9f7a140275$var$Tab = ({ intl: intl, title: title, isTabClicked: isTabClicked })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        alignItems: "center",
        columnGap: "space.100",
        children: [
            title,
            !isTabClicked && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: "new",
                children: intl.formatMessage((0, $hE3SI.messages).confluence_availability_tab_more_results)
            })
        ]
    });
};
const $316b2c9f7a140275$export$7c1324847c202edb = (0, $8RXs9.default)($316b2c9f7a140275$var$Tab);

});
parcelRegister("hE3SI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5aa6f210265dde57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5aa6f210265dde57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    confluence_availability_header: {
        id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.header',
        defaultMessage: 'Your team is now using Confluence',
        description: 'Section title for indicating the user can join Confluence'
    },
    confluence_availability_description: {
        id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.description',
        defaultMessage: 'Your team is collaborating in Confluence. Organize team knowledge, capture ideas, and share requirements for your Jira projects with pages, whiteboards, and databases.',
        description: 'Description text for encouraging the user to join Confluence.'
    },
    confluence_availability_learn_more_button: {
        id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.learn_more_button',
        defaultMessage: 'Learn more',
        description: 'Button to get more information about Confluence.'
    },
    confluence_availability_join_button: {
        id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.join_button',
        defaultMessage: 'Join your team',
        description: 'Button to join Confluence.'
    },
    confluence_availability_tab_more_results: {
        id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.tab.more_results',
        defaultMessage: 'More results',
        description: 'Lozenge text for indicating more results in the Confluence tab.'
    }
});

});


parcelRegister("jmlNs", function(module, exports) {

$parcel$export(module.exports, "ConfluenceAvailabilityTabBody", () => $22c662fe237b1193$export$ccbc160de81853cb);
/* confluence-availability-tab-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $1GGwS = parcelRequire("1GGwS");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $8fQL0 = parcelRequire("8fQL0");

var $azglh = parcelRequire("azglh");

var $hE3SI = parcelRequire("hE3SI");

var $75NXP = parcelRequire("75NXP");
const $22c662fe237b1193$var$styles = {
    heroImageContainer: "_2rkob7nn _1reo15vq _18m915vq _kqswh2mm",
    heroBackground: "_4t3ikbql _1bsb1c3h",
    center: "_kqswstnw _154ize3t _1ltvze3t _4t3ikbql _1bsb1osq",
    heroAnimated: "_2rkob7nn _1reo15vq _18m915vq _1bsbcv93 _4t3inx5m",
    bodyStack: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $22c662fe237b1193$var$HeroImage = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
        xcss: $22c662fe237b1193$var$styles.heroImageContainer,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $22c662fe237b1193$var$styles.heroBackground,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($azglh))),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                xcss: $22c662fe237b1193$var$styles.center,
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $22c662fe237b1193$var$styles.heroAnimated,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8fQL0))),
                        alt: ""
                    })
                })
            })
        ]
    });
const $22c662fe237b1193$var$ConfluenceAvailabilityTabBodyWithIntl = ({ confluenceUrl: confluenceUrl, intl: intl })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        fireAnalyticsEvent({
            name: 'crossProductSearchConfluenceUpsellTab',
            eventType: 'screen'
        });
    }, [
        fireAnalyticsEvent
    ]);
    const onLearnMoreClick = ()=>fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'learnMoreButton',
            actionSubjectId: 'crossProductSearchConfluenceUpsellLearnMoreButton',
            eventType: 'ui'
        });
    const onJoinClick = ()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'joinButton',
            actionSubjectId: 'crossProductSearchConfluenceUpsellJoinButton',
            eventType: 'ui'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        testId: "confluence-availability-tab-body",
        xcss: $22c662fe237b1193$var$styles.bodyStack,
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($22c662fe237b1193$var$HeroImage, {}),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "medium",
                        children: intl.formatMessage((0, $hE3SI.messages).confluence_availability_header)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        color: "color.text.subtle",
                        children: intl.formatMessage((0, $hE3SI.messages).confluence_availability_description)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
                justifyContent: "end",
                columnGap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                        appearance: "subtle",
                        href: "https://www.atlassian.com/software/confluence",
                        target: "_blank",
                        rel: "noopener",
                        testId: "confluence-availability-learn-more-button",
                        onClick: onLearnMoreClick,
                        children: intl.formatMessage((0, $hE3SI.messages).confluence_availability_learn_more_button)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                        appearance: "primary",
                        href: confluenceUrl,
                        target: "_blank",
                        rel: "noopener",
                        testId: "confluence-availability-join-button",
                        onClick: onJoinClick,
                        children: intl.formatMessage((0, $hE3SI.messages).confluence_availability_join_button)
                    })
                ]
            })
        ]
    });
};
const $22c662fe237b1193$export$ccbc160de81853cb = (0, $8RXs9.default)($22c662fe237b1193$var$ConfluenceAvailabilityTabBodyWithIntl);

});
parcelRegister("8fQL0", function(module, exports) {
module.exports = new URL("confluence-availability-hero.783f42a0.gif", import.meta.url).toString();

});

parcelRegister("azglh", function(module, exports) {
module.exports = new URL("foundational-blue-work-management.260d07fb.png", import.meta.url).toString();

});


parcelRegister("3UF9C", function(module, exports) {

$parcel$export(module.exports, "FilterContextHOC", () => $503bef5c1b783a77$export$ceb34aeb37186333);
$parcel$export(module.exports, "useGenericFilters", () => $503bef5c1b783a77$export$bc4556a4dba20090);
$parcel$export(module.exports, "useSiteFilterDefinition", () => $503bef5c1b783a77$export$aa277293bef5fdbf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $i5cPn = parcelRequire("i5cPn");

var $2k6eV = parcelRequire("2k6eV");

var $gMpaQ = parcelRequire("gMpaQ");

var $3RKSV = parcelRequire("3RKSV");

var $bONub = parcelRequire("bONub");

var $k4hbD = parcelRequire("k4hbD");
const $503bef5c1b783a77$export$95f4aabc01d7575d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    filterDefinitions: {},
    defineFilters: ()=>{}
});
const $503bef5c1b783a77$export$ceb34aeb37186333 = ({ children: children })=>{
    const filterDefinitions = (0, $5uXOq.useRef)({}).current;
    const { isExpanded: isExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const { stickySearchEnabled: stickySearchEnabled, resetExtensibleFiltersRef: resetExtensibleFiltersRef } = (0, $2k6eV.useSessionUserInput)();
    const previousExpandState = (0, $5uXOq.useRef)(isExpanded);
    const defineFilters = (productId, filters)=>{
        filterDefinitions[productId] = filters;
    };
    const resetFilters = ()=>{
        Object.keys(filterDefinitions).forEach((productId)=>{
            filterDefinitions[productId].forEach((filter)=>{
                filter.store.reset();
            });
        });
    };
    (0, $5uXOq.useEffect)(()=>{
        if (previousExpandState.current && !isExpanded && !stickySearchEnabled) Object.keys(filterDefinitions).forEach((productId)=>{
            filterDefinitions[productId].forEach((filter)=>{
                filter.store.reset();
            });
        });
        previousExpandState.current = isExpanded;
    }, [
        isExpanded,
        stickySearchEnabled
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (resetExtensibleFiltersRef) resetExtensibleFiltersRef.current = resetFilters;
    }); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $2OMIu.jsx)($503bef5c1b783a77$export$95f4aabc01d7575d.Provider, {
        value: {
            filterDefinitions: filterDefinitions,
            defineFilters: defineFilters
        },
        children: children
    });
};
const $503bef5c1b783a77$export$bc4556a4dba20090 = ()=>(0, $5uXOq.useContext)($503bef5c1b783a77$export$95f4aabc01d7575d);
const $503bef5c1b783a77$export$aa277293bef5fdbf = (workspaces, productId)=>{
    const isMultiWorkspace = workspaces && workspaces.length > 1;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const siteFilterStore = (0, $3RKSV.useFilterStore)(workspaces?.map((workspace, index)=>({
            label: workspace.name,
            id: workspace.id,
            isChecked: false,
            isVisible: index < 3,
            filterSource: (0, $gMpaQ.FilterOptionSource).EXTERNAL,
            avatarUrl: ''
        })), productId, (0, $bONub.SITE_FILTER_TYPE_NAME));
    if (isMultiWorkspace) return [
        {
            '@type': (0, $bONub.SITE_FILTER_TYPE_NAME),
            fieldName: 'values',
            store: siteFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $k4hbD.messages).site_filters_title),
            findMoreLabel: formatMessage((0, $k4hbD.messages).site_filters_find_more)
        }
    ];
    else return [];
};

});
parcelRegister("gMpaQ", function(module, exports) {

$parcel$export(module.exports, "FilterOptionSource", () => $c1bdcdaf62eb4986$export$a386c4ddeb43c20a);
var $c1bdcdaf62eb4986$export$a386c4ddeb43c20a = /*#__PURE__*/ function(FilterOptionSource) {
    /**
	 * This means the result came from collab graph
	 */ FilterOptionSource["COLLABORATION_GRAPH"] = "COLLABORATION_GRAPH";
    /**
	 * This means the result came from smart user picker
	 */ FilterOptionSource["SMART_USER_PICKER"] = "SMART_USER_PICKER";
    /**
	 * This means the result came from a recents (bootstrap) query
	 */ FilterOptionSource["RECENT"] = "RECENT";
    /**
	 * This means the result came from an explicit search
	 */ FilterOptionSource["SEARCH"] = "SEARCH";
    /**
	 * This means the result is derived from the current user
	 */ FilterOptionSource["CURRENT_USER"] = "CURRENT_USER";
    /**
	 * This means the result came from an external source passed into the component
	 */ FilterOptionSource["EXTERNAL"] = "EXTERNAL";
    /**
	 * This means the result is static without any user-generation
	 */ FilterOptionSource["STATIC"] = "STATIC";
    return FilterOptionSource;
}({});

});

parcelRegister("3RKSV", function(module, exports) {

$parcel$export(module.exports, "useFilterStore", () => $c22de69bbcb043d2$export$875b296eac126ec2);

var $5uXOq = parcelRequire("5uXOq");

var $gMpaQ = parcelRequire("gMpaQ");

var $5uOu6 = parcelRequire("5uOu6");

var $2k6eV = parcelRequire("2k6eV");
const $c22de69bbcb043d2$export$875b296eac126ec2 = (defaultFilters = [], productId, filterType)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters } = (0, $2k6eV.useSessionUserInput)();
    const storedFilters = readFilters(productId) ? readFilters(productId)[filterType] : [];
    const defaultFiltersRef = (0, $5uXOq.useRef)(stickySearchEnabled && storedFilters && storedFilters.length > 0 ? storedFilters : defaultFilters);
    const { filters: filters, dispatch: dispatch } = (0, $5uOu6.useFilter)(defaultFiltersRef.current);
    const addFilters = (0, $5uXOq.useCallback)((newFilters)=>dispatch((0, $5uOu6.addFilters)(newFilters, (a, b)=>{
            if (a.filterSource === (0, $gMpaQ.FilterOptionSource).CURRENT_USER && b.filterSource !== (0, $gMpaQ.FilterOptionSource).CURRENT_USER) return -1;
            if (a.filterSource !== (0, $gMpaQ.FilterOptionSource).CURRENT_USER && b.filterSource === (0, $gMpaQ.FilterOptionSource).CURRENT_USER) return 1;
            return 0;
        })), [
        dispatch
    ]);
    const loadDefaultFilters = (load)=>{
        setIsLoading(true);
        load.then((result)=>setDefaultFilters(result)).finally(()=>setIsLoading(false));
    };
    const updateFilter = (0, $5uXOq.useCallback)((id, isChecked, isVisible = true)=>dispatch((0, $5uOu6.updateFilterState)(id, isChecked, isVisible)), [
        dispatch
    ]);
    const updateSingleValueFilter = (0, $5uXOq.useCallback)((id)=>{
        filters.forEach((f)=>dispatch((0, $5uOu6.updateFilterState)(f.id, f.id === id)));
    }, [
        filters,
        dispatch
    ]);
    const clearFilter = (0, $5uXOq.useCallback)(()=>{
        filters.forEach((f)=>dispatch((0, $5uOu6.updateFilterState)(f.id, false)));
    }, [
        filters,
        dispatch
    ]);
    const resetFilter = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $5uOu6.replaceAllFilters)(defaultFilters.length ? defaultFilters : defaultFiltersRef.current));
    }, [
        defaultFilters,
        dispatch
    ]);
    const setDefaultFilters = (0, $5uXOq.useCallback)((filters)=>{
        defaultFiltersRef.current = filters;
        resetFilter();
    }, [
        defaultFiltersRef,
        resetFilter
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (stickySearchEnabled) {
            const stickyFilter = readFilters(productId);
            stickyFilter[filterType] = filters;
            storeFilters(productId, stickyFilter);
        }
    }, [
        stickySearchEnabled,
        readFilters,
        storeFilters,
        productId,
        filterType,
        filters
    ]);
    return {
        availableFilters: filters,
        isLoading: isLoading && defaultFilters.length === 0,
        loadDefaultFilters: loadDefaultFilters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        updateSingleValueFilter: updateSingleValueFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch,
        setDefaultFilters: setDefaultFilters
    };
};

});



parcelRegister("3tGqW", function(module, exports) {

$parcel$export(module.exports, "CrossProductTab", () => $9719617961a07e9e$export$c4a0fd0c177c46c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $kR3QW = parcelRequire("kR3QW");

var $6m35g = parcelRequire("6m35g");

var $8Xs9r = parcelRequire("8Xs9r");
var $kv2Va = parcelRequire("kv2Va");

var $3QLe6 = parcelRequire("3QLe6");

var $28nD0 = parcelRequire("28nD0");

var $c2JME = parcelRequire("c2JME");

var $a353g = parcelRequire("a353g");

var $7VoGI = parcelRequire("7VoGI");

var $4f9Ma = parcelRequire("4f9Ma");

var $lvCts = parcelRequire("lvCts");
const $9719617961a07e9e$var$CrossProductTabWithIntl = ({ intl: intl, ...rest })=>{
    const { preQuerySupplier: preQuerySupplier, postQuerySupplier: postQuerySupplier } = (0, $kR3QW.useCrossProductQuerySupplier)();
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query)=>orgId && cloudId ? (0, $4f9Ma.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id) : '', [
        orgId,
        cloudId,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        urlGeneratorForNoResultsScreen: generateAdvancedSearchUrl,
        ResultRenderer: (0, $c2JME.ResultRenderer),
        preQueryItemSupplier: preQuerySupplier,
        postQueryItemSupplier: postQuerySupplier,
        sections: (0, $3QLe6.getSections)(intl),
        id: (0, $kR3QW.CROSS_PRODUCT_PRODUCT_ID),
        title: intl.formatMessage((0, $6m35g.messages).cross_product_tab_label),
        expandedStateInputPlaceholder: intl.formatMessage((0, $6m35g.messages).cross_product_expanded_input_placeholder),
        permissionSupplier: ()=>Promise.resolve(Object.values((0, $28nD0.CrossProductScope))),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        ...rest,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: orgId && cloudId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f9Ma.AtlassianHomeSearchLink), {
                                actionSubjectId: "AllAdvancedSearchLink",
                                orgId: orgId,
                                cloudId: cloudId
                            })
                        })
                    })
            };
        }
    });
};
const $9719617961a07e9e$export$c4a0fd0c177c46c = (0, $8RXs9.default)($9719617961a07e9e$var$CrossProductTabWithIntl);

});
parcelRegister("kR3QW", function(module, exports) {

$parcel$export(module.exports, "CROSS_PRODUCT_PRODUCT_ID", () => $15a3f16d8396dd50$export$6f9668437bcabf4e);
$parcel$export(module.exports, "useCrossProductQuerySupplier", () => $15a3f16d8396dd50$export$6ca9415334f42abe);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lvCts = parcelRequire("lvCts");

var $28nD0 = parcelRequire("28nD0");

var $6m35g = parcelRequire("6m35g");

var $cvYmc = parcelRequire("cvYmc");

var $8qbvg = parcelRequire("8qbvg");

var $6ZsPS = parcelRequire("6ZsPS");

var $44X98 = parcelRequire("44X98");

var $hkGQV = parcelRequire("hkGQV");
const $15a3f16d8396dd50$export$6f9668437bcabf4e = 'rovo-cross-product';
const $15a3f16d8396dd50$var$resultRenderer = (args)=>(0, $cvYmc.defaultResultRenderer)({
        ...args,
        isCollapsed: true
    });
const $15a3f16d8396dd50$export$6ca9415334f42abe = ()=>{
    const intl = (0, $koVbs.default)();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const [results, setResults] = (0, $5uXOq.useState)([]);
    const [isQueryResolved, setIsQueryResolved] = (0, $5uXOq.useState)(false);
    const hasFilters = (0, $44X98.useCurrentProductHasAppliedFilters)();
    const preQuerySupplier = (0, $5uXOq.useCallback)(async ()=>{
        let currentResults = results;
        if (!isQueryResolved) {
            const response = await (0, $8qbvg.fetchRecentActivities)(cloudId || '', searchSessionId || '');
            currentResults = response.filter((result)=>result !== undefined);
            setResults(currentResults);
            setIsQueryResolved(true);
        }
        return {
            size: currentResults.length,
            sections: [
                {
                    id: (0, $28nD0.CrossProductScope).RECENTS,
                    title: intl.formatMessage((0, $6m35g.messages).cross_product_recents_section_heading),
                    searchResults: currentResults,
                    resultRenderer: $15a3f16d8396dd50$var$resultRenderer
                }
            ]
        };
    }, [
        cloudId,
        intl,
        isQueryResolved,
        results,
        searchSessionId
    ]);
    const postQuerySupplier = (0, $5uXOq.useCallback)(async (args)=>{
        let currentResults = results;
        if (!isQueryResolved) {
            const response = await (0, $8qbvg.fetchRecentActivities)(cloudId || '', searchSessionId || '');
            currentResults = response.filter((result)=>result !== undefined);
            setResults(currentResults);
            setIsQueryResolved(true);
        }
        const searchResults = {
            size: currentResults.length,
            sections: [
                {
                    id: (0, $28nD0.CrossProductScope).RESULTS,
                    title: intl.formatMessage((0, $6m35g.messages).cross_product_results_section_heading),
                    searchResults: currentResults,
                    resultRenderer: $15a3f16d8396dd50$var$resultRenderer
                }
            ]
        };
        return (0, $hkGQV.filterFirstSectionItems)(searchResults, args.query, hasFilters ? 0 : 3);
    }, [
        cloudId,
        intl,
        isQueryResolved,
        results,
        searchSessionId,
        hasFilters
    ]);
    return {
        preQuerySupplier: preQuerySupplier,
        postQuerySupplier: postQuerySupplier
    };
};

});
parcelRegister("28nD0", function(module, exports) {

$parcel$export(module.exports, "CrossProductScope", () => $0d78541e1b25ef2e$export$8b40788ab131f69a);
var $0d78541e1b25ef2e$export$8b40788ab131f69a = /*#__PURE__*/ function(CrossProductScope) {
    CrossProductScope["RECENTS"] = "rovo-cross-product.recents";
    CrossProductScope["RESULTS"] = "rovo-cross-product.results";
    return CrossProductScope;
}({});

});

parcelRegister("6m35g", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0b26eee5de2b4427$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0b26eee5de2b4427$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    cross_product_tab_label: {
        id: 'product_search_dialog.cross_product.tab_label',
        defaultMessage: 'All',
        description: 'Label to display for the Cross Product search tab'
    },
    cross_product_expanded_input_placeholder: {
        id: 'product_search_dialog.cross_product.expanded.input-placeholder',
        defaultMessage: 'Search All',
        description: 'The placeholder which is visible to the user when Cross Product tab is active '
    },
    cross_product_recents_section_heading: {
        id: 'product_search_dialog.cross_product.recents.section_heading',
        defaultMessage: 'Recently viewed',
        description: 'The heading to display for the Cross Product recents section'
    },
    cross_product_results_section_heading: {
        id: 'product_search_dialog.cross_product.results.section_heading',
        defaultMessage: 'Search results',
        description: 'The heading to display for the Cross Product results section'
    },
    googleDocsLabel: {
        id: 'document-search-result.google-docs-label',
        defaultMessage: 'Docs',
        description: 'Google Docs subtype label'
    },
    googleSlidesLabel: {
        id: 'document-search-result.google-slides-label',
        defaultMessage: 'Slides',
        description: 'Google Slides subtype label'
    },
    googleSheetsLabel: {
        id: 'document-search-result.google-sheets-label',
        defaultMessage: 'Sheets',
        description: 'Google Sheets subtype label'
    },
    msWordLabel: {
        id: 'document-search-result.ms-word-label',
        defaultMessage: 'Word',
        description: 'Microsoft Word subtype label'
    },
    msPowerpointLabel: {
        id: 'document-search-result.ms-powerpoint-label',
        defaultMessage: 'PowerPoint',
        description: 'Microsoft PowerPoint subtype label'
    },
    msExcelLabel: {
        id: 'document-search-result.ms-excel-label',
        defaultMessage: 'Excel',
        description: 'Microsoft Excel subtype label'
    },
    cross_product_empty_state_body: {
        id: 'product_search_dialog.cross_product.empty.no_results_body',
        defaultMessage: '<a>Search all content across your organization</a> or try a different term.',
        description: ''
    },
    documentLabel: {
        id: 'document.label',
        defaultMessage: 'Document',
        description: 'Document subtype label'
    },
    spreadsheetLabel: {
        id: 'spreadsheet.label',
        defaultMessage: 'Spreadsheet',
        description: 'Spreadsheet subtype label'
    },
    presentationLabel: {
        id: 'presentation.label',
        defaultMessage: 'Presentation',
        description: 'Presentation subtype label'
    },
    fileLabel: {
        id: 'file.label',
        defaultMessage: 'File',
        description: 'File subtype label'
    },
    databaseLabel: {
        id: 'database.label',
        defaultMessage: 'Database',
        description: 'Database subtype label'
    },
    webPageLabel: {
        id: 'web-page.label',
        defaultMessage: 'Web Page',
        description: 'Web Page subtype label'
    },
    pageLabel: {
        id: 'page.label',
        defaultMessage: 'Page',
        description: 'Page subtype label'
    },
    blogpostLabel: {
        id: 'blogpost.label',
        defaultMessage: 'Blogpost',
        description: 'Blogpost subtype label'
    },
    dashboardLabel: {
        id: 'dashboard.label',
        defaultMessage: 'Dashboard',
        description: 'Dashboard subtype label'
    },
    invoiceLabel: {
        id: 'invoice.label',
        defaultMessage: 'Invoice',
        description: 'Invoice subtype label'
    },
    designLabel: {
        id: 'design.label',
        defaultMessage: 'Design',
        description: 'Design subtype label'
    },
    dealLabel: {
        id: 'deal.label',
        defaultMessage: 'Deal',
        description: 'Deal subtype label'
    },
    videoLabel: {
        id: 'video.label',
        defaultMessage: 'Video',
        description: 'Video subtype label'
    },
    taskLabel: {
        id: 'task.label',
        defaultMessage: 'Task',
        description: 'Task subtype label'
    },
    issueLabel: {
        id: 'issue.label',
        defaultMessage: 'Issue',
        description: 'Issue subtype label'
    },
    spaceLabel: {
        id: 'space.label',
        defaultMessage: 'Space',
        description: 'Space subtype label'
    },
    projectLabel: {
        id: 'project.label',
        defaultMessage: 'Project',
        description: 'Project subtype label'
    },
    repositoryLabel: {
        id: 'repository.label',
        defaultMessage: 'Repository',
        description: 'Repository subtype label'
    },
    customerOrgLabel: {
        id: 'customer-org.label',
        defaultMessage: 'Customer Org',
        description: 'Customer Org subtype label'
    },
    imageLabel: {
        id: 'image.label',
        defaultMessage: 'Image',
        description: 'Image subtype label'
    },
    archiveLabel: {
        id: 'archive.label',
        defaultMessage: 'Archive',
        description: 'Archive subtype label'
    },
    audioLabel: {
        id: 'audio.label',
        defaultMessage: 'Audio',
        description: 'Audio subtype label'
    },
    pdfLabel: {
        id: 'pdf.label',
        defaultMessage: 'PDF',
        description: 'PDF subtype label'
    },
    codeLabel: {
        id: 'code.label',
        defaultMessage: 'Code',
        description: 'Code subtype label'
    },
    otherLabel: {
        id: 'other.label',
        defaultMessage: 'Other',
        description: 'Other subtype label'
    }
});

});

parcelRegister("8qbvg", function(module, exports) {

$parcel$export(module.exports, "fetchRecentActivities", () => $316e0e4733900abb$export$ae65634d024c5427);

var $aCZVj = parcelRequire("aCZVj");

var $5aOMn = parcelRequire("5aOMn");

var $VSDnB = parcelRequire("VSDnB");
const $316e0e4733900abb$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $316e0e4733900abb$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $316e0e4733900abb$export$ae65634d024c5427 = async (cloudId, searchSessionId)=>{
    return await (0, $aCZVj.recentActivitiesQuery)({
        variables: {
            filteredProducts: $316e0e4733900abb$export$48de245659972a87,
            filteredObjectTypes: (0, $VSDnB.fg)('smartlinks-qf-recents') ? $316e0e4733900abb$export$742b5ce6018da1f4 : $316e0e4733900abb$export$742b5ce6018da1f4.filter((type)=>type !== 'remote-link'),
            filteredRootContainerIds: [
                `ari:cloud:platform::site/${cloudId}`,
                `ari:cloud:townsquare::site/${cloudId}`
            ],
            itemsLimit: 200
        }
    }).then((response)=>{
        const edges = response.data?.activity?.myActivity?.all?.edges || [];
        try {
            return edges.map((edge)=>(0, $5aOMn.mapRecentActivitiesToSearchResult)(edge, searchSessionId || ''));
        } catch (error) {
            return [];
        }
    }).catch((error)=>{
        throw error;
    });
};

});
parcelRegister("5aOMn", function(module, exports) {

$parcel$export(module.exports, "mapRecentActivitiesToSearchResult", () => $957ffe6362199f59$export$b4f3fd6ea4c72985);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3kLdO = parcelRequire("3kLdO");
var $29HNI = parcelRequire("29HNI");

var $kwzcy = parcelRequire("kwzcy");
var $4ZbRt = parcelRequire("4ZbRt");

var $b0tBm = parcelRequire("b0tBm");

var $jQxxC = parcelRequire("jQxxC");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $6m35g = parcelRequire("6m35g");
const $957ffe6362199f59$var$typeLabelContainer = (0, $8CUq3.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $957ffe6362199f59$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $6m35g.messages).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $6m35g.messages).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $6m35g.messages).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $6m35g.messages).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $6m35g.messages).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $6m35g.messages).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $jQxxC.Products).Sharepoint || product === (0, $jQxxC.Products).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $jQxxC.Products).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    return label;
};
const $957ffe6362199f59$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $6m35g.messages)) return (0, $6m35g.messages)[labelKey];
    else return (0, $6m35g.messages).otherLabel;
};
const $957ffe6362199f59$var$mapConfluenceActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jQxxC.ProductIcon), {
        productKey: (0, $jQxxC.Products).Confluence
    });
    const spaceName = space?.name || '';
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    if (!title || !url) return undefined;
    return {
        id: id,
        url: url,
        icon: icon,
        type: activity.object.type,
        title: title,
        meta: spaceName,
        containerId: (0, $4ZbRt.transformAriToId)(space?.id || 'UNAVAILABLE', 'space'),
        additionalMeta: timestamp ? (0, $b0tBm.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $957ffe6362199f59$var$mapJiraActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jQxxC.ProductIcon), {
        productKey: (0, $jQxxC.Products).Jira
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const meta = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $957ffe6362199f59$var$typeLabelContainer,
        children: activity.object.type
    });
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        url: webUrl,
        icon: icon,
        type: activity.object.type,
        title: title,
        meta: meta,
        containerId: '',
        additionalMeta: timestamp ? (0, $b0tBm.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $957ffe6362199f59$var$mapTownsquareActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jQxxC.ProductIcon), {
        productKey: (0, $jQxxC.Products).Atlas
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    if (!name || !url) return undefined;
    return {
        id: id,
        url: url,
        icon: icon,
        type: activity.object.type,
        title: name,
        meta: key,
        containerId: '',
        additionalMeta: timestamp ? (0, $b0tBm.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $957ffe6362199f59$var$mapGraphDocumentActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url } = activity.object.data;
    const id = activity.object.id;
    const { resourceOwner: resourceOwner } = (0, $29HNI.parseThirdPartyARI)(id);
    const resourceType = resourceOwner.split('.').at(1);
    const product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    if (!Object.values((0, $jQxxC.Products)).includes(product)) return;
    const title = displayName;
    if (!title || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jQxxC.ProductIcon), {
        productKey: product
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const subtype = type?.category?.toLowerCase();
    const label = $957ffe6362199f59$export$a47c0c6de01249fd({
        product: product,
        subtype: subtype
    });
    const typeLabel = label ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $957ffe6362199f59$var$typeLabelContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        })
    }) : subtype ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $957ffe6362199f59$var$typeLabelContainer,
        children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
    }) : null;
    return {
        id: id,
        url: url,
        icon: icon,
        type: type,
        title: title,
        meta: typeLabel,
        containerId: parent?.id || 'UNAVAILABLE',
        additionalMeta: timestamp ? (0, $b0tBm.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $957ffe6362199f59$var$mapGraphRemoteLinkActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const { displayName: displayName, category: category, url: url } = activity.object.data;
    const id = activity.object.id;
    const { resourceOwner: resourceOwner } = (0, $29HNI.parseThirdPartyARI)(id);
    const resourceType = resourceOwner.split('.').at(1);
    const product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    if (!Object.values((0, $jQxxC.Products)).includes(product)) return;
    const title = displayName;
    if (!title || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jQxxC.ProductIcon), {
        productKey: product
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const subtype = category?.toLowerCase();
    const label = $957ffe6362199f59$export$19dc2415a5fa9123({
        product: product,
        subtype: subtype
    });
    const typeLabel = label ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $957ffe6362199f59$var$typeLabelContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        })
    }) : subtype ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $957ffe6362199f59$var$typeLabelContainer,
        children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
    }) : null;
    return {
        id: id,
        url: url,
        icon: icon,
        type: category,
        title: title,
        meta: typeLabel,
        containerId: 'UNAVAILABLE',
        additionalMeta: timestamp ? (0, $b0tBm.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $957ffe6362199f59$var$mapGraphActivityToSearchResult = (activity)=>{
    if ((0, $3kLdO.isDocumentActivity)(activity.object)) return $957ffe6362199f59$var$mapGraphDocumentActivityToSearchResult(activity);
    if ((0, $3kLdO.isRemoteLinkActivity)(activity.object) && (0, $VSDnB.fg)('smartlinks-qf-recents')) return $957ffe6362199f59$var$mapGraphRemoteLinkActivityToSearchResult(activity);
    return undefined;
};
const $957ffe6362199f59$export$b4f3fd6ea4c72985 = (edge, searchSessionId)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const result = (0, $3kLdO.isGraphActivity)(activity.object) ? $957ffe6362199f59$var$mapGraphActivityToSearchResult(activity) : product === 'confluence' ? $957ffe6362199f59$var$mapConfluenceActivityToSearchResult(activity) : product === 'jira' ? $957ffe6362199f59$var$mapJiraActivityToSearchResult(activity) : product === 'townsquare' ? $957ffe6362199f59$var$mapTownsquareActivityToSearchResult(activity) : undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $kwzcy.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams
    };
};

});
parcelRegister("29HNI", function(module, exports) {

$parcel$export(module.exports, "getProductAndIDFromARI", () => $f42ce0a236988769$export$d8a746fe35b1c95d);
$parcel$export(module.exports, "parseThirdPartyARI", () => $f42ce0a236988769$export$2f432ca99e30467e);

var $jbrzS = parcelRequire("jbrzS");
const $f42ce0a236988769$export$d8a746fe35b1c95d = (ari)=>{
    const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $f42ce0a236988769$export$fccbae65febb6fd4(ari) ? $f42ce0a236988769$export$2f432ca99e30467e(ari) : (0, $jbrzS.parse)(ari);
    return [
        resourceOwner,
        cloudId,
        resourceType,
        resourceId
    ];
};
const $f42ce0a236988769$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $f42ce0a236988769$export$2f432ca99e30467e = (ari)=>{
    const result = $f42ce0a236988769$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$f42ce0a236988769$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner, resourceType, resourceId] = result;
    return {
        resourceId: resourceId,
        resourceOwner: resourceOwner,
        resourceType: resourceType,
        cloudId: resourceId
    };
};
const $f42ce0a236988769$export$fccbae65febb6fd4 = (ari)=>$f42ce0a236988769$var$thirdPartyRegex.test(ari);

});
parcelRegister("jbrzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $aRXoY = parcelRequire("aRXoY");

$3VFsf.__exportStar((parcelRequire("8T6Ee")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $df746fbe0ba5443e$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $df746fbe0ba5443e$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $df746fbe0ba5443e$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $df746fbe0ba5443e$var$InvalidAriError;
function $df746fbe0ba5443e$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $df746fbe0ba5443e$var$basicCharConstraint = $aRXoY.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $df746fbe0ba5443e$var$resourceTypeCharConstraints = $aRXoY.pattern(/^[a-z][a-z.-]*$/i);
const $df746fbe0ba5443e$var$resourceOwnerConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$basicCharConstraint
];
const $df746fbe0ba5443e$var$resourceTypeConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$resourceTypeCharConstraints
];
const $df746fbe0ba5443e$var$cloudIdConstraints = [
    $aRXoY.lengthBetween(3, 255)
];
const $df746fbe0ba5443e$var$siteResourceType = 'site';
const $df746fbe0ba5443e$var$resourceIdChars = /[\w-._~:@#]/.source;
const $df746fbe0ba5443e$var$resourceIdConstraints = [
    $aRXoY.pattern(new RegExp(`^${$df746fbe0ba5443e$var$resourceIdChars}+(/${$df746fbe0ba5443e$var$resourceIdChars}*)*(;v=${$df746fbe0ba5443e$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $df746fbe0ba5443e$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $df746fbe0ba5443e$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $df746fbe0ba5443e$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $df746fbe0ba5443e$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $df746fbe0ba5443e$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        return new $df746fbe0ba5443e$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $df746fbe0ba5443e$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $df746fbe0ba5443e$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $df746fbe0ba5443e$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $df746fbe0ba5443e$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $df746fbe0ba5443e$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $df746fbe0ba5443e$var$siteResourceType && !cloudId) return new $aRXoY.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'resourceOwner', $df746fbe0ba5443e$var$resourceOwnerConstraints),
            $aRXoY.validateField(this, 'resourceType', $df746fbe0ba5443e$var$resourceTypeConstraints),
            $aRXoY.validateField(this, 'resourceId', $df746fbe0ba5443e$var$resourceIdConstraints),
            $aRXoY.validateField(this, 'cloudId', $df746fbe0ba5443e$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $df746fbe0ba5443e$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $df746fbe0ba5443e$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $df746fbe0ba5443e$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parse(ariString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $df746fbe0ba5443e$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parseEncoded(encodedAriString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $df746fbe0ba5443e$var$parseEncoded;

});
parcelRegister("aRXoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aB0SS = parcelRequire("aB0SS");
class $7e9cee950eba220a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $7e9cee950eba220a$var$LengthConstraint;
class $7e9cee950eba220a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $7e9cee950eba220a$var$RegexConstraint;
class $7e9cee950eba220a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $7e9cee950eba220a$var$GeneralValidationError;
class $7e9cee950eba220a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $7e9cee950eba220a$var$ConstraintViolation;
function $7e9cee950eba220a$var$lengthBetween(min, max) {
    return new $7e9cee950eba220a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $7e9cee950eba220a$var$lengthBetween;
function $7e9cee950eba220a$var$pattern(regex) {
    return new $7e9cee950eba220a$var$RegexConstraint(regex);
}
module.exports.pattern = $7e9cee950eba220a$var$pattern;
function $7e9cee950eba220a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($aB0SS.isDefined);
    return violatedConstraints.length > 0 ? new $7e9cee950eba220a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $7e9cee950eba220a$var$validateField;

});
parcelRegister("aB0SS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $7b6e0ba147b061df$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $7b6e0ba147b061df$var$isPresent;
function $7b6e0ba147b061df$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $7b6e0ba147b061df$var$isDefined;
function $7b6e0ba147b061df$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $7b6e0ba147b061df$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $7b6e0ba147b061df$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $7b6e0ba147b061df$var$hasValueAtKey;

});


parcelRegister("8T6Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kQInL = parcelRequire("kQInL");
var $67889de6c03493da$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($67889de6c03493da$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $67889de6c03493da$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $67889de6c03493da$var$AppFamilyAriError;
class $67889de6c03493da$var$NotAppFamilyAriError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $67889de6c03493da$var$NotAppFamilyAriError;
class $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $67889de6c03493da$var$parseAppAri(ari) {
    return $kQInL.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $67889de6c03493da$var$parseAppAri;
function $67889de6c03493da$var$createAppAri(json) {
    return new $kQInL.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $67889de6c03493da$var$createAppAri;

});
parcelRegister("kQInL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8T6Ee = parcelRequire("8T6Ee");

var $jbrzS = parcelRequire("jbrzS");

var $aRXoY = parcelRequire("aRXoY");
const $f2db175f2d527230$var$versionPrefix = ';v=';
const $f2db175f2d527230$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $f2db175f2d527230$var$uuidConstraints = [
    $aRXoY.pattern(new RegExp(`^${$f2db175f2d527230$var$uuidRegExpString}$`, 'i'))
];
const $f2db175f2d527230$var$extensionGroupIdConstraints = [
    $aRXoY.pattern(new RegExp(`^(${$f2db175f2d527230$var$uuidRegExpString}|static)$`, 'i'))
];
class $f2db175f2d527230$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $8T6Ee.AppFamilyAri.resourceOwner) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$8T6Ee.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $8T6Ee.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceType must be one of ${$8T6Ee.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($f2db175f2d527230$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($f2db175f2d527230$var$versionPrefix) > versionIndex) throw new $8T6Ee.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($f2db175f2d527230$var$versionPrefix);
        const segments = mainResourceId.split('/').map($f2db175f2d527230$var$stripToUndefined);
        if (segments.length > 4) throw new $8T6Ee.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType || resourceType === $8T6Ee.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $8T6Ee.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        return new $f2db175f2d527230$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $8T6Ee.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'environmentId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'appId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'extensionGroupId', $f2db175f2d527230$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $jbrzS.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $8T6Ee.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$f2db175f2d527230$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $f2db175f2d527230$var$AppFamilyAriImpl;
function $f2db175f2d527230$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("kwzcy", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUrlWithAnalyticsQueryParams", () => $ec29360b989a163a$export$ce6d1d009c92f1be);
$parcel$export(module.exports, "getJiraUrlWithAnalyticsQueryParams", () => $ec29360b989a163a$export$b780bd7096d811c5);
$parcel$export(module.exports, "getGenericUrlWithAnalyticsQueryParams", () => $ec29360b989a163a$export$a5abc05a86b8de68);

var $5B8KC = parcelRequire("5B8KC");
const $ec29360b989a163a$var$CONFLUENCE_VALUE_SEPARATOR = '---';
const $ec29360b989a163a$var$CONFLUENCE_ATTRIBUTE_SEPARATOR = '___';
const $ec29360b989a163a$export$ce6d1d009c92f1be = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${$ec29360b989a163a$var$CONFLUENCE_VALUE_SEPARATOR}${(0, $5B8KC.hashData)(query)}`);
    if (additionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${$ec29360b989a163a$var$CONFLUENCE_VALUE_SEPARATOR}${value}`);
    });
    if (events.length === 0) return urlObject.toString();
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join($ec29360b989a163a$var$CONFLUENCE_ATTRIBUTE_SEPARATOR));
    urlObject.searchParams.set('additional_analytics', analyticsFormattedForUrlParsing);
    return urlObject.toString();
};
const $ec29360b989a163a$export$2e67c54459604a9 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split($ec29360b989a163a$var$CONFLUENCE_ATTRIBUTE_SEPARATOR);
    events.forEach((event)=>{
        const formattedEvent = event?.split($ec29360b989a163a$var$CONFLUENCE_VALUE_SEPARATOR);
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
const $ec29360b989a163a$export$b780bd7096d811c5 = ({ url: url, searchSessionId: searchSessionId, resultId: resultId, projectId: projectId })=>{
    const jiraResultARIPattern = /^ari:cloud:jira:[a-z0-9-]+:[a-z]+\/[0-9]+$/;
    if (!resultId.match(jiraResultARIPattern)) return url;
    const jiraProjectARIPattern = /^ari:cloud:jira:[a-z0-9-]+:project\/[0-9]+$/;
    if (projectId && !projectId.match(jiraProjectARIPattern)) return url;
    const urlObject = new URL(url);
    urlObject.searchParams.set('searchSessionId', searchSessionId);
    const searchObjectId = resultId.split('/').pop();
    searchObjectId && urlObject.searchParams.set('searchObjectId', searchObjectId);
    const searchContentType = resultId.split('/')[0].split(':').pop();
    searchContentType && urlObject.searchParams.set('searchContentType', searchContentType);
    const searchContainerId = projectId?.split('/').pop();
    searchContainerId && urlObject.searchParams.set('searchContainerId', searchContainerId);
    return urlObject.toString();
};
const $ec29360b989a163a$export$a5abc05a86b8de68 = ({ url: url, searchSessionId: searchSessionId })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    return urlObject.toString();
};

});

parcelRegister("b0tBm", function(module, exports) {

$parcel$export(module.exports, "dateFormatter", () => $c92e528d6b4598c6$export$406508d2ca449bd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $2tElP = parcelRequire("2tElP");

var $k4hbD = parcelRequire("k4hbD");
const $c92e528d6b4598c6$var$SECONDS_IN_MIN = 60;
const $c92e528d6b4598c6$var$SECONDS_IN_HR = $c92e528d6b4598c6$var$SECONDS_IN_MIN * 60;
const $c92e528d6b4598c6$var$SECONDS_IN_DAY = $c92e528d6b4598c6$var$SECONDS_IN_HR * 24;
const $c92e528d6b4598c6$export$be5e766167e613a9 = {
    commented: (0, $k4hbD.commentedEventTypeMessages),
    created: (0, $k4hbD.createdEventTypeMessages),
    edited: (0, $k4hbD.editedEventTypeMessages),
    published: (0, $k4hbD.publishedEventTypeMessages),
    updated: (0, $k4hbD.updatedEventTypeMessages),
    viewed: (0, $k4hbD.viewedEventTypeMessages)
};
const $c92e528d6b4598c6$var$WithUpdatedLabel = (formattedDate)=>{
    const i18nMessage = (0, $k4hbD.messages).common_updated_date_formatter;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...i18nMessage,
        values: {
            date: formattedDate
        }
    });
};
const $c92e528d6b4598c6$var$recentEventLabel = (eventType)=>{
    const i18nMessage = eventType ? $c92e528d6b4598c6$export$be5e766167e613a9[eventType] || (0, $k4hbD.defaultEventTypeMessages) : (0, $k4hbD.defaultEventTypeMessages);
    return (formattedDate)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...i18nMessage.relative,
            values: {
                date: formattedDate
            }
        });
};
const $c92e528d6b4598c6$var$absoluteRecentEventLabel = (eventType)=>{
    const i18nMessage = eventType ? $c92e528d6b4598c6$export$be5e766167e613a9[eventType] || (0, $k4hbD.defaultEventTypeMessages) : (0, $k4hbD.defaultEventTypeMessages);
    return (formattedDate)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...i18nMessage.absolute,
            values: {
                date: formattedDate
            }
        });
};
function $c92e528d6b4598c6$export$406508d2ca449bd(lastModified, isRecentActivity, eventType) {
    const secondsSinceUpdate = Math.floor((Date.now() - new Date(lastModified).getTime()) / 1000);
    const totalDays = Math.floor(secondsSinceUpdate / $c92e528d6b4598c6$var$SECONDS_IN_DAY);
    const totalHours = Math.floor(secondsSinceUpdate / $c92e528d6b4598c6$var$SECONDS_IN_HR);
    const totalMinutes = Math.floor(secondsSinceUpdate / $c92e528d6b4598c6$var$SECONDS_IN_MIN);
    if (secondsSinceUpdate > 1 && secondsSinceUpdate < 60) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tElP.default), {
        value: -secondsSinceUpdate,
        style: "narrow",
        unit: "second",
        children: isRecentActivity ? $c92e528d6b4598c6$var$recentEventLabel(eventType) : $c92e528d6b4598c6$var$WithUpdatedLabel
    });
    if (totalMinutes >= 1 && totalMinutes < 60) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tElP.default), {
        value: -totalMinutes,
        style: "narrow",
        unit: "minute",
        children: isRecentActivity ? $c92e528d6b4598c6$var$recentEventLabel(eventType) : $c92e528d6b4598c6$var$WithUpdatedLabel
    });
    if (totalHours >= 1 && totalHours < 24) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tElP.default), {
        value: -totalHours,
        style: "narrow",
        unit: "hour",
        children: isRecentActivity ? $c92e528d6b4598c6$var$recentEventLabel(eventType) : $c92e528d6b4598c6$var$WithUpdatedLabel
    });
    if (totalDays >= 1 && totalDays < 8) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tElP.default), {
        value: -totalDays,
        style: "narrow",
        unit: "day",
        children: isRecentActivity ? $c92e528d6b4598c6$var$recentEventLabel(eventType) : $c92e528d6b4598c6$var$WithUpdatedLabel
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
        year: "numeric",
        month: "short",
        day: "2-digit",
        value: lastModified,
        children: isRecentActivity ? $c92e528d6b4598c6$var$absoluteRecentEventLabel(eventType) : $c92e528d6b4598c6$var$WithUpdatedLabel
    });
}

});

parcelRegister("jQxxC", function(module, exports) {

$parcel$export(module.exports, "Products", () => $e9846983234897e3$export$92e44ea1079b9ec6);
$parcel$export(module.exports, "ProductIcon", () => $e9846983234897e3$export$1a199e029d5e93d6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2pMF0 = parcelRequire("2pMF0");
var $iMzG0 = parcelRequire("iMzG0");
var $dIHEn = parcelRequire("dIHEn");
var $7anl7 = parcelRequire("7anl7");
var $4o4xT = parcelRequire("4o4xT");
var $29YN9 = parcelRequire("29YN9");
var $34gGM = parcelRequire("34gGM");
var $epnSS = parcelRequire("epnSS");
var $h5j0J = parcelRequire("h5j0J");

var $lAZCM = parcelRequire("lAZCM");

var $5nbLn = parcelRequire("5nbLn");

var $1U4EY = parcelRequire("1U4EY");

var $fC06l = parcelRequire("fC06l");

var $kaR8K = parcelRequire("kaR8K");

var $gTrd0 = parcelRequire("gTrd0");

var $goJA6 = parcelRequire("goJA6");

var $5d7aC = parcelRequire("5d7aC");

var $9x5pH = parcelRequire("9x5pH");

var $8hUYi = parcelRequire("8hUYi");

var $7g5Lp = parcelRequire("7g5Lp");

var $ewszM = parcelRequire("ewszM");

var $kANz3 = parcelRequire("kANz3");

var $d7VwU = parcelRequire("d7VwU");

var $hSByb = parcelRequire("hSByb");

var $9oHmx = parcelRequire("9oHmx");

var $jZsZZ = parcelRequire("jZsZZ");

var $iPetR = parcelRequire("iPetR");

var $aE2ug = parcelRequire("aE2ug");

var $aEezf = parcelRequire("aEezf");

var $049D0 = parcelRequire("049D0");

var $1twqS = parcelRequire("1twqS");

var $6kGiZ = parcelRequire("6kGiZ");

var $gXv8Q = parcelRequire("gXv8Q");

var $AiWrx = parcelRequire("AiWrx");

var $4B1q6 = parcelRequire("4B1q6");

var $hflpd = parcelRequire("hflpd");

var $7IBsh = parcelRequire("7IBsh");

var $a1mh2 = parcelRequire("a1mh2");

var $8gEJD = parcelRequire("8gEJD");

var $aDJD2 = parcelRequire("aDJD2");

var $5c1Lk = parcelRequire("5c1Lk");

var $j6OsA = parcelRequire("j6OsA");

var $eoM0O = parcelRequire("eoM0O");

var $4I6wX = parcelRequire("4I6wX");

var $38KKz = parcelRequire("38KKz");

var $3jKSn = parcelRequire("3jKSn");

var $4JSYN = parcelRequire("4JSYN");

var $85FG3 = parcelRequire("85FG3");

var $8aqSD = parcelRequire("8aqSD");

var $4KJOP = parcelRequire("4KJOP");

var $fcIyF = parcelRequire("fcIyF");

var $1GMny = parcelRequire("1GMny");

var $ehNOw = parcelRequire("ehNOw");

var $dTazm = parcelRequire("dTazm");

var $haSA5 = parcelRequire("haSA5");

var $bradz = parcelRequire("bradz");

var $2MYL5 = parcelRequire("2MYL5");

var $gpecJ = parcelRequire("gpecJ");

var $40pJL = parcelRequire("40pJL");

var $0DeLg = parcelRequire("0DeLg");

var $9b2Uq = parcelRequire("9b2Uq");

var $aUMOt = parcelRequire("aUMOt");

var $1im96 = parcelRequire("1im96");

var $gixZp = parcelRequire("gixZp");

var $kFf5O = parcelRequire("kFf5O");
const $e9846983234897e3$var$ProductKeys3P = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3'
};
const $e9846983234897e3$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury'
};
const $e9846983234897e3$var$products1PIcons = {
    [$e9846983234897e3$var$ProductKeys1P.Confluence]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $1U4EY.ConfluenceIcon), (0, $7anl7.ConfluenceIcon)), 'Confluence'),
    [$e9846983234897e3$var$ProductKeys1P.Atlas]: (0, $kFf5O.RovoLogoFromLogo)((0, $2pMF0.AtlassianIcon), 'Home'),
    [$e9846983234897e3$var$ProductKeys1P.Jira]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $kaR8K.JiraIcon), (0, $29YN9.JiraIcon)), 'Jira'),
    [$e9846983234897e3$var$ProductKeys1P.JiraProductDiscovery]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $gTrd0.JiraProductDiscoveryIcon), (0, $34gGM.JiraProductDiscoveryIcon)), 'Jira Product Discovery'),
    [$e9846983234897e3$var$ProductKeys1P.JiraServiceManagement]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $goJA6.JiraServiceManagementIcon), (0, $epnSS.JiraServiceManagementIcon)), 'Jira Service Management'),
    [$e9846983234897e3$var$ProductKeys1P.Bitbucket]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $lAZCM.BitbucketIcon), (0, $iMzG0.BitbucketIcon)), 'Bitbucket'),
    [$e9846983234897e3$var$ProductKeys1P.Trello]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $5d7aC.TrelloIcon), (0, $h5j0J.TrelloIcon)), 'Trello'),
    [$e9846983234897e3$var$ProductKeys1P.Compass]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $5nbLn.CompassIcon), (0, $dIHEn.CompassIcon)), 'Compass'),
    [$e9846983234897e3$var$ProductKeys1P.Focus]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $fC06l.FocusIcon), (0, $4o4xT.FocusIcon)), 'Focus')
};
const $e9846983234897e3$var$products3PIcons = {
    [$e9846983234897e3$var$ProductKeys3P.AdobeXD]: (0, $kFf5O.get3PLogo)((0, $8hUYi.default), 'Adobe XD'),
    [$e9846983234897e3$var$ProductKeys3P.AdobeSign]: (0, $kFf5O.get3PLogo)((0, $7g5Lp.default), 'Adobe Sign'),
    [$e9846983234897e3$var$ProductKeys3P.Aha]: (0, $kFf5O.get3PLogo)((0, $ewszM.default), 'Aha'),
    [$e9846983234897e3$var$ProductKeys3P.Airtable]: (0, $kFf5O.get3PLogo)((0, $kANz3.default), 'Airtable'),
    [$e9846983234897e3$var$ProductKeys3P.Amplitude]: (0, $kFf5O.get3PLogo)((0, $d7VwU.default), 'Amplitude'),
    [$e9846983234897e3$var$ProductKeys3P.Asana]: (0, $kFf5O.get3PLogo)((0, $hSByb.default), 'Asana'),
    [$e9846983234897e3$var$ProductKeys3P.AzureDevops]: (0, $kFf5O.get3PLogo)((0, $9oHmx.default), 'Azure Devops'),
    [$e9846983234897e3$var$ProductKeys3P.Box]: (0, $kFf5O.get3PLogo)((0, $jZsZZ.default), 'Box'),
    [$e9846983234897e3$var$ProductKeys3P.Canva]: (0, $kFf5O.get3PLogo)((0, $iPetR.default), 'Canva'),
    [$e9846983234897e3$var$ProductKeys3P.Docusign]: (0, $kFf5O.get3PLogo)((0, $aE2ug.default), 'Docusign'),
    [$e9846983234897e3$var$ProductKeys3P.Dovetail]: (0, $kFf5O.get3PLogo)((0, $aEezf.default), 'Dovetail'),
    [$e9846983234897e3$var$ProductKeys3P.Dropbox]: (0, $kFf5O.get3PLogo)((0, $049D0.default), 'Dropbox'),
    [$e9846983234897e3$var$ProductKeys3P.Figma]: (0, $kFf5O.get3PLogo)((0, $1twqS.default), 'Figma'),
    [$e9846983234897e3$var$ProductKeys3P.Freshservice]: (0, $kFf5O.get3PLogo)((0, $6kGiZ.default), 'Freshservice'),
    [$e9846983234897e3$var$ProductKeys3P.Gmail]: (0, $kFf5O.get3PLogo)((0, $gXv8Q.default), 'Gmail'),
    [$e9846983234897e3$var$ProductKeys3P.Github]: (0, $kFf5O.get3PLogo)((0, $AiWrx.default), 'Github'),
    [$e9846983234897e3$var$ProductKeys3P.Gitlab]: (0, $kFf5O.get3PLogo)((0, $4B1q6.default), 'Gitlab'),
    [$e9846983234897e3$var$ProductKeys3P.GoogleCalendar]: (0, $kFf5O.get3PLogo)((0, $hflpd.default), 'Google Calendar'),
    [$e9846983234897e3$var$ProductKeys3P.Hubspot]: (0, $kFf5O.get3PLogo)((0, $7IBsh.default), 'Hubspot'),
    [$e9846983234897e3$var$ProductKeys3P.Lucid]: (0, $kFf5O.get3PLogo)((0, $a1mh2.default), 'Lucid'),
    [$e9846983234897e3$var$ProductKeys3P.Loom]: (0, $kFf5O.get3PLogo)((0, $8gEJD.default), 'Loom'),
    [$e9846983234897e3$var$ProductKeys3P.Miro]: (0, $kFf5O.get3PLogo)((0, $aDJD2.default), 'Miro'),
    [$e9846983234897e3$var$ProductKeys3P.Monday]: (0, $kFf5O.get3PLogo)((0, $5c1Lk.default), 'Monday'),
    [$e9846983234897e3$var$ProductKeys3P.Mural]: (0, $kFf5O.get3PLogo)((0, $j6OsA.default), 'Mural'),
    [$e9846983234897e3$var$ProductKeys3P.Notion]: (0, $kFf5O.get3PLogo)((0, $eoM0O.default), 'Notion'),
    [$e9846983234897e3$var$ProductKeys3P.OutlookCalendar]: (0, $kFf5O.get3PLogo)((0, $4I6wX.default), 'Outlook Calendar'),
    [$e9846983234897e3$var$ProductKeys3P.OutlookMail]: (0, $kFf5O.get3PLogo)((0, $38KKz.default), 'Outlook Mail'),
    [$e9846983234897e3$var$ProductKeys3P.Pipedrive]: (0, $kFf5O.get3PLogo)((0, $3jKSn.default), 'Pipedrive'),
    [$e9846983234897e3$var$ProductKeys3P.Salesforce]: (0, $kFf5O.get3PLogo)((0, $4JSYN.default), 'Salesforce'),
    [$e9846983234897e3$var$ProductKeys3P.Sentry]: (0, $kFf5O.get3PLogo)((0, $85FG3.default), 'Sentry'),
    [$e9846983234897e3$var$ProductKeys3P.Sharepoint]: (0, $kFf5O.get3PLogo)((0, $8aqSD.default), 'Sharepoint'),
    [$e9846983234897e3$var$ProductKeys3P.Slack]: (0, $kFf5O.get3PLogo)((0, $4KJOP.default), 'Slack'),
    [$e9846983234897e3$var$ProductKeys3P.Smartsheet]: (0, $kFf5O.get3PLogo)((0, $fcIyF.default), 'Smartsheet'),
    [$e9846983234897e3$var$ProductKeys3P.Stripe]: (0, $kFf5O.get3PLogo)((0, $1GMny.default), 'Stripe'),
    [$e9846983234897e3$var$ProductKeys3P.Teams]: (0, $kFf5O.get3PLogo)((0, $ehNOw.default), 'Teams'),
    [$e9846983234897e3$var$ProductKeys3P.Todoist]: (0, $kFf5O.get3PLogo)((0, $dTazm.default), 'Todoist'),
    [$e9846983234897e3$var$ProductKeys3P.Webex]: (0, $kFf5O.get3PLogo)((0, $haSA5.default), 'Webex'),
    [$e9846983234897e3$var$ProductKeys3P.Zeplin]: (0, $kFf5O.get3PLogo)((0, $bradz.default), 'Zeplin'),
    [$e9846983234897e3$var$ProductKeys3P.Zendesk]: (0, $kFf5O.get3PLogo)((0, $2MYL5.default), 'Zendesk'),
    [$e9846983234897e3$var$ProductKeys3P.Gitbook]: (0, $kFf5O.get3PLogo)((0, $gpecJ.default), 'Gitbook'),
    [$e9846983234897e3$var$ProductKeys3P.AtlassianWebCrawler]: (0, $kFf5O.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($9x5pH))), 'Atlassian Web Crawler'),
    [$e9846983234897e3$var$ProductKeys3P.ConfluenceDC]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $1U4EY.ConfluenceIcon), (0, $7anl7.ConfluenceIcon)), 'Confluence'),
    [$e9846983234897e3$var$ProductKeys3P.JiraDC]: (0, $kFf5O.RovoLogoFromLogo)((0, $kFf5O.getLogoVersion)((0, $kaR8K.JiraIcon), (0, $29YN9.JiraIcon)), 'Jira'),
    [$e9846983234897e3$var$ProductKeys3P.LaunchDarkly]: (0, $kFf5O.get3PLogo)((0, $40pJL.default), 'LaunchDarkly'),
    [$e9846983234897e3$var$ProductKeys3P.PagerDuty]: (0, $kFf5O.get3PLogo)((0, $0DeLg.default), 'PagerDuty'),
    [$e9846983234897e3$var$ProductKeys3P.PowerBI]: (0, $kFf5O.get3PLogo)((0, $9b2Uq.default), 'PowerBI'),
    [$e9846983234897e3$var$ProductKeys3P.ServiceNow]: (0, $kFf5O.get3PLogo)((0, $aUMOt.default), 'ServiceNow'),
    [$e9846983234897e3$var$ProductKeys3P.AWSS3]: (0, $kFf5O.get3PLogo)((0, $1im96.default), 'AWSS3'),
    [$e9846983234897e3$var$ProductKeys3P.GoogleDrive]: (0, $kFf5O.get3PLogo)((0, $gixZp.default), 'GoogleDrive')
};
const $e9846983234897e3$var$productIcons = {
    ...$e9846983234897e3$var$products1PIcons,
    ...$e9846983234897e3$var$products3PIcons
};
const $e9846983234897e3$export$92e44ea1079b9ec6 = {
    ...$e9846983234897e3$var$ProductKeys1P,
    ...$e9846983234897e3$var$ProductKeys3P
};
const $e9846983234897e3$export$1a199e029d5e93d6 = ({ productKey: productKey })=>{
    const Icon = $e9846983234897e3$var$productIcons[productKey];
    return Icon ? /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        label: productKey
    }) : null;
};

});
parcelRegister("iMzG0", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $0af9b15279bc8ff1$export$5fc1066e677788d4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $0af9b15279bc8ff1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $0af9b15279bc8ff1$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $0af9b15279bc8ff1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dIHEn", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", () => $85c2cd6f52fb90ed$export$f7857fe64d7161d9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $85c2cd6f52fb90ed$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $85c2cd6f52fb90ed$export$f7857fe64d7161d9 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $85c2cd6f52fb90ed$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4o4xT", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", () => $c39ee6056d0f0f6c$export$1e02e7298035a77c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $c39ee6056d0f0f6c$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>
		</svg>
		`;
};
const $c39ee6056d0f0f6c$export$1e02e7298035a77c = ({ appearance: appearance, label: label = 'Focus', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $c39ee6056d0f0f6c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("h5j0J", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", () => $9094d680a5304b47$export$4384da9b8b140bf4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $9094d680a5304b47$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>
    </svg>`;
};
const $9094d680a5304b47$export$4384da9b8b140bf4 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $9094d680a5304b47$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lAZCM", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $1433366fe21bdea1$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::749e70fd922e9461f6a5423730c61b8d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1433366fe21bdea1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $1433366fe21bdea1$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
function $1433366fe21bdea1$export$5fc1066e677788d4({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $1433366fe21bdea1$var$svg,
        customThemeSvg: $1433366fe21bdea1$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Bitbucket',
        testId: testId
    });
}

});

parcelRegister("5nbLn", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", () => $e82fb65f5281281d$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::47230916c8ace4e66464ab0a154a2cc3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e82fb65f5281281d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
function $e82fb65f5281281d$export$f7857fe64d7161d9({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $e82fb65f5281281d$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Compass',
        testId: testId
    });
}

});

parcelRegister("fC06l", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", () => $c0bc43fc9853e2d5$export$1e02e7298035a77c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afceb3214285cf3d88bc319aaba91325>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $c0bc43fc9853e2d5$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#fb9700" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
function $c0bc43fc9853e2d5$export$1e02e7298035a77c({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $c0bc43fc9853e2d5$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Focus',
        testId: testId
    });
}

});

parcelRegister("5d7aC", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", () => $0cc15d0ef866b8cf$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce5b9fbd7811d07687572e8e6bbfb3e8>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0cc15d0ef866b8cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $0cc15d0ef866b8cf$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
function $0cc15d0ef866b8cf$export$4384da9b8b140bf4({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $0cc15d0ef866b8cf$var$svg,
        customThemeSvg: $0cc15d0ef866b8cf$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Trello',
        testId: testId
    });
}

});

parcelRegister("8hUYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $af98a0e346090ece$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $af98a0e346090ece$var$AdobeXDIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-635.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.5802 7.40457L9.75898 12.1789L12.7683 17.2427C12.7871 17.2812 12.7965 17.3198 12.7871 17.3584C12.7777 17.397 12.7401 17.368 12.6836 17.3777H10.5301C10.3796 17.3777 10.2762 17.368 10.2104 17.2716C10.0129 16.8665 9.806 16.471 9.60851 16.0659C9.41103 15.6705 9.19473 15.2654 8.96903 14.8507C8.74334 14.4359 8.51764 14.0212 8.29194 13.5968H8.27313C8.07565 14.0115 7.85935 14.4263 7.64306 14.841C7.42677 15.2558 7.21047 15.6705 7.00359 16.0756C6.78729 16.4807 6.571 16.8954 6.3547 17.2909C6.31709 17.3873 6.24186 17.397 6.13841 17.397H4.06952C4.0319 17.397 4.00369 17.4163 4.00369 17.368C3.99429 17.3295 4.00369 17.2909 4.0225 17.262L6.94716 12.3429L4.09773 7.39492C4.06952 7.35634 4.06011 7.31776 4.07892 7.29847C4.09773 7.26953 4.13535 7.25989 4.17296 7.25989H6.30768C6.3547 7.25989 6.40173 7.26953 6.43934 7.27918C6.47696 7.29847 6.50517 7.3274 6.53338 7.36598C6.71206 7.78073 6.91895 8.19547 7.13524 8.61021C7.36094 9.02496 7.57723 9.43006 7.81233 9.83515C8.03803 10.2403 8.24492 10.6453 8.44241 11.0601H8.46122C8.6587 10.6357 8.86559 10.221 9.07248 9.81586C9.27937 9.41077 9.49566 9.00567 9.71196 8.60057C9.92825 8.19547 10.1351 7.78073 10.342 7.38528C10.3514 7.34669 10.3702 7.30811 10.3985 7.28882C10.4361 7.26953 10.4737 7.25989 10.5207 7.26953H12.505C12.552 7.25989 12.599 7.28882 12.6084 7.33705C12.6178 7.34669 12.599 7.38528 12.5802 7.40457Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M16.9248 17.5803C16.2289 17.5899 15.533 17.4453 14.9029 17.1463C14.3105 16.8666 13.8215 16.4036 13.4829 15.8345C13.135 15.2462 12.9657 14.5131 12.9657 13.6354C12.9563 12.9217 13.135 12.2176 13.4829 11.6003C13.8403 10.9733 14.3575 10.4525 14.9782 10.1053C15.6364 9.72911 16.4264 9.54585 17.3574 9.54585C17.4044 9.54585 17.4702 9.54585 17.5549 9.5555C17.711 9.5733 17.8464 9.43978 17.8464 9.28259V6.52691C17.8464 6.45939 17.8746 6.42081 17.9404 6.42081H19.791C19.8299 6.42081 19.873 6.41051 19.9052 6.43245C19.9189 6.44186 19.9299 6.45544 19.937 6.4702C19.9425 6.48177 19.9435 6.50762 19.9435 6.50762C19.9435 6.50762 19.9435 6.50762 19.9435 6.50762V15.6898C19.9435 15.8635 19.9529 16.0564 19.9623 16.2686C19.9811 16.4711 19.9905 16.664 19.9999 16.828C19.9999 16.8955 19.9717 16.9534 19.9059 16.9823C19.4169 17.1945 18.8996 17.3488 18.373 17.4453C17.8934 17.5321 17.4138 17.5803 16.9248 17.5803ZM17.5438 15.7015C17.7293 15.7077 17.8464 15.5265 17.8464 15.3409V11.666C17.8464 11.5147 17.7428 11.3763 17.5925 11.3591C17.489 11.3495 17.3856 11.3399 17.2821 11.3399C16.9154 11.3399 16.5486 11.417 16.2195 11.5906C15.8998 11.7546 15.627 11.9957 15.4201 12.3044C15.2133 12.613 15.1098 13.0278 15.1098 13.5293C15.1004 13.8669 15.1568 14.2045 15.2697 14.5228C15.3637 14.7832 15.5048 15.0147 15.6929 15.2076C15.8715 15.3812 16.0878 15.5162 16.3323 15.5934C16.5862 15.6802 16.8496 15.7188 17.1129 15.7188C17.2409 15.7188 17.3612 15.7108 17.4737 15.7022C17.4964 15.7004 17.521 15.7007 17.5438 15.7015Z",
                fill: "#FF61F6"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.90598 4H17.5043C19.1111 4 20.4103 5.29915 20.4103 6.90598V17.094C20.4103 18.7009 19.1111 20 17.5043 20H6.90598C5.29915 20 4 18.7009 4 17.094V6.90598C4 5.29915 5.29915 4 6.90598 4Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.629 8.2051L10.5777 11.5897L12.7658 15.1795C12.7794 15.2068 12.7863 15.2342 12.7794 15.2615C12.7726 15.2889 12.7453 15.2684 12.7042 15.2752H11.1384C11.029 15.2752 10.9538 15.2684 10.9059 15.2C10.7624 14.9128 10.6119 14.6325 10.4683 14.3453C10.3247 14.0649 10.1675 13.7778 10.0034 13.4837C9.83928 13.1897 9.67518 12.8957 9.51107 12.5948H9.4974C9.35381 12.8889 9.19654 13.1829 9.03928 13.4769C8.88201 13.7709 8.72475 14.0649 8.57432 14.3521C8.41706 14.6393 8.25979 14.9333 8.10253 15.2136C8.07518 15.282 8.02047 15.2889 7.94526 15.2889H6.44099C6.41364 15.2889 6.39312 15.3025 6.39312 15.2684C6.38629 15.241 6.39312 15.2136 6.4068 15.1931L8.5333 11.706L6.4615 8.19827C6.44099 8.17092 6.43415 8.14356 6.44783 8.12989C6.4615 8.10938 6.48885 8.10254 6.5162 8.10254H8.06834C8.10253 8.10254 8.13671 8.10938 8.16406 8.11621C8.19142 8.12989 8.21193 8.1504 8.23244 8.17775C8.36236 8.47177 8.51278 8.76579 8.67005 9.0598C8.83415 9.35382 8.99142 9.641 9.16236 9.92818C9.32646 10.2154 9.47688 10.5025 9.62047 10.7966H9.63415C9.77774 10.4957 9.92817 10.2017 10.0786 9.9145C10.229 9.62733 10.3863 9.34015 10.5436 9.05297C10.7008 8.76579 10.8512 8.47177 11.0017 8.19143C11.0085 8.16408 11.0222 8.13673 11.0427 8.12305C11.07 8.10938 11.0974 8.10254 11.1316 8.10938H12.5743C12.6085 8.10254 12.6427 8.12305 12.6495 8.15724C12.6564 8.16408 12.6427 8.19143 12.629 8.2051Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.788 15.4188C15.282 15.4256 14.776 15.323 14.3179 15.1111C13.8872 14.9128 13.5316 14.5846 13.2854 14.1812C13.0325 13.7641 12.9094 13.2444 12.9094 12.6222C12.9025 12.1162 13.0325 11.6171 13.2854 11.1794C13.5453 10.735 13.9213 10.3658 14.3726 10.1196C14.8513 9.85295 15.4256 9.72304 16.1025 9.72304C16.1367 9.72304 16.1846 9.72304 16.2461 9.72988C16.3077 9.73671 16.376 9.73671 16.4581 9.74355V7.58287C16.4581 7.53501 16.4786 7.50765 16.5265 7.50765H17.9145C17.9487 7.50082 17.976 7.52817 17.9829 7.55552C17.9829 7.56236 17.9829 7.56919 17.9829 7.56919V14.0786C17.9829 14.2017 17.9897 14.3384 17.9966 14.4889C18.0102 14.6324 18.0171 14.7692 18.0239 14.8854C18.0239 14.9333 18.0034 14.9743 17.9555 14.9948C17.6 15.1453 17.2239 15.2547 16.841 15.323C16.4923 15.3846 16.1436 15.4188 15.788 15.4188ZM16.4581 14.0512V11.0427C16.3966 11.029 16.335 11.0153 16.2735 11.0085C16.1983 11.0017 16.1231 10.9948 16.0478 10.9948C15.7812 10.9948 15.5145 11.0495 15.2752 11.1726C15.0427 11.2889 14.8444 11.4598 14.694 11.6786C14.5436 11.8974 14.4683 12.1914 14.4683 12.547C14.4615 12.7863 14.5025 13.0256 14.5846 13.2512C14.653 13.4359 14.7555 13.6 14.8923 13.7367C15.0222 13.8598 15.1795 13.9555 15.3572 14.0102C15.5419 14.0718 15.7333 14.0991 15.9248 14.0991C16.0273 14.0991 16.1231 14.0923 16.2119 14.0854C16.3008 14.0923 16.376 14.0786 16.4581 14.0512Z",
                fill: "#FF61F6"
            })
        ]
    });
};
var $af98a0e346090ece$export$2e2bcd8739ae039 = $af98a0e346090ece$var$AdobeXDIcon;

});

parcelRegister("7g5Lp", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbdd266cf5ccea64$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $bbdd266cf5ccea64$var$AdobeSignIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-19.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.82667 4H17.1733C18.72 4 20 5.28 20 6.82667V16.7467C20 18.32 18.72 19.5733 17.1733 19.5733H6.82667C5.28 19.6 4 18.32 4 16.7733V6.82667C4 5.28 5.28 4 6.82667 4Z",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M16.8533 13.0401C16.5333 12.6934 15.92 12.5334 15.04 12.5334C14.56 12.5334 14.0533 12.5868 13.5733 12.6668C13.2533 12.3734 12.9867 12.0268 12.72 11.6801C12.5333 11.4134 12.3467 11.1468 12.1867 10.8534C12.4533 10.1068 12.6133 9.30676 12.6667 8.50676C12.6667 7.78676 12.3733 7.01343 11.5733 7.01343C11.3067 7.01343 11.04 7.17343 10.9067 7.41343C10.56 8.00009 10.6933 9.20009 11.2533 10.4534C11.0667 11.0134 10.8533 11.5734 10.6133 12.1868C10.4 12.7201 10.16 13.2268 9.86668 13.7068C9.04001 14.0268 7.30668 14.8268 7.14668 15.7068C7.09334 15.9734 7.17334 16.2401 7.38668 16.4001C7.57334 16.5601 7.84001 16.6668 8.10668 16.6401C9.14668 16.6401 10.1867 15.2001 10.9067 13.9468C11.3067 13.8134 11.7067 13.6801 12.1333 13.5734C12.5867 13.4668 13.0133 13.3601 13.4133 13.2801C14.5333 14.2401 15.52 14.4001 16 14.4001C16.6667 14.4001 16.9333 14.1068 17.0133 13.8668C17.12 13.5734 17.0667 13.2534 16.8533 13.0401ZM16.1333 13.5468C16.1067 13.7334 15.8933 13.8668 15.6267 13.8668C15.5467 13.8668 15.4667 13.8668 15.3867 13.8401C14.8533 13.7068 14.3467 13.4401 13.92 13.0934C14.2667 13.0401 14.64 13.0134 14.9867 13.0134C15.2267 13.0134 15.4667 13.0401 15.7067 13.0668C15.9467 13.1201 16.2133 13.2268 16.1333 13.5468ZM11.36 7.65343C11.4133 7.57343 11.4933 7.52009 11.6 7.49343C11.8667 7.49343 11.92 7.78676 11.92 8.05343C11.8933 8.66676 11.7867 9.25343 11.6 9.84009C11.1467 8.69343 11.2 7.92009 11.36 7.65343ZM12.8533 12.7734C12.56 12.8268 12.2667 12.9068 11.9733 12.9868C11.76 13.0401 11.5467 13.1201 11.3067 13.1734C11.4133 12.9334 11.52 12.6934 11.6267 12.4801C11.76 12.1868 11.8667 11.8934 11.9733 11.6001C12.08 11.7601 12.16 11.8934 12.2667 12.0268C12.4533 12.2934 12.6667 12.5334 12.8533 12.7734ZM9.62668 14.3201C8.96001 15.3868 8.29334 16.0801 7.92001 16.0801C7.86668 16.0801 7.78668 16.0534 7.76001 16.0268C7.68001 15.9734 7.65334 15.8668 7.68001 15.7868C7.73334 15.3868 8.50668 14.8268 9.62668 14.3201Z",
                fill: "white"
            })
        ]
    });
};
var $bbdd266cf5ccea64$export$2e2bcd8739ae039 = $bbdd266cf5ccea64$var$AdobeSignIcon;

});

parcelRegister("ewszM", function(module, exports) {

$parcel$export(module.exports, "default", () => $38dd52310a6a1dd3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $38dd52310a6a1dd3$var$AhaIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-635.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.5114 14.3589C13.4961 13.9874 13.4858 13.6157 13.4829 13.2439C13.4806 12.9476 13.4822 12.6512 13.4798 12.3549C13.4779 12.1238 13.4776 11.8926 13.4483 11.6628C13.4314 11.5303 13.4041 11.4003 13.3459 11.2789C13.2429 11.0639 13.0729 10.9187 12.8595 10.8216C12.562 10.6863 12.2524 10.6769 11.9374 10.742C11.6833 10.7945 11.4482 10.8957 11.2248 11.0259C11.1582 11.0647 11.0935 11.1066 11.0248 11.1522C11.0248 11.139 11.0248 11.1317 11.0248 11.1242C11.024 10.9117 11.0232 10.6993 11.0223 10.4868C11.0205 10.0525 11.0181 9.61825 11.0083 9.18407C11.0075 9.14589 11.0068 9.1076 11.003 9.06965C10.9985 9.02436 10.9605 8.99346 10.9209 9.00118C10.7482 9.03488 10.5756 9.06898 10.403 9.10296C10.182 9.14651 9.96017 9.18597 9.73703 9.21771C9.63006 9.23294 9.52302 9.24761 9.41605 9.26266C9.40776 9.26384 9.39813 9.26496 9.39433 9.27313C9.38968 9.28299 9.39892 9.28864 9.4053 9.29306C9.41476 9.29956 9.4137 9.30885 9.41498 9.31786C9.43737 9.47365 9.45467 9.63006 9.46883 9.7868C9.49083 10.0299 9.5041 10.2737 9.51339 10.5176C9.52722 10.8799 9.53366 11.2423 9.53607 11.6048C9.54323 12.6756 9.53573 13.7464 9.52577 14.8172C9.52515 14.8822 9.54228 14.8991 9.60722 14.8982C9.9839 14.8933 10.3605 14.8882 10.7372 14.8834C10.8454 14.882 10.9536 14.8819 11.0617 14.88C11.1067 14.8793 11.1419 14.8617 11.1375 14.803C11.1263 14.6534 11.1212 14.5034 11.1135 14.3536C11.0966 14.0279 11.0824 13.7021 11.0754 13.376C11.0725 13.24 11.0686 13.104 11.0675 12.968C11.065 12.6502 11.064 12.3324 11.0619 12.0146C11.0618 12.0001 11.0668 11.9933 11.0802 11.9881C11.1314 11.9683 11.1821 11.9472 11.233 11.9266C11.3449 11.8813 11.4598 11.8553 11.582 11.8677C11.6869 11.8784 11.7678 11.9237 11.8182 12.0183C11.8354 12.0504 11.8491 12.0839 11.8596 12.1188C11.9079 12.2798 11.9208 12.4461 11.9309 12.6124C11.9449 12.8432 11.9481 13.0743 11.9491 13.3054C11.9514 13.8152 11.9454 14.3249 11.943 14.8346C11.9427 14.8967 11.9627 14.9166 12.025 14.9164C12.2432 14.9154 12.4613 14.9063 12.6794 14.9013C12.7968 14.8986 12.9143 14.8968 13.0318 14.9015C13.1743 14.9071 13.3167 14.9164 13.4594 14.9164C13.5133 14.9164 13.5378 14.89 13.5351 14.8365C13.527 14.6775 13.5179 14.5184 13.5113 14.3592L13.5114 14.3589Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.9366 9.01969C19.8949 9.01381 19.8552 9.02663 19.8151 9.03307C19.5797 9.07063 19.3445 9.10948 19.1092 9.14766C18.8849 9.18405 18.6607 9.22071 18.4363 9.25626C18.3593 9.26846 18.3278 9.30709 18.335 9.3844C18.3477 9.52166 18.3605 9.65887 18.372 9.79624C18.3901 10.0134 18.4071 10.2308 18.4246 10.448C18.4441 10.6912 18.4592 10.9349 18.473 11.1785C18.4862 11.4092 18.4974 11.64 18.5087 11.8708C18.5253 12.2067 18.5413 12.5427 18.5572 12.8786C18.5601 12.9403 18.5901 12.9699 18.6524 12.9689C18.8259 12.966 18.9992 12.9627 19.1727 12.9596C19.1727 12.959 19.1727 12.9585 19.1727 12.9579C19.2109 12.9579 19.2491 12.9584 19.2874 12.9578C19.4272 12.9557 19.567 12.9535 19.7069 12.9509C19.7598 12.9499 19.7931 12.9184 19.7943 12.8695C19.7981 12.7158 19.8008 12.5621 19.8057 12.4084C19.8128 12.1849 19.8201 11.9614 19.8299 11.7379C19.8428 11.4466 19.8577 11.1554 19.8727 10.8642C19.8815 10.6958 19.8914 10.5274 19.9024 10.3592C19.9159 10.1537 19.9299 9.94834 19.9456 9.74312C19.9583 9.57691 19.9737 9.41088 19.9879 9.24479C19.9923 9.19379 19.9984 9.14279 20 9.09168C20.0016 9.04511 19.9823 9.02619 19.9366 9.01969H19.9366Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.8688 14.1793C19.8688 13.9604 19.8688 13.7414 19.8688 13.5225C19.8688 13.4553 19.8458 13.4339 19.7778 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3336 13.4735 19.0533 13.4827 18.7725 13.4746C18.6672 13.4715 18.562 13.4672 18.4571 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3715 13.5886 18.3713 13.6537 18.3731 13.7185C18.3774 13.8731 18.3778 14.0277 18.3757 14.1823C18.3727 14.4096 18.372 14.6369 18.3711 14.8643C18.3709 14.9132 18.3988 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.695 14.9194C18.9465 14.9041 19.198 14.9013 19.4498 14.9076C19.5653 14.9104 19.6808 14.9132 19.7964 14.9166C19.8276 14.9174 19.8511 14.9065 19.864 14.8775C19.8706 14.8627 19.8688 14.8464 19.8688 14.8306C19.8689 14.6135 19.8688 14.3964 19.8688 14.1793Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M9.07031 14.2687C8.61418 12.7687 8.15801 11.2688 7.70189 9.76881C7.63667 9.55441 7.57151 9.34 7.50612 9.1256C7.48597 9.05949 7.43526 9.0268 7.36791 9.03771C7.25763 9.05557 7.14763 9.07522 7.03735 9.09313C6.67802 9.15152 6.31852 9.20884 5.96031 9.274C5.86772 9.29085 5.80132 9.34224 5.77154 9.43248C5.18325 11.2134 4.59553 12.9943 4.00768 14.7753C3.98317 14.8496 4.01849 14.8982 4.09703 14.8982C4.53249 14.8982 4.96801 14.8982 5.40348 14.8983C5.42128 14.8983 5.43902 14.8983 5.45593 14.8922C5.47636 14.8849 5.49142 14.8721 5.49635 14.8498C5.51896 14.7472 5.54136 14.6445 5.56425 14.5419C5.6335 14.2314 5.70297 13.921 5.77233 13.6105C5.77546 13.5964 5.77815 13.5867 5.79847 13.587C6.27581 13.5939 6.7532 13.6 7.23054 13.6053C7.25254 13.6055 7.26054 13.6121 7.26508 13.633C7.3552 14.0446 7.446 14.456 7.53669 14.8675C7.54811 14.9193 7.56759 14.935 7.62116 14.9357C7.63141 14.9358 7.64165 14.9352 7.6519 14.9349C7.90072 14.9282 8.14961 14.9214 8.34341 14.9162C8.65494 14.9162 8.91138 14.9165 9.16782 14.9161C9.22923 14.916 9.25593 14.8791 9.2383 14.8211C9.18226 14.6369 9.12623 14.4528 9.07025 14.2686L9.07031 14.2687ZM7.00544 12.4829C6.70517 12.4823 6.4049 12.4822 6.10457 12.483C6.07881 12.4831 6.07909 12.4754 6.08486 12.4548C6.22089 11.9665 6.3497 11.4762 6.47397 10.9849C6.50952 10.8442 6.54289 10.703 6.57737 10.562C6.57866 10.5569 6.58056 10.5518 6.58465 10.5392C6.6816 10.937 6.76787 11.3295 6.85732 11.7211C6.91319 11.966 6.96978 12.2107 7.02739 12.4552C7.03299 12.479 7.02834 12.4829 7.0055 12.4828L7.00544 12.4829Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.6715 14.483C17.6508 14.1846 17.6368 13.8858 17.6337 13.5866C17.6292 13.1505 17.6392 12.7144 17.6459 12.2783C17.6489 12.0854 17.6451 11.8927 17.6116 11.7017C17.5626 11.4229 17.427 11.1973 17.2 11.0277C17.0326 10.9026 16.8409 10.8332 16.6391 10.7888C16.3129 10.7171 15.9826 10.7133 15.6513 10.735C15.4224 10.75 15.1954 10.7808 14.9697 10.822C14.7443 10.8632 14.5215 10.9154 14.3015 10.9796C14.2482 10.9951 14.2304 11.018 14.2279 11.0738C14.225 11.1361 14.2232 11.1986 14.2205 11.2609C14.2138 11.4201 14.2068 11.5793 14.2002 11.7385C14.1971 11.812 14.193 11.8856 14.1925 11.9591C14.192 12.0256 14.2482 12.0552 14.2961 12.0363C14.4737 11.9667 14.6519 11.899 14.8344 11.8434C15.1069 11.7603 15.3843 11.7096 15.6705 11.7156C15.765 11.7175 15.8584 11.726 15.9472 11.7617C16.0354 11.797 16.0909 11.8595 16.1043 11.9553C16.11 11.996 16.1065 12.0371 16.106 12.0781C16.1057 12.1005 16.0979 12.1097 16.0745 12.1129C15.9739 12.127 15.8735 12.1417 15.7735 12.1592C15.4704 12.2122 15.1722 12.2838 14.8841 12.3937C14.6487 12.4835 14.426 12.5963 14.2307 12.7575C14.0093 12.9403 13.8519 13.1654 13.7916 13.4492C13.733 13.7249 13.7543 13.9976 13.8446 14.2642C13.9131 14.4664 14.0269 14.6385 14.1966 14.7708C14.3761 14.9107 14.5826 14.976 14.8076 14.9892C14.8076 14.9907 14.8078 14.9922 14.808 14.9937H14.9647C14.9647 14.9921 14.9647 14.9906 14.9649 14.989C15.0468 14.9825 15.1278 14.9702 15.2076 14.9506C15.5361 14.87 15.8352 14.7248 16.1143 14.5361C16.1279 14.527 16.1412 14.5175 16.1583 14.5057V14.5414C16.1583 14.6448 16.1582 14.7483 16.1584 14.8517C16.1585 14.9143 16.1809 14.9365 16.2426 14.9356C16.3964 14.9334 16.5502 14.9309 16.7041 14.9288C17.0099 14.9245 17.3157 14.9204 17.6215 14.9161C17.6734 14.9154 17.696 14.8915 17.6952 14.8397C17.6951 14.8341 17.6948 14.8285 17.6945 14.823C17.6868 14.7095 17.6793 14.5962 17.6714 14.4828L17.6715 14.483ZM16.1219 13.3558C16.1219 13.4806 16.1214 13.6055 16.1224 13.7302C16.1226 13.7497 16.1161 13.76 16.0995 13.7695C15.9485 13.857 15.7891 13.9147 15.6115 13.9032C15.4004 13.8894 15.2482 13.7607 15.226 13.5542C15.2022 13.3329 15.2951 13.1667 15.5135 13.0711C15.6245 13.0225 15.7419 12.9981 15.861 12.9813C15.9384 12.9704 16.0164 12.9631 16.0939 12.9531C16.1155 12.9503 16.1227 12.9553 16.1224 12.9785C16.1213 13.1043 16.1219 13.2301 16.1219 13.3558Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.5116 14.3589C13.4963 13.9874 13.4861 13.6157 13.4831 13.2439C13.4808 12.9476 13.4825 12.6512 13.48 12.3549C13.4781 12.1238 13.4778 11.8926 13.4486 11.6628C13.4316 11.5303 13.4044 11.4003 13.3462 11.2789C13.2432 11.0639 13.0732 10.9187 12.8598 10.8216C12.5623 10.6863 12.2527 10.6769 11.9377 10.742C11.6836 10.7945 11.4485 10.8957 11.225 11.0259C11.1584 11.0647 11.0938 11.1066 11.0251 11.1522C11.0251 11.139 11.0251 11.1317 11.0251 11.1242C11.0242 10.9117 11.0234 10.6993 11.0225 10.4868C11.0208 10.0525 11.0184 9.61825 11.0086 9.18407C11.0077 9.14589 11.007 9.1076 11.0033 9.06965C10.9988 9.02436 10.9607 8.99346 10.9211 9.00118C10.7485 9.03488 10.5759 9.06898 10.4033 9.10296C10.1822 9.14651 9.96041 9.18597 9.73728 9.21771C9.6303 9.23294 9.52327 9.24761 9.41629 9.26266C9.40801 9.26384 9.39838 9.26496 9.39457 9.27313C9.38992 9.28299 9.39916 9.28864 9.40554 9.29306C9.415 9.29956 9.41394 9.30885 9.41523 9.31786C9.43762 9.47365 9.45492 9.63006 9.46908 9.7868C9.49108 10.0299 9.50435 10.2737 9.51364 10.5176C9.52747 10.8799 9.5339 11.2423 9.53631 11.6048C9.54348 12.6756 9.53597 13.7464 9.52601 14.8172C9.52539 14.8822 9.54252 14.8991 9.60746 14.8982C9.98415 14.8933 10.3608 14.8882 10.7375 14.8834C10.8456 14.882 10.9538 14.8819 11.0619 14.88C11.107 14.8793 11.1421 14.8617 11.1377 14.803C11.1265 14.6534 11.1215 14.5034 11.1137 14.3536C11.0969 14.0279 11.0826 13.7021 11.0756 13.376C11.0727 13.24 11.0688 13.104 11.0677 12.968C11.0652 12.6502 11.0642 12.3324 11.0621 12.0146C11.062 12.0001 11.0671 11.9933 11.0804 11.9881C11.1316 11.9683 11.1823 11.9472 11.2332 11.9266C11.3452 11.8813 11.46 11.8553 11.5822 11.8677C11.6871 11.8784 11.768 11.9237 11.8185 12.0183C11.8356 12.0504 11.8494 12.0839 11.8599 12.1188C11.9082 12.2798 11.921 12.4461 11.9311 12.6124C11.9451 12.8432 11.9483 13.0743 11.9493 13.3054C11.9516 13.8152 11.9457 14.3249 11.9432 14.8346C11.9429 14.8967 11.963 14.9166 12.0253 14.9164C12.2435 14.9154 12.4615 14.9063 12.6796 14.9013C12.7971 14.8986 12.9146 14.8968 13.032 14.9015C13.1745 14.9071 13.3169 14.9164 13.4597 14.9164C13.5135 14.9164 13.5381 14.89 13.5353 14.8365C13.5272 14.6775 13.5181 14.5184 13.5116 14.3592L13.5116 14.3589Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.9364 9.01981C19.8947 9.01394 19.855 9.02676 19.8149 9.03319C19.5795 9.07075 19.3443 9.1096 19.109 9.14778C18.8847 9.18417 18.6605 9.22084 18.4361 9.25638C18.3591 9.26859 18.3276 9.30721 18.3348 9.38452C18.3475 9.52178 18.3603 9.65899 18.3718 9.79636C18.3899 10.0136 18.4069 10.2309 18.4244 10.4481C18.444 10.6914 18.459 10.935 18.4729 11.1787C18.486 11.4094 18.4972 11.6402 18.5086 11.8709C18.5251 12.2068 18.5411 12.5428 18.557 12.8788C18.5599 12.9404 18.5899 12.97 18.6523 12.969C18.8257 12.9661 18.9991 12.9628 19.1725 12.9597C19.1725 12.9592 19.1725 12.9586 19.1725 12.958C19.2107 12.958 19.249 12.9585 19.2872 12.9579C19.427 12.9558 19.5669 12.9537 19.7067 12.951C19.7597 12.95 19.793 12.9186 19.7941 12.8696C19.7979 12.7159 19.8006 12.5622 19.8055 12.4085C19.8127 12.185 19.8199 11.9615 19.8297 11.7381C19.8426 11.4468 19.8575 11.1555 19.8726 10.8643C19.8813 10.6959 19.8913 10.5276 19.9022 10.3593C19.9157 10.1538 19.9297 9.94846 19.9454 9.74324C19.9581 9.57703 19.9736 9.411 19.9877 9.24491C19.9921 9.19391 19.9982 9.14291 19.9999 9.0918C20.0014 9.04523 19.9821 9.02631 19.9364 9.01981H19.9364Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.8689 14.1793C19.8689 13.9604 19.8689 13.7414 19.8689 13.5225C19.8689 13.4553 19.8459 13.4339 19.7779 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3337 13.4735 19.0533 13.4827 18.7726 13.4746C18.6673 13.4715 18.5621 13.4672 18.4572 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3716 13.5886 18.3714 13.6537 18.3732 13.7185C18.3774 13.8731 18.3779 14.0277 18.3758 14.1823C18.3728 14.4096 18.3721 14.6369 18.3712 14.8643C18.3709 14.9132 18.3989 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.6951 14.9194C18.9465 14.9041 19.1981 14.9013 19.4498 14.9076C19.5654 14.9104 19.6809 14.9132 19.7965 14.9166C19.8276 14.9174 19.8512 14.9065 19.8641 14.8775C19.8706 14.8627 19.8689 14.8464 19.8689 14.8306C19.8689 14.6135 19.8689 14.3964 19.8689 14.1793Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M9.07031 14.2689C8.61418 12.7689 8.15801 11.269 7.70189 9.76905C7.63667 9.55465 7.57151 9.34025 7.50612 9.12585C7.48597 9.05973 7.43526 9.02704 7.36791 9.03796C7.25763 9.05582 7.14763 9.07546 7.03735 9.09338C6.67802 9.15176 6.31852 9.20909 5.96031 9.27425C5.86772 9.2911 5.80132 9.34249 5.77154 9.43273C5.18325 11.2136 4.59553 12.9946 4.00768 14.7756C3.98317 14.8498 4.01849 14.8984 4.09703 14.8984C4.53249 14.8984 4.96801 14.8984 5.40348 14.8985C5.42128 14.8985 5.43902 14.8985 5.45593 14.8925C5.47636 14.8851 5.49142 14.8724 5.49635 14.85C5.51896 14.7474 5.54136 14.6448 5.56425 14.5421C5.6335 14.2317 5.70297 13.9212 5.77233 13.6108C5.77546 13.5966 5.77815 13.587 5.79847 13.5872C6.27581 13.5942 6.7532 13.6003 7.23054 13.6056C7.25254 13.6058 7.26054 13.6124 7.26508 13.6332C7.3552 14.0448 7.446 14.4563 7.53669 14.8678C7.54811 14.9195 7.56759 14.9352 7.62116 14.9359C7.63141 14.936 7.64165 14.9354 7.6519 14.9351C7.90072 14.9284 8.14961 14.9217 8.34341 14.9165C8.65494 14.9165 8.91138 14.9167 9.16782 14.9163C9.22923 14.9162 9.25593 14.8793 9.2383 14.8213C9.18226 14.6371 9.12623 14.453 9.07025 14.2689L9.07031 14.2689ZM7.00544 12.4832C6.70517 12.4825 6.4049 12.4824 6.10457 12.4833C6.07881 12.4833 6.07909 12.4757 6.08486 12.455C6.22089 11.9667 6.3497 11.4765 6.47397 10.9851C6.50952 10.8444 6.54289 10.7032 6.57737 10.5623C6.57866 10.5571 6.58056 10.5521 6.58465 10.5394C6.6816 10.9372 6.76787 11.3297 6.85732 11.7214C6.91319 11.9662 6.96978 12.2109 7.02739 12.4554C7.03299 12.4792 7.02834 12.4831 7.0055 12.4831L7.00544 12.4832Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.6717 14.483C17.6511 14.1846 17.637 13.8858 17.634 13.5866C17.6294 13.1505 17.6394 12.7144 17.6462 12.2783C17.6491 12.0854 17.6453 11.8927 17.6118 11.7017C17.5628 11.4229 17.4273 11.1973 17.2002 11.0277C17.0328 10.9026 16.8412 10.8332 16.6394 10.7888C16.3131 10.7171 15.9828 10.7133 15.6516 10.735C15.4227 10.75 15.1956 10.7808 14.97 10.822C14.7445 10.8632 14.5217 10.9154 14.3018 10.9796C14.2485 10.9951 14.2307 11.018 14.2281 11.0738C14.2253 11.1361 14.2234 11.1986 14.2208 11.2609C14.2141 11.4201 14.2071 11.5793 14.2004 11.7385C14.1973 11.812 14.1932 11.8856 14.1927 11.9591C14.1923 12.0256 14.2484 12.0552 14.2963 12.0363C14.4739 11.9667 14.6521 11.899 14.8346 11.8434C15.1071 11.7603 15.3845 11.7096 15.6707 11.7156C15.7653 11.7175 15.8586 11.726 15.9475 11.7617C16.0357 11.797 16.0911 11.8595 16.1045 11.9553C16.1103 11.996 16.1068 12.0371 16.1062 12.0781C16.1059 12.1005 16.0981 12.1097 16.0747 12.1129C15.9742 12.127 15.8737 12.1417 15.7738 12.1592C15.4707 12.2122 15.1724 12.2838 14.8843 12.3937C14.6489 12.4835 14.4263 12.5963 14.2309 12.7575C14.0095 12.9403 13.8522 13.1654 13.7918 13.4492C13.7332 13.7249 13.7546 13.9976 13.8449 14.2642C13.9133 14.4664 14.0271 14.6385 14.1969 14.7708C14.3763 14.9107 14.5829 14.976 14.8078 14.9892C14.8079 14.9907 14.8081 14.9922 14.8083 14.9937H14.965C14.965 14.9921 14.965 14.9906 14.9652 14.989C15.0471 14.9825 15.128 14.9702 15.2078 14.9506C15.5364 14.87 15.8355 14.7248 16.1146 14.5361C16.1281 14.527 16.1414 14.5175 16.1586 14.5057V14.5414C16.1586 14.6448 16.1584 14.7483 16.1586 14.8517C16.1587 14.9143 16.1811 14.9365 16.2428 14.9356C16.3966 14.9334 16.5505 14.9309 16.7043 14.9288C17.0101 14.9245 17.3159 14.9204 17.6218 14.9161C17.6737 14.9154 17.6963 14.8915 17.6954 14.8397C17.6953 14.8341 17.695 14.8285 17.6947 14.823C17.687 14.7095 17.6795 14.5962 17.6717 14.4828L17.6717 14.483ZM16.1221 13.3558C16.1221 13.4806 16.1217 13.6055 16.1226 13.7302C16.1228 13.7497 16.1163 13.76 16.0998 13.7695C15.9488 13.857 15.7893 13.9147 15.6117 13.9032C15.4006 13.8894 15.2485 13.7607 15.2262 13.5542C15.2024 13.3329 15.2953 13.1667 15.5138 13.0711C15.6247 13.0225 15.7421 12.9981 15.8613 12.9813C15.9387 12.9704 16.0166 12.9631 16.0942 12.9531C16.1157 12.9503 16.1229 12.9553 16.1227 12.9785C16.1215 13.1043 16.1221 13.2301 16.1221 13.3558Z",
                fill: "#0172CE"
            })
        ]
    });
};
var $38dd52310a6a1dd3$export$2e2bcd8739ae039 = $38dd52310a6a1dd3$var$AhaIcon;

});

parcelRegister("kANz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $345e3d30d2a462ce$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $345e3d30d2a462ce$var$AirtableIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-635.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.1447 5.16889L5.17945 7.63723C4.84772 7.77451 4.85115 8.24569 5.18496 8.37801L11.1751 10.7535C11.7015 10.9622 12.2876 10.9622 12.8139 10.7535L18.8042 8.37801C19.1379 8.24569 19.1414 7.77451 18.8096 7.63723L12.8445 5.16889C12.3002 4.9437 11.6888 4.9437 11.1447 5.16889Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.5259 12.0506V17.9848C12.5259 18.2671 12.8105 18.4603 13.0728 18.3563L19.7477 15.7655C19.9001 15.705 20.0001 15.5578 20.0001 15.3939V9.45974C20.0001 9.17748 19.7155 8.98421 19.4531 9.08821L12.7782 11.6791C12.6259 11.7395 12.5259 11.8867 12.5259 12.0506Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.9672 12.3568L8.98623 13.3133L8.78509 13.4105L4.6034 15.4141C4.33833 15.542 4 15.3488 4 15.0544V9.48465C4 9.37811 4.05462 9.28613 4.12788 9.21686C4.15845 9.1862 4.19309 9.16097 4.22908 9.14098C4.32901 9.08102 4.47155 9.06501 4.59273 9.11295L10.9339 11.6254C11.2562 11.7533 11.2815 12.2049 10.9672 12.3568Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.9672 12.3568L8.98628 13.3133L4.12793 9.21686C4.1585 9.1862 4.19314 9.16097 4.22913 9.14098C4.32906 9.08102 4.4716 9.06501 4.59278 9.11295L10.934 11.6254C11.2563 11.7533 11.2816 12.2049 10.9672 12.3568Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.2515 6.14778L6.03189 8.30757C5.74163 8.4277 5.74464 8.83998 6.03672 8.95576L11.2781 11.0343C11.7387 11.2169 12.2515 11.2169 12.712 11.0343L17.9535 8.95576C18.2455 8.83998 18.2486 8.4277 17.9583 8.30757L12.7388 6.14778C12.2625 5.95074 11.7276 5.95074 11.2515 6.14778Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.4601 12.1693V17.3617C12.4601 17.6087 12.7091 17.7778 12.9387 17.6868L18.7792 15.4198C18.9126 15.3669 19 15.2381 19 15.0947V9.90228C19 9.65531 18.751 9.4862 18.5214 9.5772L12.6809 11.8442C12.5476 11.8971 12.4601 12.0259 12.4601 12.1693Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.0963 12.4372L9.36295 13.2741L9.18695 13.3592L5.52798 15.1124C5.29604 15.2243 5 15.0552 5 14.7976V9.92405C5 9.83083 5.0478 9.75035 5.11189 9.68974C5.13864 9.66291 5.16895 9.64083 5.20045 9.62334C5.28789 9.57088 5.4126 9.55687 5.51864 9.59881L11.0672 11.7972C11.3492 11.9091 11.3714 12.3043 11.0963 12.4372Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.0963 12.4372L9.36293 13.2741L5.11188 9.68974C5.13862 9.66291 5.16893 9.64083 5.20043 9.62334C5.28787 9.57088 5.41258 9.55687 5.51862 9.59881L11.0671 11.7972C11.3492 11.9091 11.3713 12.3043 11.0963 12.4372Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
};
var $345e3d30d2a462ce$export$2e2bcd8739ae039 = $345e3d30d2a462ce$var$AirtableIcon;

});

parcelRegister("d7VwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4033d0745e77c2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $9e4033d0745e77c2$var$AmplitudeIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-683.5",
                y: "-507.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.0516 7.60124C11.0073 7.54277 10.9568 7.51208 10.9007 7.51208C10.8545 7.51208 10.8122 7.53281 10.7851 7.55016C10.3591 7.88478 9.77609 9.30229 9.29834 11.1701L9.72131 11.1749C10.5565 11.1844 11.419 11.1942 12.2715 11.2073C12.0468 10.3518 11.8344 9.61843 11.6397 9.02646C11.3552 8.16124 11.1629 7.77393 11.0516 7.60124Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 12.0001C20 16.4183 16.4183 20.0001 12 20.0001C7.58169 20.0001 4 16.4183 4 12.0001C4 7.58181 7.58169 4.00012 12 4.00012C16.4183 4.00012 20 7.58181 20 12.0001ZM17.9088 11.8171C17.9088 11.6117 17.764 11.4404 17.569 11.4014C17.5679 11.4012 17.5667 11.4009 17.5655 11.4006C17.5632 11.4003 17.561 11.3995 17.5587 11.3992L17.5508 11.3984C17.5301 11.395 17.5091 11.3929 17.4876 11.3926L17.4315 11.3873C16.0916 11.2914 14.7131 11.2536 13.4199 11.2278L13.4173 11.2183C12.788 8.85747 12.0018 6.44382 10.9417 6.44382C9.9539 6.44831 9.06345 8.03418 8.29446 11.1584C7.75116 11.1514 7.2559 11.1439 6.78892 11.1359C6.76241 11.1354 6.73863 11.1352 6.71743 11.1352C6.61783 11.1352 6.56916 11.1394 6.54506 11.1426C6.28209 11.1892 6.09124 11.4186 6.09124 11.6883C6.09124 11.9633 6.29655 12.1992 6.56402 12.2377L6.56948 12.2433H8.04257C7.90586 12.8684 7.78602 13.4865 7.68594 14.0821L7.64209 14.3442L7.64161 14.3567C7.64257 14.559 7.80787 14.7235 8.00996 14.7235C8.13815 14.7235 8.2543 14.6567 8.32064 14.5526L8.33108 14.5609L9.05526 12.2433H12.5435C12.81 13.2502 13.0864 14.2899 13.4517 15.2657C13.6471 15.7874 14.1044 17.0094 14.8688 17.0155H14.8774C16.0604 17.0155 16.5214 15.1047 16.8268 13.8398C16.8924 13.5677 16.9491 13.3327 17.0026 13.16L17.0239 13.0886H17.0238C17.0289 13.0719 17.0316 13.0543 17.0316 13.0358C17.0316 12.9346 16.9496 12.8525 16.8484 12.8525C16.7698 12.8525 16.703 12.9018 16.6768 12.9712L16.6765 12.971L16.6508 13.0421C16.5504 13.32 16.4575 13.5828 16.3753 13.8157L16.369 13.8332C15.857 15.2833 15.6233 15.9452 15.1655 15.9453L15.1542 15.9452L15.1478 15.9461L15.1364 15.9458C14.5504 15.9458 13.9986 13.5635 13.7908 12.6668C13.7549 12.5114 13.7219 12.3688 13.6916 12.2433H17.481C17.5521 12.2433 17.6191 12.2255 17.6779 12.1947C17.6784 12.1945 17.6787 12.1943 17.679 12.1942C17.685 12.1911 17.6906 12.1876 17.6964 12.1842C17.7028 12.1805 17.7091 12.1768 17.7152 12.1728C17.7182 12.1709 17.7211 12.1688 17.724 12.1667C17.7332 12.1604 17.742 12.1539 17.7507 12.1468C17.7513 12.1463 17.7518 12.1458 17.7524 12.1453C17.8479 12.0671 17.9088 11.9486 17.9088 11.8171Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.9329 7.05123C10.883 6.98545 10.8263 6.95093 10.7632 6.95093C10.7112 6.95093 10.6636 6.97424 10.6331 6.99376C10.1538 7.37021 9.49798 8.9649 8.96051 11.0662L9.43635 11.0716C10.3759 11.0823 11.3462 11.0933 12.3053 11.1081C12.0525 10.1456 11.8136 9.32057 11.5945 8.6546C11.2745 7.68123 11.0582 7.24551 10.9329 7.05123Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21 12C21 16.9704 16.9706 21 12 21C7.0294 21 3 16.9704 3 12C3 7.0294 7.0294 3 12 3C16.9706 3 21 7.0294 21 12ZM18.6473 11.7942C18.6473 11.563 18.4845 11.3704 18.2651 11.3264C18.2639 11.3263 18.2626 11.3259 18.2611 11.3255C18.2586 11.3252 18.2561 11.3243 18.2536 11.3239L18.2447 11.323C18.2214 11.3192 18.1977 11.3169 18.1735 11.3165L18.1104 11.3105C16.603 11.2027 15.0522 11.1602 13.5974 11.1311L13.5945 11.1204C12.8864 8.46452 12.002 5.74916 10.8094 5.74916C9.69813 5.75422 8.69639 7.53831 7.83126 11.053C7.22006 11.0452 6.66289 11.0367 6.13753 11.0277C6.10771 11.0272 6.08096 11.027 6.05711 11.027C5.94506 11.027 5.8903 11.0317 5.86319 11.0353C5.56735 11.0877 5.35265 11.3458 5.35265 11.6492C5.35265 11.9586 5.58361 12.2239 5.88452 12.2673L5.89066 12.2736H7.54789C7.3941 12.9768 7.25928 13.6722 7.14669 14.3422L7.09735 14.6371L7.09681 14.6512C7.09789 14.8787 7.28385 15.0638 7.5112 15.0638C7.65542 15.0638 7.78608 14.9886 7.86072 14.8715L7.87247 14.8809L8.68717 12.2736H12.6114C12.9112 13.4064 13.2222 14.576 13.6332 15.6737C13.853 16.2607 14.3675 17.6355 15.2273 17.6423H15.2371C16.568 17.6423 17.0866 15.4927 17.4302 14.0696C17.5039 13.7635 17.5677 13.4991 17.6279 13.3048L17.6519 13.2246H17.6517C17.6575 13.2058 17.6606 13.1859 17.6606 13.1651C17.6606 13.0513 17.5683 12.9589 17.4544 12.9589C17.366 12.9589 17.2908 13.0144 17.2614 13.0925L17.261 13.0923L17.2321 13.1722C17.1192 13.4848 17.0147 13.7805 16.9222 14.0425L16.9151 14.0622C16.3392 15.6936 16.0762 16.4382 15.5611 16.4384L15.5485 16.4382L15.5413 16.4393L15.5284 16.4389C14.8692 16.4389 14.2484 13.7588 14.0147 12.75C13.9742 12.5752 13.9372 12.4148 13.903 12.2736H18.1661C18.2461 12.2736 18.3215 12.2536 18.3877 12.2189C18.3882 12.2187 18.3886 12.2185 18.3889 12.2183C18.3956 12.2149 18.4019 12.2109 18.4084 12.2071C18.4157 12.203 18.4227 12.1988 18.4296 12.1943C18.433 12.1921 18.4363 12.1898 18.4395 12.1874C18.4498 12.1804 18.4598 12.173 18.4695 12.165C18.4702 12.1645 18.4708 12.1639 18.4715 12.1634C18.5789 12.0754 18.6473 11.942 18.6473 11.7942Z",
                fill: "#007FD2"
            })
        ]
    });
};
var $9e4033d0745e77c2$export$2e2bcd8739ae039 = $9e4033d0745e77c2$var$AmplitudeIcon;

});

parcelRegister("hSByb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc382d242081166$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $5dc382d242081166$var$AsanaIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#F06A6A"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9553 12.3807C14.2737 12.3807 12.9105 13.7439 12.9105 15.4256C12.9105 17.1072 14.2737 18.4704 15.9553 18.4704C17.6369 18.4704 19 17.1072 19 15.4256C19 13.7439 17.6369 12.3807 15.9553 12.3807ZM8.04475 12.381C6.3632 12.381 5 13.7439 5 15.4256C5 17.1072 6.3632 18.4704 8.04475 18.4704C9.72637 18.4704 11.0896 17.1072 11.0896 15.4256C11.0896 13.7439 9.72637 12.381 8.04475 12.381ZM15.0447 8.57471C15.0447 10.2564 13.6816 11.6197 12 11.6197C10.3184 11.6197 8.95526 10.2564 8.95526 8.57471C8.95526 6.89336 10.3184 5.53003 12 5.53003C13.6816 5.53003 15.0447 6.89336 15.0447 8.57471Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0853 12.8081C14.9233 12.8081 13.1707 14.5607 13.1707 16.7229C13.1707 18.8849 14.9233 20.6376 17.0853 20.6376C19.2474 20.6376 21 18.8849 21 16.7229C21 14.5607 19.2474 12.8081 17.0853 12.8081ZM6.91468 12.8084C4.75268 12.8084 3 14.5607 3 16.7229C3 18.8849 4.75268 20.6376 6.91468 20.6376C9.07677 20.6376 10.8295 18.8849 10.8295 16.7229C10.8295 14.5607 9.07677 12.8084 6.91468 12.8084ZM15.9146 7.91459C15.9146 10.0768 14.162 11.8296 12 11.8296C9.83793 11.8296 8.08533 10.0768 8.08533 7.91459C8.08533 5.75285 9.83793 4 12 4C14.162 4 15.9146 5.75285 15.9146 7.91459Z",
            fill: "#F06A6A"
        })
    });
};
var $5dc382d242081166$export$2e2bcd8739ae039 = $5dc382d242081166$var$AsanaIcon;

});

parcelRegister("9oHmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f61e212b20a1941f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $f61e212b20a1941f$var$AzureDevopsIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.5 7.30929V16.4293L15.75 19.5L9.9375 17.3839V19.4818L6.64714 15.1821L16.2375 15.9321V7.71964L19.5 7.30929ZM16.3029 7.76786L10.9221 4.5V6.64393L5.98071 8.09571L4.5 9.99643V14.3132L6.61929 15.2486V9.71679L16.3029 7.76786Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19 7.622V16.134L15.5 19L10.075 17.025V18.983L7.004 14.97L15.955 15.67V8.005L19 7.622ZM16.016 8.05L10.994 5V7.001L6.382 8.356L5 10.13V14.159L6.978 15.032V9.869L16.016 8.05Z",
                fill: "url(#paint0_linear_24_1001)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                    id: "paint0_linear_24_1001",
                    x1: "12",
                    y1: "18.956",
                    x2: "12",
                    y2: "5.026",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            stopColor: "#0078D4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: "0.16",
                            stopColor: "#1380DA"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: "0.53",
                            stopColor: "#3C91E5"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: "0.82",
                            stopColor: "#559CEC"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: "1",
                            stopColor: "#5EA0EF"
                        })
                    ]
                })
            })
        ]
    });
};
var $f61e212b20a1941f$export$2e2bcd8739ae039 = $f61e212b20a1941f$var$AzureDevopsIcon;

});

parcelRegister("jZsZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d7d19f5d1162f24$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $3d7d19f5d1162f24$var$BoxIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-683.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0071F7"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.8589 15.3516C20.0587 15.6312 20.0187 15.9907 19.779 16.1905C19.4994 16.3902 19.0999 16.3502 18.9002 16.1106L17.5021 14.313L16.1439 16.0706C15.9441 16.3502 15.5447 16.3502 15.265 16.1505C14.9854 15.9508 14.9455 15.5913 15.1452 15.3116L16.7431 13.2344L15.1452 11.1571C14.9455 10.8775 15.0254 10.478 15.265 10.2783C15.5447 10.0786 15.9441 10.1585 16.1439 10.3982L17.5021 12.1958L18.9002 10.478C19.0999 10.1984 19.4595 10.1585 19.779 10.3582C20.0587 10.5579 20.0587 10.9574 19.8589 11.237L18.301 13.2743L19.8589 15.3516ZM12.5886 15.1119C11.55 15.1119 10.7111 14.313 10.7111 13.2743C10.7111 12.2757 11.55 11.4368 12.5886 11.4368C13.6272 11.4368 14.4661 12.2757 14.4661 13.2743C14.4261 14.313 13.5873 15.1119 12.5886 15.1119ZM7.07591 15.1119C6.03729 15.1119 5.19841 14.313 5.19841 13.2743C5.19841 12.2757 6.03729 11.4368 7.07591 11.4368C8.11453 11.4368 8.95342 12.2757 8.95342 13.2743C8.95342 14.313 8.11453 15.1119 7.07591 15.1119ZM12.5886 10.2384C11.4301 10.2384 10.3915 10.8775 9.8722 11.8362C9.35289 10.8775 8.31427 10.2384 7.11586 10.2384C6.39682 10.2384 5.75766 10.478 5.23835 10.8376V8.28097C5.23835 7.96139 4.95873 7.68176 4.63915 7.68176C4.27963 7.68176 4 7.96139 4 8.28097V13.3143C4.03995 14.9921 5.39814 16.3103 7.07591 16.3103C8.27432 16.3103 9.31294 15.6312 9.83225 14.6725C10.3516 15.6312 11.3902 16.3103 12.5486 16.3103C14.2664 16.3103 15.6645 14.9521 15.6645 13.2344C15.7045 11.5966 14.3063 10.2384 12.5886 10.2384Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M20.8413 15.6285C21.066 15.9431 21.0211 16.3476 20.7514 16.5723C20.4368 16.797 19.9874 16.752 19.7627 16.4824L18.1898 14.4601L16.6619 16.4375C16.4371 16.752 15.9877 16.752 15.6732 16.5273C15.3586 16.3026 15.3136 15.8982 15.5383 15.5836L17.336 13.2467L15.5383 10.9098C15.3136 10.5952 15.4035 10.1458 15.6732 9.92112C15.9877 9.69642 16.4371 9.7863 16.6619 10.0559L18.1898 12.0783L19.7627 10.1458C19.9874 9.83124 20.3919 9.7863 20.7514 10.011C21.066 10.2357 21.066 10.6851 20.8413 10.9997L19.0886 13.2916L20.8413 15.6285ZM12.6622 15.3589C11.4937 15.3589 10.55 14.4601 10.55 13.2916C10.55 12.1681 11.4937 11.2244 12.6622 11.2244C13.8306 11.2244 14.7744 12.1681 14.7744 13.2916C14.7294 14.4601 13.7857 15.3589 12.6622 15.3589ZM6.4604 15.3589C5.29196 15.3589 4.34821 14.4601 4.34821 13.2916C4.34821 12.1681 5.29196 11.2244 6.4604 11.2244C7.62885 11.2244 8.5726 12.1681 8.5726 13.2916C8.5726 14.4601 7.62885 15.3589 6.4604 15.3589ZM12.6622 9.87618C11.3589 9.87618 10.1904 10.5952 9.60622 11.6738C9.022 10.5952 7.85355 9.87618 6.50534 9.87618C5.69642 9.87618 4.97737 10.1458 4.39315 10.5503V7.6741C4.39315 7.31458 4.07857 7 3.71904 7C3.31458 7 3 7.31458 3 7.6741V13.3366C3.04494 15.2241 4.57291 16.7071 6.4604 16.7071C7.80861 16.7071 8.97706 15.9431 9.56128 14.8646C10.1455 15.9431 11.314 16.7071 12.6172 16.7071C14.5497 16.7071 16.1226 15.1791 16.1226 13.2467C16.1675 11.4041 14.5946 9.87618 12.6622 9.87618Z",
            fill: "#0071F7"
        })
    });
};
var $3d7d19f5d1162f24$export$2e2bcd8739ae039 = $3d7d19f5d1162f24$var$BoxIcon;

});

parcelRegister("iPetR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a554317b561c7bd7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $a554317b561c7bd7$var$CanvaIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_1737_5849)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M17.0221 14.2091C16.9332 14.2091 16.855 14.2841 16.7737 14.4479C15.8548 16.3111 14.2679 17.6294 12.4314 17.6294C10.308 17.6294 8.993 15.7125 8.993 13.0644C8.993 8.57869 11.4923 5.98516 13.6875 5.98516C14.7133 5.98516 15.3398 6.62979 15.3398 7.65565C15.3398 8.87317 14.6481 9.51781 14.6481 9.94721C14.6481 10.14 14.768 10.2567 15.0057 10.2567C15.9609 10.2567 17.082 9.15909 17.082 7.60853C17.082 6.10509 15.7735 5 13.5783 5C9.95033 5 6.72607 8.36346 6.72607 13.0172C6.72607 16.6195 8.78313 19 11.9571 19C15.3258 19 17.2737 15.6483 17.2737 14.5604C17.2737 14.3194 17.1506 14.2091 17.0221 14.2091Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_1737_5849",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                        fill: "white"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "#7D2AE7"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint0_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint1_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint2_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint3_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.4538 13.656C15.3878 13.656 15.3297 13.7118 15.2692 13.8338C14.5864 15.2204 13.4071 16.2016 12.0425 16.2016C10.4645 16.2016 9.48736 14.775 9.48736 12.804C9.48736 9.4655 11.3446 7.53522 12.9759 7.53522C13.7382 7.53522 14.2037 8.015 14.2037 8.77851C14.2037 9.68467 13.6897 10.1645 13.6897 10.484C13.6897 10.6275 13.7788 10.7144 13.9554 10.7144C14.6652 10.7144 15.4983 9.89747 15.4983 8.74344C15.4983 7.62448 14.526 6.802 12.8947 6.802C10.1988 6.802 7.8028 9.30531 7.8028 12.769C7.8028 15.45 9.3314 17.2217 11.69 17.2217C14.1933 17.2217 15.6408 14.7271 15.6408 13.9174C15.6408 13.7381 15.5493 13.656 15.4538 13.656Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint0_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.0906 18.2033) rotate(-49.4602) scale(12.3858 12.3828)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint1_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.23576 5.82176) rotate(54.7452) scale(13.9692 13.962)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint2_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.09053 18.2032) rotate(-45.2401) scale(12.2345 5.62672)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint3_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.5432 6.15916) rotate(66.5525) scale(12.6133 21.1075)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#00C4CC",
                                stopOpacity: "0.725916"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.0001",
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a554317b561c7bd7$export$2e2bcd8739ae039 = $a554317b561c7bd7$var$CanvaIcon;

});

parcelRegister("aE2ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $510fd2cf4d1169b9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $510fd2cf4d1169b9$var$DocusignIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-115.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.0826 15.0417V18.6075C15.0826 18.7948 14.9308 18.946 14.7429 18.946H5.3397C5.15178 18.946 5 18.7948 5 18.6075V9.24286C5 9.05557 5.15178 8.9043 5.3397 8.9043H8.91017V14.7031C8.91017 14.8904 9.06195 15.0417 9.24987 15.0417H15.0826Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19 10.0137C19 13.0104 17.2437 15.0346 15.0826 15.0418V11.2671C15.0826 11.159 15.0393 11.051 14.9598 10.979L12.9938 9.0196C12.9143 8.94036 12.8131 8.89714 12.7047 8.89714H8.91742V5.33859C8.91742 5.15129 9.0692 5.00002 9.25712 5.00002H14.555C17.0702 4.99282 19 7.00981 19 10.0137Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14.9598 10.9717C15.0393 11.051 15.0826 11.1518 15.0826 11.2599V15.0345H9.25712C9.0692 15.0345 8.91742 14.8832 8.91742 14.6959V8.89709H12.7047C12.8131 8.89709 12.9215 8.94032 12.9938 9.01955L14.9598 10.9717Z",
                fill: "black"
            })
        ]
    });
};
var $510fd2cf4d1169b9$export$2e2bcd8739ae039 = $510fd2cf4d1169b9$var$DocusignIcon;

});

parcelRegister("aEezf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c030499494bf77cd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $c030499494bf77cd$var$DovetailIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-747.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 13.8484C5.74119 13.8676 5.74119 13.9156 5.77446 13.9349L8.90847 15.7448C8.93934 15.7626 8.95836 15.7956 8.95836 15.8312V19.4501C8.95836 19.4885 8.99997 19.5125 9.03327 19.4933L12.1673 17.6834C12.1981 17.6656 12.2172 17.6326 12.2172 17.597V13.9492C12.2172 13.9136 12.1981 13.8806 12.1672 13.8628L8.95836 12.0106L5.77446 13.8484Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 6.32257C5.74119 6.3418 5.74119 6.38983 5.77446 6.40903L8.90847 8.21896C8.93934 8.23681 8.95836 8.26975 8.95836 8.30542V12.0108L12.2172 10.1288V6.42346C12.2172 6.38779 12.1981 6.35482 12.1672 6.33697L9.00828 4.51363C8.97741 4.49578 8.93934 4.49578 8.90847 4.51363L5.77446 6.32257Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2173 10.1281L15.4261 11.9813C15.457 11.9991 15.4761 12.0321 15.4761 12.0678V15.6866C15.4761 15.7251 15.5177 15.7491 15.5509 15.7299L18.6849 13.9199C18.7158 13.9021 18.7348 13.8691 18.7348 13.8335V10.1858C18.7348 10.1501 18.7158 10.1171 18.6849 10.0993L15.526 8.27594C15.4951 8.25812 15.457 8.25812 15.4261 8.27594L12.2173 10.1281Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.72 4H5.28C4.57308 4 4 4.57308 4 5.28V18.72C4 19.4269 4.57308 20 5.28 20H18.72C19.4269 20 20 19.4269 20 18.72V5.28C20 4.57308 19.4269 4 18.72 4Z",
                fill: "#0C0020"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.8497 13.2323C7.82752 13.2451 7.82752 13.2771 7.8497 13.2899L9.93904 14.4965C9.95962 14.5084 9.9723 14.5304 9.9723 14.5542V16.9667C9.9723 16.9924 10 17.0084 10.0222 16.9955L12.1116 15.7889C12.1321 15.777 12.1448 15.7551 12.1448 15.7313V13.2995C12.1448 13.2757 12.1321 13.2537 12.1115 13.2419L9.9723 12.0071L7.8497 13.2323Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.8497 8.21489C7.82752 8.22771 7.82752 8.25973 7.8497 8.27253L9.93904 9.47915C9.95962 9.49104 9.9723 9.513 9.9723 9.53678V12.007L12.1448 10.7524V8.28214C12.1448 8.25836 12.1321 8.23638 12.1115 8.22449L10.0056 7.00893C9.985 6.99702 9.95962 6.99702 9.93904 7.00893L7.8497 8.21489Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1448 10.7523L14.2841 11.9877C14.3047 11.9996 14.3174 12.0216 14.3174 12.0453V14.4579C14.3174 14.4835 14.3451 14.4995 14.3673 14.4867L16.4566 13.2801C16.4772 13.2682 16.4899 13.2463 16.4899 13.2225V10.7907C16.4899 10.7669 16.4772 10.7449 16.4566 10.733L14.3506 9.51745C14.33 9.50557 14.3047 9.50557 14.2841 9.51745L12.1448 10.7523Z",
                fill: "white"
            })
        ]
    });
};
var $c030499494bf77cd$export$2e2bcd8739ae039 = $c030499494bf77cd$var$DovetailIcon;

});

parcelRegister("049D0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e47bcf30851bb3ab$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $e47bcf30851bb3ab$var$DropboxIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0061FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.0098 8.48964L8.24219 10.8931L12.0098 13.2965L8.24219 15.7L4.47461 13.2836L8.24219 10.8801L4.47461 8.48964L8.24219 6.08618L12.0098 8.48964ZM8.2227 16.473L11.9903 14.0695L15.7579 16.473L11.9903 18.8765L8.2227 16.473ZM12.0098 13.2836L15.7773 10.8801L12.0098 8.48964L15.7579 6.08618L19.5254 8.48964L15.7579 10.8931L19.5254 13.2965L15.7579 15.7L12.0098 13.2836Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43 40",
        version: "1.1",
        height: "24px",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
            fill: "#007EE5"
        })
    });
};
var $e47bcf30851bb3ab$export$2e2bcd8739ae039 = $e47bcf30851bb3ab$var$DropboxIcon;

});

parcelRegister("1twqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5b3b0e8c55e688$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $eb5b3b0e8c55e688$var$FigmaIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M12 12C12 11.337 12.254 10.7011 12.7061 10.2322C13.1582 9.76339 13.7714 9.5 14.4107 9.5C15.0501 9.5 15.6633 9.76339 16.1153 10.2322C16.5674 10.7011 16.8214 11.337 16.8214 12C16.8214 12.663 16.5674 13.2989 16.1153 13.7678C15.6633 14.2366 15.0501 14.5 14.4107 14.5C13.7714 14.5 13.1582 14.2366 12.7061 13.7678C12.254 13.2989 12 12.663 12 12Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M7.17871 17C7.17871 16.337 7.4327 15.7011 7.88479 15.2322C8.33689 14.7634 8.95006 14.5 9.58943 14.5H12.0001V17C12.0001 17.663 11.7462 18.2989 11.2941 18.7678C10.842 19.2366 10.2288 19.5 9.58943 19.5C8.95006 19.5 8.33689 19.2366 7.88479 18.7678C7.4327 18.2989 7.17871 17.663 7.17871 17V17Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M12 4.5V9.5H14.4107C15.0501 9.5 15.6633 9.23661 16.1153 8.76777C16.5674 8.29893 16.8214 7.66304 16.8214 7C16.8214 6.33696 16.5674 5.70107 16.1153 5.23223C15.6633 4.76339 15.0501 4.5 14.4107 4.5H12Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M7.17871 7C7.17871 7.66304 7.4327 8.29893 7.88479 8.76777C8.33689 9.23661 8.95006 9.5 9.58943 9.5H12.0001V4.5H9.58943C8.95006 4.5 8.33689 4.76339 7.88479 5.23223C7.4327 5.70107 7.17871 6.33696 7.17871 7V7Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M7.17871 12C7.17871 12.663 7.4327 13.2989 7.88479 13.7678C8.33689 14.2366 8.95006 14.5 9.58943 14.5H12.0001V9.5H9.58943C8.95006 9.5 8.33689 9.76339 7.88479 10.2322C7.4327 10.7011 7.17871 11.337 7.17871 12V12Z",
                        fill: "#A259FF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_7_728)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M9.22776 20C10.6998 20 11.8944 18.8053 11.8944 17.3333V14.6666H9.22776C7.75576 14.6666 6.5611 15.8613 6.5611 17.3333C6.5611 18.8053 7.75576 20 9.22776 20Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M6.5611 12C6.5611 10.528 7.75576 9.33337 9.22776 9.33337H11.8944V14.6667H9.22776C7.75576 14.6667 6.5611 13.472 6.5611 12Z",
                        fill: "#A259FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M6.5611 6.66667C6.5611 5.19467 7.75576 4 9.22776 4H11.8944V9.33333H9.22776C7.75576 9.33333 6.5611 8.13867 6.5611 6.66667Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M11.8943 4H14.561C16.033 4 17.2277 5.19467 17.2277 6.66667C17.2277 8.13867 16.033 9.33333 14.561 9.33333H11.8943V4Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M17.2277 12C17.2277 13.472 16.033 14.6667 14.561 14.6667C13.089 14.6667 11.8943 13.472 11.8943 12C11.8943 10.528 13.089 9.33337 14.561 9.33337C16.033 9.33337 17.2277 10.528 17.2277 12Z",
                        fill: "#1ABCFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_7_728",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
};
var $eb5b3b0e8c55e688$export$2e2bcd8739ae039 = $eb5b3b0e8c55e688$var$FigmaIcon;

});

parcelRegister("6kGiZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $59075bd03bcf906a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $59075bd03bcf906a$var$FreshserviceIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-683.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#09C6FA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14.6954 4.25008C15.7025 4.25008 16.7099 4.25338 17.7183 4.25008C18.2271 4.24619 18.6802 4.38244 19.0651 4.72054C19.4877 5.09067 19.7328 5.55604 19.7349 6.11783C19.7436 8.16046 19.767 10.2037 19.7289 12.2454C19.6945 14.0838 19.0364 15.7066 17.8236 17.091C16.5561 18.5389 14.9606 19.4014 13.0546 19.6709C11.5776 19.8805 10.1533 19.6736 8.79837 19.0498C6.90652 18.179 5.57016 16.7631 4.79229 14.8358C4.32449 13.676 4.16198 12.4628 4.29456 11.2138C4.46875 9.57492 5.09668 8.1346 6.17833 6.89283C7.22587 5.69708 8.52271 4.90171 10.0581 4.49714C10.7129 4.32786 11.3871 4.2451 12.0634 4.25098C12.9401 4.25158 13.8175 4.25128 14.6954 4.25008ZM13.1971 11.1482C12.6063 11.1482 12.0155 11.1464 11.4247 11.15C11.322 11.15 11.2897 11.1323 11.3274 11.0221C11.4729 10.5945 11.6099 10.1642 11.7503 9.73443C11.895 9.29243 12.0394 8.85042 12.1837 8.40841C12.2211 8.29372 12.1837 8.20089 12.084 8.14459C11.9844 8.08829 11.8838 8.10895 11.8087 8.20268C11.7668 8.25509 11.7291 8.31079 11.689 8.36529C11.0002 9.32517 10.3118 10.2847 9.62382 11.244C9.34987 11.6257 9.07501 12.0067 8.79926 12.3868C8.76505 12.4287 8.74371 12.4796 8.73781 12.5334C8.73192 12.5872 8.74172 12.6415 8.76604 12.6898C8.81722 12.8 8.9115 12.842 9.02673 12.8464C9.07581 12.8482 9.1252 12.8479 9.17428 12.8479H12.5042C12.7054 12.8479 12.709 12.8479 12.6449 13.0456C12.3744 13.8747 12.1026 14.7032 11.8296 15.5311C11.7802 15.6809 11.8036 15.7737 11.9113 15.8336C12.0191 15.8935 12.1128 15.8677 12.2106 15.7437C12.2247 15.7264 12.2376 15.7081 12.2507 15.6898C13.2284 14.3369 14.2055 12.9839 15.182 11.6309C15.2554 11.5294 15.2919 11.4237 15.2299 11.3063C15.168 11.1889 15.0626 11.1461 14.9288 11.1467C14.3518 11.1503 13.7745 11.1482 13.1971 11.1482Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M14.7823 4.00008C15.822 4.00008 16.8619 4.00348 17.9027 4.00008C18.428 3.99606 18.8957 4.13672 19.293 4.48571C19.7293 4.86779 19.9823 5.34817 19.9844 5.92808C19.9934 8.0366 20.0175 10.1457 19.9783 12.2533C19.9427 14.151 19.2634 15.8262 18.0115 17.2552C16.7031 18.7499 15.0561 19.6401 13.0887 19.9183C11.564 20.1347 10.0937 19.9211 8.69509 19.2772C6.74221 18.3783 5.36275 16.9168 4.55979 14.9272C4.0769 13.73 3.90914 12.4778 4.046 11.1884C4.22581 9.49669 4.87399 8.00991 5.99053 6.72809C7.07186 5.49376 8.41054 4.67273 9.99546 4.25511C10.6714 4.08037 11.3673 3.99494 12.0654 4.00101C12.9704 4.00163 13.8761 4.00132 14.7823 4.00008ZM13.2357 11.1207C12.6259 11.1207 12.016 11.1189 11.4061 11.1226C11.3002 11.1226 11.2668 11.1043 11.3057 10.9906C11.4559 10.5491 11.5974 10.1049 11.7423 9.66135C11.8916 9.20508 12.0407 8.74882 12.1896 8.29256C12.2282 8.17416 12.1896 8.07833 12.0867 8.02022C11.9839 7.9621 11.8801 7.98343 11.8025 8.08019C11.7593 8.13428 11.7203 8.19178 11.6789 8.24804C10.9679 9.23888 10.2573 10.2294 9.54717 11.2196C9.26438 11.6137 8.98066 12.0069 8.69601 12.3992C8.6607 12.4425 8.63867 12.4951 8.63258 12.5506C8.6265 12.6061 8.63662 12.6622 8.66172 12.7121C8.71455 12.8258 8.81187 12.8691 8.93082 12.8737C8.98148 12.8756 9.03246 12.8753 9.08313 12.8753H12.5205C12.7281 12.8753 12.7318 12.8753 12.6657 13.0793C12.3864 13.9352 12.1059 14.7904 11.8241 15.645C11.7732 15.7996 11.7973 15.8954 11.9085 15.9572C12.0197 16.0191 12.1164 15.9925 12.2174 15.8645C12.232 15.8466 12.2452 15.8277 12.2588 15.8089C13.2681 14.4122 14.2767 13.0156 15.2847 11.619C15.3604 11.5142 15.3981 11.4051 15.3341 11.2839C15.2702 11.1628 15.1614 11.1186 15.0233 11.1192C14.4277 11.1229 13.8317 11.1207 13.2357 11.1207Z",
            fill: "#09C6FA"
        })
    });
};
var $59075bd03bcf906a$export$2e2bcd8739ae039 = $59075bd03bcf906a$var$FreshserviceIcon;

});

parcelRegister("gXv8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6cd7bec85675d7a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $f6cd7bec85675d7a$var$GmailIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M5.52273 17.625H7.90909V11.8295L4.5 9.27271V16.6023C4.5 17.1682 4.95852 17.625 5.52273 17.625Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M16.0908 17.625H18.4772C19.0431 17.625 19.4999 17.1665 19.4999 16.6023V9.27271L16.0908 11.8295",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M16.0908 7.3977V11.8295L19.4999 9.2727V7.90906C19.4999 6.64429 18.0562 5.92327 17.0454 6.68179",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M7.90918 11.8295V7.39771L12.0001 10.4659L16.091 7.39771V11.8295L12.0001 14.8977",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M4.5 7.90931V9.27294L7.90909 11.8298V7.39794L6.95455 6.68203C5.94205 5.92351 4.5 6.64453 4.5 7.90931Z",
                        fill: "#C5221F"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "37 37 115 80",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#4285f4",
                d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#34a853",
                d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#fbbc04",
                d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#ea4335",
                d: "M72 74V48l24 18 24-18v26L96 92"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#c5221f",
                d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
            })
        ]
    });
};
var $f6cd7bec85675d7a$export$2e2bcd8739ae039 = $f6cd7bec85675d7a$var$GmailIcon;

});

parcelRegister("AiWrx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a7f03646dfa3741$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

const $2a7f03646dfa3741$var$GithubIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_6309_146339)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.0001 0C4.47791 0 0 4.59039 0 10.2532C0 14.7833 2.86533 18.6266 6.83867 19.9824C7.33844 20.0773 7.52192 19.76 7.52192 19.4891C7.52192 19.2446 7.51265 18.437 7.50834 17.5802C4.72631 18.2005 4.13927 16.3705 4.13927 16.3705C3.68437 15.1854 3.02894 14.8702 3.02894 14.8702C2.12163 14.2339 3.09733 14.2469 3.09733 14.2469C4.10151 14.3193 4.63026 15.3035 4.63026 15.3035C5.52217 16.871 6.96965 16.4178 7.5403 16.1559C7.63006 15.4932 7.88921 15.0409 8.1752 14.7848C5.95404 14.5256 3.61912 13.6464 3.61912 9.71766C3.61912 8.59825 4.00977 7.6836 4.64947 6.96556C4.54564 6.70731 4.20335 5.66448 4.74635 4.25218C4.74635 4.25218 5.58609 3.97661 7.49708 5.30317C8.29476 5.07599 9.15024 4.96206 10.0001 4.95816C10.8499 4.96206 11.7061 5.07599 12.5052 5.30317C14.4139 3.97661 15.2525 4.25218 15.2525 4.25218C15.7968 5.66448 15.4544 6.70731 15.3505 6.96556C15.9917 7.6836 16.3797 8.59825 16.3797 9.71766C16.3797 13.6557 14.0403 14.5228 11.8135 14.7767C12.1722 15.0949 12.4918 15.7188 12.4918 16.6754C12.4918 18.0473 12.4802 19.1514 12.4802 19.4891C12.4802 19.762 12.6602 20.0817 13.1671 19.981C17.1383 18.6237 20 14.7818 20 10.2532C20 4.59039 15.5227 0 10.0001 0Z",
                        fill: `var(--ds-icon, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_6309_146339",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: `var(--ds-icon, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
                    })
                })
            })
        ]
    });
};
var $2a7f03646dfa3741$export$2e2bcd8739ae039 = $2a7f03646dfa3741$var$GithubIcon;

});

parcelRegister("4B1q6", function(module, exports) {

$parcel$export(module.exports, "default", () => $10b87ab7f87d0930$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $10b87ab7f87d0930$var$GitlabIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-587.5",
                y: "-363.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.7331 10.3948L19.7115 10.3373L17.5339 4.65705C17.4898 4.54552 17.4114 4.4509 17.31 4.3869C17.2343 4.33846 17.1483 4.30842 17.059 4.29919C16.9696 4.28996 16.8793 4.30179 16.7953 4.33375C16.7113 4.3657 16.636 4.41688 16.5754 4.4832C16.5147 4.54951 16.4705 4.6291 16.4461 4.7156L14.9763 9.21564H9.02381L7.55392 4.7156C7.5294 4.62923 7.48504 4.54979 7.42438 4.4836C7.36371 4.41742 7.28842 4.36632 7.20451 4.3344C7.1206 4.30247 7.03039 4.29059 6.94107 4.2997C6.85175 4.30882 6.7658 4.33868 6.69007 4.3869C6.58865 4.4509 6.51022 4.54552 6.46615 4.65705L4.28957 10.3383L4.26697 10.3948C3.95361 11.2138 3.91501 12.1125 4.15698 12.9553C4.39895 13.7981 4.90838 14.5394 5.60846 15.0674L5.61668 15.0736L5.63517 15.088L8.94779 17.5706L10.5913 18.8125L11.5897 19.5675C11.7068 19.656 11.8496 19.7038 11.9964 19.7038C12.1432 19.7038 12.2861 19.656 12.4032 19.5675L13.4016 18.8125L15.0451 17.5706L18.3813 15.0736L18.3906 15.0664C19.0906 14.5386 19.6001 13.7975 19.8423 12.9549C20.0844 12.1123 20.0461 11.2138 19.7331 10.3948Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.7329 10.3948L19.7114 10.3373C18.6504 10.555 17.6507 11.0047 16.7839 11.6541L12.0024 15.2698L15.047 17.5706L18.3832 15.0736L18.3925 15.0664C19.0922 14.5383 19.6012 13.7971 19.843 12.9545C20.0848 12.1119 20.0462 11.2135 19.7329 10.3948Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.94775 17.5708L10.5912 18.8126L11.5896 19.5676C11.7068 19.6561 11.8496 19.7039 11.9964 19.7039C12.1432 19.7039 12.286 19.6561 12.4032 19.5676L13.4016 18.8126L15.045 17.5708L12.0005 15.2699L8.94775 17.5708Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.21598 11.6541C6.34952 11.005 5.35016 10.5556 4.28957 10.3383L4.26697 10.3948C3.95361 11.2137 3.91501 12.1124 4.15698 12.9552C4.39895 13.798 4.90838 14.5393 5.60846 15.0674L5.61668 15.0735L5.63517 15.0879L8.94779 17.5706L11.9944 15.2697L7.21598 11.6541Z",
                fill: "#FC6D26"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.7331 11.0987L19.7115 11.0412L17.5339 5.36091C17.4898 5.24937 17.4114 5.15476 17.31 5.09076C17.2343 5.04232 17.1483 5.01228 17.059 5.00304C16.9696 4.99381 16.8793 5.00565 16.7953 5.0376C16.7113 5.06956 16.636 5.12074 16.5754 5.18705C16.5147 5.25337 16.4705 5.33296 16.4461 5.41946L14.9763 9.91949H9.02381L7.55392 5.41946C7.5294 5.33309 7.48504 5.25364 7.42438 5.18746C7.36371 5.12127 7.28842 5.07018 7.20451 5.03825C7.1206 5.00632 7.03039 4.99444 6.94107 5.00356C6.85175 5.01268 6.7658 5.04254 6.69007 5.09076C6.58865 5.15476 6.51023 5.24937 6.46615 5.36091L4.28957 11.0422L4.26697 11.0987C3.95361 11.9177 3.91501 12.8163 4.15698 13.6591C4.39895 14.502 4.90838 15.2433 5.60846 15.7713L5.61668 15.7775L5.63517 15.7918L8.9478 18.2745L10.5913 19.5164L11.5897 20.2713C11.7068 20.3598 11.8496 20.4077 11.9964 20.4077C12.1432 20.4077 12.2861 20.3598 12.4032 20.2713L13.4016 19.5164L15.0451 18.2745L18.3813 15.7775L18.3906 15.7703C19.0906 15.2424 19.6001 14.5014 19.8423 13.6588C20.0844 12.8161 20.0461 11.9176 19.7331 11.0987Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.7331 11.0987L19.7115 11.0411C18.6505 11.2589 17.6508 11.7085 16.784 12.358L12.0026 15.9736L15.0471 18.2745L18.3833 15.7774L18.3926 15.7702C19.0923 15.2421 19.6014 14.501 19.8431 13.6583C20.0849 12.8157 20.0463 11.9174 19.7331 11.0987Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.94781 18.2745L10.5913 19.5163L11.5897 20.2713C11.7068 20.3598 11.8496 20.4077 11.9965 20.4077C12.1433 20.4077 12.2861 20.3598 12.4032 20.2713L13.4016 19.5163L15.0451 18.2745L12.0006 15.9736L8.94781 18.2745Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.21598 12.358C6.34952 11.7089 5.35016 11.2596 4.28957 11.0422L4.26697 11.0987C3.95361 11.9177 3.91501 12.8164 4.15698 13.6592C4.39895 14.502 4.90838 15.2433 5.60846 15.7713L5.61668 15.7775L5.63517 15.7919L8.9478 18.2745L11.9944 15.9737L7.21598 12.358Z",
                fill: "#FC6D26"
            })
        ]
    });
};
var $10b87ab7f87d0930$export$2e2bcd8739ae039 = $10b87ab7f87d0930$var$GitlabIcon;

});

parcelRegister("hflpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $555de31a28b44bcb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $555de31a28b44bcb$var$GoogleCalendarIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-124.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M15.8208 8.17936L12.3822 7.7973L8.17949 8.17936L7.79736 12.0001L8.17942 15.8207L12.0001 16.2983L15.8208 15.8207L16.2029 11.9046L15.8208 8.17936Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M9.74654 14.1071C9.46096 13.9142 9.26322 13.6324 9.15527 13.2599L9.81819 12.9867C9.87837 13.216 9.98341 13.3936 10.1334 13.5197C10.2824 13.6458 10.4639 13.7079 10.6759 13.7079C10.8928 13.7079 11.079 13.642 11.2347 13.5101C11.3903 13.3783 11.4687 13.2102 11.4687 13.0068C11.4687 12.7986 11.3866 12.6285 11.2223 12.4967C11.058 12.365 10.8517 12.299 10.6052 12.299H10.2222V11.6428H10.566C10.7781 11.6428 10.9567 11.5856 11.1019 11.4709C11.2471 11.3563 11.3197 11.1997 11.3197 11C11.3197 10.8224 11.2547 10.681 11.1249 10.575C10.995 10.469 10.8306 10.4155 10.631 10.4155C10.4362 10.4155 10.2814 10.4671 10.1668 10.5712C10.0522 10.6753 9.96904 10.8033 9.91655 10.9542L9.26039 10.681C9.34728 10.4346 9.50684 10.2168 9.74081 10.0287C9.97484 9.8405 10.2738 9.74591 10.6367 9.74591C10.9051 9.74591 11.1468 9.79752 11.3608 9.90162C11.5747 10.0057 11.7428 10.15 11.8641 10.3333C11.9854 10.5176 12.0456 10.724 12.0456 10.9532C12.0456 11.1872 11.9893 11.3849 11.8766 11.5473C11.7638 11.7097 11.6253 11.8338 11.461 11.9208V11.9599C11.6779 12.0507 11.8546 12.1892 11.994 12.3754C12.1325 12.5617 12.2022 12.7843 12.2022 13.0441C12.2022 13.3039 12.1363 13.536 12.0045 13.7394C11.8726 13.9429 11.6902 14.1034 11.4591 14.2199C11.227 14.3364 10.9662 14.3956 10.6768 14.3956C10.3416 14.3966 10.0321 14.3001 9.74654 14.1071Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M13.8145 10.8175L13.0905 11.3438L12.7266 10.7917L14.0323 9.84991H14.5328V14.2924H13.8145V10.8175Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M15.8208 19.2592L19.2593 15.8206L17.54 15.0565L15.8208 15.8206L15.0566 17.5399L15.8208 19.2592Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M7.41504 17.54L8.17915 19.2593H15.8205V15.8207H8.17915L7.41504 17.54Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M5.88689 4.74078C5.25366 4.74078 4.74072 5.25372 4.74072 5.88695V15.8207L6.46001 16.5848L8.17929 15.8207V8.17935H15.8206L16.5847 6.46007L15.8207 4.74078H5.88689Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M4.74072 15.8207V18.1131C4.74072 18.7464 5.25366 19.2593 5.88689 19.2593H8.17929V15.8207H4.74072Z",
                        fill: "#188038"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M15.8203 8.17945V15.8208H19.2589V8.17945L17.5396 7.41534L15.8203 8.17945Z",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M19.2589 8.17929V5.88689C19.2589 5.25359 18.7459 4.74072 18.1127 4.74072H15.8203V8.17929H19.2589Z",
                        fill: "#1967D2"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-label": "Google Calendar",
        viewBox: "50 50 410 410 ",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#4285f4",
                d: "M100 340h74V174h166v-74H137q-37 0-37 35"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#1967d2",
                d: "M338 100v76h74v-41q0-35-35-35"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#fbbc04",
                d: "M338 174h74v164h-74"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#188038",
                d: "M100 338v39q0 35 35 35h41v-74"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#34a853",
                d: "M174 338h164v74H174"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#ea4335",
                d: "M338 412v-74h74"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "none",
                stroke: "#4285f4",
                strokeLinejoin: "bevel",
                strokeWidth: 15,
                d: "M204 229a25 22 1 1 1 25 27h-9 9a25 22 1 1 1-25 27m66-52 27-19h4v-7 103"
            })
        ]
    });
};
var $555de31a28b44bcb$export$2e2bcd8739ae039 = $555de31a28b44bcb$var$GoogleCalendarIcon;

});

parcelRegister("7IBsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8defc7042f7940e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $b8defc7042f7940e$var$HubSpotFilterIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-587.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FF5C35"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
            fill: "#FF5C35"
        })
    });
};
var $b8defc7042f7940e$export$2e2bcd8739ae039 = $b8defc7042f7940e$var$HubSpotFilterIcon;

});

parcelRegister("a1mh2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6906f5ed28873a67$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

const $6906f5ed28873a67$var$LucidIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-587.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
            fill: `var(--ds-icon, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
        })
    });
};
var $6906f5ed28873a67$export$2e2bcd8739ae039 = $6906f5ed28873a67$var$LucidIcon;

});

parcelRegister("8gEJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4f739738a0e453c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $e4f739738a0e453c$var$LoomIcon = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "#5753F3"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
var $e4f739738a0e453c$export$2e2bcd8739ae039 = $e4f739738a0e453c$var$LoomIcon;

});

parcelRegister("aDJD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9053bc28b9060cd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $b9053bc28b9060cd$var$MiroIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0122 5.5H13.1097L14.6951 8.28547L11.2073 5.5H9.30491L11.0488 8.90456L7.40244 5.5H5.5L7.40244 9.83362L5.5 18.5H7.40244L11.0488 9.21453L9.30491 18.5H11.2073L14.6951 8.59544L13.1097 18.5H15.0122L18.5 7.6664L15.0122 5.5Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M4 8C4 5.79086 5.79086 4 8 4H16C18.2092 4 20 5.79086 20 8V16C20 18.2091 18.2092 20 16 20H8C5.79086 20 4 18.2091 4 16V8Z",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.6372 7.05002H13.1848L14.3951 9.17662L11.7323 7.05002H10.2799L11.6113 9.64927L8.82744 7.05002H7.375L8.82744 10.3586L7.375 16.975H8.82744L11.6113 9.88592L10.2799 16.975H11.7323L14.3951 9.41327L13.1848 16.975H14.6372L17.3 8.70398L14.6372 7.05002Z",
                fill: "black"
            })
        ]
    });
};
var $b9053bc28b9060cd$export$2e2bcd8739ae039 = $b9053bc28b9060cd$var$MiroIcon;

});

parcelRegister("5c1Lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc2e94b7cb0a85db$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $cc2e94b7cb0a85db$var$MondayIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.36594 16.7731C6.03435 16.7738 5.70851 16.6807 5.42172 16.5032C5.13492 16.3257 4.89744 16.0701 4.73354 15.7627C4.57214 15.4574 4.49165 15.111 4.50068 14.7606C4.50972 14.4103 4.60793 14.0691 4.78482 13.7738L8.14648 8.14287C8.31854 7.84024 8.56281 7.59175 8.85436 7.42277C9.14592 7.2538 9.47429 7.1704 9.80595 7.18109C10.1373 7.18956 10.4607 7.2918 10.7429 7.47734C11.0251 7.66289 11.256 7.92507 11.412 8.23707C11.7254 8.86914 11.6862 9.6296 11.3109 10.2229L7.95133 15.8538C7.78097 16.137 7.54634 16.3697 7.2692 16.5304C6.99206 16.6911 6.68137 16.7746 6.36594 16.7731Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.1321 16.7728C11.454 16.7728 10.8301 16.3861 10.5025 15.7647C10.3415 15.4602 10.2612 15.1148 10.2702 14.7653C10.2793 14.4159 10.3773 14.0756 10.5538 13.7811L13.9091 8.16313C14.0786 7.85625 14.322 7.60333 14.614 7.43061C14.9061 7.25789 15.2361 7.17165 15.5699 7.18084C16.2537 7.19679 16.8733 7.60475 17.1867 8.2429C17.4979 8.88105 17.4523 9.64607 17.0656 10.2379L13.7111 15.8559C13.5412 16.1378 13.3075 16.3696 13.0316 16.5299C12.7556 16.6901 12.4463 16.7737 12.1321 16.7728Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.7693 16.82C18.7251 16.82 19.4999 16.0108 19.4999 15.0126C19.4999 14.0145 18.7251 13.2053 17.7693 13.2053C16.8134 13.2053 16.0386 14.0145 16.0386 15.0126C16.0386 16.0108 16.8134 16.82 17.7693 16.82Z",
                fill: "#00CA72"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M5.99034 16.9904C5.63664 16.9912 5.28909 16.8981 4.98317 16.7205C4.67725 16.543 4.42393 16.2875 4.24911 15.98C4.07695 15.6747 3.99109 15.3283 4.00073 14.978C4.01037 14.6276 4.11513 14.2865 4.3038 13.9911L7.88959 8.36021C8.07311 8.05759 8.33368 7.80909 8.64467 7.64012C8.95566 7.47115 9.30592 7.38774 9.65969 7.39843C10.0132 7.40691 10.3581 7.50914 10.6591 7.69469C10.9601 7.88023 11.2064 8.14242 11.3728 8.45442C11.7071 9.08649 11.6653 9.84695 11.2649 10.4403L7.68143 16.0712C7.49971 16.3543 7.24944 16.5871 6.95382 16.7478C6.6582 16.9084 6.3268 16.9919 5.99034 16.9904Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.1409 16.9902C11.4177 16.9902 10.7522 16.6035 10.4027 15.9821C10.2309 15.6776 10.1453 15.3322 10.1549 14.9827C10.1645 14.6333 10.2691 14.2931 10.4574 13.9985L14.0363 8.38054C14.2172 8.07366 14.4768 7.82074 14.7883 7.64802C15.0998 7.47529 15.4519 7.38906 15.808 7.39825C16.5373 7.4142 17.1982 7.82216 17.5325 8.46031C17.8645 9.09846 17.8159 9.86347 17.4033 10.4553L13.8251 16.0733C13.644 16.3552 13.3947 16.587 13.1004 16.7473C12.806 16.9075 12.476 16.9911 12.1409 16.9902Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.154 17.0374C19.1736 17.0374 20.0001 16.2282 20.0001 15.2301C20.0001 14.2319 19.1736 13.4227 18.154 13.4227C17.1344 13.4227 16.3079 14.2319 16.3079 15.2301C16.3079 16.2282 17.1344 17.0374 18.154 17.0374Z",
                fill: "#00CA72"
            })
        ]
    });
};
var $cc2e94b7cb0a85db$export$2e2bcd8739ae039 = $cc2e94b7cb0a85db$var$MondayIcon;

});

parcelRegister("j6OsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e09f30bd08eb01$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $a9e09f30bd08eb01$var$MuralIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.6754 16.1763C12.6757 14.0134 12.6843 11.8504 12.6739 9.68758C12.6654 7.94483 13.8929 6.44038 15.5576 6.08234C15.8132 6.02736 16.0709 5.99181 16.3335 6.00416C16.3754 6.06652 16.3699 6.13777 16.3701 6.20736C16.3708 6.83713 16.371 7.46704 16.3698 8.09681C16.3696 8.17062 16.3803 8.24819 16.3276 8.31236C15.8848 8.32742 15.5243 8.50576 15.2565 8.86034C15.089 9.08221 14.9992 9.3339 14.9928 9.61332C14.9914 9.67342 14.9908 9.73352 14.9908 9.79377C14.9908 11.8638 14.9908 13.9339 14.9905 16.0039C14.9905 16.0639 14.9863 16.1238 14.9842 16.1839C14.9391 16.2353 14.8769 16.2339 14.8176 16.2342C14.1625 16.2368 13.5073 16.2368 12.8522 16.2342C12.7888 16.2339 12.7197 16.2401 12.6755 16.1763H12.6754Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.9958 9.66997C19.997 9.7251 19.9991 9.78023 19.9991 9.83536C19.9992 12.6608 19.9994 15.4861 19.9988 18.3115C19.9988 18.5251 20.0262 18.4962 19.8174 18.4965C19.1651 18.4977 18.5127 18.497 17.8602 18.497C17.8251 18.497 17.7899 18.4955 17.7548 18.497C17.7016 18.4992 17.684 18.4709 17.6862 18.4226C17.6871 18.4025 17.6862 18.3825 17.6862 18.3623C17.6865 15.4716 17.6867 12.5811 17.687 9.69046C17.687 9.68548 17.6874 9.68036 17.6876 9.67539C17.7236 9.6043 17.7918 9.60324 17.8563 9.60294C18.5111 9.59948 19.1658 9.59963 19.8206 9.60249C19.8869 9.60279 19.9509 9.61213 19.9956 9.66982L19.9958 9.66997Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.31589 9.65845C6.31815 9.71343 6.32222 9.76841 6.32222 9.82339C6.32252 12.6568 6.32267 15.4902 6.32222 18.3237C6.32222 18.5291 6.34511 18.5007 6.1493 18.501C5.48729 18.502 4.82529 18.502 4.16344 18.5002C4.11208 18.5002 4.05183 18.5251 4.01025 18.4692C4.02758 18.4151 4.01538 18.3598 4.01538 18.3053C4.01628 15.4761 4.01613 12.6469 4.01613 9.81781C4.01613 9.61688 4.02682 9.60212 4.22535 9.60121C4.85738 9.5985 5.4894 9.59941 6.12143 9.60106C6.19072 9.60121 6.26407 9.59579 6.31604 9.65845H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.3296 18.485C11.282 18.508 11.2309 18.499 11.1813 18.4991C10.5242 18.5006 9.86683 18.5014 9.20965 18.5021C9.1845 18.5021 9.15949 18.5029 9.13434 18.502C9.06545 18.4995 9.02985 18.4615 9.02754 18.3881C9.02709 18.373 9.02754 18.358 9.02754 18.3429C9.02754 15.4932 9.02754 12.6434 9.02769 9.79368C9.02769 9.74864 9.03101 9.70361 9.03282 9.65842C9.08463 9.59651 9.15738 9.60103 9.22667 9.60073C9.86141 9.59907 10.4961 9.59907 11.1309 9.60073C11.2003 9.60088 11.2728 9.59711 11.3247 9.65857C11.3267 9.72364 11.3305 9.78871 11.3305 9.85378C11.3308 11.899 11.3306 13.9442 11.3311 15.9892C11.3311 16.0542 11.3234 16.1197 11.3409 16.1837C11.3704 16.2444 11.3702 16.3096 11.3702 16.3748C11.3704 17.0109 11.371 17.647 11.3696 18.283C11.3696 18.3521 11.3782 18.4246 11.3296 18.4847V18.485Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.3247 9.65883C10.5607 9.65883 9.79675 9.65883 9.03263 9.65868C9.00822 9.44901 8.97343 9.24296 8.87477 9.05166C8.60861 8.53577 8.0406 8.24174 7.47124 8.32896C6.89584 8.41707 6.43884 8.87166 6.34515 9.45007C6.33401 9.5192 6.32557 9.58879 6.31593 9.65823C5.60302 9.65823 4.89011 9.65793 4.17719 9.65778C4.15716 9.65778 4.13682 9.65944 4.11694 9.65763C4.04795 9.65145 4.01226 9.67751 4.01753 9.75132C4.02039 9.79123 4.01783 9.8316 4.01783 9.87182C4.01783 12.6882 4.01783 15.5048 4.01753 18.3212C4.01753 18.3709 4.01286 18.4206 4.01015 18.4697C3.99267 18.4307 4.00307 18.3902 4.00307 18.351C4.00231 15.501 4.00201 12.6509 4.00277 9.80087C4.00277 9.28513 4.06874 8.77888 4.27389 8.30139C4.8172 7.03749 5.76675 6.26101 7.12404 6.04561C9.03022 5.74301 10.8088 6.97166 11.247 8.85389C11.3084 9.11794 11.3462 9.38605 11.3246 9.65883H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.3295 18.4854C11.3295 17.7731 11.3295 17.0608 11.3299 16.3486C11.3299 16.2938 11.3216 16.2382 11.3408 16.1844C11.7857 16.1819 12.2307 16.1793 12.6756 16.1768C12.7253 16.1795 12.7752 16.1844 12.8249 16.1844C13.5447 16.1849 14.2644 16.1846 14.9843 16.1844C14.9865 16.2343 14.9909 16.2843 14.9909 16.3342C14.9913 16.9954 14.9912 17.6568 14.9912 18.3181C14.9912 18.3532 14.99 18.3883 14.9909 18.4232C14.9921 18.4723 14.9705 18.4981 14.9201 18.4975C14.885 18.4972 14.8499 18.4982 14.8149 18.4982C13.7077 18.4982 12.6006 18.4982 11.4933 18.4981C11.4385 18.4981 11.3829 18.5051 11.3296 18.4853L11.3295 18.4854Z",
                fill: "#FFAA00"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.6756 16.1765C12.6759 14.0137 12.6845 11.8507 12.6741 9.68782C12.6657 7.94507 13.8931 6.44062 15.5579 6.08258C15.8135 6.0276 16.0712 5.99206 16.3337 6.00441C16.3756 6.06677 16.3702 6.13801 16.3703 6.2076C16.3711 6.83737 16.3712 7.46729 16.37 8.09706C16.3699 8.17086 16.3806 8.24844 16.3279 8.3126C15.885 8.32766 15.5246 8.50601 15.2568 8.86058C15.0893 9.08245 14.9995 9.33415 14.993 9.61356C14.9916 9.67366 14.991 9.73376 14.991 9.79401C14.991 11.8641 14.991 13.9341 14.9907 16.0042C14.9907 16.0641 14.9865 16.1241 14.9844 16.1842C14.9394 16.2355 14.8772 16.2342 14.8178 16.2345C14.1628 16.237 13.5075 16.237 12.8525 16.2345C12.789 16.2342 12.7199 16.2404 12.6758 16.1765H12.6756Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.9958 9.67021C19.997 9.72534 19.9991 9.78047 19.9991 9.8356C19.9992 12.661 19.9994 15.4863 19.9988 18.3118C19.9988 18.5254 20.0262 18.4965 19.8174 18.4968C19.1651 18.498 18.5127 18.4972 17.8602 18.4972C17.8251 18.4972 17.7899 18.4957 17.7548 18.4972C17.7016 18.4995 17.684 18.4712 17.6862 18.4228C17.6871 18.4028 17.6862 18.3827 17.6862 18.3625C17.6865 15.4719 17.6867 12.5814 17.687 9.6907C17.687 9.68573 17.6874 9.68061 17.6876 9.67564C17.7236 9.60454 17.7918 9.60349 17.8563 9.60319C18.5111 9.59972 19.1658 9.59987 19.8206 9.60273C19.8869 9.60303 19.9509 9.61237 19.9956 9.67006L19.9958 9.67021Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.31589 9.65857C6.31815 9.71355 6.32222 9.76853 6.32222 9.82351C6.32252 12.6569 6.32267 15.4904 6.32222 18.3238C6.32222 18.5292 6.34511 18.5008 6.1493 18.5011C5.48729 18.5021 4.82529 18.5021 4.16344 18.5003C4.11208 18.5003 4.05183 18.5252 4.01025 18.4693C4.02758 18.4152 4.01538 18.3599 4.01538 18.3054C4.01628 15.4762 4.01613 12.647 4.01613 9.81794C4.01613 9.617 4.02682 9.60224 4.22535 9.60133C4.85738 9.59862 5.4894 9.59953 6.12143 9.60118C6.19072 9.60133 6.26407 9.59591 6.31604 9.65857H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.3293 18.4851C11.2817 18.5081 11.2307 18.4991 11.1811 18.4992C10.5239 18.5008 9.86659 18.5015 9.20941 18.5023C9.18425 18.5023 9.15925 18.503 9.13409 18.5021C9.06521 18.4996 9.02961 18.4616 9.0273 18.3882C9.02685 18.3732 9.0273 18.3581 9.0273 18.343C9.0273 15.4933 9.0273 12.6435 9.02745 9.7938C9.02745 9.74877 9.03076 9.70373 9.03257 9.65854C9.08439 9.59663 9.15714 9.60115 9.22643 9.60085C9.86117 9.5992 10.4959 9.5992 11.1306 9.60085C11.2001 9.601 11.2725 9.59724 11.3245 9.65869C11.3265 9.72376 11.3302 9.78883 11.3302 9.8539C11.3305 11.8991 11.3304 13.9443 11.3308 15.9894C11.3308 16.0543 11.3231 16.1198 11.3406 16.1838C11.3701 16.2445 11.37 16.3097 11.37 16.375C11.3701 17.0111 11.3707 17.6472 11.3694 18.2831C11.3694 18.3522 11.378 18.4247 11.3293 18.4848V18.4851Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.3247 9.65896C10.5607 9.65896 9.79675 9.65896 9.03263 9.65881C9.00822 9.44913 8.97343 9.24308 8.87477 9.05178C8.60861 8.53589 8.0406 8.24187 7.47124 8.32908C6.89584 8.41719 6.43884 8.87178 6.34515 9.45019C6.33401 9.51933 6.32557 9.58891 6.31593 9.65835C5.60302 9.65835 4.89011 9.65805 4.17719 9.6579C4.15716 9.6579 4.13682 9.65956 4.11694 9.65775C4.04795 9.65158 4.01226 9.67763 4.01753 9.75144C4.02039 9.79136 4.01783 9.83172 4.01783 9.87194C4.01783 12.6883 4.01783 15.5049 4.01753 18.3213C4.01753 18.371 4.01286 18.4207 4.01015 18.4698C3.99267 18.4308 4.00307 18.3903 4.00307 18.3511C4.00231 15.5011 4.00201 12.651 4.00277 9.801C4.00277 9.28525 4.06874 8.779 4.27389 8.30151C4.8172 7.03761 5.76675 6.26113 7.12404 6.04574C9.03022 5.74313 10.8088 6.97179 11.247 8.85401C11.3084 9.11806 11.3462 9.38617 11.3246 9.65896H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.3293 18.4856C11.3293 17.7733 11.3293 17.061 11.3298 16.3489C11.3298 16.294 11.3215 16.2385 11.3406 16.1847C11.7856 16.1821 12.2305 16.1796 12.6755 16.177C12.7252 16.1797 12.775 16.1847 12.8248 16.1847C13.5446 16.1851 14.2643 16.1848 14.9841 16.1847C14.9864 16.2345 14.9908 16.2845 14.9908 16.3344C14.9912 16.9957 14.9911 17.6571 14.9911 18.3183C14.9911 18.3534 14.9899 18.3885 14.9908 18.4234C14.992 18.4725 14.9704 18.4983 14.92 18.4977C14.8849 18.4974 14.8498 18.4985 14.8148 18.4985C13.7076 18.4985 12.6005 18.4985 11.4932 18.4983C11.4384 18.4983 11.3828 18.5054 11.3295 18.4855L11.3293 18.4856Z",
                fill: "#FFAA00"
            })
        ]
    });
};
var $a9e09f30bd08eb01$export$2e2bcd8739ae039 = $a9e09f30bd08eb01$var$MuralIcon;

});

parcelRegister("eoM0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b149638847a622$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $b1b149638847a622$var$NotionIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-683.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M5.72382 5.14736L14.0236 4.53432C15.0431 4.44687 15.305 4.50582 15.9461 4.97186L18.5955 6.83828C19.0325 7.15927 19.178 7.24672 19.178 7.59621V17.8325C19.178 18.474 18.945 18.8535 18.1295 18.9114L8.49127 19.4952C7.87928 19.5241 7.58784 19.4367 7.26729 19.0282L5.31628 16.4912C4.96634 16.0243 4.82129 15.6748 4.82129 15.2662V6.16734C4.82129 5.6428 5.05423 5.20541 5.72382 5.14736Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0236 4.53447L5.72382 5.14751C5.05423 5.20541 4.82129 5.64295 4.82129 6.16734V15.2662C4.82129 15.6746 4.96634 16.0241 5.31628 16.4912L7.26729 19.0281C7.58784 19.4365 7.87928 19.5241 8.49127 19.495L18.1296 18.9115C18.9446 18.8535 19.1781 18.474 19.1781 17.8326V7.59636C19.1781 7.26487 19.0472 7.16932 18.6617 6.88643L15.9461 4.97186C15.3052 4.50582 15.0431 4.44687 14.0236 4.53432V4.53447ZM8.70921 7.42882C7.92218 7.48177 7.74368 7.49377 7.29669 7.13032L6.16031 6.22644C6.04482 6.10944 6.10286 5.96349 6.39386 5.9344L14.3727 5.35136C15.0427 5.29286 15.3916 5.5264 15.6536 5.7304L17.0221 6.72188C17.0806 6.75143 17.2261 6.92588 17.051 6.92588L8.81121 7.42192L8.70921 7.42882ZM7.79168 17.7452V9.05539C7.79168 8.67589 7.90823 8.50085 8.25712 8.47145L17.721 7.91736C18.042 7.88841 18.1871 8.0924 18.1871 8.4713V17.1032C18.1871 17.4827 18.1286 17.8037 17.6046 17.8326L8.54827 18.3576C8.02433 18.3866 7.79183 18.2121 7.79183 17.7452H7.79168ZM16.7315 9.52128C16.7896 9.78377 16.7315 10.0463 16.469 10.0763L16.0325 10.1628V16.5786C15.6535 16.7826 15.3046 16.8992 15.013 16.8992C14.547 16.8992 14.4306 16.7532 14.0815 16.3161L11.2271 11.8252V16.1702L12.13 16.3746C12.13 16.3746 12.13 16.8996 11.4015 16.8996L9.39305 17.0162C9.33455 16.8992 9.39305 16.6077 9.5966 16.5497L10.1211 16.4042V10.6593L9.3932 10.6004C9.3347 10.3379 9.4802 9.95882 9.88819 9.92942L12.0432 9.78437L15.0131 14.3333V10.3089L14.2561 10.2219C14.1976 9.90047 14.4306 9.66692 14.7215 9.63842L16.7315 9.52128Z",
                fill: "#292A2E"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M5.8801 5.63103L13.9736 5.03323C14.9678 4.94796 15.2232 5.00544 15.8483 5.4599L18.4319 7.27992C18.858 7.59294 18.9999 7.67822 18.9999 8.01902V18.0009C18.9999 18.6265 18.7727 18.9965 17.9774 19.053L8.57877 19.6223C7.98199 19.6505 7.69779 19.5652 7.38521 19.1669L5.48269 16.6929C5.14144 16.2376 5 15.8968 5 15.4983V6.62566C5 6.11416 5.22716 5.68764 5.8801 5.63103Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.9736 5.03338L5.8801 5.63118C5.22716 5.68764 5 6.11431 5 6.62566V15.4983C5 15.8966 5.14144 16.2374 5.48269 16.6929L7.38521 19.1668C7.69779 19.5651 7.98199 19.6505 8.57877 19.6221L17.9776 19.0531C18.7723 18.9965 19 18.6265 19 18.001V8.01917C19 7.69591 18.8723 7.60274 18.4964 7.32688L15.8483 5.4599C15.2233 5.00544 14.9678 4.94796 13.9736 5.03323V5.03338ZM8.7913 7.85579C8.02382 7.90742 7.84976 7.91912 7.41388 7.56471L6.30574 6.68329C6.19312 6.5692 6.24972 6.42688 6.53349 6.39851L14.314 5.82996C14.9674 5.77291 15.3076 6.00066 15.5631 6.19958L16.8975 7.16642C16.9546 7.19524 17.0965 7.36535 16.9258 7.36535L8.89076 7.84906L8.7913 7.85579ZM7.89657 17.9157V9.44193C7.89657 9.07187 8.01022 8.90117 8.35044 8.8725L17.5791 8.33218C17.8922 8.30395 18.0336 8.50288 18.0336 8.87236V17.2897C18.0336 17.6598 17.9766 17.9728 17.4656 18.001L8.63435 18.513C8.12343 18.5412 7.89671 18.3711 7.89671 17.9157H7.89657ZM16.6142 9.89624C16.6708 10.1522 16.6142 10.4082 16.3582 10.4374L15.9326 10.5218V16.7782C15.563 16.9771 15.2227 17.0908 14.9384 17.0908C14.4839 17.0908 14.3704 16.9485 14.0301 16.5222L11.2466 12.1429V16.3799L12.1271 16.5793C12.1271 16.5793 12.1271 17.0912 11.4167 17.0912L9.45814 17.2049C9.40109 17.0908 9.45814 16.8066 9.65662 16.75L10.1681 16.6081V11.006L9.45828 10.9485C9.40124 10.6925 9.54312 10.3229 9.94097 10.2942L12.0424 10.1528L14.9385 14.5887V10.6643L14.2003 10.5795C14.1433 10.266 14.3704 10.0383 14.6542 10.0105L16.6142 9.89624Z",
                fill: "black"
            })
        ]
    });
};
var $b1b149638847a622$export$2e2bcd8739ae039 = $b1b149638847a622$var$NotionIcon;

});

parcelRegister("4I6wX", function(module, exports) {

$parcel$export(module.exports, "default", () => $573cbc48906e5ba6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $573cbc48906e5ba6$var$OutlookCalendarIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M27.7358 17.053C27.8457 16.7078 27.9334 16.3558 27.9983 15.9993C27.9984 15.821 27.903 15.6557 27.7486 15.5666L27.7389 15.5613L27.7358 15.5599L19.6078 10.9297C19.5728 10.907 19.5364 10.8861 19.4991 10.8674C19.1844 10.7114 18.8141 10.7114 18.4994 10.8674C18.4621 10.8861 18.4258 10.9069 18.3906 10.9297L10.2627 15.5599L10.2597 15.5613L10.2498 15.5666C10.0955 15.6557 10.0001 15.821 10.0002 15.9993C10.0652 16.3558 10.1529 16.7078 10.2627 17.053L18.8811 23.3563L27.7358 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M21.9988 7.74982H16.7491L15.2334 9.99982L16.7491 12.2496L21.9988 16.7493H26.4985V12.2496L21.9988 7.74982Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 7.74982H16.7493V12.2495H11.4996V7.74982Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 7.74982H26.4986V12.2495H21.9989V7.74982Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M21.999 16.7492L16.7493 12.2496H11.4996V16.7492L16.7493 21.249L24.8728 22.5749L21.999 16.7492Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7492H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 16.7493H16.7493V21.2489H11.4996V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 16.7493H26.4986V21.2489H21.9989V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4628L10.6678 15.8111C10.6678 15.8111 18.7261 20.4008 18.849 20.4698C18.9509 20.5107 19.0654 20.5075 19.1648 20.4608C19.2795 20.3963 27.3632 15.7886 27.3632 15.7886L27.7352 16.4403L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M27.7488 16.4321L27.7391 16.4381L27.7368 16.4396L19.6089 21.0699C19.2809 21.2813 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2843C27.8269 26.0732 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1777 27.9047 16.3431 27.7503 16.4321H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M27.9985 25.3738V24.8204L20.5117 20.5546L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.8262 26.0723 27.9993 25.7333 27.9993 25.3731L27.9985 25.3738Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M27.9611 25.661L19.7543 20.9858L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.7443 26.1312 27.8954 25.911 27.9618 25.6603L27.9611 25.661Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.2621 16.4419V16.4344H10.2547L10.2321 16.4195C10.0866 16.3299 9.99823 16.1703 9.99965 15.9995V25.3754C9.99965 25.9916 10.5068 26.4988 11.1232 26.4988H26.8737C26.9673 26.4978 27.0606 26.4853 27.1511 26.4613C27.1982 26.4531 27.2437 26.4379 27.2862 26.4163C27.3021 26.4147 27.3174 26.4096 27.3311 26.4013C27.3925 26.3762 27.4505 26.3435 27.5036 26.3037L27.5336 26.2813L10.2621 16.4419Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.4992 22.4993V10.2503C17.4976 9.70247 17.0473 9.25225 16.4995 9.25061H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V23.5019V23.4989H16.4995C17.0473 23.4973 17.4976 23.047 17.4992 22.4993Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M16.7493 23.2491V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V24.2519V24.2489H15.7496C16.2973 24.2472 16.7477 23.797 16.7493 23.2491ZM16.7493 21.7493V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H15.7496C16.2973 22.7473 16.7477 22.2971 16.7493 21.7493ZM15.9993 21.7493V11.0002C15.9977 10.4525 15.5475 10.0022 14.9997 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H14.9997C15.5475 22.7473 15.9977 22.2971 15.9993 21.7493Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.90014 14.1005C7.16577 13.5344 7.59472 13.0606 8.13155 12.7401C8.72643 12.3995 9.40377 12.2299 10.089 12.2497C10.7236 12.2357 11.35 12.3966 11.8993 12.7146C12.4163 13.0225 12.8327 13.4741 13.0977 14.0143C13.3864 14.6095 13.5304 15.2645 13.5177 15.9259C13.5318 16.6172 13.3835 17.3023 13.085 17.9261C12.8142 18.4854 12.3852 18.9533 11.8513 19.2715C11.2806 19.5995 10.6308 19.7648 9.97268 19.7492C9.32435 19.7646 8.6841 19.6019 8.12185 19.2789C7.60083 18.9705 7.17941 18.5185 6.90843 17.977C6.61792 17.3903 6.47228 16.7425 6.48395 16.0879C6.47108 15.4025 6.61366 14.7231 6.9009 14.1005H6.90014ZM8.2125 17.2938C8.35421 17.6517 8.59454 17.9623 8.90555 18.1892C9.22203 18.4109 9.60145 18.5252 9.98763 18.5155C10.3991 18.5318 10.8048 18.4138 11.1433 18.1795C11.4505 17.9526 11.6845 17.6404 11.8161 17.2818C11.964 16.8821 12.0369 16.4585 12.0313 16.0324C12.0359 15.6026 11.9674 15.1749 11.8289 14.768C11.7067 14.4017 11.4811 14.0783 11.1793 13.8374C10.8498 13.5913 10.4452 13.4662 10.0342 13.4834C9.63963 13.4731 9.2517 13.5881 8.9265 13.8118C8.6097 14.0395 8.36403 14.3527 8.2185 14.7148C7.89668 15.5438 7.89483 16.4636 8.21326 17.2938H8.2125Z",
                fill: "white"
            })
        ]
    });
};
var $573cbc48906e5ba6$export$2e2bcd8739ae039 = $573cbc48906e5ba6$var$OutlookCalendarIcon;

});

parcelRegister("38KKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c907ec72a8023c9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $3c907ec72a8023c9$var$OutlookMailIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M27.7361 17.053C27.8459 16.7078 27.9336 16.3558 27.9985 15.9993C27.9986 15.821 27.9033 15.6557 27.7488 15.5666L27.7391 15.5613L27.7361 15.5599L19.608 10.9297C19.573 10.907 19.5367 10.8861 19.4994 10.8674C19.1846 10.7114 18.8144 10.7114 18.4997 10.8674C18.4623 10.8861 18.426 10.9069 18.3909 10.9297L10.263 15.5599L10.2599 15.5613L10.2501 15.5666C10.0957 15.6557 10.0004 15.821 10.0005 15.9993C10.0654 16.3558 10.1531 16.7078 10.263 17.053L18.8814 23.3563L27.7361 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M21.999 7.74976H16.7494L15.2336 9.99976L16.7494 12.2495L21.999 16.7492H26.4987V12.2495L21.999 7.74976Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4995 7.74976H16.7492V12.2494H11.4995V7.74976Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.999 7.74976H26.4987V12.2494H21.999V7.74976Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M21.9989 16.7493L16.7492 12.2496H11.4995V16.7493L16.7492 21.2491L24.8726 22.575L21.9989 16.7493Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7493H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4995 16.7493H16.7492V21.2489H11.4995V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.999 16.7493H26.4987V21.2489H21.999V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4629L10.6678 15.8112C10.6678 15.8112 18.7261 20.4008 18.849 20.4699C18.9509 20.5108 19.0654 20.5075 19.1648 20.4608C19.2795 20.3964 27.3632 15.7887 27.3632 15.7887L27.7352 16.4404L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M27.7488 16.4322L27.7391 16.4382L27.7368 16.4397L19.6089 21.0699C19.2809 21.2814 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2844C27.8269 26.0733 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1778 27.9047 16.3431 27.7503 16.4322H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M27.9985 25.3739V24.8205L20.5117 20.5547L19.608 21.0692C19.2802 21.2806 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2836C27.8262 26.0724 27.9993 25.7333 27.9993 25.3731L27.9985 25.3739Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M27.9611 25.6612L19.7543 20.986L19.608 21.0692C19.2802 21.2806 18.8648 21.3066 18.5132 21.1374L21.3442 24.933L27.5343 26.2806V26.2836C27.7443 26.1313 27.8954 25.9111 27.9618 25.6604L27.9611 25.6612Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.262 16.442V16.4345H10.2546L10.232 16.4195C10.0865 16.3299 9.99811 16.1703 9.99953 15.9995V25.3754C9.99953 25.9917 10.5067 26.4989 11.1231 26.4989H26.8736C26.9672 26.4979 27.0605 26.4853 27.151 26.4613C27.198 26.4531 27.2435 26.438 27.2861 26.4164C27.302 26.4147 27.3173 26.4096 27.331 26.4013C27.3923 26.3762 27.4504 26.3435 27.5035 26.3038L27.5335 26.2813L10.262 16.442Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.4991 22.4994V10.2504C17.4974 9.70259 17.0472 9.25237 16.4994 9.25073H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V23.502V23.499H16.4994C17.0472 23.4975 17.4974 23.0471 17.4991 22.4994Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M16.7492 23.2493V11.0003C16.7475 10.4526 16.2972 10.0024 15.7495 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V24.252V24.249H15.7495C16.2972 24.2473 16.7475 23.7971 16.7492 23.2493ZM16.7492 21.7494V11.0003C16.7475 10.4526 16.2972 10.0024 15.7495 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V22.752V22.7491H15.7495C16.2972 22.7474 16.7475 22.2972 16.7492 21.7494ZM15.9992 21.7494V11.0003C15.9975 10.4526 15.5473 10.0024 14.9996 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V22.752V22.7491H14.9996C15.5473 22.7474 15.9975 22.2972 15.9992 21.7494Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M6.90014 14.1006C7.16577 13.5345 7.59472 13.0607 8.13155 12.7402C8.72643 12.3996 9.40377 12.23 10.089 12.2497C10.7236 12.2358 11.35 12.3967 11.8993 12.7147C12.4163 13.0225 12.8327 13.4742 13.0977 14.0144C13.3864 14.6096 13.5304 15.2646 13.5177 15.926C13.5318 16.6173 13.3835 17.3024 13.085 17.9262C12.8142 18.4855 12.3852 18.9534 11.8513 19.2716C11.2806 19.5996 10.6308 19.7649 9.97268 19.7493C9.32435 19.7647 8.6841 19.602 8.12185 19.279C7.60083 18.9706 7.17941 18.5185 6.90843 17.9771C6.61792 17.3904 6.47228 16.7425 6.48395 16.088C6.47108 15.4026 6.61366 14.7231 6.9009 14.1006H6.90014ZM8.2125 17.2939C8.35421 17.6518 8.59454 17.9624 8.90555 18.1893C9.22203 18.411 9.60145 18.5253 9.98763 18.5156C10.3991 18.5318 10.8048 18.4139 11.1433 18.1796C11.4505 17.9527 11.6845 17.6404 11.8161 17.2819C11.964 16.8822 12.0369 16.4586 12.0313 16.0324C12.0359 15.6026 11.9674 15.175 11.8289 14.7681C11.7067 14.4018 11.4811 14.0784 11.1793 13.8374C10.8498 13.5913 10.4452 13.4663 10.0342 13.4834C9.63963 13.4732 9.2517 13.5882 8.9265 13.8119C8.6097 14.0396 8.36403 14.3528 8.2185 14.7148C7.89668 15.5438 7.89483 16.4637 8.21326 17.2939H8.2125Z",
                fill: "white"
            })
        ]
    });
};
var $3c907ec72a8023c9$export$2e2bcd8739ae039 = $3c907ec72a8023c9$var$OutlookMailIcon;

});

parcelRegister("3jKSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97ce0e3116fe9ba$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $b97ce0e3116fe9ba$var$PipedriveIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-635.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#017737"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.2336 10.1635C10.2336 11.5838 10.9541 13.1159 12.5396 13.1159C13.7154 13.1159 14.9043 12.198 14.9043 10.1427C14.9043 8.34075 13.9697 7.13106 12.5787 7.13106C11.4453 7.13106 10.2336 7.92728 10.2336 10.1635ZM13.1373 4.5C15.9802 4.5 17.8917 6.75159 17.8917 10.1032C17.8917 13.4022 15.878 15.7053 12.9993 15.7053C11.6268 15.7053 10.7476 15.1175 10.2879 14.6919C10.2912 14.7928 10.2933 14.9058 10.2933 15.0264V19.5H7.34834V7.58072C7.34834 7.40743 7.29292 7.3526 7.12122 7.3526H6.1084V4.74238H8.5796C9.71739 4.74238 10.0086 5.32145 10.0641 5.76782C10.5259 5.25017 11.4833 4.5 13.1373 4.5Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M10.4002 10.0411C10.4002 11.556 11.1687 13.1903 12.8599 13.1903C14.1142 13.1903 15.3823 12.2112 15.3823 10.0189C15.3823 8.0968 14.3854 6.80647 12.9017 6.80647C11.6927 6.80647 10.4002 7.65577 10.4002 10.0411ZM13.4975 4C16.5299 4 18.5688 6.4017 18.5688 9.97675C18.5688 13.4957 16.4209 15.9523 13.3503 15.9523C11.8862 15.9523 10.9485 15.3253 10.4582 14.8714C10.4616 14.979 10.4639 15.0995 10.4639 15.2282V20H7.32261V7.2861C7.32261 7.10126 7.26349 7.04278 7.08034 7.04278H6V4.25854H8.63594C9.84959 4.25854 10.1602 4.87621 10.2194 5.35234C10.712 4.80018 11.7332 4 13.4975 4Z",
            fill: "#017737"
        })
    });
};
var $b97ce0e3116fe9ba$export$2e2bcd8739ae039 = $b97ce0e3116fe9ba$var$PipedriveIcon;

});

parcelRegister("4JSYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a30a7a8f1d55ec$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $55a30a7a8f1d55ec$var$SalesforceIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M3 5.71326H21V18.2868H3V5.71326Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                mask: "url(#mask0_719_13847)",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.4738 7.08983C11.0548 6.48497 11.8635 6.11041 12.7569 6.11041C13.9481 6.11041 14.9804 6.77218 15.5363 7.75821C16.0297 7.53763 16.5642 7.42374 17.1047 7.42402C19.2488 7.42402 20.9892 9.17769 20.9892 11.3417C20.9892 13.5056 19.2488 15.2593 17.1047 15.2593C16.8426 15.2593 16.5872 15.233 16.337 15.1832C15.8506 16.0501 14.9209 16.6391 13.862 16.6391C13.431 16.6399 13.0054 16.5422 12.6179 16.3532C12.1249 17.5113 10.9767 18.3253 9.63998 18.3253C8.24366 18.3253 7.0591 17.4451 6.60248 16.2076C6.39925 16.2505 6.1921 16.2721 5.98439 16.2719C4.32336 16.2719 2.97998 14.9087 2.97998 13.2344C2.97998 12.1094 3.58483 11.13 4.48219 10.6006C4.29181 10.1621 4.19382 9.689 4.19432 9.21091C4.19432 7.27856 5.7627 5.7168 7.69505 5.7168C8.82667 5.7168 9.83917 6.25614 10.4745 7.09327",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6037 12.2516C5.59239 12.2812 5.60774 12.2873 5.61138 12.2925C5.64519 12.317 5.67954 12.3348 5.71395 12.3547C5.89792 12.452 6.07131 12.4804 6.25263 12.4804C6.62189 12.4804 6.85153 12.2839 6.85153 11.9675V11.9613C6.85153 11.6688 6.59211 11.5623 6.34991 11.4862L6.31821 11.4759C6.1349 11.4165 5.97674 11.3647 5.97674 11.2443V11.2381C5.97674 11.1349 6.06939 11.0588 6.21233 11.0588C6.37115 11.0588 6.56042 11.1117 6.68152 11.1786C6.68152 11.1786 6.71739 11.2018 6.73042 11.1671C6.7375 11.1484 6.79925 10.9832 6.80586 10.9646C6.81288 10.9453 6.80057 10.9306 6.78793 10.9231C6.64896 10.8384 6.45705 10.7808 6.25852 10.7808L6.22166 10.7809C5.8835 10.7809 5.64725 10.9854 5.64725 11.2779V11.2842C5.64725 11.5926 5.90798 11.6932 6.15151 11.7627L6.19069 11.7748C6.36804 11.8294 6.52157 11.8768 6.52157 12.0012V12.0074C6.52157 12.1219 6.42164 12.2072 6.2615 12.2072C6.19922 12.2072 6.00076 12.2062 5.78569 12.0703C5.75968 12.0551 5.74486 12.0442 5.72481 12.0319C5.71422 12.0255 5.68775 12.0139 5.67623 12.0486L5.60344 12.2511M11.0101 12.2511C10.9987 12.2806 11.0141 12.2868 11.0179 12.292C11.0515 12.3165 11.086 12.3342 11.1204 12.3541C11.3044 12.4514 11.4778 12.4799 11.6591 12.4799C12.0284 12.4799 12.258 12.2833 12.258 11.967V11.9608C12.258 11.6683 11.9993 11.5618 11.7564 11.4856L11.7247 11.4754C11.5414 11.416 11.3832 11.3642 11.3832 11.2438V11.2376C11.3832 11.1344 11.4759 11.0583 11.6188 11.0583C11.7776 11.0583 11.9662 11.1112 12.088 11.1781C12.088 11.1781 12.1239 11.2012 12.137 11.1666C12.144 11.1479 12.2058 10.9826 12.2118 10.9641C12.2188 10.9447 12.2065 10.9301 12.1939 10.9226C12.0549 10.8378 11.863 10.7803 11.6645 10.7803L11.6275 10.7804C11.2894 10.7804 11.0531 10.9849 11.0531 11.2774V11.2837C11.0531 11.5921 11.3139 11.6926 11.5574 11.7621L11.5965 11.7743C11.7745 11.8288 11.9274 11.8762 11.9274 12.0006V12.0069C11.9274 12.1213 11.8275 12.2067 11.6673 12.2067C11.6049 12.2067 11.4059 12.2056 11.1915 12.0697C11.1655 12.0546 11.1503 12.0441 11.1306 12.0314C11.1239 12.0272 11.0927 12.015 11.0821 12.0481L11.0093 12.2506M14.7019 11.6312C14.7019 11.8098 14.6686 11.9508 14.6033 12.0507C14.5382 12.1493 14.4398 12.1976 14.3029 12.1976C14.1659 12.1976 14.0679 12.1497 14.0037 12.0514C13.9391 11.9521 13.9065 11.8105 13.9065 11.6318C13.9065 11.4532 13.9393 11.3129 14.0037 11.2143C14.0678 11.1163 14.1652 11.0693 14.3029 11.0693C14.4405 11.0693 14.5385 11.1168 14.6033 11.2143C14.669 11.3129 14.7019 11.4532 14.7019 11.6318M15.0103 11.3003C14.9799 11.1977 14.9329 11.1077 14.87 11.0323C14.8071 10.9568 14.7277 10.8959 14.6331 10.8523C14.5391 10.8083 14.4279 10.7861 14.3022 10.7861C14.1765 10.7861 14.066 10.8084 13.9713 10.8523C13.8773 10.8962 13.7973 10.9568 13.7344 11.0323C13.6717 11.1077 13.6246 11.1977 13.5941 11.3003C13.564 11.4022 13.5487 11.5134 13.5487 11.6318C13.5487 11.7503 13.564 11.8615 13.5941 11.9634C13.6244 12.0659 13.6715 12.1559 13.7344 12.2314C13.7973 12.3068 13.8773 12.3671 13.9713 12.4101C14.066 12.4529 14.1771 12.4748 14.3022 12.4748C14.4273 12.4748 14.5385 12.4529 14.6324 12.4101C14.7264 12.3672 14.8065 12.3068 14.8693 12.2314C14.9321 12.1559 14.9792 12.0659 15.0096 11.9634C15.0397 11.8615 15.055 11.7503 15.055 11.6318C15.055 11.514 15.0397 11.4022 15.0096 11.3003M17.5442 12.1473C17.5341 12.1174 17.5048 12.1287 17.5048 12.1287C17.46 12.1458 17.4122 12.1617 17.3612 12.1696C17.3099 12.1777 17.2527 12.1818 17.1925 12.1818C17.0436 12.1818 16.9244 12.1374 16.8397 12.0494C16.7544 11.9614 16.7067 11.8198 16.7074 11.6279C16.7078 11.4532 16.7501 11.3221 16.8258 11.2215C16.9006 11.1223 17.0158 11.0707 17.168 11.0707C17.295 11.0707 17.3923 11.0854 17.4942 11.1173C17.4942 11.1173 17.5184 11.1278 17.53 11.096C17.557 11.0212 17.577 10.9676 17.6061 10.8856C17.6143 10.8621 17.5942 10.8521 17.5868 10.8493C17.5468 10.8337 17.4525 10.8081 17.381 10.7973C17.3142 10.7871 17.2367 10.7818 17.1494 10.7818C17.0197 10.7818 16.9045 10.804 16.8059 10.8479C16.7073 10.8918 16.6239 10.9525 16.5578 11.0279C16.4916 11.1033 16.4413 11.1933 16.4075 11.2959C16.3741 11.3978 16.3572 11.5097 16.3572 11.6281C16.3572 11.8836 16.4261 12.0907 16.5624 12.2422C16.6987 12.3944 16.9039 12.4712 17.1712 12.4712C17.3294 12.4712 17.4915 12.4393 17.608 12.3931C17.608 12.3931 17.6302 12.3824 17.6206 12.3565L17.5445 12.1473M18.0838 11.4591C18.0985 11.3598 18.1257 11.2771 18.1685 11.2129C18.2325 11.115 18.33 11.0614 18.467 11.0614C18.6039 11.0614 18.6946 11.1153 18.7595 11.2129C18.8025 11.2775 18.8213 11.3632 18.8283 11.4591L18.0805 11.459L18.0838 11.4591ZM19.1228 11.2407C19.0965 11.1421 19.0314 11.0422 18.9891 10.9965C18.9216 10.9244 18.8561 10.8734 18.7906 10.8457C18.696 10.8054 18.5942 10.7848 18.4914 10.785C18.3611 10.785 18.2426 10.807 18.1467 10.8518C18.0507 10.8969 17.97 10.9584 17.9064 11.0351C17.843 11.1119 17.7953 11.2025 17.7648 11.3064C17.7344 11.409 17.719 11.5215 17.719 11.6393C17.719 11.7598 17.735 11.8716 17.7663 11.9728C17.798 12.0748 17.8491 12.1641 17.9179 12.2382C17.9867 12.313 18.0747 12.3712 18.1806 12.4123C18.2858 12.4529 18.4135 12.4741 18.5598 12.4736C18.8616 12.4726 19.0204 12.4054 19.0852 12.369C19.0968 12.3626 19.1077 12.3514 19.0941 12.3191L19.0259 12.1279C19.0155 12.0994 18.9866 12.1097 18.9866 12.1097C18.9119 12.1376 18.806 12.1878 18.5578 12.1871C18.3957 12.1869 18.2759 12.139 18.2005 12.064C18.1237 11.9873 18.0853 11.8754 18.0794 11.7166L19.1249 11.7174C19.1249 11.7174 19.1525 11.7171 19.1553 11.6903C19.1564 11.6791 19.1911 11.4759 19.1242 11.2409L19.1228 11.2407ZM9.7257 11.4591C9.74046 11.3598 9.76772 11.2771 9.81041 11.2129C9.87447 11.115 9.97188 11.0614 10.1089 11.0614C10.2458 11.0614 10.3365 11.1153 10.4014 11.2129C10.4443 11.2775 10.4631 11.3632 10.4702 11.4591L9.72239 11.459L9.7257 11.4591ZM10.7647 11.2407C10.7385 11.1421 10.6733 11.0422 10.631 10.9965C10.5635 10.9244 10.498 10.8734 10.4325 10.8457C10.3379 10.8054 10.2361 10.7848 10.1333 10.785C10.003 10.785 9.88453 10.807 9.78857 10.8518C9.69261 10.8969 9.61188 10.9584 9.54835 11.0351C9.48502 11.1119 9.43717 11.2025 9.40673 11.3064C9.37636 11.409 9.36107 11.5215 9.36107 11.6393C9.36107 11.7598 9.37689 11.8716 9.40845 11.9728C9.44008 12.0748 9.49117 12.1641 9.55933 12.2382C9.62816 12.313 9.71617 12.3712 9.82206 12.4123C9.92728 12.4529 10.0543 12.4741 10.2012 12.4736C10.503 12.4726 10.6618 12.4054 10.7267 12.369C10.7382 12.3626 10.7492 12.3514 10.7355 12.3191L10.6673 12.1279C10.6568 12.0994 10.628 12.1097 10.628 12.1097C10.5532 12.1376 10.4473 12.1878 10.1991 12.1871C10.0377 12.1869 9.91722 12.139 9.84178 12.064C9.76501 11.9873 9.72663 11.8754 9.72067 11.7166L10.7663 11.7174C10.7663 11.7174 10.7938 11.7171 10.7966 11.6903C10.7978 11.6791 10.8324 11.4759 10.7654 11.2409L10.7647 11.2407ZM7.46908 12.1407C7.42812 12.108 7.42243 12.1 7.40886 12.0788C7.38815 12.0468 7.37756 12.0014 7.37756 11.9431C7.37756 11.8518 7.408 11.7856 7.47087 11.7413C7.47021 11.7414 7.56087 11.6632 7.77396 11.6658C7.86881 11.6675 7.96343 11.6756 8.05719 11.69V12.1645H8.05733C8.05733 12.1645 7.92497 12.193 7.77542 12.202C7.56299 12.2148 7.46902 12.1409 7.46968 12.1411L7.46908 12.1407ZM7.88467 11.4062C7.84232 11.4031 7.78739 11.4015 7.72188 11.4015C7.63254 11.4015 7.54585 11.4127 7.46511 11.4345C7.38372 11.4565 7.31026 11.4905 7.24739 11.5357C7.18435 11.5807 7.1325 11.6396 7.09585 11.7078C7.05886 11.7766 7.04 11.8574 7.04 11.9487C7.04 12.0413 7.05608 12.1214 7.08784 12.1869C7.11897 12.2519 7.16583 12.3081 7.22417 12.3504C7.2822 12.3926 7.35387 12.4238 7.43659 12.4424C7.51865 12.4611 7.6113 12.4706 7.71321 12.4706C7.82042 12.4706 7.92696 12.4616 8.03019 12.4441C8.11812 12.429 8.20571 12.4119 8.29292 12.3931C8.32772 12.3851 8.36637 12.3745 8.36637 12.3745C8.39218 12.368 8.3902 12.3404 8.3902 12.3404L8.3896 11.3874C8.3896 11.1783 8.33375 11.0228 8.2235 10.9269C8.11364 10.8309 7.95283 10.7826 7.74438 10.7826C7.66629 10.7826 7.53989 10.7932 7.46445 10.8083C7.46445 10.8083 7.23681 10.8525 7.14283 10.9261C7.14283 10.9261 7.12219 10.9388 7.13344 10.9676L7.20756 11.1661C7.21675 11.1919 7.24183 11.1831 7.24183 11.1831C7.24183 11.1831 7.24971 11.18 7.25897 11.1745C7.45949 11.0653 7.71361 11.0686 7.71361 11.0686C7.82611 11.0686 7.91346 11.0914 7.97169 11.1361C8.02867 11.1798 8.05772 11.246 8.05772 11.3849V11.4291C7.96839 11.4161 7.88567 11.4086 7.88567 11.4086L7.88467 11.4062ZM16.2891 10.8682C16.2906 10.8647 16.2914 10.8609 16.2914 10.8571C16.2914 10.8533 16.2907 10.8495 16.2892 10.846C16.2878 10.8425 16.2856 10.8394 16.2829 10.8367C16.2802 10.834 16.2769 10.832 16.2734 10.8306C16.2556 10.8238 16.1669 10.8051 16.0987 10.8009C15.9677 10.7926 15.8949 10.8148 15.8294 10.8441C15.7646 10.8733 15.693 10.9202 15.6533 10.9745L15.6532 10.8474C15.6532 10.83 15.6408 10.8159 15.6232 10.8159H15.3559C15.3385 10.8159 15.326 10.83 15.326 10.8474V12.4026C15.326 12.411 15.3293 12.419 15.3353 12.425C15.3412 12.4309 15.3492 12.4343 15.3577 12.4343H15.6316C15.64 12.4343 15.6481 12.4309 15.654 12.425C15.6599 12.419 15.6633 12.411 15.6633 12.4026V11.6217C15.6633 11.5171 15.6748 11.4133 15.6977 11.3477C15.7204 11.2829 15.7511 11.2313 15.7891 11.1942C15.8252 11.1584 15.8695 11.1319 15.9181 11.1168C15.9637 11.1037 16.0109 11.0971 16.0584 11.0971C16.113 11.0971 16.1729 11.1111 16.1729 11.1111C16.193 11.1133 16.2042 11.101 16.211 11.0829C16.2289 11.0352 16.2798 10.8923 16.2897 10.8639",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.1503C13.6961 10.14 13.6616 10.1319 13.6267 10.1258C13.5799 10.118 13.5324 10.1143 13.4849 10.1148C13.2961 10.1148 13.1472 10.1681 13.0427 10.2735C12.939 10.378 12.8684 10.5373 12.833 10.7469L12.8202 10.8177H12.5832C12.5832 10.8177 12.5543 10.8165 12.5482 10.848L12.5093 11.0651C12.5066 11.0859 12.5155 11.0988 12.5433 11.0987H12.774L12.5399 12.4052C12.5216 12.5104 12.5006 12.597 12.4774 12.6626C12.4545 12.7273 12.4321 12.7758 12.4046 12.811C12.3779 12.8451 12.3527 12.8702 12.309 12.8848C12.273 12.8969 12.2316 12.9025 12.1862 12.9025C12.1609 12.9025 12.1273 12.8982 12.1025 12.8933C12.0777 12.8884 12.0648 12.8828 12.0462 12.875C12.0462 12.875 12.0191 12.8647 12.0085 12.8918C11.9998 12.914 11.9383 13.0831 11.931 13.104C11.9236 13.1246 11.934 13.1409 11.9471 13.1456C11.9778 13.1566 12.0007 13.1636 12.0425 13.1735C12.1006 13.1872 12.1496 13.188 12.1954 13.188C12.2915 13.188 12.3791 13.1745 12.4517 13.1483C12.5247 13.1219 12.5883 13.0759 12.6446 13.0137C12.7054 12.9465 12.7436 12.8761 12.7802 12.7802C12.8164 12.6851 12.8473 12.567 12.8719 12.4294L13.1071 11.0987H13.451C13.451 11.0987 13.48 11.0998 13.486 11.0683L13.5249 10.8513C13.5276 10.8305 13.5187 10.8175 13.4908 10.8177H13.1571C13.1587 10.8101 13.1739 10.6927 13.2122 10.5822C13.2286 10.535 13.2593 10.497 13.2854 10.4708C13.3098 10.4459 13.3397 10.4273 13.3728 10.4164C13.4091 10.4052 13.4469 10.3998 13.4849 10.4003C13.5163 10.4003 13.5471 10.4041 13.5706 10.4089C13.603 10.4158 13.6156 10.4195 13.624 10.422C13.6581 10.4324 13.6626 10.4223 13.6693 10.4058L13.7491 10.1867C13.7573 10.1631 13.7373 10.1532 13.7299 10.1503ZM9.0662 12.408C9.0662 12.4255 9.05376 12.4397 9.03629 12.4397H8.75947C8.74193 12.4397 8.72949 12.4255 8.72949 12.408V10.18C8.72949 10.1626 8.74193 10.1485 8.75947 10.1485H9.03629C9.05376 10.1485 9.0662 10.1626 9.0662 10.18V12.408Z",
                fill: "#FFFFFE"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                id: "mask0_7_630",
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M3 6H21V18.5735H3V6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                mask: "url(#mask0_7_630)",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.474 7.37645C11.055 6.77159 11.8637 6.39704 12.7571 6.39704C13.9483 6.39704 14.9806 7.0588 15.5365 8.04483C16.0299 7.82425 16.5644 7.71036 17.1049 7.71064C19.249 7.71064 20.9894 9.46431 20.9894 11.6283C20.9894 13.7923 19.249 15.5459 17.1049 15.5459C16.8428 15.5459 16.5874 15.5196 16.3372 15.4698C15.8508 16.3367 14.921 16.9257 13.8622 16.9257C13.4311 16.9266 13.0056 16.8288 12.6181 16.6398C12.1251 17.7979 10.9769 18.6119 9.64016 18.6119C8.24384 18.6119 7.05928 17.7317 6.60266 16.4942C6.39943 16.5371 6.19228 16.5587 5.98458 16.5586C4.32355 16.5586 2.98016 15.1953 2.98016 13.5211C2.98016 12.3961 3.58502 11.4167 4.48237 10.8872C4.292 10.4487 4.194 9.97562 4.1945 9.49754C4.1945 7.56518 5.76288 6.00342 7.69524 6.00342C8.82686 6.00342 9.83935 6.54276 10.4746 7.37989",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6034 12.5383C5.59208 12.5678 5.60743 12.5739 5.61107 12.5792C5.64489 12.6036 5.67924 12.6214 5.71365 12.6413C5.89762 12.7386 6.071 12.767 6.25232 12.767C6.62159 12.767 6.85122 12.5705 6.85122 12.2542V12.2479C6.85122 11.9554 6.59181 11.8489 6.3496 11.7728L6.3179 11.7625C6.1346 11.7031 5.97643 11.6514 5.97643 11.5309V11.5248C5.97643 11.4215 6.06908 11.3454 6.21202 11.3454C6.37085 11.3454 6.56011 11.3983 6.68121 11.4652C6.68121 11.4652 6.71708 11.4884 6.73012 11.4538C6.7372 11.435 6.79894 11.2698 6.80556 11.2513C6.81257 11.2319 6.80026 11.2172 6.78762 11.2097C6.64865 11.125 6.45674 11.0674 6.25821 11.0674L6.22135 11.0676C5.88319 11.0676 5.64694 11.272 5.64694 11.5645V11.5708C5.64694 11.8792 5.90768 11.9798 6.15121 12.0493L6.19038 12.0615C6.36774 12.116 6.52126 12.1634 6.52126 12.2878V12.294C6.52126 12.4085 6.42134 12.4939 6.26119 12.4939C6.19892 12.4939 6.00046 12.4928 5.78538 12.3569C5.75937 12.3417 5.74455 12.3308 5.7245 12.3186C5.71391 12.3121 5.68744 12.3006 5.67593 12.3352L5.60313 12.5377M11.0097 12.5377C10.9984 12.5672 11.0138 12.5734 11.0176 12.5786C11.0512 12.6031 11.0857 12.6209 11.1201 12.6408C11.3041 12.738 11.4775 12.7665 11.6588 12.7665C12.0281 12.7665 12.2577 12.57 12.2577 12.2536V12.2474C12.2577 11.9549 11.999 11.8484 11.7561 11.7723L11.7244 11.762C11.5411 11.7026 11.3829 11.6508 11.3829 11.5304V11.5242C11.3829 11.421 11.4756 11.3449 11.6185 11.3449C11.7773 11.3449 11.9659 11.3978 12.0877 11.4647C12.0877 11.4647 12.1236 11.4878 12.1367 11.4532C12.1437 11.4345 12.2055 11.2693 12.2114 11.2507C12.2185 11.2313 12.2062 11.2167 12.1936 11.2092C12.0546 11.1245 11.8627 11.0669 11.6642 11.0669L11.6272 11.067C11.2891 11.067 11.0528 11.2715 11.0528 11.564V11.5703C11.0528 11.8787 11.3136 11.9793 11.5571 12.0488L11.5962 12.0609C11.7742 12.1155 11.9271 12.1628 11.9271 12.2873V12.2935C11.9271 12.408 11.8272 12.4933 11.667 12.4933C11.6046 12.4933 11.4056 12.4923 11.1912 12.3563C11.1652 12.3412 11.15 12.3307 11.1303 12.318C11.1236 12.3138 11.0924 12.3016 11.0817 12.3347L11.009 12.5372M14.7016 11.9178C14.7016 12.0965 14.6683 12.2374 14.603 12.3374C14.5379 12.436 14.4395 12.4843 14.3026 12.4843C14.1656 12.4843 14.0676 12.4364 14.0034 12.338C13.9388 12.2387 13.9062 12.0971 13.9062 11.9185C13.9062 11.7398 13.939 11.5995 14.0034 11.5009C14.0675 11.4029 14.1649 11.356 14.3026 11.356C14.4402 11.356 14.5381 11.4034 14.603 11.5009C14.6686 11.5995 14.7016 11.7398 14.7016 11.9185M15.01 11.5869C14.9796 11.4843 14.9326 11.3943 14.8697 11.3189C14.8068 11.2435 14.7274 11.1826 14.6328 11.1389C14.5388 11.0949 14.4276 11.0727 14.3019 11.0727C14.1762 11.0727 14.0656 11.095 13.971 11.1389C13.877 11.1828 13.797 11.2435 13.7341 11.3189C13.6714 11.3943 13.6242 11.4843 13.5938 11.5869C13.5637 11.6888 13.5484 11.8 13.5484 11.9185C13.5484 12.0369 13.5637 12.1481 13.5938 12.25C13.6241 12.3526 13.6712 12.4426 13.7341 12.518C13.797 12.5935 13.877 12.6537 13.971 12.6967C14.0656 12.7396 14.1768 12.7614 14.3019 12.7614C14.427 12.7614 14.5381 12.7396 14.6321 12.6967C14.7261 12.6538 14.8062 12.5935 14.869 12.518C14.9318 12.4426 14.9789 12.3526 15.0093 12.25C15.0394 12.1481 15.0547 12.0369 15.0547 11.9185C15.0547 11.8007 15.0394 11.6888 15.0093 11.5869M17.5439 12.434C17.5338 12.404 17.5045 12.4153 17.5045 12.4153C17.4597 12.4324 17.4119 12.4483 17.3609 12.4563C17.3096 12.4643 17.2524 12.4684 17.1922 12.4684C17.0433 12.4684 16.9241 12.424 16.8394 12.336C16.7541 12.248 16.7064 12.1064 16.7071 11.9145C16.7075 11.7398 16.7498 11.6087 16.8255 11.5082C16.9003 11.4089 17.0155 11.3573 17.1677 11.3573C17.2947 11.3573 17.392 11.372 17.4939 11.4039C17.4939 11.4039 17.5181 11.4145 17.5297 11.3826C17.5567 11.3078 17.5767 11.2542 17.6058 11.1722C17.614 11.1487 17.5938 11.1388 17.5865 11.1359C17.5465 11.1203 17.4522 11.0947 17.3807 11.0839C17.3139 11.0737 17.2364 11.0684 17.1491 11.0684C17.0194 11.0684 16.9042 11.0906 16.8056 11.1345C16.707 11.1784 16.6236 11.2391 16.5575 11.3145C16.4913 11.39 16.441 11.48 16.4072 11.5825C16.3738 11.6845 16.3569 11.7963 16.3569 11.9147C16.3569 12.1702 16.4258 12.3773 16.5621 12.5289C16.6984 12.6811 16.9036 12.7578 17.1709 12.7578C17.3291 12.7578 17.4912 12.7259 17.6077 12.6797C17.6077 12.6797 17.6299 12.669 17.6203 12.6431L17.5441 12.434M18.0835 11.7457C18.0982 11.6465 18.1254 11.5637 18.1682 11.4996C18.2322 11.4016 18.3297 11.348 18.4666 11.348C18.6036 11.348 18.6943 11.4019 18.7591 11.4996C18.8022 11.5641 18.821 11.6498 18.828 11.7457L18.0802 11.7456L18.0835 11.7457ZM19.1225 11.5274C19.0962 11.4287 19.0311 11.3288 18.9888 11.2832C18.9213 11.211 18.8558 11.1601 18.7903 11.1323C18.6957 11.0921 18.5939 11.0714 18.4911 11.0716C18.3608 11.0716 18.2423 11.0936 18.1464 11.1384C18.0504 11.1836 17.9697 11.245 17.9061 11.3217C17.8427 11.3985 17.795 11.4892 17.7645 11.5931C17.7341 11.6956 17.7187 11.8081 17.7187 11.9259C17.7187 12.0464 17.7347 12.1582 17.766 12.2595C17.7977 12.3614 17.8488 12.4507 17.9176 12.5248C17.9864 12.5996 18.0744 12.6578 18.1803 12.6989C18.2855 12.7396 18.4132 12.7607 18.5595 12.7602C18.8613 12.7592 19.0201 12.6921 19.0849 12.6557C19.0965 12.6492 19.1074 12.638 19.0938 12.6058L19.0256 12.4145C19.0152 12.386 18.9863 12.3963 18.9863 12.3963C18.9116 12.4242 18.8057 12.4744 18.5575 12.4737C18.3954 12.4735 18.2756 12.4256 18.2002 12.3507C18.1234 12.2739 18.085 12.162 18.0791 12.0032L19.1246 12.004C19.1246 12.004 19.1522 12.0038 19.155 11.9769C19.1561 11.9658 19.1908 11.7625 19.1238 11.5275L19.1225 11.5274ZM9.7254 11.7457C9.74015 11.6465 9.76742 11.5637 9.8101 11.4996C9.87416 11.4016 9.97157 11.348 10.1086 11.348C10.2455 11.348 10.3362 11.4019 10.4011 11.4996C10.444 11.5641 10.4628 11.6498 10.4699 11.7457L9.72209 11.7456L9.7254 11.7457ZM10.7644 11.5274C10.7382 11.4287 10.673 11.3288 10.6307 11.2832C10.5632 11.211 10.4977 11.1601 10.4322 11.1323C10.3376 11.0921 10.2358 11.0714 10.133 11.0716C10.0027 11.0716 9.88422 11.0936 9.78826 11.1384C9.69231 11.1836 9.61157 11.245 9.54804 11.3217C9.48471 11.3985 9.43687 11.4892 9.40643 11.5931C9.37605 11.6956 9.36076 11.8081 9.36076 11.9259C9.36076 12.0464 9.37658 12.1582 9.40815 12.2595C9.43978 12.3614 9.49087 12.4507 9.55903 12.5248C9.62785 12.5996 9.71587 12.6578 9.82175 12.6989C9.92697 12.7396 10.054 12.7607 10.2009 12.7602C10.5027 12.7592 10.6615 12.6921 10.7264 12.6557C10.7379 12.6492 10.7489 12.638 10.7352 12.6058L10.667 12.4145C10.6565 12.386 10.6276 12.3963 10.6276 12.3963C10.5529 12.4242 10.447 12.4744 10.1988 12.4737C10.0374 12.4735 9.91691 12.4256 9.84147 12.3507C9.76471 12.2739 9.72632 12.162 9.72037 12.0032L10.766 12.004C10.766 12.004 10.7935 12.0038 10.7963 11.9769C10.7975 11.9658 10.8321 11.7625 10.7651 11.5275L10.7644 11.5274ZM7.46878 12.4274C7.42782 12.3947 7.42213 12.3867 7.40856 12.3654C7.38785 12.3334 7.37726 12.288 7.37726 12.2297C7.37726 12.1384 7.4077 12.0722 7.47057 12.0279C7.4699 12.028 7.56057 11.9498 7.77365 11.9525C7.8685 11.9542 7.96313 11.9622 8.05689 11.9766V12.4511H8.05702C8.05702 12.4511 7.92467 12.4796 7.77511 12.4886C7.56268 12.5014 7.46871 12.4275 7.46938 12.4277L7.46878 12.4274ZM7.88437 11.6928C7.84201 11.6897 7.78709 11.6882 7.72157 11.6882C7.63224 11.6882 7.54554 11.6993 7.46481 11.7211C7.38341 11.7431 7.30996 11.7771 7.24709 11.8224C7.18405 11.8673 7.1322 11.9262 7.09554 11.9944C7.05855 12.0632 7.03969 12.144 7.03969 12.2353C7.03969 12.328 7.05577 12.408 7.08754 12.4735C7.11866 12.5385 7.16552 12.5947 7.22386 12.637C7.2819 12.6792 7.35357 12.7105 7.43629 12.729C7.51835 12.7477 7.61099 12.7572 7.7129 12.7572C7.82011 12.7572 7.92665 12.7482 8.02989 12.7308C8.11782 12.7156 8.20541 12.6986 8.29261 12.6797C8.32742 12.6717 8.36607 12.6612 8.36607 12.6612C8.39188 12.6546 8.38989 12.627 8.38989 12.627L8.38929 11.6741C8.38929 11.4649 8.33344 11.3094 8.22319 11.2135C8.11334 11.1175 7.95253 11.0692 7.74407 11.0692C7.66599 11.0692 7.53959 11.0798 7.46415 11.095C7.46415 11.095 7.2365 11.1392 7.14253 11.2127C7.14253 11.2127 7.12188 11.2255 7.13313 11.2542L7.20725 11.4528C7.21645 11.4785 7.24153 11.4697 7.24153 11.4697C7.24153 11.4697 7.2494 11.4666 7.25867 11.4611C7.45918 11.3519 7.7133 11.3552 7.7133 11.3552C7.8258 11.3552 7.91315 11.3781 7.97139 11.4227C8.02837 11.4665 8.05742 11.5326 8.05742 11.6715V11.7157C7.96808 11.7027 7.88536 11.6952 7.88536 11.6952L7.88437 11.6928ZM16.2888 11.1548C16.2903 11.1513 16.2911 11.1475 16.2911 11.1437C16.2911 11.1399 16.2904 11.1362 16.2889 11.1327C16.2874 11.1291 16.2853 11.126 16.2826 11.1233C16.2799 11.1207 16.2766 11.1186 16.2731 11.1172C16.2553 11.1104 16.1666 11.0917 16.0984 11.0875C15.9674 11.0793 15.8946 11.1014 15.8291 11.1308C15.7643 11.1599 15.6927 11.2069 15.653 11.2611L15.6529 11.1341C15.6529 11.1166 15.6405 11.1025 15.6229 11.1025H15.3556C15.3382 11.1025 15.3256 11.1166 15.3256 11.1341V12.6892C15.3257 12.6976 15.329 12.7057 15.335 12.7116C15.3409 12.7175 15.3489 12.7209 15.3573 12.7209H15.6313C15.6397 12.7209 15.6478 12.7175 15.6537 12.7116C15.6596 12.7057 15.6629 12.6976 15.6629 12.6892V11.9083C15.6629 11.8038 15.6745 11.6999 15.6974 11.6344C15.7201 11.5696 15.7508 11.5179 15.7888 11.4808C15.8249 11.445 15.8692 11.4185 15.9178 11.4034C15.9634 11.3903 16.0106 11.3837 16.0581 11.3837C16.1127 11.3837 16.1726 11.3977 16.1726 11.3977C16.1927 11.4 16.2039 11.3877 16.2107 11.3695C16.2286 11.3218 16.2795 11.1789 16.2894 11.1505",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.437C13.6961 10.4268 13.6616 10.4186 13.6267 10.4125C13.5799 10.4047 13.5324 10.401 13.4849 10.4015C13.2961 10.4015 13.1472 10.4549 13.0427 10.5602C12.939 10.6648 12.8684 10.8241 12.833 11.0337L12.8202 11.1044H12.5832C12.5832 11.1044 12.5543 11.1032 12.5482 11.1348L12.5093 11.3518C12.5066 11.3726 12.5155 11.3856 12.5433 11.3854H12.774L12.5399 12.692C12.5216 12.7972 12.5006 12.8837 12.4774 12.9493C12.4545 13.0141 12.4321 13.0626 12.4046 13.0978C12.3779 13.1318 12.3527 13.1569 12.309 13.1716C12.273 13.1837 12.2316 13.1892 12.1862 13.1892C12.1609 13.1892 12.1273 13.185 12.1025 13.18C12.0777 13.1751 12.0648 13.1696 12.0462 13.1618C12.0462 13.1618 12.0191 13.1514 12.0085 13.1786C11.9998 13.2007 11.9383 13.3698 11.931 13.3907C11.9236 13.4114 11.934 13.4277 11.9471 13.4324C11.9778 13.4433 12.0007 13.4504 12.0425 13.4602C12.1006 13.4739 12.1496 13.4748 12.1954 13.4748C12.2915 13.4748 12.3791 13.4613 12.4517 13.4351C12.5247 13.4087 12.5883 13.3627 12.6446 13.3004C12.7054 13.2332 12.7436 13.1629 12.7802 13.0669C12.8164 12.9718 12.8473 12.8538 12.8719 12.7162L13.1071 11.3854H13.451C13.451 11.3854 13.48 11.3865 13.486 11.3551L13.5249 11.138C13.5276 11.1172 13.5187 11.1043 13.4908 11.1044H13.1571C13.1587 11.0969 13.1739 10.9795 13.2122 10.8689C13.2286 10.8218 13.2593 10.7837 13.2854 10.7576C13.3098 10.7327 13.3397 10.714 13.3728 10.7032C13.4091 10.692 13.4469 10.6865 13.4849 10.687C13.5163 10.687 13.5471 10.6908 13.5706 10.6957C13.603 10.7026 13.6156 10.7062 13.624 10.7087C13.6581 10.7191 13.6626 10.7091 13.6693 10.6926L13.7491 10.4734C13.7573 10.4498 13.7373 10.4399 13.7299 10.437ZM9.0662 12.6948C9.0662 12.7122 9.05376 12.7264 9.03629 12.7264H8.75947C8.74193 12.7264 8.72949 12.7122 8.72949 12.6948V10.4667C8.72949 10.4493 8.74193 10.4352 8.75947 10.4352H9.03629C9.05376 10.4352 9.0662 10.4493 9.0662 10.4667V12.6948Z",
                fill: "#FFFFFE"
            })
        ]
    });
};
var $55a30a7a8f1d55ec$export$2e2bcd8739ae039 = $55a30a7a8f1d55ec$var$SalesforceIcon;

});

parcelRegister("85FG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba002b88a0262ae$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $bba002b88a0262ae$var$SentryIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-779.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.2634 5.12647C13.1313 4.90729 12.9448 4.72597 12.722 4.6001C12.4992 4.47423 12.2477 4.40808 11.9918 4.40808C11.7359 4.40808 11.4844 4.47423 11.2616 4.6001C11.0388 4.72597 10.8523 4.90729 10.7202 5.12647L8.62849 8.70913C10.2265 9.50694 11.588 10.7089 12.5779 12.1956C13.5677 13.6823 14.1514 15.4021 14.2711 17.1842H12.8024C12.683 15.6566 12.1667 14.1867 11.3047 12.9199C10.4427 11.6531 9.26492 10.6334 7.8878 9.96162L5.95183 13.309C6.726 13.6562 7.40046 14.1925 7.91318 14.8686C8.4259 15.5446 8.76042 16.3387 8.88598 17.1778H5.51314C5.47313 17.175 5.43447 17.1622 5.40062 17.1407C5.36677 17.1192 5.33881 17.0896 5.31926 17.0546C5.2997 17.0196 5.28917 16.9803 5.28861 16.9402C5.28805 16.9001 5.29747 16.8605 5.31604 16.8249L6.25065 15.2355C5.93401 14.9713 5.57212 14.7667 5.18253 14.6315L4.25746 16.2209C4.16115 16.3861 4.09863 16.5688 4.07353 16.7584C4.04842 16.9479 4.06124 17.1406 4.11122 17.3251C4.16121 17.5097 4.24737 17.6825 4.3647 17.8335C4.48203 17.9844 4.62819 18.1106 4.7947 18.2046C5.01407 18.3282 5.26134 18.3938 5.51314 18.3953H10.1321C10.2179 17.3368 10.0289 16.274 9.58332 15.3099C9.13777 14.3459 8.45081 13.5132 7.58898 12.8926L8.32331 11.621C9.41096 12.3681 10.285 13.3858 10.8592 14.5738C11.4334 15.7618 11.6879 17.0789 11.5976 18.3953H15.5109C15.602 16.4012 15.1682 14.418 14.2528 12.6441C13.3373 10.8701 11.9724 9.36748 10.2943 8.28633L11.7788 5.74318C11.8119 5.68775 11.8655 5.64764 11.928 5.63156C11.9906 5.61549 12.0569 5.62476 12.1126 5.65735C12.2811 5.74954 18.5627 16.7105 18.6803 16.8377C18.701 16.8748 18.7115 16.9168 18.7108 16.9593C18.7101 17.0019 18.6982 17.0435 18.6763 17.0799C18.6543 17.1164 18.6232 17.1464 18.5859 17.1669C18.5487 17.1874 18.5066 17.1978 18.4641 17.1969H16.9509C16.97 17.6017 16.97 18.0054 16.9509 18.4081H18.4705C18.6634 18.4093 18.8547 18.3723 19.0333 18.2991C19.2118 18.226 19.3741 18.1181 19.5107 17.9818C19.6473 17.8455 19.7554 17.6835 19.829 17.5051C19.9025 17.3267 19.94 17.1355 19.9391 16.9426C19.9393 16.6877 19.8713 16.4374 19.742 16.2178L13.2634 5.12647Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M13.273 5.71839C13.1399 5.49921 12.952 5.31788 12.7275 5.19201C12.503 5.06614 12.2495 5 11.9916 5C11.7338 5 11.4803 5.06614 11.2558 5.19201C11.0313 5.31788 10.8434 5.49921 10.7103 5.71839L8.60252 9.30104C10.2128 10.0989 11.5848 11.3008 12.5822 12.7875C13.5796 14.2742 14.1679 15.994 14.2884 17.7761H12.8085C12.6881 16.2485 12.1679 14.7786 11.2993 13.5118C10.4307 12.2451 9.24383 11.2253 7.85614 10.5535L5.90531 13.901C6.68543 14.2482 7.36506 14.7844 7.88171 15.4605C8.39837 16.1365 8.73546 16.9306 8.86199 17.7697H5.46325C5.42294 17.7669 5.38397 17.7542 5.34987 17.7326C5.31576 17.7111 5.28758 17.6815 5.26788 17.6465C5.24817 17.6115 5.23756 17.5722 5.23699 17.5321C5.23643 17.492 5.24593 17.4524 5.26464 17.4169L6.20642 15.8274C5.88735 15.5632 5.52269 15.3586 5.1301 15.2234L4.19793 16.8129C4.10089 16.978 4.03789 17.1607 4.01259 17.3503C3.98729 17.5398 4.0002 17.7325 4.05057 17.917C4.10094 18.1016 4.18776 18.2744 4.30599 18.4254C4.42423 18.5764 4.57151 18.7025 4.73929 18.7965C4.96035 18.9201 5.20952 18.9858 5.46325 18.9873H10.1177C10.2041 17.9287 10.0136 16.8659 9.56468 15.9018C9.11571 14.9378 8.42348 14.1051 7.55503 13.4845L8.295 12.2129C9.391 12.96 10.2718 13.9777 10.8504 15.1657C11.429 16.3537 11.6854 17.6709 11.5944 18.9873H15.5377C15.6296 16.9931 15.1924 15.01 14.27 13.236C13.3475 11.462 11.9721 9.9594 10.2811 8.87825L11.777 6.3351C11.8104 6.27967 11.8644 6.23956 11.9274 6.22348C11.9904 6.20741 12.0572 6.21667 12.1134 6.24927C12.2831 6.34146 18.6129 17.3024 18.7315 17.4296C18.7523 17.4667 18.763 17.5087 18.7623 17.5512C18.7616 17.5938 18.7495 17.6354 18.7274 17.6718C18.7053 17.7083 18.6739 17.7383 18.6364 17.7588C18.5988 17.7794 18.5565 17.7897 18.5136 17.7888H16.9889C17.0081 18.1936 17.0081 18.5973 16.9889 19H18.52C18.7145 19.0012 18.9072 18.9642 19.0872 18.8911C19.2671 18.8179 19.4306 18.71 19.5682 18.5737C19.7059 18.4375 19.8149 18.2754 19.889 18.097C19.9631 17.9186 20.0008 17.7274 20 17.5345C20.0002 17.2796 19.9316 17.0294 19.8014 16.8097L13.273 5.71839Z",
            fill: "#362D59"
        })
    });
};
var $bba002b88a0262ae$export$2e2bcd8739ae039 = $bba002b88a0262ae$var$SentryIcon;

});

parcelRegister("8aqSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $13090e382d1293f8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $13090e382d1293f8$var$SharePointIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-650.5",
                y: "-28.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#0B1228",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M12.1863 13.1429C14.6523 13.1429 16.6514 11.0962 16.6514 8.57143C16.6514 6.0467 14.6523 4 12.1863 4C9.72029 4 7.72119 6.0467 7.72119 8.57143C7.72119 11.0962 9.72029 13.1429 12.1863 13.1429Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M15.907 16.9525C18.1675 16.9525 20 15.0763 20 12.762C20 10.4477 18.1675 8.57153 15.907 8.57153C13.6465 8.57153 11.814 10.4477 11.814 12.762C11.814 15.0763 13.6465 16.9525 15.907 16.9525Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M12.7443 20.0001C14.4911 20.0001 15.9071 18.5504 15.9071 16.762C15.9071 14.9737 14.4911 13.5239 12.7443 13.5239C10.9976 13.5239 9.58154 14.9737 9.58154 16.762C9.58154 18.5504 10.9976 20.0001 12.7443 20.0001Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.9302 8.12585V16.2554C12.9283 16.5379 12.7611 16.7916 12.506 16.8992C12.4248 16.9344 12.3374 16.9525 12.2492 16.9525H9.58506C9.58134 16.8878 9.58134 16.8268 9.58134 16.762C9.5801 16.6984 9.58258 16.6348 9.58878 16.5716C9.65688 15.3538 10.3896 14.2794 11.4827 13.7944V13.0858C9.04996 12.6911 7.39032 10.3521 7.77583 7.86137C7.77851 7.84412 7.78127 7.82688 7.78414 7.80966C7.80266 7.68118 7.82876 7.55396 7.86228 7.42871H12.2493C12.6247 7.43017 12.9287 7.74144 12.9302 8.12585Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78421C7.37074 10.2958 9.00415 12.6544 11.4325 13.0777C11.5061 13.0906 11.5799 13.1015 11.654 13.1105C10.5005 13.6705 9.65993 15.261 9.58849 16.5715C9.5823 16.6348 9.57981 16.6984 9.58104 16.7619C9.58104 16.8267 9.58104 16.8877 9.58476 16.9524C9.59147 17.0805 9.60765 17.2078 9.63313 17.3334H11.8769C12.1528 17.3315 12.4006 17.1603 12.5057 16.8991C12.54 16.8159 12.5578 16.7265 12.5578 16.6362V8.50671C12.5564 8.12245 12.2526 7.81125 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78418C7.37079 10.296 9.00445 12.6548 11.4331 13.078C11.4828 13.0867 11.5326 13.0945 11.5825 13.1014C10.4662 13.7018 9.65879 15.2884 9.58883 16.5715H11.8772C12.2521 16.5686 12.5553 16.2581 12.5581 15.8743V8.50671C12.5567 8.1223 12.2527 7.81103 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.505 7.80957H7.78405C7.39371 10.1568 8.8303 12.4172 11.0845 13.0027C10.231 14.0012 9.70744 15.2502 9.58871 16.5715H11.505C11.8805 16.57 12.1845 16.2587 12.1859 15.8743V8.50671C12.1857 8.12178 11.881 7.80978 11.505 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M4.68205 7.80957H11.504C11.8807 7.80957 12.186 8.1222 12.186 8.50786V15.4922C12.186 15.8779 11.8807 16.1905 11.504 16.1905H4.68205C4.30536 16.1905 4 15.8779 4 15.4922V8.50786C4 8.1222 4.30536 7.80957 4.68205 7.80957Z",
                        fill: "#026D71"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M7.04621 11.9147C6.88638 11.8062 6.75286 11.6617 6.65588 11.4922C6.56192 11.3151 6.51508 11.1158 6.52007 10.9143C6.5117 10.6415 6.60162 10.3751 6.77272 10.1658C6.95251 9.95618 7.1849 9.80099 7.44472 9.717C7.74082 9.61722 8.05096 9.56805 8.36267 9.57148C8.77258 9.55614 9.18193 9.61482 9.57197 9.74481V10.621C9.40249 10.5159 9.21791 10.4388 9.02499 10.3924C8.81567 10.3399 8.60088 10.3135 8.38536 10.314C8.15809 10.3054 7.93227 10.3544 7.72787 10.4564C7.57007 10.5261 7.46774 10.6851 7.46741 10.861C7.46677 10.9677 7.50682 11.0705 7.57904 11.1475C7.66434 11.2382 7.76525 11.3121 7.87672 11.3654C8.00074 11.4286 8.18679 11.5127 8.43485 11.6176C8.46217 11.6264 8.48879 11.6374 8.51448 11.6504C8.75862 11.748 8.99415 11.867 9.21848 12.0058C9.38837 12.113 9.53095 12.26 9.63449 12.4347C9.74064 12.6328 9.79209 12.8566 9.78332 13.0824C9.79544 13.3624 9.71174 13.6381 9.54667 13.8618C9.38213 14.0674 9.16216 14.219 8.91411 14.2976C8.62236 14.3912 8.31786 14.4365 8.01215 14.4317C7.73787 14.433 7.46399 14.41 7.19355 14.3631C6.96521 14.3249 6.74237 14.2578 6.53011 14.1635V13.2397C6.733 13.388 6.95967 13.4989 7.19988 13.5673C7.43928 13.6437 7.68814 13.6845 7.93886 13.6884C8.17091 13.7035 8.40255 13.6532 8.60863 13.5429C8.75299 13.4595 8.84079 13.3015 8.83709 13.1319C8.83806 13.0138 8.79244 12.9004 8.71058 12.8172C8.60879 12.7149 8.49093 12.6308 8.36194 12.5684C8.2131 12.4922 7.99393 12.3918 7.70445 12.2671C7.47415 12.1723 7.25365 12.0543 7.04621 11.9147Z",
                        fill: "white"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                clipPath: "url(#clip0_271_181641)",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip1_271_181641)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
                            fill: "#036C70"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
                            fill: "#1A9BA1"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
                            fill: "#37C6D0"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            opacity: "0.1",
                            d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
                            fill: "#04868B"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_271_181641",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip1_271_181641",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    })
                ]
            })
        ]
    });
};
var $13090e382d1293f8$export$2e2bcd8739ae039 = $13090e382d1293f8$var$SharePointIcon;

});

parcelRegister("4KJOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $589402e3e10dda2c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $589402e3e10dda2c$var$SlackIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-603.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
                        fill: "#ECB22E"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};
var $589402e3e10dda2c$export$2e2bcd8739ae039 = $589402e3e10dda2c$var$SlackIcon;

});

parcelRegister("fcIyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $20b0360aba9d0433$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $20b0360aba9d0433$var$SmartsheetIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-171.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.2708 12.9524C12.0781 12.5707 11.8938 12.2011 11.6762 11.8499C11.4003 11.4042 11.1009 10.9773 10.6919 10.6414C10.3847 10.3891 10.0444 10.2293 9.63382 10.2899C9.27961 10.3422 8.99393 10.5287 8.73676 10.7652C8.60099 10.8901 8.47697 11.0271 8.36318 11.1923C8.42475 11.2006 8.47588 11.2054 8.52636 11.2146C8.8921 11.2813 9.17343 11.4943 9.4269 11.7487C9.85292 12.1767 10.1699 12.6838 10.4539 13.2121C11.0905 14.3964 11.5574 15.6505 11.9569 16.9316C11.9608 16.944 11.9643 16.9564 11.9732 16.9859C13.5754 13.1534 15.383 9.45358 17.8734 6.12915L17.9021 6.13874C17.9021 6.22486 17.9021 6.31098 17.9021 6.39688C17.9021 9.19064 17.9052 11.9844 17.9002 14.7784C17.8986 15.6202 17.8858 16.4624 17.8233 17.3027C17.8027 17.5811 17.7742 17.8593 17.6754 18.1242C17.5601 18.4333 17.3395 18.5127 17.0594 18.338C16.8218 18.1898 16.6373 17.9825 16.4822 17.754C16.1504 17.2654 15.831 16.7687 15.6093 16.2167C15.5952 16.1814 15.5917 16.1009 15.5142 16.1761C15.009 16.6673 14.4222 17.0471 13.8187 17.4003C12.0839 18.4152 10.2293 19.1317 8.28355 19.6187C7.58535 19.7934 6.88193 19.9416 6.1735 20.0672C6.10497 20.0794 6.08734 20.0753 6.10192 19.997C6.19656 19.4857 6.23986 18.9697 6.23986 18.449C6.23856 14.0349 6.23964 9.6208 6.23638 5.20669C6.23638 5.09615 6.26314 5.07239 6.37128 5.07239C10.1708 5.07544 13.9701 5.075 17.7696 5.075H17.9017C15.5708 7.38279 13.6026 9.93061 12.2715 12.9526L12.2708 12.9524Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M12.2752 13.0096C12.0792 12.6216 11.8919 12.246 11.6708 11.8889C11.3903 11.436 11.086 11.0021 10.6703 10.6606C10.358 10.4042 10.0121 10.2417 9.59481 10.3033C9.23477 10.3565 8.9444 10.546 8.68299 10.7864C8.54499 10.9134 8.41894 11.0526 8.30327 11.2206C8.36586 11.229 8.41783 11.2339 8.46914 11.2432C8.8409 11.311 9.12685 11.5275 9.38449 11.7861C9.81751 12.2211 10.1397 12.7366 10.4283 13.2736C11.0754 14.4773 11.55 15.752 11.9561 17.0542C11.96 17.0668 11.9636 17.0795 11.9726 17.1094C13.6012 13.2139 15.4386 9.45323 17.9699 6.07414L17.9991 6.08389C17.9991 6.17142 17.9991 6.25896 17.9991 6.34627C17.9991 9.18597 18.0022 12.0257 17.9971 14.8656C17.9955 15.7212 17.9825 16.5773 17.919 17.4314C17.898 17.7144 17.869 17.9971 17.7686 18.2664C17.6514 18.5806 17.4272 18.6613 17.1425 18.4838C16.901 18.3331 16.7135 18.1224 16.5558 17.8901C16.2186 17.3935 15.8939 16.8887 15.6686 16.3275C15.6542 16.2916 15.6506 16.2099 15.5719 16.2863C15.0584 16.7856 14.4619 17.1717 13.8485 17.5307C12.0852 18.5623 10.2001 19.2905 8.22233 19.7855C7.51265 19.963 6.79766 20.1137 6.07759 20.2414C6.00793 20.2538 5.99001 20.2496 6.00483 20.17C6.10103 19.6504 6.14504 19.1258 6.14504 18.5966C6.14371 14.1099 6.14482 9.62321 6.1415 5.13651C6.1415 5.02415 6.1687 5 6.27862 5C10.1406 5.0031 14.0024 5.00266 17.8644 5.00266H17.9986C15.6294 7.34839 13.6289 9.93811 12.2758 13.0098L12.2752 13.0096Z",
            fill: "#143158"
        })
    });
};
var $20b0360aba9d0433$export$2e2bcd8739ae039 = $20b0360aba9d0433$var$SmartsheetIcon;

});

parcelRegister("1GMny", function(module, exports) {

$parcel$export(module.exports, "default", () => $1361f7b5510de5d5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $1361f7b5510de5d5$var$StripeIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.0639 9.32966C11.0639 8.76566 11.5259 8.54366 12.2939 8.54366C13.3979 8.54366 14.7899 8.87966 15.8939 9.47366V6.06566C14.6879 5.58566 13.4999 5.39966 12.2999 5.39966C9.35395 5.39966 7.39795 6.93566 7.39795 9.50366C7.39795 13.5057 12.9119 12.8697 12.9119 14.5977C12.9119 15.2637 12.3299 15.4797 11.5199 15.4797C10.3139 15.4797 8.77795 14.9877 7.55995 14.3217V17.7717C8.90995 18.3537 10.2719 18.5997 11.5199 18.5997C14.5379 18.5997 16.6139 17.1057 16.6139 14.5077C16.5899 10.1877 11.0639 10.9557 11.0639 9.32966Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 5H19V19H5V5Z",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4541 10.4422C11.4541 10.1132 11.7236 9.98366 12.1716 9.98366C12.8156 9.98366 13.6276 10.1797 14.2716 10.5262V8.53816C13.5681 8.25816 12.8751 8.14966 12.1751 8.14966C10.4566 8.14966 9.31555 9.04566 9.31555 10.5437C9.31555 12.8782 12.5321 12.5072 12.5321 13.5152C12.5321 13.9037 12.1926 14.0297 11.7201 14.0297C11.0166 14.0297 10.1206 13.7427 9.41005 13.3542V15.3667C10.1976 15.7062 10.9921 15.8497 11.7201 15.8497C13.4806 15.8497 14.6916 14.9782 14.6916 13.4627C14.6776 10.9427 11.4541 11.3907 11.4541 10.4422Z",
                fill: "white"
            })
        ]
    });
};
var $1361f7b5510de5d5$export$2e2bcd8739ae039 = $1361f7b5510de5d5$var$StripeIcon;

});

parcelRegister("ehNOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e02084d9c66d58$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $f1e02084d9c66d58$var$TeamsIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-506.5",
                y: "-603.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: "0.1",
                d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: "0.2",
                d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: "0.1",
                d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: "0.2",
                d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "1 1 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_3561_46629)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M15.0321 10H19.4879C19.9088 10 20.2501 10.3403 20.2501 10.76V14.8068C20.2501 16.3494 18.9959 17.6 17.4488 17.6H17.4355C15.8884 17.6002 14.634 16.3498 14.6338 14.8072C14.6338 14.8071 14.6338 14.8069 14.6338 14.8068V10.3972C14.6338 10.1778 14.8121 10 15.0321 10Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.0435 9.19961C19.0405 9.19961 19.8487 8.39372 19.8487 7.39961C19.8487 6.4055 19.0405 5.59961 18.0435 5.59961C17.0465 5.59961 16.2383 6.4055 16.2383 7.39961C16.2383 8.39372 17.0465 9.19961 18.0435 9.19961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M12.4274 9.20001C13.8675 9.20001 15.0349 8.03594 15.0349 6.6C15.0349 5.16406 13.8675 4 12.4274 4C10.9873 4 9.81982 5.16406 9.81982 6.6C9.81982 8.03594 10.9873 9.20001 12.4274 9.20001Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M15.904 10H8.54908C8.13313 10.0103 7.8041 10.3545 7.81375 10.7692V15.3848C7.75566 17.8737 9.73048 19.9391 12.2265 20C14.7226 19.9391 16.6974 17.8737 16.6393 15.3848V10.7692C16.649 10.3545 16.3199 10.0103 15.904 10Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.6276 10V16.468C12.6256 16.7646 12.4454 17.0311 12.1703 17.144C12.0827 17.1809 11.9886 17.2 11.8935 17.2H8.16671C8.11456 17.068 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.6276Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.868C12.2265 16.9628 12.2074 17.0567 12.1703 17.144C12.0571 17.4183 11.7898 17.598 11.4924 17.6H8.35526C8.28706 17.468 8.22288 17.336 8.16671 17.2C8.11055 17.064 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.068C12.2234 16.471 11.8965 16.797 11.4923 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8253 10V16.068C11.8223 16.471 11.4954 16.797 11.0912 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H11.8253Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.628 7.93121V9.19121C12.5598 9.19521 12.4956 9.19921 12.4274 9.19921C12.3592 9.19921 12.2951 9.19522 12.2269 9.19121C12.0914 9.18225 11.9572 9.16083 11.8257 9.12721C11.0133 8.93539 10.3422 8.36732 10.0205 7.59922C9.9651 7.47023 9.92213 7.33629 9.89209 7.19922H11.8939C12.2987 7.20075 12.6265 7.52757 12.628 7.93121Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8257 8.33161V9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.0916C11.4964 7.60115 11.8242 7.92798 11.8257 8.33161Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M3.73533 7.59961H11.0902C11.4964 7.59961 11.8256 7.92788 11.8256 8.33281V15.6664C11.8256 16.0713 11.4963 16.3996 11.0902 16.3996H3.73533C3.32921 16.3996 3 16.0713 3 15.6664V8.33281C3 7.92788 3.32922 7.59961 3.73533 7.59961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M9.34796 10.3916H7.87769V14.3836H6.94098V10.3916H5.47754V9.61719H9.34796V10.3916Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_3561_46629",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "17.25",
                        height: "16",
                        fill: "white",
                        transform: "translate(3 4)"
                    })
                })
            })
        ]
    });
};
var $f1e02084d9c66d58$export$2e2bcd8739ae039 = $f1e02084d9c66d58$var$TeamsIcon;

});

parcelRegister("dTazm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f766f4c3596db56$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $8f766f4c3596db56$var$TodoistIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-731.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M16.7653 5.01575H7.2667C6.03236 5.01575 5.03174 6.01638 5.03174 7.25072V16.7493C5.03174 17.9837 6.03236 18.9843 7.2667 18.9843H16.7653C17.9996 18.9843 19.0002 17.9837 19.0002 16.7493V7.25072C19.0002 6.01638 17.9996 5.01575 16.7653 5.01575Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.98402 11.5604L10.7664 9.9593L10.7699 9.95712L13.6369 8.30708C13.7578 8.23724 13.7635 8.02335 13.6282 7.94565L13.5334 7.89152C13.3951 7.81295 13.2161 7.7108 13.1397 7.66628C13.0728 7.62983 12.9976 7.61118 12.9214 7.61209C12.8452 7.61301 12.7705 7.63347 12.7045 7.67151C12.6368 7.7108 8.12065 10.3072 7.96961 10.3932C7.88062 10.4441 7.77988 10.4708 7.67737 10.4708C7.57485 10.4708 7.47412 10.4441 7.38512 10.3932L5 9.00726V10.1854L5.02444 10.1994C5.61985 10.5464 7.02892 11.3671 7.37377 11.5613C7.58286 11.6792 7.78278 11.6766 7.98402 11.5604Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.98402 13.9142L10.7629 12.3148L10.7734 12.3087L13.6369 10.6608C13.7578 10.591 13.7635 10.3767 13.6282 10.2994L13.5334 10.2453C13.3955 10.1667 13.2161 10.0646 13.1397 10.02C13.0728 9.98359 12.9976 9.96494 12.9214 9.96585C12.8452 9.96677 12.7705 9.98723 12.7045 10.0253C12.6368 10.0641 8.12065 12.661 7.96961 12.7465C7.88062 12.7974 7.77988 12.8242 7.67737 12.8242C7.57485 12.8242 7.47412 12.7974 7.38512 12.7465C7.24282 12.6645 5 11.361 5 11.361V12.5387L5.02444 12.5531C5.62029 12.9002 7.02892 13.7204 7.37377 13.9151C7.58286 14.0329 7.78278 14.0303 7.98402 13.9142Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.7668 14.6663L7.98402 16.2679C7.78279 16.384 7.58242 16.3866 7.37377 16.2688C7.02892 16.0741 5.62029 15.2539 5.02444 14.9069L5 14.8924V13.7147L7.38512 15.1002C7.5654 15.2046 7.7889 15.2032 7.96961 15.1002C8.12065 15.0147 12.6368 12.4178 12.7045 12.3785C12.7705 12.3405 12.8452 12.32 12.9214 12.3191C12.9976 12.3182 13.0728 12.3369 13.1397 12.3733C13.3022 12.4673 13.4652 12.5604 13.6286 12.6527C13.7639 12.7304 13.7578 12.9447 13.6369 13.0146L10.7668 14.6663Z",
                fill: "#DE483A"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.4458 4H6.59025C5.17958 4 4.03601 5.14358 4.03601 6.55425V17.4098C4.03601 18.8205 5.17958 19.9641 6.59025 19.9641H17.4458C18.8564 19.9641 20 18.8205 20 17.4098V6.55425C20 5.14358 18.8564 4 17.4458 4Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.41031 11.4797L10.5901 9.64985L10.5941 9.64735L13.8707 7.7616C14.0089 7.68178 14.0154 7.43733 13.8608 7.34853L13.7525 7.28667C13.5944 7.19687 13.3898 7.08013 13.3025 7.02924C13.226 6.9876 13.1401 6.96627 13.053 6.96732C12.966 6.96837 12.8806 6.99175 12.8051 7.03523C12.7278 7.08013 7.56645 10.0475 7.39384 10.1457C7.29213 10.2039 7.17701 10.2345 7.05985 10.2345C6.94269 10.2345 6.82756 10.2039 6.72585 10.1457L4 8.5618V9.90827L4.02794 9.92423C4.7084 10.3208 6.31877 11.2587 6.71288 11.4807C6.95184 11.6154 7.18033 11.6124 7.41031 11.4797Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.41031 14.1697L10.5861 12.3418L10.5981 12.3348L13.8707 10.4515C14.0089 10.3717 14.0154 10.1268 13.8608 10.0385L13.7525 9.97661C13.5949 9.88681 13.3898 9.77007 13.3025 9.71919C13.226 9.67754 13.1401 9.65622 13.053 9.65726C12.966 9.65831 12.8806 9.68169 12.8051 9.72517C12.7278 9.76957 7.56645 12.7374 7.39384 12.8352C7.29213 12.8933 7.17701 12.9239 7.05985 12.9239C6.94269 12.9239 6.82756 12.8933 6.72585 12.8352C6.56322 12.7414 4 11.2517 4 11.2517V12.5977L4.02794 12.6142C4.7089 13.0108 6.31877 13.9482 6.71288 14.1707C6.95184 14.3054 7.18033 14.3024 7.41031 14.1697Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.5906 15.0292L7.41031 16.8596C7.18033 16.9923 6.95134 16.9953 6.71288 16.8606C6.31877 16.6381 4.7089 15.7007 4.02794 15.3041L4 15.2877V13.9417L6.72585 15.5251C6.93189 15.6444 7.18731 15.6429 7.39384 15.5251C7.56645 15.4273 12.7278 12.4595 12.8051 12.4146C12.8806 12.3711 12.966 12.3478 13.053 12.3467C13.1401 12.3457 13.226 12.367 13.3025 12.4086C13.4882 12.516 13.6745 12.6225 13.8613 12.7279C14.0159 12.8167 14.0089 13.0617 13.8707 13.1415L10.5906 15.0292Z",
                fill: "white"
            })
        ]
    });
};
var $8f766f4c3596db56$export$2e2bcd8739ae039 = $8f766f4c3596db56$var$TodoistIcon;

});

parcelRegister("haSA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdd292bd55d5ab15$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $fdd292bd55d5ab15$var$WebexIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-554.5",
                y: "-363.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M20.5 6.177H3.5V18.551H20.5V6.177Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                mask: "url(#mask0_719_13847)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.77473 18.5019C5.62694 18.5019 4.55554 14.5209 4.31548 13.7465C3.71261 11.8018 3.52935 10.05 3.50994 9.86618C3.39799 8.80539 4.24877 8.06718 5.18252 8.06718C5.8895 8.06718 6.71005 8.49041 6.81877 9.51726C6.83761 9.68995 6.98136 11.1795 7.48984 12.8026C8.02049 14.4964 8.58341 15.1479 8.98879 15.1479C9.64347 15.1479 10.0429 13.4664 10.396 11.8653C10.6562 10.6857 10.9374 9.49712 11.4926 8.44128C12.4585 6.60445 13.9181 6.177 15.1791 6.177C17.944 6.177 19.3278 9.38049 19.3278 10.2105C19.3278 11.5975 18.1965 11.9513 17.7062 11.9513C16.6338 11.9513 16.2703 11.2327 15.9643 10.6029C15.689 10.0363 15.4016 9.56515 15.0299 9.56515C14.9078 9.56515 14.7946 9.62698 14.69 9.73341C13.7662 10.6723 13.4565 15.584 11.6095 17.4612C10.5856 18.5019 9.47152 18.5019 8.77473 18.5019Z",
                        fill: "#00BBFF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.8181 8.06718C18.6934 8.06718 18.5681 8.07894 18.4451 8.1032C19.0296 8.94596 19.3221 9.82891 19.3221 10.2104C19.3221 11.5975 18.1907 11.9512 17.7004 11.9512C17.3178 11.9512 17.0254 11.8597 16.7937 11.7134C16.7916 11.7221 16.7895 11.7307 16.7873 11.7394C16.7184 12.0147 16.664 12.3159 16.5698 12.6092C16.3888 13.1729 16.1446 13.8168 15.8839 14.3151C15.6028 14.8523 15.3246 15.1666 14.9929 15.1501C14.6157 15.1314 14.3099 14.6452 13.9298 13.2711C13.8072 12.8281 13.6937 12.3423 13.5885 11.8653C13.3276 10.6822 13.0074 9.49254 12.4598 8.44128C11.5653 6.72426 10.0396 6.177 8.82156 6.177C7.69192 6.177 6.84795 6.71182 6.18495 7.3857C6.00175 7.57192 5.80158 7.82283 5.60059 8.11766C6.17886 8.25694 6.72565 8.69224 6.81293 9.51716C6.83015 9.67444 6.95085 10.9237 7.35628 12.3714C7.4726 12.0084 7.64222 11.4709 8.03625 10.6029C8.22939 10.2054 8.40369 9.94325 8.56092 9.78348C8.70514 9.63686 8.83499 9.57634 8.95193 9.57634C9.07804 9.57634 9.50861 9.69177 9.92778 11.1628C10.4477 12.9869 10.8346 15.8898 12.3086 17.4312C12.9587 18.1111 13.8685 18.551 15.1294 18.551C16.2358 18.551 17.1582 18.0637 17.8159 17.3859C18.8973 16.2712 19.4898 14.4284 19.7011 13.7465C20.3026 11.8064 20.4711 10.0518 20.4907 9.86618C20.6026 8.80539 19.709 8.06718 18.8181 8.06718Z",
                        fill: "#316AFF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                id: "mask0_647_117",
                maskUnits: "userSpaceOnUse",
                x: "4",
                y: "6",
                width: "16",
                height: "12",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M20 6H4V17.6461H20V6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                mask: "url(#mask0_647_117)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint0_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint1_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint2_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint3_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint4_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint5_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint6_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint7_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint8_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M14.9922 6C13.8054 6 12.4317 6.4023 11.5225 8.13109C11 9.12482 10.7353 10.2435 10.4905 11.3537C10.4099 11.719 10.3267 12.0888 10.2382 12.4394V17.4624C10.6873 17.3353 11.1697 17.0908 11.6326 16.6205C13.3709 14.8536 13.6625 10.2308 14.5319 9.34721C14.6303 9.24703 14.7369 9.18884 14.8518 9.18884C15.2016 9.18884 15.4722 9.63224 15.7312 10.1655C16.0192 10.7583 16.3613 11.4346 17.3707 11.4346C17.8322 11.4346 18.8969 11.1017 18.8969 9.79624C18.8969 9.01505 17.5945 6 14.9922 6Z",
                        fill: "url(#paint9_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint10_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint11_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint12_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint13_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint14_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "#316AFF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint15_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint16_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint17_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint18_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint19_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint20_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint21_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint22_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint23_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint24_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint25_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint26_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint27_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint28_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint29_radial_647_117)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint0_linear_647_117",
                        x1: "17.2757",
                        y1: "9.40344",
                        x2: "6.80986",
                        y2: "12.8357",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#5CEE64"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00BBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint1_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.09 12.186) rotate(-120.86) scale(6.85625 5.75574)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#007383"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#00717E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint2_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(14.5948 10.9103) rotate(-126.734) scale(5.59154 3.67393)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#218970"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.459527",
                                stopColor: "#267E6A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#026C51",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint3_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(9.6952 12.5099) rotate(-107.468) scale(4.554 2.37251)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#178697"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#17838F",
                                stopOpacity: "0.79"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint4_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(11.7199 12.4856) rotate(-120.86) scale(11.5648 3.56733)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#25342F",
                                stopOpacity: "0.3"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#25342F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint5_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.7828 11.0371) rotate(85.0979) scale(4.35562 2.47045)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#056D4F"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.232593",
                                stopColor: "#056C4E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.598902",
                                stopColor: "#056C4E",
                                stopOpacity: "0.300824"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#056C4F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint6_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.9754 3.99288) rotate(57.0774) scale(5.12012 2.6855)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#22B67B"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#24BE82"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#24BE82",
                                stopOpacity: "0.07"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint7_linear_647_117",
                        x1: "0.0633092",
                        y1: "11.6988",
                        x2: "7.4802",
                        y2: "11.7598",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint8_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(1.65669 5.0183) rotate(49.6506) scale(6.68716 6.67046)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint9_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.01337 1.6515) rotate(48.0118) scale(13.5629 13.5415)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#00B8FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.745423",
                                stopColor: "#00B9FC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint10_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.73139 11.8243) rotate(-107.468) scale(6.53747 4.52974)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint11_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.6701 9.34133) rotate(-129.551) scale(4.62291 3.23649)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#5FEC50"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#3CC08E",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint12_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.0084 12.3189) rotate(-79.0944) scale(1.39957 0.968007)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint13_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.941 12.2159) rotate(-77.8798) scale(1.15379 1.61246)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint14_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(18.3155 10.1373) rotate(-132.79) scale(3.82739 2.68878)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#5FF05B"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.813285",
                                stopColor: "#5DE955",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint15_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.1186 11.2367) rotate(37.4559) scale(3.40381 4.73123)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.966119",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint16_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.2718 11.6203) rotate(8.48611) scale(4.01618 5.99473)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint17_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.5977 12.1185) rotate(24.6631) scale(3.43068 6.11312)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.756788",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint18_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.1948 12.3217) rotate(95.8028) scale(6.16725 3.37972)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint19_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.1186 9.59893) rotate(93.6671) scale(7.42211 2.64877)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint20_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.70726 11.1422) rotate(84.8296) scale(3.93849 2.08658)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint21_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.70442 11.2481) rotate(87.2504) scale(4.11044 3.39354)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint22_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(9.63961 15.1104) rotate(-23.1725) scale(4.58388 8.95991)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint23_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.00865 10.2431) rotate(-159.526) scale(3.03689 5.19997)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#1A3DA0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint24_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(5.33541 11.2767) rotate(16.749) scale(5.79218 5.84719)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#1E3882"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.761404",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint25_linear_647_117",
                        x1: "3.51831",
                        y1: "8.07299",
                        x2: "9.22598",
                        y2: "11.7159",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.229329",
                                stopColor: "#1DC4FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1CC1FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint26_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(1.65635 5.01803) rotate(49.6506) scale(6.68716 6.67046)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint27_linear_647_117",
                        x1: "3.8338",
                        y1: "8.25908",
                        x2: "5.43479",
                        y2: "9.71047",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint28_linear_647_117",
                        x1: "3.40845",
                        y1: "9.36998",
                        x2: "5.62288",
                        y2: "9.52796",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint29_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.73119 11.8243) rotate(-107.468) scale(6.53747 4.52974)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fdd292bd55d5ab15$export$2e2bcd8739ae039 = $fdd292bd55d5ab15$var$WebexIcon;

});

parcelRegister("bradz", function(module, exports) {

$parcel$export(module.exports, "default", () => $50dc305664cde58a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $50dc305664cde58a$var$ZeplinIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    });
};
var $50dc305664cde58a$export$2e2bcd8739ae039 = $50dc305664cde58a$var$ZeplinIcon;

});

parcelRegister("2MYL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $155304b7e928092c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $155304b7e928092c$var$ZendeskIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-491.5",
                y: "-219.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#03363D"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.6092 9.34881V17.3365H4.99316L11.6092 9.34881ZM11.6092 6.48242C11.6092 7.35976 11.2607 8.20117 10.6403 8.82155C10.0199 9.44192 9.17853 9.79044 8.30119 9.79044C7.42384 9.79044 6.58244 9.44192 5.96206 8.82155C5.34169 8.20117 4.99316 7.35976 4.99316 6.48242H11.6092ZM12.6991 17.3372C12.6991 16.4598 13.0477 15.6184 13.668 14.9981C14.2884 14.3777 15.1298 14.0292 16.0072 14.0292C16.8845 14.0292 17.7259 14.3777 18.3463 14.9981C18.9667 15.6184 19.3152 16.4598 19.3152 17.3372H12.6991ZM12.6991 14.4708V6.48242H19.3166L12.6991 14.4701V14.4708Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M11.4666 9.80166V17.609H5L11.4666 9.80166ZM11.4666 7C11.4666 7.85753 11.126 8.67994 10.5196 9.2863C9.91326 9.89267 9.09085 10.2333 8.23332 10.2333C7.37579 10.2333 6.55338 9.89267 5.94702 9.2863C5.34065 8.67994 5 7.85753 5 7H11.4666ZM12.532 17.6096C12.532 16.7521 12.8726 15.9297 13.479 15.3233C14.0854 14.717 14.9078 14.3763 15.7653 14.3763C16.6228 14.3763 17.4452 14.717 18.0516 15.3233C18.658 15.9297 18.9986 16.7521 18.9986 17.6096H12.532ZM12.532 14.808V7H19L12.532 14.8073V14.808Z",
            fill: "#03363D"
        })
    });
};
var $155304b7e928092c$export$2e2bcd8739ae039 = $155304b7e928092c$var$ZendeskIcon;

});

parcelRegister("gpecJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3595a920f79e111e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

const $3595a920f79e111e$var$GitbookIcon = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        fill: `var(--ds-icon, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
        })
    });
var $3595a920f79e111e$export$2e2bcd8739ae039 = $3595a920f79e111e$var$GitbookIcon;

});

parcelRegister("40pJL", function(module, exports) {

$parcel$export(module.exports, "default", () => $585df7fab60abb83$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $585df7fab60abb83$var$LaunchDarklyIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-683.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M20.0232 12.0808C20.0002 12.2346 19.9148 12.3512 19.8075 12.4584C17.3508 14.9147 14.895 17.3719 12.4389 19.8288C12.4116 19.8561 12.3853 19.8845 12.3562 19.9098C12.2424 20.0088 12.113 20.0247 11.9781 19.9655C11.845 19.9072 11.7732 19.798 11.7632 19.6539C11.7574 19.5702 11.7891 19.4944 11.8388 19.4264C11.9362 19.2931 12.0329 19.1593 12.13 19.0257C12.7486 18.1738 13.3672 17.3218 13.9859 16.47C14.3904 15.913 14.795 15.3562 15.1995 14.7994C15.3066 14.6519 15.4141 14.5047 15.5208 14.357C15.5315 14.3423 15.5483 14.3295 15.5454 14.3065C15.5243 14.3004 15.5082 14.3131 15.4912 14.32C14.8996 14.5611 14.308 14.8024 13.7166 15.0438C13.2263 15.2439 12.7362 15.4442 12.246 15.6446C11.1843 16.0784 10.1224 16.5119 9.06106 16.9467C8.97552 16.9817 8.88978 17.0024 8.79819 16.9813C8.65305 16.9479 8.54691 16.8331 8.52155 16.684C8.49883 16.5505 8.56326 16.4093 8.68877 16.3339C8.9313 16.1881 9.17582 16.0455 9.41951 15.9016C10.289 15.3879 11.1584 14.8742 12.028 14.3607C12.7979 13.9061 13.568 13.4519 14.338 12.9974C14.3655 12.9812 14.3924 12.9642 14.4339 12.9389C14.3588 12.9323 14.2988 12.9253 14.2387 12.922C13.9713 12.9073 13.7038 12.894 13.4363 12.8793C13.2181 12.8673 13 12.8547 12.7819 12.8415C12.5296 12.8261 12.2774 12.8095 12.0251 12.7943C11.9225 12.788 11.8197 12.7846 11.717 12.7786C11.5224 12.7673 11.3279 12.7548 11.1333 12.7432C11.0542 12.7385 10.975 12.7358 10.8959 12.7303C10.7057 12.7172 10.515 12.711 10.3246 12.6999C10.0723 12.6852 9.82012 12.6679 9.56774 12.6531C9.48432 12.6482 9.40084 12.6449 9.31742 12.6397C9.0523 12.6232 8.78686 12.6112 8.52161 12.5966C8.29917 12.5844 8.07679 12.5711 7.85434 12.5583C7.62765 12.5453 7.40082 12.5335 7.17426 12.519C6.95188 12.5048 6.72956 12.4913 6.50699 12.4805C6.28229 12.4696 6.05785 12.4551 5.83328 12.4422C5.61083 12.4294 5.38845 12.4166 5.166 12.4038C4.94356 12.391 4.72111 12.3791 4.49873 12.3648C4.43675 12.3608 4.37431 12.3592 4.31284 12.3523C4.16358 12.3353 4.05918 12.256 4.00602 12.1135C3.99707 12.0894 3.99243 12.0637 3.97705 12.0422V11.9393C3.99733 11.9207 3.99932 11.8936 4.0091 11.8701C4.06504 11.736 4.16332 11.6549 4.30917 11.6409C4.4307 11.6293 4.5528 11.6239 4.67464 11.6167C4.89921 11.6034 5.12378 11.5908 5.34835 11.5778C5.5708 11.565 5.79318 11.5517 6.01569 11.5395C6.28312 11.5249 6.55069 11.513 6.818 11.4964C6.89929 11.4914 6.98058 11.4877 7.06188 11.483C7.24364 11.4725 7.42528 11.4591 7.60705 11.4487C7.79532 11.438 7.98384 11.432 8.17185 11.4184C8.25315 11.4125 8.33451 11.4106 8.4158 11.4056C8.60606 11.3938 8.79639 11.3816 8.98672 11.3705C9.08938 11.3644 9.19223 11.3612 9.2949 11.355C9.54721 11.3397 9.79945 11.3229 10.0518 11.3077C10.2741 11.2942 10.4967 11.282 10.7191 11.2693C10.9458 11.2563 11.1726 11.2433 11.3993 11.2303C11.6196 11.2176 11.8398 11.2048 12.0602 11.1922C12.2847 11.1792 12.5093 11.1658 12.7339 11.1535C13.0014 11.1389 13.2689 11.127 13.5362 11.1105C13.6175 11.1055 13.6988 11.1016 13.7801 11.0971C13.9812 11.0858 14.1821 11.0732 14.3832 11.0609C14.3985 11.0599 14.4156 11.0646 14.4308 11.0529C14.4137 11.033 14.3934 11.0251 14.3751 11.0143C13.5146 10.5062 12.654 9.99844 11.7936 9.49047C10.898 8.96178 10.0024 8.43308 9.10689 7.90432C8.96837 7.82258 8.82909 7.74206 8.69192 7.65813C8.56776 7.58211 8.50449 7.44392 8.52374 7.31442C8.55817 7.0829 8.80701 6.93975 9.02933 7.03359C9.54483 7.25121 10.0641 7.45969 10.5821 7.67152C11.5167 8.05372 12.4516 8.43553 13.3863 8.81767C14.0887 9.10486 14.7912 9.39225 15.4938 9.679C15.5099 9.68556 15.5262 9.70217 15.5467 9.68743C15.5473 9.66503 15.5315 9.65177 15.5205 9.63665C15.1123 9.07442 14.7037 8.51251 14.2954 7.95041C13.7824 7.24426 13.2698 6.53792 12.7569 5.8317C12.4532 5.41352 12.1522 4.99341 11.8443 4.57832C11.679 4.35536 11.8105 4.07621 12.0167 4.01719C12.031 4.01313 12.0443 4.00579 12.0581 4C12.101 4 12.1439 4 12.1868 4C12.282 4.02349 12.354 4.08136 12.4221 4.14939C14.8857 6.61367 17.3497 9.07744 19.8147 11.5404C19.9208 11.6464 20.0037 11.7613 20.0233 11.9138V12.081L20.0232 12.0808Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M19.9999 12.0808C19.977 12.2346 19.8919 12.3512 19.7849 12.4584C17.3353 14.9147 14.8865 17.3719 12.4375 19.8288C12.4103 19.8561 12.384 19.8845 12.355 19.9098C12.2415 20.0088 12.1125 20.0247 11.978 19.9655C11.8453 19.9072 11.7737 19.798 11.7638 19.6539C11.758 19.5702 11.7896 19.4944 11.8391 19.4264C11.9362 19.2931 12.0327 19.1593 12.1295 19.0257C12.7463 18.1738 13.3631 17.3218 13.98 16.47C14.3833 15.913 14.7867 15.3562 15.1901 14.7994C15.2969 14.6519 15.4041 14.5047 15.5105 14.357C15.5212 14.3423 15.5379 14.3295 15.535 14.3065C15.514 14.3004 15.4979 14.3131 15.481 14.32C14.891 14.5611 14.3012 14.8024 13.7115 15.0438C13.2226 15.2439 12.7339 15.4442 12.2451 15.6446C11.1865 16.0784 10.1277 16.5119 9.06936 16.9467C8.98407 16.9817 8.89858 17.0024 8.80725 16.9813C8.66253 16.9479 8.55669 16.8331 8.53141 16.684C8.50875 16.5505 8.573 16.4093 8.69815 16.3339C8.93998 16.1881 9.18379 16.0455 9.42678 15.9016C10.2938 15.3879 11.1607 14.8742 12.0278 14.3607C12.7954 13.9061 13.5634 13.4519 14.3311 12.9974C14.3585 12.9812 14.3854 12.9642 14.4267 12.9389C14.3518 12.9323 14.292 12.9253 14.232 12.922C13.9654 12.9073 13.6987 12.894 13.432 12.8793C13.2145 12.8673 12.997 12.8547 12.7795 12.8415C12.5279 12.8261 12.2765 12.8095 12.0249 12.7943C11.9225 12.788 11.82 12.7846 11.7177 12.7786C11.5237 12.7673 11.3296 12.7548 11.1356 12.7432C11.0568 12.7385 10.9777 12.7358 10.8989 12.7303C10.7092 12.7172 10.5191 12.711 10.3293 12.6999C10.0777 12.6852 9.82623 12.6679 9.57458 12.6531C9.49141 12.6482 9.40817 12.6449 9.32499 12.6397C9.06063 12.6232 8.79596 12.6112 8.53147 12.5966C8.30967 12.5844 8.08793 12.5711 7.86612 12.5583C7.64008 12.5453 7.41391 12.5335 7.188 12.519C6.96626 12.5048 6.74458 12.4913 6.52265 12.4805C6.2986 12.4696 6.0748 12.4551 5.85088 12.4422C5.62907 12.4294 5.40733 12.4166 5.18553 12.4038C4.96372 12.391 4.74192 12.3791 4.52018 12.3648C4.45837 12.3608 4.39612 12.3592 4.33483 12.3523C4.18599 12.3353 4.08189 12.256 4.02888 12.1135C4.01996 12.0894 4.01534 12.0637 4 12.0422V11.9393C4.02022 11.9207 4.02221 11.8936 4.03196 11.8701C4.08773 11.736 4.18574 11.6549 4.33117 11.6409C4.45234 11.6293 4.57409 11.6239 4.69558 11.6167C4.9195 11.6034 5.14343 11.5908 5.36735 11.5778C5.58915 11.565 5.81089 11.5517 6.03276 11.5395C6.29943 11.5249 6.56623 11.513 6.83276 11.4964C6.91382 11.4914 6.99488 11.4877 7.07594 11.483C7.25718 11.4725 7.4383 11.4591 7.61954 11.4487C7.80727 11.438 7.99525 11.432 8.18272 11.4184C8.26378 11.4125 8.3449 11.4106 8.42596 11.4056C8.61568 11.3938 8.80546 11.3816 8.99523 11.3705C9.0976 11.3644 9.20016 11.3612 9.30253 11.355C9.55411 11.3397 9.80563 11.3229 10.0572 11.3077C10.279 11.2942 10.5008 11.282 10.7226 11.2693C10.9487 11.2563 11.1748 11.2433 11.4008 11.2303C11.6205 11.2176 11.8401 11.2048 12.0598 11.1922C12.2837 11.1792 12.5077 11.1658 12.7316 11.1535C12.9983 11.1389 13.2651 11.127 13.5316 11.1105C13.6127 11.1055 13.6938 11.1016 13.7748 11.0971C13.9753 11.0858 14.1757 11.0732 14.3761 11.0609C14.3914 11.0599 14.4085 11.0646 14.4236 11.0529C14.4066 11.033 14.3863 11.0251 14.3681 11.0143C13.5101 10.5062 12.652 9.99844 11.794 9.49047C10.901 8.96178 10.008 8.43308 9.11506 7.90432C8.97694 7.82258 8.83806 7.74206 8.70129 7.65813C8.57749 7.58211 8.5144 7.44392 8.53359 7.31442C8.56793 7.0829 8.81604 6.93975 9.03772 7.03359C9.55174 7.25121 10.0695 7.45969 10.586 7.67152C11.5179 8.05372 12.4501 8.43553 13.3821 8.81767C14.0826 9.10486 14.783 9.39225 15.4836 9.679C15.4996 9.68556 15.5159 9.70217 15.5363 9.68743C15.5369 9.66503 15.5212 9.65177 15.5102 9.63665C15.1032 9.07442 14.6957 8.51251 14.2886 7.95041C13.7771 7.24426 13.2659 6.53792 12.7546 5.8317C12.4518 5.41352 12.1516 4.99341 11.8446 4.57832C11.6797 4.35536 11.8109 4.07621 12.0165 4.01719C12.0307 4.01313 12.044 4.00579 12.0578 4C12.1005 4 12.1433 4 12.1861 4C12.281 4.02349 12.3529 4.08136 12.4207 4.14939C14.8772 6.61367 17.3341 9.07744 19.792 11.5404C19.8978 11.6464 19.9805 11.7613 20 11.9138V12.081L19.9999 12.0808Z",
            fill: "black"
        })
    });
};
var $585df7fab60abb83$export$2e2bcd8739ae039 = $585df7fab60abb83$var$LaunchDarklyIcon;

});

parcelRegister("0DeLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6fc5bcf23cf5df5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $e6fc5bcf23cf5df5$var$PagerDutyIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-731.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.33974 9.0588C7.33988 9.05866 7.33996 9.05847 7.33996 9.05827C7.33996 7.60876 7.34084 6.15925 7.3382 4.70974C7.3382 4.5796 7.33644 4.4987 7.51495 4.50002C9.30876 4.51057 11.1026 4.49738 12.8964 4.51892C13.9116 4.53123 14.8801 4.77262 15.7546 5.30858C16.8256 5.96414 17.4222 6.94066 17.6117 8.16868C17.8148 9.48551 17.6012 10.7206 16.7918 11.8057C16.1033 12.7294 15.1439 13.2175 14.0285 13.4329C13.3347 13.567 12.6326 13.5846 11.9309 13.5899C10.4668 13.6013 9.00231 13.5912 7.53781 13.5991C7.36414 13.6 7.33557 13.5411 7.33645 13.3859C7.34172 11.9438 7.33952 10.5014 7.33952 9.05933C7.33952 9.05913 7.3396 9.05894 7.33974 9.0588Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.35232 17.4818C7.35232 16.8821 7.35539 16.2819 7.34968 15.6822C7.34836 15.5516 7.36463 15.4905 7.52246 15.4931C8.14414 15.5037 8.76626 15.5024 9.38794 15.4931C9.53215 15.4909 9.55281 15.5415 9.55237 15.6681C9.54798 16.89 9.5471 18.1118 9.55325 19.3333C9.55413 19.4753 9.50841 19.5003 9.37959 19.499C8.75791 19.4929 8.13579 19.4911 7.51411 19.4999C7.3699 19.5021 7.34836 19.452 7.34968 19.3249C7.35583 18.7102 7.35232 18.096 7.35232 17.4813V17.4818Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M9.54312 8.99636C9.54312 8.1834 9.54488 7.37088 9.54093 6.55791C9.54049 6.43788 9.55148 6.37589 9.70184 6.37677C10.7051 6.38424 11.7084 6.36446 12.7113 6.38776C13.2833 6.40095 13.8408 6.53021 14.3464 6.81996C15.0103 7.20028 15.3295 7.79604 15.3967 8.54042C15.4464 9.09221 15.4223 9.63697 15.1853 10.1514C14.8072 10.9723 14.1037 11.3416 13.2675 11.521C12.8942 11.601 12.5143 11.6195 12.1332 11.6195C11.3422 11.619 10.5513 11.612 9.76075 11.6247C9.56818 11.6278 9.53697 11.565 9.53917 11.3913C9.5484 10.5933 9.54312 9.79481 9.54312 8.9968V8.99636Z",
                fill: "#04AB38"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.9969 11.9995C19.9969 14.6225 19.9963 17.2458 19.9997 19.8688C19.9997 19.9713 19.985 19.9991 19.8741 19.9987C14.6273 19.995 9.38021 19.995 4.13343 19.9987C4.01562 19.9991 4 19.9684 4 19.8609C4.00312 14.62 4.00312 9.37906 4 4.13812C4 4.03094 4.015 4 4.13343 4C9.37521 4.00406 14.6167 4.00406 19.8584 4C19.98 4 20 4.03187 20 4.14562C19.9966 6.76359 19.9972 9.38125 19.9972 11.9992L19.9969 11.9995Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.67927 9.89217C8.67927 8.86191 8.6799 7.83166 8.67802 6.80141C8.67802 6.70891 8.67677 6.65142 8.80364 6.65236C10.0786 6.65985 11.3536 6.65048 12.6286 6.66579C13.3501 6.67454 14.0385 6.84609 14.6601 7.22701C15.4213 7.69292 15.8454 8.38694 15.9801 9.2597C16.1244 10.1956 15.9726 11.0733 15.3973 11.8446C14.9079 12.5011 14.226 12.8479 13.4332 13.001C12.9401 13.0964 12.4411 13.1089 11.9423 13.1126C10.9017 13.1207 9.86081 13.1135 8.81989 13.1192C8.69646 13.1198 8.67615 13.0779 8.67677 12.9676C8.68052 11.9427 8.67896 10.9174 8.67896 9.89248L8.67927 9.89217Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.68845 15.8778C8.68845 15.4515 8.69063 15.025 8.68657 14.5988C8.68563 14.506 8.6972 14.4625 8.80938 14.4644C9.25125 14.4719 9.69343 14.471 10.1353 14.4644C10.2378 14.4629 10.2525 14.4988 10.2522 14.5888C10.249 15.4572 10.2484 16.3256 10.2528 17.1936C10.2534 17.2946 10.2209 17.3124 10.1294 17.3114C9.68749 17.3071 9.24531 17.3058 8.80345 17.3121C8.70095 17.3136 8.68563 17.278 8.68657 17.1877C8.69095 16.7508 8.68845 16.3143 8.68845 15.8775V15.8778Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.2451 9.89333C10.2451 9.31556 10.2463 8.73809 10.2435 8.16031C10.2432 8.075 10.251 8.03094 10.3579 8.03157C11.071 8.03688 11.7841 8.02282 12.4969 8.03938C12.9035 8.04876 13.2997 8.14062 13.6591 8.34655C14.1309 8.61685 14.3578 9.04026 14.4056 9.56929C14.4409 9.96146 14.4237 10.3486 14.2553 10.7142C13.9866 11.2976 13.4866 11.5601 12.8922 11.6876C12.6269 11.7445 12.3569 11.7576 12.086 11.7576C11.5238 11.7573 10.9616 11.7523 10.3998 11.7613C10.2629 11.7635 10.2407 11.7189 10.2423 11.5954C10.2488 11.0283 10.2451 10.4608 10.2451 9.89365V9.89333Z",
                fill: "#04AB38"
            })
        ]
    });
};
var $e6fc5bcf23cf5df5$export$2e2bcd8739ae039 = $e6fc5bcf23cf5df5$var$PagerDutyIcon;

});

parcelRegister("9b2Uq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f26026e17a0d1b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $f0f26026e17a0d1b$var$PowerBIIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-602.5",
                y: "-507.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.4031 4H13.1618C12.7971 4 12.5015 4.29563 12.5015 4.66032V19.3397C12.5015 19.7044 12.7971 20 13.1618 20H17.4031C17.7677 20 18.0634 19.7044 18.0634 19.3397V4.66032C18.0634 4.29563 17.7677 4 17.4031 4Z",
                fill: "#B25400"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "#DE9800"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3394V19.9998H6.66032C6.29562 19.9998 6 19.7041 6 19.3394V12.6601C6 12.2954 6.29562 11.9998 6.66032 11.9998H10.9016C11.2663 11.9998 11.5619 12.2954 11.5619 12.6601V19.3394Z",
                fill: "#F3CD32"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17.4032 4H13.1619C12.7972 4 12.5016 4.29563 12.5016 4.66032V19.3397C12.5016 19.7044 12.7972 20 13.1619 20H17.4032C17.7679 20 18.0635 19.7044 18.0635 19.3397V4.66032C18.0635 4.29563 17.7679 4 17.4032 4Z",
                fill: "url(#paint0_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7873 19.3397V20H9.88572C9.52102 20 9.2254 19.7044 9.2254 19.3397V8.64762C9.2254 8.28292 9.52102 7.9873 9.88572 7.9873H14.127C14.4917 7.9873 14.7873 8.28292 14.7873 8.64762V19.3397Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7873 19.3397V20H9.88572C9.52102 20 9.2254 19.7044 9.2254 19.3397V8.64762C9.2254 8.28292 9.52102 7.9873 9.88572 7.9873H14.127C14.4917 7.9873 14.7873 8.28292 14.7873 8.64762V19.3397Z",
                fill: "url(#paint1_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3397V20H6.66032C6.29562 20 6 19.7044 6 19.3397V12.6603C6 12.2956 6.29562 12 6.66032 12H10.9016C11.2663 12 11.5619 12.2956 11.5619 12.6603V19.3397Z",
                fill: "url(#paint2_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint0_linear_384_141",
                        x1: "15.2561",
                        y1: "3.97968",
                        x2: "15.2561",
                        y2: "19.9797",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#EBBB14"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B25400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint1_linear_384_141",
                        x1: "11.9799",
                        y1: "7.93778",
                        x2: "11.9799",
                        y2: "19.9505",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#F9E583"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DE9800"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint2_linear_384_141",
                        x1: "8.75454",
                        y1: "11.9797",
                        x2: "8.75454",
                        y2: "19.9797",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#F9E68B"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F3CD32"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f0f26026e17a0d1b$export$2e2bcd8739ae039 = $f0f26026e17a0d1b$var$PowerBIIcon;

});

parcelRegister("aUMOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc04bfd19fa2e489$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $bc04bfd19fa2e489$var$ServiceNowIcon = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-539.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0473 4.00178C10.4382 3.99842 8.86528 4.4785 7.53234 5.37978C6.19941 6.28105 5.16796 7.56197 4.57171 9.05646C3.97546 10.5509 3.84191 12.1901 4.18837 13.7614C4.53483 15.3327 5.34532 16.7637 6.51478 17.8688C6.78908 18.13 7.14782 18.2844 7.52608 18.3041C7.90434 18.3237 8.27713 18.2073 8.57701 17.9759C9.56641 17.2396 10.7668 16.842 12.0001 16.842C13.2334 16.842 14.4339 17.2396 15.4233 17.9759C15.726 18.2078 16.1021 18.3232 16.4828 18.301C16.8635 18.2788 17.2236 18.1205 17.4973 17.8549C18.6576 16.7539 19.4626 15.3314 19.8092 13.7698C20.1558 12.2082 20.0282 10.5787 19.4426 9.09017C18.8571 7.60161 17.8404 6.32184 16.5228 5.41488C15.2052 4.50793 13.6467 4.01512 12.0473 3.99963M12.0001 16.0379C11.4713 16.0522 10.9451 15.9586 10.4536 15.7628C9.96216 15.567 9.51573 15.2731 9.1416 14.8991C8.76746 14.525 8.47347 14.0787 8.27754 13.5873C8.08161 13.0959 7.98787 12.5697 8.00202 12.0408C8.00202 10.9805 8.42326 9.96353 9.17305 9.21374C9.92284 8.46395 10.9398 8.04272 12.0001 8.04272C13.0605 8.04272 14.0774 8.46395 14.8272 9.21374C15.577 9.96353 15.9983 10.9805 15.9983 12.0408C16.0124 12.5697 15.9187 13.0959 15.7227 13.5873C15.5268 14.0787 15.2328 14.525 14.8587 14.8991C14.4846 15.2731 14.0381 15.567 13.5467 15.7628C13.0552 15.9586 12.529 16.0522 12.0001 16.0379Z",
                fill: "#62D84E"
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0473 5.00214C10.4382 4.99878 8.86528 5.47886 7.53234 6.38014C6.19941 7.28142 5.16796 8.56233 4.57171 10.0568C3.97546 11.5513 3.84191 13.1905 4.18837 14.7618C4.53483 16.333 5.34532 17.764 6.51478 18.8692C6.78908 19.1304 7.14782 19.2848 7.52608 19.3044C7.90434 19.3241 8.27713 19.2077 8.57701 18.9763C9.56641 18.24 10.7668 17.8423 12.0001 17.8423C13.2334 17.8423 14.4339 18.24 15.4233 18.9763C15.726 19.2082 16.1021 19.3236 16.4828 19.3013C16.8635 19.2791 17.2236 19.1208 17.4973 18.8553C18.6576 17.7542 19.4626 16.3317 19.8092 14.7702C20.1558 13.2086 20.0282 11.5791 19.4426 10.0905C18.8571 8.60198 17.8404 7.3222 16.5228 6.41525C15.2052 5.50829 13.6467 5.01549 12.0473 5M12.0001 17.0382C11.4713 17.0525 10.9451 16.9589 10.4536 16.7631C9.96216 16.5674 9.51573 16.2735 9.1416 15.8994C8.76746 15.5254 8.47347 15.0791 8.27754 14.5876C8.08161 14.0962 7.98787 13.57 8.00202 13.0412C8.00202 11.9808 8.42326 10.9639 9.17305 10.2141C9.92284 9.46432 10.9398 9.04309 12.0001 9.04309C13.0605 9.04309 14.0774 9.46432 14.8272 10.2141C15.577 10.9639 15.9983 11.9808 15.9983 13.0412C16.0124 13.57 15.9187 14.0962 15.7227 14.5876C15.5268 15.0791 15.2328 15.5254 14.8587 15.8994C14.4846 16.2735 14.0381 16.5674 13.5467 16.7631C13.0552 16.9589 12.529 17.0525 12.0001 17.0382Z",
            fill: "#62D84E"
        })
    });
};
var $bc04bfd19fa2e489$export$2e2bcd8739ae039 = $bc04bfd19fa2e489$var$ServiceNowIcon;

});

parcelRegister("1im96", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a761931aa22061b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $9a761931aa22061b$var$AWSS3Icon = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("title", {
                children: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                width: "24",
                height: "24",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                        id: "Icon-Architecture-BG/64/Storage",
                        fill: "#7AA116",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            id: "Rectangle",
                            x: "0",
                            y: "0",
                            width: "24",
                            height: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
                        transform: "scale(0.3) translate(12.999900, 11.999600)",
                        fill: "#FFFFFF",
                        width: "24",
                        height: "24",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
                            id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
                        })
                    })
                ]
            })
        ]
    });
var $9a761931aa22061b$export$2e2bcd8739ae039 = $9a761931aa22061b$var$AWSS3Icon;

});

parcelRegister("gixZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $47db84d3d54224a3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $47db84d3d54224a3$export$e16bd899bb4eebf9 = ()=>{
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "-587.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M5.20962 17.0782L5.91523 18.2907C6.06186 18.546 6.27262 18.7466 6.52005 18.8925L9.04009 14.5529H4C4 14.8355 4.07331 15.1181 4.21993 15.3734L5.20962 17.0782Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M12 9.44751L9.47995 5.10791C9.23253 5.25378 9.02176 5.45435 8.87514 5.70962L4.21993 13.7324C4.07601 13.9822 4.00019 14.265 4 14.5529H9.04009L12 9.44751Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M17.4799 18.8925C17.7273 18.7466 17.9381 18.546 18.0847 18.2907L18.3779 17.7893L19.78 15.3734C19.9266 15.1181 19.9999 14.8355 19.9999 14.5529H14.9595L16.032 16.6497L17.4799 18.8925Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M12 9.4475L14.5201 5.1079C14.2726 4.96203 13.9886 4.8891 13.6953 4.8891H10.3047C10.0115 4.8891 9.7274 4.97115 9.47998 5.1079L12 9.4475Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M14.9594 14.5529H9.03958L6.51953 18.8925C6.76695 19.0383 7.05103 19.1113 7.34427 19.1113H16.6547C16.9479 19.1113 17.232 19.0292 17.4794 18.8925L14.9594 14.5529Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M17.4525 9.72101L15.1249 5.70962C14.9782 5.45435 14.7675 5.25378 14.52 5.10791L12 9.44751L14.9599 14.5529H19.9908C19.9908 14.2703 19.9175 13.9877 19.7709 13.7324L17.4525 9.72101Z",
                        fill: "#FFBA00"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                clipPath: "url(#clip0_271_181643)",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip1_271_181643)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white",
                            fillOpacity: "0.01"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                            clipPath: "url(#clip2_271_181643)",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                    d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
                                    fill: "#0066DA"
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                    d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
                                    fill: "#00AC47"
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                    d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
                                    fill: "#EA4335"
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                    d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
                                    fill: "#00832D"
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                    d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
                                    fill: "#2684FC"
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                    d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
                                    fill: "#FFBA00"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_271_181643",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip1_271_181643",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip2_271_181643",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "20",
                            height: "18.3333",
                            fill: "white",
                            transform: "translate(2 2.83325)"
                        })
                    })
                ]
            })
        ]
    });
};
var $47db84d3d54224a3$export$2e2bcd8739ae039 = $47db84d3d54224a3$export$e16bd899bb4eebf9;

});

parcelRegister("kFf5O", function(module, exports) {

$parcel$export(module.exports, "getLogoVersion", () => $4bb32bdf79c301bd$export$f2e275790a265e16);
$parcel$export(module.exports, "get3PLogo", () => $4bb32bdf79c301bd$export$fab9faef3411dc6c);
$parcel$export(module.exports, "RovoLogoFromLogo", () => $4bb32bdf79c301bd$export$32db889b380fa03c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5LWLA = parcelRequire("5LWLA");
const $4bb32bdf79c301bd$var$iconContainerStyles = {
    small: (0, $8CUq3.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $8CUq3.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $8CUq3.xcss)({
        width: '40px',
        height: '40px'
    }),
    xlarge: (0, $8CUq3.xcss)({
        width: '48px',
        height: '48px'
    })
};
const $4bb32bdf79c301bd$var$t25IconContainerStyles = {
    small: (0, $8CUq3.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $8CUq3.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $8CUq3.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $8CUq3.xcss)({
        width: '32x',
        height: '32px'
    })
};
const $4bb32bdf79c301bd$var$iconStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
function $4bb32bdf79c301bd$export$f2e275790a265e16(t25LogoComponent, LogoComponent) {
    return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? t25LogoComponent : LogoComponent;
}
function $4bb32bdf79c301bd$export$fab9faef3411dc6c(iconGlyph, iconLabel) {
    return (0, $VSDnB.fg)('rovo_search_custom_icon_component') ? $4bb32bdf79c301bd$export$dae027fade2c6d1d(iconGlyph, iconLabel) : $4bb32bdf79c301bd$export$7b66a86355afbb91(iconGlyph, iconLabel);
}
const $4bb32bdf79c301bd$export$1776e6671850176d = ({ glyph: SVG, label: label, size: size })=>{
    const useT25Styles = (0, $VSDnB.fg)('platform-team25-app-icon-tiles');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: [
            useT25Styles ? $4bb32bdf79c301bd$var$t25IconContainerStyles[size] : $4bb32bdf79c301bd$var$iconContainerStyles[size],
            $4bb32bdf79c301bd$var$iconStyles
        ],
        "aria-label": label,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(SVG, {})
    });
};
const $4bb32bdf79c301bd$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: "small",
            appearance: "brand"
        });
    };
};
const $4bb32bdf79c301bd$export$dae027fade2c6d1d = (glyph, defaultLabel = '')=>{
    return ({ label: label = defaultLabel })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4bb32bdf79c301bd$export$1776e6671850176d, {
            label: label,
            glyph: glyph,
            size: "medium"
        });
};
const $4bb32bdf79c301bd$export$7b66a86355afbb91 = (glyph, defaultLabel = '')=>{
    return ({ label: label = defaultLabel, testId: testId })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
            label: label,
            testId: testId,
            glyph: glyph,
            size: "medium"
        });
    };
};

});




parcelRegister("44X98", function(module, exports) {

$parcel$export(module.exports, "useCurrentProductHasFilters", () => $d93e3dbd4a449a4d$export$7fe06de49ac4bced);
$parcel$export(module.exports, "useGetCurrentProductFilters", () => $d93e3dbd4a449a4d$export$1f8e3e68f7016027);
$parcel$export(module.exports, "useCurrentProductHasAppliedFilters", () => $d93e3dbd4a449a4d$export$75dfe0d9a43fb0ea);
$parcel$export(module.exports, "useCurrentProductGenericSelectedFilterCount", () => $d93e3dbd4a449a4d$export$b5ddd6b67ba52fed);

var $kv2Va = parcelRequire("kv2Va");

var $3UF9C = parcelRequire("3UF9C");

var $bONub = parcelRequire("bONub");
const $d93e3dbd4a449a4d$export$7fe06de49ac4bced = ()=>{
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const product = getActiveProduct();
    const { filterDefinitions: filterDefinitions } = (0, $3UF9C.useGenericFilters)();
    return !!(product && filterDefinitions[product.id]?.length > 0);
};
const $d93e3dbd4a449a4d$export$1f8e3e68f7016027 = ()=>{
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const product = getActiveProduct();
    const { filterDefinitions: filterDefinitions } = (0, $3UF9C.useGenericFilters)();
    return product && filterDefinitions[product.id] || [];
};
const $d93e3dbd4a449a4d$export$75dfe0d9a43fb0ea = ()=>{
    const filters = $d93e3dbd4a449a4d$export$1f8e3e68f7016027();
    let hasFilters = false;
    filters.forEach((filter)=>{
        filter.store.availableFilters.forEach((option)=>{
            if (option.isChecked && option.id !== (0, $bONub.DEFAULT_OPTION)) hasFilters = true;
        });
    });
    return hasFilters;
};
const $d93e3dbd4a449a4d$export$b5ddd6b67ba52fed = ()=>{
    const filters = $d93e3dbd4a449a4d$export$1f8e3e68f7016027();
    const genericFilters = filters.filter((filter)=>filter['@type'] !== (0, $bONub.SITE_FILTER_TYPE_NAME));
    return genericFilters.reduce((filterCount, nextFilter)=>nextFilter.store.availableFilters.filter((f)=>f.isChecked).length + filterCount, 0);
};

});


parcelRegister("3QLe6", function(module, exports) {

$parcel$export(module.exports, "getSections", () => $9839fbd9dfaf5954$export$ddbcae0b0bd6b092);

var $6m35g = parcelRequire("6m35g");

var $28nD0 = parcelRequire("28nD0");
const $9839fbd9dfaf5954$export$ddbcae0b0bd6b092 = (intl)=>{
    const sections = [
        {
            id: (0, $28nD0.CrossProductScope).RECENTS,
            title: intl.formatMessage((0, $6m35g.messages).cross_product_recents_section_heading)
        },
        {
            id: (0, $28nD0.CrossProductScope).RESULTS,
            title: intl.formatMessage((0, $6m35g.messages).cross_product_results_section_heading)
        }
    ];
    return sections;
};

});

parcelRegister("c2JME", function(module, exports) {

$parcel$export(module.exports, "ResultRenderer", () => $fc4361f5a99303a0$export$464b81a1c23b01aa);

var $2OMIu = parcelRequire("2OMIu");

var $5bKWp = parcelRequire("5bKWp");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $edfe8 = parcelRequire("edfe8");

var $azBuE = parcelRequire("azBuE");

var $idS9H = parcelRequire("idS9H");

var $6m35g = parcelRequire("6m35g");

var $44X98 = parcelRequire("44X98");

var $eimKN = parcelRequire("eimKN");

var $bYLf6 = parcelRequire("bYLf6");
var $3Cqqi = parcelRequire("3Cqqi");

var $2dI5H = parcelRequire("2dI5H");

var $lOhWS = parcelRequire("lOhWS");

var $8U8gz = parcelRequire("8U8gz");

var $zHf3l = parcelRequire("zHf3l");

var $aKYAO = parcelRequire("aKYAO");

var $lVuuE = parcelRequire("lVuuE");

var $8ilpI = parcelRequire("8ilpI");

var $hI9zY = parcelRequire("hI9zY");

var $j4xTD = parcelRequire("j4xTD");
const $fc4361f5a99303a0$export$464b81a1c23b01aa = ({ productState: productState, preQueryItems: preQueryItems, postQueryItems: postQueryItems, onRetryPreQuery: onRetryPreQuery, onRetryPostQuery: onRetryPostQuery, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', preQuerySectionTitleGenerator: preQuerySectionTitleGenerator, linkComponent: linkComponent, children: children, searchFooterLabel: searchFooterLabel, appendQueryParams: appendQueryParams, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled })=>{
    const DefaultHeader = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
    const DefaultSectionFooter = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
    const intl = (0, $koVbs.default)();
    const isMobileView = (0, $aKYAO.useIsMobileView)();
    const areFiltersEnabled = (0, $44X98.useCurrentProductHasFilters)();
    const { query: query } = (0, $2dI5H.useQuery)();
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $j4xTD.useAutocorrectionEnabled)();
    const { correction: correction } = (0, $hI9zY.useAutocorrection)();
    const renderer = children && typeof children === 'function' ? children({
        query: query,
        productState: productState,
        linkComponent: linkComponent,
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItems,
        onRetryPreQuery: onRetryPreQuery,
        onRetryPostQuery: onRetryPostQuery,
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    }) : null;
    const Header = renderer?.Header || DefaultHeader;
    const SectionFooter = renderer?.SectionFooter || DefaultSectionFooter;
    const Footer = renderer?.Footer || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8U8gz.GetDefaultFooter), {
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        linkComponent: linkComponent,
        productState: productState,
        searchFooterLabel: searchFooterLabel
    });
    const renderResults = (0, $5uXOq.useCallback)(()=>{
        switch(productState){
            case (0, $azBuE.ProductStates).PostQueryError:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ilpI.SearchErrorScreen), {
                    onRetry: onRetryPostQuery
                });
            case (0, $azBuE.ProductStates).PostQueryTyping:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idS9H.GenericSearchResult), {
                    searchItems: postQueryItems,
                    screen: "cachedResults",
                    forceHideResultCount: true,
                    linkComponent: linkComponent,
                    isCollapsed: areFiltersEnabled || isMobileView,
                    productState: (0, $azBuE.ProductStates).PostQueryTyping,
                    appendQueryParams: appendQueryParams
                });
            case (0, $azBuE.ProductStates).PostQueryLoading:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idS9H.GenericSearchResult), {
                    searchItems: postQueryItems,
                    generateSectionTitle: ()=>intl.formatMessage((0, $6m35g.messages).cross_product_results_section_heading),
                    screen: "cachedResults",
                    forceHideResultCount: true,
                    linkComponent: linkComponent,
                    isCollapsed: areFiltersEnabled || isMobileView,
                    productState: (0, $azBuE.ProductStates).PostQueryLoading,
                    appendQueryParams: appendQueryParams,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $edfe8.LoadingSpinner), {})
                });
            case (0, $azBuE.ProductStates).PostQueryNoResult:
                return (0, $lVuuE.hasSearchResults)(postQueryItems) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idS9H.GenericSearchResult), {
                    searchItems: postQueryItems,
                    screen: "cachedResults",
                    forceHideResultCount: true,
                    linkComponent: linkComponent,
                    isCollapsed: areFiltersEnabled || isMobileView,
                    productState: (0, $azBuE.ProductStates).PostQueryLoading,
                    appendQueryParams: appendQueryParams
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eimKN.default), {
                    urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen
                });
            case (0, $azBuE.ProductStates).PostQuerySuccess:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idS9H.GenericSearchResult), {
                        searchItems: postQueryItems,
                        forceHideResultCount: autocorrectionEnabled && !!correction && correction.length > 0,
                        linkComponent: linkComponent,
                        screen: "postQuerySearchResults",
                        productState: (0, $azBuE.ProductStates).PostQuerySuccess,
                        isCollapsed: areFiltersEnabled || isMobileView,
                        renderSectionViewAll: true,
                        appendQueryParams: appendQueryParams
                    })
                });
            case (0, $azBuE.ProductStates).PreQueryError:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Cqqi.default), {});
            case (0, $azBuE.ProductStates).PreQueryLoading:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $edfe8.LoadingSpinner), {});
            case (0, $azBuE.ProductStates).PreQueryNoResult:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bYLf6.default), {});
            case (0, $azBuE.ProductStates).PreQuerySuccess:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idS9H.GenericSearchResult), {
                    searchItems: preQueryItems,
                    generateSectionTitle: ()=>intl.formatMessage((0, $6m35g.messages).cross_product_recents_section_heading),
                    linkComponent: linkComponent,
                    screen: "preQuerySearchResults",
                    forceHideResultCount: true,
                    productState: (0, $azBuE.ProductStates).PreQuerySuccess,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
        }
    }, [
        correction,
        autocorrectionEnabled,
        productState,
        preQueryItems,
        postQueryItems,
        linkComponent,
        onRetryPostQuery,
        urlGeneratorForNoResultsScreen,
        areFiltersEnabled,
        isMobileView,
        appendQueryParams,
        intl
    ]);
    const body = (0, $5uXOq.useMemo)(()=>renderer && renderer.Body && renderer?.Body() !== undefined ? renderer.Body : renderResults, [
        renderer,
        renderResults
    ]);
    const isOnLoadingScreen = productState === (0, $azBuE.ProductStates).PostQueryLoading || productState === (0, $azBuE.ProductStates).PreQueryLoading;
    const footer = typeof Footer === 'function' ? /*#__PURE__*/ (0, $2OMIu.jsx)(Footer, {}) : Footer;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lOhWS.HeightRetainingContainer), {
        retainHeight: isOnLoadingScreen,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Header, {}),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5bKWp.SearchDialogContent), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5bKWp.ResultContainerOuter), {
                        "aria-live": "polite",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bKWp.ResultContainer), {
                                children: body()
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)(SectionFooter, {})
                        ]
                    }),
                    areFiltersEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $zHf3l.FilterSection), {
                        productState: productState,
                        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled
                    })
                ]
            }),
            footer
        ]
    });
};

});
parcelRegister("eimKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $834a668e926c2b4f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4bcZr = parcelRequire("4bcZr");
var $kCMvS = parcelRequire("kCMvS");

var $1FaYJ = parcelRequire("1FaYJ");

var $k4hbD = parcelRequire("k4hbD");

var $6m35g = parcelRequire("6m35g");

var $3FqY6 = parcelRequire("3FqY6");
var $8oG5R = parcelRequire("8oG5R");
var $75NXP = parcelRequire("75NXP");

var $2dI5H = parcelRequire("2dI5H");
const $834a668e926c2b4f$export$ef6006467f04ee41 = ({ urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'' })=>{
    const intl = (0, $koVbs.default)();
    const { query: query } = (0, $2dI5H.useQuery)();
    const advancedSearchUrl = urlGeneratorForNoResultsScreen(query);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const onAdvancedSearchClicked = (0, $5uXOq.useCallback)((e)=>{
        fireAnalyticsEvent((0, $3FqY6.onAdvancedSearchSelected)({
            trigger: (0, $8oG5R.getTrigger)(e),
            actionSubjectId: (0, $3FqY6.AdvancedSearchLinkSubjectId).NO_RESULTS,
            isLoading: false,
            newTab: (0, $8oG5R.isNewTab)(e),
            isRovoCrossProductSearchLink: true
        }));
    }, [
        fireAnalyticsEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>{
        return !advancedSearchUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $k4hbD.messages).common_empty_state_body_no_advanced_search
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $6m35g.messages).cross_product_empty_state_body,
            values: {
                a: (s)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kCMvS.Link), {
                        onClick: onAdvancedSearchClicked,
                        href: advancedSearchUrl,
                        target: "_blank",
                        children: s
                    })
            }
        });
    }, [
        onAdvancedSearchClicked,
        advancedSearchUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4bcZr.EmptyState), {
        title: intl.formatMessage((0, $k4hbD.messages).common_empty_state_heading),
        Image: (0, $1FaYJ.Image),
        content: content
    });
};
var $834a668e926c2b4f$export$2e2bcd8739ae039 = $834a668e926c2b4f$export$ef6006467f04ee41;

});

parcelRegister("bYLf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $93559d09366e5717$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4bcZr = parcelRequire("4bcZr");

var $8RXs9 = parcelRequire("8RXs9");

var $k4hbD = parcelRequire("k4hbD");

const $93559d09366e5717$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("cfkMs")));
const $93559d09366e5717$var$NoPreQueryResults = ({ intl: intl, message: message })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4bcZr.EmptyState), {
        title: intl.formatMessage(message || (0, $k4hbD.messages).common_empty_state_prequery_heading),
        Image: $93559d09366e5717$var$Image
    });
var $93559d09366e5717$export$2e2bcd8739ae039 = (0, $8RXs9.default)($93559d09366e5717$var$NoPreQueryResults);

});
parcelRegister("cfkMs", function(module, exports) {

let $8ea7015cd6329f81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ea7015cd6329f81$var$load("VBVa9").then(()=>parcelRequire('ldK5O'));

});


parcelRegister("3Cqqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $022488d51ac8d1c5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4bcZr = parcelRequire("4bcZr");

var $8RXs9 = parcelRequire("8RXs9");

var $k4hbD = parcelRequire("k4hbD");

const $022488d51ac8d1c5$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("lk4JF")));
const $022488d51ac8d1c5$var$PreQueryErrorScreen = ({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4bcZr.EmptyState), {
        title: intl.formatMessage((0, $k4hbD.messages).common_error_state_prequery_heading),
        Image: $022488d51ac8d1c5$var$Image
    });
var $022488d51ac8d1c5$export$2e2bcd8739ae039 = (0, $8RXs9.default)($022488d51ac8d1c5$var$PreQueryErrorScreen);

});
parcelRegister("lk4JF", function(module, exports) {

let $f85f23a3efe51846$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f85f23a3efe51846$var$load("lknRC").then(()=>parcelRequire('2jNnj'));

});


parcelRegister("lOhWS", function(module, exports) {

$parcel$export(module.exports, "HeightRetainingContainer", () => $d7beae7cfcfd737b$export$b7b07b85de5702d4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5bKWp = parcelRequire("5bKWp");
const $d7beae7cfcfd737b$export$b7b07b85de5702d4 = ({ retainHeight: retainHeight, children: children, ...rest })=>{
    const minimumHeight = (0, $5uXOq.useRef)(undefined);
    const ref = (0, $5uXOq.useRef)(null);
    // Why is this not in a `useEffect`?
    // Render order for React is from top down (parent -> children), this enables to retain the most up to date height of the children before a transition happens.
    // useEffect happens after render so we won't be able to account for changes to child height that does not cause a render to this component, checking the height
    // when the transition happens would be too late as it will register the new height instead.
    if (retainHeight) {
        const height = ref.current?.getBoundingClientRect()?.height;
        minimumHeight.current = height;
    }
    // Despite what is said above we do need to track the initial size, this can only be done once the ref.current? is set hence the onMount useEffect here.
    (0, $5uXOq.useEffect)(()=>{
        const height = ref.current?.getBoundingClientRect()?.height;
        minimumHeight.current = height;
    }, []);
    const shouldFixMinimumHeight = retainHeight && minimumHeight.current;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bKWp.ResultRenderWrapper), {
        shouldFixMinimumHeight: shouldFixMinimumHeight,
        minimumHeight: minimumHeight.current,
        ref: ref,
        ...rest,
        children: children
    });
};

});

parcelRegister("8U8gz", function(module, exports) {

$parcel$export(module.exports, "GetDefaultFooter", () => $a50192ade6dfad61$export$e3c8b9bd86c3cfd6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1W52p = parcelRequire("1W52p");

var $a353g = parcelRequire("a353g");
const $a50192ade6dfad61$export$e3c8b9bd86c3cfd6 = ({ productState: productState, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.AdvancedSearchFooter), {
            ...rest
        })
    });
};

});

parcelRegister("zHf3l", function(module, exports) {

$parcel$export(module.exports, "FilterSection", () => $d432fe4e28a9d2bb$export$4c5b17bfcbab1742);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5bKWp = parcelRequire("5bKWp");

var $bONub = parcelRequire("bONub");

var $44X98 = parcelRequire("44X98");

var $kv2Va = parcelRequire("kv2Va");

var $azBuE = parcelRequire("azBuE");

var $2NcgO = parcelRequire("2NcgO");

var $7hfia = parcelRequire("7hfia");

var $2dI5H = parcelRequire("2dI5H");

var $eVPhA = parcelRequire("eVPhA");

var $2k6eV = parcelRequire("2k6eV");

var $fqwv7 = parcelRequire("fqwv7");

const $d432fe4e28a9d2bb$var$StaticSelectFilter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("aqGMV")).then(({ StaticSelectFilter: StaticSelectFilter })=>({
            default: StaticSelectFilter
        })));

const $d432fe4e28a9d2bb$var$MultiSelectFilter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("05f3J")).then(({ MultiSelectFilter: MultiSelectFilter })=>({
            default: MultiSelectFilter
        })));
const $d432fe4e28a9d2bb$export$58cd6790f867654e = 5;
const $d432fe4e28a9d2bb$var$Filters = ({ query: query, filters: filters, href: href, showViewAllFiltersLink: showViewAllFiltersLink })=>{
    const { resetSearchSession: resetSearchSession } = (0, $2k6eV.useSessionUserInput)();
    const selectedFiltersCount = (0, $44X98.useCurrentProductGenericSelectedFilterCount)();
    const siteFilters = filters.find((filter)=>filter['@type'] === (0, $bONub.SITE_FILTER_TYPE_NAME));
    if (!!siteFilters) siteFilters.filterConfig = {
        ...siteFilters.filterConfig,
        hideIcon: true,
        usePreloadedOptions: true
    };
    const nonSiteFilters = filters.filter((filter)=>filter['@type'] !== (0, $bONub.SITE_FILTER_TYPE_NAME));
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bKWp.SidebarContainerBorder), {}),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5bKWp.SidebarContainerPane), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5bKWp.SidebarScrollContainer), {
                            children: [
                                !!siteFilters && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2NcgO.CheckboxListFilter), {
                                    filterType: siteFilters['@type'],
                                    ...siteFilters,
                                    maxSelectable: $d432fe4e28a9d2bb$export$58cd6790f867654e
                                }),
                                nonSiteFilters.map((nonSiteFilter)=>{
                                    switch(nonSiteFilter.uiVariant){
                                        case (0, $bONub.FilterUIVariant).MULTI_SELECT:
                                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                                                fallback: null,
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)($d432fe4e28a9d2bb$var$MultiSelectFilter, {
                                                    filterType: nonSiteFilter['@type'],
                                                    ...nonSiteFilter
                                                })
                                            });
                                        case (0, $bONub.FilterUIVariant).STATIC_SELECT:
                                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                                                fallback: null,
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)($d432fe4e28a9d2bb$var$StaticSelectFilter, {
                                                    filterType: nonSiteFilter['@type'],
                                                    filterStore: nonSiteFilter.store,
                                                    sectionTitle: nonSiteFilter.sectionLabel
                                                })
                                            });
                                        default:
                                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2NcgO.CheckboxListFilter), {
                                                filterType: nonSiteFilter['@type'],
                                                ...nonSiteFilter
                                            });
                                    }
                                }),
                                !siteFilters && showViewAllFiltersLink && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqwv7.MoreFiltersContainer), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eVPhA.default), {
                                        isLoading: false,
                                        href: href,
                                        query: query,
                                        selectedFiltersCount: selectedFiltersCount,
                                        onClick: resetSearchSession
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bKWp.SidebarBottomFixedContainer), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hfia.default), {})
                        })
                    ]
                })
            ]
        }), [
        href,
        nonSiteFilters,
        query,
        resetSearchSession,
        selectedFiltersCount,
        showViewAllFiltersLink,
        siteFilters
    ]);
};
const $d432fe4e28a9d2bb$export$4c5b17bfcbab1742 = ({ productState: productState, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled = false })=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const activeProduct = getActiveProduct();
    const productId = activeProduct?.id;
    const filters = (0, $44X98.useGetCurrentProductFilters)();
    if (!productId || !filters.length) return null;
    const href = activeProduct?.generateAdvancedSearchUrl?.(query) || '';
    const showViewAllFiltersLink = !!activeProduct?.showViewAllFiltersLink;
    switch(productState){
        case (0, $azBuE.ProductStates).PostQueryTyping:
        case (0, $azBuE.ProductStates).PostQueryLoading:
        case (0, $azBuE.ProductStates).PostQuerySuccess:
        case (0, $azBuE.ProductStates).PostQueryNoResult:
        case (0, $azBuE.ProductStates).PostQueryError:
            return /*#__PURE__*/ (0, $2OMIu.jsx)($d432fe4e28a9d2bb$var$Filters, {
                query: query,
                filters: filters,
                href: href,
                showViewAllFiltersLink: showViewAllFiltersLink
            });
        case (0, $azBuE.ProductStates).Invalid:
            return null;
        default:
            if (isPreQueryFiltersEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)($d432fe4e28a9d2bb$var$Filters, {
                query: query,
                filters: filters,
                href: href,
                showViewAllFiltersLink: showViewAllFiltersLink
            });
            return null;
    }
};

});
parcelRegister("2NcgO", function(module, exports) {

$parcel$export(module.exports, "CheckboxListFilter", () => $afd12a4ffd4a0b21$export$bbc3e0c0bbb663f0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iCBcG = parcelRequire("iCBcG");

var $koVbs = parcelRequire("koVbs");

var $ujWmd = parcelRequire("ujWmd");

var $2Vjr3 = parcelRequire("2Vjr3");
var $1K1Vs = parcelRequire("1K1Vs");
var $cYugq = parcelRequire("cYugq");
var $cN0cY = parcelRequire("cN0cY");
var $7W71o = parcelRequire("7W71o");

var $gMpaQ = parcelRequire("gMpaQ");

var $3FqY6 = parcelRequire("3FqY6");
var $75NXP = parcelRequire("75NXP");

var $5aEuc = parcelRequire("5aEuc");

var $k4hbD = parcelRequire("k4hbD");

var $lnyO0 = parcelRequire("lnyO0");
const $afd12a4ffd4a0b21$var$SHOW_MORE_DEBOUNCE_TIME = 250;
const $afd12a4ffd4a0b21$export$bbc3e0c0bbb663f0 = ({ filterType: filterType, store: store, loadFilterOptions: loadFilterOptions, sectionLabel: sectionLabel, findMoreLabel: findMoreLabel, maxSelectable: maxSelectable, filterConfig: filterConfig })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const { availableFilters: availableFilters, updateFilter: updateFilter, addFilters: addFilters, isLoading: isLoading } = store;
    const usePreloadedOptions = filterConfig?.usePreloadedOptions || false;
    const showIcons = !filterConfig?.hideIcon;
    const appearanceIcon = filterConfig?.filterOptionIconShape || 'square';
    const options = availableFilters.map((filterOption)=>({
            label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnyO0.FilterOptionItem), {
                label: filterOption.label,
                iconProps: {
                    src: filterOption.avatarUrl,
                    appearance: filterConfig?.filterOptionIconShape
                }
            }),
            value: filterOption
        }));
    const visibleOptions = options.filter((option)=>option.value.isVisible);
    const onChangeCallback = (0, $5uXOq.useCallback)((value, _, checked)=>{
        updateFilter(value, checked);
    }, [
        updateFilter
    ]);
    const addFilter = (0, $5uXOq.useCallback)(({ value: value })=>{
        addFilters([
            value
        ]);
        updateFilter(value.id, true);
        fireAnalyticsEvent((0, $3FqY6.onFilterSelect)({
            filterId: value.id,
            filterSource: (0, $gMpaQ.FilterOptionSource).EXTERNAL,
            filterType: filterType
        }));
    }, [
        addFilters,
        updateFilter,
        fireAnalyticsEvent,
        filterType
    ]);
    const loadMoreFilters = (0, (/*@__PURE__*/$parcel$interopDefault($iCBcG)))((query)=>loadFilterOptions(query), $afd12a4ffd4a0b21$var$SHOW_MORE_DEBOUNCE_TIME);
    const loadAvatar = (0, $5uXOq.useCallback)(({ avatarUrl: iconUrl, name: name })=>{
        if (showIcons) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearanceIcon,
            size: 'small',
            name: name
        });
    }, [
        showIcons,
        appearanceIcon
    ]);
    const checkedValues = availableFilters.filter((filter)=>filter.isChecked);
    const showMoreOptions = options.filter((option)=>!option.value.isVisible);
    const filterPreloadedOptions = (query)=>Promise.resolve(showMoreOptions.filter((option)=>option.value.label.indexOf(query.trim().toLowerCase()) !== -1));
    const isMaxValuesSelected = !!maxSelectable && checkedValues.length === maxSelectable;
    const loadFilterItems = (isColumnGrouped = false)=>visibleOptions.map(({ value: value })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aEuc.ProductFilterItem), {
                value: value.id,
                filterType: filterType,
                icon: loadAvatar(value),
                label: value.label,
                onChange: onChangeCallback,
                isChecked: value.isChecked,
                filterSource: value.filterSource,
                isDisabled: isMaxValuesSelected && !value.isChecked,
                variant: (0, $7W71o.OptionVariant).CHECKBOX,
                LabelComponent: filterConfig?.labelComponent ?? (isColumnGrouped ? (0, $cYugq.FilterColLabelText) : (0, $cYugq.FilterRowLabelText))
            }));
    const onFocusAriaMessage = (0, $5uXOq.useCallback)((props)=>{
        const { focused: focused, options: options } = props;
        const optionIndex = options?.findIndex((option)=>{
            return option === focused;
        });
        return `Option ${focused.value.label} focused, ${optionIndex + 1} out of ${options.length}.`;
    }, []);
    const loadFilterShowMore = ()=>!(usePreloadedOptions && showMoreOptions.length === 0) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cN0cY.FilterShowMore), {
            placeholderText: findMoreLabel,
            addFilter: addFilter,
            defaultOptions: showMoreOptions || [],
            loadOptions: usePreloadedOptions ? filterPreloadedOptions : loadMoreFilters,
            buttonText: formatMessage((0, $k4hbD.messages).show_more_filters),
            filterComponent: (0, $2Vjr3.AsyncSelectFilterComponent),
            loadingMessage: ()=>formatMessage((0, $k4hbD.messages).loading_filters),
            noOptionsMessage: ()=>formatMessage((0, $k4hbD.messages).no_options_filters),
            isDisabled: isMaxValuesSelected,
            onFocusAriaMessage: onFocusAriaMessage
        });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            (!filterConfig?.filterGroupedBy || filterConfig?.filterGroupedBy === 'column') && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1K1Vs.ColumnFilterGroup), {
                title: sectionLabel,
                isLoading: isLoading,
                avatarShape: filterConfig?.filterOptionIconShape ?? 'circle',
                children: [
                    loadFilterItems(true),
                    loadFilterShowMore()
                ]
            }),
            filterConfig?.filterGroupedBy === 'row' && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1K1Vs.RowFilterGroup), {
                title: sectionLabel,
                isLoading: false,
                children: [
                    loadFilterItems(false),
                    loadFilterShowMore()
                ]
            })
        ]
    });
};

});
parcelRegister("2Vjr3", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectFilterComponent", () => $91d372b2c523ef0e$export$15e0a6dd776b6e98);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $91d372b2c523ef0e$var$isOptionType(o) {
    return o.value !== undefined;
}

const $91d372b2c523ef0e$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("4UdwD")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $91d372b2c523ef0e$export$15e0a6dd776b6e98 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.onChange = (value, { action: action })=>{
            if ($91d372b2c523ef0e$var$isOptionType(value) && (action === 'select-option' || action === 'create-option')) {
                this.props.onMenuClosed();
                this.props.refocusEditLink();
                this.props.onConfirm(value);
            }
        }, this.handleFocus = ()=>{
            this.setState({
                menuIsOpen: true
            });
        }, this.handleInputChange = (query, { action: action })=>{
            const { inputValue: inputValue } = this.state;
            if (action === 'input-change' || action === 'set-value') {
                this.setState({
                    inputValue: query
                });
                return query;
            }
            if (action === 'menu-close') {
                // want to keep menu open if user clicks on input box
                this.setState({
                    menuIsOpen: true,
                    inputValue: inputValue
                });
                // need to return inputValue to override react-select resetting
                // to empty string and clearing options if user clicks on input box
                return inputValue;
            }
        };
        this.state = {
            menuIsOpen: false,
            inputValue: ''
        };
    }
    render() {
        const { menuIsOpen: menuIsOpen, inputValue: inputValue } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {}),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($91d372b2c523ef0e$var$AsyncSelect, {
                defaultOptions: this.props.defaultOptions,
                loadOptions: this.props.loadOptions,
                autoFocus: true,
                openMenuOnFocus: true,
                ariaLiveMessages: this.props.onFocusAriaMessage ? {
                    onFocus: this.props.onFocusAriaMessage
                } : undefined,
                inputValue: inputValue,
                menuIsOpen: menuIsOpen,
                placeholder: this.props.placeholderText,
                loadingMessage: this.props.loadingMessage,
                noOptionsMessage: this.props.noOptionsMessage,
                onChange: this.onChange,
                onKeyDown: (e)=>{
                    if (e.key === 'Escape') {
                        this.props.onMenuClosed();
                        e.stopPropagation();
                        this.props.refocusEditLink();
                    }
                },
                onBlur: ()=>{
                    this.props.refocusEditLink();
                    this.props.onMenuClosed();
                },
                onFocus: this.handleFocus,
                menuPosition: "fixed",
                captureMenuScroll: true,
                onInputChange: this.handleInputChange
            })
        });
    }
}
var $91d372b2c523ef0e$export$2e2bcd8739ae039 = $91d372b2c523ef0e$export$15e0a6dd776b6e98;

});
parcelRegister("4UdwD", function(module, exports) {

let $3926e240bb39f968$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3926e240bb39f968$var$load("f6a21").then(()=>parcelRequire('c40YO'));

});


parcelRegister("1K1Vs", function(module, exports) {

$parcel$export(module.exports, "ColumnFilterGroup", () => $e5fd8fd75fbbfe7e$export$1848b6a6bb206b21);
$parcel$export(module.exports, "RowFilterGroup", () => $e5fd8fd75fbbfe7e$export$583c381620e3badb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iU60E = parcelRequire("iU60E");

var $5sY59 = parcelRequire("5sY59");
const $e5fd8fd75fbbfe7e$export$1848b6a6bb206b21 = ({ children: children, title: title, isLoading: isLoading, avatarShape: avatarShape })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iU60E.FilterGroupContainer), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iU60E.FilterGroupTitle), {
                children: title
            }),
            !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iU60E.SkeletonContainer), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sY59.SkeletonItem), {
                        avatarShape: avatarShape,
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sY59.SkeletonItem), {
                        avatarShape: avatarShape,
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sY59.SkeletonItem), {
                        avatarShape: avatarShape,
                        isShimmering: true
                    })
                ]
            })
        ]
    });
};
const $e5fd8fd75fbbfe7e$export$583c381620e3badb = ({ children: children, title: title, isLoading: isLoading, avatarShape: avatarShape = 'none' })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iU60E.FilterGroupContainer), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iU60E.FilterGroupTitle), {
                children: title
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iU60E.FilterResultRowContainer), {
                children: !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iU60E.SkeletonContainer), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sY59.SkeletonItem), {
                        avatarShape: avatarShape,
                        isShimmering: true
                    })
                })
            })
        ]
    });
};

});
parcelRegister("iU60E", function(module, exports) {

$parcel$export(module.exports, "FilterGroupTitle", () => $dc7f772610c27146$export$20c2f8430aa388ca);
$parcel$export(module.exports, "SkeletonContainer", () => $dc7f772610c27146$export$66b8cea0c448285);
$parcel$export(module.exports, "FilterGroupContainer", () => $dc7f772610c27146$export$ed1e22b72fb518f1);
$parcel$export(module.exports, "FilterResultRowContainer", () => $dc7f772610c27146$export$1c358a11c930965b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $3JZ8k = parcelRequire("3JZ8k");

var $bWGt6 = parcelRequire("bWGt6");
function $dc7f772610c27146$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dc7f772610c27146$export$20c2f8430aa388ca = /*#__PURE__*/ (0, $bWGt6.default)("h2", {
    target: "e1749x7q3"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $3JZ8k.grid).multiple(2).px,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBottom: (0, $3JZ8k.grid).multiple(0.5).px
});
const $dc7f772610c27146$export$66b8cea0c448285 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1749x7q2"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const $dc7f772610c27146$export$ed1e22b72fb518f1 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1749x7q1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':not(:first-of-type)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingTop: (0, $3JZ8k.grid).multiple(3.5).px
    }
});
const $dc7f772610c27146$export$1c358a11c930965b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1749x7q0"
})({
    name: "60msyp",
    styles: "display:flex;justify-content:left;align-items:center"
});

});

parcelRegister("5sY59", function(module, exports) {

$parcel$export(module.exports, "SkeletonItem", () => $554c3358a59b1942$export$fbc0ea7debdb77e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iKLMI = parcelRequire("iKLMI");
const $554c3358a59b1942$export$fbc0ea7debdb77e = ({ avatarShape: avatarShape = 'none', width: width, isShimmering: isShimmering, textHeight: textHeight })=>{
    const avatarShapes = Array.isArray(avatarShape) ? avatarShape : [
        avatarShape
    ];
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $iKLMI.itemSkeletonCSS)
    }, avatarShape !== 'none' ? // eslint-disable-next-line react/no-array-index-key
    avatarShapes.map((shape, idx)=>// @ts-ignore
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            key: idx,
            css: (0, $iKLMI.avatarSkeletonCSS)(shape, isShimmering)
        })) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $iKLMI.labelSkeletonCSS)(width, isShimmering, textHeight)
    })));
};

});
parcelRegister("iKLMI", function(module, exports) {

$parcel$export(module.exports, "avatarSkeletonCSS", () => $fd680b4cf434d1cc$export$5d78cba328c109d7);
$parcel$export(module.exports, "labelSkeletonCSS", () => $fd680b4cf434d1cc$export$31f9b59a0fa394ab);
$parcel$export(module.exports, "itemSkeletonCSS", () => $fd680b4cf434d1cc$export$93ea78b0b020396e);

var $k5uoT = parcelRequire("k5uoT");


var $f8Sb3 = parcelRequire("f8Sb3");

var $3JZ8k = parcelRequire("3JZ8k");
function $fd680b4cf434d1cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fd680b4cf434d1cc$var$smallItemElemSpacing = (0, $3JZ8k.grid).multiple(1.5).unitless;
const $fd680b4cf434d1cc$var$itemElemSpacing = (0, $3JZ8k.grid).multiple(1).unitless;
const $fd680b4cf434d1cc$var$itemElemSize = (0, $3JZ8k.grid).multiple(3).unitless;
const $fd680b4cf434d1cc$var$itemMinHeight = (0, $3JZ8k.grid).multiple(5).unitless;
const $fd680b4cf434d1cc$var$skeletonContentHeight = (0, $3JZ8k.grid).multiple(1.75).unitless / 2;
const $fd680b4cf434d1cc$var$shimmer = (0, $k5uoT.skeletonShimmer)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $fd680b4cf434d1cc$var$shimmerKeyframes = (0, $f8Sb3.keyframes)($fd680b4cf434d1cc$var$shimmer.keyframes);
const $fd680b4cf434d1cc$var$isSmallAvatar = (avatarShape)=>{
    return avatarShape.indexOf('small') === 0;
};
const $fd680b4cf434d1cc$var$isCircleAvatar = (avatarShape)=>{
    return avatarShape.indexOf('circle') !== -1;
};
const $fd680b4cf434d1cc$export$5d78cba328c109d7 = (avatarShape, isShimmering)=>({
        // This will render a skeleton in the "elemBefore" position.
        backgroundColor: `var(--ds-skeleton, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`,
        ...isShimmering && {
            ...$fd680b4cf434d1cc$var$shimmer.css,
            animationName: `${$fd680b4cf434d1cc$var$shimmerKeyframes}`
        },
        marginRight: $fd680b4cf434d1cc$var$isSmallAvatar(avatarShape) ? $fd680b4cf434d1cc$var$smallItemElemSpacing : $fd680b4cf434d1cc$var$itemElemSpacing,
        width: $fd680b4cf434d1cc$var$isSmallAvatar(avatarShape) ? '14px' : $fd680b4cf434d1cc$var$itemElemSize,
        height: $fd680b4cf434d1cc$var$isSmallAvatar(avatarShape) ? '14px' : $fd680b4cf434d1cc$var$itemElemSize,
        borderRadius: $fd680b4cf434d1cc$var$isCircleAvatar(avatarShape) ? '100%' : (0, $k5uoT.borderRadius)(),
        flexShrink: 0,
        display: 'inline-block'
    });
const $fd680b4cf434d1cc$var$itemCSS = {
    name: "fihlmz",
    styles: "cursor:pointer;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);display:block;width:100%;box-sizing:border-box;background-color:transparent;border:0;outline:0;margin:0"
};
const $fd680b4cf434d1cc$export$31f9b59a0fa394ab = (width, isShimmering, textHeight)=>({
        // This will render the skeleton "text".
        backgroundColor: `var(--ds-skeleton, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`,
        ...isShimmering && {
            ...$fd680b4cf434d1cc$var$shimmer.css,
            animationName: `${$fd680b4cf434d1cc$var$shimmerKeyframes}`
        },
        height: `${textHeight ? textHeight / 2 : $fd680b4cf434d1cc$var$skeletonContentHeight}px`,
        borderRadius: (0, $k5uoT.borderRadius)(),
        flexBasis: width || '100%'
    });
const $fd680b4cf434d1cc$export$93ea78b0b020396e = /*#__PURE__*/ (0, $f8Sb3.css)([
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $fd680b4cf434d1cc$var$itemCSS,
    {
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: $fd680b4cf434d1cc$var$itemMinHeight
    }
]);

});



parcelRegister("cYugq", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $a6ab4ad7cc3d214c$export$be58b4326e23250f);
$parcel$export(module.exports, "LabelWrapper", () => $a6ab4ad7cc3d214c$export$147422f7450ccfac);
$parcel$export(module.exports, "FilterColLabelText", () => $a6ab4ad7cc3d214c$export$39d33abf45c3996);
$parcel$export(module.exports, "FilterRowLabelText", () => $a6ab4ad7cc3d214c$export$dd6e1c6307d95848);
$parcel$export(module.exports, "CheckboxWrapper", () => $a6ab4ad7cc3d214c$export$eef12940a6696c78);
$parcel$export(module.exports, "PillButton", () => $a6ab4ad7cc3d214c$export$c5e39530e713771e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3JZ8k = parcelRequire("3JZ8k");


var $bWGt6 = parcelRequire("bWGt6");
const $a6ab4ad7cc3d214c$export$397f5285b920487e = (0, $3JZ8k.grid).multiple(22);
const $a6ab4ad7cc3d214c$export$f51daa55764f8a9 = $a6ab4ad7cc3d214c$export$397f5285b920487e.half();
const $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE = 2;
// The +4px is to ensure consistency with the Atlaskit avatar which has a 2px padding around the 24px icon
const $a6ab4ad7cc3d214c$var$ICON_WIDTH = (0, $3JZ8k.grid).multiple(3).unitless + $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
const $a6ab4ad7cc3d214c$var$ICON_HEIGHT = (0, $3JZ8k.grid).multiple(3).unitless + $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
const $a6ab4ad7cc3d214c$export$be58b4326e23250f = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e6939t15"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$a6ab4ad7cc3d214c$var$ICON_HEIGHT}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$a6ab4ad7cc3d214c$var$ICON_WIDTH}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $3JZ8k.grid).unitless - $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px 0 ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $3JZ8k.grid).half().unitless - $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px`
});
const $a6ab4ad7cc3d214c$export$147422f7450ccfac = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e6939t14"
})({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // Offset the label's 4px padding-left
    marginLeft: "var(--ds-space-negative-050, -4px)",
    // The -2px is to offset the 28px container (see IconWrapper)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $3JZ8k.grid).unitless - 2} 0`
});
const $a6ab4ad7cc3d214c$export$39d33abf45c3996 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e6939t13"
})((0, $3JZ8k.nowrapEllipsis), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $a6ab4ad7cc3d214c$export$397f5285b920487e.px,
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
});
const $a6ab4ad7cc3d214c$export$dd6e1c6307d95848 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e6939t12"
})((0, $3JZ8k.nowrapEllipsis), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $3JZ8k.grid).half().px,
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $a6ab4ad7cc3d214c$export$f51daa55764f8a9.px
});
const $a6ab4ad7cc3d214c$export$eef12940a6696c78 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e6939t11"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $3JZ8k.grid).unitless - 2}px 0`,
    display: 'flex',
    flexGrow: 1
});
const $a6ab4ad7cc3d214c$export$c5e39530e713771e = /*#__PURE__*/ (0, $bWGt6.default)("button", {
    target: "e6939t10"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $3JZ8k.grid).multiple(3).unitless + 2}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.selected ? `var(--ds-text-brand, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
        outline: 'none',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${(0, $3JZ8k.grid).half().px} ${(0, $3JZ8k.grid).px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})` : `var(--ds-background-accent-gray-subtlest, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
        border: 'none',
        borderRadius: '14px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: `${(0, $3JZ8k.grid).multiple(2).unitless + 2}px`,
        cursor: 'pointer',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        }
    }));

});

parcelRegister("cN0cY", function(module, exports) {

$parcel$export(module.exports, "FilterShowMore", () => $ed45edf7b151cf67$export$53b1613b48d79692);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $fnQlK = parcelRequire("fnQlK");
class $ed45edf7b151cf67$export$53b1613b48d79692 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentWillUnmount() {
        this.focusTimeout && clearTimeout(this.focusTimeout);
    }
    renderEditView() {
        const FilterComponent = this.props.filterComponent;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(FilterComponent, {
            defaultOptions: this.props.defaultOptions,
            loadOptions: this.props.loadOptions,
            placeholderText: this.props.placeholderText,
            label: this.props.placeholderText,
            onConfirm: this.onConfirm,
            onMenuClosed: ()=>{
                this.setIsEdit(false);
            },
            refocusEditLink: this.refocusEditLink,
            loadingMessage: this.props.loadingMessage,
            noOptionsMessage: this.props.noOptionsMessage,
            onFocusAriaMessage: this.props.onFocusAriaMessage
        });
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fnQlK.FilterShowMoreWrapper), {
            children: this.state.isEdit ? this.renderEditView() : this.renderReadView()
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isEdit: false
        }, this.readViewRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.setIsEdit = (isEdit)=>{
            this.setState({
                isEdit: isEdit
            });
        }, this.refocusEditLink = ()=>this.focusTimeout = setTimeout(()=>this.readViewRef.current?.focus(), 0), this.onConfirm = (value)=>{
            this.refocusEditLink();
            return this.props.addFilter(value);
        }, this.renderReadView = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fnQlK.FilterShowMoreButtonWrapper), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                    ref: this.readViewRef,
                    appearance: "link",
                    onClick: ()=>this.setIsEdit(true),
                    isDisabled: this.props.isDisabled,
                    children: this.props.buttonText
                })
            });
    }
}

});
parcelRegister("fnQlK", function(module, exports) {

$parcel$export(module.exports, "FilterShowMoreWrapper", () => $cb7275d5b9b34dbd$export$2b188a2db2e1eabb);
$parcel$export(module.exports, "FilterShowMoreButtonWrapper", () => $cb7275d5b9b34dbd$export$524ab404a46fe64d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3JZ8k = parcelRequire("3JZ8k");

var $bWGt6 = parcelRequire("bWGt6");
function $cb7275d5b9b34dbd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cb7275d5b9b34dbd$export$2b188a2db2e1eabb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e132hrf52"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $3JZ8k.grid).half().px} 0 0 -${(0, $3JZ8k.grid).px}`
});
const $cb7275d5b9b34dbd$export$524ab404a46fe64d = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e132hrf51"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $3JZ8k.grid).half().px} 0`
});
const $cb7275d5b9b34dbd$export$749e0fb71c21003 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e132hrf50"
})({
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
});

});


parcelRegister("7W71o", function(module, exports) {

$parcel$export(module.exports, "OptionVariant", () => $c1f4fc39b95666e1$export$627eaf65f9fd0753);
$parcel$export(module.exports, "default", () => $c1f4fc39b95666e1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cYugq = parcelRequire("cYugq");

var $kkJfY = parcelRequire("kkJfY");

var $f8Sb3 = parcelRequire("f8Sb3");
var $c1f4fc39b95666e1$export$627eaf65f9fd0753 = /*#__PURE__*/ function(OptionVariant) {
    OptionVariant["CHECKBOX"] = "CHECKBOX";
    OptionVariant["PILL"] = "PILL";
    return OptionVariant;
}({});
const $c1f4fc39b95666e1$var$FilterItem = ({ value: value, onChange: onChange, label: label, isDisabled: isDisabled = false, icon: icon, LabelComponent: LabelComponent, variant: variant, ...rest })=>{
    const onChangeCallback = (0, $5uXOq.useCallback)((e)=>{
        if (variant === "PILL") onChange?.(value, !rest.isChecked);
        else onChange?.(e.target.value, e.target.checked);
    }, [
        variant,
        onChange,
        value,
        rest.isChecked
    ]);
    switch(variant){
        case "PILL":
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cYugq.PillButton), {
                selected: rest.isChecked,
                "aria-pressed": rest.isChecked,
                onClick: onChangeCallback
            }, label);
        case "CHECKBOX":
        default:
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cYugq.CheckboxWrapper), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kkJfY.default), {
                ...rest,
                value: value,
                onChange: onChangeCallback,
                // Target the svg to move to the left and down
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $f8Sb3.css)({
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                    '& + svg': {
                        margin: `${"var(--ds-space-025, 2px)"} 0 0 ${"var(--ds-space-negative-050, -4px)"}`
                    }
                }),
                isDisabled: isDisabled,
                label: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cYugq.LabelWrapper), null, icon && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cYugq.IconWrapper), null, icon), /*#__PURE__*/ (0, $f8Sb3.jsx)(LabelComponent, null, label))
            }));
    }
};
var $c1f4fc39b95666e1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($c1f4fc39b95666e1$var$FilterItem);

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});



parcelRegister("5aEuc", function(module, exports) {

$parcel$export(module.exports, "ProductFilterItem", () => $80d10d9106924b67$export$e83a48685bfae274);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7W71o = parcelRequire("7W71o");

var $3FqY6 = parcelRequire("3FqY6");
var $75NXP = parcelRequire("75NXP");
const $80d10d9106924b67$export$e83a48685bfae274 = ({ onChange: onChange, filterType: filterType, filterSource: filterSource, isDisabled: isDisabled = false, smartValue: smartValue, allOptions: allOptions, collabGraphSessionId: collabGraphSessionId = '', variant: variant, ...rest })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const onChangeCallback = (0, $5uXOq.useCallback)((id, checked)=>{
        if (checked) {
            fireAnalyticsEvent((0, $3FqY6.onFilterSelect)({
                filterId: id,
                filterSource: filterSource,
                filterType: filterType
            }));
            if (smartValue && allOptions) fireAnalyticsEvent((0, $3FqY6.selectEvent)(smartValue, allOptions, 'quickSearch', collabGraphSessionId));
        } else fireAnalyticsEvent((0, $3FqY6.onFilterUnselect)({
            filterId: id,
            filterSource: filterSource,
            filterType: filterType
        }));
        onChange?.(id, filterType, checked);
    }, [
        onChange,
        filterType,
        fireAnalyticsEvent,
        filterSource,
        smartValue,
        allOptions,
        collabGraphSessionId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7W71o.default), {
        ...rest,
        onChange: onChangeCallback,
        isDisabled: isDisabled,
        variant: variant
    });
};

});

parcelRegister("lnyO0", function(module, exports) {

$parcel$export(module.exports, "FilterOptionItem", () => $c97aeca780b4a010$export$150fbd78f757731d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1oDph = parcelRequire("1oDph");

var $ujWmd = parcelRequire("ujWmd");
const $c97aeca780b4a010$export$150fbd78f757731d = ({ label: label, iconProps: iconProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1oDph.FilterShowMoreItem), {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            name: label,
            size: 'small',
            ...iconProps
        }),
        label: label
    });
};

});
parcelRegister("1oDph", function(module, exports) {

$parcel$export(module.exports, "FilterShowMoreItem", () => $af590ee04fadb4a8$export$c09bfbbe14287de2);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cYugq = parcelRequire("cYugq");
const $af590ee04fadb4a8$export$c09bfbbe14287de2 = ({ label: label, icon: icon, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cYugq.LabelWrapper), {
        ...rest,
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cYugq.IconWrapper), {
                children: icon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cYugq.FilterColLabelText), {
                children: label
            })
        ]
    });
};

});



parcelRegister("7hfia", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0814225b70fb492$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aoQqW = parcelRequire("aoQqW");

const $e0814225b70fb492$var$AsyncFeedbackCollector = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("6em9K"))));
const $e0814225b70fb492$var$ExtensibleFeedbackCollector = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aoQqW.FeedbackButton), {
            onClick: ()=>{}
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($e0814225b70fb492$var$AsyncFeedbackCollector, {})
    });
};
var $e0814225b70fb492$export$2e2bcd8739ae039 = $e0814225b70fb492$var$ExtensibleFeedbackCollector;

});

parcelRegister("eVPhA", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fa7ad0be93f331$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fqwv7 = parcelRequire("fqwv7");

var $8oG5R = parcelRequire("8oG5R");
var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");

var $k4hbD = parcelRequire("k4hbD");
const $42fa7ad0be93f331$var$MoreFilters = ({ linkComponent: linkComponent, href: href, selectedFiltersCount: selectedFiltersCount, isLoading: isLoading, onClick: onClick, ...rest })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const onMoreFiltersClicked = (0, $5uXOq.useCallback)((event)=>{
        const trigger = (0, $8oG5R.getTrigger)(event);
        onClick?.();
        fireAnalyticsEvent((0, $3FqY6.onMoreFiltersSelected)({
            trigger: trigger,
            selectedFiltersCount: selectedFiltersCount
        }));
    }, [
        fireAnalyticsEvent,
        selectedFiltersCount,
        onClick
    ]);
    if (isLoading) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqwv7.MoreFiltersLink), {
        ...rest,
        linkComponent: linkComponent,
        href: href,
        onClick: onMoreFiltersClicked,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $k4hbD.messages).more_filters
        })
    });
};
var $42fa7ad0be93f331$export$2e2bcd8739ae039 = $42fa7ad0be93f331$var$MoreFilters;

});
parcelRegister("fqwv7", function(module, exports) {

$parcel$export(module.exports, "MoreFiltersLink", () => $0dbb4e2e00e6f8d3$export$c592d0ff434e3f);
$parcel$export(module.exports, "MoreFiltersContainer", () => $0dbb4e2e00e6f8d3$export$5a1c3f665eb7c630);

var $kCMvS = parcelRequire("kCMvS");


var $bWGt6 = parcelRequire("bWGt6");
function $0dbb4e2e00e6f8d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0dbb4e2e00e6f8d3$export$c592d0ff434e3f = /*#__PURE__*/ (0, $bWGt6.default)((0, $kCMvS.Link), {
    target: "e3by6ib1"
})({
    display: 'block',
    textAlign: 'center',
    borderRadius: '3px',
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
    cursor: 'pointer',
    padding: "var(--ds-space-075, 6px)",
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    '&:visited': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    }
});
const $0dbb4e2e00e6f8d3$export$5a1c3f665eb7c630 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3by6ib0"
})({
    name: "bnuiyf",
    styles: "padding-top:var(--ds-space-400, 28px)"
});

});


parcelRegister("aqGMV", function(module, exports) {

let $797d85ec548fe0b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $797d85ec548fe0b2$var$load("7y5pw").then(()=>parcelRequire('aIFVn'));

});

parcelRegister("05f3J", function(module, exports) {

let $00fc26315e7efabb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00fc26315e7efabb$var$load("7AMjb").then(()=>parcelRequire('kVQiD'));

});


parcelRegister("hI9zY", function(module, exports) {

$parcel$export(module.exports, "AutocorrectionProvider", () => $13d3be8a5d1cfe7f$export$8ba6d08e2bcc861f);
$parcel$export(module.exports, "useAutocorrection", () => $13d3be8a5d1cfe7f$export$2f6912f63e498900);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2dI5H = parcelRequire("2dI5H");

var $j4xTD = parcelRequire("j4xTD");

var $lvCts = parcelRequire("lvCts");
const $13d3be8a5d1cfe7f$var$NO_CORRECTION = [];
const $13d3be8a5d1cfe7f$var$AutocorrectionContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    correction: undefined,
    setCorrection: ()=>{}
});
const $13d3be8a5d1cfe7f$export$8ba6d08e2bcc861f = ({ children: children })=>{
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $j4xTD.useAutocorrectionEnabled)();
    const [correction, setCorrection] = (0, $5uXOq.useState)($13d3be8a5d1cfe7f$var$NO_CORRECTION);
    const { query: query } = (0, $2dI5H.useQuery)();
    const { locale: locale } = (0, $koVbs.default)();
    const lang = (0, $j4xTD.sanitizeLanguage)(locale);
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const { url: aggregatorUrl, cloudId: cloudId } = aggregatorClient?.getAggregatorConfig() || {};
    (0, $5uXOq.useEffect)(()=>{
        setCorrection($13d3be8a5d1cfe7f$var$NO_CORRECTION);
        if (autocorrectionEnabled && (0, $j4xTD.shouldFetchAutocorrection)(query) && aggregatorUrl && cloudId) (0, $j4xTD.fetchAutocorrection)({
            query: query,
            aggregatorUrl: aggregatorUrl,
            lang: lang,
            cloudId: cloudId
        }).then((result)=>{
            if (!!result.termCorrections) setCorrection(result.termCorrections);
        }).catch((_error_)=>{});
    }, [
        autocorrectionEnabled,
        query,
        aggregatorUrl,
        cloudId,
        lang
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($13d3be8a5d1cfe7f$var$AutocorrectionContext.Provider, {
        value: {
            correction: correction,
            setCorrection: setCorrection
        },
        children: children
    });
};
const $13d3be8a5d1cfe7f$export$2f6912f63e498900 = ()=>{
    return (0, $5uXOq.useContext)($13d3be8a5d1cfe7f$var$AutocorrectionContext);
};

});



parcelRegister("hynt0", function(module, exports) {

$parcel$export(module.exports, "ExtensibleConfluenceTab", () => $ed6ea212d5cb6772$export$9afff4557e36fda3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $k4hbD = parcelRequire("k4hbD");

var $8Xs9r = parcelRequire("8Xs9r");
var $kv2Va = parcelRequire("kv2Va");

var $f4GCr = parcelRequire("f4GCr");

var $5S6Yv = parcelRequire("5S6Yv");

var $iRI1s = parcelRequire("iRI1s");

var $3CuYo = parcelRequire("3CuYo");

var $3RKSV = parcelRequire("3RKSV");
var $3UF9C = parcelRequire("3UF9C");

var $gMpaQ = parcelRequire("gMpaQ");

var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");

var $azBuE = parcelRequire("azBuE");

var $dVo7Y = parcelRequire("dVo7Y");

var $9WUgS = parcelRequire("9WUgS");

var $aiVOu = parcelRequire("aiVOu");

var $lnyO0 = parcelRequire("lnyO0");

var $4DehF = parcelRequire("4DehF");

var $1A3ka = parcelRequire("1A3ka");

var $gQz3v = parcelRequire("gQz3v");

var $i5cPn = parcelRequire("i5cPn");

var $2dI5H = parcelRequire("2dI5H");

var $2k6eV = parcelRequire("2k6eV");

var $3HoVl = parcelRequire("3HoVl");

var $iCcpP = parcelRequire("iCcpP");
var $4f9Ma = parcelRequire("4f9Ma");

var $7VoGI = parcelRequire("7VoGI");

var $lvCts = parcelRequire("lvCts");

var $95MIc = parcelRequire("95MIc");

const $ed6ea212d5cb6772$var$InteractiveSearchAIOnboardingBanner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("lTJ4g")).then(({ InteractiveSearchAIOnboardingBanner: InteractiveSearchAIOnboardingBanner })=>({
            default: InteractiveSearchAIOnboardingBanner
        })));
const $ed6ea212d5cb6772$export$9afff4557e36fda3 = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, aiSearchConfig: aiSearchConfig, formatDate: formatDate, children: children, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled = false, rendererOverride: rendererOverride, aiAdminNotificationHeader: aiAdminNotificationHeader, confluenceReactivationExperiment: confluenceReactivationExperiment, confluenceAvailabilityExperiment: confluenceAvailabilityExperiment, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const { setQuery: setQuery } = (0, $2dI5H.useQuery)();
    const { toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $2k6eV.useSessionUserInput)();
    const { confluenceSites: confluenceSites } = (0, $dVo7Y.useSearchConfigContext)();
    const { defineFilters: defineFilters } = (0, $3UF9C.useGenericFilters)();
    const { isUserAnonymous: isUserAnonymous } = recentClientConfig;
    const { searchClient: searchClient } = (0, $3CuYo.useRecentsClient)(recentClientConfig);
    const { isExpanded: isExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const appendAnalyticsQueryParams = (0, $3HoVl.useQueryParams)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const [hasFiredVisitedEvent, setHasFiredVisitedEvent] = (0, $5uXOq.useState)(false);
    const isEnhancedSearchAnalyticsEnabled = (0, $VSDnB.fg)('cc_page_experiences_enhanced_search_analytics_conf');
    const appendQueryParams = isEnhancedSearchAnalyticsEnabled ? appendAnalyticsQueryParams : undefined;
    const siteFilterDefinition = (0, $3UF9C.useSiteFilterDefinition)(rest.workspaces || [], (0, $5S6Yv.CONFLUENCE_PRODUCT_ID));
    const { confluenceTabDateFilter: confluenceTabDateFilter, appliedDateFilter: appliedDateFilter } = (0, $gQz3v.useConfluenceDateFilter)();
    const spaceFilterStore = (0, $3RKSV.useFilterStore)([], (0, $5S6Yv.CONFLUENCE_PRODUCT_ID), (0, $5S6Yv.ConfluenceFilters).Space);
    const peopleFilterStore = (0, $3RKSV.useFilterStore)([], (0, $5S6Yv.CONFLUENCE_PRODUCT_ID), (0, $5S6Yv.ConfluenceFilters).People);
    const { preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier } = (0, $1A3ka.useConfluenceSuppliers)({
        recentClientConfig: recentClientConfig,
        searchClientConfig: searchClientConfig,
        autocorrectEnabled: autocorrectEnabled,
        spaceFilterStore: spaceFilterStore,
        peopleFilterStore: peopleFilterStore,
        isExpanded: isExpanded,
        isUserAnonymous: isUserAnonymous,
        formatDate: formatDate,
        rendererOverride: rendererOverride,
        additionalContentTypesEnabled: additionalContentTypesEnabled
    });
    const sections = (0, $4DehF.useConfluenceSections)({
        formatDate: formatDate,
        autocorrectEnabled: autocorrectEnabled,
        additionalContentTypesEnabled: additionalContentTypesEnabled,
        rendererOverride: rendererOverride
    });
    const itemSuppliers = (0, $f4GCr.useDefaultSuppliers)((0, $5S6Yv.CONFLUENCE_PRODUCT_ID), sections, {
        preQueryItemSupplier: rest.preQueryItemSupplier || preQueryItemSupplier,
        postQueryItemSupplier: rest.postQueryItemSupplier || postQueryItemSupplier
    });
    const confluenceAdvancedSearchUrlFactory = (0, $iRI1s.useConfluenceAdvancedSearchUrlFactory)(recentClientConfig.url, {
        spaceFilters: spaceFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.spaceKey || ''),
        peopleFilters: peopleFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.id),
        dateFilter: !!appliedDateFilter ? [
            appliedDateFilter
        ] : []
    });
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $4f9Ma.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return confluenceAdvancedSearchUrlFactory(query, baseUrl);
    }, [
        confluenceAdvancedSearchUrlFactory,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    const recentSectionTitleGenerator = (0, $5uXOq.useCallback)((section)=>{
        return section.title;
    }, []);
    const loadSpaceFilters = (0, $5uXOq.useCallback)((query)=>{
        return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                (0, $5S6Yv.ConfluenceScope).Space
            ],
            modelParams: [],
            resultLimit: (0, $5S6Yv.SPACE_FILTER_LIMIT),
            experience: (0, $5S6Yv.NAVIGATION_V3_EXPERIENCE),
            sites: []
        }).then(({ response: response })=>{
            const results = response.retrieveScope((0, $5S6Yv.ConfluenceScope).Space)?.results;
            return results?.map((result)=>({
                    value: {
                        id: result.id,
                        spaceKey: result.space?.key || '',
                        avatarUrl: `${result.baseUrl}${result.space.icon.path}`,
                        label: result.title,
                        filterSource: (0, $gMpaQ.FilterOptionSource).SEARCH,
                        isChecked: false,
                        isVisible: true
                    },
                    label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnyO0.FilterOptionItem), {
                        label: result.title,
                        iconProps: {
                            src: `${result.baseUrl}${result.space.icon.path}`,
                            appearance: 'square'
                        }
                    })
                })) || [];
        });
    }, [
        searchClient,
        isUserAnonymous
    ]);
    const loadPeopleFilters = (0, $5uXOq.useCallback)((query)=>{
        return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                (0, $5S6Yv.ConfluenceScope).People
            ],
            modelParams: [],
            resultLimit: (0, $5S6Yv.PEOPLE_FILTER_LIMIT),
            experience: (0, $5S6Yv.NAVIGATION_V3_EXPERIENCE),
            sites: []
        }).then(({ response: response })=>{
            const results = response.retrieveScope((0, $5S6Yv.ConfluenceScope).People)?.results;
            return results?.map((result)=>({
                    value: {
                        id: result.id,
                        avatarUrl: result.avatarUrl,
                        label: result.name,
                        filterSource: (0, $gMpaQ.FilterOptionSource).SEARCH,
                        isChecked: false,
                        isVisible: true
                    },
                    label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnyO0.FilterOptionItem), {
                        label: result.name,
                        iconProps: {
                            src: result.avatarUrl
                        }
                    })
                })) || [];
        });
    }, [
        searchClient,
        isUserAnonymous
    ]);
    const confluenceTabGenericFilters = (0, $5uXOq.useMemo)(()=>{
        return [
            {
                ['@type']: (0, $5S6Yv.ConfluenceFilters).Space,
                fieldName: 'spaceKeys',
                store: spaceFilterStore,
                loadFilterOptions: loadSpaceFilters,
                sectionLabel: formatMessage((0, $k4hbD.messages).space_filters_title),
                findMoreLabel: formatMessage((0, $k4hbD.messages).space_filters_find_more)
            },
            {
                ['@type']: (0, $5S6Yv.ConfluenceFilters).People,
                fieldName: 'accountIds',
                store: peopleFilterStore,
                loadFilterOptions: loadPeopleFilters,
                sectionLabel: formatMessage((0, $k4hbD.messages).contributor_filters_title),
                findMoreLabel: formatMessage((0, $k4hbD.messages).contributor_filters_find_more),
                filterConfig: {
                    filterOptionIconShape: 'circle'
                }
            }
        ];
    }, [
        formatMessage,
        loadPeopleFilters,
        loadSpaceFilters,
        peopleFilterStore,
        spaceFilterStore
    ]);
    const filtersToDefine = (0, $5uXOq.useMemo)(()=>{
        return [
            ...confluenceTabDateFilter,
            ...siteFilterDefinition,
            ...confluenceTabGenericFilters
        ];
    }, [
        confluenceTabGenericFilters,
        confluenceTabDateFilter,
        siteFilterDefinition
    ]);
    const onPrequeryBannerRender = (0, $5uXOq.useCallback)(()=>{
        fireAnalyticsEvent((0, $3FqY6.onPrequeryBannerShown)());
    }, [
        fireAnalyticsEvent
    ]);
    const onPromptSuggestionClick = (0, $5uXOq.useCallback)((prompt, promptId)=>{
        fireAnalyticsEvent((0, $3FqY6.onSuggestedPromptClick)(promptId));
        setQuery(prompt);
        toggleShowSearchAIDialog(true);
    }, [
        fireAnalyticsEvent,
        setQuery,
        toggleShowSearchAIDialog
    ]);
    const dismissOnboardingBanner = (0, $5uXOq.useCallback)(()=>{
        if (aiSearchConfig?.dismissPrequeryBanner) {
            fireAnalyticsEvent((0, $3FqY6.onPrequeryBannerDismiss)());
            aiSearchConfig.dismissPrequeryBanner();
        }
    }, [
        aiSearchConfig,
        fireAnalyticsEvent
    ]);
    const initializeFilters = (0, $5uXOq.useCallback)(()=>{
        defineFilters((0, $5S6Yv.CONFLUENCE_PRODUCT_ID), filtersToDefine);
    }, [
        defineFilters,
        filtersToDefine
    ]);
    initializeFilters();
    const { isEligibleInactiveUser: isEligibleInactiveUser, isEligibleNewUser: isEligibleNewUser, nudgeShown: isNudgeShown, setAllowConfluenceAccessCache: setAllowConfluenceAccessCache } = confluenceReactivationExperiment ?? {
        isEligibleUser: false,
        isEligibleNewUser: false,
        nudgeShown: false
    };
    const confluenceReactivationExperimentTabRenderer = (0, $5uXOq.useCallback)(({ title: title })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aiVOu.ConfluenceReactivationExperimentTab), {
            title: title,
            isEligibleInactiveUser: isEligibleInactiveUser,
            isEligibleNewUser: isEligibleNewUser,
            isNudgeShown: isNudgeShown
        }), [
        isEligibleInactiveUser,
        isEligibleNewUser,
        isNudgeShown
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isNudgeShown && getActiveProduct()?.id === (0, $5S6Yv.CONFLUENCE_PRODUCT_ID) && !hasFiredVisitedEvent) {
            // https://data-portal.internal.atlassian.com/analytics/registry/76739
            fireAnalyticsEvent({
                action: 'opened',
                actionSubject: 'panel',
                actionSubjectId: 'crossProductSearchPanel',
                source: 'searchDialog',
                eventType: 'ui',
                attributes: {
                    activeProduct: (0, $5S6Yv.CONFLUENCE_PRODUCT_ID),
                    reactivationNudgeShown: true
                }
            });
            setHasFiredVisitedEvent(true);
        }
    }, [
        fireAnalyticsEvent,
        getActiveProduct,
        hasFiredVisitedEvent,
        setHasFiredVisitedEvent,
        isNudgeShown
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        id: (0, $5S6Yv.CONFLUENCE_PRODUCT_ID),
        expandedStateInputPlaceholder: !!aiSearchConfig ? formatMessage((0, $k4hbD.messages).confluence_search_input_expanded_placeholder_ai) : formatMessage((0, $k4hbD.messages).confluence_search_input_expanded_placeholder),
        title: formatMessage((0, $k4hbD.messages).confluence_tab_label),
        tabRenderer: confluenceReactivationExperimentTabRenderer,
        autocorrectEnabled: autocorrectEnabled,
        sections: sections,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        preQuerySectionTitleGenerator: recentSectionTitleGenerator,
        showViewAllFiltersLink: true,
        ...rest,
        ...itemSuppliers,
        aiSearchConfig: aiSearchConfig,
        permissionSupplier: confluenceSites.length > 0 ? (0, $9WUgS.defaultPermissionsSupplier) : rest.permissionSupplier,
        appendQueryParams: appendQueryParams,
        children: ({ productState: productState, ...props })=>{
            const Footer = showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iCcpP.ExtensibleConfluenceTabFooter), {
                orgId: orgId,
                cloudId: cloudId,
                ...props
            });
            if (productState === (0, $azBuE.ProductStates).PreQuerySuccess) {
                setAllowConfluenceAccessCache?.();
                if (!!aiAdminNotificationHeader) return {
                    Header: aiAdminNotificationHeader,
                    Footer: Footer
                };
                if (!!aiSearchConfig && aiSearchConfig.prequeryBannerEnabled) return {
                    Header: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($ed6ea212d5cb6772$var$InteractiveSearchAIOnboardingBanner, {
                            onPromptSuggestionClick: onPromptSuggestionClick,
                            onXButtonClick: dismissOnboardingBanner,
                            onBannerShown: onPrequeryBannerRender
                        }),
                    Footer: Footer
                };
            }
            return {
                Footer: Footer
            };
        }
    });
};

});
parcelRegister("3CuYo", function(module, exports) {

$parcel$export(module.exports, "useRecentsClient", () => $57281abd856e23a8$export$2ac7f7e39d1eda48);

var $5uXOq = parcelRequire("5uXOq");

var $3JOCw = parcelRequire("3JOCw");

var $8QpSo = parcelRequire("8QpSo");

var $6SBvm = parcelRequire("6SBvm");

var $dS9cn = parcelRequire("dS9cn");

var $5S6Yv = parcelRequire("5S6Yv");

var $3GGIR = parcelRequire("3GGIR");

var $jFHlY = parcelRequire("jFHlY");
var $lQmoS = parcelRequire("lQmoS");
var $lFNae = parcelRequire("lFNae");


var $lvCts = parcelRequire("lvCts");

var $ckvH1 = parcelRequire("ckvH1");

var $k7rsK = parcelRequire("k7rsK");
const $57281abd856e23a8$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
const $57281abd856e23a8$var$RECENT_PAGES_PATH = 'rest/recentlyviewed/1.0/recent';
const $57281abd856e23a8$var$RECENT_SPACE_PATH = 'rest/recentlyviewed/1.0/recent/spaces';
const $57281abd856e23a8$var$DEFAULT_COLLAB_GRAPH_URL = 'gateway/api/collaboration';
const $57281abd856e23a8$var$ACTIVITY_CLIENT_RETRY_MS = 250;
const $57281abd856e23a8$var$RECENT_PAGES_LIMIT = 200;
const $57281abd856e23a8$var$RECENT_SPACE_LIMIT = 10;
const $57281abd856e23a8$var$RECENT_PEOPLE_LIMIT = 10;
function $57281abd856e23a8$var$recentWorkItemToResult(recentItem) {
    const { object: object, containers: containers } = recentItem;
    return {
        resultId: object.id,
        containerName: containers[0].name,
        containerId: '',
        resultType: (0, $3GGIR.ConfluenceObjectResult),
        isRecentResult: true,
        name: object.name || '',
        href: object.url,
        contentType: `confluence-${object.type}`,
        lastModified: undefined,
        analyticsType: (0, $3GGIR.RecentConfluence)
    };
}
function $57281abd856e23a8$var$recentPageToResult(recentPage, baseUrl) {
    return {
        resultId: String(recentPage.id),
        name: recentPage.title || '',
        href: `${baseUrl}${recentPage.url}`,
        containerName: recentPage.space,
        analyticsType: (0, $3GGIR.RecentConfluence),
        resultType: (0, $3GGIR.ConfluenceObjectResult),
        contentType: `confluence-${recentPage.contentType}`,
        iconClass: recentPage.iconClass,
        containerId: recentPage.spaceId.toString(),
        isRecentResult: true,
        lastModified: undefined,
        spaceId: recentPage.spaceId?.toString()
    };
}
function $57281abd856e23a8$var$mapCollabGraphContainer(response) {
    const items = response.collaborationGraphEntities.map((item)=>({
            id: item.containerDetails?.id,
            key: item.containerDetails?.key,
            icon: item.containerDetails?.iconUrl,
            name: item.containerDetails?.name,
            url: item.containerDetails?.url
        })).filter((space)=>space.id !== undefined).map((space)=>$57281abd856e23a8$var$recentSpaceToResult(space, space.url));
    return {
        items: items,
        timings: response.timings
    };
}
function $57281abd856e23a8$var$recentSpaceToResult(recentSpace, href) {
    return {
        resultId: recentSpace.id,
        name: recentSpace.name,
        key: recentSpace.key,
        href: href,
        avatarUrl: recentSpace.icon,
        analyticsType: (0, $3GGIR.RecentConfluence),
        resultType: (0, $3GGIR.GenericContainerResult),
        contentType: (0, $3GGIR.ConfluenceSpace),
        id: recentSpace.id
    };
}
function $57281abd856e23a8$var$mapUrsPeople(response, timings, isMultiSite) {
    if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $3GGIR.Scope).UserConfluence}`);
    if (response.error) throw (0, $lQmoS.responseErrorToError)(response.error);
    const items = response.results.map((item)=>({
            resultType: (0, $3GGIR.PersonResult),
            resultId: `people-${item.id}`,
            userId: item.id,
            name: item.name,
            href: (0, $ckvH1.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
            avatarUrl: item.avatarUrl,
            contentType: (0, $3GGIR.Person),
            analyticsType: (0, $3GGIR.ResultPerson),
            mentionName: item.nickname || '',
            presenceMessage: ''
        }));
    return {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(items, (item)=>item.resultId),
        timings: timings
    };
}

class $57281abd856e23a8$var$RecentsCache {
    constructor(props){
        this.recentItemSupplier = async ()=>{
            if (!!this.recentCacheProps.recentWorkAPIUrl) try {
                const { createActivityClient: createActivityClient } = await (parcelRequire("il3ui"));
                const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentCacheProps.recentWorkAPIUrl);
                const { viewed: viewed } = await activityClient.fetchActivities([
                    $57281abd856e23a8$var$ACTIVITY_CLIENT_RETRY_MS
                ], {
                    products: [
                        'confluence'
                    ]
                }, [
                    'viewed'
                ]);
                const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$57281abd856e23a8$var$recentWorkItemToResult(item));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: 0
                };
            } catch (e) {
                return {
                    items: [],
                    totalSize: 0,
                    timings: -1
                };
            }
            else try {
                const { result: result, durationMs: durationMs } = await (0, $lFNae.timed)((0, $dS9cn.utils).requestService({
                    url: this.recentCacheProps.url
                }, {
                    path: $57281abd856e23a8$var$RECENT_PAGES_PATH,
                    queryParams: {
                        limit: $57281abd856e23a8$var$RECENT_PAGES_LIMIT
                    }
                }));
                const items = result.filter((page)=>!!page.title).map((recentPage)=>$57281abd856e23a8$var$recentPageToResult(recentPage, this.recentCacheProps.url));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: durationMs
                };
            } catch (e) {
                return {
                    items: [],
                    totalSize: 0,
                    timings: -1
                };
            }
        };
        this.recentSpaceSupplier = async ()=>{
            if (this.recentCacheProps.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0
            });
            if (this.recentCacheProps.isCollaborationGraphEnabled) return this.recentCacheProps.getCollabGraphContainers();
            else try {
                const { result: result, durationMs: durationMs } = await (0, $lFNae.timed)((0, $dS9cn.utils).requestService({
                    url: this.recentCacheProps.url
                }, {
                    path: $57281abd856e23a8$var$RECENT_SPACE_PATH,
                    queryParams: {
                        limit: $57281abd856e23a8$var$RECENT_SPACE_LIMIT
                    }
                }));
                return {
                    items: result.map((recentSpace)=>$57281abd856e23a8$var$recentSpaceToResult(recentSpace, `${this.recentCacheProps.url}/spaces/${recentSpace.key}`)),
                    timings: durationMs
                };
            } catch (e) {
                return {
                    items: [],
                    timings: -1
                };
            }
        };
        this.recentPeopleSupplier = async ()=>{
            if (this.recentCacheProps.isUserAnonymous || !this.recentCacheProps.aggregatorClient) return Promise.resolve({
                items: [],
                timings: 0
            });
            return this.recentCacheProps.aggregatorClient.search({
                query: '',
                context: {
                    sessionId: '',
                    referrerId: null
                },
                scopes: [
                    (0, $5S6Yv.ConfluenceScope).People
                ],
                modelParams: [],
                resultLimit: $57281abd856e23a8$var$RECENT_PEOPLE_LIMIT,
                experience: $57281abd856e23a8$var$NAVIGATION_V3_EXPERIENCE,
                sites: this.recentCacheProps.sites?.map((s)=>s.cloudId)
            }).then(({ response: response, requestDurationMs: requestDurationMs })=>$57281abd856e23a8$var$mapUrsPeople(response.retrieveScope((0, $5S6Yv.ConfluenceScope).People), requestDurationMs, (this.recentCacheProps.sites || []).length > 0)).catch((e)=>({
                    items: [],
                    timings: -1
                }));
        };
        this.recentCacheProps = props;
        this.recentItemCache = new (0, $k7rsK.SimpleCache)(this.recentItemSupplier);
        this.recentSpaceCache = new (0, $k7rsK.SimpleCache)(this.recentSpaceSupplier);
        this.recentPeopleCache = new (0, $k7rsK.SimpleCache)(this.recentPeopleSupplier);
    }
}
const $57281abd856e23a8$var$getRecentsCache = (0, $8QpSo.default)((recentsCacheProps)=>new $57281abd856e23a8$var$RecentsCache(recentsCacheProps), (0, (/*@__PURE__*/$parcel$interopDefault($6SBvm))));
const $57281abd856e23a8$var$getCollabGraphClientWithConfig = (0, $8QpSo.default)((config)=>new (0, $jFHlY.CollaborationGraphClient)(config), (0, (/*@__PURE__*/$parcel$interopDefault($6SBvm))));
const $57281abd856e23a8$export$2ac7f7e39d1eda48 = (props)=>{
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const collabGraphClient = $57281abd856e23a8$var$getCollabGraphClientWithConfig({
        collaborationGraphUrl: props.collaborationGraphUrl || $57281abd856e23a8$var$DEFAULT_COLLAB_GRAPH_URL,
        cloudId: props.cloudId,
        isMultiSite: (props.sites || []).length > 1,
        sites: props.sites || [],
        collabGraphSessionId: props.collabGraphSessionId
    });
    const { isUserAnonymous: isUserAnonymous } = props;
    const getCollabGraphContainers = (0, $5uXOq.useCallback)(async ()=>{
        return isUserAnonymous ? Promise.resolve({
            items: [],
            timings: 0
        }) : collabGraphClient.getContainers([
            (0, $94417f843d249742$export$e28d152a38023114)
        ]).then((response)=>$57281abd856e23a8$var$mapCollabGraphContainer(response)).catch((e)=>({
                items: [],
                timings: -1
            }));
    }, [
        collabGraphClient,
        isUserAnonymous
    ]);
    const recentsCache = $57281abd856e23a8$var$getRecentsCache({
        ...props,
        aggregatorClient: aggregatorClient,
        getCollabGraphContainers: getCollabGraphContainers
    });
    const getRecentItems = (0, $5uXOq.useCallback)(()=>{
        return recentsCache.recentItemCache.get().value;
    }, [
        recentsCache
    ]);
    const getRecentSpaces = (0, $5uXOq.useCallback)(()=>{
        return recentsCache.recentSpaceCache.get().value;
    }, [
        recentsCache
    ]);
    const getRecentPeople = (0, $5uXOq.useCallback)(()=>{
        return recentsCache.recentPeopleCache.get().value;
    }, [
        recentsCache
    ]);
    return {
        getRecentItems: getRecentItems,
        getRecentSpaces: getRecentSpaces,
        getRecentPeople: getRecentPeople,
        getCollabGraphContainers: getCollabGraphContainers,
        searchClient: aggregatorClient,
        collabGraphClient: collabGraphClient
    };
};

});

parcelRegister("dVo7Y", function(module, exports) {

$parcel$export(module.exports, "useSearchConfigContext", () => $c6945e33dd34d635$export$dca16f1ca9af3934);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iK6UE = parcelRequire("iK6UE");
/**
 * Every product configuration might not choose to have the search config provider.
 * Hence this is explicitly initialised to null.
 */ const $c6945e33dd34d635$var$SearchConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    jiraSites: [],
    confluenceSites: [],
    atlasWorkspaces: []
});
const $c6945e33dd34d635$export$9ce36a8a6ea7b893 = (props)=>{
    const { children: children, skeleton: SkeletonComponent = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}) } = props;
    const accessibleProducts = (0, $iK6UE.useSearchConfigClient)(props);
    return accessibleProducts == null ? /*#__PURE__*/ (0, $2OMIu.jsx)(SkeletonComponent, {}) : /*#__PURE__*/ (0, $2OMIu.jsx)($c6945e33dd34d635$var$SearchConfigContext.Provider, {
        value: accessibleProducts,
        children: children
    });
};
function $c6945e33dd34d635$export$dca16f1ca9af3934() {
    return (0, $5uXOq.useContext)($c6945e33dd34d635$var$SearchConfigContext);
}

});
parcelRegister("iK6UE", function(module, exports) {

$parcel$export(module.exports, "AGGREGATOR_URL", () => $c78f48659b66734f$export$55ad0abefe643b5f);
$parcel$export(module.exports, "useSearchConfigClient", () => $c78f48659b66734f$export$16414e90b8f90666);

var $5uXOq = parcelRequire("5uXOq");

var $dS9cn = parcelRequire("dS9cn");

var $fFYHI = parcelRequire("fFYHI");

var $1EZbw = parcelRequire("1EZbw");
var $c78f48659b66734f$var$ProductsFromARI = /*#__PURE__*/ function(ProductsFromARI) {
    ProductsFromARI["JIRA"] = "jira";
    ProductsFromARI["CONFLUENCE"] = "confluence";
    ProductsFromARI["TOWNSQUARE"] = "townsquare";
    return ProductsFromARI;
}($c78f48659b66734f$var$ProductsFromARI || {});
const $c78f48659b66734f$var$CONFIG_API_URL = '/configuration/v1';
const $c78f48659b66734f$export$55ad0abefe643b5f = '/gateway/api/xpsearch-aggregator';
const $c78f48659b66734f$var$options = {
    path: $c78f48659b66734f$var$CONFIG_API_URL,
    requestInit: {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }
};
const $c78f48659b66734f$var$noAccessState = {
    jiraSites: [],
    confluenceSites: [],
    atlasWorkspaces: []
};
const $c78f48659b66734f$var$dedupeEntriesById = (arr)=>{
    return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.id === initial.id) === index);
};
const $c78f48659b66734f$var$dedupeEntriesByCloudId = (arr)=>{
    return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.cloudId === initial.cloudId) === index);
};
const $c78f48659b66734f$export$ba14d9a5a581e827 = (response)=>{
    const groupedProducts = response.resources.reduce((acc, resource)=>{
        const { baseUrl: baseUrl, id: ari, siteName: siteName } = resource;
        const { id: id, product: product } = (0, $fFYHI.parseSiteARI)(ari);
        if (product.includes("jira")) acc.jiraSites && acc.jiraSites.push({
            product: (0, $1EZbw.Products).jira,
            avatarUrl: '',
            cloudId: id,
            siteUrl: baseUrl,
            siteName: siteName
        });
        if (product === "confluence") acc.confluenceSites && acc.confluenceSites.push({
            product: (0, $1EZbw.Products).confluence,
            avatarUrl: '',
            cloudId: id,
            siteUrl: baseUrl,
            siteName: siteName
        });
        if (product === "townsquare") acc.atlasWorkspaces && acc.atlasWorkspaces.push({
            name: siteName,
            id: id,
            baseUrl: baseUrl
        });
        return acc;
    }, $c78f48659b66734f$var$noAccessState);
    return {
        jiraSites: $c78f48659b66734f$var$dedupeEntriesByCloudId(groupedProducts.jiraSites),
        confluenceSites: $c78f48659b66734f$var$dedupeEntriesByCloudId(groupedProducts.confluenceSites),
        atlasWorkspaces: $c78f48659b66734f$var$dedupeEntriesById(groupedProducts.atlasWorkspaces)
    };
};
const $c78f48659b66734f$export$16414e90b8f90666 = (props)=>{
    const { aggregatorUrl: aggregatorUrl = `${$c78f48659b66734f$export$55ad0abefe643b5f}`, skip: skip = false } = props;
    const [accessibleProducts, setAccessibleProducts] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!skip && accessibleProducts === null) (0, $dS9cn.utils).requestService({
            url: aggregatorUrl
        }, $c78f48659b66734f$var$options).then((resp)=>{
            setAccessibleProducts($c78f48659b66734f$export$ba14d9a5a581e827(resp));
        }).catch((_e)=>{
            setAccessibleProducts($c78f48659b66734f$var$noAccessState);
        });
    }, [
        accessibleProducts,
        setAccessibleProducts,
        aggregatorUrl,
        skip
    ]);
    return accessibleProducts;
};

});
parcelRegister("fFYHI", function(module, exports) {

$parcel$export(module.exports, "parseSiteARI", () => $3960d39b10102c49$export$8837a793ca98a5b5);
const $3960d39b10102c49$var$SITE_ARI_REGEX = new RegExp('ari:cloud:(.+)::site/(.+)');
const $3960d39b10102c49$export$8837a793ca98a5b5 = (ari)=>{
    if (!ari) return {
        product: '',
        id: ''
    };
    const [_original, product, id] = Array.from(ari.match($3960d39b10102c49$var$SITE_ARI_REGEX) || [
        '',
        '',
        ''
    ]);
    return {
        product: product,
        id: id
    };
};

});

parcelRegister("1EZbw", function(module, exports) {

$parcel$export(module.exports, "Products", () => $2b3a78109aa67a90$export$92e44ea1079b9ec6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
var $2b3a78109aa67a90$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["other"] = "OTHER";
    return Products;
}({});
const $2b3a78109aa67a90$var$primaryProductIndex = 0;
const $2b3a78109aa67a90$var$ProductContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    products: [],
    activeIndex: $2b3a78109aa67a90$var$primaryProductIndex,
    primaryProduct: ''
});
const $2b3a78109aa67a90$export$7d76ff5e8c6ff5f2 = ({ children: children, products: products, activeIndex: activeIndex = 0, primaryProduct: primaryProduct = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)($2b3a78109aa67a90$var$ProductContext.Provider, {
        value: {
            products: products,
            activeIndex: Math.min(products.length - 1, Math.max(0, activeIndex)),
            primaryProduct: primaryProduct
        },
        children: children
    });
const $2b3a78109aa67a90$export$964e8498268f0fe3 = ()=>(0, $5uXOq.useContext)($2b3a78109aa67a90$var$ProductContext).products;
const $2b3a78109aa67a90$export$92c6f3c7c09f3247 = ()=>{
    const { products: products, primaryProduct: primaryProduct } = (0, $5uXOq.useContext)($2b3a78109aa67a90$var$ProductContext);
    return primaryProduct || products[$2b3a78109aa67a90$var$primaryProductIndex];
};
const $2b3a78109aa67a90$export$1fc003d00f9819a9 = ()=>{
    const context = (0, $5uXOq.useContext)($2b3a78109aa67a90$var$ProductContext);
    return context.products[context.activeIndex];
};

});



parcelRegister("aiVOu", function(module, exports) {

$parcel$export(module.exports, "ConfluenceReactivationExperimentTab", () => $2c644d331ce81ef0$export$33a7dd41d4b97411);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $3u0c5 = parcelRequire("3u0c5");

var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");

var $iIaax = parcelRequire("iIaax");

var $kgoHi = parcelRequire("kgoHi");
const $2c644d331ce81ef0$var$Tab = ({ intl: intl, title: title, isEligibleInactiveUser: isEligibleInactiveUser, isEligibleNewUser: isEligibleNewUser, isNudgeShown: isNudgeShown })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const displayNudge = !isNudgeShown && (isEligibleInactiveUser || isEligibleNewUser);
    (0, $5uXOq.useEffect)(()=>{
        displayNudge && fireAnalyticsEvent((0, $3FqY6.onConfluenceReactionNudgeShown)(!!isEligibleNewUser));
    }, [
        displayNudge,
        fireAnalyticsEvent,
        isEligibleNewUser
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        alignItems: "center",
        columnGap: "space.100",
        children: [
            title,
            displayNudge && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: "new",
                children: intl.formatMessage(isEligibleNewUser ? (0, $iIaax.messages).never_active_user : (0, $iIaax.messages).inactive_user)
            })
        ]
    });
};
const $2c644d331ce81ef0$export$33a7dd41d4b97411 = (0, $8RXs9.default)($2c644d331ce81ef0$var$Tab);

});
parcelRegister("iIaax", function(module, exports) {

$parcel$export(module.exports, "messages", () => $71ef92363b081cb5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $71ef92363b081cb5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Confluence reactivation experiment tab nudge
	 */ never_active_user: {
        id: 'product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user',
        defaultMessage: 'Free access',
        description: 'Lozenge next to Confluence tab title indicating the user (who has never been active in Confluence) has free access to Confluence'
    },
    inactive_user: {
        id: 'product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user',
        defaultMessage: 'More results',
        description: 'Lozenge next to Confluence tab title indicating the user (who has been inactive in Confluence) has more results in Confluence'
    }
});

});


parcelRegister("1A3ka", function(module, exports) {

$parcel$export(module.exports, "useConfluenceSuppliers", () => $d7659a1c2a00f403$export$c9757f311cedcc1d);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5S6Yv = parcelRequire("5S6Yv");

var $gMpaQ = parcelRequire("gMpaQ");

var $lMcGZ = parcelRequire("lMcGZ");

var $k4hbD = parcelRequire("k4hbD");

var $3CuYo = parcelRequire("3CuYo");

var $2dI5H = parcelRequire("2dI5H");

var $kv2Va = parcelRequire("kv2Va");

var $iRI1s = parcelRequire("iRI1s");

var $luwNM = parcelRequire("luwNM");

var $cGpvK = parcelRequire("cGpvK");
const $d7659a1c2a00f403$var$RECENT_ITEMS_SIZE_LIMIT = 10;
const $d7659a1c2a00f403$var$RECENT_SPACES_SIZE_LIMIT = 3;
const $d7659a1c2a00f403$var$ITEM_LIMIT_SIZE = 10;
const $d7659a1c2a00f403$var$SPACE_LIMIT_SIZE = 3;
const $d7659a1c2a00f403$var$PEOPLE_LIMIT_SIZE = 3;

const $d7659a1c2a00f403$export$c9757f311cedcc1d = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, spaceFilterStore: spaceFilterStore, peopleFilterStore: peopleFilterStore, isExpanded: isExpanded, isUserAnonymous: isUserAnonymous, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, rendererOverride: rendererOverride, additionalContentTypesEnabled: additionalContentTypesEnabled })=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const warmUpCache = isExpanded && query !== '' && getActiveProduct()?.id === (0, $5S6Yv.CONFLUENCE_PRODUCT_ID);
    const [hasFetchedSpaces, setHasFetchedSpaces] = (0, $5uXOq.useState)(spaceFilterStore?.availableFilters?.length > 0 || false);
    const intl = (0, $koVbs.default)();
    const hasFetchedUsersRef = (0, $5uXOq.useRef)(peopleFilterStore?.availableFilters?.length > 0 || false);
    const { isCollaborationGraphEnabled: isCollaborationGraphEnabled } = recentClientConfig;
    const { getRecentItems: getRecentItems, getRecentSpaces: getRecentSpaces, getRecentPeople: getRecentPeople, getCollabGraphContainers: getCollabGraphContainers } = (0, $3CuYo.useRecentsClient)(recentClientConfig);
    // Set the default space filters to come from the collab graph if they are not enabled for recents
    (0, $5uXOq.useEffect)(()=>{
        if (warmUpCache && !isCollaborationGraphEnabled && !hasFetchedSpaces) getCollabGraphContainers().then((spaces)=>{
            if (spaces.items.length > 0) spaceFilterStore.setDefaultFilters(spaces.items.map((item, index)=>({
                    id: item.id,
                    spaceKey: item.key,
                    avatarUrl: item.avatarUrl,
                    label: item.name,
                    filterSource: (0, $gMpaQ.FilterOptionSource).RECENT,
                    isChecked: false,
                    isVisible: index < 3
                })));
            setHasFetchedSpaces(true);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isCollaborationGraphEnabled,
        getCollabGraphContainers,
        isExpanded,
        warmUpCache
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (warmUpCache && !hasFetchedUsersRef.current) {
            getRecentPeople().then((recentPeople)=>{
                peopleFilterStore.setDefaultFilters(recentPeople.items.map((item, index)=>({
                        id: item.userId,
                        avatarUrl: item.avatarUrl,
                        label: item.name,
                        filterSource: (0, $gMpaQ.FilterOptionSource).RECENT,
                        isChecked: false,
                        isVisible: index < 3
                    })));
            });
            hasFetchedUsersRef.current = true;
        }
    }, [
        warmUpCache,
        peopleFilterStore,
        getRecentPeople
    ]);
    const contentResultRenderer = additionalContentTypesEnabled && rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, $lMcGZ.ConfluenceItemResultRenderer);
    const scope = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, $5S6Yv.ConfluenceScope).Item;
    const preQueryItemSupplier = (0, $5uXOq.useMemo)(()=>()=>Promise.all([
                getRecentItems(),
                getRecentSpaces()
            ]).then((results)=>{
                const recentItems = results[0].items;
                const recentSpaces = results[1].items;
                if (!hasFetchedSpaces && isCollaborationGraphEnabled) {
                    spaceFilterStore.setDefaultFilters(recentSpaces.map((item, index)=>({
                            id: item.id,
                            spaceKey: item.key,
                            avatarUrl: item.avatarUrl,
                            label: item.name,
                            filterSource: (0, $gMpaQ.FilterOptionSource).RECENT,
                            isChecked: false,
                            isVisible: index < 3
                        })));
                    setHasFetchedSpaces(true);
                }
                return {
                    size: results.reduce((sum, { items: items })=>{
                        return sum + items.length;
                    }, 0),
                    sections: [
                        {
                            id: 'recent-confluence-items',
                            titleRenderer: (0, $lMcGZ.sectionTitleRenderer)(!!autocorrectEnabled),
                            title: intl.formatMessage((0, $k4hbD.messages).common_recently_viewed_section_heading),
                            resultRenderer: contentResultRenderer,
                            scope: scope,
                            searchResults: recentItems.map((result)=>({
                                    id: result.resultId,
                                    title: result.name,
                                    meta: result.containerName,
                                    additionalMeta: result.contentType,
                                    url: result.href,
                                    containerId: result.spaceId,
                                    icon: (0, $luwNM.getAvatarForConfluenceObjectResult)({
                                        type: result.contentType,
                                        title: result.name,
                                        isCollapsed: false
                                    }),
                                    isRecentResult: true
                                })),
                            resultLimit: $d7659a1c2a00f403$var$RECENT_ITEMS_SIZE_LIMIT
                        },
                        {
                            id: 'recent-confluence-spaces',
                            title: intl.formatMessage((0, $k4hbD.messages).common_recently_spaces_section_heading),
                            searchResults: recentSpaces.map((result)=>({
                                    id: result.resultId,
                                    title: result.name,
                                    meta: '',
                                    url: result.href,
                                    containerId: '',
                                    iconUrl: result.avatarUrl,
                                    isRecentResult: true
                                })),
                            resultLimit: $d7659a1c2a00f403$var$RECENT_SPACES_SIZE_LIMIT
                        }
                    ]
                };
            }), [
        getRecentItems,
        getRecentSpaces,
        hasFetchedSpaces,
        isCollaborationGraphEnabled,
        autocorrectEnabled,
        intl,
        spaceFilterStore,
        contentResultRenderer,
        scope
    ]);
    const postQueryItemSupplier = (0, $5uXOq.useMemo)(()=>!searchClientConfig?.graphQLEnabled ? undefined : async (args)=>{
            const { hasCheckedFilters: hasCheckedFilters, getUserSearchResults: getUserSearchResults } = await (parcelRequire("h6iqq"));
            const pageBlogAttachmentGraphQLResultMapper = ({ node: item })=>{
                return {
                    id: (0, $cGpvK.transformAriToId)(item?.id || '', item?.type || ''),
                    title: item?.title || '',
                    url: item?.url || '',
                    meta: item?.space?.name || '',
                    additionalMeta: item?.lastModified ? formatDate ? formatDate(item?.lastModified) : (0, $iRI1s.defaultFormatDate)(item?.lastModified) : '',
                    containerId: (0, $cGpvK.transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
                    type: item?.type || '',
                    icon: (0, $luwNM.getAvatarForConfluenceObjectResult)({
                        type: item?.type || '',
                        title: item?.title || '',
                        iconCssClass: item?.iconCssClass || '',
                        isCollapsed: true
                    })
                };
            };
            const spaceGraphQLResultMapper = ({ node: item })=>{
                return {
                    id: (0, $cGpvK.transformAriToId)(item?.id || '', item?.type || ''),
                    title: item?.title || '',
                    meta: '',
                    url: item?.url || '',
                    type: item?.type || '',
                    containerId: (0, $cGpvK.transformAriToId)(item?.id || '', item?.type || ''),
                    icon: (0, $luwNM.GenericConfluenceIconRenderer)(`/wiki${item?.iconPath || ''}`, true)
                };
            };
            const peopleResultMapper = (user)=>({
                    title: user.name,
                    id: user.id,
                    meta: '',
                    url: `${window.location.origin}/wiki/people/${user.id}`,
                    icon: (0, $luwNM.GenericConfluenceIconRenderer)(`${user.avatarUrl}`, true)
                });
            const fetchOnlyPageBlogAttachments = hasCheckedFilters(args.filters);
            const graphQLResultsPromise = searchClientConfig?.graphQLPromise?.(args);
            const peopleResultsPromise = fetchOnlyPageBlogAttachments || isUserAnonymous ? Promise.resolve([]) : getUserSearchResults({
                query: args.query,
                cloudId: searchClientConfig?.cloudId || '',
                principalId: searchClientConfig?.userId,
                intl: intl
            }).catch((e)=>[]);
            return Promise.all([
                graphQLResultsPromise,
                peopleResultsPromise
            ]).then((results)=>{
                const pageBlogAttachmentResults = results[0]?.search.pageBlogAttachments.edges.map(pageBlogAttachmentGraphQLResultMapper) || [];
                const pageBlogAttachmentsCount = results[0]?.search.pageBlogAttachments.totalCount;
                const spaceResults = results[0]?.search.spaces?.edges.map(spaceGraphQLResultMapper) || [];
                const peopleResults = results[1].map(peopleResultMapper) || [];
                return {
                    sections: [
                        {
                            id: scope,
                            title: intl.formatMessage((0, $k4hbD.messages).confluence_content_section_heading),
                            searchResults: pageBlogAttachmentResults,
                            titleRenderer: (0, $lMcGZ.sectionTitleRenderer)(!!autocorrectEnabled),
                            resultRenderer: contentResultRenderer,
                            showResultCount: true,
                            size: pageBlogAttachmentsCount || undefined,
                            resultLimit: $d7659a1c2a00f403$var$ITEM_LIMIT_SIZE
                        },
                        {
                            id: (0, $5S6Yv.ConfluenceScope).Space,
                            title: intl.formatMessage((0, $k4hbD.messages).confluence_spaces_section_heading),
                            searchResults: spaceResults,
                            resultLimit: $d7659a1c2a00f403$var$SPACE_LIMIT_SIZE
                        },
                        {
                            id: (0, $5S6Yv.ConfluenceScope).People,
                            title: intl.formatMessage((0, $k4hbD.messages).confluence_people_section_heading),
                            searchResults: peopleResults,
                            resultLimit: $d7659a1c2a00f403$var$PEOPLE_LIMIT_SIZE
                        }
                    ],
                    size: pageBlogAttachmentResults.length + spaceResults.length + peopleResults.length
                };
            });
        }, [
        autocorrectEnabled,
        formatDate,
        intl,
        searchClientConfig,
        contentResultRenderer,
        isUserAnonymous,
        scope
    ]);
    return {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    };
};

});
parcelRegister("cGpvK", function(module, exports) {

$parcel$export(module.exports, "transformAriToId", () => $4d63df86a1050889$export$6d8886e8d5cdbeec);
const $4d63df86a1050889$export$6d8886e8d5cdbeec = (id, type)=>{
    switch(type){
        case 'page':
            return id.split(':page/')[1];
        case 'blogpost':
            return id.split(':blogpost/')[1];
        case 'attachment':
            return id.split(':attachment/')[1];
        case 'space':
            return id.split(':space/')[1];
        case 'whiteboard':
            return id.split(':whiteboard/')[1];
        case 'embed':
            // embed ari url contains activation id so we split it differently here
            const embedAri = id.split('/');
            return embedAri[embedAri.length - 1];
        case 'database':
            // Databases ari url contains activation id so we split it differently here
            const databaseAri = id.split('/');
            return databaseAri[databaseAri.length - 1];
        default:
            return id;
    }
};

});

parcelRegister("h6iqq", function(module, exports) {

let $c7314a160a3889c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7314a160a3889c0$var$load("bD6YK").then(()=>parcelRequire('71tek'));

});


parcelRegister("gQz3v", function(module, exports) {

$parcel$export(module.exports, "useConfluenceDateFilter", () => $07d41b9ec9c896ea$export$a31429ad2d37d59f);

var $5uXOq = parcelRequire("5uXOq");

var $5S6Yv = parcelRequire("5S6Yv");

var $gMpaQ = parcelRequire("gMpaQ");

var $bONub = parcelRequire("bONub");
var $3RKSV = parcelRequire("3RKSV");

var $kuaGQ = parcelRequire("kuaGQ");

var $koVbs = parcelRequire("koVbs");
const $07d41b9ec9c896ea$var$getUTCDateRange = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    const startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const endOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999);
    const from = new Date(startOfDay.getTime() - fromOffset * 86400000);
    const to = new Date(endOfDay.getTime() - toOffset * 86400000);
    return {
        from: from.toISOString().split('Z')[0],
        to: to.toISOString().split('Z')[0]
    };
};
const $07d41b9ec9c896ea$export$a31429ad2d37d59f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dateFilterOptionsAndValues = (0, $5uXOq.useMemo)(()=>{
        return {
            [(0, $bONub.LastModifiedValues).DEFAULT]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).DEFAULT,
                    label: formatMessage((0, $kuaGQ.messages).confluence_date_filter_any_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: true,
                    isVisible: true
                },
                dateRange: {
                    from: '',
                    to: ''
                }
            },
            [(0, $bONub.LastModifiedValues).TODAY]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).TODAY,
                    label: formatMessage((0, $kuaGQ.messages).confluence_date_filter_today_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(0, 0)
            },
            [(0, $bONub.LastModifiedValues).YESTERDAY]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).YESTERDAY,
                    label: formatMessage((0, $kuaGQ.messages).confluence_date_filter_yesterday_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(1, 1)
            },
            [(0, $bONub.LastModifiedValues).PAST_SEVEN_DAYS]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).PAST_SEVEN_DAYS,
                    label: formatMessage((0, $kuaGQ.messages).confluence_date_filter_week_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(7, 0)
            },
            [(0, $bONub.LastModifiedValues).PAST_THIRTY_DAYS]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).PAST_THIRTY_DAYS,
                    label: formatMessage((0, $kuaGQ.messages).confluence_date_filter_month_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(30, 0)
            },
            [(0, $bONub.LastModifiedValues).PAST_YEAR]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).PAST_YEAR,
                    label: formatMessage((0, $kuaGQ.messages).confluence_date_filter_year_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(365, 0)
            }
        };
    }, [
        formatMessage
    ]);
    const dateFilterOptions = (0, $5uXOq.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
        dateFilterOptionsAndValues
    ]);
    const dateFilterStore = (0, $3RKSV.useFilterStore)(dateFilterOptions, (0, $5S6Yv.CONFLUENCE_PRODUCT_ID), (0, $5S6Yv.ConfluenceFilters).Date);
    const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, $bONub.DEFAULT_OPTION))?.id;
    const getLastModifiedValue = (0, $5uXOq.useCallback)(()=>{
        return appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? {
            '@type': (0, $5S6Yv.ConfluenceFilters).Date,
            from: dateFilterOptionsAndValues[appliedDateFilter].dateRange.from,
            to: dateFilterOptionsAndValues[appliedDateFilter].dateRange.to
        } : null;
    }, [
        appliedDateFilter,
        dateFilterOptionsAndValues
    ]);
    const confluenceTabDateFilter = (0, $5uXOq.useMemo)(()=>{
        return [
            {
                ['@type']: (0, $5S6Yv.ConfluenceFilters).Date,
                uiVariant: (0, $bONub.FilterUIVariant).STATIC_SELECT,
                fieldName: 'from',
                store: dateFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, $kuaGQ.messages).confluence_date_filter_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: ()=>getLastModifiedValue()
            }
        ];
    }, [
        dateFilterStore,
        formatMessage,
        getLastModifiedValue
    ]);
    return {
        appliedDateFilter: appliedDateFilter,
        confluenceTabDateFilter: confluenceTabDateFilter
    };
};

});
parcelRegister("kuaGQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $36e36222d4b88bcd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $36e36222d4b88bcd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    confluence_typing_state_header_text: {
        id: 'product_search_dialog.confluence.typing_state_header_text',
        defaultMessage: 'Search for content in Confluence',
        description: 'Text for the typing state header for confluence'
    },
    confluence_date_filter_title: {
        id: 'product_search_dialog.confluence.date_filter_title',
        defaultMessage: 'Last updated',
        description: 'Section title for date filters in Confluence'
    },
    confluence_date_filter_today_label: {
        id: 'product_search_dialog.confluence.date_filter_today',
        defaultMessage: 'Today',
        description: 'Date filter label for current day.'
    },
    confluence_date_filter_yesterday_label: {
        id: 'product_search_dialog.confluence.date_filter_yesterday',
        defaultMessage: 'Yesterday',
        description: 'Date filter label for previous day.'
    },
    confluence_date_filter_week_label: {
        id: 'product_search_dialog.confluence.date_filters_week',
        defaultMessage: 'Past 7 days',
        description: 'Date filter label for past week.'
    },
    confluence_date_filter_month_label: {
        id: 'product_search_dialog.confluence.date_filters_month',
        defaultMessage: 'Past 30 days',
        description: 'Date filter label for past month.'
    },
    confluence_date_filter_year_label: {
        id: 'product_search_dialog.confluence.date_filters_year',
        defaultMessage: 'Past year',
        description: 'Date filter label for past year.'
    },
    confluence_date_filter_any_label: {
        id: 'product_search_dialog.confluence.date_filters_any',
        defaultMessage: 'Any time',
        description: 'Date filter label for any time.'
    }
});

});


parcelRegister("iCcpP", function(module, exports) {

$parcel$export(module.exports, "ExtensibleConfluenceTabFooter", () => $449ae06cc59cca20$export$d7ad215466e34991);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $a353g = parcelRequire("a353g");

var $1W52p = parcelRequire("1W52p");

var $4f9Ma = parcelRequire("4f9Ma");

var $1W52p = parcelRequire("1W52p");
const $449ae06cc59cca20$var$ReturnIcon = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.ReturnIconWithModifier), {});
const $449ae06cc59cca20$export$d7ad215466e34991 = ({ orgId: orgId, cloudId: cloudId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.AdvancedSearchFooter), {
                    ...props,
                    returnKeyIconComponent: $449ae06cc59cca20$var$ReturnIcon
                })
            }),
            orgId && cloudId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f9Ma.AtlassianHomeSearchLink), {
                    orgId: orgId,
                    cloudId: cloudId,
                    showModifierIcon: true
                })
            })
        ]
    });
};

});

parcelRegister("lTJ4g", function(module, exports) {

let $ff11b191b8e13477$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff11b191b8e13477$var$load("egHGn").then(()=>parcelRequire('9zGp3'));

});


parcelRegister("7PQor", function(module, exports) {

$parcel$export(module.exports, "ExtensibleJiraTab", () => $03501126184a65a5$export$8db2a2835d8b9d10);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $a353g = parcelRequire("a353g");

var $k4hbD = parcelRequire("k4hbD");

var $8Xs9r = parcelRequire("8Xs9r");
var $kv2Va = parcelRequire("kv2Va");

var $f4GCr = parcelRequire("f4GCr");

var $9Lv6B = parcelRequire("9Lv6B");

var $3UF9C = parcelRequire("3UF9C");

var $9fi3n = parcelRequire("9fi3n");

var $f2vlR = parcelRequire("f2vlR");

var $eW6Jk = parcelRequire("eW6Jk");

var $5fXfn = parcelRequire("5fXfn");

var $3FqY6 = parcelRequire("3FqY6");

var $dVo7Y = parcelRequire("dVo7Y");

var $95MIc = parcelRequire("95MIc");

var $7VoGI = parcelRequire("7VoGI");

var $ha1Zp = parcelRequire("ha1Zp");

var $i5cPn = parcelRequire("i5cPn");

var $2dI5H = parcelRequire("2dI5H");

var $1yUhh = parcelRequire("1yUhh");

var $icutB = parcelRequire("icutB");

var $azBuE = parcelRequire("azBuE");

var $edfe8 = parcelRequire("edfe8");

var $4tuQr = parcelRequire("4tuQr");

var $bYLf6 = parcelRequire("bYLf6");

var $5hwDL = parcelRequire("5hwDL");

var $4f9Ma = parcelRequire("4f9Ma");

var $1W52p = parcelRequire("1W52p");

var $lvCts = parcelRequire("lvCts");
let $03501126184a65a5$var$hasLoadedFilters = false;
let $03501126184a65a5$var$currentProjectRef;
let $03501126184a65a5$var$currentUserRef;
const $03501126184a65a5$export$5eff96142961f4a2 = (value)=>$03501126184a65a5$var$hasLoadedFilters = value;
const $03501126184a65a5$var$JiraNoPreQueryResults = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bYLf6.default), {
        message: (0, $k4hbD.messages).jira_empty_state_prequery_heading
    });
const $03501126184a65a5$export$8db2a2835d8b9d10 = ({ features: features, children: children, config: config, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, currentProject: currentProject, currentUser: currentUser, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { jiraSites: jiraSites } = (0, $dVo7Y.useSearchConfigContext)();
    const { isExpanded: isExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const { query: query } = (0, $2dI5H.useQuery)();
    const hasAdvancedRoadmapsAccess = !!features?.hasAdvancedRoadmapsAccess;
    const hasSoftwareAccess = !!features?.hasSoftwareAccess;
    const isPreviewOnJiraSearchResultsEnabled = !!features?.isPreviewOnJiraSearchResultsEnabled;
    const isReportedByMeFilterEnabled = !!features?.isReportedByMeFilterEnabled;
    const isConsistentIssueDetailsEnabled = !!features?.isConsistentIssueDetailsEnabled;
    const isDateFromFilterEnabled = !!features?.enableDateFromFilter;
    const shouldShowIssueLabelsFilter = !!features?.enableIssueLabelsFilter;
    const isPreQueryFiltersEnabled = true;
    const isSearchWithTextFieldInAllIssuesLinkEnabled = !!features?.isSearchWithTextFieldInAllIssuesLinkEnabled;
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const { defineFilters: defineFilters } = (0, $3UF9C.useGenericFilters)();
    const { filtersDefinition: filtersDefinition, loadFilters: loadFilters, filterValueGetters: filterValueGetters } = (0, $9fi3n.useFilters)(rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled);
    const { jiraTabDateFilterDefinition: jiraTabDateFilterDefinition, appliedDateFilterValue: appliedDateFilterValue } = (0, $5hwDL.useJiraDateFilter)({
        isDateFromFilterEnabled: isDateFromFilterEnabled
    });
    const abTest = (0, $4tuQr.useABTest)();
    const isFasterSearchDisabled = abTest !== null && abTest !== undefined && (abTest.experimentId === 'durian-without-faster-search' || abTest.experimentId === 'default-without-faster-search');
    if ((!$03501126184a65a5$var$hasLoadedFilters || $03501126184a65a5$var$currentProjectRef?.id !== currentProject?.id || $03501126184a65a5$var$currentUserRef?.id !== currentUser?.id || $03501126184a65a5$var$currentUserRef?.avatarUrl !== currentUser?.avatarUrl) && isExpanded && getActiveProduct()?.id === (0, $9Lv6B.JIRA_PRODUCT_ID) && (isPreQueryFiltersEnabled || query !== '')) {
        loadFilters();
        $03501126184a65a5$var$currentProjectRef = currentProject;
        $03501126184a65a5$var$currentUserRef = currentUser;
        $03501126184a65a5$export$5eff96142961f4a2(true);
    }
    defineFilters((0, $9Lv6B.JIRA_PRODUCT_ID), [
        ...isDateFromFilterEnabled ? jiraTabDateFilterDefinition : [],
        ...filtersDefinition
    ]);
    const { getFiltersAdvancedSearchUrl: getFiltersAdvancedSearchUrl } = (0, $eW6Jk.useURLFactory)(filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled);
    const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $4f9Ma.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return getFiltersAdvancedSearchUrl(query, baseUrl);
    }, [
        getFiltersAdvancedSearchUrl,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    const { recentSectionTitleGenerator: recentSectionTitleGenerator, sections: sections } = (0, $f2vlR.useSections)(hasAdvancedRoadmapsAccess, hasSoftwareAccess, getFiltersAdvancedSearchUrl, isPreviewOnJiraSearchResultsEnabled, (0, $koVbs.default)(), formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled);
    const itemSuppliers = (0, $f4GCr.useDefaultSuppliers)((0, $9Lv6B.JIRA_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        id: (0, $9Lv6B.JIRA_PRODUCT_ID),
        expandedStateInputPlaceholder: formatMessage((0, $k4hbD.messages).jira_search_placeholder),
        title: formatMessage((0, $k4hbD.messages).jira_tab_label),
        autocorrectEnabled: autocorrectEnabled,
        sections: sections,
        preQuerySectionTitleGenerator: recentSectionTitleGenerator,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        ...rest,
        ...itemSuppliers,
        permissionSupplier: jiraSites.length > 0 ? (0, $ha1Zp.defaultPermissionsSupplier) : rest.permissionSupplier,
        appendQueryParams: (0, $1yUhh.appendQueryParams),
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled,
        debounceTime: 300,
        children: ({ linkComponent: linkComponent, productState: productState })=>{
            return {
                Body: ()=>{
                    if (productState === (0, $azBuE.ProductStates).PostQueryLoading && isFasterSearchDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $edfe8.LoadingSpinner), {});
                    else if (productState === (0, $azBuE.ProductStates).PreQueryNoResult) return /*#__PURE__*/ (0, $2OMIu.jsx)($03501126184a65a5$var$JiraNoPreQueryResults, {});
                },
                SectionFooter: jiraSites.length > 1 ? undefined // don't show the footer for multi sites
                 : ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $icutB.default), {
                        advancedSearchSelected: (0, $3FqY6.onAdvancedSearchSelected),
                        linkComponent: linkComponent,
                        productState: productState,
                        features: features
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5fXfn.JiraAdvancedSearch), {
                                returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.ReturnIconWithModifier), {}) : undefined,
                                linkComponent: linkComponent,
                                productState: productState,
                                features: features
                            }),
                            showAtlassianHomeSearchLink && orgId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f9Ma.AtlassianHomeSearchLink), {
                                    orgId: orgId,
                                    cloudId: cloudId,
                                    showModifierIcon: true
                                })
                            })
                        ]
                    })
            };
        }
    });
};

});
parcelRegister("9Lv6B", function(module, exports) {

$parcel$export(module.exports, "JIRA_PRODUCT_ID", () => $88ac52b5e26a6c16$export$bf5ad8f7e6312fe2);
$parcel$export(module.exports, "NAVIGATION_V3_EXPERIENCE", () => $88ac52b5e26a6c16$export$4a204ebf24901f2e);
$parcel$export(module.exports, "FILTER_LIST_LIMIT", () => $88ac52b5e26a6c16$export$a0931d840e4e9fd9);
$parcel$export(module.exports, "ISSUE_LIST_LIMIT", () => $88ac52b5e26a6c16$export$f6357d218d3fefa3);
$parcel$export(module.exports, "OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS", () => $88ac52b5e26a6c16$export$862d39c85199c14c);
$parcel$export(module.exports, "OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS", () => $88ac52b5e26a6c16$export$223565448ddb4a15);
$parcel$export(module.exports, "DEFAULT_COLLAB_GRAPH_URL", () => $88ac52b5e26a6c16$export$e5ea847149c37067);
$parcel$export(module.exports, "DEFAULT_ISSUE_LABELS_SERVICE_URL", () => $88ac52b5e26a6c16$export$43bbc37c110456ee);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_URL", () => $88ac52b5e26a6c16$export$da00a8e161805bdf);
$parcel$export(module.exports, "JiraScope", () => $88ac52b5e26a6c16$export$45df25c6bac04c78);
$parcel$export(module.exports, "JiraFilters", () => $88ac52b5e26a6c16$export$dfd4d34c680dbd6e);
const $88ac52b5e26a6c16$export$bf5ad8f7e6312fe2 = 'jira';
const $88ac52b5e26a6c16$export$4a204ebf24901f2e = 'jira.nav-v3';
const $88ac52b5e26a6c16$export$a0931d840e4e9fd9 = 10;
const $88ac52b5e26a6c16$export$f6357d218d3fefa3 = 10;
const $88ac52b5e26a6c16$export$862d39c85199c14c = 6;
const $88ac52b5e26a6c16$export$223565448ddb4a15 = 8;
const $88ac52b5e26a6c16$export$e5ea847149c37067 = 'gateway/api/collaboration';
const $88ac52b5e26a6c16$export$43bbc37c110456ee = '/rest/api/1.0/labels/suggest';
const $88ac52b5e26a6c16$export$da00a8e161805bdf = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
var $88ac52b5e26a6c16$export$45df25c6bac04c78 = /*#__PURE__*/ function(JiraScope) {
    JiraScope["Issue"] = "jira.issue";
    JiraScope["ProjectFilter"] = "jira.project,filter";
    JiraScope["BoardProjectFilter"] = "jira.board,project,filter";
    JiraScope["BoardProjectFilterPlans"] = "jira.board,project,filter,plan";
    JiraScope["Project"] = "jira.project";
    JiraScope["Assignee"] = "urs.user-jira";
    return JiraScope;
}({});
var $88ac52b5e26a6c16$export$dfd4d34c680dbd6e = /*#__PURE__*/ function(JiraFilters) {
    JiraFilters["Projects"] = "projects";
    JiraFilters["Assignees"] = "assignees";
    JiraFilters["Status"] = "binary_status_categories";
    JiraFilters["Date"] = "lastModified";
    JiraFilters["ReportedBy"] = "reportedBy";
    JiraFilters["IssueLabels"] = "issueLabels";
    return JiraFilters;
}({});

});

parcelRegister("9fi3n", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $a71ac9960ce3e1f1$export$973ca22476b0e05f);

var $2OMIu = parcelRequire("2OMIu");

var $koVbs = parcelRequire("koVbs");

var $5uXOq = parcelRequire("5uXOq");

var $4Pado = parcelRequire("4Pado");

var $k4hbD = parcelRequire("k4hbD");

var $9Lv6B = parcelRequire("9Lv6B");

var $bONub = parcelRequire("bONub");
var $3RKSV = parcelRequire("3RKSV");
var $3UF9C = parcelRequire("3UF9C");

var $9p2Gk = parcelRequire("9p2Gk");

var $lnyO0 = parcelRequire("lnyO0");

var $gMpaQ = parcelRequire("gMpaQ");

var $71nSq = parcelRequire("71nSq");
const $a71ac9960ce3e1f1$export$fe780e7155e72c07 = (projects, project)=>{
    if (!project) return projects;
    const newOption = {
        ...project,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $gMpaQ.FilterOptionSource).EXTERNAL
    };
    const existingItem = projects.find((s)=>s.id === project.id);
    if (!existingItem?.isVisible) {
        const lastVisibleItemIdx = projects.findIndex((s)=>!s.isVisible) - 1;
        if (lastVisibleItemIdx > 0) projects[lastVisibleItemIdx].isVisible = false;
    }
    return [
        newOption
    ].concat(projects.filter((s)=>s.id !== project.id));
};
const $a71ac9960ce3e1f1$export$e54fe71d6476ce8f = (assignees, currentUser)=>{
    if (!currentUser) return assignees;
    const newOption = {
        id: currentUser.id,
        label: currentUser.name,
        avatarUrl: currentUser.avatarUrl,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $gMpaQ.FilterOptionSource).CURRENT_USER
    };
    const existingItem = assignees.find((assignee)=>assignee.id === currentUser.id);
    if (!existingItem?.isVisible) {
        const lastVisibleItemIdx = assignees.findIndex((assignee)=>!assignee.isVisible) - 1;
        if (lastVisibleItemIdx > 0) assignees[lastVisibleItemIdx].isVisible = false;
    }
    return [
        newOption
    ].concat(assignees.filter((assignee)=>assignee.id !== currentUser.id));
};
const $a71ac9960ce3e1f1$export$973ca22476b0e05f = (rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getFilterItemsByJiraScope: getFilterItemsByJiraScope, getProjectOptions: getProjectOptions, fetchIssueLabelOptions: fetchIssueLabelOptions, statusFilterOptions: statusFilterOptions } = (0, $9p2Gk.useFiltersClient)(config);
    const siteFilterDefinition = (0, $3UF9C.useSiteFilterDefinition)(rest.workspaces || [], (0, $9Lv6B.JIRA_PRODUCT_ID));
    const projectsFilterStore = (0, $3RKSV.useFilterStore)([], (0, $9Lv6B.JIRA_PRODUCT_ID), (0, $9Lv6B.JiraFilters).Projects);
    const assigneesFilterStore = (0, $3RKSV.useFilterStore)([], (0, $9Lv6B.JIRA_PRODUCT_ID), (0, $9Lv6B.JiraFilters).Assignees);
    const reportedByFilterStore = (0, $3RKSV.useFilterStore)([], (0, $9Lv6B.JIRA_PRODUCT_ID), (0, $9Lv6B.JiraFilters).ReportedBy);
    const statusFilterStore = (0, $3RKSV.useFilterStore)(statusFilterOptions, (0, $9Lv6B.JIRA_PRODUCT_ID), (0, $9Lv6B.JiraFilters).Status);
    const issueLabelsFilterStore = (0, $3RKSV.useFilterStore)([], (0, $9Lv6B.JIRA_PRODUCT_ID), (0, $9Lv6B.JiraFilters).IssueLabels);
    const loadFilters = (0, $5uXOq.useCallback)(()=>{
        projectsFilterStore.loadDefaultFilters(getProjectOptions().then((results)=>$a71ac9960ce3e1f1$export$fe780e7155e72c07(results, currentProject)));
        assigneesFilterStore.loadDefaultFilters(getFilterItemsByJiraScope((0, $9Lv6B.JiraScope).Assignee, '').then((results)=>$a71ac9960ce3e1f1$export$e54fe71d6476ce8f(results, currentUser)));
        if (shouldShowIssueLabelsFilter) issueLabelsFilterStore.loadDefaultFilters(fetchIssueLabelOptions(''));
        const defaultReportByOption = currentUser && currentUser.id ? {
            id: currentUser.id,
            label: formatMessage((0, $4Pado.messages).reported_by_me_filter_option),
            avatarUrl: '',
            isChecked: false,
            isVisible: true,
            filterSource: (0, $gMpaQ.FilterOptionSource).CURRENT_USER
        } : undefined;
        if (defaultReportByOption && isReportedByMeFilterEnabled) reportedByFilterStore.setDefaultFilters([
            defaultReportByOption
        ]);
    }, [
        projectsFilterStore,
        getProjectOptions,
        assigneesFilterStore,
        getFilterItemsByJiraScope,
        shouldShowIssueLabelsFilter,
        currentUser,
        formatMessage,
        isReportedByMeFilterEnabled,
        currentProject,
        issueLabelsFilterStore,
        fetchIssueLabelOptions,
        reportedByFilterStore
    ]);
    const searchProject = (0, $5uXOq.useCallback)(async (query)=>{
        const result = await getFilterItemsByJiraScope((0, $9Lv6B.JiraScope).Project, query);
        return result?.map((item)=>({
                value: item,
                label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnyO0.FilterOptionItem), {
                    label: item.label,
                    iconProps: {
                        src: item.avatarUrl,
                        appearance: 'square'
                    }
                })
            })) || [];
    }, [
        getFilterItemsByJiraScope
    ]);
    const searchAssignee = (0, $5uXOq.useCallback)(async (query)=>{
        const result = await getFilterItemsByJiraScope((0, $9Lv6B.JiraScope).Assignee, query);
        return result?.map((item)=>({
                value: item,
                label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnyO0.FilterOptionItem), {
                    label: item.label,
                    iconProps: {
                        src: item.avatarUrl
                    }
                })
            })) || [];
    }, [
        getFilterItemsByJiraScope
    ]);
    const searchIssueLabels = (0, $5uXOq.useCallback)(async (query)=>{
        if (shouldShowIssueLabelsFilter) {
            const result = await fetchIssueLabelOptions(query);
            return result?.map((item)=>({
                    value: item,
                    label: item.label
                })) || [];
        }
        return [];
    }, [
        fetchIssueLabelOptions,
        shouldShowIssueLabelsFilter
    ]);
    const defaultValueGetter = (0, $5uXOq.useCallback)((availableFilters, valueKey = 'id')=>availableFilters.filter((f)=>f.isChecked && f[valueKey]).map((f)=>f[valueKey]), []);
    const appliedReportedByFilter = reportedByFilterStore?.availableFilters?.find((f)=>f.isChecked)?.id;
    const getReportedByMe = (0, $5uXOq.useCallback)(()=>{
        return appliedReportedByFilter ? {
            '@type': (0, $9Lv6B.JiraFilters).ReportedBy,
            accountIds: [
                appliedReportedByFilter
            ]
        } : null;
    }, [
        appliedReportedByFilter
    ]);
    const reportedByDefinition = isReportedByMeFilterEnabled ? [
        {
            ['@type']: (0, $9Lv6B.JiraFilters).ReportedBy,
            fieldName: 'accountIds',
            store: reportedByFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $4Pado.messages).report_by_filters_title),
            findMoreLabel: '',
            mapSelectionToAppliedValue: getReportedByMe,
            filterConfig: {
                hideIcon: true,
                usePreloadedOptions: true,
                labelComponent: (0, $71nSq.FilterColLabText)
            }
        }
    ] : [];
    const appliedIssueLabelsFilters = (0, $5uXOq.useMemo)(()=>defaultValueGetter(issueLabelsFilterStore.availableFilters, 'label'), [
        defaultValueGetter,
        issueLabelsFilterStore.availableFilters
    ]);
    const getAppliedIssueLabels = (0, $5uXOq.useCallback)(()=>{
        if (appliedIssueLabelsFilters.length > 0) return {
            '@type': (0, $9Lv6B.JiraFilters).IssueLabels,
            issueLabels: appliedIssueLabelsFilters
        };
        return null;
    }, [
        appliedIssueLabelsFilters
    ]);
    const issueLabelsFilterDefinition = shouldShowIssueLabelsFilter ? [
        {
            ['@type']: (0, $9Lv6B.JiraFilters).IssueLabels,
            uiVariant: (0, $bONub.FilterUIVariant).MULTI_SELECT,
            fieldName: 'issueLabels',
            store: issueLabelsFilterStore,
            loadFilterOptions: searchIssueLabels,
            sectionLabel: formatMessage((0, $4Pado.messages).issue_labels_filters_title),
            findMoreLabel: '',
            placeholderText: formatMessage((0, $4Pado.messages).issue_labels_filters_placeholder),
            mapSelectionToAppliedValue: getAppliedIssueLabels,
            filterConfig: {
                mainGroupLabel: formatMessage((0, $4Pado.messages).issue_labels_filters_options_group_label)
            }
        }
    ] : [];
    const filtersDefinition = [
        ...siteFilterDefinition,
        {
            ['@type']: (0, $9Lv6B.JiraFilters).Projects,
            fieldName: 'projectIds',
            store: projectsFilterStore,
            loadFilterOptions: searchProject,
            sectionLabel: formatMessage((0, $k4hbD.messages).project_filters_title),
            findMoreLabel: formatMessage((0, $k4hbD.messages).project_filters_find_more),
            filterConfig: {
                filterOptionIconShape: 'square'
            }
        },
        {
            ['@type']: (0, $9Lv6B.JiraFilters).Assignees,
            fieldName: 'accountIds',
            store: assigneesFilterStore,
            loadFilterOptions: searchAssignee,
            sectionLabel: formatMessage((0, $k4hbD.messages).assignee_filters_title),
            findMoreLabel: formatMessage((0, $k4hbD.messages).assignee_filters_find_more),
            filterConfig: {
                filterOptionIconShape: 'circle'
            }
        },
        ...reportedByDefinition,
        {
            ['@type']: (0, $9Lv6B.JiraFilters).Status,
            fieldName: 'binaryStatusCategories',
            store: statusFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $k4hbD.messages).binary_status_category_filters_title),
            findMoreLabel: '',
            filterConfig: {
                filterGroupedBy: 'row',
                hideIcon: true,
                usePreloadedOptions: true
            }
        },
        ...issueLabelsFilterDefinition
    ];
    const filterValueGetters = (0, $5uXOq.useMemo)(()=>({
            projects: ()=>defaultValueGetter(projectsFilterStore.availableFilters),
            assignees: ()=>defaultValueGetter(assigneesFilterStore.availableFilters),
            statuses: ()=>defaultValueGetter(statusFilterStore.availableFilters),
            reportedBy: ()=>defaultValueGetter(reportedByFilterStore.availableFilters),
            issueLabels: ()=>shouldShowIssueLabelsFilter ? appliedIssueLabelsFilters : []
        }), [
        defaultValueGetter,
        projectsFilterStore.availableFilters,
        assigneesFilterStore.availableFilters,
        statusFilterStore.availableFilters,
        reportedByFilterStore.availableFilters,
        appliedIssueLabelsFilters,
        shouldShowIssueLabelsFilter
    ]);
    return {
        filterValueGetters: filterValueGetters,
        filtersDefinition: filtersDefinition,
        loadFilters: loadFilters
    };
};

});
parcelRegister("4Pado", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e65a6288707a6982$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e65a6288707a6982$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    // NOT USED
    jira_boards_icon_accessibility_text: {
        id: 'product_search_dialog.jira.boards_icon_accessibility_text',
        defaultMessage: 'Board icon',
        description: 'The alternative accessibility text for a Jira Software board icon.'
    },
    date_filter_today_label: {
        id: 'product_search_dialog.jira.date_filter_today',
        defaultMessage: 'Today',
        description: 'Date filter label for today.'
    },
    date_filter_yesterday_label: {
        id: 'product_search_dialog.jira.date_filter_yesterday',
        defaultMessage: 'Yesterday',
        description: 'Date filter label for yesterday.'
    },
    date_filter_past_7_days_label: {
        id: 'product_search_dialog.jira.date_filter_past_7_days',
        defaultMessage: 'Past 7 days',
        description: 'Date filter label for past 7 days.'
    },
    date_filter_past_30_days_label: {
        id: 'product_search_dialog.jira.date_filter_past_30_days',
        defaultMessage: 'Past 30 days',
        description: 'Date filter label for past 30 days.'
    },
    date_filter_past_year_label: {
        id: 'product_search_dialog.jira.date_filter_past_year',
        defaultMessage: 'Past year',
        description: 'Date filter label for past year.'
    },
    report_by_filters_title: {
        id: 'product_search_dialog.jira.report_by_filters',
        defaultMessage: 'Filter by reporter',
        description: 'Section title for report by filters in Jira'
    },
    reported_by_me_filter_option: {
        id: 'product_search_dialog.jira.reported_by_me_filter',
        defaultMessage: 'Reported by me',
        description: 'Filter option for reported by me'
    },
    issue_labels_filters_title: {
        id: 'product_search_dialog.jira.issue_labels_filters',
        defaultMessage: 'Filter by label',
        description: 'Section title for label filter in Jira'
    },
    issue_labels_filters_placeholder: {
        id: 'product_search_dialog.jira.issue_labels_filters_placeholder',
        defaultMessage: 'Select label',
        description: 'Placeholder text inside Dropdown Select component for label filter'
    },
    issue_labels_filters_options_group_label: {
        id: 'product_search_dialog.jira.issue_labels_filters_options_group_label',
        defaultMessage: 'All labels',
        description: 'Title/label of the options group within the issue labels filter dropdown'
    }
});

});

parcelRegister("9p2Gk", function(module, exports) {

$parcel$export(module.exports, "useFiltersClient", () => $8df42fd5acdf3bca$export$86c53720f7942492);

var $koVbs = parcelRequire("koVbs");

var $k4hbD = parcelRequire("k4hbD");

var $9Lv6B = parcelRequire("9Lv6B");

var $gMpaQ = parcelRequire("gMpaQ");

var $jFHlY = parcelRequire("jFHlY");
var $lQmoS = parcelRequire("lQmoS");

var $lvCts = parcelRequire("lvCts");

var $6SBvm = parcelRequire("6SBvm");

var $8QpSo = parcelRequire("8QpSo");

var $dVo7Y = parcelRequire("dVo7Y");

var $jFHlY = parcelRequire("jFHlY");

var $3JOCw = parcelRequire("3JOCw");

var $dS9cn = parcelRequire("dS9cn");

var $8oG5R = parcelRequire("8oG5R");
var $75NXP = parcelRequire("75NXP");

// Jira uses this for performance monitoring/debugging
const $8df42fd5acdf3bca$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $8df42fd5acdf3bca$var$getCollabGraphClientWithConfig = (0, $8QpSo.default)((config)=>new (0, $jFHlY.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6SBvm))));
const $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS = 3;
const $8df42fd5acdf3bca$export$86c53720f7942492 = (config)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { jiraSites: jiraSites } = (0, $dVo7Y.useSearchConfigContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const statusFilterOptions = [
        {
            id: 'open',
            filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
            isChecked: false,
            isVisible: true,
            label: formatMessage((0, $k4hbD.messages).binary_status_category_filter_option_open)
        },
        {
            id: 'done',
            filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
            isChecked: false,
            isVisible: true,
            label: formatMessage((0, $k4hbD.messages).binary_status_category_filter_option_done)
        }
    ];
    const jiraScopeFilterItemMapper = (item, isVisible, isRecent)=>({
            id: item.id,
            avatarUrl: item.avatarUrl || item.attributes?.avatar?.url,
            label: item.name,
            filterSource: isRecent ? (0, $gMpaQ.FilterOptionSource).RECENT : (0, $gMpaQ.FilterOptionSource).SEARCH,
            isChecked: false,
            isVisible: isVisible
        });
    const filterSupplier = async (currentScope, query, defaultItem)=>{
        if (!aggregatorClient) return [];
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                currentScope
            ],
            modelParams: [],
            resultLimit: (0, $9Lv6B.FILTER_LIST_LIMIT),
            experience: (0, $9Lv6B.NAVIGATION_V3_EXPERIENCE)
        }).then(({ response: response })=>{
            if (!response) throw (0, $lQmoS.responseErrorToError)(`Expected a response but did not get any for scope: ${currentScope}`);
            const scopedResponse = response.retrieveScope(currentScope);
            if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
            if (scopedResponse.error) throw (0, $lQmoS.responseErrorToError)(scopedResponse.error);
            const maxVisible = defaultItem !== undefined ? $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS - 1 : $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS;
            const options = scopedResponse.results.map((result, i)=>jiraScopeFilterItemMapper(result, i < maxVisible, query === ''));
            return defaultItem !== undefined ? [
                defaultItem,
                ...options
            ] : options;
        });
    };
    const fetchCollabGraphProjectOptions = async ()=>{
        const collabGraphClient = $8df42fd5acdf3bca$var$getCollabGraphClientWithConfig({
            collaborationGraphUrl: config?.collaborationGraphUrl || (0, $9Lv6B.DEFAULT_COLLAB_GRAPH_URL),
            cloudId: config?.cloudId || '',
            isMultiSite: jiraSites?.length > 1,
            sites: jiraSites
        });
        return await collabGraphClient.getContainers([
            'jiraProject'
        ], jiraSites).then(({ collaborationGraphEntities: collaborationGraphEntities })=>{
            return collaborationGraphEntities.map((entity, i)=>({
                    label: entity.containerDetails.name,
                    id: entity.containerDetails.id,
                    avatarUrl: entity.containerDetails.iconUrl,
                    filterSource: (0, $gMpaQ.FilterOptionSource).COLLABORATION_GRAPH,
                    isChecked: false,
                    isVisible: i < $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS
                }));
        });
    };
    const interleaveCGAndRecentResults = async (uniqueFn, collabGraphOptions)=>{
        if (collabGraphOptions?.length === (0, $jFHlY.MAX_CG_RESULTS)) return collabGraphOptions;
        else try {
            const recentOptions = await filterSupplier((0, $9Lv6B.JiraScope).Project, '');
            return collabGraphOptions?.length ? (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...collabGraphOptions,
                ...recentOptions
            ], uniqueFn).map((item, i)=>({
                    ...item,
                    isVisible: i < $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS
                })) : recentOptions;
        } catch (e) {
            return collabGraphOptions?.length ? collabGraphOptions : [];
        }
    };
    const getProjectOptions = async ()=>{
        let collaborationGraphOptions;
        if (!!config?.cloudId) collaborationGraphOptions = await fetchCollabGraphProjectOptions();
        const interleavedResults = await interleaveCGAndRecentResults((project)=>project.id, collaborationGraphOptions);
        return interleavedResults;
    };
    const issueLabelFilterItemMapper = (issueLabel, isExternal)=>{
        return {
            id: (0, $8oG5R.sha256Hash)(`${config?.cloudId || ''}_${issueLabel.label}`),
            filterSource: isExternal ? (0, $gMpaQ.FilterOptionSource).EXTERNAL : (0, $gMpaQ.FilterOptionSource).SEARCH,
            isChecked: false,
            isVisible: isExternal,
            label: issueLabel.label
        };
    };
    const fireOperationalEvent = (payload)=>{
        fireAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            source: 'searchDialog',
            ...payload
        });
    };
    const fetchIssueLabelOptions = async (query)=>{
        const params = new URLSearchParams([
            [
                'query',
                query
            ]
        ]);
        const path = `${(0, $9Lv6B.DEFAULT_ISSUE_LABELS_SERVICE_URL)}?${params.toString()}`;
        const options = {
            requestInit: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    [$8df42fd5acdf3bca$var$CAPABILITY_HEADER_NAME]: 'PRODUCT_SEARCH_DIALOG'
                }
            }
        };
        try {
            return await (0, $dS9cn.utils).requestService({
                url: path
            }, options).then((response)=>response?.suggestions?.map((issueLabel)=>issueLabelFilterItemMapper(issueLabel, query === '')));
        } catch (error) {
            fireOperationalEvent({
                action: 'failed',
                actionSubject: 'fetchIssueLabels',
                attributes: {
                    error: (0, $lQmoS.responseErrorToError)(error).message
                }
            });
            return [];
        }
    };
    return {
        mapJiraScopeFilterItem: jiraScopeFilterItemMapper,
        mapIssueLabelFilterItem: issueLabelFilterItemMapper,
        statusFilterOptions: statusFilterOptions,
        fetchIssueLabelOptions: fetchIssueLabelOptions,
        fetchCollabGraphProjectOptions: fetchCollabGraphProjectOptions,
        getProjectOptions: getProjectOptions,
        getFilterItemsByJiraScope: filterSupplier
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';


parcelRegister("71nSq", function(module, exports) {

$parcel$export(module.exports, "FilterColLabText", () => $5b82822acf4f40fb$export$53582861b2eaced6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $k5uoT = parcelRequire("k5uoT");


var $bWGt6 = parcelRequire("bWGt6");
const $5b82822acf4f40fb$export$53582861b2eaced6 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ekcv2vh0"
})({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $k5uoT.gridSize)() * 22}px`,
    paddingLeft: "var(--ds-space-050, 4px)",
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
});

});


parcelRegister("f2vlR", function(module, exports) {

$parcel$export(module.exports, "useSections", () => $23582cadd68d58c9$export$5e1b8123b0df487f);

var $2OMIu = parcelRequire("2OMIu");

var $VSDnB = parcelRequire("VSDnB");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $k4hbD = parcelRequire("k4hbD");

var $9Lv6B = parcelRequire("9Lv6B");

var $1yUhh = parcelRequire("1yUhh");

var $4biU5 = parcelRequire("4biU5");

var $cvYmc = parcelRequire("cvYmc");

var $l7Y85 = parcelRequire("l7Y85");

var $8Vidy = parcelRequire("8Vidy");

var $5C7CC = parcelRequire("5C7CC");

var $hqNwv = parcelRequire("hqNwv");

var $dn5wJ = parcelRequire("dn5wJ");

const $23582cadd68d58c9$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("1TW8v")).then((mod)=>({
            default: mod.HoverCard
        })));
const $23582cadd68d58c9$var$HoverCardResultWrapper = ({ children: children, url: url = '', titleId: titleId = '' })=>{
    const hidePreviewAction = (0, $5uXOq.useMemo)(()=>{
        return {
            hide: false,
            exclude: [
                (0, $dn5wJ.CardAction).PreviewAction
            ]
        };
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l7Y85.HoverCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hqNwv.default), {
            fallback: children,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                fallback: children,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($23582cadd68d58c9$var$HoverCard, {
                    url: url,
                    actionOptions: hidePreviewAction,
                    role: "dialog",
                    titleId: titleId,
                    children: children
                })
            })
        })
    });
};
const $23582cadd68d58c9$var$viewAllLinkRendererIssues = ({ section: section, totalResults: totalResults })=>{
    const isTotalItemsGreaterThanTheLimit = (totalResults || section.searchResults?.length) > (section.resultLimit || 0);
    return isTotalItemsGreaterThanTheLimit ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $k4hbD.messages).common_show_all_results_link
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
};
const $23582cadd68d58c9$export$5e1b8123b0df487f = (hasAdvancedRoadmapsAccess, hasSoftwareAccess, viewAllLinkGenerator, isPreviewOnJiraSearchResultsEnabled, intl, formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled)=>{
    const appendQueryParams = (0, $1yUhh.useQueryParams)();
    const mapJiraItems = (response)=>response.results.map((item)=>{
            const base = {
                id: item.id,
                title: item.name,
                url: appendQueryParams(item.url || '', item),
                meta: '',
                iconUrl: item.attributes?.avatar?.url || '',
                type: item.attributes['@type']
            };
            if (item.attributes && item.attributes['@type'] === (0, $4biU5.AttributeType).issue) return {
                ...base,
                title: `${item.attributes?.key}  ${item.name}`,
                meta: item.attributes?.container?.title || '',
                containerId: item.attributes?.containerId,
                additionalMeta: (0, $8Vidy.getTimeDetailForJiraIssueResult)(intl, formatDate, item.attributes?.updated)
            };
            if (item.attributes && item.attributes['@type'] === (0, $4biU5.AttributeType).board) return {
                ...base,
                meta: item.attributes?.container?.title || '',
                containerId: item.attributes?.containerId
            };
            return base;
        });
    const getSectionDetailsByAccess = ()=>{
        if (hasAdvancedRoadmapsAccess) return {
            scope: (0, $9Lv6B.JiraScope).BoardProjectFilterPlans,
            recentHeading: (0, $k4hbD.messages).jira_recent_boards_projects_filters_plans_section_heading,
            searchHeading: (0, $k4hbD.messages).jira_boards_projects_filters_plans_section_heading
        };
        if (hasSoftwareAccess) return {
            scope: (0, $9Lv6B.JiraScope).BoardProjectFilter,
            recentHeading: (0, $k4hbD.messages).jira_recent_boards_projects_filters_section_heading,
            searchHeading: (0, $k4hbD.messages).jira_boards_projects_filters_section_heading
        };
        return {
            scope: (0, $9Lv6B.JiraScope).ProjectFilter,
            recentHeading: (0, $k4hbD.messages).jira_recent_projects_filters_section_heading,
            searchHeading: (0, $k4hbD.messages).jira_projects_filters_section_heading
        };
    };
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const secondSectionDetails = getSectionDetailsByAccess();
    const enableNoIssueSection = (query, filters)=>!filters.find((filter)=>filter['accountIds']?.length > 0 || filter['projectIds']?.length > 0 || filter['binaryStatusCategories']?.length > 0 || filter['issueLabels']?.length > 0);
    const resultRenderer = ()=>{
        return (args)=>(0, $cvYmc.defaultResultRenderer)(isConsistentIssueDetailsEnabled ? {
                ...args,
                isCollapsed: true
            } : args);
    };
    const sections = [
        {
            id: (0, $9Lv6B.JiraScope).Issue,
            title: formatMessage((0, $VSDnB.fg)('jira-issue-terminology-refresh-m3') ? (0, $k4hbD.messages).jira_issues_section_headingIssueTermRefresh : (0, $k4hbD.messages).jira_issues_section_heading),
            titleRenderer: (0, $5C7CC.sectionTitleRenderer)(!!autocorrectEnabled),
            scope: (0, $9Lv6B.JiraScope).Issue,
            resultMapper: mapJiraItems,
            showResultCount: true,
            resultLimit: (0, $9Lv6B.ISSUE_LIST_LIMIT),
            viewAllLinkRenderer: $23582cadd68d58c9$var$viewAllLinkRendererIssues,
            resultRenderer: resultRenderer(),
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultWrapper: isPreviewOnJiraSearchResultsEnabled ? $23582cadd68d58c9$var$HoverCardResultWrapper : undefined
        },
        {
            id: secondSectionDetails.scope,
            title: formatMessage(secondSectionDetails.searchHeading),
            scope: secondSectionDetails.scope,
            resultMapper: mapJiraItems,
            isEnabled: enableNoIssueSection,
            resultLimit: hasAdvancedRoadmapsAccess ? (0, $9Lv6B.OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS) : (0, $9Lv6B.OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS)
        }
    ];
    const recentSectionTitleGenerator = (section)=>section.id === (0, $9Lv6B.JiraScope).Issue ? formatMessage((0, $VSDnB.fg)('jira-issue-terminology-refresh-m3') ? (0, $k4hbD.messages).jira_recently_viewed_issues_section_headingIssueTermRefresh : (0, $k4hbD.messages).jira_recently_viewed_issues_section_heading) : formatMessage(secondSectionDetails.recentHeading);
    return {
        recentSectionTitleGenerator: recentSectionTitleGenerator,
        sections: sections,
        mapJiraItems: mapJiraItems,
        getSectionDetailsByAccess: getSectionDetailsByAccess
    };
};

});
parcelRegister("1yUhh", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $a8d4b6dc4532af30$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "appendQueryParams", () => $a8d4b6dc4532af30$export$a0b32aef6b0d7373);

var $WBFHc = parcelRequire("WBFHc");

var $4biU5 = parcelRequire("4biU5");

var $7xoNc = parcelRequire("7xoNc");
const $a8d4b6dc4532af30$export$fd0142e43ea55591 = (href, searchResult)=>{
    const hrefWithReferrals = (0, $WBFHc.attachJiraReferralIds)(href, {
        searchObjectId: searchResult.id,
        searchContainerId: searchResult.attributes.containerId,
        searchContentType: (0, $4biU5.AttributeType).issue
    });
    return hrefWithReferrals;
};
const $a8d4b6dc4532af30$export$8aceb1d6e8b68a94 = (href, searchResult)=>{
    const containerAttribute = searchResult.attributes['@type'] === (0, $4biU5.AttributeType).board ? {
        searchContainerId: searchResult.attributes.containerId
    } : {};
    const contentTypeAttribute = {
        searchContentType: searchResult.attributes['@type']
    };
    const hrefWithReferrals = (0, $WBFHc.attachJiraReferralIds)(href, {
        ...contentTypeAttribute,
        ...containerAttribute,
        searchObjectId: searchResult.id
    });
    return hrefWithReferrals;
};
const $a8d4b6dc4532af30$export$b37ee0d76c6d2fbc = ()=>{
    return (href, searchResult)=>{
        if (searchResult.attributes['@type'] === (0, $4biU5.AttributeType).issue) return $a8d4b6dc4532af30$export$fd0142e43ea55591(href, searchResult);
        return $a8d4b6dc4532af30$export$8aceb1d6e8b68a94(href, searchResult);
    };
};
const $a8d4b6dc4532af30$export$a0b32aef6b0d7373 = (url, searchSessionId)=>{
    return (0, $7xoNc.addQueryParams)(url, {
        searchSessionId: searchSessionId
    });
};

});
parcelRegister("WBFHc", function(module, exports) {

$parcel$export(module.exports, "attachJiraReferralIds", () => $f74da4ecf1f65489$export$6ad518df41ca9b2f);

var $7xoNc = parcelRequire("7xoNc");
const $f74da4ecf1f65489$export$6ad518df41ca9b2f = (href, ids)=>{
    return (0, $7xoNc.addQueryParams)(href, ids);
};

});


parcelRegister("l7Y85", function(module, exports) {

$parcel$export(module.exports, "HoverCardWrapper", () => $b907af13130be8c0$export$54477ee883ec6167);

var $bWGt6 = parcelRequire("bWGt6");
function $b907af13130be8c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b907af13130be8c0$export$54477ee883ec6167 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "esh65ev0"
})({
    name: "1082qq3",
    styles: "display:block;width:100%"
});

});

parcelRegister("8Vidy", function(module, exports) {

$parcel$export(module.exports, "getTimeDetailForJiraIssueResult", () => $aaa9f8745993162d$export$1d30bb3376c56ddb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $k4hbD = parcelRequire("k4hbD");

var $b0tBm = parcelRequire("b0tBm");
const $aaa9f8745993162d$export$1d30bb3376c56ddb = (intl, formatDate, updated)=>{
    if (!updated) {
        const message = intl.formatMessage((0, $k4hbD.messages).common_recently_viewed_section_heading);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            title: message,
            children: message
        });
    }
    if (formatDate) return formatDate(updated);
    else return (0, $b0tBm.dateFormatter)(updated);
};

});

parcelRegister("5C7CC", function(module, exports) {

$parcel$export(module.exports, "sectionTitleRenderer", () => $8dc8dbbedcfb827a$export$aee00814c9e3bae7);

var $2OMIu = parcelRequire("2OMIu");

var $VSDnB = parcelRequire("VSDnB");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $k4hbD = parcelRequire("k4hbD");

var $azBuE = parcelRequire("azBuE");

var $337hv = parcelRequire("337hv");

var $71Kgw = parcelRequire("71Kgw");
const $8dc8dbbedcfb827a$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
        const { productState: productState } = args;
        const recentTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $k4hbD.messages).common_recently_viewed_section_heading
        });
        const issuesTitleMessage = (0, $VSDnB.fg)('jira-issue-terminology-refresh-m3') ? (0, $k4hbD.messages).jira_issues_section_headingIssueTermRefresh : (0, $k4hbD.messages).jira_issues_section_heading;
        const issuesTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...issuesTitleMessage
        });
        switch(productState){
            case (0, $azBuE.ProductStates).PreQuerySuccess:
                return recentTitle;
            case (0, $azBuE.ProductStates).PostQueryLoading:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $337hv.LoadingSkeleton), {
                    "data-testid": 'autocorrection-loading-skeleton'
                });
                return issuesTitle;
            case (0, $azBuE.ProductStates).PostQuerySuccess:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $71Kgw.AutocorrectAsyncWrapper), {
                    fallback: issuesTitle
                });
                return issuesTitle;
            default:
                return issuesTitle;
        }
    };

});

parcelRegister("hqNwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $971336ce10923695$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $971336ce10923695$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onError && this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
var $971336ce10923695$export$2e2bcd8739ae039 = $971336ce10923695$var$ErrorBoundary;

});

parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("1TW8v", function(module, exports) {

let $1628061f1439ac99$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1628061f1439ac99$var$load("kNFvF"),
    $1628061f1439ac99$var$load("jw4Hh")
]).then(()=>parcelRequire('3Awyp'));

});


parcelRegister("eW6Jk", function(module, exports) {

$parcel$export(module.exports, "useURLFactory", () => $0622859967535f1a$export$f63780fc2b3633e);

var $5uXOq = parcelRequire("5uXOq");

var $9Lv6B = parcelRequire("9Lv6B");
/**
 * Builds a JQL query for text search input using summary and description
 */ const $0622859967535f1a$var$buildTextSearchInputJql = (query)=>{
    if (!query) return '';
    const encodedQuery = encodeURIComponent(query);
    return `textfields ~ "${encodedQuery}*"`;
};
const $0622859967535f1a$var$buildJQLAdvancedIssueUrl = (jql)=>`/issues/?jql=${jql}`;
const $0622859967535f1a$var$buildJiraSearchUrl = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $0622859967535f1a$var$buildSmartQueryAdvancedSearchUrl = (query)=>`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;
const $0622859967535f1a$var$escapeAndQuoteLabels = (label)=>{
    // Escape backslashes and double quotes
    const escapedLabel = label.replace(/([\\"])/g, '\\$1');
    // Wrap the escaped label in double quotes
    return `"${escapedLabel}"`;
};
const $0622859967535f1a$var$buildJqlQuery = (query, projectIds, accountIds, reporterIds, binaryStatusCategoryValues, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled)=>{
    let textJQL;
    if (isSearchWithTextFieldInAllIssuesLinkEnabled) textJQL = query ? `text ~ "${encodeURIComponent(query)}*"` : '';
    else textJQL = query ? $0622859967535f1a$var$buildTextSearchInputJql(query) : '';
    const projectJQL = projectIds.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : '';
    const assigneeJQL = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : '';
    const issueLabelsJQL = issueLabels.length > 0 ? `labels IN (${encodeURIComponent(issueLabels.map((label)=>$0622859967535f1a$var$escapeAndQuoteLabels(label)).join(','))})` : '';
    const reporterJQL = reporterIds.length > 0 ? `reporter IN (${encodeURIComponent(reporterIds.join(','))})` : '';
    const updateDateJQL = appliedDateFilterValue !== null ? `updated >= "${appliedDateFilterValue.from}" AND updated <= "${appliedDateFilterValue.to}"` : '';
    const binaryStatusCategoryJQL = binaryStatusCategoryValues?.length === 1 ? `statusCategory IN (${encodeURIComponent($0622859967535f1a$var$getStatusesByStatusCategory(binaryStatusCategoryValues))})` : '';
    return [
        textJQL,
        projectJQL,
        assigneeJQL,
        reporterJQL,
        binaryStatusCategoryJQL,
        issueLabelsJQL,
        updateDateJQL
    ].filter(Boolean).join(' AND ');
};
const $0622859967535f1a$var$getStatusesByStatusCategory = (values)=>{
    if (!!values.find((v)=>v === 'open')) return '"undefined", "In Progress", "To Do"';
    if (!!values.find((v)=>v === 'done')) return '"Done"';
    return '';
};
const $0622859967535f1a$export$f63780fc2b3633e = (filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled = false)=>{
    const buildJiraAdvancedSearchPath = (0, $5uXOq.useCallback)((query)=>{
        const trimmedQuery = query.trim();
        const projectIds = filterValueGetters.projects();
        const accountIds = filterValueGetters.assignees();
        const reporterIds = filterValueGetters.reportedBy();
        const binaryStatusCategories = filterValueGetters.statuses();
        const issueLabels = filterValueGetters.issueLabels();
        // If there is a filter applied, and either a query is provided or isPreQueryFiltersEnabled is true, then we build the JQL
        if ((projectIds.length !== 0 || accountIds.length !== 0 || reporterIds.length !== 0 || binaryStatusCategories.length === 1 || issueLabels.length !== 0 || appliedDateFilterValue !== null) && (trimmedQuery || isPreQueryFiltersEnabled)) return $0622859967535f1a$var$buildJQLAdvancedIssueUrl($0622859967535f1a$var$buildJqlQuery(trimmedQuery, projectIds, accountIds, reporterIds, binaryStatusCategories, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled));
        // Otherwise we determine next action based on whether a query is provided or not
        if (!trimmedQuery) // If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
        return query === '' ? (0, $9Lv6B.ISSUE_NAVIGATOR_URL) : $0622859967535f1a$var$buildSmartQueryAdvancedSearchUrl(query);
        return $0622859967535f1a$var$buildJiraSearchUrl(trimmedQuery);
    }, [
        filterValueGetters,
        appliedDateFilterValue,
        isPreQueryFiltersEnabled,
        isSearchWithTextFieldInAllIssuesLinkEnabled
    ]);
    const useFiltersAdvancedSearchUrlFactory = (0, $5uXOq.useCallback)((query, siteUrl)=>`${siteUrl ?? ''}${buildJiraAdvancedSearchPath(query)}`, [
        buildJiraAdvancedSearchPath
    ]);
    return {
        getFiltersAdvancedSearchUrl: useFiltersAdvancedSearchUrlFactory
    };
};

});

parcelRegister("5fXfn", function(module, exports) {

$parcel$export(module.exports, "JiraAdvancedSearch", () => $67511804354a3ced$export$f8ed21c35936f5aa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gsomE = parcelRequire("gsomE");

var $3FqY6 = parcelRequire("3FqY6");

var $k4hbD = parcelRequire("k4hbD");

var $koVbs = parcelRequire("koVbs");

var $8U8gz = parcelRequire("8U8gz");
const $67511804354a3ced$export$f5d288a16f3b101c = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8U8gz.GetDefaultFooter), {
            returnKeyIconComponent: props.returnKeyIconComponent,
            linkComponent: props.linkComponent,
            productState: props.productState,
            searchFooterLabel: formatMessage((0, $VSDnB.fg)('jira-issue-terminology-refresh-m3') ? (0, $k4hbD.messages).jira_view_all_issues_newIssueTermRefresh : (0, $k4hbD.messages).jira_view_all_issues_new)
        })
    });
};
const $67511804354a3ced$export$f8ed21c35936f5aa = (0, $gsomE.withAnalytics)({
    advancedSearchSelected: (0, $3FqY6.onAdvancedSearchSelected)
})($67511804354a3ced$export$f5d288a16f3b101c);
var $67511804354a3ced$export$2e2bcd8739ae039 = $67511804354a3ced$export$f8ed21c35936f5aa;

});

parcelRegister("ha1Zp", function(module, exports) {

$parcel$export(module.exports, "defaultPermissionsSupplier", () => $34f45a70c8cf1c6d$export$79b79eb7219cb5fd);

var $4biU5 = parcelRequire("4biU5");
const $34f45a70c8cf1c6d$export$79b79eb7219cb5fd = ()=>{
    const response = Object.values((0, $4biU5.Scope));
    return Promise.resolve(response);
};

});

parcelRegister("icutB", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ed6f1424c61374$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8oG5R = parcelRequire("8oG5R");

var $3FqY6 = parcelRequire("3FqY6");

var $k4hbD = parcelRequire("k4hbD");

var $2dI5H = parcelRequire("2dI5H");

var $4dZPc = parcelRequire("4dZPc");
const $68ed6f1424c61374$export$4c85ccfa2dce935c = (query, features)=>{
    let allLinks = {
        board: {
            href: `/secure/ManageRapidViews.jspa?contains=${query}`,
            message: (0, $k4hbD.messages).jira_advanced_search_boards,
            actionSubjectId: (0, $3FqY6.AdvancedSearchLinkSubjectId).JIRA_BOARDS
        },
        project: {
            href: `/projects?contains=${query}`,
            message: (0, $k4hbD.messages).jira_advanced_search_projects,
            actionSubjectId: (0, $3FqY6.AdvancedSearchLinkSubjectId).JIRA_PROJECTS
        },
        filters: {
            href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
            message: (0, $k4hbD.messages).jira_advanced_search_filters,
            actionSubjectId: (0, $3FqY6.AdvancedSearchLinkSubjectId).JIRA_FILTERS
        },
        plans: {
            href: `/jira/plans`,
            message: (0, $k4hbD.messages).jira_advanced_search_plans,
            actionSubjectId: (0, $3FqY6.AdvancedSearchLinkSubjectId).JIRA_PLANS
        },
        people: {
            href: `/jira/people/search?q=${query}`,
            message: (0, $k4hbD.messages).jira_advanced_search_people,
            actionSubjectId: (0, $3FqY6.AdvancedSearchLinkSubjectId).JIRA_PEOPLE
        }
    };
    // Remove access to plans if the user does not have Advanced Roadmaps access
    if (!features?.hasAdvancedRoadmapsAccess) delete allLinks.plans;
    // Remove access to boards if the user does not have software access
    if (!features?.hasAdvancedRoadmapsAccess && !features?.hasSoftwareAccess) delete allLinks.board;
    return allLinks;
};
const $68ed6f1424c61374$export$b16edfe49ade2612 = ({ advancedSearchSelected: advancedSearchSelected, features: features, linkComponent: linkComponent })=>{
    const { query: query, isLoading: isLoading } = (0, $2dI5H.useQuery)();
    const onClickAndFireEvent = (e, actionSubjectId)=>{
        e.preventDefault();
        advancedSearchSelected({
            actionSubjectId: actionSubjectId,
            trigger: (0, $8oG5R.getTrigger)(e),
            isLoading: isLoading,
            newTab: (0, $8oG5R.isNewTab)(e)
        });
    };
    const searchConfiguration = $68ed6f1424c61374$export$4c85ccfa2dce935c(query, features);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4dZPc.AdvancedSearchContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
            as: "ul",
            xcss: $68ed6f1424c61374$var$advancedSearchListStyles,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4dZPc.LabelContainer), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $k4hbD.messages).jira_advanced_search_label
                    })
                }),
                Object.keys(searchConfiguration).map((key)=>{
                    const { href: href, message: message, actionSubjectId: actionSubjectId } = searchConfiguration[key];
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        as: "li",
                        xcss: $68ed6f1424c61374$var$advancedSearchListItemStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            onClick: (e)=>onClickAndFireEvent(e, actionSubjectId),
                            role: "none",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4dZPc.StyledLink), {
                                linkComponent: linkComponent,
                                href: href,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...message
                                })
                            }, `search_link_${key}`)
                        })
                    });
                })
            ]
        })
    });
};
const $68ed6f1424c61374$var$advancedSearchListStyles = (0, $8CUq3.xcss)({
    padding: '0',
    margin: '0',
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'row'
});
const $68ed6f1424c61374$var$advancedSearchListItemStyles = (0, $8CUq3.xcss)({
    margin: '0',
    padding: '0'
});
var $68ed6f1424c61374$export$2e2bcd8739ae039 = (0, $8RXs9.default)($68ed6f1424c61374$export$b16edfe49ade2612);

});
parcelRegister("4dZPc", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchContainer", () => $ff863c289484f355$export$cb4aeb4aba07ad10);
$parcel$export(module.exports, "LabelContainer", () => $ff863c289484f355$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "StyledLink", () => $ff863c289484f355$export$9048d548939551ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $kCMvS = parcelRequire("kCMvS");

var $bWGt6 = parcelRequire("bWGt6");
function $ff863c289484f355$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ff863c289484f355$export$cb4aeb4aba07ad10 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eq9f4ne2"
})({
    name: "1es2nqu",
    styles: "padding:var(--ds-space-200, 16px)"
});
const $ff863c289484f355$export$f5ae33f1b01a6402 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "eq9f4ne1"
})({
    marginRight: "var(--ds-space-100, 8px)",
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
    '&:hover, &:focus': {
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':visited': {
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
    }
});
const $ff863c289484f355$export$9048d548939551ee = /*#__PURE__*/ (0, $bWGt6.default)((0, $kCMvS.Link), {
    target: "eq9f4ne0"
})({
    WebkitBoxAlign: 'baseline',
    alignItems: 'baseline',
    boxSizing: 'border-box',
    display: 'inline-flex',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    textAlign: 'center',
    whiteSpace: 'nowrap',
    borderRadius: '3px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-150, 8px)"}`,
    marginRight: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    '&:visited, &:focus-visible, &:focus': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    }
});

});


parcelRegister("5hwDL", function(module, exports) {

$parcel$export(module.exports, "useJiraDateFilter", () => $cd3eda81797e2df9$export$ab45d91883e25704);

var $5uXOq = parcelRequire("5uXOq");

var $9Lv6B = parcelRequire("9Lv6B");

var $gMpaQ = parcelRequire("gMpaQ");

var $bONub = parcelRequire("bONub");
var $3RKSV = parcelRequire("3RKSV");

var $4Pado = parcelRequire("4Pado");

var $k4hbD = parcelRequire("k4hbD");

var $koVbs = parcelRequire("koVbs");
// The toOffset default is -1 because the 'to' date is not inclusive,
//  so we set it to the tomorrow's date to include results from today
const $cd3eda81797e2df9$var$getDateRange = (fromOffset, toOffset = -1)=>{
    const from = new Date();
    const to = new Date();
    from.setDate(from.getDate() - fromOffset);
    to.setDate(to.getDate() - toOffset);
    return {
        from: from.toISOString().split('T')[0],
        to: to.toISOString().split('T')[0]
    };
};
const $cd3eda81797e2df9$export$ab45d91883e25704 = ({ isDateFromFilterEnabled: isDateFromFilterEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dateFilterOptionsAndValues = (0, $5uXOq.useMemo)(()=>{
        return !isDateFromFilterEnabled ? null : {
            [(0, $bONub.LastModifiedValues).DEFAULT]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).DEFAULT,
                    label: formatMessage((0, $k4hbD.messages).date_filter_any_time_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: true,
                    isVisible: true
                },
                dateRange: {
                    from: '',
                    to: ''
                }
            },
            [(0, $bONub.LastModifiedValues).TODAY]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).TODAY,
                    label: formatMessage((0, $4Pado.messages).date_filter_today_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $cd3eda81797e2df9$var$getDateRange(0)
            },
            [(0, $bONub.LastModifiedValues).YESTERDAY]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).YESTERDAY,
                    label: formatMessage((0, $4Pado.messages).date_filter_yesterday_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $cd3eda81797e2df9$var$getDateRange(1, 0)
            },
            [(0, $bONub.LastModifiedValues).PAST_SEVEN_DAYS]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).PAST_SEVEN_DAYS,
                    label: formatMessage((0, $4Pado.messages).date_filter_past_7_days_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $cd3eda81797e2df9$var$getDateRange(7)
            },
            [(0, $bONub.LastModifiedValues).PAST_THIRTY_DAYS]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).PAST_THIRTY_DAYS,
                    label: formatMessage((0, $4Pado.messages).date_filter_past_30_days_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $cd3eda81797e2df9$var$getDateRange(30)
            },
            [(0, $bONub.LastModifiedValues).PAST_YEAR]: {
                filter: {
                    id: (0, $bONub.LastModifiedValues).PAST_YEAR,
                    label: formatMessage((0, $4Pado.messages).date_filter_past_year_label),
                    filterSource: (0, $gMpaQ.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $cd3eda81797e2df9$var$getDateRange(365)
            }
        };
    }, [
        isDateFromFilterEnabled,
        formatMessage
    ]);
    const dateFilterOptions = (0, $5uXOq.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
        dateFilterOptionsAndValues
    ]);
    const dateFilterStore = (0, $3RKSV.useFilterStore)(dateFilterOptions, (0, $9Lv6B.JIRA_PRODUCT_ID), (0, $9Lv6B.JiraFilters).Date);
    const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, $bONub.DEFAULT_OPTION))?.id;
    const appliedDateFilterValue = appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? dateFilterOptionsAndValues[appliedDateFilter].dateRange : null;
    const getLastModifiedValue = (0, $5uXOq.useCallback)(()=>{
        return appliedDateFilterValue ? {
            '@type': (0, $9Lv6B.JiraFilters).Date,
            from: appliedDateFilterValue.from,
            to: appliedDateFilterValue.to
        } : null;
    }, [
        appliedDateFilterValue
    ]);
    const jiraTabDateFilterDefinition = (0, $5uXOq.useMemo)(()=>{
        return isDateFromFilterEnabled ? [
            {
                ['@type']: (0, $9Lv6B.JiraFilters).Date,
                uiVariant: (0, $bONub.FilterUIVariant).STATIC_SELECT,
                fieldName: 'from',
                store: dateFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, $k4hbD.messages).date_filter_filters_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: ()=>getLastModifiedValue()
            }
        ] : [];
    }, [
        isDateFromFilterEnabled,
        dateFilterStore,
        formatMessage,
        getLastModifiedValue
    ]);
    return {
        appliedDateFilterValue: appliedDateFilterValue,
        jiraTabDateFilterDefinition: jiraTabDateFilterDefinition,
        dateFilterOptionsAndValues: dateFilterOptionsAndValues
    };
};

});


parcelRegister("9RlGt", function(module, exports) {

$parcel$export(module.exports, "FilterContextProvider", () => $82a54352c7d6692f$export$eb71bf38f5ae0f9c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $tUDIN = parcelRequire("tUDIN");

var $5uOu6 = parcelRequire("5uOu6");

var $gMpaQ = parcelRequire("gMpaQ");

var $k4hbD = parcelRequire("k4hbD");

var $lL734 = parcelRequire("lL734");
const $82a54352c7d6692f$var$BROCCOLI_30_EXPERIMENT = {
    experimentId: 'broccoli-30-frontend',
    days: 30
};
const $82a54352c7d6692f$var$BROCCOLI_60_EXPERIMENT = {
    experimentId: 'broccoli-60-frontend',
    days: 60
};
const $82a54352c7d6692f$var$BROCCOLI_90_EXPERIMENT = {
    experimentId: 'broccoli-90-frontend',
    days: 90
};
const $82a54352c7d6692f$export$40e7ffc2d13a061c = [
    $82a54352c7d6692f$var$BROCCOLI_30_EXPERIMENT,
    $82a54352c7d6692f$var$BROCCOLI_60_EXPERIMENT,
    $82a54352c7d6692f$var$BROCCOLI_90_EXPERIMENT
];
class $82a54352c7d6692f$export$bea22cefe0b3447c {
    static{
        this.OPEN = new $82a54352c7d6692f$export$bea22cefe0b3447c('open', '"undefined", "In Progress", "To Do"');
    }
    static{
        this.DONE = new $82a54352c7d6692f$export$bea22cefe0b3447c('done', '"Done"');
    }
    constructor(id, jqlValue){
        this.id = id;
        this.jqlValue = jqlValue;
    }
}
const $82a54352c7d6692f$export$b5d1c2ef6aead4e6 = [
    {
        title: (0, $k4hbD.messages).binary_status_category_filter_option_open,
        id: $82a54352c7d6692f$export$bea22cefe0b3447c.OPEN.id,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $gMpaQ.FilterOptionSource).STATIC
    },
    {
        title: (0, $k4hbD.messages).binary_status_category_filter_option_done,
        id: $82a54352c7d6692f$export$bea22cefe0b3447c.DONE.id,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $gMpaQ.FilterOptionSource).STATIC
    }
];
const $82a54352c7d6692f$export$973ca22476b0e05f = (defaultFilters = [])=>{
    const { filters: filters, dispatch: dispatch } = (0, $5uOu6.useFilter)(defaultFilters);
    const addFilters = (0, $5uXOq.useCallback)((newFilters)=>dispatch((0, $5uOu6.addFilters)(newFilters, (a, b)=>{
            if (a.filterSource === (0, $gMpaQ.FilterOptionSource).CURRENT_USER && b.filterSource !== (0, $gMpaQ.FilterOptionSource).CURRENT_USER) return -1;
            if (a.filterSource !== (0, $gMpaQ.FilterOptionSource).CURRENT_USER && b.filterSource === (0, $gMpaQ.FilterOptionSource).CURRENT_USER) return 1;
            return 0;
        })), [
        dispatch
    ]);
    const updateFilter = (0, $5uXOq.useCallback)((id, isChecked)=>dispatch((0, $5uOu6.updateFilterState)(id, isChecked, true)), [
        dispatch
    ]);
    const clearFilter = (0, $5uXOq.useCallback)(()=>{
        filters.forEach((f)=>dispatch((0, $5uOu6.updateFilterState)(f.id, false)));
    }, [
        filters,
        dispatch
    ]);
    const resetFilter = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $5uOu6.replaceAllFilters)(defaultFilters));
    }, [
        defaultFilters,
        dispatch
    ]);
    return {
        availableFilters: filters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch
    };
};
const $82a54352c7d6692f$var$DEFAULT_FILTER_STATE = {
    availableFilters: [],
    addFilters: ()=>{},
    updateFilter: ()=>{},
    clearFilter: ()=>{},
    reset: ()=>{},
    dispatch: ()=>{}
};
const $82a54352c7d6692f$var$FilterContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    projectFilters: $82a54352c7d6692f$var$DEFAULT_FILTER_STATE,
    assigneeFilters: $82a54352c7d6692f$var$DEFAULT_FILTER_STATE,
    siteFilters: $82a54352c7d6692f$var$DEFAULT_FILTER_STATE,
    binaryStatusCategoryFilters: $82a54352c7d6692f$var$DEFAULT_FILTER_STATE,
    dateFilterFrom: {
        value: '',
        setValue: (_value)=>null
    },
    dateFilterTo: {
        value: '',
        setValue: (_value)=>null
    }
});
function $82a54352c7d6692f$export$5e1edcb3c154ab79(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $82a54352c7d6692f$var$transformDateFiltersForAnalytics = (dateFilterFrom)=>{
    const availiableFilters = $82a54352c7d6692f$export$40e7ffc2d13a061c.map((experiment)=>experiment.days).map((days)=>[
            days,
            (0, $lL734.getDateXDaysBack)(days)
        ]);
    const appliedFilter = availiableFilters.filter(([_, date])=>date === dateFilterFrom).map(([days, _])=>({
            id: days
        }));
    return {
        applied: appliedFilter.map(({ id: id })=>({
                id: id,
                source: (0, $gMpaQ.FilterOptionSource).STATIC
            })),
        recommendedIds: availiableFilters.map(([days, _])=>({
                id: days,
                source: (0, $gMpaQ.FilterOptionSource).STATIC
            }))
    };
};
const $82a54352c7d6692f$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultProjectFilters: defaultProjectFilters, defaultAssigneeFilters: defaultAssigneeFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
    const previousEnabledState = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(isEnabled);
    const [dateFilterFrom, setDateFilterFrom] = (0, $5uXOq.useState)('');
    const [dateFilterTo, setDateFilterTo] = (0, $5uXOq.useState)('');
    const projectFilterStore = $82a54352c7d6692f$export$973ca22476b0e05f(defaultProjectFilters);
    const assigneeFilterStore = $82a54352c7d6692f$export$973ca22476b0e05f(defaultAssigneeFilters);
    const siteFilterStore = $82a54352c7d6692f$export$973ca22476b0e05f(defaultSiteFilters);
    const binaryStatusCategoryFilterStore = $82a54352c7d6692f$export$973ca22476b0e05f($82a54352c7d6692f$export$b5d1c2ef6aead4e6);
    const filtersAnalyticsContext = projectFilterStore.availableFilters.length === 0 && assigneeFilterStore.availableFilters.length === 0 ? {} : {
        projects: $82a54352c7d6692f$export$5e1edcb3c154ab79(projectFilterStore.availableFilters),
        assignees: $82a54352c7d6692f$export$5e1edcb3c154ab79(assigneeFilterStore.availableFilters),
        binaryStatusCategories: $82a54352c7d6692f$export$5e1edcb3c154ab79(binaryStatusCategoryFilterStore.availableFilters),
        dateFrom: $82a54352c7d6692f$var$transformDateFiltersForAnalytics(dateFilterFrom)
    };
    // We reset the state when the component becomes disabled
    if (previousEnabledState.current && !isEnabled) {
        projectFilterStore.reset();
        assigneeFilterStore.reset();
        siteFilterStore.reset();
        binaryStatusCategoryFilterStore.clearFilter();
        setDateFilterFrom('');
        setDateFilterTo('');
    }
    previousEnabledState.current = isEnabled;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($82a54352c7d6692f$var$FilterContext.Provider, {
        value: {
            projectFilters: projectFilterStore,
            assigneeFilters: assigneeFilterStore,
            siteFilters: siteFilterStore,
            binaryStatusCategoryFilters: binaryStatusCategoryFilterStore,
            dateFilterFrom: {
                value: dateFilterFrom,
                setValue: setDateFilterFrom
            },
            dateFilterTo: {
                value: dateFilterTo,
                setValue: setDateFilterTo
            }
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext,
            children: children
        })
    });
};
const $82a54352c7d6692f$export$396ef541d9951d45 = ()=>{
    const filterContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($82a54352c7d6692f$var$FilterContext);
    return filterContext;
};

});
parcelRegister("lL734", function(module, exports) {

$parcel$export(module.exports, "getDateXDaysBack", () => $e0620f149fbe48f1$export$e4a4d5c1140c233a);
const $e0620f149fbe48f1$export$edfa1467d84b6872 = (item, query)=>{
    const lowerQuery = query.toLowerCase().trim();
    return item.name.toLowerCase().includes(lowerQuery) || item.attributes.key.toLowerCase().includes(lowerQuery);
};
const $e0620f149fbe48f1$export$e4a4d5c1140c233a = (daysBefore)=>{
    const date = new Date();
    date.setDate(date.getDate() - daysBefore);
    return date.toISOString().split('T')[0];
};

});


parcelRegister("6P5ov", function(module, exports) {

$parcel$export(module.exports, "MultiProductDialog", () => $576ecf3485148ab8$export$c952be4395be8d29);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7J7Sh = parcelRequire("7J7Sh");
var $i8oou = parcelRequire("i8oou");
var $5rLBT = parcelRequire("5rLBT");
var $2k6eV = parcelRequire("2k6eV");

var $lvCts = parcelRequire("lvCts");

var $3wz5U = parcelRequire("3wz5U");

var $9Mho6 = parcelRequire("9Mho6");

var $2dI5H = parcelRequire("2dI5H");

var $7VoGI = parcelRequire("7VoGI");

var $7Givh = parcelRequire("7Givh");

var $6ZsPS = parcelRequire("6ZsPS");

var $i5cPn = parcelRequire("i5cPn");

var $dnjeJ = parcelRequire("dnjeJ");

var $gNiXZ = parcelRequire("gNiXZ");

var $2DWAC = parcelRequire("2DWAC");

var $5ZS4j = parcelRequire("5ZS4j");
const $576ecf3485148ab8$var$ConditionalWrapper = ({ wrapper: wrapper, children: children })=>wrapper?.({
        children: children
    }) ?? children;

const $576ecf3485148ab8$var$SearchAIDialogComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("iSMg5")).then(({ SearchAIDialog: SearchAIDialog })=>({
            default: SearchAIDialog
        })));
const $576ecf3485148ab8$var$SearchAIAnswerDialog = ({ aiSearchConfig: aiSearchConfig, onClose: onClose, edition: edition, closeParentDialog: closeParentDialog })=>{
    const { query: query, setQueryOnly: setQueryOnly } = (0, $2dI5H.useQuery)();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId || '';
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const { user: user } = (0, $7VoGI.useUserContext)();
    const { resetSearchSession: resetSearchSession } = (0, $2k6eV.useSessionUserInput)();
    const { allowChangeExpand: allowChangeExpand } = (0, $i5cPn.useDialogExpansionContext)();
    const filters = (0, $7Givh.useAppliedFilters)('confluence');
    const onNavigate = (0, $5uXOq.useCallback)(()=>{
        resetSearchSession();
        allowChangeExpand(true);
    }, [
        resetSearchSession,
        allowChangeExpand
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($576ecf3485148ab8$var$SearchAIDialogComponent, {
            query: query,
            setQuery: setQueryOnly,
            cloudId: cloudId,
            getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
            edition: edition,
            followUpsEnabled: aiSearchConfig.followUpsEnabled,
            onNavigate: onNavigate,
            onClose: onClose,
            searchSessionId: searchSessionId,
            userDetails: user,
            source: "searchDialog",
            parsedFilters: filters,
            closeParentDialog: closeParentDialog,
            sourceProduct: "confluence",
            userGeneratedAI: true
        })
    });
};
const $576ecf3485148ab8$export$c952be4395be8d29 = ({ children: children, theme: theme, isExpanded: isExpanded, setIsExpanded: setIsExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, dialogFeatures: dialogFeatures, user: user, orgId: orgId, forwardRef: forwardRef, onNavigateGeneric: onNavigateGeneric, keepExpandedInTab: keepExpandedInTab, pageLoadMetrics: pageLoadMetrics, DialogWrapper: DialogWrapper, OnboardingRenderer: OnboardingRenderer, experience: experience, aiSearchConfig: aiSearchConfig, edition: edition, primaryProduct: primaryProduct, shouldFillContainer: shouldFillContainer, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
    (0, $dnjeJ.useUFOComponentExperience)((0, $9Mho6.initialisationExperience));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8oou.MetaContextProvider), {
        theme: theme,
        experience: experience,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        abTestCloudId: abTestCloudId,
        aggregatorUrl: aggregatorUrl,
        clientProviderFeatures: dialogFeatures,
        user: user,
        orgId: orgId,
        dialogFeatures: dialogFeatures,
        primaryProduct: primaryProduct,
        forwardRef: forwardRef,
        isRovoEnabled: isRovoEnabled,
        queryParams: queryParams,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7J7Sh.KeyboardWrapper), {
            shouldFillContainer: shouldFillContainer,
            forwardRef: forwardRef,
            keepExpandedInTab: keepExpandedInTab,
            children: ({ ref: ref, onRetry: onRetry })=>{
                return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3wz5U.ActiveProductSearchInput), {
                            shouldFillContainer: shouldFillContainer,
                            forwardRef: ref,
                            onNavigateGeneric: onNavigateGeneric,
                            features: dialogFeatures,
                            pageLoadMetrics: pageLoadMetrics
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)($576ecf3485148ab8$var$ConditionalWrapper, {
                            wrapper: DialogWrapper,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gNiXZ.ActiveProductProvider), {
                                    children: ({ activeProduct: activeProduct, showSearchAIDialog: showSearchAIDialog, onCloseAIDialog: onCloseAIDialog, defaultAIConfig: defaultAIConfig })=>{
                                        const finalAIConfig = dialogFeatures?.isGriffinNavEnabled ? aiSearchConfig || defaultAIConfig : aiSearchConfig;
                                        return showSearchAIDialog && finalAIConfig && isExpanded ? /*#__PURE__*/ (0, $2OMIu.jsx)($576ecf3485148ab8$var$SearchAIAnswerDialog, {
                                            aiSearchConfig: finalAIConfig,
                                            onClose: onCloseAIDialog,
                                            edition: edition,
                                            closeParentDialog: ()=>setIsExpanded(false)
                                        }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5ZS4j.ProductSearchDialogWrapper), {
                                            shouldFillContainer: shouldFillContainer,
                                            children: [
                                                OnboardingRenderer && isExpanded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2DWAC.DisableXPSAB), {
                                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(OnboardingRenderer, {
                                                        activeProductId: activeProduct?.id
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rLBT.ProductTabs), {}),
                                                children({
                                                    ref: ref,
                                                    onRetry: onRetry
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
};

});
parcelRegister("7J7Sh", function(module, exports) {

$parcel$export(module.exports, "KeyboardWrapper", () => $531fcb313c93fb66$export$8ee2389f89cfdd2f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7yucS = parcelRequire("7yucS");
var $fYvdU = parcelRequire("fYvdU");
var $9enEu = parcelRequire("9enEu");

var $i5cPn = parcelRequire("i5cPn");

var $aR1b2 = parcelRequire("aR1b2");

var $hNXQY = parcelRequire("hNXQY");
class $531fcb313c93fb66$export$bb50437fb01e8bb5 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isExpanded: isExpanded, isQuickFind: isQuickFind, shouldFillContainer: shouldFillContainer, children: children } = this.props;
        const SearchAnchorComponent = isQuickFind ? (0, $7yucS.EnlargedSearchAnchor) : (0, $9enEu.SearchAnchor);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SearchAnchorComponent, {
            onBlur: this.onBlurHandler,
            onFocus: this.onFocusHandler,
            onKeyDown: this.handleKeyDown,
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fYvdU.KeyboardHighlightProvider), {
                listenerNode: this.state.ref,
                children: children ? children(this.setRef) : null
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            ref: null
        }, /**
	 * Hold a timeout id for the onBlur and onFocus handlers
	 */ this.timeout = undefined, this.handleKeyDown = (event)=>{
            if (event.key === 'Escape' && !event.defaultPrevented && this.props.isExpanded) {
                event.preventDefault();
                this.close();
            }
        }, this.onBlurHandler = ()=>{
            this.timeout = window.setTimeout(()=>{
                this.close();
            });
        }, this.onFocusHandler = ()=>{
            window.clearTimeout(this.timeout);
        }, this.setRef = (ref)=>{
            if (this.state.ref !== ref) this.setState({
                ref: ref
            });
        }, this.close = ()=>{
            const { ref: ref } = this.state;
            ref && ref.blur();
            this.props.onClose();
        };
    }
}
const $531fcb313c93fb66$export$8ee2389f89cfdd2f = ({ children: children, keepExpandedInTab: keepExpandedInTab = false, forwardRef: forwardRef, shouldFillContainer: shouldFillContainer, ...rest })=>{
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded, allowChangeExpand: allowChangeExpand } = (0, $i5cPn.useDialogExpansionContext)();
    const inputRef = (0, $5uXOq.useRef)(null);
    const mergedForwardref = (0, $aR1b2.mergeRefCallback)(inputRef, forwardRef);
    const isQuickFind = (0, $hNXQY.useFeaturesContext)().quickFind?.enabled;
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    const onTabChange = (0, $5uXOq.useCallback)(()=>{
        if (document.hidden) allowChangeExpand(false);
        else {
            if (isExpanded) inputRef?.current?.focus?.();
            allowChangeExpand(true);
        }
    }, [
        allowChangeExpand,
        isExpanded
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (keepExpandedInTab) {
            document.addEventListener('visibilitychange', onTabChange);
            return ()=>{
                document.removeEventListener('visibilitychange', onTabChange);
            };
        }
    }, [
        onTabChange,
        keepExpandedInTab
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($531fcb313c93fb66$export$bb50437fb01e8bb5, {
        ...rest,
        shouldFillContainer: shouldFillContainer,
        onClose: onClose,
        isExpanded: isExpanded,
        isQuickFind: isQuickFind,
        children: (setRef)=>{
            const ref = (0, $aR1b2.mergeRefCallback)(setRef, mergedForwardref);
            const onRetry = ()=>{
                inputRef?.current?.focus?.();
            };
            return children({
                ref: ref,
                onRetry: onRetry
            });
        }
    });
};

});
parcelRegister("7yucS", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchAnchor", () => $740d2c18f0dc3fe4$export$774d556eae0f6945);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hLeR9 = parcelRequire("hLeR9");
const $740d2c18f0dc3fe4$export$774d556eae0f6945 = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.EnlargedSearchAnchorWrapper), {
        isExpanded: isExpanded,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.AbsoluteContainer), {
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });

});

parcelRegister("9enEu", function(module, exports) {

$parcel$export(module.exports, "SearchAnchor", () => $ca26fcb83502085a$export$bc951697710bb35a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hLeR9 = parcelRequire("hLeR9");
const $ca26fcb83502085a$export$bc951697710bb35a = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.AbsoluteContainer), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });

});

parcelRegister("aR1b2", function(module, exports) {

$parcel$export(module.exports, "mergeRefCallback", () => $57727f9aa893daf5$export$bf39ce724f6cc9e5);
/**
 * Helper util class to merge a forward and callback ref.
 * The implementation to do this is not clean and so it's isolated here until React has a better solution.
 */ const $57727f9aa893daf5$var$callRef = (callbackOrForwardRef, ref)=>{
    if (!callbackOrForwardRef) return;
    if (typeof callbackOrForwardRef === 'function') callbackOrForwardRef(ref);
    else if (typeof callbackOrForwardRef === 'object' && Object.prototype.hasOwnProperty.call(callbackOrForwardRef, 'current')) // `#current` is technically read only, but we will force an assignment here.
    /* eslint-disable-next-line no-param-reassign */ callbackOrForwardRef.current = ref;
    else // This should never happen
    throw new Error('unsupported ref format, currently only callback and forward refs are supported');
};
const $57727f9aa893daf5$export$bf39ce724f6cc9e5 = (...refs)=>{
    return (ref)=>{
        refs.forEach((r)=>$57727f9aa893daf5$var$callRef(r, ref));
    };
};

});


parcelRegister("i8oou", function(module, exports) {

$parcel$export(module.exports, "MetaContextProvider", () => $abdb99ba2b051c55$export$3d88e5d350ac07d9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2AbEM = parcelRequire("2AbEM");

var $i5cPn = parcelRequire("i5cPn");

var $2dI5H = parcelRequire("2dI5H");

var $kv2Va = parcelRequire("kv2Va");

var $aySTE = parcelRequire("aySTE");

var $4k2KW = parcelRequire("4k2KW");

var $6ZsPS = parcelRequire("6ZsPS");

var $lvCts = parcelRequire("lvCts");

var $4tuQr = parcelRequire("4tuQr");

var $jQ6em = parcelRequire("jQ6em");

var $ebv5l = parcelRequire("ebv5l");

var $7VoGI = parcelRequire("7VoGI");

var $eARpK = parcelRequire("eARpK");

var $3UF9C = parcelRequire("3UF9C");

var $hI9zY = parcelRequire("hI9zY");

var $ihzp7 = parcelRequire("ihzp7");

var $hNXQY = parcelRequire("hNXQY");

var $8zfVb = parcelRequire("8zfVb");

var $3bJE0 = parcelRequire("3bJE0");

var $lTDGC = parcelRequire("lTDGC");

var $4QKbG = parcelRequire("4QKbG");
const $abdb99ba2b051c55$export$3d88e5d350ac07d9 = ({ children: children, theme: theme, setIsExpanded: setIsExpanded, isExpanded: isExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, experience: experience, clientProviderFeatures: clientProviderFeatures, user: user, orgId: orgId, dialogFeatures: dialogFeatures, primaryProduct: primaryProduct, forwardRef: forwardRef, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4QKbG.QueryParamsProvider), {
        queryParams: queryParams,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hNXQY.FeaturesProvider), {
            dialogFeatures: dialogFeatures,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VoGI.UserProvider), {
                user: user,
                orgId: orgId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lTDGC.RovoContextProvider), {
                    isEnabled: isRovoEnabled,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aySTE.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zfVb.QuickFindAnalyticContext), {
                            isQuickFind: dialogFeatures?.quickFind?.enabled,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4k2KW.BuildVersionAnalyticContext), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2AbEM.ThemeProvider), {
                                    partialSearchCSS: theme,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5cPn.DialogExpansionContextProvider), {
                                        isExpanded: isExpanded,
                                        setIsExpanded: setIsExpanded,
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kv2Va.ProductRouter), {
                                            primaryProduct: primaryProduct,
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lvCts.AggregatorClientContextProvider), {
                                                abTestCloudId: abTestCloudId,
                                                aggregatorUrl: aggregatorUrl,
                                                features: clientProviderFeatures,
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tuQr.ABTestContextProvider), {
                                                    experience: experience,
                                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6ZsPS.SearchSessionProvider), {
                                                        sessionKey: `ssid_provider_${isExpanded}`,
                                                        children: [
                                                            isExpanded ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jQ6em.default), {}) : null,
                                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2dI5H.QueryContextProvider), {
                                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3UF9C.FilterContextHOC), {
                                                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hI9zY.AutocorrectionProvider), {
                                                                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3bJE0.InputContext), {
                                                                            forwardRef: forwardRef,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eARpK.AsyncLoadOnQuery), {}),
                                                                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ihzp7.DialogShownHandler), {
                                                                                    isExpanded: isExpanded
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ebv5l.DialogDismissedHandler), {
                                                                                    isExpanded: isExpanded
                                                                                }),
                                                                                children
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("aySTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc9fe0da8e58978$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $9hHHT = parcelRequire("9hHHT");

var $jY7fH = parcelRequire("jY7fH");
class $ecc9fe0da8e58978$var$MessagesIntlProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.fetchLocale = ()=>{
            (0, $9hHHT.getMessagesForLocale)(this.props.intl.locale).then((messages)=>this.setState({
                    messages: messages
                }));
        };
        this.state = {
            messages: (0, $9hHHT.ENGLISH_LOCALES).indexOf(props.intl.locale) !== -1 ? (0, $jY7fH.default) : undefined
        };
        this.fetchLocale();
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            messages: this.state.messages,
            locale: this.props.intl.locale,
            children: children
        });
    }
}
const $ecc9fe0da8e58978$var$MessagesIntlProviderWithIntl = (0, $8RXs9.default)($ecc9fe0da8e58978$var$MessagesIntlProvider);
var $ecc9fe0da8e58978$export$2e2bcd8739ae039 = $ecc9fe0da8e58978$var$MessagesIntlProviderWithIntl;

});
parcelRegister("9hHHT", function(module, exports) {

$parcel$export(module.exports, "ENGLISH_LOCALES", () => $1ac9bebb062b7c13$export$507533edf8f43d4e);
$parcel$export(module.exports, "getMessagesForLocale", () => $1ac9bebb062b7c13$export$d0a3169680473b6c);

var $jY7fH = parcelRequire("jY7fH");
const $1ac9bebb062b7c13$export$507533edf8f43d4e = [
    'en',
    'en-US',
    'en-GB'
];






























async function $1ac9bebb062b7c13$var$getMessages(locale) {
    let messages;
    switch(locale){
        case 'cs':
            messages = (parcelRequire("ePAaW"));
            break;
        case 'da':
            messages = (parcelRequire("bbntL"));
            break;
        case 'de':
            messages = (parcelRequire("9DUHg"));
            break;
        case 'en':
            messages = Promise.resolve((parcelRequire("jY7fH")));
            break;
        case 'en_GB':
            messages = (parcelRequire("5iwLe"));
            break;
        case 'en_ZZ':
            messages = (parcelRequire("bBCTS"));
            break;
        case 'es':
            messages = (parcelRequire("dAZNx"));
            break;
        case 'et':
            messages = (parcelRequire("9IbRW"));
            break;
        case 'fi':
            messages = (parcelRequire("lU5y1"));
            break;
        case 'fr':
            messages = (parcelRequire("3rrBV"));
            break;
        case 'hu':
            messages = (parcelRequire("68Am3"));
            break;
        case 'is':
            messages = (parcelRequire("3Rg0H"));
            break;
        case 'it':
            messages = (parcelRequire("imnjX"));
            break;
        case 'ja':
            messages = (parcelRequire("2evHd"));
            break;
        case 'ko':
            messages = (parcelRequire("hgaVS"));
            break;
        case 'nb':
            messages = (parcelRequire("grNAz"));
            break;
        case 'nl':
            messages = (parcelRequire("42Lin"));
            break;
        case 'pl':
            messages = (parcelRequire("9UBw1"));
            break;
        case 'pt_BR':
            messages = (parcelRequire("ja43E"));
            break;
        case 'pt_PT':
            messages = (parcelRequire("bsIH3"));
            break;
        case 'ro':
            messages = (parcelRequire("fnP1u"));
            break;
        case 'ru':
            messages = (parcelRequire("hXRqF"));
            break;
        case 'sk':
            messages = (parcelRequire("6EQEt"));
            break;
        case 'sv':
            messages = (parcelRequire("lcpgs"));
            break;
        case 'th':
            messages = (parcelRequire("iLnDi"));
            break;
        case 'tr':
            messages = (parcelRequire("nFzmq"));
            break;
        case 'uk':
            messages = (parcelRequire("k3zhF"));
            break;
        case 'vi':
            messages = (parcelRequire("25q0u"));
            break;
        case 'zh':
            messages = (parcelRequire("jHws8"));
            break;
        case 'zh_TW':
            messages = (parcelRequire("g7FTT"));
            break;
        default:
            throw new Error('Unknown locale: ' + locale);
    }
    return (await messages).default;
}
const $1ac9bebb062b7c13$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        return await $1ac9bebb062b7c13$var$getMessages(locale);
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        return await $1ac9bebb062b7c13$var$getMessages(parentLocale);
    } catch (e) {
    // ignore
    }
    return 0, $jY7fH.default;
};

});
parcelRegister("jY7fH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ad43061586046ad5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $ad43061586046ad5$export$2e2bcd8739ae039 = {
    'cross_product_search_dialog.atlas.tab_label': 'Atlas',
    'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
    'cross_product_search_dialog.confluence.tab_label': 'Confluence',
    'cross_product_search_dialog.google_drive.tab_label': 'Drive',
    'cross_product_search_dialog.google_drive.unauthenticated_prompt': 'You can work on all of your Google sheets, docs, slides and more, without ever leaving Atlassian. Only you have this access.',
    'cross_product_search_dialog.jira.tab_label': 'Jira',
    'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
    'cross_product_search_dialog.recently_viewed_title': 'Recently Viewed {sectionTitle}',
    'cross_product_search_dialog.townsquare_globex_tab_label': 'Home',
    'cross_product_search_dialog.townsquare_recent_goals': 'Recent Goals',
    'cross_product_search_dialog.townsquare_recent_help_links': 'Recent Help Links',
    'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': 'Recent Learnings, Risks and Decisions',
    'cross_product_search_dialog.townsquare_recent_projects': 'Recent Projects',
    'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
    'cross_product_search_dialog.trello.tab_label': 'Trello',
    'cross_product_search_dialog.view_all_results_link': 'View all {sectionTitle}',
    'document-search-result.google-docs-label': 'Docs',
    'document-search-result.google-sheets-label': 'Sheets',
    'document-search-result.google-slides-label': 'Slides',
    'document-search-result.ms-excel-label': 'Excel',
    'document-search-result.ms-powerpoint-label': 'PowerPoint',
    'document-search-result.ms-word-label': 'Word',
    'extensible_search_dialog.advanced_search': 'Advanced search',
    'extensible_search_dialog.advanced_search_all_apps': 'Search all apps',
    'extensible_search_dialog.connect': 'Connect',
    'extensible_search_dialog.connect_to': 'Connect to',
    'extensible_search_dialog.more': '+ more',
    'global_search.jira.advanced_search_boards': 'Boards',
    'global_search.jira.advanced_search_filters': 'Filters',
    'global_search.jira.advanced_search_issues': 'Issues',
    'global_search.jira.advanced_search_issues-issue-term-refresh': 'Work items',
    'global_search.jira.advanced_search_label': 'Go to all:',
    'global_search.jira.advanced_search_people': 'People',
    'global_search.jira.advanced_search_plans': 'Plans',
    'global_search.jira.advanced_search_projects': 'Projects',
    'global_search.jira.search_placeholder': 'Search Jira',
    'global_search.jira.search_placeholder_experiment_jsw_enabled': 'Search for issues, boards, projects, and filters',
    'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh': 'Search for work items, boards, projects, and filters',
    'product_s earch_dialog.confluence.assignee_filters_find_more': 'Find an assignee',
    'product_search_dialog.atlas.search_input_expanded_placeholder': 'Search Atlas',
    'product_search_dialog.autocorrection.label': 'Did you mean',
    'product_search_dialog.bitbucket.bitbucket_advanced_search': 'Search for code in {source}',
    'product_search_dialog.bitbucket.bitbucket_recent_repositories': 'Recently updated repositories',
    'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'Repositories',
    'product_search_dialog.bitbucket.expanded.input-placeholder': 'Search Bitbucket',
    'product_search_dialog.bitbucket.repository_heading': 'Repositories',
    'product_search_dialog.common.site_filters': 'Filter by site',
    'product_search_dialog.compass.component_type.application': 'Application',
    'product_search_dialog.compass.component_type.capability': 'Capability',
    'product_search_dialog.compass.component_type.cloud_resource': 'Cloud resource',
    'product_search_dialog.compass.component_type.data_pipeline': 'Data pipeline',
    'product_search_dialog.compass.component_type.library': 'Library',
    'product_search_dialog.compass.component_type.machine_learning_model': 'Machine learning model',
    'product_search_dialog.compass.component_type.other': 'Other',
    'product_search_dialog.compass.component_type.service': 'Service',
    'product_search_dialog.compass.component_type.ui_element': 'UI element',
    'product_search_dialog.compass.component_type.website': 'Website',
    'product_search_dialog.compass.components_section_heading': 'Components',
    'product_search_dialog.compass.endpoints_section_heading': 'Endpoints',
    'product_search_dialog.compass.expanded.input-placeholder': 'Search Compass',
    'product_search_dialog.compass.people_section_heading': 'People',
    'product_search_dialog.compass.recently_viewed_components': 'Recently viewed components',
    'product_search_dialog.compass.recently_viewed_endpoints': 'Recently viewed endpoints',
    'product_search_dialog.compass.recently_viewed_teams': 'Recently viewed teams',
    'product_search_dialog.compass.tab_label': 'Compass',
    'product_search_dialog.compass.teams_section_heading': 'Teams',
    'product_search_dialog.compass.upsell_modal_cta_text': 'Get Compass free',
    'product_search_dialog.compass.upsell_modal_description': "Catalog your software architecture in one place \u2013 so the teams working on it can reduce context switching, find what they need faster, and be more productive. How\u2019s that for a developer experience?",
    'product_search_dialog.compass.upsell_modal_description.bitbucket': 'See owners, dependencies, and help resources for your repositories by linking them to a central software catalog.',
    'product_search_dialog.compass.upsell_modal_heading': 'Control your software sprawl, so developers can control their time',
    'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'Bring more context to your code',
    'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Learn more about Compass',
    'product_search_dialog.compass.upsell_modal_learn_more_link': 'Learn more',
    'product_search_dialog.compass.upsell_tab_title_lozenge': 'New',
    'product_search_dialog.compass.view_all_components_label': 'View all components',
    'product_search_dialog.compass.view_all_results_label': 'View all results',
    'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Confluence advanced search',
    'product_search_dialog.confluence.clear_filters': 'Clear filters',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.description': 'Your team is collaborating in Confluence. Organize team knowledge, capture ideas, and share requirements for your Jira projects with pages, whiteboards, and databases.',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.header': 'Your team is now using Confluence',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.join_button': 'Join your team',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.learn_more_button': 'Learn more',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.tab.more_results': 'More results',
    'product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user': 'More results',
    'product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user': 'Free access',
    'product_search_dialog.confluence.content_section_heading': 'Content',
    'product_search_dialog.confluence.contributor_filters': 'Filter by contributor',
    'product_search_dialog.confluence.contributor_filters_find_more': 'Find a contributor',
    'product_search_dialog.confluence.date_filter_title': 'Last updated',
    'product_search_dialog.confluence.date_filter_today': 'Today',
    'product_search_dialog.confluence.date_filter_yesterday': 'Yesterday',
    'product_search_dialog.confluence.date_filters_any': 'Any time',
    'product_search_dialog.confluence.date_filters_month': 'Past 30 days',
    'product_search_dialog.confluence.date_filters_week': 'Past 7 days',
    'product_search_dialog.confluence.date_filters_year': 'Past year',
    'product_search_dialog.confluence.empty_state_body_no_advanced_search': 'Try different keywords, fewer of them, or ones that are more general.',
    'product_search_dialog.confluence.empty_state_body_prequery_filters': "We can\u2019t find anything created or updated in the last 90 days with your selected filters.",
    'product_search_dialog.confluence.empty_state_body_title': "We couldn't find any matches for your search.",
    'product_search_dialog.confluence.filters_applied': 'Looks like you have some filters applied',
    'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'Pages, blogs and attachments',
    'product_search_dialog.confluence.people_section_heading': 'People',
    'product_search_dialog.confluence.search_input_expanded_placeholder': 'Search Confluence',
    'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Search or ask questions within your Confluence',
    'product_search_dialog.confluence.space_filters': 'Filter by space',
    'product_search_dialog.confluence.space_filters_find_more': 'Find a space',
    'product_search_dialog.confluence.spaces_section_heading': 'Spaces',
    'product_search_dialog.confluence.typing_state_header_text': 'Search for content in Confluence',
    'product_search_dialog.cross_product.empty.no_results_body': '<a>Search all content across your organization</a> or try a different term.',
    'product_search_dialog.cross_product.expanded.input-placeholder': 'Search All',
    'product_search_dialog.cross_product.recents.section_heading': 'Recently viewed',
    'product_search_dialog.cross_product.results.section_heading': 'Search results',
    'product_search_dialog.cross_product.tab_label': 'All',
    'product_search_dialog.empty.no_results_body': 'Try again with a different term, or refine your results with <a>Advanced Search</a>',
    'product_search_dialog.empty.no_results_body_with_no_advanced_search': 'Try again with a different term.',
    'product_search_dialog.empty.no_results_heading': "We couldn't find anything matching your search.",
    'product_search_dialog.empty_prequery.error_heading': 'Something went wrong with showing initial results',
    'product_search_dialog.empty_prequery.no_results_heading': 'Search for what you need',
    'product_search_dialog.error.failed_loading_search_body': 'It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>',
    'product_search_dialog.error.failed_loading_search_heading': "We're having trouble loading your recently viewed content.",
    'product_search_dialog.give_feedback': 'Give feedback',
    'product_search_dialog.google_drive.files_heading': 'Files',
    'product_search_dialog.inline_onboarding_action': 'Ok',
    'product_search_dialog.inline_onboarding_body': 'Use the Jira and Confluence tabs to search and see recent items in either location.',
    'product_search_dialog.inline_onboarding_title': 'Search across Jira and Confluence',
    'product_search_dialog.jira.assignee_filters': 'Filter by assignee',
    'product_search_dialog.jira.boards_icon_accessibility_text': 'Board icon',
    'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Boards, Projects, Filters and Plans',
    'product_search_dialog.jira.boards_projects_filters_section_heading': 'Boards, Projects and Filters',
    'product_search_dialog.jira.date_filter_30': '30d',
    'product_search_dialog.jira.date_filter_60': '60d',
    'product_search_dialog.jira.date_filter_90': '90d',
    'product_search_dialog.jira.date_filter_any': 'Any time',
    'product_search_dialog.jira.date_filter_past_30_days': 'Past 30 days',
    'product_search_dialog.jira.date_filter_past_7_days': 'Past 7 days',
    'product_search_dialog.jira.date_filter_past_year': 'Past year',
    'product_search_dialog.jira.date_filter_today': 'Today',
    'product_search_dialog.jira.date_filter_yesterday': 'Yesterday',
    'product_search_dialog.jira.date_filters': 'Last updated',
    'product_search_dialog.jira.empty_prequery.no_results_heading': 'Start searching to find your work',
    'product_search_dialog.jira.issue_filter_done': 'Done',
    'product_search_dialog.jira.issue_filter_open': 'Open',
    'product_search_dialog.jira.issue_filters': 'Filter by status',
    'product_search_dialog.jira.issue_labels_filters': 'Filter by label',
    'product_search_dialog.jira.issue_labels_filters_options_group_label': 'All labels',
    'product_search_dialog.jira.issue_labels_filters_placeholder': 'Select label',
    'product_search_dialog.jira.issues_section_heading': 'Issues',
    'product_search_dialog.jira.issues_section_heading-issue-term-refresh': 'Work items',
    'product_search_dialog.jira.jira_view_all_issues_new': 'View all issues',
    'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh': 'View all work items',
    'product_search_dialog.jira.project_filters': 'Filter by project',
    'product_search_dialog.jira.project_filters_find_more': 'Find a project',
    'product_search_dialog.jira.projects_filters_section_heading': 'Projects and Filters',
    'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading': 'Recent Boards, Projects, Filters and Plans',
    'product_search_dialog.jira.recent_boards_projects_filters_section_heading': 'Recent Boards, Projects and Filters',
    'product_search_dialog.jira.recent_projects_filters_section_heading': 'Recent Projects and Filters',
    'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Recently viewed issues',
    'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh': 'Recently viewed work items',
    'product_search_dialog.jira.report_by_filters': 'Filter by reporter',
    'product_search_dialog.jira.reported_by_me_filter': 'Reported by me',
    'product_search_dialog.jira.site_filters_find_more': 'Find a site',
    'product_search_dialog.loading_filters': 'Loading',
    'product_search_dialog.more_filters': 'View all filters',
    'product_search_dialog.multi_site_advanced_search_label': 'Search on:',
    'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} more',
    'product_search_dialog.no_options_filters': 'No options',
    'product_search_dialog.opsgenie.advanced_search': 'Advanced alert search',
    'product_search_dialog.opsgenie.alert_heading': 'Alerts',
    'product_search_dialog.opsgenie.expanded.input-placeholder': 'Search Opsgenie',
    'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Recent Alerts',
    'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Ask Atlassian Intelligence',
    'product_search_dialog.quick_find_confluence_space': 'Confluence Space',
    'product_search_dialog.quick_find_footer_full_page_search_products_link': 'Search across products',
    'product_search_dialog.quick_find_footer_help_text': 'Help us improve search',
    'product_search_dialog.quick_find_no_content_body_rovo': "Search or ask Rovo what you're looking for in your Atlassian and integrated products",
    'product_search_dialog.quick_find_no_content_header': 'Seek and you shall find',
    'product_search_dialog.quick_find_post_query_no_results_body': '<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term.',
    'product_search_dialog.quick_find_post_query_no_results_header': "We couldn't find any results with that title",
    'product_search_dialog.quick_find_recent_draft_label': 'DRAFT',
    'product_search_dialog.quick_find_recent_search': 'Recent search',
    'product_search_dialog.quick_find_recent_search_text_dialog': 'From your recent searches',
    'product_search_dialog.quick_find_recent_spaces_additional_meta': 'You recently visited',
    'product_search_dialog.quick_find_recently_viewed': 'Recently Viewed',
    'product_search_dialog.quick_find_result_item_team': 'Team',
    'product_search_dialog.quick_find_results_section': 'Search Results',
    'product_search_dialog.quick_find_rovo_tip': "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer.",
    'product_search_dialog.quick_find_search_input_rovo_placeholder': 'Search or ask Rovo',
    'product_search_dialog.quick_find_search_results': 'Search Results',
    'product_search_dialog.quick_find_show_filtered_confluence_results': 'Filter by Confluence spaces, contributors and more',
    'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon': 'Filter by {confluenceIcon} Confluence spaces, contributors and more',
    'product_search_dialog.quick_find_show_organization_results': 'Search your organization',
    'product_search_dialog.recent_spaces_section_heading': 'Recent spaces',
    'product_search_dialog.recently_viewed_heading': 'Advanced search',
    'product_search_dialog.recently_viewed_section_heading': 'Recently viewed',
    'product_search_dialog.recently_worked_with_section_heading': 'Recently worked with',
    'product_search_dialog.results.remove_button_label': 'Remove this.',
    'product_search_dialog.search_input_collapsed_placeholder': 'Search',
    'product_search_dialog.search_input_enlarged_aria_label': 'Press enter to navigate to advanced search',
    'product_search_dialog.search_people_link': 'Search people',
    'product_search_dialog.show_all_results_link': 'View all results',
    'product_search_dialog.show_more_results_link': 'Show more',
    'product_search_dialog.townsquare.search_input_expanded_placeholder': 'Search Home',
    'product_search_dialog.townsquare_goals_heading': 'Goals',
    'product_search_dialog.townsquare_goals_view_all': 'Search all goals',
    'product_search_dialog.townsquare_help_links_heading': 'Help Links',
    'product_search_dialog.townsquare_learnings_risks_decisions_heading': 'Learnings, Risks and Decisions',
    'product_search_dialog.townsquare_people_heading': 'People',
    'product_search_dialog.townsquare_people_view_all': 'Search all people',
    'product_search_dialog.townsquare_projects_heading': 'Projects',
    'product_search_dialog.townsquare_projects_view_all': 'Search all projects',
    'product_search_dialog.townsquare_recent_people': 'Recent People',
    'product_search_dialog.townsquare_recent_topics': 'Recent Topics',
    'product_search_dialog.townsquare_teams_heading': 'Teams',
    'product_search_dialog.townsquare_teams_view_all': 'Search all teams',
    'product_search_dialog.townsquare_topics_heading': 'Topics',
    'product_search_dialog.townsquare_topics_view_all': 'Search all topics',
    'product_search_dialog.trello.archived': 'Archived',
    'product_search_dialog.trello.archived.card-hover': 'This card is archived',
    'product_search_dialog.trello.board': 'Board',
    'product_search_dialog.trello.boards_heading': 'Boards',
    'product_search_dialog.trello.cards_heading': 'Cards',
    'product_search_dialog.trello.closed': 'Closed',
    'product_search_dialog.trello.closed.board-hover': 'This board is closed',
    'product_search_dialog.trello.expanded.input-placeholder': 'Search Trello',
    'product_search_dialog.trello.feedback_link': 'Help us improve your search results!',
    'product_search_dialog.trello.list': 'List',
    'product_search_dialog.trello.private_workspace': 'Private Workspace',
    'product_search_dialog.trello.recent_boards_heading': 'Recent boards',
    'product_search_dialog.trello.workspace': 'Workspace',
    'product_search_dialog.updated_date_formatter': 'Updated {date}',
    'recentWork.eventTypeMessage.absolute.commented': 'You commented on {date}',
    'recentWork.eventTypeMessage.absolute.created': 'You created on {date}',
    'recentWork.eventTypeMessage.absolute.edited': 'You edited on {date}',
    'recentWork.eventTypeMessage.absolute.published': 'You published on {date}',
    'recentWork.eventTypeMessage.absolute.updated': 'You updated on {date}',
    'recentWork.eventTypeMessage.absolute.viewed': 'You viewed on {date}',
    'recentWork.eventTypeMessage.absolute.workedOn': 'You worked on {date}',
    'recentWork.eventTypeMessage.relative.commented': 'You commented {date}',
    'recentWork.eventTypeMessage.relative.created': 'You created {date}',
    'recentWork.eventTypeMessage.relative.edited': 'You edited {date}',
    'recentWork.eventTypeMessage.relative.published': 'You published {date}',
    'recentWork.eventTypeMessage.relative.updated': 'You updated {date}',
    'recentWork.eventTypeMessage.relative.viewed': 'You viewed {date}',
    'search_dialog.filters.group.show-more': 'Show more',
    'search_dialog.search_input_clear_label': 'Clear search session',
    'search_dialog.search_input_exit_label': 'Exit Search'
};

});

parcelRegister("ePAaW", function(module, exports) {

let $acc1e3cd23ac4389$var$load = (parcelRequire("28QjX"))(4);
module.exports = $acc1e3cd23ac4389$var$load("iekKZ").then(()=>parcelRequire('jXoZr'));

});

parcelRegister("bbntL", function(module, exports) {

let $8242ef3efbf09cc2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8242ef3efbf09cc2$var$load("ioDXi").then(()=>parcelRequire('8QdkF'));

});

parcelRegister("9DUHg", function(module, exports) {

let $7053bc5ffc4c6179$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7053bc5ffc4c6179$var$load("2GVxb").then(()=>parcelRequire('iqmRB'));

});

parcelRegister("5iwLe", function(module, exports) {

let $3db80bca732d0b94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3db80bca732d0b94$var$load("hC8BQ").then(()=>parcelRequire('hU8Wg'));

});

parcelRegister("bBCTS", function(module, exports) {

let $8731532c65944d2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8731532c65944d2a$var$load("6Pnts").then(()=>parcelRequire('G6p7g'));

});

parcelRegister("dAZNx", function(module, exports) {

let $9e5e92eede6a30dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e5e92eede6a30dd$var$load("3lZh6").then(()=>parcelRequire('8XBJD'));

});

parcelRegister("9IbRW", function(module, exports) {

let $71216e0cd59aefd6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71216e0cd59aefd6$var$load("doaKf").then(()=>parcelRequire('2OsED'));

});

parcelRegister("lU5y1", function(module, exports) {

let $ff23219963f4df7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff23219963f4df7a$var$load("cno8Q").then(()=>parcelRequire('kYYal'));

});

parcelRegister("3rrBV", function(module, exports) {

let $28194f9c7de408b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28194f9c7de408b9$var$load("3O0ky").then(()=>parcelRequire('dEbhi'));

});

parcelRegister("68Am3", function(module, exports) {

let $477fb0b4c2a5175c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $477fb0b4c2a5175c$var$load("9yVDq").then(()=>parcelRequire('3cACL'));

});

parcelRegister("3Rg0H", function(module, exports) {

let $2cf2bda0e521b1d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2cf2bda0e521b1d7$var$load("3NdES").then(()=>parcelRequire('dJ2yL'));

});

parcelRegister("imnjX", function(module, exports) {

let $d5dc5f1834ca7d30$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5dc5f1834ca7d30$var$load("3UKtX").then(()=>parcelRequire('4mTJs'));

});

parcelRegister("2evHd", function(module, exports) {

let $1a0579c27b831b40$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1a0579c27b831b40$var$load("12owP").then(()=>parcelRequire('e3A3t'));

});

parcelRegister("hgaVS", function(module, exports) {

let $c90c693c1c8953ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c90c693c1c8953ed$var$load("gDPLv").then(()=>parcelRequire('jsrqy'));

});

parcelRegister("grNAz", function(module, exports) {

let $bf95a2478aeb2441$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf95a2478aeb2441$var$load("9jQ2E").then(()=>parcelRequire('lB7uF'));

});

parcelRegister("42Lin", function(module, exports) {

let $2f1c0932a7a3f682$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f1c0932a7a3f682$var$load("lQESu").then(()=>parcelRequire('jGHC1'));

});

parcelRegister("9UBw1", function(module, exports) {

let $737671d4c51baf2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $737671d4c51baf2c$var$load("gnMGO").then(()=>parcelRequire('a9EL3'));

});

parcelRegister("ja43E", function(module, exports) {

let $df3219519070aafb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $df3219519070aafb$var$load("68Mmc").then(()=>parcelRequire('50j5y'));

});

parcelRegister("bsIH3", function(module, exports) {

let $8584fa69369fe587$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8584fa69369fe587$var$load("era9z").then(()=>parcelRequire('l5flR'));

});

parcelRegister("fnP1u", function(module, exports) {

let $b330951ae2e62ebc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b330951ae2e62ebc$var$load("2Tyv2").then(()=>parcelRequire('2V7Za'));

});

parcelRegister("hXRqF", function(module, exports) {

let $d1416448af3fe0e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d1416448af3fe0e0$var$load("eLsdD").then(()=>parcelRequire('gKwhP'));

});

parcelRegister("6EQEt", function(module, exports) {

let $4d8f5209e095461f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d8f5209e095461f$var$load("9CAaE").then(()=>parcelRequire('2SnNI'));

});

parcelRegister("lcpgs", function(module, exports) {

let $f6ee50f806da04b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f6ee50f806da04b3$var$load("foiH8").then(()=>parcelRequire('cRUF7'));

});

parcelRegister("iLnDi", function(module, exports) {

let $da8ef2c56aea219a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $da8ef2c56aea219a$var$load("bdzoF").then(()=>parcelRequire('1ng90'));

});

parcelRegister("nFzmq", function(module, exports) {

let $047264e6a9a80f8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $047264e6a9a80f8f$var$load("7CAzE").then(()=>parcelRequire('j8EgG'));

});

parcelRegister("k3zhF", function(module, exports) {

let $e99f752395bc5503$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e99f752395bc5503$var$load("fgy6J").then(()=>parcelRequire('9QTmV'));

});

parcelRegister("25q0u", function(module, exports) {

let $185038d42c8e7e46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $185038d42c8e7e46$var$load("gzqsu").then(()=>parcelRequire('27gZm'));

});

parcelRegister("jHws8", function(module, exports) {

let $e57b34f2342ca3e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e57b34f2342ca3e5$var$load("iseQf").then(()=>parcelRequire('dKu0d'));

});

parcelRegister("g7FTT", function(module, exports) {

let $bbcdcd5586bdf4c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bbcdcd5586bdf4c2$var$load("ygkQh").then(()=>parcelRequire('k6ygv'));

});



parcelRegister("4k2KW", function(module, exports) {

$parcel$export(module.exports, "BuildVersionAnalyticContext", () => $b4c67553dbafe429$export$7095b8205ce661b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $tUDIN = parcelRequire("tUDIN");

const $b4c67553dbafe429$export$7095b8205ce661b6 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
        analyticContext: {
            frontend: (0, $7531534e67cbfa1e$export$2db401a6b81eceee)
        },
        nonPrivacySafeAnalyticContext: {},
        children: children
    });

});

parcelRegister("jQ6em", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c1427246b87c479$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $75NXP = parcelRequire("75NXP");

var $6ZsPS = parcelRequire("6ZsPS");
var $9c1427246b87c479$export$2e2bcd8739ae039 = ()=>{
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'operational',
            action: 'exposed',
            actionSubject: 'quickSearchExperiment',
            source: 'searchDialog'
        });
    // We keep the searchSessionId here because we want a new experiment exposure event every new session
    }, [
        fireAnalyticsEvent,
        searchSessionId
    ]);
    return null;
};

});

parcelRegister("ebv5l", function(module, exports) {

$parcel$export(module.exports, "DialogDismissedHandler", () => $0656c1e6493952a0$export$50483e15753411d8);

var $5uXOq = parcelRequire("5uXOq");

var $gsomE = parcelRequire("gsomE");

var $3FqY6 = parcelRequire("3FqY6");
class $0656c1e6493952a0$export$b768cbf5d904a94a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        const { onDialogClosed: onDialogClosed, isExpanded: isExpanded } = this.props;
        if (prevProps.isExpanded && !isExpanded) onDialogClosed();
    }
    render() {
        return null;
    }
}
const $0656c1e6493952a0$export$50483e15753411d8 = (0, $gsomE.withAnalytics)({
    onDialogClosed: (0, $3FqY6.onDismissed)
})($0656c1e6493952a0$export$b768cbf5d904a94a);

});

parcelRegister("eARpK", function(module, exports) {

$parcel$export(module.exports, "AsyncLoadOnQuery", () => $de1588b902d53d4e$export$c658105a3bdf0409);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5cPn = parcelRequire("i5cPn");

var $2dI5H = parcelRequire("2dI5H");


const $de1588b902d53d4e$export$c658105a3bdf0409 = ()=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const { isExpanded: isExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const [isFetched, setIsFetched] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (query && isFetched === false && isExpanded) {
            (parcelRequire("cZrdv"));
            (parcelRequire("4UdwD"));
            setIsFetched(true);
        }
    }, [
        query,
        isFetched,
        setIsFetched,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
};

});

parcelRegister("ihzp7", function(module, exports) {

$parcel$export(module.exports, "DialogShownHandler", () => $e3877db627479ac3$export$914029055eb3fe8e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kv2Va = parcelRequire("kv2Va");

var $3FqY6 = parcelRequire("3FqY6");

var $gsomE = parcelRequire("gsomE");

var $95MIc = parcelRequire("95MIc");
const $e3877db627479ac3$export$18e8dcaf0a5a46b2 = ({ isExpanded: isExpanded, onDialogShown: onDialogShown })=>{
    const { products: products, getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const isRovoCrossProductSearchLinkShown = (0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    (0, $5uXOq.useEffect)(()=>{
        const emitAnalyticsEvent = ()=>{
            const visibleProducts = products.map((product)=>product.title);
            const visibleTabsCount = visibleProducts.length > 1 ? products.length : 0;
            onDialogShown({
                visibleProducts: visibleProducts,
                visibleTabsCount: visibleTabsCount,
                isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown
            });
        };
        isExpanded && emitAnalyticsEvent();
    }, [
        isExpanded
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
};
const $e3877db627479ac3$export$914029055eb3fe8e = (0, $gsomE.withAnalytics)({
    onDialogShown: (0, $3FqY6.onShown)
})($e3877db627479ac3$export$18e8dcaf0a5a46b2);

});

parcelRegister("8zfVb", function(module, exports) {

$parcel$export(module.exports, "QuickFindAnalyticContext", () => $05f4ad407d190e0b$export$bf21b659e40e8eb4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $tUDIN = parcelRequire("tUDIN");
const $05f4ad407d190e0b$export$bf21b659e40e8eb4 = ({ children: children, isQuickFind: isQuickFind = false })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $tUDIN.SearchDialogAnalyticsContext), {
        analyticContext: {
            isQuickFind: isQuickFind
        },
        nonPrivacySafeAnalyticContext: {},
        children: children
    });

});


parcelRegister("5rLBT", function(module, exports) {

$parcel$export(module.exports, "ProductTabs", () => $ad9945747297e609$export$f698db24bc555eee);

var $2OMIu = parcelRequire("2OMIu");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");
parcelRequire("5uXOq");

var $3FqY6 = parcelRequire("3FqY6");
var $75NXP = parcelRequire("75NXP");

var $4tuQr = parcelRequire("4tuQr");

var $2DWAC = parcelRequire("2DWAC");

var $i5cPn = parcelRequire("i5cPn");

var $kv2Va = parcelRequire("kv2Va");

var $gnqGE = parcelRequire("gnqGE");
const $ad9945747297e609$var$CustomTab = ({ index: index, title: title, tabRenderer: tabRenderer })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jxIT3.default), {
        testId: `search-dialog-product-tab-${index}`,
        children: tabRenderer ? tabRenderer({
            title: title
        }) : title
    }, index);
};
const $ad9945747297e609$export$bd4c4b880e23a953 = (props)=>{
    const { products: products, showProduct: showProduct, getActiveProduct: getActiveProduct, isExpanded: isExpanded, abTest: abTest } = props;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const onTabClicked = (index)=>{
        const id = products[index].id;
        showProduct(products[index].id);
        fireAnalyticsEvent((0, $3FqY6.onTabSelected)({
            tabName: id
        }));
    };
    const activeProductId = getActiveProduct()?.id;
    const activeProductIndex = products.findIndex((product)=>product.id === activeProductId);
    const primaryProduct = products.find((product)=>product.order === 0);
    if (activeProductIndex === -1 && isExpanded && primaryProduct && abTest) {
        showProduct(primaryProduct.id);
        return null;
    }
    if (!isExpanded || products.length === 1 || !abTest || !primaryProduct) return null;
    // Tabs has unwanted flex-basis: 100% set, div wrapper gets around this
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2DWAC.DisableXPSAB), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gnqGE.TabControlsWrapper), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fphHl.default), {
                selected: activeProductIndex,
                onChange: onTabClicked,
                id: "tab-controls",
                shouldUnmountTabPanelOnChange: true,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cte3m.default), {
                    children: products.map((product, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)($ad9945747297e609$var$CustomTab, {
                            index: index,
                            title: product.title,
                            tabRenderer: product.tabRenderer
                        }, product.id))
                })
            })
        })
    });
};
const $ad9945747297e609$export$f698db24bc555eee = (0, $4tuQr.withABTestContext)((0, $kv2Va.withProductContext)((0, $i5cPn.withDialogExpansionContext)($ad9945747297e609$export$bd4c4b880e23a953)));

});
parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("jxIT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a23bdf24c904bdb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $dS3PR = parcelRequire("dS3PR");

var $eQ4wW = parcelRequire("eQ4wW");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $5a23bdf24c904bdb$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eQ4wW.useTab)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                weight: "medium",
                color: "inherit",
                maxLines: 1,
                children: children
            })
        })
    });
});
var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");
const $e15f9538b451f314$var$baseStyles = null;
const $e15f9538b451f314$var$tabListStyles = null;
const $e15f9538b451f314$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});

parcelRegister("2DWAC", function(module, exports) {

$parcel$export(module.exports, "DisableXPSAB", () => $4166b18629be3a52$export$67fbd6b459867ac2);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4tuQr = parcelRequire("4tuQr");
const $4166b18629be3a52$export$67fbd6b459867ac2 = ({ children: children })=>{
    const abTest = (0, $4tuQr.useABTest)();
    if (abTest?.experimentId === 'xps-hidden') // This experiment is a permanent FE experiment inside aggregator.
    return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("gnqGE", function(module, exports) {

$parcel$export(module.exports, "TabControlsWrapper", () => $1514ab84f2b5017c$export$f26b9facc67e59ba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
const $1514ab84f2b5017c$export$f26b9facc67e59ba = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "et5m3c0"
})({
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"}`
});

});


parcelRegister("3wz5U", function(module, exports) {

$parcel$export(module.exports, "ActiveProductSearchInput", () => $e63cabfbbda63efb$export$88d712058aeecea7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2AbEM = parcelRequire("2AbEM");

var $VSDnB = parcelRequire("VSDnB");

var $kMSay = parcelRequire("kMSay");

var $kv2Va = parcelRequire("kv2Va");

var $aR1b2 = parcelRequire("aR1b2");

var $2dI5H = parcelRequire("2dI5H");

var $i5cPn = parcelRequire("i5cPn");

var $4tuQr = parcelRequire("4tuQr");

var $bPysz = parcelRequire("bPysz");
var $ghYvR = parcelRequire("ghYvR");

var $bjTHS = parcelRequire("bjTHS");

var $2k6eV = parcelRequire("2k6eV");

var $koVbs = parcelRequire("koVbs");

var $k4hbD = parcelRequire("k4hbD");
const $e63cabfbbda63efb$export$83ddef5d719c74b1 = ({ forwardRef: forwardRef, isExpanded: isExpanded, setIsExpanded: setIsExpanded, activeProductId: activeProductId, query: query, setQuery: setQuery, onNavigateGeneric: onNavigateGeneric, isLoading: isLoading, pageLoadMetrics: pageLoadMetrics, shouldFillContainer: shouldFillContainer })=>{
    const inputRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (pageLoadMetrics) {
            const { metric: metric, customDataGetter: customDataGetter } = pageLoadMetrics;
            metric.stop({
                customData: customDataGetter()
            });
        }
    }, [
        pageLoadMetrics
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) inputRef?.current?.focus();
    }, [
        isExpanded,
        inputRef,
        activeProductId
    ]);
    const ref = (0, $aR1b2.mergeRefCallback)(forwardRef, inputRef);
    const openPressTracing = (0, $kMSay.default)('product-search-input-open');
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        setIsExpanded(true);
        if ((0, $VSDnB.fg)('cc_search_input_open_press_tracing')) openPressTracing();
    }, [
        setIsExpanded,
        openPressTracing
    ]);
    const onBack = (0, $5uXOq.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    const inputComponentProps = {
        activeProductId: activeProductId,
        query: query,
        setQuery: setQuery,
        forwardRef: ref,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        onOpen: onOpen,
        onNavigateGeneric: onNavigateGeneric,
        onBack: onBack,
        isLoading: isLoading,
        shouldFillContainer: shouldFillContainer
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bjTHS.GenericProductSearchInput), {
        ...inputComponentProps
    });
};
const $e63cabfbbda63efb$export$88d712058aeecea7 = ({ features: features, shouldFillContainer: shouldFillContainer, ...rest })=>{
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const { query: query, setQuery: setQuery, isLoading: isLoading } = (0, $2dI5H.useQuery)();
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const { stickySearchEnabled: stickySearchEnabled } = (0, $2k6eV.useSessionUserInput)();
    const abTest = (0, $4tuQr.useABTest)();
    const theme = (0, $2AbEM.useTheme)();
    const activeProduct = getActiveProduct();
    const intl = (0, $koVbs.default)();
    if (!abTest) return features?.interactiveSkeleton ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ghYvR.ProductSearchInputSkeletonInteractive), {
        theme: theme,
        shouldFillContainer: shouldFillContainer,
        stickySearchEnabled: stickySearchEnabled,
        ...features.interactiveSkeleton
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bPysz.ProductSearchInputSkeleton), {
        shouldFillContainer: shouldFillContainer,
        theme: theme,
        placeholder: intl.formatMessage((0, $k4hbD.messages).common_search_input_collapsed_placeholder)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e63cabfbbda63efb$export$83ddef5d719c74b1, {
        ...rest,
        shouldFillContainer: shouldFillContainer,
        activeProductId: activeProduct?.id,
        query: query,
        setQuery: setQuery,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        isLoading: isLoading
    });
};

});
parcelRegister("ghYvR", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeletonInteractive", () => $3c18a1528422c7a4$export$e3798ad624b9f761);
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input.  The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 * On the first render of this component, this stored state is used as initial
 * an initial state. This behaviour allows one instance of this component
 * to be replaced by another and appear to seamlessly act as a single component.
 *
 * This component is intended to be used for client side rendering only.
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2VWh9 = parcelRequire("2VWh9");
var $2AbEM = parcelRequire("2AbEM");
const $3c18a1528422c7a4$export$e3798ad624b9f761 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2AbEM.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2VWh9.SearchInputSkeletonInteractive), {
            ...props
        })
    });
};

});
parcelRegister("2VWh9", function(module, exports) {

$parcel$export(module.exports, "SearchInputSkeletonInteractive", () => $8f3a15c2a2955cf8$export$fca483ab36e9fec9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9enEu = parcelRequire("9enEu");

var $3bWiA = parcelRequire("3bWiA");

var $3ZeOg = parcelRequire("3ZeOg");

var $j1SOM = parcelRequire("j1SOM");
const $8f3a15c2a2955cf8$export$fca483ab36e9fec9 = ({ placeholder: placeholder, stickySearchEnabled: stickySearchEnabled, onEnter: onEnter, shouldFillContainer: shouldFillContainer })=>{
    // Initialise stored inputSkeletonState if necessary
    const checkedForInputSkeletonState = (0, $5uXOq.useRef)(false);
    if (!checkedForInputSkeletonState.current) {
        if (!window.inputSkeletonState) (0, $j1SOM.resetInputSkeletonState)();
        checkedForInputSkeletonState.current = true;
    }
    const searchInputRef = (0, $5uXOq.useRef)(null);
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)((0, $j1SOM.getInputSkeletonFocus)());
    const [value, setValue] = (0, $5uXOq.useState)(()=>{
        const stickySearchQuery = (0, $3ZeOg.getSessionItem)((0, $3ZeOg.SEARCH_QUERY_KEY));
        return stickySearchEnabled && stickySearchQuery ? stickySearchQuery : (0, $j1SOM.getInputSkeletonQuery)();
    });
    // Use the stored state to focus and set selection
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $j1SOM.removeInputSkeletonEventListeners)();
        const isFoucsed = (0, $j1SOM.getInputSkeletonFocus)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $j1SOM.getInputSkeletonSelection)();
        if (isFoucsed) {
            searchInputRef?.current?.focus();
            searchInputRef?.current?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    }, []);
    const onFocus = ()=>{
        setIsExpanded(true);
        (0, $j1SOM.setInputSkeletonIsFocus)(true);
        searchInputRef?.current?.focus();
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $j1SOM.setInputSkeletonIsFocus)(false);
        if (!stickySearchEnabled) {
            setValue('');
            (0, $j1SOM.setInputSkeletonQuery)('');
            (0, $j1SOM.setInputSkeletonSelection)(0, 0, 'none');
        }
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Escape') {
            searchInputRef?.current?.blur();
            onBlur();
        }
    };
    const onInput = (newValue)=>{
        setValue(newValue);
        (0, $j1SOM.setInputSkeletonQuery)(newValue);
        (0, $j1SOM.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
        if (stickySearchEnabled) (0, $3ZeOg.setSessionItem)((0, $3ZeOg.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = ()=>{
        (0, $j1SOM.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
    };
    // Fixes some instances where callbacks would not be called when the search
    // input is clicked as the component is being destroyed
    (0, $5uXOq.useEffect)(()=>{
        let storedSearchInputRef = null;
        if (searchInputRef.current) storedSearchInputRef = searchInputRef.current;
        return ()=>{
            if (storedSearchInputRef) {
                (0, $j1SOM.setInputSkeletonQuery)(storedSearchInputRef.value);
                (0, $j1SOM.setInputSkeletonIsFocus)(document.activeElement === storedSearchInputRef);
                (0, $j1SOM.setInputSkeletonSelection)(storedSearchInputRef.selectionStart || 0, storedSearchInputRef.selectionEnd || 0, storedSearchInputRef.selectionDirection || 'none');
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9enEu.SearchAnchor), {
        isExpanded: isExpanded,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bWiA.default), {
            "data-test-id": "search-dialog-input-skeleton-interactive",
            isExpanded: isExpanded,
            placeholder: placeholder,
            onInput: onInput,
            onSelect: onSelect,
            onEnter: onEnter,
            shouldFillContainer: shouldFillContainer,
            value: value,
            ref: searchInputRef
        })
    });
};

});
parcelRegister("3bWiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $11a67e855bc3630f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $bu8Mq = parcelRequire("bu8Mq");

var $42CjB = parcelRequire("42CjB");

var $2AbEM = parcelRequire("2AbEM");

var $6I8Kl = parcelRequire("6I8Kl");

var $b9NEf = parcelRequire("b9NEf");

var $lWgWi = parcelRequire("lWgWi");
const $11a67e855bc3630f$var$MAX_INPUT_LENGTH = 500;
const $11a67e855bc3630f$export$55d7609a8f1eccd2 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, onSelect: onSelect, toggleAISearchButton: toggleAISearchButton, shouldFillContainer: shouldFillContainer })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleTabEnter = (e)=>{
        if (e.key === 'Enter' && onClick) onClick();
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $b9NEf.HiddenTooltip);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        label: "Search",
                        onClick: handleClick,
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    onKeyPress: handleTabEnter,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bu8Mq))), {
                        label: exitSearchLabel || 'Exit Search',
                        LEGACY_size: "large",
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $11a67e855bc3630f$var$MAX_INPUT_LENGTH,
                    "aria-label": placeholder,
                    ...theme
                }),
                (showClearButton || !!toggleAISearchButton) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lWgWi.SearchInputOverlay), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    toggleAISearchButton: toggleAISearchButton
                })
            ]
        })
    });
};
var $11a67e855bc3630f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const theme = (0, $2AbEM.useTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($11a67e855bc3630f$export$55d7609a8f1eccd2, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});

});
parcelRegister("bu8Mq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::707984c4bf43fbcb724a560e605082a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85c94e946798d101$var$_react = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $85c94e946798d101$var$_arrowLeft = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("ctqwA")));

var $85c94e946798d101$var$_arrowLeft2 = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("3gt3f")));
function $85c94e946798d101$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85c94e946798d101$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $85c94e946798d101$var$_react.default.createElement($85c94e946798d101$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $85c94e946798d101$var$_arrowLeft2.default
    }, props));
$85c94e946798d101$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $85c94e946798d101$var$_default = module.exports.default = $85c94e946798d101$var$ArrowLeftIcon;

});
parcelRegister("ctqwA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $914cc4b222e651e0$var$_react = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $914cc4b222e651e0$var$_baseNew = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $914cc4b222e651e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $914cc4b222e651e0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $914cc4b222e651e0$var$_react.default.createElement($914cc4b222e651e0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$914cc4b222e651e0$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $914cc4b222e651e0$var$_default = module.exports.default = $914cc4b222e651e0$var$ArrowLeftIcon;

});

parcelRegister("3gt3f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $260966be5d9bd0f6$var$_react = $260966be5d9bd0f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $260966be5d9bd0f6$var$_arrowLeft = $260966be5d9bd0f6$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $260966be5d9bd0f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $260966be5d9bd0f6$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $260966be5d9bd0f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $260966be5d9bd0f6$var$_arrowLeft.default
    }));
$260966be5d9bd0f6$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $260966be5d9bd0f6$var$_default = module.exports.default = $260966be5d9bd0f6$var$ArrowLeftIcon;

});


parcelRegister("lWgWi", function(module, exports) {

$parcel$export(module.exports, "SearchInputOverlay", () => $55ed4baddf3d1eb5$export$bde709da22d710bb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $b9NEf = parcelRequire("b9NEf");

var $ip0rq = parcelRequire("ip0rq");
const $55ed4baddf3d1eb5$export$bde709da22d710bb = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, toggleAISearchButton: toggleAISearchButton })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.InputBoxOverlayRight), {
        children: [
            showClearButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.ClearIconWrapper), {
                ...theme,
                role: "button",
                onClick: onClear,
                onMouseEnter: ()=>{
                    allowChangeExpand?.(false);
                },
                onMouseLeave: ()=>{
                    allowChangeExpand?.(true);
                },
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
                    color: "currentColor",
                    label: clearSearchLabel || 'Clear search session',
                    LEGACY_size: "small"
                })
            }),
            toggleAISearchButton
        ]
    });
};

});
parcelRegister("ip0rq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32d605899e0518e58ac6527dead74482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d65ae76e92cae981$var$_react = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d65ae76e92cae981$var$_crossCircle = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("hI6SY")));

var $d65ae76e92cae981$var$_selectClear = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("673MF")));
function $d65ae76e92cae981$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d65ae76e92cae981$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $d65ae76e92cae981$var$_react.default.createElement($d65ae76e92cae981$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $d65ae76e92cae981$var$_selectClear.default
    }, props));
$d65ae76e92cae981$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $d65ae76e92cae981$var$_default = module.exports.default = $d65ae76e92cae981$var$CrossCircleIcon;

});
parcelRegister("673MF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
function $473654f205f53fc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $473654f205f53fc4$var$SelectClearIcon = (props)=>/*#__PURE__*/ $473654f205f53fc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $473654f205f53fc4$var$_crossCircle.default
    }));
$473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;

});






parcelRegister("bjTHS", function(module, exports) {

$parcel$export(module.exports, "GenericProductSearchInput", () => $dfb8c51fd095fc5a$export$372be6d3f9d3f49);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $jn29h = parcelRequire("jn29h");

var $k4hbD = parcelRequire("k4hbD");

var $kv2Va = parcelRequire("kv2Va");

var $hNXQY = parcelRequire("hNXQY");

var $4QKbG = parcelRequire("4QKbG");
const $dfb8c51fd095fc5a$var$debounceTime = 250;
const $dfb8c51fd095fc5a$var$GenericInputWithIntl = ({ activeProductId: activeProductId, intl: intl, onNavigateGeneric: onNavigateGeneric, query: query, isExpanded: isExpanded, isLoading: isLoading, onOpen: onOpen, forwardRef: forwardRef, onBack: onBack, setQuery: setQuery, shouldFillContainer: shouldFillContainer })=>{
    const { getProduct: getProduct } = (0, $kv2Va.useProductContext)();
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $hNXQY.useFeaturesContext)();
    const { queryParams: queryParams } = (0, $4QKbG.useQueryParams)();
    const hasQueryParamText = queryParams?.hasOwnProperty('text');
    const queryParamText = queryParams?.text?.toString() || '';
    const onNavigateGenericInput = (0, $5uXOq.useCallback)((productId)=>(href, event)=>{
            if (href) onNavigateGeneric(productId, href, event);
        }, [
        onNavigateGeneric
    ]);
    // We're using a ref for setQuery so that we can guarantee the function
    // definition is the same reference between renders.
    const setQueryRef = (0, $5uXOq.useRef)(setQuery);
    (0, $5uXOq.useEffect)(()=>{
        setQueryRef.current = setQuery;
    }, [
        setQuery
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isGriffinNavEnabled && hasQueryParamText) setQueryRef.current(queryParamText);
    }, [
        isGriffinNavEnabled,
        hasQueryParamText,
        queryParamText,
        setQueryRef
    ]);
    const { advancedSearchUrl: advancedSearchUrl, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, onNavigate: onNavigate, actionSubjectId: actionSubjectId, expandedStateInputPlaceholder: // @ts-expect-error
    expandedStateInputPlaceholder } = (()=>{
        if (!activeProductId || !getProduct(activeProductId)) return {
            advancedSearchUrl: '',
            secondaryAdvancedSearchURL: '',
            onNavigate: isGriffinNavEnabled ? onNavigateGenericInput('') : ()=>{},
            actionSubjectId: 'noActiveProduct'
        };
        return {
            advancedSearchUrl: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query) || '',
            secondaryAdvancedSearchURL: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query, undefined, 'onInputEnterModified') || '',
            expandedStateInputPlaceholder: getProduct(activeProductId)?.expandedStateInputPlaceholder || '',
            onNavigate: onNavigateGenericInput(activeProductId),
            actionSubjectId: activeProductId
        };
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jn29h.ProductSearchInput), {
        shouldFillContainer: shouldFillContainer,
        forwardRef: forwardRef,
        value: query,
        isExpanded: isExpanded,
        isLoading: isLoading,
        onOpen: onOpen,
        debounceTime: $dfb8c51fd095fc5a$var$debounceTime,
        advancedSearchURL: advancedSearchUrl,
        secondaryAdvancedSearchURL: secondaryAdvancedSearchURL,
        actionSubjectId: actionSubjectId,
        onBack: onBack,
        onInput: setQuery,
        expandedPlaceholder: expandedStateInputPlaceholder ? expandedStateInputPlaceholder : intl.formatMessage((0, $k4hbD.messages).common_search_input_collapsed_placeholder),
        collapsedPlaceholder: intl.formatMessage((0, $k4hbD.messages).common_search_input_collapsed_placeholder),
        onNavigate: onNavigate
    });
};
const $dfb8c51fd095fc5a$export$372be6d3f9d3f49 = (0, $8RXs9.default)($dfb8c51fd095fc5a$var$GenericInputWithIntl);

});
parcelRegister("jn29h", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInput", () => $3378b59567d048c9$export$1ea4f29215db3ad6);

var $2OMIu = parcelRequire("2OMIu");

var $7aggy = parcelRequire("7aggy");
var $j1SOM = parcelRequire("j1SOM");
var $3ZeOg = parcelRequire("3ZeOg");
var $3bWiA = parcelRequire("3bWiA");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $agEiU = parcelRequire("agEiU");

var $8oG5R = parcelRequire("8oG5R");
var $lYEL5 = parcelRequire("lYEL5");
var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");

var $6ZsPS = parcelRequire("6ZsPS");

var $k4hbD = parcelRequire("k4hbD");

var $aR1b2 = parcelRequire("aR1b2");

var $2k6eV = parcelRequire("2k6eV");

var $i5cPn = parcelRequire("i5cPn");

var $kv2Va = parcelRequire("kv2Va");

var $2dI5H = parcelRequire("2dI5H");

var $7ttuB = parcelRequire("7ttuB");

var $hNXQY = parcelRequire("hNXQY");

var $4QKbG = parcelRequire("4QKbG");

var $95MIc = parcelRequire("95MIc");

var $kR3QW = parcelRequire("kR3QW");

const $3378b59567d048c9$var$SearchAIPromptComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7t1n2")).then(({ SearchAIPrompt: SearchAIPrompt })=>({
            default: SearchAIPrompt
        })));
const $3378b59567d048c9$var$AskAIButton = ()=>{
    const { query: query } = (0, $2dI5H.useQuery)();
    const queryHash = (0, $8oG5R.sha256Hash)(query);
    const { getActiveProduct: getActiveProduct } = (0, $kv2Va.useProductContext)();
    const activeProduct = getActiveProduct();
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $2k6eV.useSessionUserInput)();
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $hNXQY.useFeaturesContext)();
    const handleToggleShowSearchAIDialog = (0, $5uXOq.useCallback)((show)=>{
        if (isGriffinNavEnabled) setIsExpanded(show);
        toggleShowSearchAIDialog(show);
    }, [
        isGriffinNavEnabled,
        setIsExpanded,
        toggleShowSearchAIDialog
    ]);
    return !!activeProduct?.aiSearchConfig || !!showSearchAIDialog && isExpanded || isGriffinNavEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($3378b59567d048c9$var$SearchAIPromptComponent, {
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            onToggleShowSearchAIDialog: handleToggleShowSearchAIDialog,
            source: "searchDialog"
        })
    }) : null;
};
const $3378b59567d048c9$var$getTooltipContent = (message)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $agEiU.KeyboardShortcutContainer), {
        children: [
            message,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agEiU.KeyboardShortcut), {
                children: '/'
            })
        ]
    });
class $3378b59567d048c9$export$f964308946b6123b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        const { onInput: onInput, stickySearchEnabled: stickySearchEnabled } = this.props;
        const skeletonFocused = (0, $j1SOM.getInputSkeletonFocus)();
        const skeletonQuery = (0, $j1SOM.getInputSkeletonQuery)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $j1SOM.getInputSkeletonSelection)();
        const stickySearchQuery = (0, $3ZeOg.getSessionItem)((0, $3ZeOg.SEARCH_QUERY_KEY)) || '';
        if (skeletonFocused) {
            this.expand((0, $3FqY6.Trigger).CLICK);
            onInput?.(skeletonQuery);
            if (this.ref) {
                this.ref.value = skeletonQuery;
                this.ref.focus();
                this.ref?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $j1SOM.removeInputSkeletonState)();
        if (stickySearchEnabled && stickySearchQuery) onInput?.(stickySearchQuery);
    }
    render() {
        const { value: value, isExpanded: isExpanded, expandedPlaceholder: expandedPlaceholder, collapsedPlaceholder: collapsedPlaceholder, debounceTime: debounceTime, intl: intl, showAIToggleButton: showAIToggleButton, isQuickFind: isQuickFind, ...rest } = this.props;
        const placeholder = isExpanded ? expandedPlaceholder : collapsedPlaceholder;
        const tooltipContent = $3378b59567d048c9$var$getTooltipContent(intl.formatMessage((0, $k4hbD.messages).common_search_input_collapsed_placeholder));
        const SearchInputComponent = isQuickFind ? (0, $7aggy.default) : (0, $3bWiA.default);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                isExpanded ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lYEL5.default), {
                    query: value,
                    debounceTime: debounceTime
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)(SearchInputComponent, {
                    ...rest,
                    onClick: this.onInputClick,
                    onInput: this.onInput,
                    ref: this.onRef,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    value: value,
                    onEnter: this.onEnter,
                    onClear: this.onClear,
                    toggleAISearchButton: showAIToggleButton ? /*#__PURE__*/ (0, $2OMIu.jsx)($3378b59567d048c9$var$AskAIButton, {}) : undefined,
                    tooltipContent: tooltipContent,
                    exitSearchLabel: intl.formatMessage((0, $k4hbD.messages).common_search_input_exit_button_label),
                    clearSearchLabel: intl.formatMessage((0, $k4hbD.messages).common_search_input_clear_button_label),
                    ...isQuickFind && {
                        ariaLabelContent: intl.formatMessage((0, $k4hbD.messages).common_search_input_enlarged_aria_label)
                    }
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.onInput = (value)=>{
            if (value !== this.props.value) {
                this.expand((0, $3FqY6.Trigger).TEXT_ENTERED);
                this.props.onInput?.(value);
            }
        }, this.expand = (trigger)=>{
            const { isExpanded: isExpanded, onOpen: onOpen, preQueryScreenViewed: preQueryScreenViewed, searchSessionId: searchSessionId } = this.props;
            if (!isExpanded) {
                onOpen();
                preQueryScreenViewed({
                    searchSessionId: searchSessionId,
                    trigger: trigger
                });
            }
        }, this.close = (e)=>{
            const { isExpanded: isExpanded, onBack: onBack } = this.props;
            if (isExpanded) onBack?.(e);
        }, this.onInputClick = ()=>{
            setTimeout(()=>this.ref?.focus());
            this.expand((0, $3FqY6.Trigger).CLICK);
        }, this.onEnter = (event)=>{
            const { isExpanded: isExpanded, onEnter: onEnter } = this.props;
            if (isExpanded) onEnter?.(event);
        }, this.onClear = ()=>{
            setTimeout(()=>this.ref?.focus());
            this.props.onClear?.();
        }, this.onRef = (0, $aR1b2.mergeRefCallback)(this.props.forwardRef, (ref)=>{
            this.ref = ref;
        });
    }
}
const $3378b59567d048c9$export$b12c0eea3d812057 = (0, $8RXs9.default)($3378b59567d048c9$export$f964308946b6123b);
const $3378b59567d048c9$export$1ea4f29215db3ad6 = (props)=>{
    const [_ignore, persistRecentSearchOnEnter] = (0, $7ttuB.usePersistRecentSearches)();
    const { actionSubjectId: actionSubjectId, advancedSearchURL: advancedSearchURL, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, isLoading: isLoading, onNavigate: onNavigate, ...rest } = props;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const { stickySearchEnabled: stickySearchEnabled, query: query, resetSearchSession: resetSearchSession, showSearchAIDialog: showSearchAIDialog } = (0, $2k6eV.useSessionUserInput)();
    const { allowChangeExpand: allowChangeExpand } = (0, $i5cPn.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const isRovoCrossProductSearchLinkShown = (0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    const { quickFind: quickFind, isGriffinNavEnabled: isGriffinNavEnabled } = (0, $hNXQY.useFeaturesContext)();
    const showSearchOnEnter = !!getActiveProduct()?.showSearchOnEnter;
    const invokePostQuerySearchRef = getActiveProduct()?.invokePostQuerySearchRef;
    const activeProduct = getActiveProduct();
    const showAskAIButton = (0, $5uXOq.useMemo)(()=>{
        if (activeProduct) return !!activeProduct.aiSearchConfig;
        return query.length > 0;
    }, [
        query,
        activeProduct
    ]);
    const aiSearchEnabled = isGriffinNavEnabled ? showAskAIButton : !!getActiveProduct()?.aiSearchConfig || !!showSearchAIDialog;
    const isQuickFind = quickFind?.enabled;
    const { queryParams: queryParams } = (0, $4QKbG.useQueryParams)();
    const onEnter = (0, $5uXOq.useCallback)((event)=>{
        if ((0, $VSDnB.fg)('psd_stop_propagation_on_enter')) event.stopPropagation();
        persistRecentSearchOnEnter(event);
        if (showSearchAIDialog) return;
        if (showSearchOnEnter && !event?.shiftKey) {
            if (invokePostQuerySearchRef) {
                fireAnalyticsEvent((0, $3FqY6.onNonDebouncedSearchTriggered)());
                invokePostQuerySearchRef.current();
            }
            return;
        }
        const modifierKeyPressed = navigator.userAgent.includes('Mac') ? event.metaKey : event.ctrlKey;
        fireAnalyticsEvent((0, $3FqY6.onAdvancedSearchSelected)({
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: false,
            trigger: modifierKeyPressed ? (0, $3FqY6.Trigger).SHORTCUT_MODIFIED : (0, $3FqY6.Trigger).SHORTCUT,
            // We know the user navigated to Rovo Search in Atlassian Home if the Rovo Search link was shown to them AND they either:
            // 1. navigated when the "All" product tab was selected
            // 2. navigated by using (cmd or ctrl) + enter when any product tab was selected
            isRovoCrossProductSearchLink: isRovoCrossProductSearchLinkShown && (activeProduct?.id === (0, $kR3QW.CROSS_PRODUCT_PRODUCT_ID) || modifierKeyPressed)
        }));
        if (stickySearchEnabled && advancedSearchURL && !isGriffinNavEnabled && !(event.metaKey || event.ctrlKey)) resetSearchSession();
        if (isGriffinNavEnabled) event.currentTarget.blur();
        onNavigate(modifierKeyPressed && secondaryAdvancedSearchURL ? secondaryAdvancedSearchURL : advancedSearchURL, event);
    }, [
        persistRecentSearchOnEnter,
        showSearchAIDialog,
        showSearchOnEnter,
        fireAnalyticsEvent,
        actionSubjectId,
        isLoading,
        stickySearchEnabled,
        advancedSearchURL,
        onNavigate,
        secondaryAdvancedSearchURL,
        invokePostQuerySearchRef,
        resetSearchSession,
        isGriffinNavEnabled,
        isRovoCrossProductSearchLinkShown,
        activeProduct?.id
    ]);
    const onClear = (0, $5uXOq.useCallback)(()=>{
        fireAnalyticsEvent((0, $3FqY6.onXButtonClicked)({
            actionSubjectId: actionSubjectId,
            searchSessionId: searchSessionId
        }));
        resetSearchSession();
        allowChangeExpand(true);
    }, [
        fireAnalyticsEvent,
        actionSubjectId,
        searchSessionId,
        resetSearchSession,
        allowChangeExpand
    ]);
    const onPreQueryScreenViewedCB = (0, $5uXOq.useCallback)((preQueryProps)=>fireAnalyticsEvent({
            ...(0, $3FqY6.onPreQueryScreenViewed)(preQueryProps),
            actionSubject: actionSubjectId
        }), [
        fireAnalyticsEvent,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3378b59567d048c9$export$b12c0eea3d812057, {
        ...rest,
        onEnter: onEnter,
        searchSessionId: searchSessionId,
        preQueryScreenViewed: onPreQueryScreenViewedCB,
        onClear: onClear,
        showClearButton: stickySearchEnabled && query !== '',
        allowChangeExpand: allowChangeExpand,
        stickySearchEnabled: stickySearchEnabled,
        showSearchOnEnter: showSearchOnEnter,
        showAIToggleButton: aiSearchEnabled,
        isLoading: isLoading,
        onNavigate: onNavigate,
        isQuickFind: isQuickFind,
        isGriffinNavEnabled: isGriffinNavEnabled,
        queryParams: queryParams
    });
};

});
parcelRegister("7aggy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc50a9c0bd82455$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $bu8Mq = parcelRequire("bu8Mq");

var $42CjB = parcelRequire("42CjB");

var $2AbEM = parcelRequire("2AbEM");

var $6I8Kl = parcelRequire("6I8Kl");

var $b9NEf = parcelRequire("b9NEf");

var $znWph = parcelRequire("znWph");

var $d78H7 = parcelRequire("d78H7");

const $2dc50a9c0bd82455$var$MAX_INPUT_LENGTH = 500;
const $2dc50a9c0bd82455$export$33e4ffe00576d3b4 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, shouldFillContainer: shouldFillContainer, onSelect: onSelect, ariaLabelContent: ariaLabelContent })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $b9NEf.HiddenTooltip);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        onClick: handleClick,
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded,
                                size: "small"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $znWph.EnlargedDesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded,
                        size: isExpanded ? 'medium' : 'small',
                        primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bu8Mq))), {
                        label: exitSearchLabel || 'Exit Search',
                        LEGACY_size: "large",
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $znWph.EnlargedSearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $2dc50a9c0bd82455$var$MAX_INPUT_LENGTH,
                    "aria-label": ariaLabelContent || placeholder,
                    ...theme
                }),
                showClearButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d78H7.EnlargedSearchInputOverlay), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    isExpanded: isExpanded
                })
            ]
        })
    });
};
var $2dc50a9c0bd82455$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const theme = (0, $2AbEM.useTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2dc50a9c0bd82455$export$33e4ffe00576d3b4, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});

});
parcelRegister("znWph", function(module, exports) {

$parcel$export(module.exports, "EnlargedDesktopSearchIconWrapper", () => $c3baf951aebf86a1$export$3324ef4e3e3970dc);
$parcel$export(module.exports, "EnlargedClearIconWrapper", () => $c3baf951aebf86a1$export$68bd88880d49fc5);
$parcel$export(module.exports, "EnlargedSearchInputField", () => $c3baf951aebf86a1$export$aa34c63c6bd8fcb0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3JZ8k = parcelRequire("3JZ8k");


var $b9NEf = parcelRequire("b9NEf");

var $bWGt6 = parcelRequire("bWGt6");
const $c3baf951aebf86a1$export$3324ef4e3e3970dc = /*#__PURE__*/ (0, $bWGt6.default)((0, $b9NEf.DesktopSearchIconWrapper), {
    target: "e4mn9mz2"
})("width:", (props)=>props.isExpanded ? (0, $3JZ8k.enlargedInputFieldHeight).half().px : (0, $3JZ8k.grid).multiple(2).px, ";height:", (props)=>props.isExpanded ? (0, $3JZ8k.enlargedInputFieldHeight).half().px : (0, $3JZ8k.grid).multiple(2).px, ";top:", (props)=>props.isExpanded ? (0, $3JZ8k.grid).multiple(1.5).px : (0, $3JZ8k.grid).px, ";left:", (props)=>props.isExpanded ? (0, $3JZ8k.grid).multiple(2).px : (0, $3JZ8k.grid).px, ";display:flex;align-items:center;");
const $c3baf951aebf86a1$export$68bd88880d49fc5 = /*#__PURE__*/ (0, $bWGt6.default)((0, $b9NEf.ClearIconWrapper), {
    target: "e4mn9mz1"
})("width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);padding-top:0;padding-bottom:0;padding-left:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-150, 12px)"}` : '0', ";padding-right:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-200, 16px)"}` : '2px', ";color:", `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`, ";");
const $c3baf951aebf86a1$export$aa34c63c6bd8fcb0 = /*#__PURE__*/ (0, $bWGt6.default)((0, $b9NEf.SearchInputField), {
    target: "e4mn9mz0"
})("display:flex;align-items:center;height:", (props)=>props.isExpanded ? (0, $3JZ8k.enlargedInputFieldHeight).px : (0, $3JZ8k.inputFieldHeight).px, ";border-radius:", (props)=>props.isExpanded ? '8px' : '5px', ";padding:", (props)=>props.isExpanded ? `${"var(--ds-space-150, 12px)"} 52px ${"var(--ds-space-150, 12px)"} 52px` : `0px ${"var(--ds-space-300, 24px)"} 0px 30px`, ";:focus{border:none;box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, $3JZ8k.grid).multiple(0.5).px + ' ' + (0, $3JZ8k.grid).px + ' ' + (0, $829f609a65d26a98$export$7d3359664e8bb0e5) + ', 0 0 1px ' + (0, $829f609a65d26a98$export$d2d3bedfb276cac0)})`, ";}");

});

parcelRegister("d78H7", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchInputOverlay", () => $34a2e607a591d65f$export$cfdb69c9b0b1fec);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $b9NEf = parcelRequire("b9NEf");

var $2jwCH = parcelRequire("2jwCH");

var $znWph = parcelRequire("znWph");
const $34a2e607a591d65f$export$cfdb69c9b0b1fec = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, isExpanded: isExpanded })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.InputBoxOverlayRight), {
        children: showClearButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $znWph.EnlargedClearIconWrapper), {
            ...theme,
            role: "button",
            onClick: onClear,
            onMouseEnter: ()=>{
                allowChangeExpand?.(false);
            },
            onMouseLeave: ()=>{
                allowChangeExpand?.(true);
            },
            tabIndex: 0,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
                color: "currentColor",
                label: clearSearchLabel || 'Clear search session',
                LEGACY_size: "medium",
                spacing: "spacious"
            })
        })
    });
};

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});
parcelRegister("2C7j9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $1e74cc92a54dd799$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $1e74cc92a54dd799$var$_close.default
    }));
$1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;

});




parcelRegister("agEiU", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcutContainer", () => $c11edbcf060d4242$export$e2deb14b255cffa0);
$parcel$export(module.exports, "KeyboardShortcut", () => $c11edbcf060d4242$export$47a1bf8d9994c680);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
function $c11edbcf060d4242$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c11edbcf060d4242$export$e2deb14b255cffa0 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e19ugnpx1"
})({
    name: "1buofu5",
    styles: "display:flex;line-height:16px;align-items:center;padding-bottom:var(--ds-space-025, 2px);padding-top:var(--ds-space-025, 2px)"
});
const $c11edbcf060d4242$export$47a1bf8d9994c680 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e19ugnpx0"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
    border: `1px solid ${`var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`}`,
    borderRadius: '2px',
    marginLeft: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});

});

parcelRegister("lYEL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b889dd0552f6aff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3FqY6 = parcelRequire("3FqY6");

var $gsomE = parcelRequire("gsomE");

var $lFKmC = parcelRequire("lFKmC");
class $8b889dd0552f6aff$export$6cdeb9eeefdb65f3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        const { query: query } = this.props;
        if (prevProps.query !== query) /**
			 * Earlier this component was child of [confluence|jira]-search-dialog which ensured that this got fired after the debounced search.
			 * Now it will get moved to the wrapper component which will bring this at the same level as [confluence|jira]-search-dialog.
			 * This leads to the event handler getting fired in the same tick before the debounced search.
			 * Hence, forceful execution in the next tick.
			 */ setTimeout(()=>this.textEntered());
    }
    componentWillUnmount() {
        this.textEntered.cancel();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), this.textEntered = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            const { textEntered: textEntered } = this.props;
            textEntered();
        }, this.props.debounceTime || 0);
    }
}
var $8b889dd0552f6aff$export$2e2bcd8739ae039 = (0, $gsomE.withAnalytics)({
    textEntered: (0, $3FqY6.onTextEntered)
})($8b889dd0552f6aff$export$6cdeb9eeefdb65f3);

});

parcelRegister("7t1n2", function(module, exports) {

let $56fc4dfb78e5eecf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fc4dfb78e5eecf$var$load("kCIje").then(()=>parcelRequire('3Htia'));

});




parcelRegister("7Givh", function(module, exports) {

$parcel$export(module.exports, "useAppliedFilters", () => $7b67174a3474dde8$export$51b04ed1f44b6aaf);

var $bONub = parcelRequire("bONub");

var $3UF9C = parcelRequire("3UF9C");
const $7b67174a3474dde8$export$51b04ed1f44b6aaf = (activeProductId)=>{
    const { filterDefinitions: filterDefinitions } = (0, $3UF9C.useGenericFilters)();
    let appliedFilters = [];
    // Find all of the filters that apply to the current product
    const filters = filterDefinitions[activeProductId];
    if (filters !== undefined) filters.forEach((filter)=>{
        // filters with specified value mapping logic should implement it, else use generic logic
        if (filter.mapSelectionToAppliedValue) {
            const valueToApply = filter.mapSelectionToAppliedValue();
            !!valueToApply && appliedFilters.push(valueToApply);
        } else {
            let applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.id);
            // if no site filters are applied, the search should use the top 3 available sites
            if (filter['@type'] === (0, $bONub.SITE_FILTER_TYPE_NAME) && applied.length === 0) applied = filter.store.availableFilters.slice(0, 3).map((filter)=>filter.id);
            if (filter['@type'] === 'spaces') applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.spaceKey || '');
            if (applied.length > 0) appliedFilters.push({
                '@type': filter['@type'],
                [filter.fieldName]: applied
            });
        }
    });
    return appliedFilters;
};

});

parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("gNiXZ", function(module, exports) {

$parcel$export(module.exports, "ActiveProductProvider", () => $a0aa6cb8c87f81f6$export$8cce9f9e667fae48);

var $5uXOq = parcelRequire("5uXOq");

var $kv2Va = parcelRequire("kv2Va");

var $2k6eV = parcelRequire("2k6eV");
const $a0aa6cb8c87f81f6$export$8cce9f9e667fae48 = ({ children: children })=>{
    const { getActiveProduct: getActiveProduct, getDefaultAIConfig: getDefaultAIConfig } = (0, $kv2Va.useProductContext)();
    const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $2k6eV.useSessionUserInput)();
    const onCloseAIDialog = (0, $5uXOq.useCallback)(()=>{
        toggleShowSearchAIDialog(false);
    }, [
        toggleShowSearchAIDialog
    ]);
    const defaultAIConfig = getDefaultAIConfig();
    return children({
        activeProduct: getActiveProduct(),
        showSearchAIDialog: showSearchAIDialog,
        onCloseAIDialog: onCloseAIDialog,
        defaultAIConfig: defaultAIConfig
    });
};

});

parcelRegister("5ZS4j", function(module, exports) {

$parcel$export(module.exports, "ProductSearchDialogWrapper", () => $d690986f2d02d893$export$99f979ec765e5f8f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jj80G = parcelRequire("jj80G");

var $i5cPn = parcelRequire("i5cPn");

var $hNXQY = parcelRequire("hNXQY");
const $d690986f2d02d893$export$99f979ec765e5f8f = ({ children: children, shouldFillContainer: shouldFillContainer })=>{
    const { isExpanded: isExpanded } = (0, $i5cPn.useDialogExpansionContext)();
    const { quickFind: quickFind } = (0, $hNXQY.useFeaturesContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jj80G.SearchDialog), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        style: {
            boxShadow: isExpanded ? undefined : 'none',
            borderRadius: quickFind?.enabled ? "var(--ds-space-100, 8px)" : undefined
        },
        children: children
    });
};

});
parcelRegister("jj80G", function(module, exports) {

$parcel$export(module.exports, "SearchDialog", () => $0c0b33d125acba1d$export$2aadebb53f6015f6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5bKWp = parcelRequire("5bKWp");
const $0c0b33d125acba1d$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bKWp.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });

});


parcelRegister("iSMg5", function(module, exports) {

let $dbf2b448a6338c85$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dbf2b448a6338c85$var$load("ffQaD"),
    $dbf2b448a6338c85$var$load("kvRbA"),
    $dbf2b448a6338c85$var$load("kNFvF"),
    $dbf2b448a6338c85$var$load("kO2XI")
]).then(()=>parcelRequire('7sXJw'));

});


parcelRegister("ffvO4", function(module, exports) {

$parcel$export(module.exports, "OpsgenieTab", () => $4140a4c6d2998b1d$export$7571e7fdcc46c96b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $f4GCr = parcelRequire("f4GCr");

var $k4hbD = parcelRequire("k4hbD");

var $3UM2O = parcelRequire("3UM2O");

var $8Xs9r = parcelRequire("8Xs9r");
var $kv2Va = parcelRequire("kv2Va");

var $eGmm9 = parcelRequire("eGmm9");

var $k5VJd = parcelRequire("k5VJd");

var $a353g = parcelRequire("a353g");

var $95MIc = parcelRequire("95MIc");

var $7VoGI = parcelRequire("7VoGI");

var $4f9Ma = parcelRequire("4f9Ma");

var $1W52p = parcelRequire("1W52p");

var $1W52p = parcelRequire("1W52p");
const $4140a4c6d2998b1d$var$OPSGENIE_PRODUCT_ID = 'opsgenie';
const $4140a4c6d2998b1d$export$864cff1b26c75e89 = (alert)=>{
    return {
        title: alert.message,
        id: alert.id,
        meta: alert.status.charAt(0).toUpperCase() + alert.status.slice(1),
        url: alert.link,
        iconUrl: alert.iconURI,
        containerId: ''
    };
};
const $4140a4c6d2998b1d$export$527d10d7fdeeea4e = ({ intl: intl, cloudId: cloudId, generateAdvancedSearchUrl: overriddenGenerateAdvancedSearchUrl, hostUrl: hostUrl, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, ...rest })=>{
    const urlGeneratorArguments = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hostUrl: hostUrl
        }), [
        cloudId,
        hostUrl
    ]);
    const { viewAllLinkGenerator: viewAllLinkGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $k5VJd.useOpsgenieURLGenerators)(urlGeneratorArguments);
    const sections = [
        {
            id: (0, $eGmm9.OpsgenieScope).OpsgenieAlert,
            title: intl.formatMessage((0, $3UM2O.messages).opsgenie_alerts_heading),
            scope: (0, $eGmm9.OpsgenieScope).OpsgenieAlert,
            showResultCount: true,
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultMapper: ({ results: results })=>results.map((value)=>$4140a4c6d2998b1d$export$864cff1b26c75e89(value))
        }
    ];
    const itemSuppliers = (0, $f4GCr.useDefaultSuppliers)($4140a4c6d2998b1d$var$OPSGENIE_PRODUCT_ID, sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const preQuerySectionTitleGenerator = (0, $5uXOq.useCallback)((section)=>section.id === (0, $eGmm9.OpsgenieScope).OpsgenieAlert ? intl.formatMessage((0, $3UM2O.messages).opsgenie_recent_alerts) : '', [
        intl
    ]);
    const { getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const showAtlassianHomeSearchLink = !!((0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink && orgId) return (0, $4f9Ma.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return overriddenGenerateAdvancedSearchUrl?.(query, baseUrl, usage) || viewAllLinkGenerator(query);
    }, [
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id,
        overriddenGenerateAdvancedSearchUrl,
        viewAllLinkGenerator
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        expandedStateInputPlaceholder: intl.formatMessage((0, $3UM2O.messages).opsgenie_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        id: $4140a4c6d2998b1d$var$OPSGENIE_PRODUCT_ID,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        sections: sections,
        title: intl.formatMessage((0, $k4hbD.messages).opsgenie_tab_label),
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        ...rest,
        ...itemSuppliers,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.AdvancedSearchFooter), {
                                    ...rest,
                                    searchFooterLabel: intl.formatMessage((0, $3UM2O.messages).opsgenie_advanced_search),
                                    returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.ReturnIconWithModifier), {}) : undefined
                                })
                            }),
                            showAtlassianHomeSearchLink && orgId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f9Ma.AtlassianHomeSearchLink), {
                                    orgId: orgId,
                                    cloudId: cloudId,
                                    showModifierIcon: true
                                })
                            })
                        ]
                    })
            };
        }
    });
};
const $4140a4c6d2998b1d$export$7571e7fdcc46c96b = (0, $8RXs9.default)($4140a4c6d2998b1d$export$527d10d7fdeeea4e);

});
parcelRegister("3UM2O", function(module, exports) {

$parcel$export(module.exports, "messages", () => $71f6266f9d0dc873$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $71f6266f9d0dc873$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /*
	 * Opsgenie
	 */ opsgenie_expanded_input_placeholder: {
        id: 'product_search_dialog.opsgenie.expanded.input-placeholder',
        defaultMessage: 'Search Opsgenie',
        description: 'The placeholder which is visible to the user when opsgenie tab is active '
    },
    opsgenie_recent_alerts: {
        id: 'product_search_dialog.opsgenie.opsgenie_recent_alerts',
        defaultMessage: 'Recent Alerts',
        description: ''
    },
    opsgenie_alerts_heading: {
        id: 'product_search_dialog.opsgenie.alert_heading',
        defaultMessage: 'Alerts',
        description: ''
    },
    opsgenie_advanced_search: {
        id: 'product_search_dialog.opsgenie.advanced_search',
        defaultMessage: 'Advanced alert search',
        description: 'Advanced search link text when inside Opsgenie tab'
    }
});

});

parcelRegister("eGmm9", function(module, exports) {

$parcel$export(module.exports, "OpsgenieScope", () => $275cc94eefbb021e$export$dc14148e3ded2998);
var $275cc94eefbb021e$export$dc14148e3ded2998 = /*#__PURE__*/ function(OpsgenieScope) {
    OpsgenieScope["OpsgenieAlert"] = "opsgenie.alert";
    return OpsgenieScope;
}({});

});

parcelRegister("k5VJd", function(module, exports) {

$parcel$export(module.exports, "useOpsgenieURLGenerators", () => $c518ba9dda1d08c5$export$c78c65c0f344862e);

var $5uXOq = parcelRequire("5uXOq");
const $c518ba9dda1d08c5$var$getOpsgenieAggregatorRedirectUrl = ({ cloudId: cloudId, hostUrl: hostUrl = '' })=>{
    return `${hostUrl}/gateway/api/xpsearch-aggregator/redirect/advanced/opsgenie/${cloudId}`;
};
const $c518ba9dda1d08c5$export$c78c65c0f344862e = (arg)=>{
    const opsgenieAggregatorRedirector = (0, $5uXOq.useCallback)((query)=>`${$c518ba9dda1d08c5$var$getOpsgenieAggregatorRedirectUrl(arg)}?query=${query}`, [
        arg
    ]);
    return {
        viewAllLinkGenerator: opsgenieAggregatorRedirector,
        urlGeneratorForNoResultsScreen: opsgenieAggregatorRedirector
    };
};

});


parcelRegister("bHEFa", function(module, exports) {

$parcel$export(module.exports, "TownsquareTab", () => $fead6f04769a8277$export$b2c9c8ae315d8935);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $9i3B5 = parcelRequire("9i3B5");

var $dVo7Y = parcelRequire("dVo7Y");

var $1ICFC = parcelRequire("1ICFC");

var $8Xs9r = parcelRequire("8Xs9r");
var $kv2Va = parcelRequire("kv2Va");

var $3UF9C = parcelRequire("3UF9C");

var $l6iRn = parcelRequire("l6iRn");

var $1Z4tV = parcelRequire("1Z4tV");

var $iwg9m = parcelRequire("iwg9m");

var $c04PQ = parcelRequire("c04PQ");

var $iEN9D = parcelRequire("iEN9D");

var $a353g = parcelRequire("a353g");

var $95MIc = parcelRequire("95MIc");

var $7VoGI = parcelRequire("7VoGI");

var $4f9Ma = parcelRequire("4f9Ma");

var $lvCts = parcelRequire("lvCts");
const $fead6f04769a8277$var$defaultPermissionsSupplier = ()=>{
    const response = Object.values((0, $iwg9m.TownsquareScope));
    return Promise.resolve(response);
};
const $fead6f04769a8277$export$e502dfe73eec1c84 = ({ intl: intl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, userTeamConfig: userTeamConfig, workspaces: workspaces, atlasClientBaseUrlOverride: atlasClientBaseUrlOverride, organizationId: organizationId, ...rest })=>{
    const [isGlobalExperienceWorkspace, setGlobalExperienceWorkspace] = (0, $5uXOq.useState)();
    const { atlasWorkspaces: atlasWorkspaces } = (0, $dVo7Y.useSearchConfigContext)();
    if (!workspaces) workspaces = atlasWorkspaces;
    const siteFilterDefinition = (0, $3UF9C.useSiteFilterDefinition)(workspaces, (0, $1Z4tV.TOWNSQUARE_PRODUCT_ID));
    const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, $1Z4tV.useTownsquareSuppliers)({
        userTeamConfig: userTeamConfig,
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier,
        workspaces: workspaces,
        isGlobalExperienceWorkspace: isGlobalExperienceWorkspace
    });
    const { defineFilters: defineFilters } = (0, $3UF9C.useGenericFilters)();
    defineFilters((0, $1Z4tV.TOWNSQUARE_PRODUCT_ID), siteFilterDefinition);
    (0, $5uXOq.useEffect)(()=>{
        (0, $9i3B5.isGlobalExperienceWorkspaceForCloudId)(userTeamConfig?.context.siteId, atlasClientBaseUrlOverride).then((result)=>{
            setGlobalExperienceWorkspace(result);
        }).catch(()=>{
            setGlobalExperienceWorkspace(false);
        });
    }, [
        atlasClientBaseUrlOverride,
        userTeamConfig?.context.siteId
    ]);
    const { getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $4f9Ma.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return '';
    }, [
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    let permissionSupplier = workspaces && workspaces.length > 0 || isGlobalExperienceWorkspace ? $fead6f04769a8277$var$defaultPermissionsSupplier : rest.permissionSupplier;
    if (isGlobalExperienceWorkspace === undefined) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        ...rest,
        id: (0, $1Z4tV.TOWNSQUARE_PRODUCT_ID),
        expandedStateInputPlaceholder: intl.formatMessage(isGlobalExperienceWorkspace ? (0, $1ICFC.messages).townsquare_search_input_expanded_placeholder : (0, $1ICFC.messages).atlas_search_input_expanded_placeholder),
        sections: (0, $l6iRn.getSections)(intl, workspaces, isGlobalExperienceWorkspace, userTeamConfig?.context.organizationId),
        title: intl.formatMessage(isGlobalExperienceWorkspace ? (0, $1ICFC.messages).townsquare_globex_tab_label : (0, $1ICFC.messages).townsquare_tab_label),
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        workspaces: workspaces,
        permissionSupplier: permissionSupplier,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f9Ma.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $fead6f04769a8277$export$485492c388dcd81e = (props)=>{
    if ((0, $iEN9D.default).initializeCompleted() && (0, $iEN9D.default).checkGate('ignore_atlas_product_search_dialog_on_fedramp') && (0, $c04PQ.isFedRamp)()) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fead6f04769a8277$export$e502dfe73eec1c84, {
        ...props
    });
};
const $fead6f04769a8277$export$b2c9c8ae315d8935 = (0, $8RXs9.default)($fead6f04769a8277$export$485492c388dcd81e);

});
parcelRegister("9i3B5", function(module, exports) {

$parcel$export(module.exports, "isGlobalExperienceWorkspaceForCloudId", () => $b5b9b84c25cd7779$export$d39036e5b47a0af);
function $b5b9b84c25cd7779$var$getServiceUrl(cloudId, baseUrlOverride) {
    const path = `/gateway/api/townsquare/s/${cloudId}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`;
    if (baseUrlOverride) return `${baseUrlOverride}${path}`;
    return path;
}
async function $b5b9b84c25cd7779$export$d39036e5b47a0af(cloudId, baseUrlOverride) {
    if (cloudId === undefined) return false;
    try {
        const response = await fetch($b5b9b84c25cd7779$var$getServiceUrl(cloudId, baseUrlOverride), {
            credentials: 'include'
        });
        if (response.ok) {
            const workspaceType = await response.text();
            return workspaceType === 'GLOBAL_EXPERIENCE';
        }
        return false;
    } catch (err) {
        return false;
    }
}

});

parcelRegister("1ICFC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e68bbdea7fdeab88$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e68bbdea7fdeab88$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /*
	 * Atlas, formerly known as Team Central or Townsquare
	 */ atlas_search_input_expanded_placeholder: {
        id: 'product_search_dialog.atlas.search_input_expanded_placeholder',
        defaultMessage: 'Search Atlas',
        description: 'Input placeholder shown when searching for items in the Atlas product'
    },
    townsquare_search_input_expanded_placeholder: {
        id: 'product_search_dialog.townsquare.search_input_expanded_placeholder',
        defaultMessage: 'Search Home',
        description: 'Input placeholder shown when searching for items in Atlassian Home'
    },
    townsquare_tab_label: {
        id: 'cross_product_search_dialog.townsquare_tab_label',
        defaultMessage: 'Atlas',
        description: ''
    },
    townsquare_globex_tab_label: {
        id: 'cross_product_search_dialog.townsquare_globex_tab_label',
        defaultMessage: 'Home',
        description: ''
    },
    townsquare_recent_projects: {
        id: 'cross_product_search_dialog.townsquare_recent_projects',
        defaultMessage: 'Recent Projects',
        description: ''
    },
    townsquare_recent_goals: {
        id: 'cross_product_search_dialog.townsquare_recent_goals',
        defaultMessage: 'Recent Goals',
        description: ''
    },
    townsquare_recent_help_links: {
        id: 'cross_product_search_dialog.townsquare_recent_help_links',
        defaultMessage: 'Recent Help Links',
        description: ''
    },
    townsquare_recent_learnings_risks_decisions: {
        id: 'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions',
        defaultMessage: 'Recent Learnings, Risks and Decisions',
        description: 'Section heading for all types of project learnings: learnings, risks and decisions'
    },
    townsquare_recent_topics: {
        id: 'product_search_dialog.townsquare_recent_topics',
        defaultMessage: 'Recent Topics',
        description: 'Topic: A collection of projects, goals, teams and help curated through tagging objects.'
    },
    townsquare_recent_people: {
        id: 'product_search_dialog.townsquare_recent_people',
        defaultMessage: 'Recent People',
        description: ''
    },
    townsquare_projects_heading: {
        id: 'product_search_dialog.townsquare_projects_heading',
        defaultMessage: 'Projects',
        description: ''
    },
    townsquare_projects_view_all: {
        id: 'product_search_dialog.townsquare_projects_view_all',
        defaultMessage: 'Search all projects',
        description: 'Link to send the user to atlas extended project search'
    },
    townsquare_goals_heading: {
        id: 'product_search_dialog.townsquare_goals_heading',
        defaultMessage: 'Goals',
        description: ''
    },
    townsquare_goals_view_all: {
        id: 'product_search_dialog.townsquare_goals_view_all',
        defaultMessage: 'Search all goals',
        description: 'Link to send the user to atlas extended goal search'
    },
    townsquare_help_links_heading: {
        id: 'product_search_dialog.townsquare_help_links_heading',
        defaultMessage: 'Help Links',
        description: ''
    },
    townsquare_topics_heading: {
        id: 'product_search_dialog.townsquare_topics_heading',
        defaultMessage: 'Topics',
        description: 'Topic: A collection of projects, goals, teams and help curated through tagging objects.'
    },
    townsquare_topics_view_all: {
        id: 'product_search_dialog.townsquare_topics_view_all',
        defaultMessage: 'Search all topics',
        description: 'Link to send the user to atlas extended topic search'
    },
    townsquare_learnings_risks_decisions_heading: {
        id: 'product_search_dialog.townsquare_learnings_risks_decisions_heading',
        defaultMessage: 'Learnings, Risks and Decisions',
        description: 'Section heading for all types of project learnings: learnings, risks and decisions'
    },
    townsquare_people_heading: {
        id: 'product_search_dialog.townsquare_people_heading',
        defaultMessage: 'People',
        description: ''
    },
    townsquare_people_view_all: {
        id: 'product_search_dialog.townsquare_people_view_all',
        defaultMessage: 'Search all people',
        description: 'Link to send the user to atlas extended people search'
    },
    townsquare_teams_heading: {
        id: 'product_search_dialog.townsquare_teams_heading',
        defaultMessage: 'Teams',
        description: ''
    },
    townsquare_teams_view_all: {
        id: 'product_search_dialog.townsquare_teams_view_all',
        defaultMessage: 'Search all teams',
        description: 'Link to send the user to atlas extended team search'
    }
});

});

parcelRegister("l6iRn", function(module, exports) {

$parcel$export(module.exports, "MAX_ITEMS_PER_SECTION", () => $49e767ce964dc9ed$export$ece7c64a85a33d85);
$parcel$export(module.exports, "getSections", () => $49e767ce964dc9ed$export$ddbcae0b0bd6b092);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $1ICFC = parcelRequire("1ICFC");

var $iwg9m = parcelRequire("iwg9m");

var $lKCn7 = parcelRequire("lKCn7");
let $49e767ce964dc9ed$var$defaultTownsquareResultMapper = ({ results: results })=>results.map((value)=>$49e767ce964dc9ed$var$mapAggregatorResponseToSearchItem(value)).slice(0, $49e767ce964dc9ed$export$ece7c64a85a33d85);
const $49e767ce964dc9ed$export$ece7c64a85a33d85 = 3;
const $49e767ce964dc9ed$var$mapAggregatorResponseToSearchItem = (response)=>{
    if ('account_id' in response) return {
        title: response.name,
        id: response.account_id,
        meta: '',
        url: response.absoluteUrl || '',
        iconUrl: response.picture,
        containerId: ''
    };
    else return {
        title: response.title,
        id: response.id,
        meta: '',
        url: response.url,
        iconUrl: response.iconUrl,
        containerId: ''
    };
};
const $49e767ce964dc9ed$export$ddbcae0b0bd6b092 = (intl, workspaces, isGlobalExperienceWorkspace, orgId)=>[
        {
            id: (0, $iwg9m.TownsquareScope).TownsquareProject,
            title: intl.formatMessage((0, $1ICFC.messages).townsquare_projects_heading),
            showResultCount: false,
            scope: (0, $iwg9m.TownsquareScope).TownsquareProject,
            resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>{
                return (0, $lKCn7.default)('projects', query, workspaces, isGlobalExperienceWorkspace, orgId);
            },
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $1ICFC.messages).townsquare_projects_view_all
                })
        },
        {
            id: (0, $iwg9m.TownsquareScope).TownsquareGoal,
            title: intl.formatMessage((0, $1ICFC.messages).townsquare_goals_heading),
            scope: (0, $iwg9m.TownsquareScope).TownsquareGoal,
            resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>(0, $lKCn7.default)('goals', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $1ICFC.messages).townsquare_goals_view_all
                })
        },
        {
            id: (0, $iwg9m.TownsquareScope).TownsquareHelpLink,
            title: intl.formatMessage((0, $1ICFC.messages).townsquare_help_links_heading),
            scope: (0, $iwg9m.TownsquareScope).TownsquareHelpLink,
            resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper
        },
        {
            id: (0, $iwg9m.TownsquareScope).TownsquareTag,
            title: intl.formatMessage((0, $1ICFC.messages).townsquare_topics_heading),
            scope: (0, $iwg9m.TownsquareScope).TownsquareTag,
            resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>(0, $lKCn7.default)('topics', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $1ICFC.messages).townsquare_topics_view_all
                })
        },
        {
            id: (0, $iwg9m.TownsquareScope).TownsquareLearning,
            title: intl.formatMessage((0, $1ICFC.messages).townsquare_learnings_risks_decisions_heading),
            scope: (0, $iwg9m.TownsquareScope).TownsquareLearning,
            resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper
        }
    ];

});
parcelRegister("iwg9m", function(module, exports) {

$parcel$export(module.exports, "TownsquareScope", () => $942dcc058359fc29$export$fca43c5c12a4e3fa);
var $942dcc058359fc29$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});

});


parcelRegister("1Z4tV", function(module, exports) {

$parcel$export(module.exports, "TOWNSQUARE_PRODUCT_ID", () => $43c3794682d18a62$export$dac5be8ec1b3ddb1);
$parcel$export(module.exports, "useTownsquareSuppliers", () => $43c3794682d18a62$export$a0d26d0ba1e6d87a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $g12zs = parcelRequire("g12zs");

var $1ICFC = parcelRequire("1ICFC");

var $f4GCr = parcelRequire("f4GCr");

var $l6iRn = parcelRequire("l6iRn");

var $iwg9m = parcelRequire("iwg9m");

var $lKCn7 = parcelRequire("lKCn7");
const $43c3794682d18a62$export$dac5be8ec1b3ddb1 = 'townsquare';
const $43c3794682d18a62$var$sectionSortOrder = [
    (0, $iwg9m.TownsquareScope).TownsquareProject,
    (0, $iwg9m.TownsquareScope).TownsquareGoal,
    (0, $iwg9m.TownsquareScope).People,
    (0, $iwg9m.TownsquareScope).Teams,
    (0, $iwg9m.TownsquareScope).TownsquareTag,
    (0, $iwg9m.TownsquareScope).TownsquareHelpLink,
    (0, $iwg9m.TownsquareScope).TownsquareLearning
];
/**
 * Sorting sections to match the order defined in the array {sectionSortOrder}
 * While this should not happen, if the section is not part of the array, it is considered to be at the end.
 */ const $43c3794682d18a62$var$sortSections = (sectionA, sectionB)=>{
    const indexA = $43c3794682d18a62$var$sectionSortOrder.indexOf(sectionA.id);
    const indexB = $43c3794682d18a62$var$sectionSortOrder.indexOf(sectionB.id);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
};
const $43c3794682d18a62$export$a0d26d0ba1e6d87a = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, workspaces: workspaces, organizationId: organizationId, isGlobalExperienceWorkspace: isGlobalExperienceWorkspace })=>{
    const intl = (0, $koVbs.default)();
    const orgId = organizationId ?? userTeamConfig?.context.organizationId;
    const itemSuppliers = (0, $f4GCr.useDefaultSuppliers)($43c3794682d18a62$export$dac5be8ec1b3ddb1, (0, $l6iRn.getSections)(intl, workspaces, isGlobalExperienceWorkspace, orgId), {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    // If we are in a global experience workspace, we need to set the product key to 'people'
    if (userTeamConfig) userTeamConfig.context.productKey = isGlobalExperienceWorkspace ? 'people' : userTeamConfig?.context.productKey;
    const peopleAndTeamSupplier = (0, $g12zs.usePeopleAndTeamsQuery)({
        people: {
            id: (0, $iwg9m.TownsquareScope).People,
            title: intl.formatMessage((0, $1ICFC.messages).townsquare_people_heading),
            viewAllLinkGenerator: (query)=>(0, $lKCn7.default)('people', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $1ICFC.messages).townsquare_people_view_all
                })
        },
        teams: {
            id: (0, $iwg9m.TownsquareScope).Teams,
            title: intl.formatMessage((0, $1ICFC.messages).townsquare_teams_heading),
            viewAllLinkGenerator: (query)=>(0, $lKCn7.default)('teams', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $1ICFC.messages).townsquare_teams_view_all
                })
        }
    }, (0, $l6iRn.MAX_ITEMS_PER_SECTION));
    const preQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await itemSuppliers.preQueryItemSupplier(args);
        const people = userTeamConfig ? await peopleAndTeamSupplier('', {
            resolveUserUrl: (userId)=>(0, $lKCn7.createProfileLink)(userId, isGlobalExperienceWorkspace, orgId),
            resolveTeamUrl: (teamId)=>(0, $lKCn7.createTeamProfileLink)(teamId, isGlobalExperienceWorkspace, orgId),
            ...userTeamConfig
        }) : null;
        const unsortedSections = [
            ...existingSections.sections,
            ...people?.sections ?? []
        ];
        return {
            size: unsortedSections.length,
            sections: unsortedSections.sort($43c3794682d18a62$var$sortSections)
        };
    };
    const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await itemSuppliers.postQueryItemSupplier(args);
        const { filters: filters } = args;
        const selectedWorkspace = filters.filter((filter)=>filter['@type'] === 'sites').map((filter)=>filter.values[0]).filter((val)=>val).shift();
        const people = userTeamConfig ? await peopleAndTeamSupplier(args.query, {
            resolveUserUrl: (userId)=>(0, $lKCn7.createProfileLink)(userId, isGlobalExperienceWorkspace, orgId),
            resolveTeamUrl: (teamId)=>(0, $lKCn7.createTeamProfileLink)(teamId, isGlobalExperienceWorkspace, orgId),
            ...userTeamConfig,
            context: {
                ...userTeamConfig.context,
                siteId: selectedWorkspace || userTeamConfig.context.siteId
            }
        }) : null;
        const unsortedSections = [
            ...existingSections.sections,
            ...people?.sections ?? []
        ];
        return {
            size: unsortedSections.length,
            sections: unsortedSections.sort($43c3794682d18a62$var$sortSections)
        };
    };
    const preQuerySectionTitleGenerator = (section)=>{
        switch(section.id){
            case (0, $iwg9m.TownsquareScope).TownsquareProject:
                return intl.formatMessage((0, $1ICFC.messages).townsquare_recent_projects);
            case (0, $iwg9m.TownsquareScope).TownsquareGoal:
                return intl.formatMessage((0, $1ICFC.messages).townsquare_recent_goals);
            case (0, $iwg9m.TownsquareScope).TownsquareHelpLink:
                return intl.formatMessage((0, $1ICFC.messages).townsquare_recent_help_links);
            case (0, $iwg9m.TownsquareScope).TownsquareTag:
                return intl.formatMessage((0, $1ICFC.messages).townsquare_recent_topics);
            case (0, $iwg9m.TownsquareScope).TownsquareLearning:
                return intl.formatMessage((0, $1ICFC.messages).townsquare_recent_learnings_risks_decisions);
            case (0, $iwg9m.TownsquareScope).People:
                return intl.formatMessage((0, $1ICFC.messages).townsquare_recent_people);
            default:
                return '';
        }
    };
    return {
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    };
};

});


parcelRegister("gUnI2", function(module, exports) {

$parcel$export(module.exports, "TrelloTab", () => $6d456a53f60ae907$export$78fe0655c043c20);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $k4hbD = parcelRequire("k4hbD");

var $eS6IA = parcelRequire("eS6IA");

var $8Xs9r = parcelRequire("8Xs9r");
var $kv2Va = parcelRequire("kv2Va");

var $f4GCr = parcelRequire("f4GCr");

var $e2gaa = parcelRequire("e2gaa");

var $9UICj = parcelRequire("9UICj");

var $3MXT1 = parcelRequire("3MXT1");

var $jNI9m = parcelRequire("jNI9m");

var $6cESN = parcelRequire("6cESN");

var $6ZsPS = parcelRequire("6ZsPS");

var $7xoNc = parcelRequire("7xoNc");

var $95MIc = parcelRequire("95MIc");

var $4f9Ma = parcelRequire("4f9Ma");

var $7VoGI = parcelRequire("7VoGI");

var $lvCts = parcelRequire("lvCts");

const $6d456a53f60ae907$var$TrelloBodyAsync = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8SM41")).then(({ TrelloBody: TrelloBody })=>({
            default: TrelloBody
        })));
const $6d456a53f60ae907$export$78fe0655c043c20 = ({ feedbackUrl: feedbackUrl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, generateAdvancedSearchUrl: generateAdvancedSearchUrl, features: features, resultOnClick: resultOnClick, ...rest })=>{
    const searchSessionId = (0, $6ZsPS.useSearchSessionId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $kv2Va.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $95MIc.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const trelloGenerateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $4f9Ma.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return (0, $7xoNc.addQueryParams)((0, $6cESN.viewAllLinkGenerator)(query), {
            search_id: searchSessionId
        });
    }, [
        searchSessionId,
        showAtlassianHomeSearchLink,
        orgId,
        cloudId,
        primaryProduct?.id
    ]);
    const boardSection = (0, $5uXOq.useMemo)(()=>{
        return {
            id: (0, $3MXT1.TrelloScope).Board,
            title: formatMessage((0, $eS6IA.messages).trello_boards_heading),
            scope: (0, $3MXT1.TrelloScope).Board,
            showResultCount: false,
            resultMapper: ({ results: results })=>results.map((board)=>({
                        id: board.id,
                        title: board.name,
                        meta: board.organization?.displayName ?? '',
                        closed: board.closed,
                        url: board.url,
                        prefs: board.prefs,
                        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNI9m.BoardIcon), {
                            ...board
                        }),
                        containerId: board.idOrganization ?? undefined
                    })),
            resultRenderer: (args)=>{
                const { id: id, title: title, meta: meta, closed: closed, url: url, prefs: prefs } = args?.searchResult;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2gaa.TrelloSearchResultComponent), {
                    id: id,
                    title: title,
                    meta: {
                        title: formatMessage((0, $eS6IA.messages).trello_workspace),
                        value: meta
                    },
                    closed: closed,
                    url: url,
                    prefs: prefs,
                    isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                    isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                    screen: args?.screen,
                    onResultClick: resultOnClick
                });
            }
        };
    }, [
        features?.isColorBlindModeEnabled,
        features?.isPreviewOnTrelloSearchResultsEnabled,
        formatMessage,
        resultOnClick
    ]);
    const cardSection = (0, $5uXOq.useMemo)(()=>{
        return {
            id: (0, $3MXT1.TrelloScope).Card,
            title: formatMessage((0, $eS6IA.messages).trello_cards_heading),
            scope: (0, $3MXT1.TrelloScope).Card,
            showResultCount: false,
            resultMapper: ({ results: results })=>results.map((card)=>({
                        id: card.id,
                        title: card.name,
                        meta: card.board.name,
                        additionalMeta: card.list.name,
                        closed: card.closed,
                        url: card.url,
                        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNI9m.CardIcon), {}),
                        containerId: card.idBoard
                    })),
            resultRenderer: (args)=>{
                const { id: id, title: title, meta: meta, additionalMeta: additionalMeta, url: url, closed: closed } = args?.searchResult;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2gaa.TrelloSearchResultComponent), {
                    id: id,
                    title: title,
                    meta: {
                        title: formatMessage((0, $eS6IA.messages).trello_board),
                        value: meta
                    },
                    additionalMeta: {
                        title: formatMessage((0, $eS6IA.messages).trello_list),
                        value: additionalMeta
                    },
                    closed: closed,
                    url: url,
                    isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                    isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                    screen: args?.screen,
                    onResultClick: resultOnClick
                });
            }
        };
    }, [
        features?.isColorBlindModeEnabled,
        features?.isPreviewOnTrelloSearchResultsEnabled,
        formatMessage,
        resultOnClick
    ]);
    const sections = (0, $5uXOq.useMemo)(()=>{
        return features?.isCardResultsSectionFirst ? [
            cardSection,
            {
                ...boardSection,
                viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
            }
        ] : [
            boardSection,
            {
                ...cardSection,
                viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
            }
        ];
    }, [
        boardSection,
        cardSection,
        features?.isCardResultsSectionFirst,
        trelloGenerateAdvancedSearchUrl
    ]);
    const itemSuppliers = (0, $f4GCr.useDefaultSuppliers)((0, $3MXT1.TRELLO_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const preQuerySectionTitleGenerator = (0, $5uXOq.useCallback)((section)=>section.id === (0, $3MXT1.TrelloScope).Board ? formatMessage((0, $eS6IA.messages).trello_recent_boards_heading) : '', [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Xs9r.SearchDialogProduct), {
        id: (0, $3MXT1.TRELLO_PRODUCT_ID),
        expandedStateInputPlaceholder: formatMessage((0, $eS6IA.messages).trello_expanded_input_placeholder),
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        generateAdvancedSearchUrl: trelloGenerateAdvancedSearchUrl,
        sections: sections,
        title: formatMessage((0, $k4hbD.messages).trello_tab_label),
        ...rest,
        ...itemSuppliers,
        children: (props)=>{
            return features?.isCardResultsSectionFirst ? {
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UICj.TrelloFooter), {
                        feedbackUrl: feedbackUrl,
                        urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl,
                        linkComponent: props.linkComponent,
                        showAtlassianHomeSearchLink: !!showAtlassianHomeSearchLink
                    }),
                Body: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($6d456a53f60ae907$var$TrelloBodyAsync, {
                        ...props
                    })
            } : {
                Footer: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UICj.TrelloFooter), {
                        feedbackUrl: feedbackUrl,
                        urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl,
                        linkComponent: props.linkComponent,
                        showAtlassianHomeSearchLink: !!showAtlassianHomeSearchLink
                    })
            };
        }
    });
};

});
parcelRegister("eS6IA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $02719a3df0703f5e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $02719a3df0703f5e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Trello
	 */ trello_archived: {
        id: 'product_search_dialog.trello.archived',
        defaultMessage: 'Archived',
        description: 'Will show on a search result if a Trello card is archived'
    },
    trello_archived_card_hover: {
        id: 'product_search_dialog.trello.archived.card-hover',
        defaultMessage: 'This card is archived',
        description: 'Hover text for archived status of card search result'
    },
    trello_board: {
        id: 'product_search_dialog.trello.board',
        defaultMessage: 'Board',
        description: 'A Trello Board'
    },
    trello_closed: {
        id: 'product_search_dialog.trello.closed',
        defaultMessage: 'Closed',
        description: 'Will show on a search result if a Trello board is closed'
    },
    trello_closed_board_hover: {
        id: 'product_search_dialog.trello.closed.board-hover',
        defaultMessage: 'This board is closed',
        description: 'Hover text for closed status of board search result'
    },
    trello_list: {
        id: 'product_search_dialog.trello.list',
        defaultMessage: 'List',
        description: 'A list on a Trello board'
    },
    trello_workspace: {
        id: 'product_search_dialog.trello.workspace',
        defaultMessage: 'Workspace',
        description: 'A Trello Workspace'
    },
    trello_private_workspace: {
        id: 'product_search_dialog.trello.private_workspace',
        defaultMessage: 'Private Workspace',
        description: 'A Trello private workspace'
    },
    trello_expanded_input_placeholder: {
        id: 'product_search_dialog.trello.expanded.input-placeholder',
        defaultMessage: 'Search Trello',
        description: 'The expanded placeholder text when the Trello tab is active.'
    },
    trello_recent_boards_heading: {
        id: 'product_search_dialog.trello.recent_boards_heading',
        defaultMessage: 'Recent boards',
        description: 'Heading for Recent boards, a Trello search result type'
    },
    trello_boards_heading: {
        id: 'product_search_dialog.trello.boards_heading',
        defaultMessage: 'Boards',
        description: 'Heading for Boards, a Trello search result type'
    },
    trello_cards_heading: {
        id: 'product_search_dialog.trello.cards_heading',
        defaultMessage: 'Cards',
        description: 'Heading for Cards, a Trello search result type'
    },
    trello_feedback_link: {
        id: 'product_search_dialog.trello.feedback_link',
        defaultMessage: 'Help us improve your search results!',
        description: 'Link redirecting to a feedback form'
    }
});

});

parcelRegister("e2gaa", function(module, exports) {

$parcel$export(module.exports, "TrelloSearchResultComponent", () => $770e5e4ad8bb17d6$export$995a33bac606d212);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eiKpf = parcelRequire("eiKpf");

var $eS6IA = parcelRequire("eS6IA");

var $eMsAl = parcelRequire("eMsAl");

var $jNI9m = parcelRequire("jNI9m");

var $8ZlAw = parcelRequire("8ZlAw");
const $770e5e4ad8bb17d6$export$995a33bac606d212 = ({ id: id, title: title, url: url, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, isColorBlindModeEnabled: isColorBlindModeEnabled, screen: screen, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isBoard = Boolean(prefs);
    const type = (0, $5uXOq.useMemo)(()=>isBoard ? 'board' : 'card', [
        isBoard
    ]);
    const metaValue = (0, $5uXOq.useMemo)(()=>isBoard && !meta.value ? formatMessage((0, $eS6IA.messages).trello_private_workspace) : meta.value, [
        formatMessage,
        isBoard,
        meta.value
    ]);
    const resultContentWrapperOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onResultClick !== undefined) onResultClick();
    }, [
        onResultClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ZlAw.HoverPreviewsResultWrapper), {
        id: id,
        title: title,
        url: url,
        prefs: prefs,
        meta: meta,
        additionalMeta: additionalMeta,
        closed: closed,
        type: type,
        isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled,
        isColorBlindModeEnabled: isColorBlindModeEnabled,
        screen: screen,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.ResultContentWrapper), {
            isCollapsed: true,
            onClick: resultContentWrapperOnClick,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.IconContainer), {
                    children: isBoard && prefs ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNI9m.BoardIcon), {
                        id: id,
                        name: title,
                        url: url,
                        prefs: prefs
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNI9m.CardIcon), {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eiKpf.CollapsedResultContentWrapper), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiKpf.ResultTitleContainer), {
                            isCollapsed: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                                title: !isPreviewOnTrelloSearchResultsEnabled ? title : undefined,
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eMsAl.CollapsedResultDetailWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eMsAl.BoardAndListCol), {
                                    children: [
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMsAl.BoardAndListDetail), {
                                            title: !isPreviewOnTrelloSearchResultsEnabled ? `${meta.title}: ${metaValue}` : undefined,
                                            children: metaValue
                                        }),
                                        additionalMeta ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eMsAl.BoardAndListDetail), {
                                            title: !isPreviewOnTrelloSearchResultsEnabled ? `${additionalMeta.title}: ${additionalMeta.value}` : undefined,
                                            children: [
                                                ": ",
                                                additionalMeta.value
                                            ]
                                        }) : null
                                    ]
                                }),
                                closed ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eMsAl.ArchivedCol), {
                                    title: !isPreviewOnTrelloSearchResultsEnabled ? isBoard ? formatMessage((0, $eS6IA.messages).trello_closed_board_hover) : formatMessage((0, $eS6IA.messages).trello_archived_card_hover) : undefined,
                                    children: [
                                        "\u2022 ",
                                        isBoard ? formatMessage((0, $eS6IA.messages).trello_closed) : formatMessage((0, $eS6IA.messages).trello_archived)
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("eMsAl", function(module, exports) {

$parcel$export(module.exports, "BoardAndListCol", () => $d8a74695157867e5$export$14ccea95a01eec04);
$parcel$export(module.exports, "BoardAndListDetail", () => $d8a74695157867e5$export$67495cfd95013c39);
$parcel$export(module.exports, "ArchivedCol", () => $d8a74695157867e5$export$cd22da1a99fcf7b1);
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $d8a74695157867e5$export$43a2b5c94cb85d9c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
function $d8a74695157867e5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8a74695157867e5$export$14ccea95a01eec04 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1rjmdl23"
})({
    name: "andpxo",
    styles: "display:flex;overflow:hidden"
});
const $d8a74695157867e5$export$67495cfd95013c39 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1rjmdl22"
})({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '5%',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
});
const $d8a74695157867e5$export$cd22da1a99fcf7b1 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1rjmdl21"
})({
    marginLeft: "var(--ds-space-050, 4px)",
    flexShrink: 0,
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
});
const $d8a74695157867e5$export$43a2b5c94cb85d9c = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1rjmdl20"
})({
    name: "zjik7",
    styles: "display:flex"
});

});

parcelRegister("jNI9m", function(module, exports) {

$parcel$export(module.exports, "getCardIconUrl", () => $2e3a87544bc74a86$export$d00fcd959e6e6c2b);
$parcel$export(module.exports, "getBoardIconUrl", () => $2e3a87544bc74a86$export$419622b78ee4bd67);
$parcel$export(module.exports, "BoardIcon", () => $2e3a87544bc74a86$export$2f9da8868573b55d);
$parcel$export(module.exports, "CardIcon", () => $2e3a87544bc74a86$export$f4619d70a16e5ea0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $k5uoT = parcelRequire("k5uoT");


var $kTHGn = parcelRequire("kTHGn");

var $bWGt6 = parcelRequire("bWGt6");
const $2e3a87544bc74a86$var$baseStyle = {
    display: 'flex',
    // hack around IconContainer styles
    flexShrink: 0,
    // hack around IconContainer styles
    borderRadius: '2px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
};
const $2e3a87544bc74a86$export$d00fcd959e6e6c2b = ()=>{
    const iconColor = (0, $kTHGn.default)('color.icon', (0, $829f609a65d26a98$export$7d61b15e0da132af));
    return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.66667 0C1.19391 0 0 1.19391 0 2.66667V16C0 17.4728 1.19391 18.6667 2.66667 18.6667H21.3333C22.8061 18.6667 24 17.4728 24 16V2.66667C24 1.19391 22.8061 0 21.3333 0H2.66667ZM21.3333 2.66667H2.66667V10.6667H21.3333V2.66667ZM18.6667 14.6667C18.6667 15.403 19.2636 16 20 16C20.7364 16 21.3333 15.403 21.3333 14.6667C21.3333 13.9303 20.7364 13.3333 20 13.3333C19.2636 13.3333 18.6667 13.9303 18.6667 14.6667ZM4 16C3.26362 16 2.66667 15.403 2.66667 14.6667C2.66667 13.9303 3.26362 13.3333 4 13.3333H9.33333C10.0697 13.3333 10.6667 13.9303 10.6667 14.6667C10.6667 15.403 10.0697 16 9.33333 16H4Z" fill="${iconColor}"/></svg>`)}`;
};
const $2e3a87544bc74a86$export$419622b78ee4bd67 = ()=>{
    const iconColor = (0, $kTHGn.default)('color.icon', (0, $829f609a65d26a98$export$7d61b15e0da132af));
    return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.77778C0 0.795938 0.795938 0 1.77778 0H14.2222C15.2041 0 16 0.795938 16 1.77778V14.2222C16 15.2041 15.2041 16 14.2222 16H1.77778C0.795938 16 0 15.2041 0 14.2222V1.77778ZM1.77778 2.66667C1.77778 2.17575 2.17575 1.77778 2.66667 1.77778H6.22222C6.71314 1.77778 7.11111 2.17575 7.11111 2.66667V11.5556C7.11111 12.0465 6.71314 12.4444 6.22222 12.4444H2.66667C2.17575 12.4444 1.77778 12.0465 1.77778 11.5556V2.66667ZM9.77778 1.77778C9.28686 1.77778 8.88889 2.17575 8.88889 2.66667V8C8.88889 8.49092 9.28686 8.88889 9.77778 8.88889H13.3333C13.8243 8.88889 14.2222 8.49092 14.2222 8V2.66667C14.2222 2.17575 13.8243 1.77778 13.3333 1.77778H9.77778Z" fill="${iconColor}"/></svg>`)}`;
};
const $2e3a87544bc74a86$export$2f9da8868573b55d = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "est758s1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ prefs: { backgroundImageScaled: backgroundImageScaled, backgroundImage: backgroundImage, backgroundColor: backgroundColor } })=>{
    const boardUrl = backgroundImageScaled?.[0]?.url || backgroundImage;
    if (boardUrl) return {
        ...$2e3a87544bc74a86$var$baseStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${(0, $k5uoT.gridSize)() * 3}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $k5uoT.gridSize)() * 3}px`,
        backgroundImage: `url(${boardUrl})`
    };
    return {
        ...$2e3a87544bc74a86$var$baseStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${(0, $k5uoT.gridSize)() * 3}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $k5uoT.gridSize)() * 3}px`,
        backgroundColor: backgroundColor || `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
});
const $2e3a87544bc74a86$export$f4619d70a16e5ea0 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "est758s0"
})(()=>{
    return {
        ...$2e3a87544bc74a86$var$baseStyle,
        height: `19px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $k5uoT.gridSize)() * 3}px`,
        marginBottom: "var(--ds-space-100, 8px)",
        backgroundImage: `url(${$2e3a87544bc74a86$export$d00fcd959e6e6c2b()})`
    };
});

});

parcelRegister("8ZlAw", function(module, exports) {

$parcel$export(module.exports, "HoverPreviewsResultWrapper", () => $0912af53c3ec2c23$export$5662bd1eb353c490);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ij3jm = parcelRequire("ij3jm");

const $0912af53c3ec2c23$var$TrelloPopperAsync = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("fZqeV")).then(({ TrelloPopper: TrelloPopper })=>({
            default: TrelloPopper
        })));
const $0912af53c3ec2c23$export$5662bd1eb353c490 = ({ id: id, title: title, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, type: type, children: children, isColorBlindModeEnabled: isColorBlindModeEnabled, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, screen: screen })=>{
    const { getCard: getCard } = (0, $ij3jm.useTrelloCard)();
    const [result, setResult] = (0, $5uXOq.useState)();
    const onFetchCard = (0, $5uXOq.useCallback)(async ()=>{
        const card = await getCard(id);
        if (card) setResult({
            ...card,
            type: 'card',
            id: id,
            title: title,
            closed: closed,
            meta: meta,
            additionalMeta: additionalMeta,
            screen: screen
        });
    }, [
        getCard,
        id,
        title,
        closed,
        meta,
        screen,
        additionalMeta
    ]);
    const onFetchBoard = (0, $5uXOq.useCallback)(()=>{
        if (prefs) setResult({
            type: 'board',
            id: id,
            title: title,
            prefs: prefs,
            meta: meta,
            closed: closed,
            screen: screen
        });
    }, [
        id,
        title,
        prefs,
        meta,
        closed,
        screen
    ]);
    if (!isPreviewOnTrelloSearchResultsEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($0912af53c3ec2c23$var$TrelloPopperAsync, {
            type: type,
            result: result,
            onFetchCard: onFetchCard,
            onFetchBoard: onFetchBoard,
            isColorBlindModeEnabled: isColorBlindModeEnabled,
            screen: screen,
            children: children
        })
    });
};

});
parcelRegister("ij3jm", function(module, exports) {

$parcel$export(module.exports, "useTrelloCard", () => $045591519f532e78$export$167729b86606a89e);

var $5uXOq = parcelRequire("5uXOq");

var $75NXP = parcelRequire("75NXP");

var $3FqY6 = parcelRequire("3FqY6");
const $045591519f532e78$var$cards = new Map();
const $045591519f532e78$export$167729b86606a89e = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $75NXP.useAnalytics)();
    const loadCard = (0, $5uXOq.useCallback)(async (cardId)=>{
        try {
            const response = await fetch(`/1/card/${cardId}?fields=name,closed,url,cover,labels,idAttachmentCover&attachments=cover`);
            if (response.ok) {
                const cardResponse = await response.json();
                $045591519f532e78$var$cards.set(cardId, cardResponse);
                return cardResponse;
            } else throw new Error(`Invalid response: ${response?.status}`);
        } catch (e) {
            if (e instanceof Error) fireAnalyticsEvent({
                ...(0, $3FqY6.onCardRequestFailed)({
                    attributes: {
                        errorMsg: e?.message,
                        errorName: e?.name
                    }
                })
            });
        }
    }, [
        fireAnalyticsEvent
    ]);
    const getCard = (0, $5uXOq.useCallback)(async (cardId)=>{
        return $045591519f532e78$var$cards.get(cardId) ? Promise.resolve($045591519f532e78$var$cards.get(cardId)) : loadCard(cardId);
    }, [
        loadCard
    ]);
    return {
        getCard: getCard
    };
};

});

parcelRegister("fZqeV", function(module, exports) {

let $ba40e82c5816d537$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba40e82c5816d537$var$load("fAgCm").then(()=>parcelRequire('6h9YI'));

});



parcelRegister("9UICj", function(module, exports) {

$parcel$export(module.exports, "TrelloFooter", () => $cc24001924c5ab43$export$c139d851a817966);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $a353g = parcelRequire("a353g");

var $eS6IA = parcelRequire("eS6IA");

var $1W52p = parcelRequire("1W52p");

var $1poKc = parcelRequire("1poKc");

var $7VoGI = parcelRequire("7VoGI");

var $4f9Ma = parcelRequire("4f9Ma");

var $1W52p = parcelRequire("1W52p");

var $lvCts = parcelRequire("lvCts");
const $cc24001924c5ab43$export$c139d851a817966 = ({ feedbackUrl: feedbackUrl, showAtlassianHomeSearchLink: showAtlassianHomeSearchLink, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { orgId: orgId } = (0, $7VoGI.useUserContext)();
    const aggregatorClient = (0, $lvCts.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1poKc.SearchFooterWrapper), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.AdvancedSearchFooter), {
                ...rest,
                returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1W52p.ReturnIconWithModifier), {}) : undefined
            }),
            showAtlassianHomeSearchLink && orgId && cloudId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a353g.SearchFooter), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f9Ma.AtlassianHomeSearchLink), {
                    orgId: orgId,
                    cloudId: cloudId,
                    showModifierIcon: true
                })
            }),
            feedbackUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1poKc.FeedbackLinkWrapper), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1poKc.FeedbackLink), {
                    appearance: "subtle-link",
                    href: feedbackUrl,
                    target: "_blank",
                    children: formatMessage((0, $eS6IA.messages).trello_feedback_link)
                })
            })
        ]
    });
};

});
parcelRegister("1poKc", function(module, exports) {

$parcel$export(module.exports, "FeedbackLinkWrapper", () => $f9c183129a568a14$export$b68f382ed631ffe5);
$parcel$export(module.exports, "FeedbackLink", () => $f9c183129a568a14$export$4d44d7534024e0b6);
$parcel$export(module.exports, "SearchFooterWrapper", () => $f9c183129a568a14$export$a6be8d069f8a5fb4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $a353g = parcelRequire("a353g");

var $fVnbM = parcelRequire("fVnbM");


var $bWGt6 = parcelRequire("bWGt6");
function $f9c183129a568a14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f9c183129a568a14$export$b68f382ed631ffe5 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "evrkq7c2"
})({
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`
});
const $f9c183129a568a14$export$4d44d7534024e0b6 = /*#__PURE__*/ (0, $bWGt6.default)((0, $fVnbM.default), {
    target: "evrkq7c1"
})("&&{text-decoration:underline;&:hover{color:", `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`, "!important;}}");
const $f9c183129a568a14$export$a6be8d069f8a5fb4 = /*#__PURE__*/ (0, $bWGt6.default)((0, $a353g.SearchFooter), {
    target: "evrkq7c0"
})({
    name: "13ku56z",
    styles: "display:flex;flex-direction:column;height:100%"
});

});


parcelRegister("3MXT1", function(module, exports) {

$parcel$export(module.exports, "TRELLO_PRODUCT_ID", () => $a857210ee855aeeb$export$4788c0ef19dba72f);
$parcel$export(module.exports, "TrelloScope", () => $a857210ee855aeeb$export$1f420d5694f8d5b3);
const $a857210ee855aeeb$export$4788c0ef19dba72f = 'trello';
var $a857210ee855aeeb$export$1f420d5694f8d5b3 = /*#__PURE__*/ function(TrelloScope) {
    TrelloScope["Board"] = "trello.board";
    TrelloScope["Card"] = "trello.card";
    return TrelloScope;
}({});

});

parcelRegister("6cESN", function(module, exports) {

$parcel$export(module.exports, "viewAllLinkGenerator", () => $17795d4edba82704$export$28a2ffcf7191490b);
const $17795d4edba82704$var$getBaseUrl = ()=>{
    const hostname = window?.location?.hostname;
    if (hostname?.includes('jira-dev.com') || hostname?.startsWith('trellis.coffee') || hostname?.startsWith('localhost') || hostname?.startsWith('team.stg')) return 'https://trellis.coffee';
    return 'https://trello.com';
};
const $17795d4edba82704$export$28a2ffcf7191490b = (query)=>query ? `${$17795d4edba82704$var$getBaseUrl()}/search?q=${encodeURIComponent(query)}` : `${$17795d4edba82704$var$getBaseUrl()}/search`;

});

parcelRegister("8SM41", function(module, exports) {

let $6778a65ece7a2b26$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6778a65ece7a2b26$var$load("1XHsG").then(()=>parcelRequire('b47ZY'));

});


parcelRegister("cbTYT", function(module, exports) {

$parcel$export(module.exports, "useNINGlobalScopeEnrolment", () => $a1f5a8d976347fb9$export$3585e395a7eced19);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $fu3P4 = parcelRequire("fu3P4");

var $VILOn = parcelRequire("VILOn");
const $a1f5a8d976347fb9$export$3585e395a7eced19 = ({ cloudId: cloudId, isExpanded: isExpanded })=>{
    const fetched = (0, $5uXOq.useRef)(false);
    const [isNinGlobalScopeEnrolmentEnabled, setIsNinGlobalScopeEnrolmentEnabled] = (0, $5uXOq.useState)(()=>{
        /**
		 * Avoiding reading from local storage during SSR
		 */ if (false) return true;
        const localStorageData = (0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)();
        if (localStorageData !== null && localStorageData !== undefined) return !!localStorageData;
        /**
		 * Defaulting to true because NIN is already used by the majority of the users
		 */ return true;
    });
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Avoiding fetching when:
		 * - is SSR
		 * - we already fetched jira.user.nin.global.scope.enrolment
		 * - extensible dialog is not expanded (to avoid unnecessary requests)
		 */ if (false || fetched.current || !isExpanded) return;
        (0, $fu3P4.default)(cloudId).then((isNinGlobalScopeEnrolmentEnabledData)=>{
            fetched.current = true;
            setIsNinGlobalScopeEnrolmentEnabled(isNinGlobalScopeEnrolmentEnabledData);
        }).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'useNINGlobalScopeEnrolment',
                    packageName: 'jiraAtlassianNavigation',
                    teamName: 'navigation'
                },
                error: error instanceof Error ? error : new Error('Error fetching jira.user.nin.global.scope.enrolment from the server'),
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        cloudId,
        isExpanded
    ]);
    return isNinGlobalScopeEnrolmentEnabled;
};

});
parcelRegister("fu3P4", function(module, exports) {

$parcel$export(module.exports, "default", () => $667869f7351d8a5e$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
const $667869f7351d8a5e$var$SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY = `
    query SelectedGlobalScopeIssueNavigatorQuery($cloudId: ID!) {
        myPreferences(keys: [
            "jira.user.nin.global.scope.enrolment"
        ]),
        jira {
            applicationPropertiesByKey(cloudId: $cloudId, keys: ["jira.admin.nin.global.scope.enrolment"]) {
                value
            }
        }
    }
`;
const $667869f7351d8a5e$var$fetchIsGlobalScopeEnrolmentEnabledFromServer = async (cloudId)=>{
    const apiResult = await (0, $eusud.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $667869f7351d8a5e$var$SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY,
            variables: {
                cloudId: cloudId
            }
        })
    });
    const userPreferenceValue = apiResult.data.myPreferences['jira.user.nin.global.scope.enrolment'];
    if (userPreferenceValue !== 'nin' && userPreferenceValue !== 'gin' && userPreferenceValue !== null) throw new RangeError('Unexpected user preference value');
    const applicationPropertyValue = apiResult.data.jira.applicationPropertiesByKey[0].value;
    if (applicationPropertyValue !== 'true' && applicationPropertyValue !== 'false') throw new RangeError('Unexpected application property value');
    return userPreferenceValue !== 'gin' && applicationPropertyValue === 'true';
};
var $667869f7351d8a5e$export$2e2bcd8739ae039 = $667869f7351d8a5e$var$fetchIsGlobalScopeEnrolmentEnabledFromServer;

});

parcelRegister("VILOn", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $5dc42c779a970b72$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $5dc42c779a970b72$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $5dc42c779a970b72$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $5dc42c779a970b72$export$458eda2352a1e223);

var $bSSG7 = parcelRequire("bSSG7");

var $2YZCu = parcelRequire("2YZCu");
const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, $bSSG7.createLocalStorageProvider)('nin-changeboarding');
const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $5dc42c779a970b72$export$34434fbbe40a8047();
    }
};
const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});


parcelRegister("kA88U", function(module, exports) {

$parcel$export(module.exports, "default", () => $d476948cd14e34b6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dh6Py = parcelRequire("dh6Py");
var $8Xs9r = parcelRequire("8Xs9r");
function $d476948cd14e34b6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Xs9r.SearchDialogProduct), {
        id: "jira",
        expandedStateInputPlaceholder: "Search",
        sections: [
            {
                id: (0, $dh6Py.PERFORMANCE_IMPROVEMENT_DUMMY_SECTION),
                title: 'Jira'
            }
        ],
        // eslint-disable-next-line jira/i18n/text-wrapped-in-format-message
        title: "Dummy",
        order: 0,
        autocorrectEnabled: false,
        preQueryItemSupplier: ()=>Promise.resolve({
                sections: []
            }),
        postQueryItemSupplier: ()=>Promise.resolve({
                sections: []
            }),
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onRetry: ()=>{}
    }, ()=>{
        return {
            Footer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        };
    });
}

});


parcelRegister("9uJ5I", function(module, exports) {

$parcel$export(module.exports, "useConfluenceAvailabilityExperiment", () => $d8082d217ebc1e1c$export$61a7447897e80a08);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $hqBSi = parcelRequire("hqBSi");

var $8ilPk = parcelRequire("8ilPk");

var $cYlk7 = parcelRequire("cYlk7");

var $4R6GH = parcelRequire("4R6GH");

var $2NMNM = parcelRequire("2NMNM");

var $cZpsT = parcelRequire("cZpsT");

var $8s4de = parcelRequire("8s4de");

var $bkb3Z = parcelRequire("bkb3Z");
const $d8082d217ebc1e1c$export$61a7447897e80a08 = (cloudId, isExpanded)=>{
    const [isEligible, setIsEligible] = (0, $5uXOq.useState)(false);
    const [tabClicked, setTabClicked] = (0, $5uXOq.useState)(false);
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { user: user } = (0, $cYlk7.useCurrentUser)().data;
    const { fetch: fetch } = (0, $8ilPk.useSiteUserPersonalization)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isAnonymousUser = (0, $cZpsT.useIsAnonymous)();
    const setAllowConfluenceAccessCache = (0, $5uXOq.useCallback)(()=>{
        (0, $bkb3Z.setConfluenceAccessCache)(true, createAnalyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const checkEligibility = async ()=>{
            if (!isExpanded) return;
            if ((0, $4R6GH.fg)('cc_virality_conf_availability_in_jira_search_kill')) return;
            if (isAnonymousUser) return;
            if (!licensedProducts?.confluence) return;
            const confluenceAccess = await (0, $bkb3Z.fetchCachedConfluenceAccess)(cloudId, createAnalyticsEvent);
            if (confluenceAccess) return;
            const isRaCapable = await (0, $8s4de.fetchCachedUserCanRequestAccess)(cloudId, createAnalyticsEvent);
            if (!isRaCapable) return;
            if (!(0, $6s1PB.expValEquals)('cc_virality_conf_availability_in_jira_search', 'cohort', 'test')) return;
            if (user.accountId) {
                const personalizationData = await fetch({
                    cloudId: cloudId,
                    userId: user.accountId
                });
                if (personalizationData) {
                    const isClicked = personalizationData.find((trait)=>trait.name === 'jira-platform_screen_viewed_crossproductsearchconfluenceupselltab_changed' && trait.value === true) !== undefined;
                    setTabClicked(isClicked);
                }
            }
            setIsEligible(true);
        };
        checkEligibility();
    }, [
        cloudId,
        licensedProducts,
        fetch,
        user.accountId,
        createAnalyticsEvent,
        isAnonymousUser,
        isExpanded
    ]);
    return {
        isEligible: isEligible,
        tabClicked: tabClicked,
        setAllowConfluenceAccessCache: setAllowConfluenceAccessCache
    };
};

});
parcelRegister("8s4de", function(module, exports) {

$parcel$export(module.exports, "fetchCachedUserCanRequestAccess", () => $63b256affab20836$export$299b740d7c248ca2);

var $7f4tk = parcelRequire("7f4tk");

var $bSSG7 = parcelRequire("bSSG7");

var $8zOmE = parcelRequire("8zOmE");
const $63b256affab20836$var$fetchUserCanRequestAccess = async (cloudId)=>{
    const resource = `ari:cloud:confluence::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    const response = await (0, $7f4tk.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
};
const $63b256affab20836$var$CONFLUENCE_CAN_REQUEST_ACCESS_CACHE_KEY = 'confluence-availability-exp.confluence-capabilities.cache.key';
// Cache for 1 day
const $63b256affab20836$var$CONFLUENCE_CAN_REQUEST_ACCESS_CACHE_KEY_EXPIRY_MS = 86400000;
const $63b256affab20836$var$confluenceCanRequestAccessApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('confluence-availability-exp-capabilities-api-cache');
const $63b256affab20836$export$299b740d7c248ca2 = async (cloudId, createAnalyticsEvent)=>{
    let canRequestAccess = $63b256affab20836$var$confluenceCanRequestAccessApiCache.get($63b256affab20836$var$CONFLUENCE_CAN_REQUEST_ACCESS_CACHE_KEY);
    if (canRequestAccess === undefined) try {
        canRequestAccess = await $63b256affab20836$var$fetchUserCanRequestAccess(cloudId);
    } catch (error) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confAvailabilityInSearchExpRequestCapabilities failed', {
            errorAction: 'Failed to fetch user capabilities',
            error: error
        });
    } finally{
        // Set the cache either way. This make sure if error occurs, we don't keep hitting the API.
        $63b256affab20836$var$setIsRACapableCache(canRequestAccess ?? false, createAnalyticsEvent);
    }
    return canRequestAccess ?? false;
};
const $63b256affab20836$var$setIsRACapableCache = (value, createAnalyticsEvent)=>{
    try {
        $63b256affab20836$var$confluenceCanRequestAccessApiCache.set($63b256affab20836$var$CONFLUENCE_CAN_REQUEST_ACCESS_CACHE_KEY, value, Date.now() + $63b256affab20836$var$CONFLUENCE_CAN_REQUEST_ACCESS_CACHE_KEY_EXPIRY_MS);
    } catch (error) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confAvailabilityInSearchExpRequestCapabilities failed', {
            errorAction: 'Failed to set user capabilities in cache',
            error: error
        });
    }
};

});

parcelRegister("bkb3Z", function(module, exports) {

$parcel$export(module.exports, "fetchCachedConfluenceAccess", () => $c92de375ef35924f$export$dcd634cbdca22f75);
$parcel$export(module.exports, "setConfluenceAccessCache", () => $c92de375ef35924f$export$67adcb5b9cbdeceb);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $c92de375ef35924f$var$URL = '/gateway/api/permissions/permitted';
const $c92de375ef35924f$var$hasProductAccess = async (cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:confluence::site/${cloudId}`
    };
    const response = await (0, $7f4tk.default)($c92de375ef35924f$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
const $c92de375ef35924f$var$CONFLUENCE_ACCESS_CACHE_KEY = 'confluence-availability-exp.confluence-access.cache.key';
// Cache for 1 day
const $c92de375ef35924f$var$CONFLUENCE_ACCESS_CACHE_KEY_EXPIRY_MS = 86400000;
const $c92de375ef35924f$var$confluenceAccessApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('confluence-availability-exp-access-api-cache');
const $c92de375ef35924f$export$dcd634cbdca22f75 = async (cloudId, createAnalyticsEvent)=>{
    let confluenceAccess = $c92de375ef35924f$var$confluenceAccessApiCache.get($c92de375ef35924f$var$CONFLUENCE_ACCESS_CACHE_KEY);
    if (confluenceAccess === undefined) try {
        confluenceAccess = await $c92de375ef35924f$var$hasProductAccess(cloudId);
    } catch (error) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confAvailabilityInSearchExpConfAccess failed', {
            errorAction: 'Failed to get confluence access',
            error: error
        });
    } finally{
        // Set the cache either way. This make sure if error occurs, we don't keep hitting the API.
        $c92de375ef35924f$export$67adcb5b9cbdeceb(confluenceAccess ?? false, createAnalyticsEvent);
    }
    return confluenceAccess ?? false;
};
const $c92de375ef35924f$export$67adcb5b9cbdeceb = (value, createAnalyticsEvent)=>{
    try {
        $c92de375ef35924f$var$confluenceAccessApiCache.set($c92de375ef35924f$var$CONFLUENCE_ACCESS_CACHE_KEY, value, Date.now() + $c92de375ef35924f$var$CONFLUENCE_ACCESS_CACHE_KEY_EXPIRY_MS);
    } catch (error) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confAvailabilityInSearchExpConfAccess failed', {
            errorAction: 'Failed to set confluence access in cache',
            error: error
        });
    }
};

});


parcelRegister("dugW4", function(module, exports) {

let $9d1b36c63009ffa7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9d1b36c63009ffa7$var$load("ffQaD"),
    $9d1b36c63009ffa7$var$load("kvRbA"),
    $9d1b36c63009ffa7$var$load("iWcMv")
]).then(()=>parcelRequire('afuot'));

});



//# sourceMappingURL=async-atlassian-navigation-search.eb228f83.js.map
